/**
 * ![60 Day Guarantee](https://images.ctfassets.net/v6awd0kabi65/1TcuIvEn8JHouZNM9SVyaM/03fad25b395b2347918178c36d88a1ea/60_Day_guarantee.png?w=120&h=120&fit=pad)
 *
 * 60 Day Guarantee
 *
 * Affirm logo with blue curved line above the word “affirm” and the phrase “0% APR financing” below.
 */
export const IMG_1TcuIvEn8JHouZNM9SVyaM = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1TcuIvEn8JHouZNM9SVyaM/03fad25b395b2347918178c36d88a1ea/60_Day_guarantee.png',
  description: `Affirm logo with blue curved line above the word “affirm” and the phrase “0% APR financing” below.`,
  originalHeight: 498,
  originalWidth: 498
}

/**
 * ![Call A Sales Specialist](https://images.ctfassets.net/v6awd0kabi65/6UMbGUo2vMm65W8HkHT2ni/b99e6e5f1e9b76878870a46b1647ba76/Sales_agent__1_.png?w=120&h=120&fit=pad)
 *
 * Call A Sales Specialist
 *
 * A woman with dreadlocks and glasses wearing a headset with a microphone, like a sales agent.
 */
export const IMG_6UMbGUo2vMm65W8HkHT2ni = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6UMbGUo2vMm65W8HkHT2ni/b99e6e5f1e9b76878870a46b1647ba76/Sales_agent__1_.png',
  description: `A woman with dreadlocks and glasses wearing a headset with a microphone, like a sales agent.`,
  originalHeight: 498,
  originalWidth: 498
}

/**
 * ![SA_DT_Summary_hero](https://images.ctfassets.net/v6awd0kabi65/5QE2zwxBWh2mHvkFK28UAg/9192d1455ff9968b36037e34f9f344cb/dt_summary_hero.jpg?w=120&h=120&fit=pad)
 *
 * SA_DT_Summary_hero
 *
 * A white SimpliSafe Base Station with a glowing blue light sits on a table in the foreground, with blurred figures of people in a living room in the background.
 */
export const IMG_5QE2zwxBWh2mHvkFK28UAg = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5QE2zwxBWh2mHvkFK28UAg/9192d1455ff9968b36037e34f9f344cb/dt_summary_hero.jpg',
  description: `A white SimpliSafe Base Station with a glowing blue light sits on a table in the foreground, with blurred figures of people in a living room in the background.`,
  originalHeight: 742,
  originalWidth: 1024
}

/**
 * ![SA_DT_Outdoor3_hero](https://images.ctfassets.net/v6awd0kabi65/5k7FHaEbmSr3iPvYbeCkXZ/b1f057ea86b915cca83594aed32914a0/SA_DT_Outdoor3_hero.png?w=120&h=120&fit=pad)
 *
 * SA_DT_Outdoor3_hero
 *
 * Professional monitoring, from the outside in
 */
export const IMG_5k7FHaEbmSr3iPvYbeCkXZ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5k7FHaEbmSr3iPvYbeCkXZ/b1f057ea86b915cca83594aed32914a0/SA_DT_Outdoor3_hero.png',
  description: `Professional monitoring, from the outside in`,
  originalHeight: 958,
  originalWidth: 1017
}

/**
 * ![AppWidget - SMB - Controls](https://images.ctfassets.net/v6awd0kabi65/7puUeIBiFmG6HKEjBokeTk/d925964076739340b750a9cce6294ee3/App_screen_art.png?w=120&h=120&fit=pad)
 *
 * AppWidget - SMB - Controls
 *
 * Phone showing controls to arm or disarm Simplisafe system
 */
export const IMG_7puUeIBiFmG6HKEjBokeTk = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7puUeIBiFmG6HKEjBokeTk/d925964076739340b750a9cce6294ee3/App_screen_art.png',
  description: `Phone showing controls to arm or disarm Simplisafe system`,
  originalHeight: 627,
  originalWidth: 501
}

/**
 * ![AppControl - SMB - Cameras UK](https://images.ctfassets.net/v6awd0kabi65/4wUyesv5oYPUDZKgagoRRj/ee2333d2e7dead6871a12b25cedb69ba/App_Screen_1_Desktop.png?w=120&h=120&fit=pad)
 *
 * AppControl - SMB - Cameras UK
 *
 * Phone showing cameras from SimpliSafe
 */
export const IMG_4wUyesv5oYPUDZKgagoRRj = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4wUyesv5oYPUDZKgagoRRj/ee2333d2e7dead6871a12b25cedb69ba/App_Screen_1_Desktop.png',
  description: `Phone showing cameras from SimpliSafe`,
  originalHeight: 1254,
  originalWidth: 1000
}

/**
 * ![App Control - Home](https://images.ctfassets.net/v6awd0kabi65/6rmX3DElVdPZn4Hw3JNqV9/af952e3f4f19c855e9c5bb37071b19e3/App_screen_art.png?w=120&h=120&fit=pad)
 *
 * App Control - Home
 *
 * Simplisafe app on the phone showing the system armed in home mode
 */
export const IMG_6rmX3DElVdPZn4Hw3JNqV9 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6rmX3DElVdPZn4Hw3JNqV9/af952e3f4f19c855e9c5bb37071b19e3/App_screen_art.png',
  description: `Simplisafe app on the phone showing the system armed in home mode`,
  originalHeight: 627,
  originalWidth: 501
}

/**
 * ![Stop Intruders - Crime Prevention](https://images.ctfassets.net/v6awd0kabi65/g4pHULrIQC3a6YCzMNLL2/880211ff83f065423d51c23e891b0417/Alarm_moments_Crime_Prevention_Desktop.png?w=120&h=120&fit=pad)
 *
 * Stop Intruders - Crime Prevention
 *
 * A SimpliSafe Outdoor Security Camera detects a person outside a closed market while a monitoring agent views the feed on a computer.
 */
export const IMG_g4pHULrIQC3a6YCzMNLL2 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/g4pHULrIQC3a6YCzMNLL2/880211ff83f065423d51c23e891b0417/Alarm_moments_Crime_Prevention_Desktop.png',
  description: `A SimpliSafe Outdoor Security Camera detects a person outside a closed market while a monitoring agent views the feed on a computer.`,
  originalHeight: 1056,
  originalWidth: 1932
}

/**
 * ![Stop Intruders - Water](https://images.ctfassets.net/v6awd0kabi65/7LHXhHoqw9cwqJ8qXYiFSE/936ae1b88cab568527edc11054226c87/Alarm_moments_Water.png?w=120&h=120&fit=pad)
 *
 * Stop Intruders - Water
 *
 * A SimpliSafe Water Sensor detects a large water leak on the floor of a cafe.
 */
export const IMG_7LHXhHoqw9cwqJ8qXYiFSE = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7LHXhHoqw9cwqJ8qXYiFSE/936ae1b88cab568527edc11054226c87/Alarm_moments_Water.png',
  description: `A SimpliSafe Water Sensor detects a large water leak on the floor of a cafe.`,
  originalHeight: 1056,
  originalWidth: 1932
}

/**
 * ![Stop Intruders - Break-in & theft (US)](https://images.ctfassets.net/v6awd0kabi65/2kHTHDqbHkJ2qjzkEHiT2J/babb93f7d1afa22cde9b07087d49a6ef/Alarm_Moments_Break_in___Theft_Desktop.png?w=120&h=120&fit=pad)
 *
 * Stop Intruders - Break-in & theft (US)
 *
 * A burglar with a crowbar enters an office as a SimpliSafe security camera detects the break-in.
 */
export const IMG_2kHTHDqbHkJ2qjzkEHiT2J = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2kHTHDqbHkJ2qjzkEHiT2J/babb93f7d1afa22cde9b07087d49a6ef/Alarm_Moments_Break_in___Theft_Desktop.png',
  description: `A burglar with a crowbar enters an office as a SimpliSafe security camera detects the break-in.`,
  originalHeight: 1056,
  originalWidth: 1932
}

/**
 * ![Stop Intruders - Crime Prevention (UK)](https://images.ctfassets.net/v6awd0kabi65/2fa5rAklsYKxgPFssFqWsL/82d33f2746703587d8422c9f78ba3326/Alarm_moments_illustrations.png?w=120&h=120&fit=pad)
 *
 * Stop Intruders - Crime Prevention (UK)
 *
 * A SimpliSafe Outdoor Security Camera detects a person outside a closed market while a monitoring agent views the feed on a computer.
 */
export const IMG_2fa5rAklsYKxgPFssFqWsL = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2fa5rAklsYKxgPFssFqWsL/82d33f2746703587d8422c9f78ba3326/Alarm_moments_illustrations.png',
  description: `A SimpliSafe Outdoor Security Camera detects a person outside a closed market while a monitoring agent views the feed on a computer.`,
  originalHeight: 528,
  originalWidth: 966
}

/**
 * ![Stop Intruders - Employee safety (US)](https://images.ctfassets.net/v6awd0kabi65/1TDwWYmESCM2gQ0LdaI3sV/ab4370c32a3ff5d79e992df201f18968/Alarm_moments_Employee_Safety_Desktop.png?w=120&h=120&fit=pad)
 *
 * Stop Intruders - Employee safety (US)
 *
 * A retail store employee presses a SimpliSafe Panic Button behind the sales counter while being confronted by a burglar.
 */
export const IMG_1TDwWYmESCM2gQ0LdaI3sV = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1TDwWYmESCM2gQ0LdaI3sV/ab4370c32a3ff5d79e992df201f18968/Alarm_moments_Employee_Safety_Desktop.png',
  description: `A retail store employee presses a SimpliSafe Panic Button behind the sales counter while being confronted by a burglar.`,
  originalHeight: 1056,
  originalWidth: 1932
}

/**
 * ![Stop Intruders - Break-in & theft](https://images.ctfassets.net/v6awd0kabi65/1fcJzqoinlB7DTE1P3Mm5i/fc8de0e22009bb3226dfba3fd7a06ce2/Alarm_moments_Breakin.png?w=120&h=120&fit=pad)
 *
 * Stop Intruders - Break-in & theft
 *
 * A burglar with a crowbar enters a jewelry store as a SimpliSafe security camera detects the break-in.
 */
export const IMG_1fcJzqoinlB7DTE1P3Mm5i = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1fcJzqoinlB7DTE1P3Mm5i/fc8de0e22009bb3226dfba3fd7a06ce2/Alarm_moments_Breakin.png',
  description: `A burglar with a crowbar enters a jewelry store as a SimpliSafe security camera detects the break-in.`,
  originalHeight: 1056,
  originalWidth: 1932
}

/**
 * ![Stop Intruders - Employee safety](https://images.ctfassets.net/v6awd0kabi65/19hf1tI1eS8FMddls73Oum/6164d1bbd0a842b29a6173ae57506f34/Alarm_Moments_Panic.png?w=120&h=120&fit=pad)
 *
 * Stop Intruders - Employee safety
 *
 * A retail store employee presses a SimpliSafe Panic Button behind the sales counter while being confronted by a burglar.
 */
export const IMG_19hf1tI1eS8FMddls73Oum = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/19hf1tI1eS8FMddls73Oum/6164d1bbd0a842b29a6173ae57506f34/Alarm_Moments_Panic.png',
  description: `A retail store employee presses a SimpliSafe Panic Button behind the sales counter while being confronted by a burglar.`,
  originalHeight: 1056,
  originalWidth: 1932
}

/**
 * ![24/7 professional monitoring for inside and out (Hero Banner, Desktop)](https://images.ctfassets.net/v6awd0kabi65/6CHNcY5u7XkspzSyUe0to5/9d5ca3d608fc150c8bf84ce1d6ad1cb3/Monitoring_Hero_Desktop.jpg?w=120&h=120&fit=pad)
 *
 * 24/7 professional monitoring for inside and out (Hero Banner, Desktop)
 *
 * 24/7 professional monitoring for inside and out
 */
export const IMG_6CHNcY5u7XkspzSyUe0to5 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6CHNcY5u7XkspzSyUe0to5/9d5ca3d608fc150c8bf84ce1d6ad1cb3/Monitoring_Hero_Desktop.jpg',
  description: `24/7 professional monitoring for inside and out`,
  originalHeight: 1815,
  originalWidth: 3906
}

/**
 * ![24/7 professional monitoring for inside and out (Hero Banner, Mobile)](https://images.ctfassets.net/v6awd0kabi65/1k1hPvPOdO3Eaf3zWPnklA/4312516e17acc04333aab61b4a5e18ec/Monitoring_Hero_Mobile.jpg?w=120&h=120&fit=pad)
 *
 * 24/7 professional monitoring for inside and out (Hero Banner, Mobile)
 *
 * 24/7 professional monitoring for inside and out
 */
export const IMG_1k1hPvPOdO3Eaf3zWPnklA = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1k1hPvPOdO3Eaf3zWPnklA/4312516e17acc04333aab61b4a5e18ec/Monitoring_Hero_Mobile.jpg',
  description: `24/7 professional monitoring for inside and out`,
  originalHeight: 753,
  originalWidth: 1129
}

/**
 * ![Smoke & Carbon Monoxide Alarm Listener - Modal](https://images.ctfassets.net/v6awd0kabi65/1J2GlWXdJCB8Q1q46Qw995/03a7b55ad0e88494ef22cd0e8f0b57c5/AL_ceiling.jpg?w=120&h=120&fit=pad)
 *
 * Smoke & Carbon Monoxide Alarm Listener - Modal
 *
 * Smoke & Carbon Monoxide Alarm Listener on a ceiling next to a Smoke & Carbon Monoxide detector
 */
export const IMG_1J2GlWXdJCB8Q1q46Qw995 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1J2GlWXdJCB8Q1q46Qw995/03a7b55ad0e88494ef22cd0e8f0b57c5/AL_ceiling.jpg',
  description: `Smoke & Carbon Monoxide Alarm Listener on a ceiling next to a Smoke & Carbon Monoxide detector`,
  originalHeight: 1056,
  originalWidth: 1256
}

/**
 * ![Olympus Front view (small)](https://images.ctfassets.net/v6awd0kabi65/1zaZyczaz2XK3Ug34J2S40/2754a29ef7793b232ef250ac2bfaca12/Shield.png?w=120&h=120&fit=pad)
 *
 * Olympus Front view (small)
 *
 * null
 */
export const IMG_1zaZyczaz2XK3Ug34J2S40 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1zaZyczaz2XK3Ug34J2S40/2754a29ef7793b232ef250ac2bfaca12/Shield.png',
  description: `null`,
  originalHeight: 512,
  originalWidth: 512
}

/**
 * ![Indoor Cam - BMS Hero](https://images.ctfassets.net/v6awd0kabi65/5XEHJRZUWAEvUgdzwkvBrn/b929c8f7b2d50e1bfeb084bc5df02d24/Indoor_Cam.png?w=120&h=120&fit=pad)
 *
 * Indoor Cam - BMS Hero
 *
 * An indoor camera on a solid white background
 */
export const IMG_5XEHJRZUWAEvUgdzwkvBrn = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5XEHJRZUWAEvUgdzwkvBrn/b929c8f7b2d50e1bfeb084bc5df02d24/Indoor_Cam.png',
  description: `An indoor camera on a solid white background`,
  originalHeight: 503,
  originalWidth: 220
}

/**
 * ![Keypad - BMS Hero](https://images.ctfassets.net/v6awd0kabi65/3lRLh6zyCjOPWMLFf7YJn3/9601b330d21e0d54ed1825bd69702b01/Keypad.png?w=120&h=120&fit=pad)
 *
 * Keypad - BMS Hero
 *
 * A keypad on a solid white background
 */
export const IMG_3lRLh6zyCjOPWMLFf7YJn3 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3lRLh6zyCjOPWMLFf7YJn3/9601b330d21e0d54ed1825bd69702b01/Keypad.png',
  description: `A keypad on a solid white background`,
  originalHeight: 534,
  originalWidth: 259
}

/**
 * ![Base Station - BMS Hero](https://images.ctfassets.net/v6awd0kabi65/4FyNuNOIRFzb2oLiumlUke/c59bf5363afc4d2e740777359c136d5a/Base_Station.png?w=120&h=120&fit=pad)
 *
 * Base Station - BMS Hero
 *
 * A base station on a solid white background
 */
export const IMG_4FyNuNOIRFzb2oLiumlUke = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4FyNuNOIRFzb2oLiumlUke/c59bf5363afc4d2e740777359c136d5a/Base_Station.png',
  description: `A base station on a solid white background`,
  originalHeight: 560,
  originalWidth: 263
}

/**
 * ![Customized Desktop](https://images.ctfassets.net/v6awd0kabi65/2akfg66HjJsCmV2yPAgNht/adb1df99654796bb633e14e01845f25e/Customized_Desktop.png?w=120&h=120&fit=pad)
 *
 * Customized Desktop
 *
 * SimpliSafe products on display
 */
export const IMG_2akfg66HjJsCmV2yPAgNht = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2akfg66HjJsCmV2yPAgNht/adb1df99654796bb633e14e01845f25e/Customized_Desktop.png',
  description: `SimpliSafe products on display`,
  originalHeight: 1413,
  originalWidth: 1947
}

/**
 * ![Business Monitoring App Widget Alerts Tab](https://images.ctfassets.net/v6awd0kabi65/14tfsMmaoy6azxM3Y6XwZA/8ea8ec6f043811bf4a7263c7b6b86fd3/app-widget-alerts-tab.png?w=120&h=120&fit=pad)
 *
 * Business Monitoring App Widget Alerts Tab
 *
 * SimpliSafe app notifications in a smartphone
 */
export const IMG_14tfsMmaoy6azxM3Y6XwZA = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/14tfsMmaoy6azxM3Y6XwZA/8ea8ec6f043811bf4a7263c7b6b86fd3/app-widget-alerts-tab.png',
  description: `SimpliSafe app notifications in a smartphone`,
  originalHeight: 1944,
  originalWidth: 1600
}

/**
 * ![Business Monitoring App Widget Cameras Tab](https://images.ctfassets.net/v6awd0kabi65/6Dh6bVTUe88libK7Gtjryf/1310b1ac15b489813748265025c021c1/app-widget-cameras-tab.png?w=120&h=120&fit=pad)
 *
 * Business Monitoring App Widget Cameras Tab
 *
 * Office and Business exterior Cameras feed
 */
export const IMG_6Dh6bVTUe88libK7Gtjryf = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6Dh6bVTUe88libK7Gtjryf/1310b1ac15b489813748265025c021c1/app-widget-cameras-tab.png',
  description: `Office and Business exterior Cameras feed`,
  originalHeight: 1944,
  originalWidth: 1600
}

/**
 * ![Intruder Intervention Desktop](https://images.ctfassets.net/v6awd0kabi65/2epmZQ71fx08gHz3l9nU3A/6fb7ee734a9e370468da3f7af80d32bf/Intruder_Intervention_Desktop.jpg?w=120&h=120&fit=pad)
 *
 * Intruder Intervention Desktop
 *
 * Live monitoring agent stopping intruder through AI-powered Smart Alarm Indoor Camera
 */
export const IMG_2epmZQ71fx08gHz3l9nU3A = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2epmZQ71fx08gHz3l9nU3A/6fb7ee734a9e370468da3f7af80d32bf/Intruder_Intervention_Desktop.jpg',
  description: `Live monitoring agent stopping intruder through AI-powered Smart Alarm Indoor Camera`,
  originalHeight: 1200,
  originalWidth: 1905
}

/**
 * ![Scout Shutter](https://images.ctfassets.net/v6awd0kabi65/2JEjQKc5qKA1I4PrQLzPiU/78e0d17bf602a9cac96c1c7ea6c0edc5/Scout_Shutter.jpg?w=120&h=120&fit=pad)
 *
 * Scout Shutter
 *
 * Outdoor Camera identifying intruder with AI technology
 */
export const IMG_2JEjQKc5qKA1I4PrQLzPiU = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2JEjQKc5qKA1I4PrQLzPiU/78e0d17bf602a9cac96c1c7ea6c0edc5/Scout_Shutter.jpg',
  description: `Outdoor Camera identifying intruder with AI technology`,
  originalHeight: 1191,
  originalWidth: 1905
}

/**
 * ![Variation Dog House Hero](https://images.ctfassets.net/v6awd0kabi65/gocnGhTHaRSUSKjaaHR66/030d3dc066cd998d91727d4ee8999c7e/Hero_Desktop__New.png?w=120&h=120&fit=pad)
 *
 * Variation Dog House Hero
 *
 * A dog standing in front of a house
 */
export const IMG_gocnGhTHaRSUSKjaaHR66 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/gocnGhTHaRSUSKjaaHR66/030d3dc066cd998d91727d4ee8999c7e/Hero_Desktop__New.png',
  description: `A dog standing in front of a house`,
  originalHeight: 2600,
  originalWidth: 5760
}

/**
 * ![VDP notifications that matter UK](https://images.ctfassets.net/v6awd0kabi65/4ULo6Qy02B3hbt8o91eVQG/944f739c20201d11e95d0a85f2389998/VDP_notifications_that_matter_UK.webp?w=120&h=120&fit=pad)
 *
 * VDP notifications that matter UK
 *
 * null
 */
export const IMG_4ULo6Qy02B3hbt8o91eVQG = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4ULo6Qy02B3hbt8o91eVQG/944f739c20201d11e95d0a85f2389998/VDP_notifications_that_matter_UK.webp',
  description: `null`,
  originalHeight: 794,
  originalWidth: 1244
}

/**
 * ![Olympus Front View](https://images.ctfassets.net/v6awd0kabi65/3etOb10ix7yPx6fKuTJ4Tz/8243e1a7cf6504f06293f530f8468c0f/Olympus_base2d_001.png?w=120&h=120&fit=pad)
 *
 * Olympus Front View
 *
 * Front view of an outdoor camera
 */
export const IMG_3etOb10ix7yPx6fKuTJ4Tz = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3etOb10ix7yPx6fKuTJ4Tz/8243e1a7cf6504f06293f530f8468c0f/Olympus_base2d_001.png',
  description: `Front view of an outdoor camera`,
  originalHeight: 1019,
  originalWidth: 1071
}

/**
 * ![Professional Monitoring SMB (Image banner Mobile/Tablet)](https://images.ctfassets.net/v6awd0kabi65/242pIbw61QnnXoRfmf4Exs/5bc337496f8d09a26393dd7048c75c4b/5ce2eec8c4adbc0790b4172b76479384cb3646a2.jpg?w=120&h=120&fit=pad)
 *
 * Professional Monitoring SMB (Image banner Mobile/Tablet)
 *
 * A professional monitoring agent looking at a monitor
 */
export const IMG_242pIbw61QnnXoRfmf4Exs = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/242pIbw61QnnXoRfmf4Exs/5bc337496f8d09a26393dd7048c75c4b/5ce2eec8c4adbc0790b4172b76479384cb3646a2.jpg',
  description: `A professional monitoring agent looking at a monitor`,
  originalHeight: 2731,
  originalWidth: 4096
}

/**
 * ![Smoke & Carbon Monoxide Alarm Listener - Product Card](https://images.ctfassets.net/v6awd0kabi65/6zkTZiyxOXODRF1Yg621n6/5fbeb7329163f3a22b6d61495e01abb4/Product_AlarmListener2x_2.png?w=120&h=120&fit=pad)
 *
 * Smoke & Carbon Monoxide Alarm Listener - Product Card
 *
 * Smoke & Carbon Monoxide Alarm Listener
 */
export const IMG_6zkTZiyxOXODRF1Yg621n6 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6zkTZiyxOXODRF1Yg621n6/5fbeb7329163f3a22b6d61495e01abb4/Product_AlarmListener2x_2.png',
  description: `Smoke & Carbon Monoxide Alarm Listener`,
  originalHeight: 320,
  originalWidth: 320
}

/**
 * ![Header | Customize A Package - Smoke & CO](https://images.ctfassets.net/v6awd0kabi65/2bbjRbJmiYWrDqmeIwqLpO/6788d32913f3c9191de4ee2a39d8c55f/CustomizeArt.png?w=120&h=120&fit=pad)
 *
 * Header | Customize A Package - Smoke & CO
 *
 * A smoke and CO detector, an outdoor camera, an indoor camera, and a motion sensor arranged in circles.
 */
export const IMG_2bbjRbJmiYWrDqmeIwqLpO = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2bbjRbJmiYWrDqmeIwqLpO/6788d32913f3c9191de4ee2a39d8c55f/CustomizeArt.png',
  description: `A smoke and CO detector, an outdoor camera, an indoor camera, and a motion sensor arranged in circles.`,
  originalHeight: 342,
  originalWidth: 342
}

/**
 * ![Smoke & CO Alarm Listener - Modal - Carousel Thumb 4](https://images.ctfassets.net/v6awd0kabi65/2IMCMsBpsc9eFuqlgxO5CG/71e5cf1732fd24b6e9c44621a17268d0/Echo_Thumb_4.jpg?w=120&h=120&fit=pad)
 *
 * Smoke & CO Alarm Listener - Modal - Carousel Thumb 4
 *
 * A person is testing a hardwired detector. The person's hands are shown pressing a test button as the detector is being disconnected from the ceiling, revealing red, white, and black wires. Text above the image says: "1 Alarm Listener is all you need for hardwired and interconnected systems."
 */
export const IMG_2IMCMsBpsc9eFuqlgxO5CG = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2IMCMsBpsc9eFuqlgxO5CG/71e5cf1732fd24b6e9c44621a17268d0/Echo_Thumb_4.jpg',
  description: `A person is testing a hardwired detector. The person's hands are shown pressing a test button as the detector is being disconnected from the ceiling, revealing red, white, and black wires. Text above the image says: "1 Alarm Listener is all you need for hardwired and interconnected systems."`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Smoke & CO Alarm Listener - Modal - Carousel Thumb 3](https://images.ctfassets.net/v6awd0kabi65/3Qjxpkpb3pBgmlhdksavvm/6f16acd88c75448be86eba13fe3957e5/Echo_Thumb_3.jpg?w=120&h=120&fit=pad)
 *
 * Smoke & CO Alarm Listener - Modal - Carousel Thumb 3
 *
 * A split-screen image shows a fire truck on the left and a monitoring agent wearing a headset on the right. A speech bubble from the agent says, "We've requested emergency dispatch. Help is on the way." The text below the image says, "Unlock 24/7 professional monitoring for your existing smoke and CO detectors. *With professional monitoring plans."
 */
export const IMG_3Qjxpkpb3pBgmlhdksavvm = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3Qjxpkpb3pBgmlhdksavvm/6f16acd88c75448be86eba13fe3957e5/Echo_Thumb_3.jpg',
  description: `A split-screen image shows a fire truck on the left and a monitoring agent wearing a headset on the right. A speech bubble from the agent says, "We've requested emergency dispatch. Help is on the way." The text below the image says, "Unlock 24/7 professional monitoring for your existing smoke and CO detectors. *With professional monitoring plans."`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Smoke & CO Alarm Listener - Modal - Carousel Thumb 2](https://images.ctfassets.net/v6awd0kabi65/Xr0YdOQ7dVA39kxhsNc1Z/c5cd03a86e1351c397d4bd36908c3d55/Echo_Thumb_2.jpg?w=120&h=120&fit=pad)
 *
 * Smoke & CO Alarm Listener - Modal - Carousel Thumb 2
 *
 * A Smoke & CO Alarm Listener is installed next to an existing smoke detector on a ceiling. An arrow with the text "4in maximum gap" points between them, visually demonstrating the required installation distance.
 */
export const IMG_Xr0YdOQ7dVA39kxhsNc1Z = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/Xr0YdOQ7dVA39kxhsNc1Z/c5cd03a86e1351c397d4bd36908c3d55/Echo_Thumb_2.jpg',
  description: `A Smoke & CO Alarm Listener is installed next to an existing smoke detector on a ceiling. An arrow with the text "4in maximum gap" points between them, visually demonstrating the required installation distance.`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Smoke & CO Alarm Listener - Modal - Carousel Thumb 1](https://images.ctfassets.net/v6awd0kabi65/3u5FN6cCrsoDzKhNBv7yy3/6446cb21a19572027b5bfb741f549ea0/Echo_Thumb_1.jpg?w=120&h=120&fit=pad)
 *
 * Smoke & CO Alarm Listener - Modal - Carousel Thumb 1
 *
 * A close-up image of a person wearing a golden-brown sweater reaching up to a white ceiling. Their hand is holding a Smoke & CO Alarm Listener that they are about to install next to a larger, existing smoke detector. The background is out of focus, with a dark blue wall visible below the ceiling.
 */
export const IMG_3u5FN6cCrsoDzKhNBv7yy3 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3u5FN6cCrsoDzKhNBv7yy3/6446cb21a19572027b5bfb741f549ea0/Echo_Thumb_1.jpg',
  description: `A close-up image of a person wearing a golden-brown sweater reaching up to a white ceiling. Their hand is holding a Smoke & CO Alarm Listener that they are about to install next to a larger, existing smoke detector. The background is out of focus, with a dark blue wall visible below the ceiling.`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Smoke & CO Alarm Listener - Modal - Carousel 4](https://images.ctfassets.net/v6awd0kabi65/7vZwGSaEmXf1Jn5VZY2cmK/dc0f5d1c4edb2c85e5b134cddea903da/Echo_Carousel_4.jpg?w=120&h=120&fit=pad)
 *
 * Smoke & CO Alarm Listener - Modal - Carousel 4
 *
 * A person is testing a hardwired detector. The person's hands are shown pressing a test button as the detector is being disconnected from the ceiling, revealing red, white, and black wires. Text above the image says: "1 Alarm Listener is all you need for hardwired and interconnected systems."
 */
export const IMG_7vZwGSaEmXf1Jn5VZY2cmK = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7vZwGSaEmXf1Jn5VZY2cmK/dc0f5d1c4edb2c85e5b134cddea903da/Echo_Carousel_4.jpg',
  description: `A person is testing a hardwired detector. The person's hands are shown pressing a test button as the detector is being disconnected from the ceiling, revealing red, white, and black wires. Text above the image says: "1 Alarm Listener is all you need for hardwired and interconnected systems."`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Smoke & CO Alarm Listener - Modal - Carousel 3](https://images.ctfassets.net/v6awd0kabi65/4VPJeVXBobfta5g7MBXoga/34f6cae337355ef0027b26e021ea4a1b/Echo_Carousel_3.jpg?w=120&h=120&fit=pad)
 *
 * Smoke & CO Alarm Listener - Modal - Carousel 3
 *
 * A split-screen image shows a fire truck on the left and a monitoring agent wearing a headset on the right. A speech bubble from the agent says, "We've requested emergency dispatch. Help is on the way." The text below the image says, "Unlock 24/7 professional monitoring for your existing smoke and CO detectors. *With professional monitoring plans."
 */
export const IMG_4VPJeVXBobfta5g7MBXoga = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4VPJeVXBobfta5g7MBXoga/34f6cae337355ef0027b26e021ea4a1b/Echo_Carousel_3.jpg',
  description: `A split-screen image shows a fire truck on the left and a monitoring agent wearing a headset on the right. A speech bubble from the agent says, "We've requested emergency dispatch. Help is on the way." The text below the image says, "Unlock 24/7 professional monitoring for your existing smoke and CO detectors. *With professional monitoring plans."`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Smoke & CO Alarm Listener - Modal - Carousel 2](https://images.ctfassets.net/v6awd0kabi65/7AvkokOWDz4EGjIjpjIECh/77636fc65250b8bf9ef0aa3d174d088f/Echo_Carousel_2.jpg?w=120&h=120&fit=pad)
 *
 * Smoke & CO Alarm Listener - Modal - Carousel 2
 *
 * A Smoke & CO Alarm Listener is installed next to an existing smoke detector on a ceiling. An arrow with the text "4in maximum gap" points between them, visually demonstrating the required installation distance.
 */
export const IMG_7AvkokOWDz4EGjIjpjIECh = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7AvkokOWDz4EGjIjpjIECh/77636fc65250b8bf9ef0aa3d174d088f/Echo_Carousel_2.jpg',
  description: `A Smoke & CO Alarm Listener is installed next to an existing smoke detector on a ceiling. An arrow with the text "4in maximum gap" points between them, visually demonstrating the required installation distance.`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Smoke & CO Alarm Listener - Modal - Carousel 1](https://images.ctfassets.net/v6awd0kabi65/2cRxMQQWhIjh7HKGkRjFux/666c20526f6bc06bc73bcfc99d949a2c/Echo_Carousel_1.jpg?w=120&h=120&fit=pad)
 *
 * Smoke & CO Alarm Listener - Modal - Carousel 1
 *
 * A close-up image of a person wearing a golden-brown sweater reaching up to a white ceiling. Their hand is holding a Smoke & CO Alarm Listener that they are about to install next to a larger, existing smoke detector. The background is out of focus, with a dark blue wall visible below the ceiling.
 */
export const IMG_2cRxMQQWhIjh7HKGkRjFux = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2cRxMQQWhIjh7HKGkRjFux/666c20526f6bc06bc73bcfc99d949a2c/Echo_Carousel_1.jpg',
  description: `A close-up image of a person wearing a golden-brown sweater reaching up to a white ceiling. Their hand is holding a Smoke & CO Alarm Listener that they are about to install next to a larger, existing smoke detector. The background is out of focus, with a dark blue wall visible below the ceiling.`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Outdoor Camera Modal (SMB)](https://images.ctfassets.net/v6awd0kabi65/5n7SSa9QaPKDrhdQJueKIH/9f896e4de5360ee2e64b25df36d38977/ODCam_Carousel_3.jpg?w=120&h=120&fit=pad)
 *
 * Outdoor Camera Modal (SMB)
 *
 * Camera must be plugged in to use SimpliSafe Active Guard Outdoor Protection.
 */
export const IMG_5n7SSa9QaPKDrhdQJueKIH = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5n7SSa9QaPKDrhdQJueKIH/9f896e4de5360ee2e64b25df36d38977/ODCam_Carousel_3.jpg',
  description: `Camera must be plugged in to use SimpliSafe Active Guard Outdoor Protection.`,
  originalHeight: 1696,
  originalWidth: 2144
}

/**
 * ![Video Doorbell Pro (SMB)](https://images.ctfassets.net/v6awd0kabi65/2T11EPrs8suwSw2DbY6jKc/8ab316f6c16113322e7a331003437d7d/Video_Doorbell.jpg?w=120&h=120&fit=pad)
 *
 * Video Doorbell Pro (SMB)
 *
 * A video doorbell on a solid white background
 */
export const IMG_2T11EPrs8suwSw2DbY6jKc = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2T11EPrs8suwSw2DbY6jKc/8ab316f6c16113322e7a331003437d7d/Video_Doorbell.jpg',
  description: `A video doorbell on a solid white background`,
  originalHeight: 320,
  originalWidth: 320
}

/**
 * ![How to conduct a security audit for your small business](https://images.ctfassets.net/v6awd0kabi65/5vrvRovIj4mT9sAa2uTDl9/e0c501377e71f26c4d98d78a2a5dd296/Screenshot_2020-11-05_at_11.21.05.webp?w=120&h=120&fit=pad)
 *
 * How to conduct a security audit for your small business
 *
 *
 */
export const IMG_5vrvRovIj4mT9sAa2uTDl9 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5vrvRovIj4mT9sAa2uTDl9/e0c501377e71f26c4d98d78a2a5dd296/Screenshot_2020-11-05_at_11.21.05.webp',
  description: ``,
  originalHeight: 836,
  originalWidth: 1182
}

/**
 * ![[internal dev tools] - Ewok - Console logging example](https://images.ctfassets.net/v6awd0kabi65/6wVFUJZ349dg8KpAswBzgc/dedcbf0e295f4b5dc15d0f7e97d86d9c/console.ts_-_ewok_-WSL__Ubuntu-_-_Visual_Studio_Code_9_3_2025_11_44_47_AM.png?w=120&h=120&fit=pad)
 *
 * [internal dev tools] - Ewok - Console logging example
 *
 * This image is used internally for our utils library Ewok inside of documentation and a code comment. Please don't use this on the ecomm website or delete it.
 */
export const IMG_6wVFUJZ349dg8KpAswBzgc = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6wVFUJZ349dg8KpAswBzgc/dedcbf0e295f4b5dc15d0f7e97d86d9c/console.ts_-_ewok_-WSL__Ubuntu-_-_Visual_Studio_Code_9_3_2025_11_44_47_AM.png',
  description: `This image is used internally for our utils library Ewok inside of documentation and a code comment. Please don't use this on the ecomm website or delete it.`,
  originalHeight: 170,
  originalWidth: 321
}

/**
 * ![Standard Whole Home Kit (Large Insurance)](https://images.ctfassets.net/v6awd0kabi65/1rwYzwy6eC203wLVe5JUt4/a723367bf4e6fcff825efd182cda76af/Standard_Whole_Home_Kit__Large_Insurance_.jpg?w=120&h=120&fit=pad)
 *
 * Standard Whole Home Kit (Large Insurance)
 *
 * Whole Home Kit components
 */
export const IMG_1rwYzwy6eC203wLVe5JUt4 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1rwYzwy6eC203wLVe5JUt4/a723367bf4e6fcff825efd182cda76af/Standard_Whole_Home_Kit__Large_Insurance_.jpg',
  description: `Whole Home Kit components`,
  originalHeight: 1400,
  originalWidth: 1400
}

/**
 * ![Outdoor Security Camera 2_Spotlight_Wired](https://downloads.ctfassets.net/v6awd0kabi65/79AxhuPduiVI6OKXKnEc5H/f78eb45134bf8af5108757a8d35e6446/Outdoor_Security_Camera_2_Spotlight_Wired.jpg?w=120&h=120&fit=pad)
 *
 * Outdoor Security Camera 2_Spotlight_Wired
 *
 * Outdoor Security Camera with Spotlight
 */
export const IMG_79AxhuPduiVI6OKXKnEc5H = {
  url: 'https://downloads.ctfassets.net/v6awd0kabi65/79AxhuPduiVI6OKXKnEc5H/f78eb45134bf8af5108757a8d35e6446/Outdoor_Security_Camera_2_Spotlight_Wired.jpg',
  description: `Outdoor Security Camera with Spotlight`,
  originalHeight: 5343,
  originalWidth: 8011
}

/**
 * ![How to set up an outdoor security camera](https://images.ctfassets.net/v6awd0kabi65/3WJV1JOBlkjFtWO97Slkhk/7bc787dfb851f3025f80757a9ad79cb9/SimpliSafe_KOALA_by_Ian_Wallman_07774.jpg?w=120&h=120&fit=pad)
 *
 * How to set up an outdoor security camera
 *
 *
 */
export const IMG_3WJV1JOBlkjFtWO97Slkhk = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3WJV1JOBlkjFtWO97Slkhk/7bc787dfb851f3025f80757a9ad79cb9/SimpliSafe_KOALA_by_Ian_Wallman_07774.jpg',
  description: ``,
  originalHeight: 2470,
  originalWidth: 3705
}

/**
 * ![The benefits of 24/7 professional monitoring for small business owners](https://images.ctfassets.net/v6awd0kabi65/3qGqv4VdrKWCtru46Deovp/f1d2e1fdabf52c1f3245e17bc6f8c991/AdobeStock_144030294__1_.jpeg?w=120&h=120&fit=pad)
 *
 * The benefits of 24/7 professional monitoring for small business owners
 *
 *
 */
export const IMG_3qGqv4VdrKWCtru46Deovp = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3qGqv4VdrKWCtru46Deovp/f1d2e1fdabf52c1f3245e17bc6f8c991/AdobeStock_144030294__1_.jpeg',
  description: ``,
  originalHeight: 4912,
  originalWidth: 7360
}

/**
 * ![Smoke & Carbon Monoxide Detector with background](https://images.ctfassets.net/v6awd0kabi65/7yfWyL9JxuzVpVXYOQJh82/708dbef123fc16ffd1a6acc697052d2e/PreBuilt-SmokeCO.jpg?w=120&h=120&fit=pad)
 *
 * Smoke & Carbon Monoxide Detector with background
 *
 * Smoke & Carbon Monoxide Detector on a white background
 */
export const IMG_7yfWyL9JxuzVpVXYOQJh82 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7yfWyL9JxuzVpVXYOQJh82/708dbef123fc16ffd1a6acc697052d2e/PreBuilt-SmokeCO.jpg',
  description: `Smoke & Carbon Monoxide Detector on a white background`,
  originalHeight: 1200,
  originalWidth: 1278
}

/**
 * ![Smoke & Carbon Monoxide Detector Floor Plan Carousel Image ](https://images.ctfassets.net/v6awd0kabi65/2LUtCoaqRozOOocoXzJozX/54b11f94e5bde7dcece61ff3ab7a19ac/carousel.png?w=120&h=120&fit=pad)
 *
 * Smoke & Carbon Monoxide Detector Floor Plan Carousel Image
 *
 * Smoke and Carbon Monoxide Detector installed on ceiling
 */
export const IMG_2LUtCoaqRozOOocoXzJozX = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2LUtCoaqRozOOocoXzJozX/54b11f94e5bde7dcece61ff3ab7a19ac/carousel.png',
  description: `Smoke and Carbon Monoxide Detector installed on ceiling`,
  originalHeight: 1094,
  originalWidth: 1641
}

/**
 * ![The Knox (with new Smoke & CO Detector)](https://images.ctfassets.net/v6awd0kabi65/1yy00W6vHeJ6CChd2Bt8Ca/104cee6da00eda615417a0f4dee1bc0b/The_Knox.jpg?w=120&h=120&fit=pad)
 *
 * The Knox (with new Smoke & CO Detector)
 *
 * The Knox
 */
export const IMG_1yy00W6vHeJ6CChd2Bt8Ca = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1yy00W6vHeJ6CChd2Bt8Ca/104cee6da00eda615417a0f4dee1bc0b/The_Knox.jpg',
  description: `The Knox`,
  originalHeight: 3160,
  originalWidth: 3160
}

/**
 * ![The Hearth (with new Smoke & CO Detector)](https://images.ctfassets.net/v6awd0kabi65/RBDE2hLDydNWNmyoKg4UN/7285b2003ec0a224e197cbffcc3dd777/The_Hearth.jpg?w=120&h=120&fit=pad)
 *
 * The Hearth (with new Smoke & CO Detector)
 *
 * The Hearth
 */
export const IMG_RBDE2hLDydNWNmyoKg4UN = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/RBDE2hLDydNWNmyoKg4UN/7285b2003ec0a224e197cbffcc3dd777/The_Hearth.jpg',
  description: `The Hearth`,
  originalHeight: 3160,
  originalWidth: 3160
}

/**
 * ![The Haven (with new Smoke & CO Detector)](https://images.ctfassets.net/v6awd0kabi65/2PnNLwevp2FQZXe7R2UiI2/fd1e15b37d57478676e0ac0a1fc92749/The_Haven.jpg?w=120&h=120&fit=pad)
 *
 * The Haven (with new Smoke & CO Detector)
 *
 * The Haven
 */
export const IMG_2PnNLwevp2FQZXe7R2UiI2 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2PnNLwevp2FQZXe7R2UiI2/fd1e15b37d57478676e0ac0a1fc92749/The_Haven.jpg',
  description: `The Haven`,
  originalHeight: 3162,
  originalWidth: 3160
}

/**
 * ![Alarm Moment - Fire - Echo](https://images.ctfassets.net/v6awd0kabi65/1qVX0m87mEqNbsOeancOrs/d16c167edba2431e1dd745151672049c/Fire.jpg?w=120&h=120&fit=pad)
 *
 * Alarm Moment - Fire - Echo
 *
 * An illustration of a couple in their bedroom being alerted of a fire in their home from the smoke detector
 */
export const IMG_1qVX0m87mEqNbsOeancOrs = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1qVX0m87mEqNbsOeancOrs/d16c167edba2431e1dd745151672049c/Fire.jpg',
  description: `An illustration of a couple in their bedroom being alerted of a fire in their home from the smoke detector`,
  originalHeight: 1056,
  originalWidth: 1932
}

/**
 * ![Smoke & Carbon Monoxide Alarm Listener render standing shadow](https://images.ctfassets.net/v6awd0kabi65/01axCPjVKD0S1Wc88JiD3v/69c0e3707296cdbe261873e6968f8fe9/Echo_standalone.png?w=120&h=120&fit=pad)
 *
 * Smoke & Carbon Monoxide Alarm Listener render standing shadow
 *
 * Smoke & Carbon Monoxide Alarm Listener render standing shadow
 */
export const IMG_01axCPjVKD0S1Wc88JiD3v = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/01axCPjVKD0S1Wc88JiD3v/69c0e3707296cdbe261873e6968f8fe9/Echo_standalone.png',
  description: `Smoke & Carbon Monoxide Alarm Listener render standing shadow`,
  originalHeight: 758,
  originalWidth: 1040
}

/**
 * ![Smoke & Carbon Monoxide Alarm Listener - Image Blurbs - Maximize your reach](https://images.ctfassets.net/v6awd0kabi65/4grtCxWrbfqlSdhV3hGA7W/929cfcbaf393c5e4b84cfe52da1b5675/AL_PDP_Widget2.jpg?w=120&h=120&fit=pad)
 *
 * Smoke & Carbon Monoxide Alarm Listener - Image Blurbs - Maximize your reach
 *
 *
 */
export const IMG_4grtCxWrbfqlSdhV3hGA7W = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4grtCxWrbfqlSdhV3hGA7W/929cfcbaf393c5e4b84cfe52da1b5675/AL_PDP_Widget2.jpg',
  description: ``,
  originalHeight: 794,
  originalWidth: 1262
}

/**
 * ![Smoke & Carbon Monoxide Alarm Listener - Image Blurbs - False Alarm](https://images.ctfassets.net/v6awd0kabi65/mfXkxSpN1oiPkKNEyp03f/8a14f63cd88877af8ac9a1f54c1bb722/AL_PDP_Widget1.jpg?w=120&h=120&fit=pad)
 *
 * Smoke & Carbon Monoxide Alarm Listener - Image Blurbs - False Alarm
 *
 *
 */
export const IMG_mfXkxSpN1oiPkKNEyp03f = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/mfXkxSpN1oiPkKNEyp03f/8a14f63cd88877af8ac9a1f54c1bb722/AL_PDP_Widget1.jpg',
  description: ``,
  originalHeight: 794,
  originalWidth: 1262
}

/**
 * ![Smoke & Carbon Monoxide Alarm Listener - App Image 3](https://images.ctfassets.net/v6awd0kabi65/4RljMtLLn1aIDZBz1NgJp0/d4f328b231b85dbbc792965ebd31f03f/Echo_app_3.png?w=120&h=120&fit=pad)
 *
 * Smoke & Carbon Monoxide Alarm Listener - App Image 3
 *
 *
 */
export const IMG_4RljMtLLn1aIDZBz1NgJp0 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4RljMtLLn1aIDZBz1NgJp0/d4f328b231b85dbbc792965ebd31f03f/Echo_app_3.png',
  description: ``,
  originalHeight: 1254,
  originalWidth: 1011
}

/**
 * ![Smoke & Carbon Monoxide Alarm Listener - App Image 2](https://images.ctfassets.net/v6awd0kabi65/4txLu2GkTLLtCBeRDNWeuV/4dfda070499b31d24dffcf6786154954/Echo_app_2.png?w=120&h=120&fit=pad)
 *
 * Smoke & Carbon Monoxide Alarm Listener - App Image 2
 *
 *
 */
export const IMG_4txLu2GkTLLtCBeRDNWeuV = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4txLu2GkTLLtCBeRDNWeuV/4dfda070499b31d24dffcf6786154954/Echo_app_2.png',
  description: ``,
  originalHeight: 1254,
  originalWidth: 1011
}

/**
 * ![Smoke & Carbon Monoxide Alarm Listener - App Image 1](https://images.ctfassets.net/v6awd0kabi65/2csJ4hTiqogAoxAghhS9Qa/0e502055d6734f397d0ccb99f54f0a2e/Echo_app_1.png?w=120&h=120&fit=pad)
 *
 * Smoke & Carbon Monoxide Alarm Listener - App Image 1
 *
 *
 */
export const IMG_2csJ4hTiqogAoxAghhS9Qa = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2csJ4hTiqogAoxAghhS9Qa/0e502055d6734f397d0ccb99f54f0a2e/Echo_app_1.png',
  description: ``,
  originalHeight: 1254,
  originalWidth: 1011
}

/**
 * ![Smoke & Carbon Monoxide Alarm Listener - Feature Image 2](https://images.ctfassets.net/v6awd0kabi65/LBjyLBao9Mm3VqpmjZicq/a840a66e552af5bfdd1c1c6cc1aa8244/Echo_diagram_2.jpg?w=120&h=120&fit=pad)
 *
 * Smoke & Carbon Monoxide Alarm Listener - Feature Image 2
 *
 *
 */
export const IMG_LBjyLBao9Mm3VqpmjZicq = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/LBjyLBao9Mm3VqpmjZicq/a840a66e552af5bfdd1c1c6cc1aa8244/Echo_diagram_2.jpg',
  description: ``,
  originalHeight: 2542,
  originalWidth: 2198
}

/**
 * ![Smoke & Carbon Monoxide Alarm Listener - Feature Image 1](https://images.ctfassets.net/v6awd0kabi65/2Qzp4XNqTPZrLgFPyS4Gve/0c6aae573d81d2c280f79aa20e6b5ef1/Echo_diagram_1.jpg?w=120&h=120&fit=pad)
 *
 * Smoke & Carbon Monoxide Alarm Listener - Feature Image 1
 *
 * Microphone. Finally-tuned to listen
 */
export const IMG_2Qzp4XNqTPZrLgFPyS4Gve = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2Qzp4XNqTPZrLgFPyS4Gve/0c6aae573d81d2c280f79aa20e6b5ef1/Echo_diagram_1.jpg',
  description: `Microphone. Finally-tuned to listen `,
  originalHeight: 2542,
  originalWidth: 2198
}

/**
 * ![Smoke & Carbon Monoxide Alarm Listener - Carousel - Image 4](https://images.ctfassets.net/v6awd0kabi65/7K1YWDhfoeO6sWs0QG2GML/b50dfeeadc826183e91493931f72d9c0/Echo_Carousel_4.jpg?w=120&h=120&fit=pad)
 *
 * Smoke & Carbon Monoxide Alarm Listener - Carousel - Image 4
 *
 * Smartphone showing fire alarm alert detected by smoke/CO listener
 */
export const IMG_7K1YWDhfoeO6sWs0QG2GML = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7K1YWDhfoeO6sWs0QG2GML/b50dfeeadc826183e91493931f72d9c0/Echo_Carousel_4.jpg',
  description: `Smartphone showing fire alarm alert detected by smoke/CO listener`,
  originalHeight: 1104,
  originalWidth: 1400
}

/**
 * ![Smoke & Carbon Monoxide Alarm Listener - Carousel - Image 3](https://images.ctfassets.net/v6awd0kabi65/71HtYiyrJv32jarn4yRzoc/34927645e1406bf62019955879cc7ed9/Echo_Carousel_3.jpg?w=120&h=120&fit=pad)
 *
 * Smoke & Carbon Monoxide Alarm Listener - Carousel - Image 3
 *
 * Alarm listener mounted on ceiling next to existing smoke detector
 */
export const IMG_71HtYiyrJv32jarn4yRzoc = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/71HtYiyrJv32jarn4yRzoc/34927645e1406bf62019955879cc7ed9/Echo_Carousel_3.jpg',
  description: `Alarm listener mounted on ceiling next to existing smoke detector`,
  originalHeight: 1104,
  originalWidth: 1400
}

/**
 * ![Smoke & Carbon Monoxide Alarm Listener - Carousel - Image 2](https://images.ctfassets.net/v6awd0kabi65/4uA9Yv74ELLkxkbS1xTW5o/2446a7e8156b67168f87e4e592147def/Echo_Carousel_2.jpg?w=120&h=120&fit=pad)
 *
 * Smoke & Carbon Monoxide Alarm Listener - Carousel - Image 2
 *
 * Smoke detector and alarm listener installed with a maximum 4-inch gap
 */
export const IMG_4uA9Yv74ELLkxkbS1xTW5o = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4uA9Yv74ELLkxkbS1xTW5o/2446a7e8156b67168f87e4e592147def/Echo_Carousel_2.jpg',
  description: `Smoke detector and alarm listener installed with a maximum 4-inch gap`,
  originalHeight: 1104,
  originalWidth: 1400
}

/**
 * ![Smoke & Carbon Monoxide Alarm Listener - Carousel - Image 1](https://images.ctfassets.net/v6awd0kabi65/4ELYTtzUtfP01Dc5OAqIih/951365bde124aa02ebc3087b23b131ea/Echo_Carousel_1.jpg?w=120&h=120&fit=pad)
 *
 * Smoke & Carbon Monoxide Alarm Listener - Carousel - Image 1
 *
 * Person installing a smoke and CO alarm listener beside existing detector.
 */
export const IMG_4ELYTtzUtfP01Dc5OAqIih = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4ELYTtzUtfP01Dc5OAqIih/951365bde124aa02ebc3087b23b131ea/Echo_Carousel_1.jpg',
  description: `Person installing a smoke and CO alarm listener beside existing detector.`,
  originalHeight: 1105,
  originalWidth: 1400
}

/**
 * ![Wireless Indoor Camera Large](https://images.ctfassets.net/v6awd0kabi65/gNTLche09MdSBR8E9XP0u/75f9d59164c1ccea8b0d851328f90768/230411_SimpliSafe_Scout_Hero_0143_FIN_Layers_noGlare_2.jpg?w=120&h=120&fit=pad)
 *
 * Wireless Indoor Camera Large
 *
 *
 */
export const IMG_gNTLche09MdSBR8E9XP0u = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/gNTLche09MdSBR8E9XP0u/75f9d59164c1ccea8b0d851328f90768/230411_SimpliSafe_Scout_Hero_0143_FIN_Layers_noGlare_2.jpg',
  description: ``,
  originalHeight: 898,
  originalWidth: 898
}

/**
 * ![[UK] Edinburgh Package](https://images.ctfassets.net/v6awd0kabi65/7tGkKxex54ZKQNEO7YCWlZ/7daa119974597f438efb4c7158769298/UK_Edinburgh_2025_SystemPackage.jpg?w=120&h=120&fit=pad)
 *
 * [UK] Edinburgh Package
 *
 *
 */
export const IMG_7tGkKxex54ZKQNEO7YCWlZ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7tGkKxex54ZKQNEO7YCWlZ/7daa119974597f438efb4c7158769298/UK_Edinburgh_2025_SystemPackage.jpg',
  description: ``,
  originalHeight: 3500,
  originalWidth: 3500
}

/**
 * ![The Pembroke](https://images.ctfassets.net/v6awd0kabi65/7lcNcvBBgZPhBxjwHIJy7e/bda44ad9b12755fc8df26501cf67a39e/UK_Pembroke_SystemPackage.jpg?w=120&h=120&fit=pad)
 *
 * The Pembroke
 *
 * The Pembroke package sensors
 */
export const IMG_7lcNcvBBgZPhBxjwHIJy7e = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7lcNcvBBgZPhBxjwHIJy7e/bda44ad9b12755fc8df26501cf67a39e/UK_Pembroke_SystemPackage.jpg',
  description: `The Pembroke package sensors`,
  originalHeight: 3500,
  originalWidth: 3500
}

/**
 * ![Build My System](https://images.ctfassets.net/v6awd0kabi65/7jOaZLJ9tVN3UNUlsJO1ES/d2085ccbef2ea3b46aa09dff05b007a2/BMS.jpg?w=120&h=120&fit=pad)
 *
 * Build My System
 *
 * null
 */
export const IMG_7jOaZLJ9tVN3UNUlsJO1ES = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7jOaZLJ9tVN3UNUlsJO1ES/d2085ccbef2ea3b46aa09dff05b007a2/BMS.jpg',
  description: `null`,
  originalHeight: 640,
  originalWidth: 815
}

/**
 * ![UK Package Windsor](https://images.ctfassets.net/v6awd0kabi65/7dLXMFMelneMysoHyhBFxq/2ceef42177d6ac3d7509591e89bba211/UK_Windsor_SystemPackage.jpg?w=120&h=120&fit=pad)
 *
 * UK Package Windsor
 *
 *
 */
export const IMG_7dLXMFMelneMysoHyhBFxq = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7dLXMFMelneMysoHyhBFxq/2ceef42177d6ac3d7509591e89bba211/UK_Windsor_SystemPackage.jpg',
  description: ``,
  originalHeight: 3500,
  originalWidth: 3500
}

/**
 * ![Header | Indoor Basic Package](https://images.ctfassets.net/v6awd0kabi65/6pToedl3jApJdlviDDSSFi/560b8b418b09918d21100c0564ca077e/Nav_essentialsAsset_3x.png?w=120&h=120&fit=pad)
 *
 * Header | Indoor Basic Package
 *
 * Indoor Basic Package
 */
export const IMG_6pToedl3jApJdlviDDSSFi = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6pToedl3jApJdlviDDSSFi/560b8b418b09918d21100c0564ca077e/Nav_essentialsAsset_3x.png',
  description: `Indoor Basic Package`,
  originalHeight: 702,
  originalWidth: 1050
}

/**
 * ![UK Package Starter - Which? Sticker](https://images.ctfassets.net/v6awd0kabi65/6ofAJThJv1d3N3nCDHdVVl/dc780820dd8c69f9c7b28d2e385a4070/UK_Starter_SystemPackage.jpg?w=120&h=120&fit=pad)
 *
 * UK Package Starter - Which? Sticker
 *
 *
 */
export const IMG_6ofAJThJv1d3N3nCDHdVVl = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6ofAJThJv1d3N3nCDHdVVl/dc780820dd8c69f9c7b28d2e385a4070/UK_Starter_SystemPackage.jpg',
  description: ``,
  originalHeight: 3500,
  originalWidth: 3500
}

/**
 * ![UK Package Bamburgh](https://images.ctfassets.net/v6awd0kabi65/6nQ3QjSyWprFk9cYtFqjaA/d9e1b4bf07d6aaa6afe07d2d641f5053/UK_Bamburgh_2025_SystemPackage_3500x3500.jpg?w=120&h=120&fit=pad)
 *
 * UK Package Bamburgh
 *
 * null
 */
export const IMG_6nQ3QjSyWprFk9cYtFqjaA = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6nQ3QjSyWprFk9cYtFqjaA/d9e1b4bf07d6aaa6afe07d2d641f5053/UK_Bamburgh_2025_SystemPackage_3500x3500.jpg',
  description: `null`,
  originalHeight: 3500,
  originalWidth: 3500
}

/**
 * ![The Foundation](https://images.ctfassets.net/v6awd0kabi65/5Uko0ohClTl4A9Jop7elUh/72de7561b484894f4fbffe41245bfc49/UK_Foundation_wSimpliCam_SystemPackage.jpg?w=120&h=120&fit=pad)
 *
 * The Foundation
 *
 * An image of all of the components included in The Foundation package.
 */
export const IMG_5Uko0ohClTl4A9Jop7elUh = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5Uko0ohClTl4A9Jop7elUh/72de7561b484894f4fbffe41245bfc49/UK_Foundation_wSimpliCam_SystemPackage.jpg',
  description: `An image of all of the components included in The Foundation package. `,
  originalHeight: 3500,
  originalWidth: 3500
}

/**
 * ![Header | Outdoor Basic Package](https://images.ctfassets.net/v6awd0kabi65/5C0JVOfwJLkJK6WF6NZ9PW/c928f224aaa994ba432679b7d9d2ef53/Nav_Tower.jpg?w=120&h=120&fit=pad)
 *
 * Header | Outdoor Basic Package
 *
 * Outdoor Basic Package
 */
export const IMG_5C0JVOfwJLkJK6WF6NZ9PW = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5C0JVOfwJLkJK6WF6NZ9PW/c928f224aaa994ba432679b7d9d2ef53/Nav_Tower.jpg',
  description: `Outdoor Basic Package`,
  originalHeight: 468,
  originalWidth: 700
}

/**
 * ![UK Package Essentials](https://images.ctfassets.net/v6awd0kabi65/4xec43dBaiTwat0ItdFxpc/e21da1d5066cad5d8524007e4a6c76a9/UK_Essentials_SystemPackage.jpg?w=120&h=120&fit=pad)
 *
 * UK Package Essentials
 *
 * null
 */
export const IMG_4xec43dBaiTwat0ItdFxpc = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4xec43dBaiTwat0ItdFxpc/e21da1d5066cad5d8524007e4a6c76a9/UK_Essentials_SystemPackage.jpg',
  description: `null`,
  originalHeight: 3500,
  originalWidth: 3500
}

/**
 * ![Wireless Indoor Camera (Transparent)](https://images.ctfassets.net/v6awd0kabi65/4oWREK1JjWTP8ipiwWNft2/32bb41ed720a5f5c591b07530104bcb2/Wireless_Indoor.jpg?w=120&h=120&fit=pad)
 *
 * Wireless Indoor Camera (Transparent)
 *
 *
 */
export const IMG_4oWREK1JjWTP8ipiwWNft2 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4oWREK1JjWTP8ipiwWNft2/32bb41ed720a5f5c591b07530104bcb2/Wireless_Indoor.jpg',
  description: ``,
  originalHeight: 400,
  originalWidth: 452
}

/**
 * ![UK Package Starter](https://images.ctfassets.net/v6awd0kabi65/3pAeJWowAZXlWOXVBJULJs/7cc1fa0b0eb2bde05631778409b40406/UK_Starter_SystemPackage.jpg?w=120&h=120&fit=pad)
 *
 * UK Package Starter
 *
 *
 */
export const IMG_3pAeJWowAZXlWOXVBJULJs = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3pAeJWowAZXlWOXVBJULJs/7cc1fa0b0eb2bde05631778409b40406/UK_Starter_SystemPackage.jpg',
  description: ``,
  originalHeight: 3500,
  originalWidth: 3500
}

/**
 * ![Header | Outdoor Elite Package](https://images.ctfassets.net/v6awd0kabi65/30qjwcrVYFr7ZLmfts9yID/d9b643f712b2fe2ef3806f33bf977f81/Nav_Edinburgh.jpg?w=120&h=120&fit=pad)
 *
 * Header | Outdoor Elite Package
 *
 * Outdoor Elite Package
 */
export const IMG_30qjwcrVYFr7ZLmfts9yID = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/30qjwcrVYFr7ZLmfts9yID/d9b643f712b2fe2ef3806f33bf977f81/Nav_Edinburgh.jpg',
  description: `Outdoor Elite Package`,
  originalHeight: 468,
  originalWidth: 700
}

/**
 * ![The Warwick](https://images.ctfassets.net/v6awd0kabi65/2Krvv0LGBMM93OCpbrYehn/c7997e719395b656405d71cc64e4c5cc/UK_Warwick_SystemPackage.jpg?w=120&h=120&fit=pad)
 *
 * The Warwick
 *
 * An image of all of the components included in The Warwick package.
 */
export const IMG_2Krvv0LGBMM93OCpbrYehn = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2Krvv0LGBMM93OCpbrYehn/c7997e719395b656405d71cc64e4c5cc/UK_Warwick_SystemPackage.jpg',
  description: `An image of all of the components included in The Warwick package. `,
  originalHeight: 3500,
  originalWidth: 3500
}

/**
 * ![Header | Customize A Package](https://images.ctfassets.net/v6awd0kabi65/2H1lDKAlSNUC4E4nSolJIV/92a1bb869cbcc1e7684fd5d4bec53a28/Navigation_Customise.png?w=120&h=120&fit=pad)
 *
 * Header | Customize A Package
 *
 * Customize A Package
 */
export const IMG_2H1lDKAlSNUC4E4nSolJIV = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2H1lDKAlSNUC4E4nSolJIV/92a1bb869cbcc1e7684fd5d4bec53a28/Navigation_Customise.png',
  description: `Customize A Package`,
  originalHeight: 448,
  originalWidth: 448
}

/**
 * ![[UK] Package Tower](https://images.ctfassets.net/v6awd0kabi65/1VHkfAB4PpyCU7JVgJCpu2/7f626f6caef6f043a198f3515cce8c99/UK_Tower_SystemPackage.jpg?w=120&h=120&fit=pad)
 *
 * [UK] Package Tower
 *
 *
 */
export const IMG_1VHkfAB4PpyCU7JVgJCpu2 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1VHkfAB4PpyCU7JVgJCpu2/7f626f6caef6f043a198f3515cce8c99/UK_Tower_SystemPackage.jpg',
  description: ``,
  originalHeight: 3500,
  originalWidth: 3500
}

/**
 * ![Scout (Transparent bg)](https://images.ctfassets.net/v6awd0kabi65/110RFqhtx573sGduRKfb1k/aaa7b543be1270332d862150ddebc68b/scout_transparent_background.png?w=120&h=120&fit=pad)
 *
 * Scout (Transparent bg)
 *
 *
 */
export const IMG_110RFqhtx573sGduRKfb1k = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/110RFqhtx573sGduRKfb1k/aaa7b543be1270332d862150ddebc68b/scout_transparent_background.png',
  description: ``,
  originalHeight: 1255,
  originalWidth: 629
}

/**
 * ![Pro Setup Help](https://images.ctfassets.net/v6awd0kabi65/5pxEZokOgt7pkiCzWFyYtV/7045e8fa50923aa1e2335ecfe2d51fd7/ProSetup.png?w=120&h=120&fit=pad)
 *
 * Pro Setup Help
 *
 * Highly trained technician installing a SimpliSafe camera outside on the side of a house
 */
export const IMG_5pxEZokOgt7pkiCzWFyYtV = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5pxEZokOgt7pkiCzWFyYtV/7045e8fa50923aa1e2335ecfe2d51fd7/ProSetup.png',
  description: `Highly trained technician installing a SimpliSafe camera outside on the side of a house`,
  originalHeight: 142,
  originalWidth: 142
}

/**
 * ![ODCamS2 live agents](https://images.ctfassets.net/v6awd0kabi65/7xogoGMwKuzQcrwstLhgGV/9d375d6778df8821c2dcfd333f13de70/ODCamS2_live_agents.png?w=120&h=120&fit=pad)
 *
 * ODCamS2 live agents
 *
 *
 */
export const IMG_7xogoGMwKuzQcrwstLhgGV = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7xogoGMwKuzQcrwstLhgGV/9d375d6778df8821c2dcfd333f13de70/ODCamS2_live_agents.png',
  description: ``,
  originalHeight: 397,
  originalWidth: 631
}

/**
 * ![ODCamS2 Carousel 2](https://images.ctfassets.net/v6awd0kabi65/2O3cxR78bbxzwGr5qMa8lU/cccaefd50bb92bf843d12bea6ae6206c/ODCam_Carousel_2.jpg?w=120&h=120&fit=pad)
 *
 * ODCamS2 Carousel 2
 *
 *
 */
export const IMG_2O3cxR78bbxzwGr5qMa8lU = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2O3cxR78bbxzwGr5qMa8lU/cccaefd50bb92bf843d12bea6ae6206c/ODCam_Carousel_2.jpg',
  description: ``,
  originalHeight: 882,
  originalWidth: 1118
}

/**
 * ![ODCamS2 advanced AI](https://images.ctfassets.net/v6awd0kabi65/20kkeBx1IuJm1VX4BIHZkB/72a1ad336d0c7d02d1157e3f48352228/ODCamS2_advanced_AI.png?w=120&h=120&fit=pad)
 *
 * ODCamS2 advanced AI
 *
 *
 */
export const IMG_20kkeBx1IuJm1VX4BIHZkB = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/20kkeBx1IuJm1VX4BIHZkB/72a1ad336d0c7d02d1157e3f48352228/ODCamS2_advanced_AI.png',
  description: ``,
  originalHeight: 397,
  originalWidth: 631
}

/**
 * ![Retail security: Protecting your store from theft and fraud](https://images.ctfassets.net/v6awd0kabi65/4hpImCVfnhxYnwj06ea9K9/f1c4983e25deadf12a65c1b205f6c341/pexels-polina-tankilevitch-3735172.jpg?w=120&h=120&fit=pad)
 *
 * Retail security: Protecting your store from theft and fraud
 *
 *
 */
export const IMG_4hpImCVfnhxYnwj06ea9K9 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4hpImCVfnhxYnwj06ea9K9/f1c4983e25deadf12a65c1b205f6c341/pexels-polina-tankilevitch-3735172.jpg',
  description: ``,
  originalHeight: 2333,
  originalWidth: 3500
}

/**
 * ![SmokeCO - System Advisor](https://images.ctfassets.net/v6awd0kabi65/7FknDTXAsWOs34Pt7HZvHx/298bf65f5670f344179ce305f15834c3/SmokeCO.png?w=120&h=120&fit=pad)
 *
 * SmokeCO - System Advisor
 *
 * A smoke and carbon monoxide detector on a solid white background
 */
export const IMG_7FknDTXAsWOs34Pt7HZvHx = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7FknDTXAsWOs34Pt7HZvHx/298bf65f5670f344179ce305f15834c3/SmokeCO.png',
  description: `A smoke and carbon monoxide detector on a solid white background`,
  originalHeight: 642,
  originalWidth: 642
}

/**
 * ![SmartLockSeries2White - System Advisor](https://images.ctfassets.net/v6awd0kabi65/42PW4W6lBkFSk78dYDG5dc/d10033aece4df017c995f3e5e5e54bfb/SmartLockSeries2White.png?w=120&h=120&fit=pad)
 *
 * SmartLockSeries2White - System Advisor
 *
 * A white smart lock series 2 on a solid white background
 */
export const IMG_42PW4W6lBkFSk78dYDG5dc = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/42PW4W6lBkFSk78dYDG5dc/d10033aece4df017c995f3e5e5e54bfb/SmartLockSeries2White.png',
  description: `A white smart lock series 2 on a solid white background`,
  originalHeight: 642,
  originalWidth: 642
}

/**
 * ![Indoor Camera - System Advisor](https://images.ctfassets.net/v6awd0kabi65/5mFiJFuR8O5LTbTJvCcBdJ/e50948b5afbc953271b685cea5070eca/IndoorCam.png?w=120&h=120&fit=pad)
 *
 * Indoor Camera - System Advisor
 *
 * An indoor camera on a solid white background
 */
export const IMG_5mFiJFuR8O5LTbTJvCcBdJ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5mFiJFuR8O5LTbTJvCcBdJ/e50948b5afbc953271b685cea5070eca/IndoorCam.png',
  description: `An indoor camera on a solid white background`,
  originalHeight: 642,
  originalWidth: 642
}

/**
 * ![Smoke Detector - System Advisor](https://images.ctfassets.net/v6awd0kabi65/2QPr0QRY771ihEcVzi9KJi/28edeee997d979b53ee4370d78d65ae8/Smoke.png?w=120&h=120&fit=pad)
 *
 * Smoke Detector - System Advisor
 *
 * A smoke detector on a plain white background
 */
export const IMG_2QPr0QRY771ihEcVzi9KJi = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2QPr0QRY771ihEcVzi9KJi/28edeee997d979b53ee4370d78d65ae8/Smoke.png',
  description: `A smoke detector on a plain white background`,
  originalHeight: 642,
  originalWidth: 642
}

/**
 * ![SmartLockSeries2Black - System Advisor](https://images.ctfassets.net/v6awd0kabi65/yLE8YOdZkUb3TK08Wqdhw/bb91f55936d623a6a259485d7f49583a/SmartLockSeries2Black.png?w=120&h=120&fit=pad)
 *
 * SmartLockSeries2Black - System Advisor
 *
 * A smart lock on a solid white background
 */
export const IMG_yLE8YOdZkUb3TK08Wqdhw = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/yLE8YOdZkUb3TK08Wqdhw/bb91f55936d623a6a259485d7f49583a/SmartLockSeries2Black.png',
  description: `A smart lock on a solid white background`,
  originalHeight: 642,
  originalWidth: 642
}

/**
 * ![Window Decals - System Advisor](https://images.ctfassets.net/v6awd0kabi65/4QT0Hkwdbu8dOFRNvuYv8q/3ddfee1119ccd788dc90e344ef04b88a/Window_Decals.png?w=120&h=120&fit=pad)
 *
 * Window Decals - System Advisor
 *
 * Window decals on a solid white background
 */
export const IMG_4QT0Hkwdbu8dOFRNvuYv8q = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4QT0Hkwdbu8dOFRNvuYv8q/3ddfee1119ccd788dc90e344ef04b88a/Window_Decals.png',
  description: `Window decals on a solid white background`,
  originalHeight: 642,
  originalWidth: 642
}

/**
 * ![Entry Sensor - System Advisor](https://images.ctfassets.net/v6awd0kabi65/4MNwpc8hznfuVPP00tz4Cs/cd8b57ae7232a9518a6dedf8326a9840/Entry.png?w=120&h=120&fit=pad)
 *
 * Entry Sensor - System Advisor
 *
 * An entry sensor on a solid white background
 */
export const IMG_4MNwpc8hznfuVPP00tz4Cs = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4MNwpc8hznfuVPP00tz4Cs/cd8b57ae7232a9518a6dedf8326a9840/Entry.png',
  description: `An entry sensor on a solid white background`,
  originalHeight: 642,
  originalWidth: 642
}

/**
 * ![PowerAdapter - System Advisor](https://images.ctfassets.net/v6awd0kabi65/6nCbHn49lnanAwqrvRefQb/efe7a6791ff9c975b4b743c3172e2ce5/PowerAdapter.png?w=120&h=120&fit=pad)
 *
 * PowerAdapter - System Advisor
 *
 * A power adapter on a solid white background
 */
export const IMG_6nCbHn49lnanAwqrvRefQb = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6nCbHn49lnanAwqrvRefQb/efe7a6791ff9c975b4b743c3172e2ce5/PowerAdapter.png',
  description: `A power adapter on a solid white background`,
  originalHeight: 854,
  originalWidth: 853
}

/**
 * ![Yard Sign - System Advisor](https://images.ctfassets.net/v6awd0kabi65/7cfhuUnn1k4Q1RWwhHvaNp/5f689e54731418eabaec455bda3084e2/Yard_Sign.png?w=120&h=120&fit=pad)
 *
 * Yard Sign - System Advisor
 *
 * A yard sign on a solid white background
 */
export const IMG_7cfhuUnn1k4Q1RWwhHvaNp = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7cfhuUnn1k4Q1RWwhHvaNp/5f689e54731418eabaec455bda3084e2/Yard_Sign.png',
  description: `A yard sign on a solid white background`,
  originalHeight: 642,
  originalWidth: 642
}

/**
 * ![Video Doorbell - System Advisor](https://images.ctfassets.net/v6awd0kabi65/5RJehU9CCwV0dbedKxrVgF/06f3b5b86eb334e5f9dd923094ac1b64/Video_Doorbell.png?w=120&h=120&fit=pad)
 *
 * Video Doorbell - System Advisor
 *
 * A video doorbell on a solid white background
 */
export const IMG_5RJehU9CCwV0dbedKxrVgF = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5RJehU9CCwV0dbedKxrVgF/06f3b5b86eb334e5f9dd923094ac1b64/Video_Doorbell.png',
  description: `A video doorbell on a solid white background`,
  originalHeight: 642,
  originalWidth: 642
}

/**
 * ![MotionSensorGen2 - System Advisor](https://images.ctfassets.net/v6awd0kabi65/4QD93jQCPa3mfXDGAONCXx/98945026e09e4ba690e23d3a1cc275e7/MotionSensorGen2.png?w=120&h=120&fit=pad)
 *
 * MotionSensorGen2 - System Advisor
 *
 * A motion sensor on a solid white background
 */
export const IMG_4QD93jQCPa3mfXDGAONCXx = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4QD93jQCPa3mfXDGAONCXx/98945026e09e4ba690e23d3a1cc275e7/MotionSensorGen2.png',
  description: `A motion sensor on a solid white background`,
  originalHeight: 642,
  originalWidth: 642
}

/**
 * ![Temperature Sensor - System Advisor](https://images.ctfassets.net/v6awd0kabi65/6Ofud9CxzWHW3lcDXXsesu/2fd249f3fe7183b13ed4d446db046051/Temp.png?w=120&h=120&fit=pad)
 *
 * Temperature Sensor - System Advisor
 *
 * A temperature sensor on a solid white background
 */
export const IMG_6Ofud9CxzWHW3lcDXXsesu = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6Ofud9CxzWHW3lcDXXsesu/2fd249f3fe7183b13ed4d446db046051/Temp.png',
  description: `A temperature sensor on a solid white background`,
  originalHeight: 642,
  originalWidth: 642
}

/**
 * ![SolarPanel - System Advisor](https://images.ctfassets.net/v6awd0kabi65/6jkyRGFpW0jks1RHKLV0PL/5b08b6b77ced73474b8f54afbdc1d8b8/SolarPanel.png?w=120&h=120&fit=pad)
 *
 * SolarPanel - System Advisor
 *
 * A solar panel on a solid white background
 */
export const IMG_6jkyRGFpW0jks1RHKLV0PL = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6jkyRGFpW0jks1RHKLV0PL/5b08b6b77ced73474b8f54afbdc1d8b8/SolarPanel.png',
  description: `A solar panel on a solid white background`,
  originalHeight: 642,
  originalWidth: 642
}

/**
 * ![Key Fob - System Advisor](https://images.ctfassets.net/v6awd0kabi65/7N1ml9w9GhxTXMMd3KnbUJ/4b0128878ce83081e78345e8adb89c16/Key_Fob.png?w=120&h=120&fit=pad)
 *
 * Key Fob - System Advisor
 *
 * A keyfob on a solid white background
 */
export const IMG_7N1ml9w9GhxTXMMd3KnbUJ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7N1ml9w9GhxTXMMd3KnbUJ/4b0128878ce83081e78345e8adb89c16/Key_Fob.png',
  description: `A keyfob on a solid white background`,
  originalHeight: 642,
  originalWidth: 642
}

/**
 * ![Keypad - System Advisor](https://images.ctfassets.net/v6awd0kabi65/41dr6SviTcXcWJ9ykbteKe/231125c930cd5d2f59b80d08c7fa5c47/Keypad.png?w=120&h=120&fit=pad)
 *
 * Keypad - System Advisor
 *
 * A keypad on a solid white background
 */
export const IMG_41dr6SviTcXcWJ9ykbteKe = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/41dr6SviTcXcWJ9ykbteKe/231125c930cd5d2f59b80d08c7fa5c47/Keypad.png',
  description: `A keypad on a solid white background`,
  originalHeight: 642,
  originalWidth: 642
}

/**
 * ![ExtraBattery - System Advisor](https://images.ctfassets.net/v6awd0kabi65/7DF8YgmI3i1wopGhjxPwmF/36407cbba5d2af573b7afe493926b315/ExtraBattery.png?w=120&h=120&fit=pad)
 *
 * ExtraBattery - System Advisor
 *
 * A battery on a solid white background
 */
export const IMG_7DF8YgmI3i1wopGhjxPwmF = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7DF8YgmI3i1wopGhjxPwmF/36407cbba5d2af573b7afe493926b315/ExtraBattery.png',
  description: `A battery on a solid white background`,
  originalHeight: 658,
  originalWidth: 658
}

/**
 * ![Base Station - System Advisor](https://images.ctfassets.net/v6awd0kabi65/ON3p26Xkyl0JZFMQAcW0i/ac41e85f7bf0cffeede4e80aa5994c1c/Base_Station.png?w=120&h=120&fit=pad)
 *
 * Base Station - System Advisor
 *
 * A base station on a solid white background
 */
export const IMG_ON3p26Xkyl0JZFMQAcW0i = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/ON3p26Xkyl0JZFMQAcW0i/ac41e85f7bf0cffeede4e80aa5994c1c/Base_Station.png',
  description: `A base station on a solid white background`,
  originalHeight: 642,
  originalWidth: 642
}

/**
 * ![OutdoorCameraSeries2 - System Advisor](https://images.ctfassets.net/v6awd0kabi65/2EirXqJeFO1zEXT6qXelLa/479b7c20caf53acb8f0a3f0321a25b24/OutdoorCameraSeries2.png?w=120&h=120&fit=pad)
 *
 * OutdoorCameraSeries2 - System Advisor
 *
 * An outdoor camera on a solid white background
 */
export const IMG_2EirXqJeFO1zEXT6qXelLa = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2EirXqJeFO1zEXT6qXelLa/479b7c20caf53acb8f0a3f0321a25b24/OutdoorCameraSeries2.png',
  description: `An outdoor camera on a solid white background`,
  originalHeight: 642,
  originalWidth: 642
}

/**
 * ![PanicButton - System Advisor](https://images.ctfassets.net/v6awd0kabi65/56013K3gcnQ16pLrZb6yF3/0eed40bcbd97dfd243c48be549d9adde/PanicButton.png?w=120&h=120&fit=pad)
 *
 * PanicButton - System Advisor
 *
 * A panic button on a solid white background
 */
export const IMG_56013K3gcnQ16pLrZb6yF3 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/56013K3gcnQ16pLrZb6yF3/0eed40bcbd97dfd243c48be549d9adde/PanicButton.png',
  description: `A panic button on a solid white background`,
  originalHeight: 642,
  originalWidth: 642
}

/**
 * ![PermanentMount - System Advisor](https://images.ctfassets.net/v6awd0kabi65/26O0p7C2dTyAV0Vfx6kTlt/3c52333d1f62329d173d755b5397c066/PermanentMount.png?w=120&h=120&fit=pad)
 *
 * PermanentMount - System Advisor
 *
 * A camera mount on a solid white background
 */
export const IMG_26O0p7C2dTyAV0Vfx6kTlt = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/26O0p7C2dTyAV0Vfx6kTlt/3c52333d1f62329d173d755b5397c066/PermanentMount.png',
  description: `A camera mount on a solid white background`,
  originalHeight: 658,
  originalWidth: 658
}

/**
 * ![Siren - System Advisor](https://images.ctfassets.net/v6awd0kabi65/2op5E5mhBpnuW8pWbPwv0x/5fc3ea29525ace131c6d2e37cd957692/Siren.png?w=120&h=120&fit=pad)
 *
 * Siren - System Advisor
 *
 * A siren on a solid white background
 */
export const IMG_2op5E5mhBpnuW8pWbPwv0x = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2op5E5mhBpnuW8pWbPwv0x/5fc3ea29525ace131c6d2e37cd957692/Siren.png',
  description: `A siren on a solid white background`,
  originalHeight: 642,
  originalWidth: 642
}

/**
 * ![Glassbreak Sensor - System Advisor](https://images.ctfassets.net/v6awd0kabi65/2H6kByypzSUZyvjWoe4DKf/0e2ed71c78b25c75601459bc774b6a69/Glassbreak.png?w=120&h=120&fit=pad)
 *
 * Glassbreak Sensor - System Advisor
 *
 * A glassbreak sensor on a solid white background
 */
export const IMG_2H6kByypzSUZyvjWoe4DKf = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2H6kByypzSUZyvjWoe4DKf/0e2ed71c78b25c75601459bc774b6a69/Glassbreak.png',
  description: `A glassbreak sensor on a solid white background`,
  originalHeight: 642,
  originalWidth: 642
}

/**
 * ![Water Sensor - System Advisor](https://images.ctfassets.net/v6awd0kabi65/1DTxIfchNeSME6lnUr5NUq/7349b9141f88a58b90987ed1d547b0e4/Water_Sensor.png?w=120&h=120&fit=pad)
 *
 * Water Sensor - System Advisor
 *
 * A water sensor on a solid white background
 */
export const IMG_1DTxIfchNeSME6lnUr5NUq = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1DTxIfchNeSME6lnUr5NUq/7349b9141f88a58b90987ed1d547b0e4/Water_Sensor.png',
  description: `A water sensor on a solid white background`,
  originalHeight: 642,
  originalWidth: 642
}

/**
 * ![25ftPowerCable - System Advisor](https://images.ctfassets.net/v6awd0kabi65/7C7QjKUWCL5jIQuhFYgwLd/d1e60afb0288c63b0eb3334bcefecbc2/25ftPowerCable.png?w=120&h=120&fit=pad)
 *
 * 25ftPowerCable - System Advisor
 *
 * A power cable on a solid white background
 */
export const IMG_7C7QjKUWCL5jIQuhFYgwLd = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7C7QjKUWCL5jIQuhFYgwLd/d1e60afb0288c63b0eb3334bcefecbc2/25ftPowerCable.png',
  description: `A power cable on a solid white background`,
  originalHeight: 642,
  originalWidth: 642
}

/**
 * ![10 of the best home guard dogs](https://images.ctfassets.net/v6awd0kabi65/76HpLBzobTpRayyFj60u0j/e0761f1adbcad7de6faf55d00982d569/pexels-edd1egalaxy-3628100.jpg?w=120&h=120&fit=pad)
 *
 * 10 of the best home guard dogs
 *
 * Learn which dogs make the best home security dogs, from German Shepherds to Great Danes and Rottweilers, with this post from SimpliSafe.
 */
export const IMG_76HpLBzobTpRayyFj60u0j = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/76HpLBzobTpRayyFj60u0j/e0761f1adbcad7de6faf55d00982d569/pexels-edd1egalaxy-3628100.jpg',
  description: `Learn which dogs make the best home security dogs, from German Shepherds to Great Danes and Rottweilers, with this post from SimpliSafe.`,
  originalHeight: 3056,
  originalWidth: 4592
}

/**
 * ![Olympus Product Modal(alarm sensor)](https://images.ctfassets.net/v6awd0kabi65/6jGddpBswTKuNJsAiX1pZX/c0dc07cdd7acd6904c8248ef423a10d7/Mask_group.png?w=120&h=120&fit=pad)
 *
 * Olympus Product Modal(alarm sensor)
 *
 * null
 */
export const IMG_6jGddpBswTKuNJsAiX1pZX = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6jGddpBswTKuNJsAiX1pZX/c0dc07cdd7acd6904c8248ef423a10d7/Mask_group.png',
  description: `null`,
  originalHeight: 1056,
  originalWidth: 936
}

/**
 * ![SA_DT_Olympus2_hero_wide](https://images.ctfassets.net/v6awd0kabi65/7Dwp8dG2k1HQLdWSaasXhr/3ec42b48c9d0823538dfb37f6ec4afce/SA_DT_Olympus2_hero_wide.jpg?w=120&h=120&fit=pad)
 *
 * SA_DT_Olympus2_hero_wide
 *
 * A close-up of a white outdoor camera mounted on a dark blue exterior wall.
 */
export const IMG_7Dwp8dG2k1HQLdWSaasXhr = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7Dwp8dG2k1HQLdWSaasXhr/3ec42b48c9d0823538dfb37f6ec4afce/SA_DT_Olympus2_hero_wide.jpg',
  description: `A close-up of a white outdoor camera mounted on a dark blue exterior wall.`,
  originalHeight: 1062,
  originalWidth: 1474
}

/**
 * ![60 Day Guarantee](https://images.ctfassets.net/v6awd0kabi65/5FRJNkZAaZL4mHk6vuMNVb/f0a94cdb3d6f751821d1dd8fba1e9b58/60DayGuarantee.png?w=120&h=120&fit=pad)
 *
 * 60 Day Guarantee
 *
 * 60 day money-back guarantee
 */
export const IMG_5FRJNkZAaZL4mHk6vuMNVb = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5FRJNkZAaZL4mHk6vuMNVb/f0a94cdb3d6f751821d1dd8fba1e9b58/60DayGuarantee.png',
  description: `60 day money-back guarantee`,
  originalHeight: 392,
  originalWidth: 392
}

/**
 * ![Lifetime Hardware Warranty](https://images.ctfassets.net/v6awd0kabi65/461swoMoMh63PKVMrvJiUl/c9266cbef1d9c0f62304a9c4600297a5/60_Day_guarantee.png?w=120&h=120&fit=pad)
 *
 * Lifetime Hardware Warranty
 *
 * Professional monitoring lifetime hardware warranty
 */
export const IMG_461swoMoMh63PKVMrvJiUl = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/461swoMoMh63PKVMrvJiUl/c9266cbef1d9c0f62304a9c4600297a5/60_Day_guarantee.png',
  description: `Professional monitoring lifetime hardware warranty`,
  originalHeight: 499,
  originalWidth: 498
}

/**
 * ![SA_DT_Base_hero](https://images.ctfassets.net/v6awd0kabi65/6seraKHHDdKD2DHSDQ2UBC/27e23f217b661349bd24090a7598aa79/Base_d_hero.jpg?w=120&h=120&fit=pad)
 *
 * SA_DT_Base_hero
 *
 * The SimpliSafe Base Station on a shelf next to a plant and a piece of framed artwork.
 */
export const IMG_6seraKHHDdKD2DHSDQ2UBC = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6seraKHHDdKD2DHSDQ2UBC/27e23f217b661349bd24090a7598aa79/Base_d_hero.jpg',
  description: `The SimpliSafe Base Station on a shelf next to a plant and a piece of framed artwork.`,
  originalHeight: 560,
  originalWidth: 729
}

/**
 * ![SA_DT_Doorbell1_hero](https://images.ctfassets.net/v6awd0kabi65/5Y4u9CxzvypNRoNyVM46QZ/904e454b54a845fb25e4818d87e624e7/Doorbell1_d_hero.jpg?w=120&h=120&fit=pad)
 *
 * SA_DT_Doorbell1_hero
 *
 * A dark blue house with the video doorbell's wide detection area highlighted by a blue overlay showing coverage from the front door across the lawn.
 */
export const IMG_5Y4u9CxzvypNRoNyVM46QZ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5Y4u9CxzvypNRoNyVM46QZ/904e454b54a845fb25e4818d87e624e7/Doorbell1_d_hero.jpg',
  description: `A dark blue house with the video doorbell's wide detection area highlighted by a blue overlay showing coverage from the front door across the lawn.`,
  originalHeight: 1200,
  originalWidth: 1474
}

/**
 * ![SA_DT_Doorbell2_hero](https://images.ctfassets.net/v6awd0kabi65/5V2ODVNQ6EhgZ3QW09uUFB/cf435bbcc7f7bbcb08555da9ff9cac51/Doorbell2_d_hero.jpg?w=120&h=120&fit=pad)
 *
 * SA_DT_Doorbell2_hero
 *
 * A person's finger pressing the button on a white video doorbell mounted on a dark door.
 */
export const IMG_5V2ODVNQ6EhgZ3QW09uUFB = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5V2ODVNQ6EhgZ3QW09uUFB/cf435bbcc7f7bbcb08555da9ff9cac51/Doorbell2_d_hero.jpg',
  description: `A person's finger pressing the button on a white video doorbell mounted on a dark door.`,
  originalHeight: 526,
  originalWidth: 730
}

/**
 * ![SA_DT_Doors2_hero](https://images.ctfassets.net/v6awd0kabi65/1L5DESnHhoSey0o3QfHsCk/b225dfde6d9c38fa87f64541cfb9d175/Doors2_d_hero.jpg?w=120&h=120&fit=pad)
 *
 * SA_DT_Doors2_hero
 *
 * A closed white sliding glass door on the side of a dark blue house, leading to a small patio area.
 */
export const IMG_1L5DESnHhoSey0o3QfHsCk = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1L5DESnHhoSey0o3QfHsCk/b225dfde6d9c38fa87f64541cfb9d175/Doors2_d_hero.jpg',
  description: `A closed white sliding glass door on the side of a dark blue house, leading to a small patio area.`,
  originalHeight: 560,
  originalWidth: 729
}

/**
 * ![SA_DT_Doors3_hero](https://images.ctfassets.net/v6awd0kabi65/1spWZhjqQXk6gLJyBfGbTd/15ab534677df6e99f1f05b499955139e/Doors3_d_hero.jpg?w=120&h=120&fit=pad)
 *
 * SA_DT_Doors3_hero
 *
 * A white door inside a garage, next to gray cabinets and a workbench with tools.
 */
export const IMG_1spWZhjqQXk6gLJyBfGbTd = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1spWZhjqQXk6gLJyBfGbTd/15ab534677df6e99f1f05b499955139e/Doors3_d_hero.jpg',
  description: `A white door inside a garage, next to gray cabinets and a workbench with tools.`,
  originalHeight: 560,
  originalWidth: 729
}

/**
 * ![SA_DT_Entry3_hero](https://images.ctfassets.net/v6awd0kabi65/7vs5KYgw5M074g1wR4xanp/b1069a8afeee396449a131810417f9da/Entry3_d_hero.jpg?w=120&h=120&fit=pad)
 *
 * SA_DT_Entry3_hero
 *
 * A close-up of the SimpliSafe Entry Sensor mounted on a dark door and door frame.
 */
export const IMG_7vs5KYgw5M074g1wR4xanp = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7vs5KYgw5M074g1wR4xanp/b1069a8afeee396449a131810417f9da/Entry3_d_hero.jpg',
  description: `A close-up of the SimpliSafe Entry Sensor mounted on a dark door and door frame.`,
  originalHeight: 526,
  originalWidth: 729
}

/**
 * ![SA_DT_Keypad_hero](https://images.ctfassets.net/v6awd0kabi65/4mzEyM8893IJWO1lrCTOT6/51bfeb01b6b72048cf6e36f0661b3a0c/Keypad_d_hero.jpg?w=120&h=120&fit=pad)
 *
 * SA_DT_Keypad_hero
 *
 * A person's hand is shown pressing a button on a white SimpliSafe Keypad that is mounted to the wall. The keypad has a black digital display showing "home" and a white number pad with circular buttons.
 */
export const IMG_4mzEyM8893IJWO1lrCTOT6 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4mzEyM8893IJWO1lrCTOT6/51bfeb01b6b72048cf6e36f0661b3a0c/Keypad_d_hero.jpg',
  description: `A person's hand is shown pressing a button on a white SimpliSafe Keypad that is mounted to the wall. The keypad has a black digital display showing "home" and a white number pad with circular buttons. `,
  originalHeight: 560,
  originalWidth: 729
}

/**
 * ![SA_DT_Motion1_hero](https://images.ctfassets.net/v6awd0kabi65/4cV5FVpBwfnh7GjDyW244L/879cf75100e8414e5506ae1fecf2e53a/Motion1_d_hero.jpg?w=120&h=120&fit=pad)
 *
 * SA_DT_Motion1_hero
 *
 * A person walks through a living room with a motion sensor's wide detection area highlighted in blue.
 */
export const IMG_4cV5FVpBwfnh7GjDyW244L = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4cV5FVpBwfnh7GjDyW244L/879cf75100e8414e5506ae1fecf2e53a/Motion1_d_hero.jpg',
  description: `A person walks through a living room with a motion sensor's wide detection area highlighted in blue.`,
  originalHeight: 1200,
  originalWidth: 1474
}

/**
 * ![SA_DT_Motion2_hero](https://images.ctfassets.net/v6awd0kabi65/3CLlyVLjxvoZoV0geLhJCY/701163379329a0adc8380885efa44a6f/Motion2_d_hero.jpg?w=120&h=120&fit=pad)
 *
 * SA_DT_Motion2_hero
 *
 * A person's hand holds the SimpliSafe Motion Sensor.
 */
export const IMG_3CLlyVLjxvoZoV0geLhJCY = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3CLlyVLjxvoZoV0geLhJCY/701163379329a0adc8380885efa44a6f/Motion2_d_hero.jpg',
  description: `A person's hand holds the SimpliSafe Motion Sensor.`,
  originalHeight: 526,
  originalWidth: 730
}

/**
 * ![SA_DT_Olympus1_hero](https://images.ctfassets.net/v6awd0kabi65/7Jv5Ic5YSs836mQJLOSUAU/f768c5e039cf689c2ad83000859e7d12/Olympus1_d_hero.jpg?w=120&h=120&fit=pad)
 *
 * SA_DT_Olympus1_hero
 *
 * The backyard of a dark blue house at dusk, with the outdoor camera's wide detection area highlighted in blue, covering a patio and yard.
 */
export const IMG_7Jv5Ic5YSs836mQJLOSUAU = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7Jv5Ic5YSs836mQJLOSUAU/f768c5e039cf689c2ad83000859e7d12/Olympus1_d_hero.jpg',
  description: `The backyard of a dark blue house at dusk, with the outdoor camera's wide detection area highlighted in blue, covering a patio and yard.`,
  originalHeight: 1200,
  originalWidth: 1474
}

/**
 * ![SA_DT_Olympus2_hero](https://images.ctfassets.net/v6awd0kabi65/6keD7Q72Q6z9RUWhuPuqGI/2b63e16046e1e54423b97f13757acd77/Olympus2_d_hero.jpg?w=120&h=120&fit=pad)
 *
 * SA_DT_Olympus2_hero
 *
 * A close-up of a white outdoor camera mounted on a dark blue exterior wall.
 */
export const IMG_6keD7Q72Q6z9RUWhuPuqGI = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6keD7Q72Q6z9RUWhuPuqGI/2b63e16046e1e54423b97f13757acd77/Olympus2_d_hero.jpg',
  description: `A close-up of a white outdoor camera mounted on a dark blue exterior wall.`,
  originalHeight: 526,
  originalWidth: 730
}

/**
 * ![SA_DT_Scout1_hero](https://images.ctfassets.net/v6awd0kabi65/1Ek8wW4JqmzwM8TihImRY0/70e66826da9f3fd941d544cfc72b9a8d/Scout1_d_hero.jpg?w=120&h=120&fit=pad)
 *
 * SA_DT_Scout1_hero
 *
 * A dog walks across a kitchen floor, with the indoor camera's wide detection area highlighted in blue.
 */
export const IMG_1Ek8wW4JqmzwM8TihImRY0 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1Ek8wW4JqmzwM8TihImRY0/70e66826da9f3fd941d544cfc72b9a8d/Scout1_d_hero.jpg',
  description: `A dog walks across a kitchen floor, with the indoor camera's wide detection area highlighted in blue.`,
  originalHeight: 1200,
  originalWidth: 1474
}

/**
 * ![SA_DT_Scout2_hero](https://images.ctfassets.net/v6awd0kabi65/UnZEzuJMupvZXyugFeRHd/bd24d5d3e56415f78aacd745cdf0124b/Scout2_d_hero.jpg?w=120&h=120&fit=pad)
 *
 * SA_DT_Scout2_hero
 *
 * A close-up of a white SimpliSafe Smart Alarm Wireless Indoor Security Camera on a wooden shelf.
 */
export const IMG_UnZEzuJMupvZXyugFeRHd = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/UnZEzuJMupvZXyugFeRHd/bd24d5d3e56415f78aacd745cdf0124b/Scout2_d_hero.jpg',
  description: `A close-up of a white SimpliSafe Smart Alarm Wireless Indoor Security Camera on a wooden shelf.`,
  originalHeight: 526,
  originalWidth: 730
}

/**
 * ![SA_MB_Base_hero](https://images.ctfassets.net/v6awd0kabi65/7DcJXfXccDIIYTveiAbU4J/74592138109dce94ed2aff550027c137/Base_m_hero.jpg?w=120&h=120&fit=pad)
 *
 * SA_MB_Base_hero
 *
 * The SimpliSafe Base Station on a shelf next to a plant and a piece of framed artwork.
 */
export const IMG_7DcJXfXccDIIYTveiAbU4J = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7DcJXfXccDIIYTveiAbU4J/74592138109dce94ed2aff550027c137/Base_m_hero.jpg',
  description: `The SimpliSafe Base Station on a shelf next to a plant and a piece of framed artwork.`,
  originalHeight: 496,
  originalWidth: 686
}

/**
 * ![SA_MB_Doorbell_hero](https://images.ctfassets.net/v6awd0kabi65/2iBtMbTbKxiemAQp7uYXev/cbbc6652e3547f1db4c3c4ab09f14a01/Doorbell_m_hero.jpg?w=120&h=120&fit=pad)
 *
 * SA_MB_Doorbell_hero
 *
 * A dark blue house with the video doorbell's wide detection area highlighted by a blue overlay showing coverage from the front door across the lawn.
 */
export const IMG_2iBtMbTbKxiemAQp7uYXev = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2iBtMbTbKxiemAQp7uYXev/cbbc6652e3547f1db4c3c4ab09f14a01/Doorbell_m_hero.jpg',
  description: `A dark blue house with the video doorbell's wide detection area highlighted by a blue overlay showing coverage from the front door across the lawn.`,
  originalHeight: 316,
  originalWidth: 686
}

/**
 * ![SA_MB_Doors2_hero](https://images.ctfassets.net/v6awd0kabi65/2hWeujtrc3cKbo0zUdvkt9/1f86fd1ed09c8678b674319543c22d54/Doors2_m_hero.jpg?w=120&h=120&fit=pad)
 *
 * SA_MB_Doors2_hero
 *
 * A closed white sliding glass door on the side of a dark blue house, leading to a small patio area.
 */
export const IMG_2hWeujtrc3cKbo0zUdvkt9 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2hWeujtrc3cKbo0zUdvkt9/1f86fd1ed09c8678b674319543c22d54/Doors2_m_hero.jpg',
  description: `A closed white sliding glass door on the side of a dark blue house, leading to a small patio area.`,
  originalHeight: 496,
  originalWidth: 686
}

/**
 * ![SA_MB_Doors3_hero](https://images.ctfassets.net/v6awd0kabi65/2p4cGaJS5z3hSiWTMEBnU5/3da69bc1625b0025b5dfcb93f2696be1/Doors3_m_hero.jpg?w=120&h=120&fit=pad)
 *
 * SA_MB_Doors3_hero
 *
 * A white door inside a garage, next to gray cabinets and a workbench with tools.
 */
export const IMG_2p4cGaJS5z3hSiWTMEBnU5 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2p4cGaJS5z3hSiWTMEBnU5/3da69bc1625b0025b5dfcb93f2696be1/Doors3_m_hero.jpg',
  description: `A white door inside a garage, next to gray cabinets and a workbench with tools.`,
  originalHeight: 496,
  originalWidth: 686
}

/**
 * ![SA_MB_IndoorCamera_hero](https://images.ctfassets.net/v6awd0kabi65/7eiVVT5xmHQdUOi2X7GFU0/c5ddb634ae75577ca781eea6bed3371f/IndoorCamera_m_hero.jpg?w=120&h=120&fit=pad)
 *
 * SA_MB_IndoorCamera_hero
 *
 * A dog walks across a kitchen floor, with the indoor camera's wide detection area highlighted in blue.
 */
export const IMG_7eiVVT5xmHQdUOi2X7GFU0 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7eiVVT5xmHQdUOi2X7GFU0/c5ddb634ae75577ca781eea6bed3371f/IndoorCamera_m_hero.jpg',
  description: `A dog walks across a kitchen floor, with the indoor camera's wide detection area highlighted in blue.`,
  originalHeight: 316,
  originalWidth: 686
}

/**
 * ![SA_MB_Keypad_hero](https://images.ctfassets.net/v6awd0kabi65/3Iy6JtaU9GDEaCFYKdvW9B/30f2a90bec36696f6d824e84e39e5fa8/Keypad_m_hero.jpg?w=120&h=120&fit=pad)
 *
 * SA_MB_Keypad_hero
 *
 * A person's hand is shown pressing a button on a white SimpliSafe Keypad that is mounted to the wall. The keypad has a black digital display showing "home" and a white number pad with circular buttons.
 */
export const IMG_3Iy6JtaU9GDEaCFYKdvW9B = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3Iy6JtaU9GDEaCFYKdvW9B/30f2a90bec36696f6d824e84e39e5fa8/Keypad_m_hero.jpg',
  description: `A person's hand is shown pressing a button on a white SimpliSafe Keypad that is mounted to the wall. The keypad has a black digital display showing "home" and a white number pad with circular buttons. `,
  originalHeight: 496,
  originalWidth: 686
}

/**
 * ![SA_MB_Motion_hero](https://images.ctfassets.net/v6awd0kabi65/7fe2EgzToTQtUbfoVxAWRp/84d81408dd49dca9b7d726cab98b6ad0/Motion_m_hero.jpg?w=120&h=120&fit=pad)
 *
 * SA_MB_Motion_hero
 *
 * A person walks through a living room with a motion sensor's wide detection area highlighted in blue.
 */
export const IMG_7fe2EgzToTQtUbfoVxAWRp = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7fe2EgzToTQtUbfoVxAWRp/84d81408dd49dca9b7d726cab98b6ad0/Motion_m_hero.jpg',
  description: `A person walks through a living room with a motion sensor's wide detection area highlighted in blue.`,
  originalHeight: 316,
  originalWidth: 686
}

/**
 * ![SA_MB_OutdoorCamera_hero](https://images.ctfassets.net/v6awd0kabi65/3s5ml2lzYJFLOXFDw6laDE/38e3a6062830530589ff3ea24a4196a2/OutdoorCamera_m_hero.jpg?w=120&h=120&fit=pad)
 *
 * SA_MB_OutdoorCamera_hero
 *
 * The backyard of a dark blue house at dusk, with the outdoor camera's wide detection area highlighted in blue, covering a patio and yard.
 */
export const IMG_3s5ml2lzYJFLOXFDw6laDE = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3s5ml2lzYJFLOXFDw6laDE/38e3a6062830530589ff3ea24a4196a2/OutdoorCamera_m_hero.jpg',
  description: `The backyard of a dark blue house at dusk, with the outdoor camera's wide detection area highlighted in blue, covering a patio and yard.`,
  originalHeight: 316,
  originalWidth: 686
}

/**
 * ![20-piece Small Business Security System - SMB Cydcor page](https://images.ctfassets.net/v6awd0kabi65/2DCT3VnyXucGpvaWejTUxb/a7f09839ac2b87915003a1c8fef684b4/20-piece_Small_Business_Security_System.png?w=120&h=120&fit=pad)
 *
 * 20-piece Small Business Security System - SMB Cydcor page
 *
 * SimpliSafe 20-piece Small Business Security System with base station, keypad, cameras, sensors, panic buttons, sirens, and accessories.
 */
export const IMG_2DCT3VnyXucGpvaWejTUxb = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2DCT3VnyXucGpvaWejTUxb/a7f09839ac2b87915003a1c8fef684b4/20-piece_Small_Business_Security_System.png',
  description: `SimpliSafe 20-piece Small Business Security System with base station, keypad, cameras, sensors, panic buttons, sirens, and accessories.`,
  originalHeight: 2800,
  originalWidth: 2800
}

/**
 * ![12-piece Small Business Security System - SMB Cydcor page](https://images.ctfassets.net/v6awd0kabi65/5KlbDONiKG5uF5QGRAumeM/f12a85d0b4e4cd927d169805eb252c2e/12-piece_Small_Business_Security_System.png?w=120&h=120&fit=pad)
 *
 * 12-piece Small Business Security System - SMB Cydcor page
 *
 * SimpliSafe 12-piece Small Business Security System with base station, keypad, cameras, sensors, panic buttons, and accessories.
 */
export const IMG_5KlbDONiKG5uF5QGRAumeM = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5KlbDONiKG5uF5QGRAumeM/f12a85d0b4e4cd927d169805eb252c2e/12-piece_Small_Business_Security_System.png',
  description: `SimpliSafe 12-piece Small Business Security System with base station, keypad, cameras, sensors, panic buttons, and accessories.`,
  originalHeight: 2800,
  originalWidth: 2800
}

/**
 * ![Yard Sign & Window Decal (2 pack)](https://images.ctfassets.net/v6awd0kabi65/65CfRuJg2zKPVYawsiQoBC/b3b67b5bcfa3741fb46529814cca18a4/Screenshot_2025-07-08_at_17.47.25.png?w=120&h=120&fit=pad)
 *
 * Yard Sign & Window Decal (2 pack)
 *
 * Yard Sign & Window Decal (2 pack)
 */
export const IMG_65CfRuJg2zKPVYawsiQoBC = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/65CfRuJg2zKPVYawsiQoBC/b3b67b5bcfa3741fb46529814cca18a4/Screenshot_2025-07-08_at_17.47.25.png',
  description: `Yard Sign & Window Decal (2 pack)`,
  originalHeight: 635,
  originalWidth: 1077
}

/**
 * ![12-piece Small Business Security System](https://images.ctfassets.net/v6awd0kabi65/jaANwxUCwII6cUKQFpeNC/a2598e154b2569e09f408f4e1ae9442c/250231_Field_Sales_Mighty_Online_Flat_Lays_12pc.png?w=120&h=120&fit=pad)
 *
 * 12-piece Small Business Security System
 *
 * SimpliSafe 12-piece Small Business Security System with base station, keypad, cameras, sensors, panic buttons, and accessories.
 */
export const IMG_jaANwxUCwII6cUKQFpeNC = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/jaANwxUCwII6cUKQFpeNC/a2598e154b2569e09f408f4e1ae9442c/250231_Field_Sales_Mighty_Online_Flat_Lays_12pc.png',
  description: `SimpliSafe 12-piece Small Business Security System with base station, keypad, cameras, sensors, panic buttons, and accessories.`,
  originalHeight: 10000,
  originalWidth: 10000
}

/**
 * ![Instant Delivery Starter Kit](https://images.ctfassets.net/v6awd0kabi65/5vGaYubn1c81mwEFEeB9E0/5ef1244532b3301f08d03dc75443d54a/New_Kit_Image.png?w=120&h=120&fit=pad)
 *
 * Instant Delivery Starter Kit
 *
 * A SimpliSafe Base Station, a Keypad, a Key Fob, an Entry Sensor, and three Motion Sensors on a yellow table.
 */
export const IMG_5vGaYubn1c81mwEFEeB9E0 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5vGaYubn1c81mwEFEeB9E0/5ef1244532b3301f08d03dc75443d54a/New_Kit_Image.png',
  description: `A SimpliSafe Base Station, a Keypad, a Key Fob, an Entry Sensor, and three Motion Sensors on a yellow table.`,
  originalHeight: 521,
  originalWidth: 718
}

/**
 * ![20-piece Small Business Security System](https://images.ctfassets.net/v6awd0kabi65/64wDUAGRVfgqEL0QDFOIBa/a739ab1d3c32fb2c34d730c2e9429be3/250231_Field_Sales_Mighty_Online_Flat_Lays_20pc.png?w=120&h=120&fit=pad)
 *
 * 20-piece Small Business Security System
 *
 * SimpliSafe 20-piece Small Business Security System with base station, keypad, cameras, sensors, panic buttons, sirens, and accessories.
 */
export const IMG_64wDUAGRVfgqEL0QDFOIBa = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/64wDUAGRVfgqEL0QDFOIBa/a739ab1d3c32fb2c34d730c2e9429be3/250231_Field_Sales_Mighty_Online_Flat_Lays_20pc.png',
  description: `SimpliSafe 20-piece Small Business Security System with base station, keypad, cameras, sensors, panic buttons, sirens, and accessories.`,
  originalHeight: 10000,
  originalWidth: 10000
}

/**
 * ![What is a Video Doorbell and why should you have one?](https://images.ctfassets.net/v6awd0kabi65/3J6E0LS2kJNkLkRJuqjG04/ade4a9807eb9ade8e07e042d261cb557/What_is_a_Video_Doorbell_and_why_should_you_have_one?w=120&h=120&fit=pad)
 *
 * What is a Video Doorbell and why should you have one?
 *
 * Learn everything you need to know about Video Doorbells: what is a Video Doorbell, benefits of a Video Doorbell, and more with SimpliSafe.
 */
export const IMG_3J6E0LS2kJNkLkRJuqjG04 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3J6E0LS2kJNkLkRJuqjG04/ade4a9807eb9ade8e07e042d261cb557/What_is_a_Video_Doorbell_and_why_should_you_have_one',
  description: `Learn everything you need to know about Video Doorbells: what is a Video Doorbell, benefits of a Video Doorbell, and more with SimpliSafe.`,
  originalHeight: 4000,
  originalWidth: 6000
}

/**
 * ![Your Ultimate Going On Holiday Checklist](https://images.ctfassets.net/v6awd0kabi65/12RATC29ye2oOKFBlic6KA/9247cb207f695b3d6dc392a7f72248ce/Your_ultimate_going_on_a_holiday_checklist.jpg?w=120&h=120&fit=pad)
 *
 * Your Ultimate Going On Holiday Checklist
 *
 * What to pack, what to leave behind, and how to keep your home secure while you’re away. Learn more with this “going on holiday” checklist from SimpliSafe.
 */
export const IMG_12RATC29ye2oOKFBlic6KA = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/12RATC29ye2oOKFBlic6KA/9247cb207f695b3d6dc392a7f72248ce/Your_ultimate_going_on_a_holiday_checklist.jpg',
  description: `What to pack, what to leave behind, and how to keep your home secure while you’re away. Learn more with this “going on holiday” checklist from SimpliSafe.`,
  originalHeight: 4160,
  originalWidth: 6240
}

/**
 * ![How to Join the Neighbourhood Watch](https://images.ctfassets.net/v6awd0kabi65/11EjobnkWN9AwtxmYhPj43/40e9c0f42054033d3f2b4cfd75faf048/How_to_Join_the_Neighbourhood_Watch.jpg?w=120&h=120&fit=pad)
 *
 * How to Join the Neighbourhood Watch
 *
 * Discover how to join your local Neighbourhood Watch and help keep your community safe with our expert guide.
 */
export const IMG_11EjobnkWN9AwtxmYhPj43 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/11EjobnkWN9AwtxmYhPj43/40e9c0f42054033d3f2b4cfd75faf048/How_to_Join_the_Neighbourhood_Watch.jpg',
  description: `Discover how to join your local Neighbourhood Watch and help keep your community safe with our expert guide.`,
  originalHeight: 3722,
  originalWidth: 5583
}

/**
 * ![Instant Delivery Starter Kit + Free Cam](https://images.ctfassets.net/v6awd0kabi65/4ZuopH1Gg2t9JOrpdcl7un/4be13f930ea1b9d84f112916752a26ef/95ea4ade27666b8fceec3bfd2dcaf7fbedae180a2.png?w=120&h=120&fit=pad)
 *
 * Instant Delivery Starter Kit + Free Cam
 *
 * A SimpliSafe Base Station, a Keypad, a Key Fob, an Entry Sensor, three Motion Sensors, an Outdoor Camera, and a cable on a yellow table.
 */
export const IMG_4ZuopH1Gg2t9JOrpdcl7un = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4ZuopH1Gg2t9JOrpdcl7un/4be13f930ea1b9d84f112916752a26ef/95ea4ade27666b8fceec3bfd2dcaf7fbedae180a2.png',
  description: `A SimpliSafe Base Station, a Keypad, a Key Fob, an Entry Sensor, three Motion Sensors, an Outdoor Camera, and a cable on a yellow table.`,
  originalHeight: 540,
  originalWidth: 720
}

/**
 * ![Instant Delivery Starter Kit - 6.12.25 update](https://images.ctfassets.net/v6awd0kabi65/2OHt08HxDRfYGJV2QoUCf/3f957b564cc8924a57f0cefccaf4e543/New_Kit_Image.png?w=120&h=120&fit=pad)
 *
 * Instant Delivery Starter Kit - 6.12.25 update
 *
 * A SimpliSafe Base Station, a Keypad, a Key Fob, an Entry Sensor, and three Motion Sensors on a yellow table.
 */
export const IMG_2OHt08HxDRfYGJV2QoUCf = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2OHt08HxDRfYGJV2QoUCf/3f957b564cc8924a57f0cefccaf4e543/New_Kit_Image.png',
  description: `A SimpliSafe Base Station, a Keypad, a Key Fob, an Entry Sensor, and three Motion Sensors on a yellow table.`,
  originalHeight: 521,
  originalWidth: 718
}

/**
 * ![How to Prevent Crime in Your Community](https://images.ctfassets.net/v6awd0kabi65/6DmfOyz6w3bJKEWMV9nIHa/1c1224935d15274c822a542cf963ab5d/237092_ODM_Beta_ProductImagery_BeautyShot_Olympus_Camera_NoWire_AM_0679_Update.jpg?w=120&h=120&fit=pad)
 *
 * How to Prevent Crime in Your Community
 *
 * Learn how to prevent crime in the community with seven practical tips from SimpliSafe.
 */
export const IMG_6DmfOyz6w3bJKEWMV9nIHa = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6DmfOyz6w3bJKEWMV9nIHa/1c1224935d15274c822a542cf963ab5d/237092_ODM_Beta_ProductImagery_BeautyShot_Olympus_Camera_NoWire_AM_0679_Update.jpg',
  description: `Learn how to prevent crime in the community with seven practical tips from SimpliSafe.`,
  originalHeight: 4602,
  originalWidth: 6900
}

/**
 * ![Outdoor Camera Power Cable](https://images.ctfassets.net/v6awd0kabi65/ZQWWxljvoCne02YkXzchv/76d400a590bd568acdc09ae16f5b7cbf/25ft-Cable.jpg?w=120&h=120&fit=pad)
 *
 * Outdoor Camera Power Cable
 *
 *
 */
export const IMG_ZQWWxljvoCne02YkXzchv = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/ZQWWxljvoCne02YkXzchv/76d400a590bd568acdc09ae16f5b7cbf/25ft-Cable.jpg',
  description: ``,
  originalHeight: 1418,
  originalWidth: 1254
}

/**
 * ![Outdoor Camera Power Cable (Transparent)](https://images.ctfassets.net/v6awd0kabi65/3jQttztevaaMwupaq66Nry/f62152913db812ae8ebe8a2430b43c8e/25ft-cable.png?w=120&h=120&fit=pad)
 *
 * Outdoor Camera Power Cable (Transparent)
 *
 * Image of a power cable on a solid white background
 */
export const IMG_3jQttztevaaMwupaq66Nry = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3jQttztevaaMwupaq66Nry/f62152913db812ae8ebe8a2430b43c8e/25ft-cable.png',
  description: `Image of a power cable on a solid white background`,
  originalHeight: 800,
  originalWidth: 1050
}

/**
 * ![SMB Base station - SimpliSafe at your business](https://images.ctfassets.net/v6awd0kabi65/5cP0jvCf1OG9DIsw2s8UIJ/87bac9e841f147771ab62b44c49d9d7c/18d03db7-92bd-4be6-ba2c-4897a447420e.png?w=120&h=120&fit=pad)
 *
 * SMB Base station - SimpliSafe at your business
 *
 * A base station on a table
 */
export const IMG_5cP0jvCf1OG9DIsw2s8UIJ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5cP0jvCf1OG9DIsw2s8UIJ/87bac9e841f147771ab62b44c49d9d7c/18d03db7-92bd-4be6-ba2c-4897a447420e.png',
  description: `A base station on a table`,
  originalHeight: 729,
  originalWidth: 1094
}

/**
 * ![ODCamS2 Carousel 3](https://images.ctfassets.net/v6awd0kabi65/1ye5KQJCnsT1MPOUtwWcyk/aaf8c2fb90075018d26ae6222b108080/ODCam_Carousel_3.jpg?w=120&h=120&fit=pad)
 *
 * ODCamS2 Carousel 3
 *
 *
 */
export const IMG_1ye5KQJCnsT1MPOUtwWcyk = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1ye5KQJCnsT1MPOUtwWcyk/aaf8c2fb90075018d26ae6222b108080/ODCam_Carousel_3.jpg',
  description: ``,
  originalHeight: 882,
  originalWidth: 1118
}

/**
 * ![ODCamS2 diagram 1](https://images.ctfassets.net/v6awd0kabi65/13J1ri5BCnSENyzH10uFBH/00900d5ffa503ea02b6d5657468be299/ODCam_diagram_1.jpg?w=120&h=120&fit=pad)
 *
 * ODCamS2 diagram 1
 *
 *
 */
export const IMG_13J1ri5BCnSENyzH10uFBH = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/13J1ri5BCnSENyzH10uFBH/00900d5ffa503ea02b6d5657468be299/ODCam_diagram_1.jpg',
  description: ``,
  originalHeight: 2542,
  originalWidth: 2198
}

/**
 * ![SimpliSafe - Logo](https://images.ctfassets.net/v6awd0kabi65/7rTc0nb3AVq5NG9WLUcG5I/7e9ec3c0dc2b525528dde190bb0f780e/image__8_.png?w=120&h=120&fit=pad)
 *
 * SimpliSafe - Logo
 *
 * SimpliSafe logo
 */
export const IMG_7rTc0nb3AVq5NG9WLUcG5I = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7rTc0nb3AVq5NG9WLUcG5I/7e9ec3c0dc2b525528dde190bb0f780e/image__8_.png',
  description: `SimpliSafe logo`,
  originalHeight: 127,
  originalWidth: 126
}

/**
 * ![Google Play](https://images.ctfassets.net/v6awd0kabi65/6CiupNcbwZWioKOCt3PIAA/7d32e6562bcac8eec2ba24935a479de4/image__5_.png?w=120&h=120&fit=pad)
 *
 * Google Play
 *
 * Google Play store logo
 */
export const IMG_6CiupNcbwZWioKOCt3PIAA = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6CiupNcbwZWioKOCt3PIAA/7d32e6562bcac8eec2ba24935a479de4/image__5_.png',
  description: `Google Play store logo`,
  originalHeight: 56,
  originalWidth: 184
}

/**
 * ![App Store](https://images.ctfassets.net/v6awd0kabi65/6AZWds73eDs6cYUcsNTOb4/1ce0c87e96812e41262431ad7106d04a/image__7_.png?w=120&h=120&fit=pad)
 *
 * App Store
 *
 * Apple App Store logo
 */
export const IMG_6AZWds73eDs6cYUcsNTOb4 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6AZWds73eDs6cYUcsNTOb4/1ce0c87e96812e41262431ad7106d04a/image__7_.png',
  description: `Apple App Store logo`,
  originalHeight: 54,
  originalWidth: 184
}

/**
 * ![Leadership page - Ai-Li Lim](https://images.ctfassets.net/v6awd0kabi65/2Kup2ramrFlY7cwIXolXIn/cd5d7c32b81d13eb179a18dd8179139a/Ai-Li.jpg?w=120&h=120&fit=pad)
 *
 * Leadership page - Ai-Li Lim
 *
 * Ai-Li Lim smiling in front of a brick wall background.
 */
export const IMG_2Kup2ramrFlY7cwIXolXIn = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2Kup2ramrFlY7cwIXolXIn/cd5d7c32b81d13eb179a18dd8179139a/Ai-Li.jpg',
  description: `Ai-Li Lim smiling in front of a brick wall background.`,
  originalHeight: 1551,
  originalWidth: 1338
}

/**
 * ![Leadership page - Christian Cerda](https://images.ctfassets.net/v6awd0kabi65/6z6QMhLfiD7RueBXo306ym/ea2430e2e857ad99ed690db59ba64c0c/Christian.jpg?w=120&h=120&fit=pad)
 *
 * Leadership page - Christian Cerda
 *
 * Christian Cerda standing with arms crossed in an indoor setting.
 */
export const IMG_6z6QMhLfiD7RueBXo306ym = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6z6QMhLfiD7RueBXo306ym/ea2430e2e857ad99ed690db59ba64c0c/Christian.jpg',
  description: `Christian Cerda standing with arms crossed in an indoor setting.`,
  originalHeight: 1551,
  originalWidth: 1338
}

/**
 * ![Leadership page - Vanessa Karlis](https://images.ctfassets.net/v6awd0kabi65/2Jw6Ph9pQRUQuKqwSOtIak/66b2786df1a2cfcd7e4c0bbf6aa849b0/Vanessa.jpg?w=120&h=120&fit=pad)
 *
 * Leadership page - Vanessa Karlis
 *
 * Vanessa Karlis smiling and standing with arms crossed in an indoor setting.
 */
export const IMG_2Jw6Ph9pQRUQuKqwSOtIak = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2Jw6Ph9pQRUQuKqwSOtIak/66b2786df1a2cfcd7e4c0bbf6aa849b0/Vanessa.jpg',
  description: `Vanessa Karlis smiling and standing with arms crossed in an indoor setting.`,
  originalHeight: 1551,
  originalWidth: 1338
}

/**
 * ![Leadership page - Scott Braun](https://images.ctfassets.net/v6awd0kabi65/ylDQvWuEuKtgDTePi0xpy/e2d21f9d1ce5232c4de86a75fcfc59c7/Scott.jpg?w=120&h=120&fit=pad)
 *
 * Leadership page - Scott Braun
 *
 * Scott Braun smiling and standing in an indoor setting.
 */
export const IMG_ylDQvWuEuKtgDTePi0xpy = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/ylDQvWuEuKtgDTePi0xpy/e2d21f9d1ce5232c4de86a75fcfc59c7/Scott.jpg',
  description: `Scott Braun smiling and standing in an indoor setting.`,
  originalHeight: 1551,
  originalWidth: 1338
}

/**
 * ![Leadership Page - Hooman Shahidi](https://images.ctfassets.net/v6awd0kabi65/1yEgj3kYgHw315LvBaabCe/aa28cda6fccb842dc095e570a28dba11/Hooman.jpg?w=120&h=120&fit=pad)
 *
 * Leadership Page - Hooman Shahidi
 *
 * Hooman Shahidi smiling and standing with arms crossed in an indoor setting.
 */
export const IMG_1yEgj3kYgHw315LvBaabCe = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1yEgj3kYgHw315LvBaabCe/aa28cda6fccb842dc095e570a28dba11/Hooman.jpg',
  description: `Hooman Shahidi smiling and standing with arms crossed in an indoor setting.`,
  originalHeight: 1551,
  originalWidth: 1338
}

/**
 * ![Leadership page - Crystal Caligiuri](https://images.ctfassets.net/v6awd0kabi65/3710pYal7yj94xfcxdMHKz/95598f351c99c1ec09324f928ae500a0/Crystal.jpg?w=120&h=120&fit=pad)
 *
 * Leadership page - Crystal Caligiuri
 *
 * Crystal Caligiuri smiling and standing with arms crossed in an indoor setting.
 */
export const IMG_3710pYal7yj94xfcxdMHKz = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3710pYal7yj94xfcxdMHKz/95598f351c99c1ec09324f928ae500a0/Crystal.jpg',
  description: `Crystal Caligiuri smiling and standing with arms crossed in an indoor setting.`,
  originalHeight: 1551,
  originalWidth: 1338
}

/**
 * ![Leadership page - Rebecca Zavin](https://images.ctfassets.net/v6awd0kabi65/UWs79QXLoMeasEhe3NYVQ/ae887bb48ac8ed7b2a8f260c5cc2b159/Rebecca.jpg?w=120&h=120&fit=pad)
 *
 * Leadership page - Rebecca Zavin
 *
 * Rebecca Zavin smiling and standing in an indoor setting.
 */
export const IMG_UWs79QXLoMeasEhe3NYVQ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/UWs79QXLoMeasEhe3NYVQ/ae887bb48ac8ed7b2a8f260c5cc2b159/Rebecca.jpg',
  description: `Rebecca Zavin smiling and standing in an indoor setting.`,
  originalHeight: 1551,
  originalWidth: 1338
}

/**
 * ![Leadership page - Don Nelson](https://images.ctfassets.net/v6awd0kabi65/57bSo5oZGx9JRLmGThQYlv/1963c7358b1f756f2c6f9de345f2247f/Don.jpg?w=120&h=120&fit=pad)
 *
 * Leadership page - Don Nelson
 *
 * Don Nelson smiling and standing in an indoor setting.
 */
export const IMG_57bSo5oZGx9JRLmGThQYlv = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/57bSo5oZGx9JRLmGThQYlv/1963c7358b1f756f2c6f9de345f2247f/Don.jpg',
  description: `Don Nelson smiling and standing in an indoor setting.`,
  originalHeight: 1551,
  originalWidth: 1338
}

/**
 * ![Leadership page - Brian Bloch](https://images.ctfassets.net/v6awd0kabi65/7nvhVprrMY6avvaX4VMNY8/2e0d43b7571735a010212e6aefcef61f/Brian.jpg?w=120&h=120&fit=pad)
 *
 * Leadership page - Brian Bloch
 *
 * Brian Bloch standing in an indoor setting.
 */
export const IMG_7nvhVprrMY6avvaX4VMNY8 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7nvhVprrMY6avvaX4VMNY8/2e0d43b7571735a010212e6aefcef61f/Brian.jpg',
  description: `Brian Bloch standing in an indoor setting.`,
  originalHeight: 1551,
  originalWidth: 1338
}

/**
 * ![Leadership page - Mark FitzPatrick](https://images.ctfassets.net/v6awd0kabi65/1ppNCp3PwAjEj8nHC7FvVT/c9ae96d5df4df5900a464cd91893c8ff/Mark.jpg?w=120&h=120&fit=pad)
 *
 * Leadership page - Mark FitzPatrick
 *
 * Mark FitzPatrick standing with arms crossed in an indoor setting.
 */
export const IMG_1ppNCp3PwAjEj8nHC7FvVT = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1ppNCp3PwAjEj8nHC7FvVT/c9ae96d5df4df5900a464cd91893c8ff/Mark.jpg',
  description: `Mark FitzPatrick standing with arms crossed in an indoor setting.`,
  originalHeight: 1551,
  originalWidth: 1338
}

/**
 * ![SA_DT_Doors1_hero](https://images.ctfassets.net/v6awd0kabi65/5UbnJuhDLAs2RY4T8TYRBJ/6f28a3e9e2009012692bf979cc6b6e03/Doors1_d_hero.jpg?w=120&h=120&fit=pad)
 *
 * SA_DT_Doors1_hero
 *
 * The side of a dark blue house with a white door and a text bubble with a checkmark stating "Needs protecting."
 */
export const IMG_5UbnJuhDLAs2RY4T8TYRBJ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5UbnJuhDLAs2RY4T8TYRBJ/6f28a3e9e2009012692bf979cc6b6e03/Doors1_d_hero.jpg',
  description: `The side of a dark blue house with a white door and a text bubble with a checkmark stating "Needs protecting."`,
  originalHeight: 1200,
  originalWidth: 1474
}

/**
 * ![SA_DT_Interior_hero](https://images.ctfassets.net/v6awd0kabi65/3Vb3E0d0rjeysiaxVjRjO8/7b3ce56333df2af04a9934fdfbfb0f48/Interior_d_hero.jpg?w=120&h=120&fit=pad)
 *
 * SA_DT_Interior_hero
 *
 * An open-concept living space with a kitchen, dining area, and living room.
 */
export const IMG_3Vb3E0d0rjeysiaxVjRjO8 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3Vb3E0d0rjeysiaxVjRjO8/7b3ce56333df2af04a9934fdfbfb0f48/Interior_d_hero.jpg',
  description: `An open-concept living space with a kitchen, dining area, and living room.`,
  originalHeight: 1200,
  originalWidth: 1474
}

/**
 * ![SA_DT_Entry1_hero](https://images.ctfassets.net/v6awd0kabi65/6d78Vey0kSH0Qox5xoDSvh/bf11a6eb48336e138b90cf05032a7e9a/Entry1_d_hero.jpg?w=120&h=120&fit=pad)
 *
 * SA_DT_Entry1_hero
 *
 * An interior view of a wooden front door with a white entry sensor, indicated by a blue circle, on the door and its frame.
 */
export const IMG_6d78Vey0kSH0Qox5xoDSvh = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6d78Vey0kSH0Qox5xoDSvh/bf11a6eb48336e138b90cf05032a7e9a/Entry1_d_hero.jpg',
  description: `An interior view of a wooden front door with a white entry sensor, indicated by a blue circle, on the door and its frame.`,
  originalHeight: 1200,
  originalWidth: 1474
}

/**
 * ![SA_DT_Entry2_hero](https://images.ctfassets.net/v6awd0kabi65/4T7RYaHtj2jQ4GMjXre8fc/84103810b357a61d8e3087ee30384b7b/Entry2_d_hero.jpg?w=120&h=120&fit=pad)
 *
 * SA_DT_Entry2_hero
 *
 * A window with a white entry circled in blue on the window frame, with pillows, a blanket, and a child's toy on a window seat.
 */
export const IMG_4T7RYaHtj2jQ4GMjXre8fc = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4T7RYaHtj2jQ4GMjXre8fc/84103810b357a61d8e3087ee30384b7b/Entry2_d_hero.jpg',
  description: `A window with a white entry circled in blue on the window frame, with pillows, a blanket, and a child's toy on a window seat.`,
  originalHeight: 526,
  originalWidth: 730
}

/**
 * ![SA_MB_YardSign_hero](https://images.ctfassets.net/v6awd0kabi65/7em5Wk1H0ndVcCPR7w1Q70/3b620f91b3dd103d4562e7b63860b5df/YardSign_m_hero.jpg?w=120&h=120&fit=pad)
 *
 * SA_MB_YardSign_hero
 *
 * A SimpliSafe yard sign in the foreground, stating "Monitored 24/7 SimpliSafe Home Security," in front of a dark blue house with a wooden front door.
 */
export const IMG_7em5Wk1H0ndVcCPR7w1Q70 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7em5Wk1H0ndVcCPR7w1Q70/3b620f91b3dd103d4562e7b63860b5df/YardSign_m_hero.jpg',
  description: `A SimpliSafe yard sign in the foreground, stating "Monitored 24/7 SimpliSafe Home Security," in front of a dark blue house with a wooden front door.`,
  originalHeight: 496,
  originalWidth: 686
}

/**
 * ![SA_MB_YardSign_thumb](https://images.ctfassets.net/v6awd0kabi65/7oi3gGvjJj70XGHibI89nl/6419ebbe1e8fe9736ec5d9cc84d6441e/YardSign_thumb.jpg?w=120&h=120&fit=pad)
 *
 * SA_MB_YardSign_thumb
 *
 * A SimpliSafe yard sign in the foreground, stating "Monitored 24/7 SimpliSafe Home Security," in front of a dark blue house with a wooden front door.
 */
export const IMG_7oi3gGvjJj70XGHibI89nl = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7oi3gGvjJj70XGHibI89nl/6419ebbe1e8fe9736ec5d9cc84d6441e/YardSign_thumb.jpg',
  description: `A SimpliSafe yard sign in the foreground, stating "Monitored 24/7 SimpliSafe Home Security," in front of a dark blue house with a wooden front door.`,
  originalHeight: 100,
  originalWidth: 100
}

/**
 * ![SA_MB_Windows2_thumb](https://images.ctfassets.net/v6awd0kabi65/602Buup74emAbCuanbC6ae/e872e6d5c686742f30dfaab72c6ef0d8/Windows2_thumb.jpg?w=120&h=120&fit=pad)
 *
 * SA_MB_Windows2_thumb
 *
 * The foundation of a dark blue house with a small window labeled "Too small" and a larger window labeled "Needs protecting" on the ground floor.
 */
export const IMG_602Buup74emAbCuanbC6ae = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/602Buup74emAbCuanbC6ae/e872e6d5c686742f30dfaab72c6ef0d8/Windows2_thumb.jpg',
  description: `The foundation of a dark blue house with a small window labeled "Too small" and a larger window labeled "Needs protecting" on the ground floor.`,
  originalHeight: 100,
  originalWidth: 100
}

/**
 * ![SA_MB_Windows1_hero](https://images.ctfassets.net/v6awd0kabi65/6CAiFCx9YZUwFgfwr0efBK/bda05a950d664f875819ffefadbb68ac/Windows1_m_hero.jpg?w=120&h=120&fit=pad)
 *
 * SA_MB_Windows1_hero
 *
 * The side of a dark blue house with white trim, featuring a door leading to a patio. Text bubbles indicate "Too high up" next to an upper window and "Needs protecting" next to a lower window.
 */
export const IMG_6CAiFCx9YZUwFgfwr0efBK = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6CAiFCx9YZUwFgfwr0efBK/bda05a950d664f875819ffefadbb68ac/Windows1_m_hero.jpg',
  description: `The side of a dark blue house with white trim, featuring a door leading to a patio. Text bubbles indicate "Too high up" next to an upper window and "Needs protecting" next to a lower window.`,
  originalHeight: 496,
  originalWidth: 686
}

/**
 * ![SA_MB_Summary_hero](https://images.ctfassets.net/v6awd0kabi65/zHlkGkezzClbnIMhFNGHo/7f787658d4ad5db8035a7ebaf5b3cf25/Summary_m_hero.jpg?w=120&h=120&fit=pad)
 *
 * SA_MB_Summary_hero
 *
 * A white SimpliSafe Base Station with a glowing blue light sits on a table in the foreground, with blurred figures of people in a living room in the background.
 */
export const IMG_zHlkGkezzClbnIMhFNGHo = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/zHlkGkezzClbnIMhFNGHo/7f787658d4ad5db8035a7ebaf5b3cf25/Summary_m_hero.jpg',
  description: `A white SimpliSafe Base Station with a glowing blue light sits on a table in the foreground, with blurred figures of people in a living room in the background.`,
  originalHeight: 362,
  originalWidth: 686
}

/**
 * ![SA_MB_Windows2_hero](https://images.ctfassets.net/v6awd0kabi65/7GJ5HavttQcOpDEGyU356Y/52e368542c350f928fbf3f3ef1570483/Windows2_m_hero.jpg?w=120&h=120&fit=pad)
 *
 * SA_MB_Windows2_hero
 *
 * The foundation of a dark blue house with a small window labeled "Too small" and a larger window labeled "Needs protecting" on the ground floor.
 */
export const IMG_7GJ5HavttQcOpDEGyU356Y = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7GJ5HavttQcOpDEGyU356Y/52e368542c350f928fbf3f3ef1570483/Windows2_m_hero.jpg',
  description: `The foundation of a dark blue house with a small window labeled "Too small" and a larger window labeled "Needs protecting" on the ground floor.`,
  originalHeight: 496,
  originalWidth: 686
}

/**
 * ![SA_MB_Windows1_thumb](https://images.ctfassets.net/v6awd0kabi65/6QrOh9lq5h20La5w3ga9Z8/c1dbd608c75f4b9e33c90e189f6745fb/Windows1_thumb.jpg?w=120&h=120&fit=pad)
 *
 * SA_MB_Windows1_thumb
 *
 * The side of a dark blue house with white trim, featuring a door leading to a patio. Text bubbles indicate "Too high up" next to an upper window and "Needs protecting" next to a lower window.
 */
export const IMG_6QrOh9lq5h20La5w3ga9Z8 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6QrOh9lq5h20La5w3ga9Z8/c1dbd608c75f4b9e33c90e189f6745fb/Windows1_thumb.jpg',
  description: `The side of a dark blue house with white trim, featuring a door leading to a patio. Text bubbles indicate "Too high up" next to an upper window and "Needs protecting" next to a lower window.`,
  originalHeight: 100,
  originalWidth: 100
}

/**
 * ![SA_MB_Outdoor2_thumb](https://images.ctfassets.net/v6awd0kabi65/2zDEgowfKZVUqTIM59ukMU/9d0567768d5f4fd146636b91b97f5645/Outdoor2_thumb.jpg?w=120&h=120&fit=pad)
 *
 * SA_MB_Outdoor2_thumb
 *
 * A stone path leading to a covered patio area on the side of a dark blue house at dusk.
 */
export const IMG_2zDEgowfKZVUqTIM59ukMU = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2zDEgowfKZVUqTIM59ukMU/9d0567768d5f4fd146636b91b97f5645/Outdoor2_thumb.jpg',
  description: `A stone path leading to a covered patio area on the side of a dark blue house at dusk.`,
  originalHeight: 100,
  originalWidth: 100
}

/**
 * ![SA_MB_Outdoor2_hero](https://images.ctfassets.net/v6awd0kabi65/3HfydyyUYQZwJcSrjIbVo8/0ea48d4d1e36b793eeda5d6f9ef2eb2b/Outdoor2_m_hero.jpg?w=120&h=120&fit=pad)
 *
 * SA_MB_Outdoor2_hero
 *
 * A stone path leading to a covered patio area on the side of a dark blue house at dusk.
 */
export const IMG_3HfydyyUYQZwJcSrjIbVo8 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3HfydyyUYQZwJcSrjIbVo8/0ea48d4d1e36b793eeda5d6f9ef2eb2b/Outdoor2_m_hero.jpg',
  description: `A stone path leading to a covered patio area on the side of a dark blue house at dusk.`,
  originalHeight: 496,
  originalWidth: 686
}

/**
 * ![SA_MB_Outdoor1_hero](https://images.ctfassets.net/v6awd0kabi65/5Ihgr9XMed27rz0pbXQnlq/865eebb50867a5210c185a1c75aec574/Outdoor1_m_hero.jpg?w=120&h=120&fit=pad)
 *
 * SA_MB_Outdoor1_hero
 *
 * The front entrance of a dark blue house with a black door and white trim, showcasing an inviting exterior.
 */
export const IMG_5Ihgr9XMed27rz0pbXQnlq = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5Ihgr9XMed27rz0pbXQnlq/865eebb50867a5210c185a1c75aec574/Outdoor1_m_hero.jpg',
  description: `The front entrance of a dark blue house with a black door and white trim, showcasing an inviting exterior.`,
  originalHeight: 496,
  originalWidth: 686
}

/**
 * ![SA_MB_Outdoor1_thumb](https://images.ctfassets.net/v6awd0kabi65/6c7d3YavbuCsDVcggqrgrX/f2c6d423936869310e3a800393c5d4bd/Outdoor1_thumb.jpg?w=120&h=120&fit=pad)
 *
 * SA_MB_Outdoor1_thumb
 *
 * The backyard of a dark blue house at dusk, with the outdoor camera's wide detection area highlighted in blue, covering a patio and yard.
 */
export const IMG_6c7d3YavbuCsDVcggqrgrX = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6c7d3YavbuCsDVcggqrgrX/f2c6d423936869310e3a800393c5d4bd/Outdoor1_thumb.jpg',
  description: `The backyard of a dark blue house at dusk, with the outdoor camera's wide detection area highlighted in blue, covering a patio and yard.`,
  originalHeight: 100,
  originalWidth: 100
}

/**
 * ![SA_MB_Keypad_thumb](https://images.ctfassets.net/v6awd0kabi65/6lhoQoIzHHEzyixRhXKwPo/79026b0fce11089983527feeba10ad02/Keypad_thumb.jpg?w=120&h=120&fit=pad)
 *
 * SA_MB_Keypad_thumb
 *
 * A person's hand is shown pressing a button on a white SimpliSafe Keypad that is mounted to the wall. The keypad has a black digital display showing "home" and a white number pad with circular buttons.
 */
export const IMG_6lhoQoIzHHEzyixRhXKwPo = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6lhoQoIzHHEzyixRhXKwPo/79026b0fce11089983527feeba10ad02/Keypad_thumb.jpg',
  description: `A person's hand is shown pressing a button on a white SimpliSafe Keypad that is mounted to the wall. The keypad has a black digital display showing "home" and a white number pad with circular buttons. `,
  originalHeight: 100,
  originalWidth: 100
}

/**
 * ![SA_MB_Entry_hero](https://images.ctfassets.net/v6awd0kabi65/2JTZIo0ui3hPSAJjYbXkIn/87970ca351487e5c6c82c6fba11ba480/Entry_m_hero.jpg?w=120&h=120&fit=pad)
 *
 * SA_MB_Entry_hero
 *
 * An interior view of a wooden front door with a white entry sensor, indicated by a blue circle, on the door and its frame.
 */
export const IMG_2JTZIo0ui3hPSAJjYbXkIn = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2JTZIo0ui3hPSAJjYbXkIn/87970ca351487e5c6c82c6fba11ba480/Entry_m_hero.jpg',
  description: `An interior view of a wooden front door with a white entry sensor, indicated by a blue circle, on the door and its frame.`,
  originalHeight: 316,
  originalWidth: 686
}

/**
 * ![SA_MB_Doors3_thumb](https://images.ctfassets.net/v6awd0kabi65/1uXmEHudwP3EGfqwRU2qUq/8b35384506a5b3635ac59da6ee3b8fdb/Doors3_thumb.jpg?w=120&h=120&fit=pad)
 *
 * SA_MB_Doors3_thumb
 *
 * A white door inside a garage, next to gray cabinets and a workbench with tools.
 */
export const IMG_1uXmEHudwP3EGfqwRU2qUq = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1uXmEHudwP3EGfqwRU2qUq/8b35384506a5b3635ac59da6ee3b8fdb/Doors3_thumb.jpg',
  description: `A white door inside a garage, next to gray cabinets and a workbench with tools.`,
  originalHeight: 100,
  originalWidth: 100
}

/**
 * ![SA_MB_Interior_hero](https://images.ctfassets.net/v6awd0kabi65/7aLv0YftFL5vP6AeikboqR/fb3a81191ceb6e35131a614ac91f6a65/Interior_m_hero.jpg?w=120&h=120&fit=pad)
 *
 * SA_MB_Interior_hero
 *
 * An open-concept living space with a kitchen, dining area, and living room.
 */
export const IMG_7aLv0YftFL5vP6AeikboqR = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7aLv0YftFL5vP6AeikboqR/fb3a81191ceb6e35131a614ac91f6a65/Interior_m_hero.jpg',
  description: `An open-concept living space with a kitchen, dining area, and living room.`,
  originalHeight: 496,
  originalWidth: 686
}

/**
 * ![SA_MB_Doors1_thumb](https://images.ctfassets.net/v6awd0kabi65/5rBlthLTevXHytLobigFdI/cd170ccec2696aba7ae452b36a8e8a0c/Doors1_thumb.jpg?w=120&h=120&fit=pad)
 *
 * SA_MB_Doors1_thumb
 *
 * The side of a dark blue house with a white door and a text bubble with a checkmark stating "Needs protecting."
 */
export const IMG_5rBlthLTevXHytLobigFdI = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5rBlthLTevXHytLobigFdI/cd170ccec2696aba7ae452b36a8e8a0c/Doors1_thumb.jpg',
  description: `The side of a dark blue house with a white door and a text bubble with a checkmark stating "Needs protecting."`,
  originalHeight: 100,
  originalWidth: 100
}

/**
 * ![SA_MB_Doors1_hero](https://images.ctfassets.net/v6awd0kabi65/3eKW5RAm9naxj5cpnGYHAl/63d41da112b64931de9059a35eb83323/Doors1_m_hero.jpg?w=120&h=120&fit=pad)
 *
 * SA_MB_Doors1_hero
 *
 * The side of a dark blue house with a white door and a text bubble with a checkmark stating "Needs protecting."
 */
export const IMG_3eKW5RAm9naxj5cpnGYHAl = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3eKW5RAm9naxj5cpnGYHAl/63d41da112b64931de9059a35eb83323/Doors1_m_hero.jpg',
  description: `The side of a dark blue house with a white door and a text bubble with a checkmark stating "Needs protecting."`,
  originalHeight: 496,
  originalWidth: 686
}

/**
 * ![SA_MB_Doors2_thumb](https://images.ctfassets.net/v6awd0kabi65/1nEKthUyEQASwpMMoWBorT/35709dc1747fe3d2f036e4db6339908c/Doors2_thumb.jpg?w=120&h=120&fit=pad)
 *
 * SA_MB_Doors2_thumb
 *
 * A closed white sliding glass door on the side of a dark blue house, leading to a small patio area.
 */
export const IMG_1nEKthUyEQASwpMMoWBorT = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1nEKthUyEQASwpMMoWBorT/35709dc1747fe3d2f036e4db6339908c/Doors2_thumb.jpg',
  description: `A closed white sliding glass door on the side of a dark blue house, leading to a small patio area.`,
  originalHeight: 100,
  originalWidth: 100
}

/**
 * ![SA_MB_Base_thumb](https://images.ctfassets.net/v6awd0kabi65/4faHJQRoWQMQhaivCSmyrA/a7411dddfc8711ff7b38a983b58a0407/Base_thumb.jpg?w=120&h=120&fit=pad)
 *
 * SA_MB_Base_thumb
 *
 * The SimpliSafe Base Station on a shelf next to a plant and a piece of framed artwork.
 */
export const IMG_4faHJQRoWQMQhaivCSmyrA = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4faHJQRoWQMQhaivCSmyrA/a7411dddfc8711ff7b38a983b58a0407/Base_thumb.jpg',
  description: `The SimpliSafe Base Station on a shelf next to a plant and a piece of framed artwork.`,
  originalHeight: 100,
  originalWidth: 100
}

/**
 * ![SA_DT_Outdoor2_hero](https://images.ctfassets.net/v6awd0kabi65/1NSXjFYCnWdFudG3VTEob4/0b44f7f08da3f852d7854a552a7aa822/Outdoor2_d_hero.jpg?w=120&h=120&fit=pad)
 *
 * SA_DT_Outdoor2_hero
 *
 * A stone path leading to a covered patio area on the side of a dark blue house at dusk.
 */
export const IMG_1NSXjFYCnWdFudG3VTEob4 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1NSXjFYCnWdFudG3VTEob4/0b44f7f08da3f852d7854a552a7aa822/Outdoor2_d_hero.jpg',
  description: `A stone path leading to a covered patio area on the side of a dark blue house at dusk.`,
  originalHeight: 1200,
  originalWidth: 1474
}

/**
 * ![SA_DT_Outdoor1_hero](https://images.ctfassets.net/v6awd0kabi65/uIYjcVkemUbEUepC3uCT7/852c78f06641f35816378a6ab2b01c81/Outdoor1_d_hero.jpg?w=120&h=120&fit=pad)
 *
 * SA_DT_Outdoor1_hero
 *
 * The front entrance of a dark blue house with a black door and white trim, showcasing an inviting exterior.
 */
export const IMG_uIYjcVkemUbEUepC3uCT7 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/uIYjcVkemUbEUepC3uCT7/852c78f06641f35816378a6ab2b01c81/Outdoor1_d_hero.jpg',
  description: `The front entrance of a dark blue house with a black door and white trim, showcasing an inviting exterior.`,
  originalHeight: 1200,
  originalWidth: 1474
}

/**
 * ![SA_DT_Windows2_hero](https://images.ctfassets.net/v6awd0kabi65/5pjl43ucTmXYaqdTzPgFf8/802af48580a2c403636bd8abec3d8c8a/Windows2_d_hero.jpg?w=120&h=120&fit=pad)
 *
 * SA_DT_Windows2_hero
 *
 * The foundation of a dark blue house with a small window labeled "Too small" and a larger window labeled "Needs protecting" on the ground floor.
 */
export const IMG_5pjl43ucTmXYaqdTzPgFf8 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5pjl43ucTmXYaqdTzPgFf8/802af48580a2c403636bd8abec3d8c8a/Windows2_d_hero.jpg',
  description: `The foundation of a dark blue house with a small window labeled "Too small" and a larger window labeled "Needs protecting" on the ground floor.`,
  originalHeight: 1200,
  originalWidth: 1474
}

/**
 * ![SA_DT_YardSign_hero](https://images.ctfassets.net/v6awd0kabi65/1nbZBtpROEDjz2ckynxkGG/09184c056b50fabe0098e67314bb887e/YardSign_d_hero.jpg?w=120&h=120&fit=pad)
 *
 * SA_DT_YardSign_hero
 *
 * A SimpliSafe yard sign in the foreground, stating "Monitored 24/7 SimpliSafe Home Security," in front of a dark blue house with a wooden front door.
 */
export const IMG_1nbZBtpROEDjz2ckynxkGG = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1nbZBtpROEDjz2ckynxkGG/09184c056b50fabe0098e67314bb887e/YardSign_d_hero.jpg',
  description: `A SimpliSafe yard sign in the foreground, stating "Monitored 24/7 SimpliSafe Home Security," in front of a dark blue house with a wooden front door.`,
  originalHeight: 1200,
  originalWidth: 1474
}

/**
 * ![SA_DT_Windows_hero](https://images.ctfassets.net/v6awd0kabi65/3wv3kMUCyGYRkzzEus7jj5/48f1e5450a5c9b3ec2e247b294718e7e/Windows1_d_hero.jpg?w=120&h=120&fit=pad)
 *
 * SA_DT_Windows_hero
 *
 * The side of a dark blue house with white trim, featuring a door leading to a patio. Text bubbles indicate "Too high up" next to an upper window and "Needs protecting" next to a lower window.
 */
export const IMG_3wv3kMUCyGYRkzzEus7jj5 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3wv3kMUCyGYRkzzEus7jj5/48f1e5450a5c9b3ec2e247b294718e7e/Windows1_d_hero.jpg',
  description: `The side of a dark blue house with white trim, featuring a door leading to a patio. Text bubbles indicate "Too high up" next to an upper window and "Needs protecting" next to a lower window.`,
  originalHeight: 1200,
  originalWidth: 1474
}

/**
 * ![Olympus Outdoor Camera](https://images.ctfassets.net/v6awd0kabi65/14iuCWv1FtQETPOw6R77jc/fe2191815e835277cd6eb2a1e294d052/image__6_.png?w=120&h=120&fit=pad)
 *
 * Olympus Outdoor Camera
 *
 * Outdoor Camera
 */
export const IMG_14iuCWv1FtQETPOw6R77jc = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/14iuCWv1FtQETPOw6R77jc/fe2191815e835277cd6eb2a1e294d052/image__6_.png',
  description: `Outdoor Camera`,
  originalHeight: 320,
  originalWidth: 320
}

/**
 * ![SMB 105dB siren - SimpliSafe at your business](https://images.ctfassets.net/v6awd0kabi65/s6gPsbW5U4Elf4kuBqD0E/3019c5f7e42a98c315666d2e38f09a1d/9bd73e4721b5bce537664c5c49431154b24a3511.png?w=120&h=120&fit=pad)
 *
 * SMB 105dB siren - SimpliSafe at your business
 *
 * A 105dB siren mounted on a gray wall close to a door
 */
export const IMG_s6gPsbW5U4Elf4kuBqD0E = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/s6gPsbW5U4Elf4kuBqD0E/3019c5f7e42a98c315666d2e38f09a1d/9bd73e4721b5bce537664c5c49431154b24a3511.png',
  description: `A 105dB siren mounted on a gray wall close to a door`,
  originalHeight: 1097,
  originalWidth: 2000
}

/**
 * ![SMB Outdoor security camera - SimpliSafe at your business](https://images.ctfassets.net/v6awd0kabi65/3H7DqVNTpGeqU9qlLtFJl4/d76a14f84a070e70520fed589f34ef93/9cd98cbfd8cfe7277b3d89d7bd6b135277a73622.jpg?w=120&h=120&fit=pad)
 *
 * SMB Outdoor security camera - SimpliSafe at your business
 *
 * Security camera installed on the exterior corner of a house
 */
export const IMG_3H7DqVNTpGeqU9qlLtFJl4 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3H7DqVNTpGeqU9qlLtFJl4/d76a14f84a070e70520fed589f34ef93/9cd98cbfd8cfe7277b3d89d7bd6b135277a73622.jpg',
  description: `Security camera installed on the exterior corner of a house`,
  originalHeight: 4096,
  originalWidth: 2732
}

/**
 * ![SMB Panic button - SimpliSafe at your business](https://images.ctfassets.net/v6awd0kabi65/7Ef0lGGrx0q0cCTki2aPSz/c59e5e394a94132a6714ecdbf51d1352/ce9e0e4948a2e0da3874792a4e639661a268ba2a.png?w=120&h=120&fit=pad)
 *
 * SMB Panic button - SimpliSafe at your business
 *
 * Hand holding a remote control key fob with three buttons
 */
export const IMG_7Ef0lGGrx0q0cCTki2aPSz = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7Ef0lGGrx0q0cCTki2aPSz/c59e5e394a94132a6714ecdbf51d1352/ce9e0e4948a2e0da3874792a4e639661a268ba2a.png',
  description: `Hand holding a remote control key fob with three buttons`,
  originalHeight: 1936,
  originalWidth: 2736
}

/**
 * ![SMB Panic button - SimpliSafe at your business](https://images.ctfassets.net/v6awd0kabi65/6C4Lu3INug7KqkmrjdzYvC/e85f7e4c9e9a48b6e94ce54ef6080f3c/52899844cb0d0d33bce1ddab1515d57422a20e51.png?w=120&h=120&fit=pad)
 *
 * SMB Panic button - SimpliSafe at your business
 *
 * Panic button on a table near an ATM
 */
export const IMG_6C4Lu3INug7KqkmrjdzYvC = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6C4Lu3INug7KqkmrjdzYvC/e85f7e4c9e9a48b6e94ce54ef6080f3c/52899844cb0d0d33bce1ddab1515d57422a20e51.png',
  description: `Panic button on a table near an ATM`,
  originalHeight: 1940,
  originalWidth: 2416
}

/**
 * ![SMB Water sensor - SimpliSafe at your business](https://images.ctfassets.net/v6awd0kabi65/RkVO2wLMF7zO4VvMRDLfh/8615f14a92fd919c04dd7a529d571fa9/5177eb45377ea0d95a6d7fc393c264b10e552e88.png?w=120&h=120&fit=pad)
 *
 * SMB Water sensor - SimpliSafe at your business
 *
 * null
 */
export const IMG_RkVO2wLMF7zO4VvMRDLfh = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/RkVO2wLMF7zO4VvMRDLfh/8615f14a92fd919c04dd7a529d571fa9/5177eb45377ea0d95a6d7fc393c264b10e552e88.png',
  description: `null`,
  originalHeight: 1868,
  originalWidth: 2844
}

/**
 * ![SMB Professional Monitoring](https://images.ctfassets.net/v6awd0kabi65/1Z6X5Z1mHm0HfPpt6cbI2z/1d8705f3b3b2d1f3174421be7b98d6ae/smb-professional-monitoring.jpg?w=120&h=120&fit=pad)
 *
 * SMB Professional Monitoring
 *
 * Support agents monitoring live locations on a computer screen with a map and customer data
 */
export const IMG_1Z6X5Z1mHm0HfPpt6cbI2z = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1Z6X5Z1mHm0HfPpt6cbI2z/1d8705f3b3b2d1f3174421be7b98d6ae/smb-professional-monitoring.jpg',
  description: `Support agents monitoring live locations on a computer screen with a map and customer data`,
  originalHeight: 2304,
  originalWidth: 4096
}

/**
 * ![PDP - Yard Sign Image](https://images.ctfassets.net/v6awd0kabi65/4z4LzJulb103zR9ztcM7fd/d53cbceb1f8b586177df65a899728f60/Yard_Sign_0360_F_8bit.jpg?w=120&h=120&fit=pad)
 *
 * PDP - Yard Sign Image
 *
 * A SimpliSafe yard sign in front of a home entrance. In the background is a father and son who are relaxed and happy because their house is protected.
 */
export const IMG_4z4LzJulb103zR9ztcM7fd = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4z4LzJulb103zR9ztcM7fd/d53cbceb1f8b586177df65a899728f60/Yard_Sign_0360_F_8bit.jpg',
  description: `A SimpliSafe yard sign in front of a home entrance. In the background is a father and son who are relaxed and happy because their house is protected.`,
  originalHeight: 5464,
  originalWidth: 8192
}

/**
 * ![ODCam Carousel 1](https://images.ctfassets.net/v6awd0kabi65/7mNZewPblmji2Uyn5RCZuc/0bfce72df62327710dec0f40e246fd9e/ODCam_Carousel_1.jpg?w=120&h=120&fit=pad)
 *
 * ODCam Carousel 1
 *
 *
 */
export const IMG_7mNZewPblmji2Uyn5RCZuc = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7mNZewPblmji2Uyn5RCZuc/0bfce72df62327710dec0f40e246fd9e/ODCam_Carousel_1.jpg',
  description: ``,
  originalHeight: 1553,
  originalWidth: 1968
}

/**
 * ![Wireless Outdoor Camera](https://images.ctfassets.net/v6awd0kabi65/6ZtjnlojH9K2DrKeq9J7bd/0d5224330c15eb4a483facf28e9b483a/wireless_outdoor_camera.jpg?w=120&h=120&fit=pad)
 *
 * Wireless Outdoor Camera
 *
 *
 */
export const IMG_6ZtjnlojH9K2DrKeq9J7bd = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6ZtjnlojH9K2DrKeq9J7bd/0d5224330c15eb4a483facf28e9b483a/wireless_outdoor_camera.jpg',
  description: ``,
  originalHeight: 1315,
  originalWidth: 2620
}

/**
 * ![Olympus With Background Image](https://images.ctfassets.net/v6awd0kabi65/6rzqAO9qRUQuyDrjtbrwVG/a5919d940c3680e77ce8fff097479858/image__15_.png?w=120&h=120&fit=pad)
 *
 * Olympus With Background Image
 *
 *
 */
export const IMG_6rzqAO9qRUQuyDrjtbrwVG = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6rzqAO9qRUQuyDrjtbrwVG/a5919d940c3680e77ce8fff097479858/image__15_.png',
  description: ``,
  originalHeight: 1200,
  originalWidth: 1278
}

/**
 * ![Outdoor Solar Panel (Transparent)](https://images.ctfassets.net/v6awd0kabi65/6onJ5OyxOwArx9g67MN0e6/86892db3d34cbd54b10a416347979bf5/Solar_Charger_flat_png.png?w=120&h=120&fit=pad)
 *
 * Outdoor Solar Panel (Transparent)
 *
 * Image of a solar panel on a solid white background
 */
export const IMG_6onJ5OyxOwArx9g67MN0e6 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6onJ5OyxOwArx9g67MN0e6/86892db3d34cbd54b10a416347979bf5/Solar_Charger_flat_png.png',
  description: `Image of a solar panel on a solid white background`,
  originalHeight: 3000,
  originalWidth: 4000
}

/**
 * ![Outdoor Solar Panel](https://images.ctfassets.net/v6awd0kabi65/5HxVAJwyjBwPxUfKQVsHSS/34ee965201b76fc94fe69f9546df1d28/solar.png?w=120&h=120&fit=pad)
 *
 * Outdoor Solar Panel
 *
 *
 */
export const IMG_5HxVAJwyjBwPxUfKQVsHSS = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5HxVAJwyjBwPxUfKQVsHSS/34ee965201b76fc94fe69f9546df1d28/solar.png',
  description: ``,
  originalHeight: 396,
  originalWidth: 608
}

/**
 * ![Wireless Outdoor Camera](https://images.ctfassets.net/v6awd0kabi65/4bMZrlMtMQAhoTxMRacg4f/4ba44c3f9b5c06d26a562e0394cedd43/outdoor.png?w=120&h=120&fit=pad)
 *
 * Wireless Outdoor Camera
 *
 * Image of an outdoor camera on a solid white background
 */
export const IMG_4bMZrlMtMQAhoTxMRacg4f = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4bMZrlMtMQAhoTxMRacg4f/4ba44c3f9b5c06d26a562e0394cedd43/outdoor.png',
  description: `Image of an outdoor camera on a solid white background`,
  originalHeight: 898,
  originalWidth: 898
}

/**
 * ![ODCam Carousel 2](https://images.ctfassets.net/v6awd0kabi65/49qJv1GWLIsZ1cTtnDtPNe/fd3a19f86cba65222a09dcd7b4b88844/ODCam_Carousel_2.jpg?w=120&h=120&fit=pad)
 *
 * ODCam Carousel 2
 *
 *
 */
export const IMG_49qJv1GWLIsZ1cTtnDtPNe = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/49qJv1GWLIsZ1cTtnDtPNe/fd3a19f86cba65222a09dcd7b4b88844/ODCam_Carousel_2.jpg',
  description: ``,
  originalHeight: 1553,
  originalWidth: 1968
}

/**
 * ![ODCam Carousel 3](https://images.ctfassets.net/v6awd0kabi65/3iqxdu8Oh8XUvUCIt4gGLX/111ecb8c7cadff435337c98180d8556c/ODCam_Carousel_3.jpg?w=120&h=120&fit=pad)
 *
 * ODCam Carousel 3
 *
 *
 */
export const IMG_3iqxdu8Oh8XUvUCIt4gGLX = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3iqxdu8Oh8XUvUCIt4gGLX/111ecb8c7cadff435337c98180d8556c/ODCam_Carousel_3.jpg',
  description: ``,
  originalHeight: 1553,
  originalWidth: 1968
}

/**
 * ![Olympus Outdoor Camera - Background](https://images.ctfassets.net/v6awd0kabi65/2T8WjMVGqJE9JrFnygoSB2/b0b5ac89953f209b7cf3b785b39b3f43/image__7_.png?w=120&h=120&fit=pad)
 *
 * Olympus Outdoor Camera - Background
 *
 *
 */
export const IMG_2T8WjMVGqJE9JrFnygoSB2 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2T8WjMVGqJE9JrFnygoSB2/b0b5ac89953f209b7cf3b785b39b3f43/image__7_.png',
  description: ``,
  originalHeight: 1168,
  originalWidth: 936
}

/**
 * ![ODCam Carousel 4](https://images.ctfassets.net/v6awd0kabi65/1oAM1oEpjG2fRVqY3LPh9d/62bcd183aeb15f068098adb7b2efdc99/ODCam_Carousel_4.jpg?w=120&h=120&fit=pad)
 *
 * ODCam Carousel 4
 *
 *
 */
export const IMG_1oAM1oEpjG2fRVqY3LPh9d = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1oAM1oEpjG2fRVqY3LPh9d/62bcd183aeb15f068098adb7b2efdc99/ODCam_Carousel_4.jpg',
  description: ``,
  originalHeight: 1553,
  originalWidth: 1968
}

/**
 * ![[UK] Olympus - Carousel 5 Desktop](https://images.ctfassets.net/v6awd0kabi65/5oICBCyE7vGQq6UoDzZTIK/d5a2718fe15bf737186f21bcf5029129/PDP_Carousel_5_Desktop.png?w=120&h=120&fit=pad)
 *
 * [UK] Olympus - Carousel 5 Desktop
 *
 * SimpliSafe Outdoor Camera mounted outside of a home wall warning intruders with two-way audio
 */
export const IMG_5oICBCyE7vGQq6UoDzZTIK = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5oICBCyE7vGQq6UoDzZTIK/d5a2718fe15bf737186f21bcf5029129/PDP_Carousel_5_Desktop.png',
  description: `SimpliSafe Outdoor Camera mounted outside of a home wall warning intruders with two-way audio`,
  originalHeight: 882,
  originalWidth: 1118
}

/**
 * ![Braun Install Video Thumbnail](https://images.ctfassets.net/v6awd0kabi65/RZiJF1AdBLXD3jI8a4Tg5/216f975b53fec7f38066d560534c158a/Braun_Install_Video_Thumbnail.png?w=120&h=120&fit=pad)
 *
 * Braun Install Video Thumbnail
 *
 * A black SimpliSafe Smart Lock installed on a door
 */
export const IMG_RZiJF1AdBLXD3jI8a4Tg5 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/RZiJF1AdBLXD3jI8a4Tg5/216f975b53fec7f38066d560534c158a/Braun_Install_Video_Thumbnail.png',
  description: `A black SimpliSafe Smart Lock installed on a door`,
  originalHeight: 740,
  originalWidth: 1316
}

/**
 * ![[UK] Olympus - Carousel 4 Desktop](https://images.ctfassets.net/v6awd0kabi65/7G9hoajvwcgnR76u76BtF/cefef9204e405a567ee39dee6c84a57d/PDP_Carousel_4_Desktop.png?w=120&h=120&fit=pad)
 *
 * [UK] Olympus - Carousel 4 Desktop
 *
 * SimpliSafe Outdoor Camera mounted outside of a home wall in the rain
 */
export const IMG_7G9hoajvwcgnR76u76BtF = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7G9hoajvwcgnR76u76BtF/cefef9204e405a567ee39dee6c84a57d/PDP_Carousel_4_Desktop.png',
  description: `SimpliSafe Outdoor Camera mounted outside of a home wall in the rain`,
  originalHeight: 882,
  originalWidth: 1118
}

/**
 * ![Olympus card modal](https://images.ctfassets.net/v6awd0kabi65/1fKqdNU4OCOvcDVIWjkHks/2de0d002d53ccdd366d2691f5786bdf3/Alarm_Sensors__BMS___Desktop_Modal.png?w=120&h=120&fit=pad)
 *
 * Olympus card modal
 *
 * SimpliSafe Outdoor Camera mounted outside of a home wall
 */
export const IMG_1fKqdNU4OCOvcDVIWjkHks = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1fKqdNU4OCOvcDVIWjkHks/2de0d002d53ccdd366d2691f5786bdf3/Alarm_Sensors__BMS___Desktop_Modal.png',
  description: `SimpliSafe Outdoor Camera mounted outside of a home wall`,
  originalHeight: 1168,
  originalWidth: 936
}

/**
 * ![NHW 6](https://images.ctfassets.net/v6awd0kabi65/5EtXVcjadQvDH1Y5vOnhrV/3447baae217eae7d6448c30712416bda/6.png?w=120&h=120&fit=pad)
 *
 * NHW 6
 *
 *
 */
export const IMG_5EtXVcjadQvDH1Y5vOnhrV = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5EtXVcjadQvDH1Y5vOnhrV/3447baae217eae7d6448c30712416bda/6.png',
  description: ``,
  originalHeight: 327,
  originalWidth: 512
}

/**
 * ![NHW 5](https://images.ctfassets.net/v6awd0kabi65/4SJWSsp7DHxT7Z9SfsQKUc/54172f29b2d5df2edf545ff1fe0e94d0/5.png?w=120&h=120&fit=pad)
 *
 * NHW 5
 *
 *
 */
export const IMG_4SJWSsp7DHxT7Z9SfsQKUc = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4SJWSsp7DHxT7Z9SfsQKUc/54172f29b2d5df2edf545ff1fe0e94d0/5.png',
  description: ``,
  originalHeight: 302,
  originalWidth: 512
}

/**
 * ![NHW 4](https://images.ctfassets.net/v6awd0kabi65/698wLy0EQ6lwCEI0MKR1n1/53befd04d8a63d0a36b619604a1ba88a/4.png?w=120&h=120&fit=pad)
 *
 * NHW 4
 *
 *
 */
export const IMG_698wLy0EQ6lwCEI0MKR1n1 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/698wLy0EQ6lwCEI0MKR1n1/53befd04d8a63d0a36b619604a1ba88a/4.png',
  description: ``,
  originalHeight: 371,
  originalWidth: 512
}

/**
 * ![NHW 3](https://images.ctfassets.net/v6awd0kabi65/511x6zyLRprnYOPAYjtRIq/4df418c06bb5c0ce89543faa3a3789aa/3.png?w=120&h=120&fit=pad)
 *
 * NHW 3
 *
 *
 */
export const IMG_511x6zyLRprnYOPAYjtRIq = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/511x6zyLRprnYOPAYjtRIq/4df418c06bb5c0ce89543faa3a3789aa/3.png',
  description: ``,
  originalHeight: 221,
  originalWidth: 512
}

/**
 * ![NHW 2](https://images.ctfassets.net/v6awd0kabi65/7fSc0OkE6mnr7JG9dyyG3e/543a7433d082083b7ea8f14fc074f21f/2.png?w=120&h=120&fit=pad)
 *
 * NHW 2
 *
 *
 */
export const IMG_7fSc0OkE6mnr7JG9dyyG3e = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7fSc0OkE6mnr7JG9dyyG3e/543a7433d082083b7ea8f14fc074f21f/2.png',
  description: ``,
  originalHeight: 411,
  originalWidth: 512
}

/**
 * ![NHW 1](https://images.ctfassets.net/v6awd0kabi65/41NXk4ReBvY6YIn6mvL5E7/957d427f6533d3b6bdd4ea64a2ac90ed/1.png?w=120&h=120&fit=pad)
 *
 * NHW 1
 *
 *
 */
export const IMG_41NXk4ReBvY6YIn6mvL5E7 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/41NXk4ReBvY6YIn6mvL5E7/957d427f6533d3b6bdd4ea64a2ac90ed/1.png',
  description: ``,
  originalHeight: 243,
  originalWidth: 512
}

/**
 * ![Neighbourhood Watch survey 2024: Everything you need to know](https://images.ctfassets.net/v6awd0kabi65/5vuMqZDoO1vmjtTCowAyKI/8a92963697cca3b40c1308205de998df/Untitled_design__13_.png?w=120&h=120&fit=pad)
 *
 * Neighbourhood Watch survey 2024: Everything you need to know
 *
 *
 */
export const IMG_5vuMqZDoO1vmjtTCowAyKI = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5vuMqZDoO1vmjtTCowAyKI/8a92963697cca3b40c1308205de998df/Untitled_design__13_.png',
  description: ``,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Benefits of joining Neighbourhood Watch](https://images.ctfassets.net/v6awd0kabi65/43VqKUi1H0Sszt42bX1mn6/3053c645c1b01902764dd6014ef83621/Untitled_design__11_.png?w=120&h=120&fit=pad)
 *
 * Benefits of joining Neighbourhood Watch
 *
 * Discover the key benefits of Neighbourhood Watch, from reducing crime to building stronger communities.
 */
export const IMG_43VqKUi1H0Sszt42bX1mn6 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/43VqKUi1H0Sszt42bX1mn6/3053c645c1b01902764dd6014ef83621/Untitled_design__11_.png',
  description: `Discover the key benefits of Neighbourhood Watch, from reducing crime to building stronger communities.`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![built-for-unexpected](https://images.ctfassets.net/v6awd0kabi65/19vmDYVnKy8DIX5ElyFOQ7/ae6ba207c84abcd46b5bc9094a0965f4/built-for-unexpected.jpeg?w=120&h=120&fit=pad)
 *
 * built-for-unexpected
 *
 * Image of a base station on a white background
 */
export const IMG_19vmDYVnKy8DIX5ElyFOQ7 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/19vmDYVnKy8DIX5ElyFOQ7/ae6ba207c84abcd46b5bc9094a0965f4/built-for-unexpected.jpeg',
  description: `Image of a base station on a white background`,
  originalHeight: 600,
  originalWidth: 1230
}

/**
 * ![Hero - Build my system (olympus) - Desktop](https://images.ctfassets.net/v6awd0kabi65/3JYKvKkItBmd4wwTLtWwDM/e4264b66694283fe28a609b2d037ae56/Shop_Page_Hero_Desktop.png?w=120&h=120&fit=pad)
 *
 * Hero - Build my system (olympus) - Desktop
 *
 * Image of home security sensors floating on a bright yellow background
 */
export const IMG_3JYKvKkItBmd4wwTLtWwDM = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3JYKvKkItBmd4wwTLtWwDM/e4264b66694283fe28a609b2d037ae56/Shop_Page_Hero_Desktop.png',
  description: `Image of home security sensors floating on a bright yellow background`,
  originalHeight: 1200,
  originalWidth: 1440
}

/**
 * ![Scout diagram v2 - shutter open 1@2x - 2](https://images.ctfassets.net/v6awd0kabi65/3eeSMAahD7T6jp6MN3zTKg/c45d80f4043535af344dbcb726429928/Armed__1_.png?w=120&h=120&fit=pad)
 *
 * Scout diagram v2 - shutter open 1@2x - 2
 *
 *
 */
export const IMG_3eeSMAahD7T6jp6MN3zTKg = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3eeSMAahD7T6jp6MN3zTKg/c45d80f4043535af344dbcb726429928/Armed__1_.png',
  description: ``,
  originalHeight: 1504,
  originalWidth: 1294
}

/**
 * ![SMB - Professional Monitoring - confirmation page](https://images.ctfassets.net/v6awd0kabi65/y4ISTjbxO9tTkXsKwJMfb/7c2f0a440efe7712d93c0f52d8006443/Monitoring__1_.png?w=120&h=120&fit=pad)
 *
 * SMB - Professional Monitoring - confirmation page
 *
 * Professional monitoring, from the outside in (Hero Banner, Mobile)
 */
export const IMG_y4ISTjbxO9tTkXsKwJMfb = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/y4ISTjbxO9tTkXsKwJMfb/7c2f0a440efe7712d93c0f52d8006443/Monitoring__1_.png',
  description: `Professional monitoring, from the outside in (Hero Banner, Mobile)`,
  originalHeight: 794,
  originalWidth: 1262
}

/**
 * ![Scout Easy Install](https://images.ctfassets.net/v6awd0kabi65/4hexf220TcMd7eNhxQ3PBy/a4c27f410b08289b9e9c5f589871b9c2/ImgGallery_Scout-2.jpg?w=120&h=120&fit=pad)
 *
 * Scout Easy Install
 *
 * The camera is easy to install
 */
export const IMG_4hexf220TcMd7eNhxQ3PBy = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4hexf220TcMd7eNhxQ3PBy/a4c27f410b08289b9e9c5f589871b9c2/ImgGallery_Scout-2.jpg',
  description: `The camera is easy to install`,
  originalHeight: 1552,
  originalWidth: 1968
}

/**
 * ![Scout Sensor](https://images.ctfassets.net/v6awd0kabi65/3mCiYof080trJww8v4ng0h/2380cb61ffef4dc4bdf439004e480d69/ImgGallery_Scout-main.jpg?w=120&h=120&fit=pad)
 *
 * Scout Sensor
 *
 * Shows the camera armed with status light on signaling that motion is detected and that video is recording
 */
export const IMG_3mCiYof080trJww8v4ng0h = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3mCiYof080trJww8v4ng0h/2380cb61ffef4dc4bdf439004e480d69/ImgGallery_Scout-main.jpg',
  description: `Shows the camera armed with status light on signaling that motion is detected and that video is recording`,
  originalHeight: 1552,
  originalWidth: 1968
}

/**
 * ![Scout Compact Size](https://images.ctfassets.net/v6awd0kabi65/2h3EvvXnUqEA6u8BW8a8p8/4345e7f54768e40ebc098b4144fd281f/ImgGallery_Scout-4.jpg?w=120&h=120&fit=pad)
 *
 * Scout Compact Size
 *
 * The camera is compact and is shown on a shell with other small decor
 */
export const IMG_2h3EvvXnUqEA6u8BW8a8p8 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2h3EvvXnUqEA6u8BW8a8p8/4345e7f54768e40ebc098b4144fd281f/ImgGallery_Scout-4.jpg',
  description: `The camera is compact and is shown on a shell with other small decor`,
  originalHeight: 1552,
  originalWidth: 1968
}

/**
 * ![SMB Confirmation Banner - Desktop](https://images.ctfassets.net/v6awd0kabi65/2cU7G4S2oJWnZlBWjX2jPs/f9c440e7d3cf97998487f56f8459f42c/Submission_Success_Hero_Desktop.jpg?w=120&h=120&fit=pad)
 *
 * SMB Confirmation Banner - Desktop
 *
 *
 */
export const IMG_2cU7G4S2oJWnZlBWjX2jPs = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2cU7G4S2oJWnZlBWjX2jPs/f9c440e7d3cf97998487f56f8459f42c/Submission_Success_Hero_Desktop.jpg',
  description: ``,
  originalHeight: 2400,
  originalWidth: 5248
}

/**
 * ![Scout Mounting Options](https://images.ctfassets.net/v6awd0kabi65/24aUHDyMpdvssuzLdRi1lL/fcdf0327d049a9fe312cdb6285435b30/ImgGallery_Scout-3.jpg?w=120&h=120&fit=pad)
 *
 * Scout Mounting Options
 *
 * There are various mounting options such as standing it on a table or mounting it on a wall
 */
export const IMG_24aUHDyMpdvssuzLdRi1lL = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/24aUHDyMpdvssuzLdRi1lL/fcdf0327d049a9fe312cdb6285435b30/ImgGallery_Scout-3.jpg',
  description: `There are various mounting options such as standing it on a table or mounting it on a wall`,
  originalHeight: 1552,
  originalWidth: 1968
}

/**
 * ![SMB Confirmation Banner - Mobile](https://images.ctfassets.net/v6awd0kabi65/1yIPderlp9VdEJ0GBeQg1O/677e7e0fec7b4e7b93e35fefe8475a37/Submission_Success_Hero_Mobile.png?w=120&h=120&fit=pad)
 *
 * SMB Confirmation Banner - Mobile
 *
 *
 */
export const IMG_1yIPderlp9VdEJ0GBeQg1O = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1yIPderlp9VdEJ0GBeQg1O/677e7e0fec7b4e7b93e35fefe8475a37/Submission_Success_Hero_Mobile.png',
  description: ``,
  originalHeight: 1244,
  originalWidth: 1500
}

/**
 * ![Scout Fast Charging](https://images.ctfassets.net/v6awd0kabi65/1hZbHbZRx3wO3D7fHp53o5/056675e3d93b68d9817d03371f6512c6/ImgGallery_Scout-5.jpg?w=120&h=120&fit=pad)
 *
 * Scout Fast Charging
 *
 * The camera has fast charging capabilities
 */
export const IMG_1hZbHbZRx3wO3D7fHp53o5 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1hZbHbZRx3wO3D7fHp53o5/056675e3d93b68d9817d03371f6512c6/ImgGallery_Scout-5.jpg',
  description: `The camera has fast charging capabilities `,
  originalHeight: 1552,
  originalWidth: 1968
}

/**
 * ![SMB - Complete control at your fingertips](https://images.ctfassets.net/v6awd0kabi65/6dCvluAwM1w2bbxKIoJ7rb/3b4497d4e95f05c84dd9ef20fa86b12e/Complete_Control_Desktop.png?w=120&h=120&fit=pad)
 *
 * SMB - Complete control at your fingertips
 *
 * A man in a cap interacts with a wall-mounted keypad on a wooden panel
 */
export const IMG_6dCvluAwM1w2bbxKIoJ7rb = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6dCvluAwM1w2bbxKIoJ7rb/3b4497d4e95f05c84dd9ef20fa86b12e/Complete_Control_Desktop.png',
  description: `A man in a cap interacts with a wall-mounted keypad on a wooden panel`,
  originalHeight: 1200,
  originalWidth: 2604
}

/**
 * ![SMB - Professional Monitoring - Installation](https://images.ctfassets.net/v6awd0kabi65/4ckpjMLRtMokEIPdVJAURP/311035db4d09e7360756f5d90a7bfd77/image_215.png?w=120&h=120&fit=pad)
 *
 * SMB - Professional Monitoring - Installation
 *
 * SimpliSafe agents monitoring homes in a SimpliSafe office.
 */
export const IMG_4ckpjMLRtMokEIPdVJAURP = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4ckpjMLRtMokEIPdVJAURP/311035db4d09e7360756f5d90a7bfd77/image_215.png',
  description: `SimpliSafe agents monitoring homes in a SimpliSafe office. `,
  originalHeight: 526,
  originalWidth: 638
}

/**
 * ![Smart Alarm Indoor Camera (Scout) on a Table (mobile)](https://images.ctfassets.net/v6awd0kabi65/oOVOxSMj7ebco1wNDIjNe/cf0463b644ccf7f040e30a245854c5fb/Scout_1.jpg?w=120&h=120&fit=pad)
 *
 * Smart Alarm Indoor Camera (Scout) on a Table (mobile)
 *
 * SimpliSafe Smart Alarm Indoor Camera on a wooden surface
 */
export const IMG_oOVOxSMj7ebco1wNDIjNe = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/oOVOxSMj7ebco1wNDIjNe/cf0463b644ccf7f040e30a245854c5fb/Scout_1.jpg',
  description: `SimpliSafe Smart Alarm Indoor Camera on a wooden surface`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Panic on Tile Wall (mobile)](https://images.ctfassets.net/v6awd0kabi65/3ggzTLkMp4C6KHtotx1UIy/cbd7f4ca8013b2a96fc1d1b45a2fe09e/Panic_4.jpg?w=120&h=120&fit=pad)
 *
 * Panic on Tile Wall (mobile)
 *
 * SimpliSafe Panic Button installed on tile wall with text explaining its simple wireless setup without the use of tools
 */
export const IMG_3ggzTLkMp4C6KHtotx1UIy = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3ggzTLkMp4C6KHtotx1UIy/cbd7f4ca8013b2a96fc1d1b45a2fe09e/Panic_4.jpg',
  description: `SimpliSafe Panic Button installed on tile wall with text explaining its simple wireless setup without the use of tools`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Panic on Tile Wall (desktop)](https://images.ctfassets.net/v6awd0kabi65/1eD7pw6m9DyoelrmehN3Fr/2c4f4c6304250ec968228a0893f433ae/Panic_4FW.jpg?w=120&h=120&fit=pad)
 *
 * Panic on Tile Wall (desktop)
 *
 * SimpliSafe Panic Button installed on tile wall with text explaining its simple wireless setup without the use of tools
 */
export const IMG_1eD7pw6m9DyoelrmehN3Fr = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1eD7pw6m9DyoelrmehN3Fr/2c4f4c6304250ec968228a0893f433ae/Panic_4FW.jpg',
  description: `SimpliSafe Panic Button installed on tile wall with text explaining its simple wireless setup without the use of tools`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Smart Alarm Indoor Camera (Scout) on a Table (desktop)](https://images.ctfassets.net/v6awd0kabi65/6Tned45pI0uK4lCgaAakZV/25af2d47c7a54150999fb1ceccf04121/Scout_1FW.jpg?w=120&h=120&fit=pad)
 *
 * Smart Alarm Indoor Camera (Scout) on a Table (desktop)
 *
 * SimpliSafe Smart Alarm Indoor Camera on a wooden surface
 */
export const IMG_6Tned45pI0uK4lCgaAakZV = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6Tned45pI0uK4lCgaAakZV/25af2d47c7a54150999fb1ceccf04121/Scout_1FW.jpg',
  description: `SimpliSafe Smart Alarm Indoor Camera on a wooden surface`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Entry Sensor on Window Sill (desktop)](https://images.ctfassets.net/v6awd0kabi65/5e7e6VV2XVWxnYK2G8cDNV/f1ae03d46d83096ece103197fc8fae88/Entry_1FW.jpg?w=120&h=120&fit=pad)
 *
 * Entry Sensor on Window Sill (desktop)
 *
 * SimpliSafe Entry sensor installed on window sill
 */
export const IMG_5e7e6VV2XVWxnYK2G8cDNV = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5e7e6VV2XVWxnYK2G8cDNV/f1ae03d46d83096ece103197fc8fae88/Entry_1FW.jpg',
  description: `SimpliSafe Entry sensor installed on window sill`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Entry Sensor on Window Sill (mobile)](https://images.ctfassets.net/v6awd0kabi65/1MapcyKyFDtCe5Iv2l0EhS/a75dac905af1b13da935f4d0332a8ea4/Entry_1.jpg?w=120&h=120&fit=pad)
 *
 * Entry Sensor on Window Sill (mobile)
 *
 * SimpliSafe Entry sensor installed on window sill
 */
export const IMG_1MapcyKyFDtCe5Iv2l0EhS = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1MapcyKyFDtCe5Iv2l0EhS/a75dac905af1b13da935f4d0332a8ea4/Entry_1.jpg',
  description: `SimpliSafe Entry sensor installed on window sill`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Entry Sensor attached to Entry Point with Text (mobile)](https://images.ctfassets.net/v6awd0kabi65/4yQIw6IYNulAJXZVFmI3na/d24a010fc0ec54959aebf79988668e06/Entry_2.jpg?w=120&h=120&fit=pad)
 *
 * Entry Sensor attached to Entry Point with Text (mobile)
 *
 * SimpliSafe Entry sensor attached to a entry point with text above that reads "Detects entry at windows, and doors, including sliding doors."
 */
export const IMG_4yQIw6IYNulAJXZVFmI3na = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4yQIw6IYNulAJXZVFmI3na/d24a010fc0ec54959aebf79988668e06/Entry_2.jpg',
  description: `SimpliSafe Entry sensor attached to a entry point with text above that reads "Detects entry at windows, and doors, including sliding doors."`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Entry Sensor attached to Entry Point with Text (desktop)](https://images.ctfassets.net/v6awd0kabi65/2zLquBts9XtWIpO2cuC7R8/5bb93c18d21ed7f671f551af28fb7d41/Entry_2FW.jpg?w=120&h=120&fit=pad)
 *
 * Entry Sensor attached to Entry Point with Text (desktop)
 *
 * SimpliSafe Entry sensor attached to a entry point with text above that reads "Detects entry at windows, and doors, including sliding doors."
 */
export const IMG_2zLquBts9XtWIpO2cuC7R8 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2zLquBts9XtWIpO2cuC7R8/5bb93c18d21ed7f671f551af28fb7d41/Entry_2FW.jpg',
  description: `SimpliSafe Entry sensor attached to a entry point with text above that reads "Detects entry at windows, and doors, including sliding doors."`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Entry Sensor Blueprint Graphic (desktop)](https://images.ctfassets.net/v6awd0kabi65/2yzOwejZgJN1hmorD9N3NO/924f335355a21b4b91f64cd7794b2058/Entry_3FW.jpg?w=120&h=120&fit=pad)
 *
 * Entry Sensor Blueprint Graphic (desktop)
 *
 * Blueprint of an interior and multiple Entry sensors in various window and doorways. To the right, a Entry sensor with text that explains it's trigger point with the magnet and sensor are at least 2 inches apart
 */
export const IMG_2yzOwejZgJN1hmorD9N3NO = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2yzOwejZgJN1hmorD9N3NO/924f335355a21b4b91f64cd7794b2058/Entry_3FW.jpg',
  description: `Blueprint of an interior and multiple Entry sensors in various window and doorways. To the right, a Entry sensor with text that explains it's trigger point with the magnet and sensor are at least 2 inches apart`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Entry Sensor Blueprint Graphic (mobile)](https://images.ctfassets.net/v6awd0kabi65/208XYNlFGIWzykVkSzxUxR/a4ae7747de74e3bc6d5845b4a7e34222/Entry_3.jpg?w=120&h=120&fit=pad)
 *
 * Entry Sensor Blueprint Graphic (mobile)
 *
 * Blueprint of an interior and multiple Entry sensors in various window and doorways
 */
export const IMG_208XYNlFGIWzykVkSzxUxR = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/208XYNlFGIWzykVkSzxUxR/a4ae7747de74e3bc6d5845b4a7e34222/Entry_3.jpg',
  description: `Blueprint of an interior and multiple Entry sensors in various window and doorways`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Entry Sensor with Text (mobile)](https://images.ctfassets.net/v6awd0kabi65/4I1W6pu6KxImzwnHZQc2L8/294a227f191681ed028f27bb659e29d0/Entry_4.jpg?w=120&h=120&fit=pad)
 *
 * Entry Sensor with Text (mobile)
 *
 * SimpliSafe Entry sensor displayed with text above that reads "Simple wireless set up. No tools required."
 */
export const IMG_4I1W6pu6KxImzwnHZQc2L8 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4I1W6pu6KxImzwnHZQc2L8/294a227f191681ed028f27bb659e29d0/Entry_4.jpg',
  description: `SimpliSafe Entry sensor displayed with text above that reads "Simple wireless set up. No tools required."`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Entry Sensor with Text (desktop)](https://images.ctfassets.net/v6awd0kabi65/MCPcb3pRpfn1JUBQwXwaA/e4fa245b9b6af70d3429ec6f2ee98e0a/Entry_4FW.jpg?w=120&h=120&fit=pad)
 *
 * Entry Sensor with Text (desktop)
 *
 * SimpliSafe Entry sensor displayed with text above that reads "Simple wireless set up. No tools required."
 */
export const IMG_MCPcb3pRpfn1JUBQwXwaA = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/MCPcb3pRpfn1JUBQwXwaA/e4fa245b9b6af70d3429ec6f2ee98e0a/Entry_4FW.jpg',
  description: `SimpliSafe Entry sensor displayed with text above that reads "Simple wireless set up. No tools required."`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Motion Sensor in Hand (mobile)](https://images.ctfassets.net/v6awd0kabi65/4eM1r7mfLsjpe4TNKlpBgJ/1780e09646ca12d96ea15d1720fd17db/Motion_1.jpg?w=120&h=120&fit=pad)
 *
 * Motion Sensor in Hand (mobile)
 *
 * A person holding a SimpliSafe Motion sensor
 */
export const IMG_4eM1r7mfLsjpe4TNKlpBgJ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4eM1r7mfLsjpe4TNKlpBgJ/1780e09646ca12d96ea15d1720fd17db/Motion_1.jpg',
  description: `A person holding a SimpliSafe Motion sensor`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Motion Sensor in Hand (desktop)](https://images.ctfassets.net/v6awd0kabi65/4WLlhcQkFhiCKLN7vBV5t6/7724cb7f505aadf05f4705924c505547/Motion_1FW.jpg?w=120&h=120&fit=pad)
 *
 * Motion Sensor in Hand (desktop)
 *
 * A person holding a SimpliSafe Motion sensor
 */
export const IMG_4WLlhcQkFhiCKLN7vBV5t6 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4WLlhcQkFhiCKLN7vBV5t6/7724cb7f505aadf05f4705924c505547/Motion_1FW.jpg',
  description: `A person holding a SimpliSafe Motion sensor`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Motion Sensor Blueprint Illustration with Text (mobile)](https://images.ctfassets.net/v6awd0kabi65/1YnC1aFv81g3MIF6TslAEX/151cd720083d1ebfd7b8516f7750f267/Motion_2.jpg?w=120&h=120&fit=pad)
 *
 * Motion Sensor Blueprint Illustration with Text (mobile)
 *
 * Blueprint of an indoor space displaying the location of two motions sensors in separate rooms. Graphics displays it's range
 */
export const IMG_1YnC1aFv81g3MIF6TslAEX = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1YnC1aFv81g3MIF6TslAEX/151cd720083d1ebfd7b8516f7750f267/Motion_2.jpg',
  description: `Blueprint of an indoor space displaying the location of two motions sensors in separate rooms. Graphics displays it's range`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Motion Sensor Blueprint Illustration with Text (desktop)](https://images.ctfassets.net/v6awd0kabi65/45qLCT0VJSvGE7geNfGkAK/1424a12475f98b97b87ee4604ac33309/Motion_2FW.jpg?w=120&h=120&fit=pad)
 *
 * Motion Sensor Blueprint Illustration with Text (desktop)
 *
 * Blueprint of an indoor space displaying the location of two motions sensors in separate rooms. Graphics displays it's range. To the right, a Motion sensor with text and graphics to show it's 35 foot detection rage and 90 degree field of view
 */
export const IMG_45qLCT0VJSvGE7geNfGkAK = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/45qLCT0VJSvGE7geNfGkAK/1424a12475f98b97b87ee4604ac33309/Motion_2FW.jpg',
  description: `Blueprint of an indoor space displaying the location of two motions sensors in separate rooms. Graphics displays it's range. To the right, a Motion sensor with text and graphics to show it's 35 foot detection rage and 90 degree field of view`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Motion Sensor Dog with Text (mobile)](https://images.ctfassets.net/v6awd0kabi65/3mYjfwiEN9m5yH1IUdBe1/455a3515bf05208cf1889b78c0cf1d5b/Motion_3.jpg?w=120&h=120&fit=pad)
 *
 * Motion Sensor Dog with Text (mobile)
 *
 * Dog walking through a room with text that reads "Fewer false alarm, Detects people, not pets."
 */
export const IMG_3mYjfwiEN9m5yH1IUdBe1 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3mYjfwiEN9m5yH1IUdBe1/455a3515bf05208cf1889b78c0cf1d5b/Motion_3.jpg',
  description: `Dog walking through a room with text that reads "Fewer false alarm, Detects people, not pets."`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Motion Sensor Dog with Text (desktop)](https://images.ctfassets.net/v6awd0kabi65/70r469b1cWsn3EWLIVocS9/d957f149039a4f6fe07a561cf79c4f7c/Motion_3FW.jpg?w=120&h=120&fit=pad)
 *
 * Motion Sensor Dog with Text (desktop)
 *
 * Dog walking through a room with text that reads "Fewer false alarm, Detects people, not pets."
 */
export const IMG_70r469b1cWsn3EWLIVocS9 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/70r469b1cWsn3EWLIVocS9/d957f149039a4f6fe07a561cf79c4f7c/Motion_3FW.jpg',
  description: `Dog walking through a room with text that reads "Fewer false alarm, Detects people, not pets."`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Motion Sensor Simple Setup with Text (desktop)](https://images.ctfassets.net/v6awd0kabi65/4FLJgWabhpSXogWNNCIRlC/c0dd3d254196529fb80f98c7e9cdf94f/Motion_4FW.jpg?w=120&h=120&fit=pad)
 *
 * Motion Sensor Simple Setup with Text (desktop)
 *
 * The backside of the SimpliSafe Motion sensor in the hand of someone peeling off the 3M protective film. Text above reads "Simple wireless setup. No tools required."
 */
export const IMG_4FLJgWabhpSXogWNNCIRlC = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4FLJgWabhpSXogWNNCIRlC/c0dd3d254196529fb80f98c7e9cdf94f/Motion_4FW.jpg',
  description: `The backside of the SimpliSafe Motion sensor in the hand of someone peeling off the 3M protective film. Text above reads "Simple wireless setup. No tools required."`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Motion Sensor Simple Setup with Text (mobile)](https://images.ctfassets.net/v6awd0kabi65/1F7G1W3yjYCiFD47hnFb2Q/eceef4b5214b39c5733d613ef73503a8/Motion_4.jpg?w=120&h=120&fit=pad)
 *
 * Motion Sensor Simple Setup with Text (mobile)
 *
 * The backside of the SimpliSafe Motion sensor in the hand of someone peeling off the 3M protective film. Text above reads "Simple wireless setup. No tools required."
 */
export const IMG_1F7G1W3yjYCiFD47hnFb2Q = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1F7G1W3yjYCiFD47hnFb2Q/eceef4b5214b39c5733d613ef73503a8/Motion_4.jpg',
  description: `The backside of the SimpliSafe Motion sensor in the hand of someone peeling off the 3M protective film. Text above reads "Simple wireless setup. No tools required."`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Glassbreak Sensor Display in the Shade (desktop)](https://images.ctfassets.net/v6awd0kabi65/28EASpaJZS4dihYRkALTOt/dff0f3d37e56b349797060e89ec0a419/Glassbreak_1FW.jpg?w=120&h=120&fit=pad)
 *
 * Glassbreak Sensor Display in the Shade (desktop)
 *
 * SimpliSafe Glassbreak sensor displayed on a table top
 */
export const IMG_28EASpaJZS4dihYRkALTOt = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/28EASpaJZS4dihYRkALTOt/dff0f3d37e56b349797060e89ec0a419/Glassbreak_1FW.jpg',
  description: `SimpliSafe Glassbreak sensor displayed on a table top`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Glassbreak Sensor Display in the Shade (mobile)](https://images.ctfassets.net/v6awd0kabi65/7oZjj1Brkuwg5Ns7wy8obI/696379e1f2c7ed3f97cfbe252d4f1634/Glassbreak_1.jpg?w=120&h=120&fit=pad)
 *
 * Glassbreak Sensor Display in the Shade (mobile)
 *
 * SimpliSafe Glassbreak sensor displayed on a table top
 */
export const IMG_7oZjj1Brkuwg5Ns7wy8obI = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7oZjj1Brkuwg5Ns7wy8obI/696379e1f2c7ed3f97cfbe252d4f1634/Glassbreak_1.jpg',
  description: `SimpliSafe Glassbreak sensor displayed on a table top`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Glassbreak Sensor Blueprint Illustration with Text (mobile)](https://images.ctfassets.net/v6awd0kabi65/15Y0g6V0QwxUP4EJ6S3wE2/227062853cf9ccbcc754c4983972a57c/Glassbreak_3.jpg?w=120&h=120&fit=pad)
 *
 * Glassbreak Sensor Blueprint Illustration with Text (mobile)
 *
 * Illustration of an indoor blueprint showing the location and coverage of the Glassbreak sensor. Text above reads "One sensor protects rooms with several vulnerable glass windows or doors."
 */
export const IMG_15Y0g6V0QwxUP4EJ6S3wE2 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/15Y0g6V0QwxUP4EJ6S3wE2/227062853cf9ccbcc754c4983972a57c/Glassbreak_3.jpg',
  description: `Illustration of an indoor blueprint showing the location and coverage of the Glassbreak sensor. Text above reads "One sensor protects rooms with several vulnerable glass windows or doors."`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Glassbreak Sensor Blueprint Illustration with Text (desktop)](https://images.ctfassets.net/v6awd0kabi65/014I1kXgA9ZrVic9wLaChN/791c9cb128ab1756fcc8f24b3d886274/Glassbreak_3FW.jpg?w=120&h=120&fit=pad)
 *
 * Glassbreak Sensor Blueprint Illustration with Text (desktop)
 *
 * Illustration of an indoor blueprint showing the location and coverage of the Glassbreak sensor. Text above reads "One sensor protects rooms with several vulnerable glass windows or doors.". The the right, a Glassbreak sensor is displayed with info text that explains it's 20 foot listening range
 */
export const IMG_014I1kXgA9ZrVic9wLaChN = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/014I1kXgA9ZrVic9wLaChN/791c9cb128ab1756fcc8f24b3d886274/Glassbreak_3FW.jpg',
  description: `Illustration of an indoor blueprint showing the location and coverage of the Glassbreak sensor. Text above reads "One sensor protects rooms with several vulnerable glass windows or doors.". The the right, a Glassbreak sensor is displayed with info text that explains it's 20 foot listening range`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Glassbreak Sensor Near Broken Glass with Text (mobile)](https://images.ctfassets.net/v6awd0kabi65/3WrTTpSV8IQNirlIZYjGHm/04bc06d5043e0c170f6d331ad4d3cdc3/Glassbreak_2.jpg?w=120&h=120&fit=pad)
 *
 * Glassbreak Sensor Near Broken Glass with Text (mobile)
 *
 * SimpliSafe Glassbreak sensor on a wooden surface near broken glass. Text above reads "Picks up the sounds of smashed windows, not dropped plates."
 */
export const IMG_3WrTTpSV8IQNirlIZYjGHm = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3WrTTpSV8IQNirlIZYjGHm/04bc06d5043e0c170f6d331ad4d3cdc3/Glassbreak_2.jpg',
  description: `SimpliSafe Glassbreak sensor on a wooden surface near broken glass. Text above reads "Picks up the sounds of smashed windows, not dropped plates."`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Glassbreak Sensor Near Broken Glass with Text (desktop)](https://images.ctfassets.net/v6awd0kabi65/5U3Bq9J8pQDYwJeSs9nM5Z/558729b334e61ca7d8af44cb0f7e3737/Glassbreak_2FW.jpg?w=120&h=120&fit=pad)
 *
 * Glassbreak Sensor Near Broken Glass with Text (desktop)
 *
 * SimpliSafe Glassbreak sensor on a wooden surface near broken glass. Text above reads "Picks up the sounds of smashed windows, not dropped plates."
 */
export const IMG_5U3Bq9J8pQDYwJeSs9nM5Z = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5U3Bq9J8pQDYwJeSs9nM5Z/558729b334e61ca7d8af44cb0f7e3737/Glassbreak_2FW.jpg',
  description: `SimpliSafe Glassbreak sensor on a wooden surface near broken glass. Text above reads "Picks up the sounds of smashed windows, not dropped plates."`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Glassbreak Sensor Table Display with Text (mobile)](https://images.ctfassets.net/v6awd0kabi65/6l8cdQ2ugO7Uay5ZcbzYJC/d92c164a42497cbde8df8fe6550ad175/Glassbreak_4.jpg?w=120&h=120&fit=pad)
 *
 * Glassbreak Sensor Table Display with Text (mobile)
 *
 * SimpliSafe Glassbreak sensor displayed on a table with multiple glass vases. Text above reads "Simple wireless setup. Mount it on a wall or set it on a shelf."
 */
export const IMG_6l8cdQ2ugO7Uay5ZcbzYJC = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6l8cdQ2ugO7Uay5ZcbzYJC/d92c164a42497cbde8df8fe6550ad175/Glassbreak_4.jpg',
  description: `SimpliSafe Glassbreak sensor displayed on a table with multiple glass vases. Text above reads "Simple wireless setup. Mount it on a wall or set it on a shelf."`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Glassbreak Sensor Table Display with Text (desktop)](https://images.ctfassets.net/v6awd0kabi65/3H5pWRh4UzmUTaWN97ds0m/3b09c16f69071ab2959fa1fd13691c38/Glassbreak_4FW.jpg?w=120&h=120&fit=pad)
 *
 * Glassbreak Sensor Table Display with Text (desktop)
 *
 * SimpliSafe Glassbreak sensor displayed on a table with multiple glass vases. Text above reads "Simple wireless setup. Mount it on a wall or set it on a shelf."
 */
export const IMG_3H5pWRh4UzmUTaWN97ds0m = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3H5pWRh4UzmUTaWN97ds0m/3b09c16f69071ab2959fa1fd13691c38/Glassbreak_4FW.jpg',
  description: `SimpliSafe Glassbreak sensor displayed on a table with multiple glass vases. Text above reads "Simple wireless setup. Mount it on a wall or set it on a shelf."`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Base Station on a Table (mobile)](https://images.ctfassets.net/v6awd0kabi65/3V6n5v3fD677Dp3G2rHzo4/f7354bcfd16571cff4f15812bef19a79/Base_1.jpg?w=120&h=120&fit=pad)
 *
 * Base Station on a Table (mobile)
 *
 * SimpliSafe Base Station on a table in front of a couch
 */
export const IMG_3V6n5v3fD677Dp3G2rHzo4 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3V6n5v3fD677Dp3G2rHzo4/f7354bcfd16571cff4f15812bef19a79/Base_1.jpg',
  description: `SimpliSafe Base Station on a table in front of a couch`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Base Station on a Table (desktop)](https://images.ctfassets.net/v6awd0kabi65/3q4EaWYF186TnGdieAd9Qr/3a8022c4d63c0882b338b919137c94db/Base_1FW.jpg?w=120&h=120&fit=pad)
 *
 * Base Station on a Table (desktop)
 *
 * SimpliSafe Base Station on a table in front of a couch
 */
export const IMG_3q4EaWYF186TnGdieAd9Qr = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3q4EaWYF186TnGdieAd9Qr/3a8022c4d63c0882b338b919137c94db/Base_1FW.jpg',
  description: `SimpliSafe Base Station on a table in front of a couch`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Base Station Info Graphic Meet the Brains (mobile)](https://images.ctfassets.net/v6awd0kabi65/7bO3RmhgX2GIzpRvKvWtuA/43ebfe70c3e9cb82700118df741f0638/Base_2.jpg?w=120&h=120&fit=pad)
 *
 * Base Station Info Graphic Meet the Brains (mobile)
 *
 * SimpliSafe Base Station graphic with text that explains some of the features of the Base Station
 */
export const IMG_7bO3RmhgX2GIzpRvKvWtuA = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7bO3RmhgX2GIzpRvKvWtuA/43ebfe70c3e9cb82700118df741f0638/Base_2.jpg',
  description: `SimpliSafe Base Station graphic with text that explains some of the features of the Base Station`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Base Station Info Graphic Meet the Brains (desktop)](https://images.ctfassets.net/v6awd0kabi65/z2sVTtwBtGueU1vgCENKp/3292dc7cea09d0d856d15845b6442af5/Base_2FW.jpg?w=120&h=120&fit=pad)
 *
 * Base Station Info Graphic Meet the Brains (desktop)
 * 
 * SimpliSafe Base Station graphic with text that explains some of the features of the Base Station

 */
export const IMG_z2sVTtwBtGueU1vgCENKp = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/z2sVTtwBtGueU1vgCENKp/3292dc7cea09d0d856d15845b6442af5/Base_2FW.jpg',
  description: `SimpliSafe Base Station graphic with text that explains some of the features of the Base Station
`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Base Station Info Graphic (mobile)](https://images.ctfassets.net/v6awd0kabi65/2N1fRs7czzENCBdrAWE0C8/63a16dafc60d36df67b6e61f26bea778/Base_3.jpg?w=120&h=120&fit=pad)
 *
 * Base Station Info Graphic (mobile)
 *
 * SimpliSafe Base Station on a shelf. The text explains the Base Stations ability to protect even when the power goes out
 */
export const IMG_2N1fRs7czzENCBdrAWE0C8 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2N1fRs7czzENCBdrAWE0C8/63a16dafc60d36df67b6e61f26bea778/Base_3.jpg',
  description: `SimpliSafe Base Station on a shelf. The text explains the Base Stations ability to protect even when the power goes out`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Base Station Info Graphic (desktop)](https://images.ctfassets.net/v6awd0kabi65/1P7afJ2a1tNW1QUAIIJmjE/72613472e6c5d1e25ca73b6602e6bdff/Base_3FW.jpg?w=120&h=120&fit=pad)
 *
 * Base Station Info Graphic (desktop)
 *
 * SimpliSafe Base Station on a shelf. The text explains the Base Stations ability to protect even when the power goes out
 */
export const IMG_1P7afJ2a1tNW1QUAIIJmjE = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1P7afJ2a1tNW1QUAIIJmjE/72613472e6c5d1e25ca73b6602e6bdff/Base_3FW.jpg',
  description: `SimpliSafe Base Station on a shelf. The text explains the Base Stations ability to protect even when the power goes out`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Base Station Top-Down View with Text (mobile)](https://images.ctfassets.net/v6awd0kabi65/5ISYV36U9GuFOq6vFNELYQ/130e885a3c0fbfd99dcbfa36dc0b5aad/Base_4.jpg?w=120&h=120&fit=pad)
 *
 * Base Station Top-Down View with Text (mobile)
 *
 * SimpliSafe Base Station on a table from a top down perspective with text that reads "Sounds an alarm using a built-in 100 decibel siren."
 */
export const IMG_5ISYV36U9GuFOq6vFNELYQ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5ISYV36U9GuFOq6vFNELYQ/130e885a3c0fbfd99dcbfa36dc0b5aad/Base_4.jpg',
  description: `SimpliSafe Base Station on a table from a top down perspective with text that reads "Sounds an alarm using a built-in 100 decibel siren."`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Base Station Top-Down View with Text (desktop)](https://images.ctfassets.net/v6awd0kabi65/7Dd1BPpHSKxIxMu6Fs1n9t/083f6a07a0a9bbd79f298b9f902185b2/Base_4FW.jpg?w=120&h=120&fit=pad)
 *
 * Base Station Top-Down View with Text (desktop)
 *
 * SimpliSafe Base Station on a table from a top down perspective with text that reads "Sounds an alarm using a built-in 100 decibel siren."
 */
export const IMG_7Dd1BPpHSKxIxMu6Fs1n9t = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7Dd1BPpHSKxIxMu6Fs1n9t/083f6a07a0a9bbd79f298b9f902185b2/Base_4FW.jpg',
  description: `SimpliSafe Base Station on a table from a top down perspective with text that reads "Sounds an alarm using a built-in 100 decibel siren."`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Extra Keypad Mounted Display (desktop)](https://images.ctfassets.net/v6awd0kabi65/3aPkiIJEDi50Yy0VNgT0g8/8d687fa7b5fa108ec1b5946d8149f497/Keypad_1FW.jpg?w=120&h=120&fit=pad)
 *
 * Extra Keypad Mounted Display (desktop)
 *
 * SimpliSafe Keypad mounted on a wall near the kitchen
 */
export const IMG_3aPkiIJEDi50Yy0VNgT0g8 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3aPkiIJEDi50Yy0VNgT0g8/8d687fa7b5fa108ec1b5946d8149f497/Keypad_1FW.jpg',
  description: `SimpliSafe Keypad mounted on a wall near the kitchen`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Extra Keypad Mounted Display (mobile)](https://images.ctfassets.net/v6awd0kabi65/7DB7oLzN8qzYRoWQDJVy2k/8594be2efc7d81055b724901270f0c38/Keypad_1.jpg?w=120&h=120&fit=pad)
 *
 * Extra Keypad Mounted Display (mobile)
 *
 * SimpliSafe Keypad mounted on a wall near the kitchen
 */
export const IMG_7DB7oLzN8qzYRoWQDJVy2k = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7DB7oLzN8qzYRoWQDJVy2k/8594be2efc7d81055b724901270f0c38/Keypad_1.jpg',
  description: `SimpliSafe Keypad mounted on a wall near the kitchen`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Extra Keypad One Touch with Text (mobile)](https://images.ctfassets.net/v6awd0kabi65/1SH65B2Gk4tFQSi3cNctLh/3c624852d9a2932cd9592f32382192bb/Keypad_2.jpg?w=120&h=120&fit=pad)
 *
 * Extra Keypad One Touch with Text (mobile)
 *
 * SimpliSafe Extra Keypad mounted on wall. Text above reads "Get an extra wireless keypad for one-touch control in more places."
 */
export const IMG_1SH65B2Gk4tFQSi3cNctLh = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1SH65B2Gk4tFQSi3cNctLh/3c624852d9a2932cd9592f32382192bb/Keypad_2.jpg',
  description: `SimpliSafe Extra Keypad mounted on wall. Text above reads "Get an extra wireless keypad for one-touch control in more places."`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Extra Keypad One Touch with Text (desktop)](https://images.ctfassets.net/v6awd0kabi65/2rO188Xu9wPQVDnbjMgKfo/cbd0a6571d20a88315ec9e5cea772b50/Keypad_2FW.jpg?w=120&h=120&fit=pad)
 *
 * Extra Keypad One Touch with Text (desktop)
 *
 * SimpliSafe Extra Keypad mounted on wall. Text above reads "Get an extra wireless keypad for one-touch control in more places."
 */
export const IMG_2rO188Xu9wPQVDnbjMgKfo = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2rO188Xu9wPQVDnbjMgKfo/cbd0a6571d20a88315ec9e5cea772b50/Keypad_2FW.jpg',
  description: `SimpliSafe Extra Keypad mounted on wall. Text above reads "Get an extra wireless keypad for one-touch control in more places."`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Extra Keypad with Text (mobile)](https://images.ctfassets.net/v6awd0kabi65/2SeaPJnzi7ay8BRM8wUYqr/39f8e04d8d892a99f8a8579a6890429b/Keypad_4.jpg?w=120&h=120&fit=pad)
 *
 * Extra Keypad with Text (mobile)
 *
 * SimpliSafe Keypad with text that reads "Includes a hidden panic button."
 */
export const IMG_2SeaPJnzi7ay8BRM8wUYqr = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2SeaPJnzi7ay8BRM8wUYqr/39f8e04d8d892a99f8a8579a6890429b/Keypad_4.jpg',
  description: `SimpliSafe Keypad with text that reads "Includes a hidden panic button."`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Extra Keypad with Text (desktop)](https://images.ctfassets.net/v6awd0kabi65/7qKHYwsRjk0rhOuUiMjOn6/b7349263da15263342f46cbdb47b3c7e/Keypad_4FW.jpg?w=120&h=120&fit=pad)
 *
 * Extra Keypad with Text (desktop)
 *
 * SimpliSafe Keypad with text that reads "Includes a hidden panic button."
 */
export const IMG_7qKHYwsRjk0rhOuUiMjOn6 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7qKHYwsRjk0rhOuUiMjOn6/b7349263da15263342f46cbdb47b3c7e/Keypad_4FW.jpg',
  description: `SimpliSafe Keypad with text that reads "Includes a hidden panic button."`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Outdoor Camera (Olympus) Mounted Outside Daytime (mobile)](https://images.ctfassets.net/v6awd0kabi65/2sXS2LlVD203p554A12Hkx/e3bbbe3b811d5f02728773eccb647878/Olympus_1.jpg?w=120&h=120&fit=pad)
 *
 * Outdoor Camera (Olympus) Mounted Outside Daytime (mobile)
 *
 * SimpliSafe Outdoor Camera mounted outside of a home wall
 */
export const IMG_2sXS2LlVD203p554A12Hkx = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2sXS2LlVD203p554A12Hkx/e3bbbe3b811d5f02728773eccb647878/Olympus_1.jpg',
  description: `SimpliSafe Outdoor Camera mounted outside of a home wall`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Outdoor Camera (Olympus) Mounted Outside Daytime (desktop)](https://images.ctfassets.net/v6awd0kabi65/2UyAED8NRFLTNzhy13IzxX/8cec50ec5dd9753538d9f6c1b5472007/Olympus_1FW.jpg?w=120&h=120&fit=pad)
 *
 * Outdoor Camera (Olympus) Mounted Outside Daytime (desktop)
 *
 * SimpliSafe Outdoor Camera mounted outside of a home wall
 */
export const IMG_2UyAED8NRFLTNzhy13IzxX = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2UyAED8NRFLTNzhy13IzxX/8cec50ec5dd9753538d9f6c1b5472007/Olympus_1FW.jpg',
  description: `SimpliSafe Outdoor Camera mounted outside of a home wall`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Outdoor Camera (Olympus) Active Guard Illustration (desktop)](https://images.ctfassets.net/v6awd0kabi65/58S8cQS8rLSsb3MwdhWYG5/5be783214ade3d1c8c698a454bc8a71f/Olympus_2FW.jpg?w=120&h=120&fit=pad)
 *
 * Outdoor Camera (Olympus) Active Guard Illustration (desktop)
 *
 * Illustration of a SimpliSafe Active Guard agent speaking to an intruder through the Outdoor Camera speaker. Text above explains that by enabling SimpliSafe Active Guard Outdoor Protection, with select monitoring plans, agents can see and speak through the Outdoor Camera to help prevent crime before it happens
 */
export const IMG_58S8cQS8rLSsb3MwdhWYG5 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/58S8cQS8rLSsb3MwdhWYG5/5be783214ade3d1c8c698a454bc8a71f/Olympus_2FW.jpg',
  description: `Illustration of a SimpliSafe Active Guard agent speaking to an intruder through the Outdoor Camera speaker. Text above explains that by enabling SimpliSafe Active Guard Outdoor Protection, with select monitoring plans, agents can see and speak through the Outdoor Camera to help prevent crime before it happens`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Outdoor Camera (Olympus) Active Guard Illustration (mobile)](https://images.ctfassets.net/v6awd0kabi65/39zfeuitnkPzi3kGol6u7e/054886004cb5b6b7b0c6cf8d791cb851/Olympus_2.jpg?w=120&h=120&fit=pad)
 *
 * Outdoor Camera (Olympus) Active Guard Illustration (mobile)
 *
 * Illustration of an intruder outside of a home holding a metal tool standing in front of an Outdoor Camera with graphics displaying sound coming from its built in speakers
 */
export const IMG_39zfeuitnkPzi3kGol6u7e = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/39zfeuitnkPzi3kGol6u7e/054886004cb5b6b7b0c6cf8d791cb851/Olympus_2.jpg',
  description: `Illustration of an intruder outside of a home holding a metal tool standing in front of an Outdoor Camera with graphics displaying sound coming from its built in speakers`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Outdoor Camera (Olympus) Mounted Outside (mobile)](https://images.ctfassets.net/v6awd0kabi65/2UuoAAm194ACOHtbrXWTYh/65834c22dadc39c8a50d73cf4ceccbf2/Olympus_3.jpg?w=120&h=120&fit=pad)
 *
 * Outdoor Camera (Olympus) Mounted Outside (mobile)
 *
 * SimpliSafe Outdoor Camera mounted outside of a house
 */
export const IMG_2UuoAAm194ACOHtbrXWTYh = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2UuoAAm194ACOHtbrXWTYh/65834c22dadc39c8a50d73cf4ceccbf2/Olympus_3.jpg',
  description: `SimpliSafe Outdoor Camera mounted outside of a house`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Outdoor Camera (Olympus) Mounted Outside (desktop)](https://images.ctfassets.net/v6awd0kabi65/4gacZ6kDq2ygy763jslzYF/1d1face09b40d0cbf6ff7a2108bfe7f0/Olympus_3FW.jpg?w=120&h=120&fit=pad)
 *
 * Outdoor Camera (Olympus) Mounted Outside (desktop)
 *
 * Three panel image. Left panel is the Outdoor Camera plugged into to an outdoor outlet. The right panel is the SimpliSafe Outdoor Camera mounted outside of a house. The bottom panel is text that reads "Camera must be plugged in to use SimpliSafe Active Guard Outdoor Protection."
 */
export const IMG_4gacZ6kDq2ygy763jslzYF = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4gacZ6kDq2ygy763jslzYF/1d1face09b40d0cbf6ff7a2108bfe7f0/Olympus_3FW.jpg',
  description: `Three panel image. Left panel is the Outdoor Camera plugged into to an outdoor outlet. The right panel is the SimpliSafe Outdoor Camera mounted outside of a house. The bottom panel is text that reads "Camera must be plugged in to use SimpliSafe Active Guard Outdoor Protection."`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Outdoor Camera (Olympus) Mounted (mobile)](https://images.ctfassets.net/v6awd0kabi65/1kaBm0rdLXPczfNQScZXgh/1fca70b7ae0ae725fcd3df66361a9659/Olympus_4.jpg?w=120&h=120&fit=pad)
 *
 * Outdoor Camera (Olympus) Mounted (mobile)
 *
 * SimpliSafe Outdoor Camera mounted outside on house wall with the built in camera spotlight turned on
 */
export const IMG_1kaBm0rdLXPczfNQScZXgh = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1kaBm0rdLXPczfNQScZXgh/1fca70b7ae0ae725fcd3df66361a9659/Olympus_4.jpg',
  description: `SimpliSafe Outdoor Camera mounted outside on house wall with the built in camera spotlight turned on`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Outdoor Camera (Olympus) Mounted (desktop)](https://images.ctfassets.net/v6awd0kabi65/3QvODb1xNusplEbd6Mqopv/fe2ecf98dff906b1d995ce50783fd20f/Olympus_4FW.jpg?w=120&h=120&fit=pad)
 *
 * Outdoor Camera (Olympus) Mounted (desktop)
 *
 * SimpliSafe Outdoor Camera mounted outside on house wall with the built in camera spotlight turned on. Text bellow reads "Bright spotlight can deter trespassers."
 */
export const IMG_3QvODb1xNusplEbd6Mqopv = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3QvODb1xNusplEbd6Mqopv/fe2ecf98dff906b1d995ce50783fd20f/Olympus_4FW.jpg',
  description: `SimpliSafe Outdoor Camera mounted outside on house wall with the built in camera spotlight turned on. Text bellow reads "Bright spotlight can deter trespassers."`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Video Doorbell Pro in Use (desktop)](https://images.ctfassets.net/v6awd0kabi65/63tIrRQtXvf3q7vfSiCOAE/ed06e4e4ad2336f2c14dae596f59ebde/Doorbell_1FW.jpg?w=120&h=120&fit=pad)
 *
 * Video Doorbell Pro in Use (desktop)
 *
 * SimpliSafe Video Doorbell Pro installed on wall with a person pressing the doorbell button
 */
export const IMG_63tIrRQtXvf3q7vfSiCOAE = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/63tIrRQtXvf3q7vfSiCOAE/ed06e4e4ad2336f2c14dae596f59ebde/Doorbell_1FW.jpg',
  description: `SimpliSafe Video Doorbell Pro installed on wall with a person pressing the doorbell button`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Video Doorbell Pro in Use (mobile)](https://images.ctfassets.net/v6awd0kabi65/5K0SC2d2e5YNtUEyXRo7Ui/f00037efe814cf3ef024017173cce88d/Doorbell_1.jpg?w=120&h=120&fit=pad)
 *
 * Video Doorbell Pro in Use (mobile)
 *
 * SimpliSafe Video Doorbell Pro installed on wall with a person pressing the doorbell button
 */
export const IMG_5K0SC2d2e5YNtUEyXRo7Ui = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5K0SC2d2e5YNtUEyXRo7Ui/f00037efe814cf3ef024017173cce88d/Doorbell_1.jpg',
  description: `SimpliSafe Video Doorbell Pro installed on wall with a person pressing the doorbell button`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Video Doorbell Pro Smartphone App with Text (mobile)](https://images.ctfassets.net/v6awd0kabi65/5ZMcidEwCG9copvrGXh3g3/dac3079ba9221f1303c9ff6de6a67457/Doorbell_2.jpg?w=120&h=120&fit=pad)
 *
 * Video Doorbell Pro Smartphone App with Text (mobile)
 *
 * A smartphone display that shows the video feed from the SimpliSafe Video Doorbell Pro. The video feed shows a man holding flowers at the doorstep. Text above reads "See who's at the door, even if they don't ring the bell."
 */
export const IMG_5ZMcidEwCG9copvrGXh3g3 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5ZMcidEwCG9copvrGXh3g3/dac3079ba9221f1303c9ff6de6a67457/Doorbell_2.jpg',
  description: `A smartphone display that shows the video feed from the SimpliSafe Video Doorbell Pro. The video feed shows a man holding flowers at the doorstep. Text above reads "See who's at the door, even if they don't ring the bell."`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Video Doorbell Pro Smartphone App with Text (desktop)](https://images.ctfassets.net/v6awd0kabi65/1CioZO1MPWL4FKtGfzZ3jU/4ca25987cd4b1da86a25b45488e022d8/Doorbell_2FW.jpg?w=120&h=120&fit=pad)
 *
 * Video Doorbell Pro Smartphone App with Text (desktop)
 *
 * A smartphone display that shows the video feed from the SimpliSafe Video Doorbell Pro. The video feed shows a man holding flowers at the doorstep. Text above reads "See who's at the door, even if they don't ring the bell." SimpliSafe app notifications in the foreground alerting of motion detection
 */
export const IMG_1CioZO1MPWL4FKtGfzZ3jU = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1CioZO1MPWL4FKtGfzZ3jU/4ca25987cd4b1da86a25b45488e022d8/Doorbell_2FW.jpg',
  description: `A smartphone display that shows the video feed from the SimpliSafe Video Doorbell Pro. The video feed shows a man holding flowers at the doorstep. Text above reads "See who's at the door, even if they don't ring the bell." SimpliSafe app notifications in the foreground alerting of motion detection`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Video Doorbell Pro Info Graphic (mobile)](https://images.ctfassets.net/v6awd0kabi65/7cCvjfA2epTGAMpxKAm8ao/6075dd840b98e54e33417f6bceec244f/Doorbell_3.jpg?w=120&h=120&fit=pad)
 *
 * Video Doorbell Pro Info Graphic (mobile)
 *
 * SimpliSafe Video Doorbell Pro graphic displaying the camera and it's feature set from the front
 */
export const IMG_7cCvjfA2epTGAMpxKAm8ao = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7cCvjfA2epTGAMpxKAm8ao/6075dd840b98e54e33417f6bceec244f/Doorbell_3.jpg',
  description: `SimpliSafe Video Doorbell Pro graphic displaying the camera and it's feature set from the front`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Video Doorbell Pro Info Graphic (desktop)](https://images.ctfassets.net/v6awd0kabi65/7mDaPNC4ZVTHp3r4aCD45k/08c8c9f7f2322ea9e00ef9496a1786ed/Doorbell_3FW.jpg?w=120&h=120&fit=pad)
 *
 * Video Doorbell Pro Info Graphic (desktop)
 *
 * Two panel graphic. The left panel is a SimpliSafe Video Doorbell Pro graphic displaying the camera and it's feature set from the front. the right panel explains the LED status light feature in more detail
 */
export const IMG_7mDaPNC4ZVTHp3r4aCD45k = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7mDaPNC4ZVTHp3r4aCD45k/08c8c9f7f2322ea9e00ef9496a1786ed/Doorbell_3FW.jpg',
  description: `Two panel graphic. The left panel is a SimpliSafe Video Doorbell Pro graphic displaying the camera and it's feature set from the front. the right panel explains the LED status light feature in more detail`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Video Doorbell Pro Illustration (mobile)](https://images.ctfassets.net/v6awd0kabi65/6fOcnIuIUiuUvbpDSQUjzq/27fe1e6be16ad738cd24fd6c5f8ffc3c/Doorbell_4.jpg?w=120&h=120&fit=pad)
 *
 * Video Doorbell Pro Illustration (mobile)
 *
 * Illustration of a SimpliSafe Video Doorbell alerting a user on her phone of a porch pirate approaching packages on the front door mat
 */
export const IMG_6fOcnIuIUiuUvbpDSQUjzq = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6fOcnIuIUiuUvbpDSQUjzq/27fe1e6be16ad738cd24fd6c5f8ffc3c/Doorbell_4.jpg',
  description: `Illustration of a SimpliSafe Video Doorbell alerting a user on her phone of a porch pirate approaching packages on the front door mat`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Video Doorbell Pro Illustration (desktop)](https://images.ctfassets.net/v6awd0kabi65/5N9nw1BM20pLrMeco63HBo/2243632da9138c23e7fe83ee1aeddb7a/Doorbell_4FW.jpg?w=120&h=120&fit=pad)
 *
 * Video Doorbell Pro Illustration (desktop)
 *
 * Illustration of a SimpliSafe Video Doorbell alerting a user on her phone of a porch pirate approaching packages on the front door mat
 */
export const IMG_5N9nw1BM20pLrMeco63HBo = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5N9nw1BM20pLrMeco63HBo/2243632da9138c23e7fe83ee1aeddb7a/Doorbell_4FW.jpg',
  description: `Illustration of a SimpliSafe Video Doorbell alerting a user on her phone of a porch pirate approaching packages on the front door mat`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Smart Alarm Indoor Camera (Scout) Info Graphic (mobile)](https://images.ctfassets.net/v6awd0kabi65/2pIhH1TRPEt6Z8zhAgDSf9/e7f71fbc224be60476b010f96628f15e/Scout_2.jpg?w=120&h=120&fit=pad)
 *
 * Smart Alarm Indoor Camera (Scout) Info Graphic (mobile)
 *
 * SimpliSafe Smart Alarm Indoor Camera graphic that shows multiple features of the camera
 */
export const IMG_2pIhH1TRPEt6Z8zhAgDSf9 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2pIhH1TRPEt6Z8zhAgDSf9/e7f71fbc224be60476b010f96628f15e/Scout_2.jpg',
  description: `SimpliSafe Smart Alarm Indoor Camera graphic that shows multiple features of the camera`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Smart Alarm Indoor Camera (Scout) Info Graphic (desktop)](https://images.ctfassets.net/v6awd0kabi65/8sdc3aWHC4w7ptebsSQCa/a35a2f01ed820309b08bcabe1c79a169/Scout_2FW.jpg?w=120&h=120&fit=pad)
 *
 * Smart Alarm Indoor Camera (Scout) Info Graphic (desktop)
 *
 * A two panel graphic. The left panel shows the SimpliSafe Smart Alarm Indoor Camera in an Off state and it's features while in the Off state. The right panel shows the SimpliSafe Smart Alarm Indoor Camera with multiple features of the camera while it is in it's Armed state
 */
export const IMG_8sdc3aWHC4w7ptebsSQCa = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/8sdc3aWHC4w7ptebsSQCa/a35a2f01ed820309b08bcabe1c79a169/Scout_2FW.jpg',
  description: `A two panel graphic. The left panel shows the SimpliSafe Smart Alarm Indoor Camera in an Off state and it's features while in the Off state. The right panel shows the SimpliSafe Smart Alarm Indoor Camera with multiple features of the camera while it is in it's Armed state`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Smart Alarm Indoor Camera (Scout) Agent (mobile)](https://images.ctfassets.net/v6awd0kabi65/7MOPXIfLp4xxzRuWCFlEcw/2dd4783cb92e15b0f2296d34add551c1/Scout_3.jpg?w=120&h=120&fit=pad)
 *
 * Smart Alarm Indoor Camera (Scout) Agent (mobile)
 *
 * A female SimpliSafe agent in uniform at a desk
 */
export const IMG_7MOPXIfLp4xxzRuWCFlEcw = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7MOPXIfLp4xxzRuWCFlEcw/2dd4783cb92e15b0f2296d34add551c1/Scout_3.jpg',
  description: `A female SimpliSafe agent in uniform at a desk`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Smart Alarm Indoor Camera (Scout) Agent (desktop)](https://images.ctfassets.net/v6awd0kabi65/6cGkh1QjUHV93hQXqrQiBC/087ebb1a5ee0fadab53d1982214b13a9/Scout_3FW.jpg?w=120&h=120&fit=pad)
 *
 * Smart Alarm Indoor Camera (Scout) Agent (desktop)
 *
 * A three panel image. The top panel with text that explains that with select monitoring plans agents can see and speak through the camera during an alarm to help stop crime in real time. The bottom left panel of a female SimpliSafe agent in uniform at a desk. The bottom right panel of the Smart Alarm Indoor Camera on a shelf with a red dotted circle graphic around the camera
 */
export const IMG_6cGkh1QjUHV93hQXqrQiBC = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6cGkh1QjUHV93hQXqrQiBC/087ebb1a5ee0fadab53d1982214b13a9/Scout_3FW.jpg',
  description: `A three panel image. The top panel with text that explains that with select monitoring plans agents can see and speak through the camera during an alarm to help stop crime in real time. The bottom left panel of a female SimpliSafe agent in uniform at a desk. The bottom right panel of the Smart Alarm Indoor Camera on a shelf with a red dotted circle graphic around the camera`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Smart Alarm Indoor Camera (Scout) Pet Detection with Text (desktop)](https://images.ctfassets.net/v6awd0kabi65/3MmWQgl4WpwVNruo8duOJH/f3314bd00873767fccc14042b8b3bdc1/Scout_4FW.jpg?w=120&h=120&fit=pad)
 *
 * Smart Alarm Indoor Camera (Scout) Pet Detection with Text (desktop)
 *
 * SimpliSafe Smart Alarm Indoor Camera detecting a dog with a green square outlining the dog in frame. Text above reads "Fewer false alarms with advanced motion detection."
 */
export const IMG_3MmWQgl4WpwVNruo8duOJH = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3MmWQgl4WpwVNruo8duOJH/f3314bd00873767fccc14042b8b3bdc1/Scout_4FW.jpg',
  description: `SimpliSafe Smart Alarm Indoor Camera detecting a dog with a green square outlining the dog in frame. Text above reads "Fewer false alarms with advanced motion detection."`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Smart Alarm Indoor Camera (Scout) Pet Detection with Text (mobile)](https://images.ctfassets.net/v6awd0kabi65/4M1vHbMVMUL1UoTKdNhxZX/72448900d277bd8054228b6ee3fdfc8f/Scout_4.jpg?w=120&h=120&fit=pad)
 *
 * Smart Alarm Indoor Camera (Scout) Pet Detection with Text (mobile)
 *
 * SimpliSafe Smart Alarm Indoor Camera detecting a dog with a green square outlining the dog in frame. Text above reads "Fewer false alarms with advanced motion detection."
 */
export const IMG_4M1vHbMVMUL1UoTKdNhxZX = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4M1vHbMVMUL1UoTKdNhxZX/72448900d277bd8054228b6ee3fdfc8f/Scout_4.jpg',
  description: `SimpliSafe Smart Alarm Indoor Camera detecting a dog with a green square outlining the dog in frame. Text above reads "Fewer false alarms with advanced motion detection."`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Key Pad on Wall with Text (mobile)](https://images.ctfassets.net/v6awd0kabi65/e7NYHcwONUCmjsUsZGiFY/5018d51ae2c236cf0259863da46b9626/Keypad_3.jpg?w=120&h=120&fit=pad)
 *
 * Key Pad on Wall with Text (mobile)
 *
 * SimpliSafe Key Pad installed on a wall with a finger on a button lighting up the display. Text above reads "Touch to wake. Only lights up when you're using it."
 */
export const IMG_e7NYHcwONUCmjsUsZGiFY = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/e7NYHcwONUCmjsUsZGiFY/5018d51ae2c236cf0259863da46b9626/Keypad_3.jpg',
  description: `SimpliSafe Key Pad installed on a wall with a finger on a button lighting up the display. Text above reads "Touch to wake. Only lights up when you're using it."`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Key Pad on Wall with Text (desktop)](https://images.ctfassets.net/v6awd0kabi65/708TRkjuDgd3KTJLNxZ0l3/dfa5cbb1a82918a28850170571501269/Keypad_3FW.jpg?w=120&h=120&fit=pad)
 *
 * Key Pad on Wall with Text (desktop)
 *
 * Two panel image. The left panel is a SimpliSafe Key Pad installed on a wall with a finger on a button lighting up the display. Text above reads "Touch to wake. Only lights up when you're using it.". The right pane with an orange lamp turned on.
 */
export const IMG_708TRkjuDgd3KTJLNxZ0l3 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/708TRkjuDgd3KTJLNxZ0l3/dfa5cbb1a82918a28850170571501269/Keypad_3FW.jpg',
  description: `Two panel image. The left panel is a SimpliSafe Key Pad installed on a wall with a finger on a button lighting up the display. Text above reads "Touch to wake. Only lights up when you're using it.". The right pane with an orange lamp turned on.`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Water Sensor Next to Water (mobile)](https://images.ctfassets.net/v6awd0kabi65/7hl5cvhzYWyiup8gPBsHHz/68f66361d9ba9bc7c50d820983253fdd/Water_1.jpg?w=120&h=120&fit=pad)
 *
 * Water Sensor Next to Water (mobile)
 *
 * SimpliSafe Water sensor on the ground next to spilled water
 */
export const IMG_7hl5cvhzYWyiup8gPBsHHz = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7hl5cvhzYWyiup8gPBsHHz/68f66361d9ba9bc7c50d820983253fdd/Water_1.jpg',
  description: `SimpliSafe Water sensor on the ground next to spilled water`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Water Sensor Next to Water (desktop)](https://images.ctfassets.net/v6awd0kabi65/5AkJ97ssZFqdOQBMNQ0ygw/553e7de10a9db75fd66cb31c2b388dc3/Water_1FW.jpg?w=120&h=120&fit=pad)
 *
 * Water Sensor Next to Water (desktop)
 *
 * SimpliSafe Water sensor on the ground next to spilled water
 */
export const IMG_5AkJ97ssZFqdOQBMNQ0ygw = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5AkJ97ssZFqdOQBMNQ0ygw/553e7de10a9db75fd66cb31c2b388dc3/Water_1FW.jpg',
  description: `SimpliSafe Water sensor on the ground next to spilled water`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Water Sensor Basement Leak Illustration (mobile)](https://images.ctfassets.net/v6awd0kabi65/11tYQFbJjV0tgTqFiq4lHr/0770a008ac8c7565591ccc03618959ed/Water_2.jpg?w=120&h=120&fit=pad)
 *
 * Water Sensor Basement Leak Illustration (mobile)
 *
 * Illustration of the SimpliSafe Water sensor in a basement near a leaking water heater. A women walks down stairs to notice the leak
 */
export const IMG_11tYQFbJjV0tgTqFiq4lHr = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/11tYQFbJjV0tgTqFiq4lHr/0770a008ac8c7565591ccc03618959ed/Water_2.jpg',
  description: `Illustration of the SimpliSafe Water sensor in a basement near a leaking water heater. A women walks down stairs to notice the leak`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Water Sensor Basement Leak Illustration (desktop)](https://images.ctfassets.net/v6awd0kabi65/gSXqIfc8qOeZwMv4S9sqF/a2523fc87100a414d1d0dde366962d2f/Water_2FW.jpg?w=120&h=120&fit=pad)
 *
 * Water Sensor Basement Leak Illustration (desktop)
 *
 * Illustration of the SimpliSafe Water sensor in a basement near a leaking water heater. A women walks down stairs to notice the leak
 */
export const IMG_gSXqIfc8qOeZwMv4S9sqF = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/gSXqIfc8qOeZwMv4S9sqF/a2523fc87100a414d1d0dde366962d2f/Water_2FW.jpg',
  description: `Illustration of the SimpliSafe Water sensor in a basement near a leaking water heater. A women walks down stairs to notice the leak`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Water Sensor on Kitchen Floor with Text (desktop)](https://images.ctfassets.net/v6awd0kabi65/BVZa9dBzqASR9ZeZxkrx3/26ac6389767af0ff82428d160df2af57/Water_3FW.jpg?w=120&h=120&fit=pad)
 *
 * Water Sensor on Kitchen Floor with Text (desktop)
 *
 * SimpliSafe Water sensor on the kitchen floor with text "Place near sinks, washers & water heaters."
 */
export const IMG_BVZa9dBzqASR9ZeZxkrx3 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/BVZa9dBzqASR9ZeZxkrx3/26ac6389767af0ff82428d160df2af57/Water_3FW.jpg',
  description: `SimpliSafe Water sensor on the kitchen floor with text "Place near sinks, washers & water heaters."`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Water Sensor on Kitchen Floor with Text (mobile)](https://images.ctfassets.net/v6awd0kabi65/1Uj3ERjKKvdH304kWIAAkw/cac806557e2a62323b8726880ac09cbb/Water_3.jpg?w=120&h=120&fit=pad)
 *
 * Water Sensor on Kitchen Floor with Text (mobile)
 *
 * SimpliSafe Water sensor on the kitchen floor with text "Place near sinks, washers & water heaters."
 */
export const IMG_1Uj3ERjKKvdH304kWIAAkw = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1Uj3ERjKKvdH304kWIAAkw/cac806557e2a62323b8726880ac09cbb/Water_3.jpg',
  description: `SimpliSafe Water sensor on the kitchen floor with text "Place near sinks, washers & water heaters."`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Water Sensor on Floor with Text (desktop)](https://images.ctfassets.net/v6awd0kabi65/DdFw0XVI9KNHVSwghOLMR/e2d8467af314e9c5e99889ba2c646068/Water_4FW.jpg?w=120&h=120&fit=pad)
 *
 * Water Sensor on Floor with Text (desktop)
 *
 * SimpliSafe Water sensor on the floor with text explaining its simple wireless setup and to place it anywhere water might collect
 */
export const IMG_DdFw0XVI9KNHVSwghOLMR = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/DdFw0XVI9KNHVSwghOLMR/e2d8467af314e9c5e99889ba2c646068/Water_4FW.jpg',
  description: `SimpliSafe Water sensor on the floor with text explaining its simple wireless setup and to place it anywhere water might collect`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Water Sensor on Floor with Text (mobile)](https://images.ctfassets.net/v6awd0kabi65/2cOkhNIFmDUkxF1orr5gic/4673fc651f2c9fe62709d30bef8b9df7/Water_4.jpg?w=120&h=120&fit=pad)
 *
 * Water Sensor on Floor with Text (mobile)
 *
 * SimpliSafe Water sensor on the floor with text explaining its simple wireless setup and to place it anywhere water might collect
 */
export const IMG_2cOkhNIFmDUkxF1orr5gic = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2cOkhNIFmDUkxF1orr5gic/4673fc651f2c9fe62709d30bef8b9df7/Water_4.jpg',
  description: `SimpliSafe Water sensor on the floor with text explaining its simple wireless setup and to place it anywhere water might collect`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Smoke & Carbon Monoxide Detector (Red) Installed on Ceiling (mobile)](https://images.ctfassets.net/v6awd0kabi65/7vHM8OAzTOJNr4QLtjz7aS/d7fdea6c5b836b6190b3e4eda98d3ca9/Red_1.jpg?w=120&h=120&fit=pad)
 *
 * Smoke & Carbon Monoxide Detector (Red) Installed on Ceiling (mobile)
 *
 * SimpliSafe Smoke & Carbon Monoxide detector installed on the ceiling
 */
export const IMG_7vHM8OAzTOJNr4QLtjz7aS = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7vHM8OAzTOJNr4QLtjz7aS/d7fdea6c5b836b6190b3e4eda98d3ca9/Red_1.jpg',
  description: `SimpliSafe Smoke & Carbon Monoxide detector installed on the ceiling `,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Red Smoke & Carbon Monoxide Detector (Red) Installed on Ceiling (desktop)](https://images.ctfassets.net/v6awd0kabi65/4qivsJHYntU9ijU9wAia3/a258449dc7f9ee8dae4a6ac628fd6626/Red_1FW.jpg?w=120&h=120&fit=pad)
 *
 * Red Smoke & Carbon Monoxide Detector (Red) Installed on Ceiling (desktop)
 *
 * SimpliSafe Smoke & Carbon Monoxide detector installed on the ceiling
 */
export const IMG_4qivsJHYntU9ijU9wAia3 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4qivsJHYntU9ijU9wAia3/a258449dc7f9ee8dae4a6ac628fd6626/Red_1FW.jpg',
  description: `SimpliSafe Smoke & Carbon Monoxide detector installed on the ceiling `,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Smoke & Carbon Monoxide Detector (Red) with Text (desktop)](https://images.ctfassets.net/v6awd0kabi65/53NrYTEuxQsQ0HAVhVvMz1/3387f4856cac74a1e16fc718d2482b17/Red_2FW.jpg?w=120&h=120&fit=pad)
 *
 * Smoke & Carbon Monoxide Detector (Red) with Text (desktop)
 *
 * SimpliSafe Smoke & Carbon Monoxide installed on a wall with text explaining its 2-in-1 hazard detection for carbon monoxide and smoke
 */
export const IMG_53NrYTEuxQsQ0HAVhVvMz1 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/53NrYTEuxQsQ0HAVhVvMz1/3387f4856cac74a1e16fc718d2482b17/Red_2FW.jpg',
  description: `SimpliSafe Smoke & Carbon Monoxide installed on a wall with text explaining its 2-in-1 hazard detection for carbon monoxide and smoke`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Smoke & Carbon Monoxide Detector (Red) with Text (mobile)](https://images.ctfassets.net/v6awd0kabi65/ZvlaskvNDP6fppIrAgssZ/ddf117bc4b3445313ef329ae87173ad6/Red_2.jpg?w=120&h=120&fit=pad)
 *
 * Smoke & Carbon Monoxide Detector (Red) with Text (mobile)
 *
 * SimpliSafe Smoke & Carbon Monoxide installed on a wall with text explaining its 2-in-1 hazard detection for carbon monoxide and smoke
 */
export const IMG_ZvlaskvNDP6fppIrAgssZ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/ZvlaskvNDP6fppIrAgssZ/ddf117bc4b3445313ef329ae87173ad6/Red_2.jpg',
  description: `SimpliSafe Smoke & Carbon Monoxide installed on a wall with text explaining its 2-in-1 hazard detection for carbon monoxide and smoke`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Smoke & Carbon Monoxide Detector (Red) in Room Illustration (mobile)](https://images.ctfassets.net/v6awd0kabi65/1UjKbZsTRFqEPbBF1GNPDf/0089a5d44d377bc37ad2f92834134b50/Red_3.jpg?w=120&h=120&fit=pad)
 *
 * Smoke & Carbon Monoxide Detector (Red) in Room Illustration (mobile)
 *
 * SimpliSafe Smoke & Carbon Monoxide detector alerting a couple in bed of a hazard
 */
export const IMG_1UjKbZsTRFqEPbBF1GNPDf = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1UjKbZsTRFqEPbBF1GNPDf/0089a5d44d377bc37ad2f92834134b50/Red_3.jpg',
  description: `SimpliSafe Smoke & Carbon Monoxide detector alerting a couple in bed of a hazard`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Smoke & Carbon Monoxide Detector (Red) in Room Illustration (desktop)](https://images.ctfassets.net/v6awd0kabi65/1wQGuqxYFqsdM29daUC18u/f537b5d7a9d0da9a85dca335badc6460/Red_3FW.jpg?w=120&h=120&fit=pad)
 *
 * Smoke & Carbon Monoxide Detector (Red) in Room Illustration (desktop)
 *
 * SimpliSafe Smoke & Carbon Monoxide detector alerting a couple in bed of smoke coming through the doorway with text explaining that it's more than a siren, but can also alert SimpliSafe's monitoring center with an asterisk to note professional monitoring plan required
 */
export const IMG_1wQGuqxYFqsdM29daUC18u = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1wQGuqxYFqsdM29daUC18u/f537b5d7a9d0da9a85dca335badc6460/Red_3FW.jpg',
  description: `SimpliSafe Smoke & Carbon Monoxide detector alerting a couple in bed of smoke coming through the doorway with text explaining that it's more than a siren, but can also alert SimpliSafe's monitoring center with an asterisk to note professional monitoring plan required `,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Smoke & Carbon Monoxide Detector (Red) Burning Food (mobile)](https://images.ctfassets.net/v6awd0kabi65/6cDAew8pu3ujotmwfR1AqR/b92fbda0c2ab8cb818394156ccb444f5/Red_4.jpg?w=120&h=120&fit=pad)
 *
 * Smoke & Carbon Monoxide Detector (Red) Burning Food (mobile)
 *
 * Food in a cast iron skillet with smoke rising. Text above explaining how the Smoke & Carbon Monoxide Detector can distinguish between dangerous smoke and burning food
 */
export const IMG_6cDAew8pu3ujotmwfR1AqR = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6cDAew8pu3ujotmwfR1AqR/b92fbda0c2ab8cb818394156ccb444f5/Red_4.jpg',
  description: `Food in a cast iron skillet with smoke rising. Text above explaining how the Smoke & Carbon Monoxide Detector can distinguish between dangerous smoke and burning food`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Smoke & Carbon Monoxide Detector (Red) Burning Food (desktop)](https://images.ctfassets.net/v6awd0kabi65/rSOPbxsenb2uPbEZjvsab/93b51de37df3588a205d9d0db0483667/Red_4FW.jpg?w=120&h=120&fit=pad)
 *
 * Smoke & Carbon Monoxide Detector (Red) Burning Food (desktop)
 *
 * Food in a cast iron skillet with smoke rising. Text above explaining how the Smoke & Carbon Monoxide Detector can distinguish between dangerous smoke and burning food
 */
export const IMG_rSOPbxsenb2uPbEZjvsab = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/rSOPbxsenb2uPbEZjvsab/93b51de37df3588a205d9d0db0483667/Red_4FW.jpg',
  description: `Food in a cast iron skillet with smoke rising. Text above explaining how the Smoke & Carbon Monoxide Detector can distinguish between dangerous smoke and burning food`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![How to improve front door security](https://downloads.ctfassets.net/v6awd0kabi65/2ioVDRhbDm4WSoVYHdYjIy/c881b1b972b816cc96bfaaf64b8e7980/Video_Doorbell_3489.png?w=120&h=120&fit=pad)
 *
 * How to improve front door security
 *
 * Improve front door security with 15 expert tips, from upgrading locks and reinforcing frames to installing smart cameras and alarms, to protect your home from and keep your family safe.
 */
export const IMG_2ioVDRhbDm4WSoVYHdYjIy = {
  url: 'https://downloads.ctfassets.net/v6awd0kabi65/2ioVDRhbDm4WSoVYHdYjIy/c881b1b972b816cc96bfaaf64b8e7980/Video_Doorbell_3489.png',
  description: `Improve front door security with 15 expert tips, from upgrading locks and reinforcing frames to installing smart cameras and alarms, to protect your home from and keep your family safe.`,
  originalHeight: 4600,
  originalWidth: 6900
}

/**
 * ![Smoke Detector Installed on Wooden Ceiling (mobile)](https://images.ctfassets.net/v6awd0kabi65/0O7EIXzjWUOafzzxjIFjQ/1f64c42bb2fec57c9092362c97739a9a/Smoke_1.jpg?w=120&h=120&fit=pad)
 *
 * Smoke Detector Installed on Wooden Ceiling (mobile)
 *
 * SimpliSafe Smoke Detector Installed on Wooden Ceiling
 */
export const IMG_0O7EIXzjWUOafzzxjIFjQ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/0O7EIXzjWUOafzzxjIFjQ/1f64c42bb2fec57c9092362c97739a9a/Smoke_1.jpg',
  description: `SimpliSafe Smoke Detector Installed on Wooden Ceiling`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Smoke Detector Installed on Wooden Ceiling (desktop)](https://images.ctfassets.net/v6awd0kabi65/4w5qWxbCEEymGG6nrdIUn1/3217ef565c7ab6c6bc64b7e660450e95/Smoke_1FW.jpg?w=120&h=120&fit=pad)
 *
 * Smoke Detector Installed on Wooden Ceiling (desktop)
 *
 * SimpliSafe Smoke Detector Installed on Wooden Ceiling
 */
export const IMG_4w5qWxbCEEymGG6nrdIUn1 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4w5qWxbCEEymGG6nrdIUn1/3217ef565c7ab6c6bc64b7e660450e95/Smoke_1FW.jpg',
  description: `SimpliSafe Smoke Detector Installed on Wooden Ceiling`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Smoke Detector with Text (mobile)](https://images.ctfassets.net/v6awd0kabi65/5oJ06ogRPO96Y30Prn098T/20fda62d0cb93af2e38ada6e8adf6381/Smoke_2.jpg?w=120&h=120&fit=pad)
 *
 * Smoke Detector with Text (mobile)
 *
 * SimpliSafe Smoke detector with text reading "Always on guard for smoke."
 */
export const IMG_5oJ06ogRPO96Y30Prn098T = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5oJ06ogRPO96Y30Prn098T/20fda62d0cb93af2e38ada6e8adf6381/Smoke_2.jpg',
  description: `SimpliSafe Smoke detector with text reading "Always on guard for smoke."`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Smoke Detector with Text (desktop)](https://images.ctfassets.net/v6awd0kabi65/NhDY0OreyjcI50E3hFGdz/afccd710fa329d5112ff5b5953f19e53/Smoke_2FW.jpg?w=120&h=120&fit=pad)
 *
 * Smoke Detector with Text (desktop)
 *
 * SimpliSafe Smoke detector with text reading "Always on guard for smoke."
 */
export const IMG_NhDY0OreyjcI50E3hFGdz = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/NhDY0OreyjcI50E3hFGdz/afccd710fa329d5112ff5b5953f19e53/Smoke_2FW.jpg',
  description: `SimpliSafe Smoke detector with text reading "Always on guard for smoke."`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Smoke Detector in Room Illustration (desktop)](https://images.ctfassets.net/v6awd0kabi65/5sJ7Gqta1yo7ZSVaQhPlvr/79b29cf1571a2e4ecd269514df257cb8/Smoke_3FW.jpg?w=120&h=120&fit=pad)
 *
 * Smoke Detector in Room Illustration (desktop)
 *
 * SimpliSafe Smoke detector alerting a couple in bed of smoke coming through the doorway with text explaining that it's more than a siren, but can also alert SimpliSafe's monitoring center with an asterisk to note professional monitoring plan required
 */
export const IMG_5sJ7Gqta1yo7ZSVaQhPlvr = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5sJ7Gqta1yo7ZSVaQhPlvr/79b29cf1571a2e4ecd269514df257cb8/Smoke_3FW.jpg',
  description: `SimpliSafe Smoke detector alerting a couple in bed of smoke coming through the doorway with text explaining that it's more than a siren, but can also alert SimpliSafe's monitoring center with an asterisk to note professional monitoring plan required `,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Smoke Detector in Room Illustration (mobile)](https://images.ctfassets.net/v6awd0kabi65/3910HuEmUC6rEG0w68qGCO/30a82c29de4710cb1dfbdb902162aeea/Smoke_3.jpg?w=120&h=120&fit=pad)
 *
 * Smoke Detector in Room Illustration (mobile)
 *
 * SimpliSafe Smoke detector alerting a couple in bed of a hazard
 */
export const IMG_3910HuEmUC6rEG0w68qGCO = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3910HuEmUC6rEG0w68qGCO/30a82c29de4710cb1dfbdb902162aeea/Smoke_3.jpg',
  description: `SimpliSafe Smoke detector alerting a couple in bed of a hazard`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Smoke Detector on Wooden Surface (desktop)](https://images.ctfassets.net/v6awd0kabi65/4JPIdIf9y8TYuKppyp9PEi/4c35f2ebbec4a26e2d5c3a10643517d3/Smoke_4FW.jpg?w=120&h=120&fit=pad)
 *
 * Smoke Detector on Wooden Surface (desktop)
 *
 * SimpliSafe Smoke detector installed on a wooden service with text that explains its simple wireless setup
 */
export const IMG_4JPIdIf9y8TYuKppyp9PEi = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4JPIdIf9y8TYuKppyp9PEi/4c35f2ebbec4a26e2d5c3a10643517d3/Smoke_4FW.jpg',
  description: `SimpliSafe Smoke detector installed on a wooden service with text that explains its simple wireless setup`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Smoke Detector on Wooden Surface (mobile)](https://images.ctfassets.net/v6awd0kabi65/30EazPWthD592iuZjIcNrH/8531ea630feadc2675eff7e956f53643/Smoke_4.jpg?w=120&h=120&fit=pad)
 *
 * Smoke Detector on Wooden Surface (mobile)
 *
 * SimpliSafe Smoke detector installed on a wooden service with text that explains its simple wireless setup
 */
export const IMG_30EazPWthD592iuZjIcNrH = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/30EazPWthD592iuZjIcNrH/8531ea630feadc2675eff7e956f53643/Smoke_4.jpg',
  description: `SimpliSafe Smoke detector installed on a wooden service with text that explains its simple wireless setup`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Temperature Sensor Next to Water Pipes (mobile)](https://images.ctfassets.net/v6awd0kabi65/3FasmpGKdFyKeCzSBjAPnH/e64b500319810476e36cd09345e4feb6/Temp_1.jpg?w=120&h=120&fit=pad)
 *
 * Temperature Sensor Next to Water Pipes (mobile)
 *
 * SimpliSafe Temperature sensor installed on a wall near to water pipes
 */
export const IMG_3FasmpGKdFyKeCzSBjAPnH = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3FasmpGKdFyKeCzSBjAPnH/e64b500319810476e36cd09345e4feb6/Temp_1.jpg',
  description: `SimpliSafe Temperature sensor installed on a wall near to water pipes`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Temperature Sensor Next to Water Pipes (desktop)](https://images.ctfassets.net/v6awd0kabi65/1jpztXf52wuu1S05S3w0FF/114224b11ebeec6b2c1727c5561ab15b/Temp_1FW.jpg?w=120&h=120&fit=pad)
 *
 * Temperature Sensor Next to Water Pipes (desktop)
 *
 * SimpliSafe Temperature sensor installed on a wall near to water pipes
 */
export const IMG_1jpztXf52wuu1S05S3w0FF = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1jpztXf52wuu1S05S3w0FF/114224b11ebeec6b2c1727c5561ab15b/Temp_1FW.jpg',
  description: `SimpliSafe Temperature sensor installed on a wall near to water pipes`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Temperature Sensor Prevent Frozen Pipes Illustration (mobile)](https://images.ctfassets.net/v6awd0kabi65/194Xqc8CLTvrTpNBZHsbt6/cca3b7a571b54a01fe7cfd1eb3b12230/Temp_2.jpg?w=120&h=120&fit=pad)
 *
 * Temperature Sensor Prevent Frozen Pipes Illustration (mobile)
 *
 * Illustration of a SimpliSafe Temperature sensor installed in a garage near water pipes with text explaining its use to prevent frozen pipes in winter
 */
export const IMG_194Xqc8CLTvrTpNBZHsbt6 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/194Xqc8CLTvrTpNBZHsbt6/cca3b7a571b54a01fe7cfd1eb3b12230/Temp_2.jpg',
  description: `Illustration of a SimpliSafe Temperature sensor installed in a garage near water pipes with text explaining its use to prevent frozen pipes in winter`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Temperature Sensor Prevent Frozen Pipes Illustration (desktop)](https://images.ctfassets.net/v6awd0kabi65/2blkGvXa7upTtmAfQq2QIy/cd9e4c30d3c58ec43d1451e628ba5ef1/Temp_2FW.jpg?w=120&h=120&fit=pad)
 *
 * Temperature Sensor Prevent Frozen Pipes Illustration (desktop)
 *
 * Two panel illustration with an illustration on the left displaying a smartphone with a notification for a temperature alert notification. The right illustration of a SimpliSafe Temperature sensor installed in a garage near water pipe. Text above explaining its use to prevent frozen pipes in winter
 */
export const IMG_2blkGvXa7upTtmAfQq2QIy = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2blkGvXa7upTtmAfQq2QIy/cd9e4c30d3c58ec43d1451e628ba5ef1/Temp_2FW.jpg',
  description: `Two panel illustration with an illustration on the left displaying a smartphone with a notification for a temperature alert notification. The right illustration of a SimpliSafe Temperature sensor installed in a garage near water pipe. Text above explaining its use to prevent frozen pipes in winter`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Temperature Safe from Heat Illustration (mobile)](https://images.ctfassets.net/v6awd0kabi65/3XoAjRZE4WP39EdLD8SUQF/65f11084d0f3babb87a1e3fbabf5d322/Temp_3.jpg?w=120&h=120&fit=pad)
 *
 * Temperature Safe from Heat Illustration (mobile)
 *
 * Illustration of a dog on a bed with text explaining how the Temperature sensor keeps pets and family safe from summer heat
 */
export const IMG_3XoAjRZE4WP39EdLD8SUQF = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3XoAjRZE4WP39EdLD8SUQF/65f11084d0f3babb87a1e3fbabf5d322/Temp_3.jpg',
  description: `Illustration of a dog on a bed with text explaining how the Temperature sensor keeps pets and family safe from summer heat`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Temperature Safe from Heat Illustration (desktop)](https://images.ctfassets.net/v6awd0kabi65/4sz7FTuHBkndOrODFAZiwX/05269afaacd2ae2bea671ff5c0cbec31/Temp_3FW.jpg?w=120&h=120&fit=pad)
 *
 * Temperature Safe from Heat Illustration (desktop)
 *
 * Illustration of a dog on a bed with text explaining how the Temperature sensor keeps pets and family safe from summer heat
 */
export const IMG_4sz7FTuHBkndOrODFAZiwX = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4sz7FTuHBkndOrODFAZiwX/05269afaacd2ae2bea671ff5c0cbec31/Temp_3FW.jpg',
  description: `Illustration of a dog on a bed with text explaining how the Temperature sensor keeps pets and family safe from summer heat`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Temperature Sensor on Table (mobile)](https://images.ctfassets.net/v6awd0kabi65/2XETjABYCBjOxjGq8N4gqG/9dbf2d38330b33b6421623952b7573bf/Temp_4.jpg?w=120&h=120&fit=pad)
 *
 * Temperature Sensor on Table (mobile)
 *
 * SimpliSafe Temperature sensor on a wooden table with text that explains its simple wireless setup with no tools required
 */
export const IMG_2XETjABYCBjOxjGq8N4gqG = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2XETjABYCBjOxjGq8N4gqG/9dbf2d38330b33b6421623952b7573bf/Temp_4.jpg',
  description: `SimpliSafe Temperature sensor on a wooden table with text that explains its simple wireless setup with no tools required`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Temperature Sensor on Table (desktop)](https://images.ctfassets.net/v6awd0kabi65/4wb8Mlm1G8JrSIkxlQq5zz/8632c303470923032cddafbad5559d32/Temp_4FW.jpg?w=120&h=120&fit=pad)
 *
 * Temperature Sensor on Table (desktop)
 *
 * SimpliSafe Temperature sensor on a wooden table with text that explains its simple wireless setup with no tools required
 */
export const IMG_4wb8Mlm1G8JrSIkxlQq5zz = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4wb8Mlm1G8JrSIkxlQq5zz/8632c303470923032cddafbad5559d32/Temp_4FW.jpg',
  description: `SimpliSafe Temperature sensor on a wooden table with text that explains its simple wireless setup with no tools required`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Panic Installed on Tile (mobile)](https://images.ctfassets.net/v6awd0kabi65/6p2akqw5Df0FXS20XSqosa/f61e57569adca185599c149e22943a31/Panic_1.jpg?w=120&h=120&fit=pad)
 *
 * Panic Installed on Tile (mobile)
 *
 * SimpliSafe Panic installed on a tile wall
 */
export const IMG_6p2akqw5Df0FXS20XSqosa = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6p2akqw5Df0FXS20XSqosa/f61e57569adca185599c149e22943a31/Panic_1.jpg',
  description: `SimpliSafe Panic installed on a tile wall`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Panic Installed on Tile (desktop)](https://images.ctfassets.net/v6awd0kabi65/3aXpsGjGMSQTDHSvSMwvFK/177c4511df4fc4e26cc0d5ac1ab15b7f/Panic_1FW.jpg?w=120&h=120&fit=pad)
 *
 * Panic Installed on Tile (desktop)
 *
 * SimpliSafe Panic installed on a tile wall
 */
export const IMG_3aXpsGjGMSQTDHSvSMwvFK = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3aXpsGjGMSQTDHSvSMwvFK/177c4511df4fc4e26cc0d5ac1ab15b7f/Panic_1FW.jpg',
  description: `SimpliSafe Panic installed on a tile wall`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Panic with Text (desktop)](https://images.ctfassets.net/v6awd0kabi65/WTBcjJyhQDhwa3G0lFZso/a26bbf3ccce36e4c144dd316a61f27a8/Panic_2FW.jpg?w=120&h=120&fit=pad)
 *
 * Panic with Text (desktop)
 *
 * SimpliSafe Panic displayed. There is text that explains its one press to alert emergency services with an asterisk denoting professional monitoring plan required
 */
export const IMG_WTBcjJyhQDhwa3G0lFZso = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/WTBcjJyhQDhwa3G0lFZso/a26bbf3ccce36e4c144dd316a61f27a8/Panic_2FW.jpg',
  description: `SimpliSafe Panic displayed. There is text that explains its one press to alert emergency services with an asterisk denoting professional monitoring plan required  `,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Panic with Text (mobile)](https://images.ctfassets.net/v6awd0kabi65/wfQYOBQEVPIRqwYCxKfZS/141cda958a6b1fa5e2d298bb943201df/Panic_2.jpg?w=120&h=120&fit=pad)
 *
 * Panic with Text (mobile)
 *
 * SimpliSafe Panic displayed. There is text that explains its one press to alert emergency services with an asterisk denoting professional monitoring plan required
 */
export const IMG_wfQYOBQEVPIRqwYCxKfZS = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/wfQYOBQEVPIRqwYCxKfZS/141cda958a6b1fa5e2d298bb943201df/Panic_2.jpg',
  description: `SimpliSafe Panic displayed. There is text that explains its one press to alert emergency services with an asterisk denoting professional monitoring plan required  `,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Panic Being Pushed (mobile)](https://images.ctfassets.net/v6awd0kabi65/1VQD9oozAQkX9LoV4Jd2oK/ed886e00743d84b38a82fc6137d6c89b/Panic_3.jpg?w=120&h=120&fit=pad)
 *
 * Panic Being Pushed (mobile)
 *
 * SimpliSafe Panic button installed next to a bed with text explaining its placement next to a bed for easy access
 */
export const IMG_1VQD9oozAQkX9LoV4Jd2oK = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1VQD9oozAQkX9LoV4Jd2oK/ed886e00743d84b38a82fc6137d6c89b/Panic_3.jpg',
  description: `SimpliSafe Panic button installed next to a bed with text explaining its placement next to a bed for easy access`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Panic Being Pushed (desktop)](https://images.ctfassets.net/v6awd0kabi65/3o9DAZAEIsXvzYQZsxEnlN/43e1980cbb65429b4a539646021d27c6/Panic_3FW.jpg?w=120&h=120&fit=pad)
 *
 * Panic Being Pushed (desktop)
 *
 * SimpliSafe Panic button installed next to a bed with text explaining its placement next to a bed for easy access
 */
export const IMG_3o9DAZAEIsXvzYQZsxEnlN = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3o9DAZAEIsXvzYQZsxEnlN/43e1980cbb65429b4a539646021d27c6/Panic_3FW.jpg',
  description: `SimpliSafe Panic button installed next to a bed with text explaining its placement next to a bed for easy access`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Siren on Wall (mobile)](https://images.ctfassets.net/v6awd0kabi65/2Jmg4fLQF7l2zipA5VTZVV/8c2ef75366d72cff54ca193bb5091cef/Siren_1.jpg?w=120&h=120&fit=pad)
 *
 * Siren on Wall (mobile)
 *
 * SimpliSafe Siren installed to a wall
 */
export const IMG_2Jmg4fLQF7l2zipA5VTZVV = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2Jmg4fLQF7l2zipA5VTZVV/8c2ef75366d72cff54ca193bb5091cef/Siren_1.jpg',
  description: `SimpliSafe Siren installed to a wall`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Siren on Wall (desktop)](https://images.ctfassets.net/v6awd0kabi65/2yTKmbaCsnbhDRskkSoftl/f8cd851811e01aa9ecc31a2f7686ca16/Siren_1FW.jpg?w=120&h=120&fit=pad)
 *
 * Siren on Wall (desktop)
 *
 * SimpliSafe Siren installed to a wall
 */
export const IMG_2yTKmbaCsnbhDRskkSoftl = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2yTKmbaCsnbhDRskkSoftl/f8cd851811e01aa9ecc31a2f7686ca16/Siren_1FW.jpg',
  description: `SimpliSafe Siren installed to a wall`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Siren Outside on Wall (desktop)](https://images.ctfassets.net/v6awd0kabi65/3aU1dmepTOoelO7rjtdqqF/e93755e9713e37bad8e1ec469cf855b6/Siren_2FW.jpg?w=120&h=120&fit=pad)
 *
 * Siren Outside on Wall (desktop)
 *
 * SimpilSafe Siren installed outside on a wall with text explaining the 105 decibel sirens ability to scare off trouble and alert neighbors
 */
export const IMG_3aU1dmepTOoelO7rjtdqqF = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3aU1dmepTOoelO7rjtdqqF/e93755e9713e37bad8e1ec469cf855b6/Siren_2FW.jpg',
  description: `SimpilSafe Siren installed outside on a wall with text explaining the 105 decibel sirens ability to scare off trouble and alert neighbors`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Siren Outside on Wall (mobile)](https://images.ctfassets.net/v6awd0kabi65/6u5Fyacca6QikY2Wo5VRe6/7e87f19ebce83690ec1d6688d695be7b/Siren_2.jpg?w=120&h=120&fit=pad)
 *
 * Siren Outside on Wall (mobile)
 *
 * SimpilSafe Siren installed outside on a wall with text explaining the 105 decibel sirens ability to scare off trouble and alert neighbors
 */
export const IMG_6u5Fyacca6QikY2Wo5VRe6 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6u5Fyacca6QikY2Wo5VRe6/7e87f19ebce83690ec1d6688d695be7b/Siren_2.jpg',
  description: `SimpilSafe Siren installed outside on a wall with text explaining the 105 decibel sirens ability to scare off trouble and alert neighbors`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Siren Outside (mobile)](https://images.ctfassets.net/v6awd0kabi65/22DVhrc1VqHatCQC5xY0hF/fc99096ecfc4a912f9d6eb2236787626/Siren_3.jpg?w=120&h=120&fit=pad)
 *
 * Siren Outside (mobile)
 *
 * SimpliSafe Siren outside on a building post with text explaining the placement of the weather-resistant siren for indoors or outdoors
 */
export const IMG_22DVhrc1VqHatCQC5xY0hF = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/22DVhrc1VqHatCQC5xY0hF/fc99096ecfc4a912f9d6eb2236787626/Siren_3.jpg',
  description: `SimpliSafe Siren outside on a building post with text explaining the placement of the weather-resistant siren for indoors or outdoors`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Siren Outside (desktop)](https://images.ctfassets.net/v6awd0kabi65/19budMx4jnD5iNF7AhtMXg/08b8606e5fd54ea82943f4fc3932eb15/Siren_3FW.jpg?w=120&h=120&fit=pad)
 *
 * Siren Outside (desktop)
 *
 * SimpliSafe Siren outside on a building post with text explaining the placement of the weather-resistant siren for indoors or outdoors
 */
export const IMG_19budMx4jnD5iNF7AhtMXg = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/19budMx4jnD5iNF7AhtMXg/08b8606e5fd54ea82943f4fc3932eb15/Siren_3FW.jpg',
  description: `SimpliSafe Siren outside on a building post with text explaining the placement of the weather-resistant siren for indoors or outdoors`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Siren with Text (mobile)](https://images.ctfassets.net/v6awd0kabi65/6lMYDrqtGrvxVd1Ze2nKPt/595e9cb60cc4436dab926b17f254b9a5/Siren_4.jpg?w=120&h=120&fit=pad)
 *
 * Siren with Text (mobile)
 *
 * SimpliSafe Siren with text explaining simple wireless setup without the need for tools
 */
export const IMG_6lMYDrqtGrvxVd1Ze2nKPt = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6lMYDrqtGrvxVd1Ze2nKPt/595e9cb60cc4436dab926b17f254b9a5/Siren_4.jpg',
  description: `SimpliSafe Siren with text explaining simple wireless setup without the need for tools`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Siren with Text (desktop)](https://images.ctfassets.net/v6awd0kabi65/10nAh4ZwiMdiCbj7fSgVVI/c53c8fb7b8e115f8b69cb4f630aadc90/Siren_4FW.jpg?w=120&h=120&fit=pad)
 *
 * Siren with Text (desktop)
 *
 * SimpliSafe Siren with text explaining simple wireless setup without the need for tools
 */
export const IMG_10nAh4ZwiMdiCbj7fSgVVI = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/10nAh4ZwiMdiCbj7fSgVVI/c53c8fb7b8e115f8b69cb4f630aadc90/Siren_4FW.jpg',
  description: `SimpliSafe Siren with text explaining simple wireless setup without the need for tools`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Smart Lock (White) (Braun) on Door (mobile)](https://images.ctfassets.net/v6awd0kabi65/1LQWFr2SpN33j6Y65KGMY6/67bdde941afa2eecdb46f5755d3b32ed/Braun_2.jpg?w=120&h=120&fit=pad)
 *
 * Smart Lock (White) (Braun) on Door (mobile)
 *
 * A white SimpliSafe Smart Lock installed on a door
 */
export const IMG_1LQWFr2SpN33j6Y65KGMY6 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1LQWFr2SpN33j6Y65KGMY6/67bdde941afa2eecdb46f5755d3b32ed/Braun_2.jpg',
  description: `A white SimpliSafe Smart Lock installed on a door`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Smart Lock (White) (Braun) on Door (desktop)](https://images.ctfassets.net/v6awd0kabi65/1BeAQwmieIr1hPPtAfqZPS/3831611647f960c15036a6c9658f520e/Braun_2FW.jpg?w=120&h=120&fit=pad)
 *
 * Smart Lock (White) (Braun) on Door (desktop)
 *
 * A white SimpliSafe Smart Lock installed on a door
 */
export const IMG_1BeAQwmieIr1hPPtAfqZPS = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1BeAQwmieIr1hPPtAfqZPS/3831611647f960c15036a6c9658f520e/Braun_2FW.jpg',
  description: `A white SimpliSafe Smart Lock installed on a door`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Smart Lock (Black) (Braun) on Door (mobile)](https://images.ctfassets.net/v6awd0kabi65/3OkVfR9vH5eS96bRWPiY1V/5a3e57b695c14dcd140543d67d648bca/Braun_1.jpg?w=120&h=120&fit=pad)
 *
 * Smart Lock (Black) (Braun) on Door (mobile)
 *
 * A black SimpliSafe Smart Lock installed on a door
 */
export const IMG_3OkVfR9vH5eS96bRWPiY1V = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3OkVfR9vH5eS96bRWPiY1V/5a3e57b695c14dcd140543d67d648bca/Braun_1.jpg',
  description: `A black SimpliSafe Smart Lock installed on a door`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Smart Lock (Black) (Braun) on Door (desktop)](https://images.ctfassets.net/v6awd0kabi65/2ipPHmO3y7aHeQmQhBGLOQ/55ee87cca715bf5936843c2a4f7aa2b8/Braun_1FW.jpg?w=120&h=120&fit=pad)
 *
 * Smart Lock (Black) (Braun) on Door (desktop)
 *
 * A black SimpliSafe Smart Lock installed on a door
 */
export const IMG_2ipPHmO3y7aHeQmQhBGLOQ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2ipPHmO3y7aHeQmQhBGLOQ/55ee87cca715bf5936843c2a4f7aa2b8/Braun_1FW.jpg',
  description: `A black SimpliSafe Smart Lock installed on a door`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Smart Lock (Braun) App Usage (mobile)](https://images.ctfassets.net/v6awd0kabi65/25ts5f6GK2UB6opZl3WD8y/a70914de46ee88f40236a9af17c4af9b/Braun_3.jpg?w=120&h=120&fit=pad)
 *
 * Smart Lock (Braun) App Usage (mobile)
 *
 * A smartphone held in hand. The smartphone displays the SimpliSafe app in use
 */
export const IMG_25ts5f6GK2UB6opZl3WD8y = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/25ts5f6GK2UB6opZl3WD8y/a70914de46ee88f40236a9af17c4af9b/Braun_3.jpg',
  description: `A smartphone held in hand. The smartphone displays the SimpliSafe app in use`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Smart Lock (Braun) App Usage (desktop)](https://images.ctfassets.net/v6awd0kabi65/2aMzgy85HsQrKkRpN8jF1Q/79d9d36472712fad704138743be7fe00/Braun_3FW.jpg?w=120&h=120&fit=pad)
 *
 * Smart Lock (Braun) App Usage (desktop)
 *
 * A three panel image. The top panel with text explains how to use the Smart Lock pin pad or SimpliSafe app to unlock a door. The left panel is a smartphone held in hand with the SimpliSafe app in use and the left panel is a user interacting with the Smart Lock
 */
export const IMG_2aMzgy85HsQrKkRpN8jF1Q = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2aMzgy85HsQrKkRpN8jF1Q/79d9d36472712fad704138743be7fe00/Braun_3FW.jpg',
  description: `A three panel image. The top panel with text explains how to use the Smart Lock pin pad or SimpliSafe app to unlock a door. The left panel is a smartphone held in hand with the SimpliSafe app in use and the left panel is a user interacting with the Smart Lock`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Smart Lock (Braun) Notifications (mobile)](https://images.ctfassets.net/v6awd0kabi65/1fsrtbPGCzHmxHsLxSqqXo/277181fafa9f8e729d445929a1dae7a8/Braun_4.jpg?w=120&h=120&fit=pad)
 *
 * Smart Lock (Braun) Notifications (mobile)
 *
 * Notification messages from the SimpliSafe app notifying of front door activity
 */
export const IMG_1fsrtbPGCzHmxHsLxSqqXo = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1fsrtbPGCzHmxHsLxSqqXo/277181fafa9f8e729d445929a1dae7a8/Braun_4.jpg',
  description: `Notification messages from the SimpliSafe app notifying of front door activity`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Smart Lock (Braun) Notifications (desktop)](https://images.ctfassets.net/v6awd0kabi65/2vAdQvQtbh83qScKKhWjus/9ca13657066fb82844b39ed7f21b958f/Braun_4FW.jpg?w=120&h=120&fit=pad)
 *
 * Smart Lock (Braun) Notifications (desktop)
 *
 * Notification messages from the SimpliSafe app notifying of front door activity
 */
export const IMG_2vAdQvQtbh83qScKKhWjus = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2vAdQvQtbh83qScKKhWjus/9ca13657066fb82844b39ed7f21b958f/Braun_4FW.jpg',
  description: `Notification messages from the SimpliSafe app notifying of front door activity`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Key Fob on Table (desktop)](https://images.ctfassets.net/v6awd0kabi65/5Q3RNATYsgOFMO35RMLNxJ/772c3ac69e8431c94ceb4b63982a8ec0/Fob_1FW.jpg?w=120&h=120&fit=pad)
 *
 * Key Fob on Table (desktop)
 *
 * SimpliSafe Key Fob on a table
 */
export const IMG_5Q3RNATYsgOFMO35RMLNxJ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5Q3RNATYsgOFMO35RMLNxJ/772c3ac69e8431c94ceb4b63982a8ec0/Fob_1FW.jpg',
  description: `SimpliSafe Key Fob on a table`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Key Fob on Table (mobile)](https://images.ctfassets.net/v6awd0kabi65/V9Yn96QQ1YDJuY8u3Xs36/fdc75c5aee8f662801ba20ae8d0158a2/Fob_1.jpg?w=120&h=120&fit=pad)
 *
 * Key Fob on Table (mobile)
 *
 * SimpliSafe Key Fob on a table
 */
export const IMG_V9Yn96QQ1YDJuY8u3Xs36 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/V9Yn96QQ1YDJuY8u3Xs36/fdc75c5aee8f662801ba20ae8d0158a2/Fob_1.jpg',
  description: `SimpliSafe Key Fob on a table`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Key Fob In Hand (mobile)](https://images.ctfassets.net/v6awd0kabi65/54cJ19qt8xWFfPoPnEJ9CH/2474fb1a9f2bc012283f890515d1dbdd/Fob_2.jpg?w=120&h=120&fit=pad)
 *
 * Key Fob In Hand (mobile)
 *
 * SimpliSafe Key Fob in a hand with text to describe it's ability to control the SimpliSafe alarm system with one touch from 30 feet away
 */
export const IMG_54cJ19qt8xWFfPoPnEJ9CH = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/54cJ19qt8xWFfPoPnEJ9CH/2474fb1a9f2bc012283f890515d1dbdd/Fob_2.jpg',
  description: `SimpliSafe Key Fob in a hand with text to describe it's ability to control the SimpliSafe alarm system with one touch from 30 feet away`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Key Fob In Hand (desktop)](https://images.ctfassets.net/v6awd0kabi65/7N278F1tprEn6QAcVOStEa/d53fa3ac947ca756891d7867f6913ad3/Fob_2FW.jpg?w=120&h=120&fit=pad)
 *
 * Key Fob In Hand (desktop)
 *
 * SimpliSafe Key Fob in a hand with text to describe it's ability to control the SimpliSafe alarm system with one touch from 30 feet away
 */
export const IMG_7N278F1tprEn6QAcVOStEa = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7N278F1tprEn6QAcVOStEa/d53fa3ac947ca756891d7867f6913ad3/Fob_2FW.jpg',
  description: `SimpliSafe Key Fob in a hand with text to describe it's ability to control the SimpliSafe alarm system with one touch from 30 feet away`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Key Fob Panic Button (mobile)](https://images.ctfassets.net/v6awd0kabi65/h1EBx5r1ZyDzpo4h5fXHF/16165f923b4e1886b108547858f8f844/Fob_3.jpg?w=120&h=120&fit=pad)
 *
 * Key Fob Panic Button (mobile)
 *
 * SimpliSafe Key Fob displaying the built-in panic button to set off the alarm manually
 */
export const IMG_h1EBx5r1ZyDzpo4h5fXHF = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/h1EBx5r1ZyDzpo4h5fXHF/16165f923b4e1886b108547858f8f844/Fob_3.jpg',
  description: `SimpliSafe Key Fob displaying the built-in panic button to set off the alarm manually`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Key Fob Panic Button (desktop)](https://images.ctfassets.net/v6awd0kabi65/1tiDVB7D8Y0wtZVXakUqwe/35168f85460d6d51624d176925cca648/Fob_3FW.jpg?w=120&h=120&fit=pad)
 *
 * Key Fob Panic Button (desktop)
 *
 * SimpliSafe Key Fob displaying the built-in panic button to set off the alarm manually
 */
export const IMG_1tiDVB7D8Y0wtZVXakUqwe = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1tiDVB7D8Y0wtZVXakUqwe/35168f85460d6d51624d176925cca648/Fob_3FW.jpg',
  description: `SimpliSafe Key Fob displaying the built-in panic button to set off the alarm manually`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Key Fob On Hook (desktop)](https://images.ctfassets.net/v6awd0kabi65/5qibvXcbnQHyCKoca3UALI/0c801a947919f3f8f41e6ff3e35ee6f8/Fob_4FW.jpg?w=120&h=120&fit=pad)
 *
 * Key Fob On Hook (desktop)
 *
 * SimpliSafe Key Fob attached to key ring hanging on a shelf attached to the wall
 */
export const IMG_5qibvXcbnQHyCKoca3UALI = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5qibvXcbnQHyCKoca3UALI/0c801a947919f3f8f41e6ff3e35ee6f8/Fob_4FW.jpg',
  description: `SimpliSafe Key Fob attached to key ring hanging on a shelf attached to the wall`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Key Fob On Hook (mobile)](https://images.ctfassets.net/v6awd0kabi65/3ed43z8JI35ShVn4sW2uZa/8c1be376b17c3572a4fb0c891d1c3895/Fob_4.jpg?w=120&h=120&fit=pad)
 *
 * Key Fob On Hook (mobile)
 *
 * SimpliSafe Key Fob attached to key ring hanging on a shelf attached to the wall
 */
export const IMG_3ed43z8JI35ShVn4sW2uZa = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3ed43z8JI35ShVn4sW2uZa/8c1be376b17c3572a4fb0c891d1c3895/Fob_4.jpg',
  description: `SimpliSafe Key Fob attached to key ring hanging on a shelf attached to the wall`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Yard Sign In Grass (mobile)](https://images.ctfassets.net/v6awd0kabi65/zt0TCTwqIiqKyGqlmO16X/14073d54275a83b366f116edeb256d5f/Sign_2.jpg?w=120&h=120&fit=pad)
 *
 * Yard Sign In Grass (mobile)
 *
 * SimpliSafe branded yard sign attached to stake in the ground
 */
export const IMG_zt0TCTwqIiqKyGqlmO16X = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/zt0TCTwqIiqKyGqlmO16X/14073d54275a83b366f116edeb256d5f/Sign_2.jpg',
  description: `SimpliSafe branded yard sign attached to stake in the ground`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Yard Sign In Grass (desktop)](https://images.ctfassets.net/v6awd0kabi65/2Ghlg2KjdJ9TinYyhXYUeO/3fbdccbba7f920a9195ba8be7dc7e006/Sign_2FW.jpg?w=120&h=120&fit=pad)
 *
 * Yard Sign In Grass (desktop)
 *
 * SimpliSafe branded yard sign attached to stake in the ground
 */
export const IMG_2Ghlg2KjdJ9TinYyhXYUeO = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2Ghlg2KjdJ9TinYyhXYUeO/3fbdccbba7f920a9195ba8be7dc7e006/Sign_2FW.jpg',
  description: `SimpliSafe branded yard sign attached to stake in the ground`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Yard Sign (mobile)](https://images.ctfassets.net/v6awd0kabi65/6SXbayKhxm3ZdjgwiXuzx4/106eb53471659ff87acddd2a6f6a2f4d/Sign_1.jpg?w=120&h=120&fit=pad)
 *
 * Yard Sign (mobile)
 *
 * SimpliSafe branded yard sign attached to stake
 */
export const IMG_6SXbayKhxm3ZdjgwiXuzx4 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6SXbayKhxm3ZdjgwiXuzx4/106eb53471659ff87acddd2a6f6a2f4d/Sign_1.jpg',
  description: `SimpliSafe branded yard sign attached to stake`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Yard Sign (desktop)](https://images.ctfassets.net/v6awd0kabi65/GyLqCIR5qmhzLfwH935aq/560dfc332900166b86ae995b5ceedb42/Sign_1FW.jpg?w=120&h=120&fit=pad)
 *
 * Yard Sign (desktop)
 *
 * SimpliSafe branded yard sign attached to stake
 */
export const IMG_GyLqCIR5qmhzLfwH935aq = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/GyLqCIR5qmhzLfwH935aq/560dfc332900166b86ae995b5ceedb42/Sign_1FW.jpg',
  description: `SimpliSafe branded yard sign attached to stake`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Pro Installation Outdoors (desktop)](https://images.ctfassets.net/v6awd0kabi65/1mNStNAYDIRJtWlXqpILzU/bd6a7d60d4920e5a833f31f41a94700d/Install_1FW.jpg?w=120&h=120&fit=pad)
 *
 * Pro Installation Outdoors (desktop)
 *
 * Highly trained technician installing a SimpliSafe camera outside on the side of a house
 */
export const IMG_1mNStNAYDIRJtWlXqpILzU = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1mNStNAYDIRJtWlXqpILzU/bd6a7d60d4920e5a833f31f41a94700d/Install_1FW.jpg',
  description: `Highly trained technician installing a SimpliSafe camera outside on the side of a house`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Pro Installation Outdoors (mobile)](https://images.ctfassets.net/v6awd0kabi65/2l4RyxkDTOPdLRhYhFCeql/8c1c6a3797692153e057e132d9a37eee/Install_1.jpg?w=120&h=120&fit=pad)
 *
 * Pro Installation Outdoors (mobile)
 *
 * Highly trained technician installing a SimpliSafe camera outside on the side of a house
 */
export const IMG_2l4RyxkDTOPdLRhYhFCeql = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2l4RyxkDTOPdLRhYhFCeql/8c1c6a3797692153e057e132d9a37eee/Install_1.jpg',
  description: `Highly trained technician installing a SimpliSafe camera outside on the side of a house`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Pro Installation Indoors (desktop)](https://images.ctfassets.net/v6awd0kabi65/4oFq4xGwwXkhdJV92BXN9u/fe691965ea5548af30ca3ecc9cfa5f91/Install_2FW.jpg?w=120&h=120&fit=pad)
 *
 * Pro Installation Indoors (desktop)
 *
 * Highly trained technician installing a SimpliSafe camera on a shelf
 */
export const IMG_4oFq4xGwwXkhdJV92BXN9u = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4oFq4xGwwXkhdJV92BXN9u/fe691965ea5548af30ca3ecc9cfa5f91/Install_2FW.jpg',
  description: `Highly trained technician installing a SimpliSafe camera on a shelf`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Pro Installation Indoors (mobile)](https://images.ctfassets.net/v6awd0kabi65/2LXahjXXyujlSbmknRKoM7/bf3b282e3e95f88405db6a3b93094c59/Install_2.jpg?w=120&h=120&fit=pad)
 *
 * Pro Installation Indoors (mobile)
 *
 * Highly trained technician installing a SimpliSafe camera on a shelf
 */
export const IMG_2LXahjXXyujlSbmknRKoM7 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2LXahjXXyujlSbmknRKoM7/bf3b282e3e95f88405db6a3b93094c59/Install_2.jpg',
  description: `Highly trained technician installing a SimpliSafe camera on a shelf`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Olympus Modal](https://images.ctfassets.net/v6awd0kabi65/12lHTWu4BdsFavcPmix85C/44f6502a4af5d1920b2e1b2daf7470ef/olympusmodal.png?w=120&h=120&fit=pad)
 *
 * Olympus Modal
 *
 * Camera must be plugged in to use SimpliSafe Active Guard Outdoor Protection.
 */
export const IMG_12lHTWu4BdsFavcPmix85C = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/12lHTWu4BdsFavcPmix85C/44f6502a4af5d1920b2e1b2daf7470ef/olympusmodal.png',
  description: `Camera must be plugged in to use SimpliSafe Active Guard Outdoor Protection.`,
  originalHeight: 1109,
  originalWidth: 1404
}

/**
 * ![Pro install - installation comparison section](https://images.ctfassets.net/v6awd0kabi65/6Zoj5XjNg2UU2Cp4WJd4sF/4acd88bba83a80e83da9ce05e1f21499/OnTech.jpg?w=120&h=120&fit=pad)
 *
 * Pro install - installation comparison section
 *
 * An expert installing the outdoor security camera
 */
export const IMG_6Zoj5XjNg2UU2Cp4WJd4sF = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6Zoj5XjNg2UU2Cp4WJd4sF/4acd88bba83a80e83da9ce05e1f21499/OnTech.jpg',
  description: `An expert installing the outdoor security camera`,
  originalHeight: 1024,
  originalWidth: 1272
}

/**
 * ![SimpliBox Image](https://images.ctfassets.net/v6awd0kabi65/2lunkBNSIVgE4tzbrIRHMS/6e42aa3b27809975df85eda58ab1c77b/SelfInstall.jpg?w=120&h=120&fit=pad)
 *
 * SimpliBox Image
 *
 * A pair of hands holding a SimpliSafe Box with the 9-piece kit on it
 */
export const IMG_2lunkBNSIVgE4tzbrIRHMS = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2lunkBNSIVgE4tzbrIRHMS/6e42aa3b27809975df85eda58ab1c77b/SelfInstall.jpg',
  description: `A pair of hands holding a SimpliSafe Box with the 9-piece kit on it`,
  originalHeight: 1024,
  originalWidth: 1272
}

/**
 * ![SMB- Hero Desktop](https://images.ctfassets.net/v6awd0kabi65/4KtvogslFc4vTH2xh2uJNe/b469d4e497713f3bbcfa8e0977ee1fb6/Hero_Desktop__1___1_.png?w=120&h=120&fit=pad)
 *
 * SMB- Hero Desktop
 *
 * Image of woman with home security products, including a panic button, an outdoor camera, and an indoor camera
 */
export const IMG_4KtvogslFc4vTH2xh2uJNe = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4KtvogslFc4vTH2xh2uJNe/b469d4e497713f3bbcfa8e0977ee1fb6/Hero_Desktop__1___1_.png',
  description: `Image of woman with home security products, including a panic button, an outdoor camera, and an indoor camera`,
  originalHeight: 1824,
  originalWidth: 3600
}

/**
 * ![SMB-Hero Mobile](https://images.ctfassets.net/v6awd0kabi65/38FkDnZB7ddgmWSRWZZjC9/deac40f3d0174ae6c7cad097754a8e1a/250148_SMB_HeroMobile__1_.png?w=120&h=120&fit=pad)
 *
 * SMB-Hero Mobile
 *
 * Image of woman with home security products, including a panic button, an outdoor camera, and an indoor camera
 */
export const IMG_38FkDnZB7ddgmWSRWZZjC9 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/38FkDnZB7ddgmWSRWZZjC9/deac40f3d0174ae6c7cad097754a8e1a/250148_SMB_HeroMobile__1_.png',
  description: `Image of woman with home security products, including a panic button, an outdoor camera, and an indoor camera`,
  originalHeight: 996,
  originalWidth: 1200
}

/**
 * ![SMB- Hero Tablet](https://images.ctfassets.net/v6awd0kabi65/1f8QXRR7ouWD2FU558bbAf/5e32267cd5a8aac077ee23286ace5ebd/250148_SMB_HeroTablet2.png?w=120&h=120&fit=pad)
 *
 * SMB- Hero Tablet
 *
 * Image of woman with home security products, including a panic button, an outdoor camera, and an indoor camera
 */
export const IMG_1f8QXRR7ouWD2FU558bbAf = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1f8QXRR7ouWD2FU558bbAf/5e32267cd5a8aac077ee23286ace5ebd/250148_SMB_HeroTablet2.png',
  description: `Image of woman with home security products, including a panic button, an outdoor camera, and an indoor camera`,
  originalHeight: 1200,
  originalWidth: 2173
}

/**
 * ![SMB - Embedded Quiz Asset](https://images.ctfassets.net/v6awd0kabi65/5syEhMu4dOSri4gvhRatpj/4b4669119088cd53807710ea41f9a5d9/Quiz_Image.png?w=120&h=120&fit=pad)
 *
 * SMB - Embedded Quiz Asset
 *
 * Image of home security sensors including a keypad, entry sensor, panic button, indoor camera and outdoor camera
 */
export const IMG_5syEhMu4dOSri4gvhRatpj = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5syEhMu4dOSri4gvhRatpj/4b4669119088cd53807710ea41f9a5d9/Quiz_Image.png',
  description: `Image of home security sensors including a keypad, entry sensor, panic button, indoor camera and outdoor camera`,
  originalHeight: 826,
  originalWidth: 1326
}

/**
 * ![Homepage UK - Hero Banner - Desktop - Dark](https://images.ctfassets.net/v6awd0kabi65/WI5vyDEVKcPY6Jm6h7pCD/89e1f1d8bd4f9b7e8cbe17d73a8bbfff/Homepage_Hero_Desktop.png?w=120&h=120&fit=pad)
 *
 * Homepage UK - Hero Banner - Desktop - Dark
 *
 * SimpliSafe Homepage Hero Image
 */
export const IMG_WI5vyDEVKcPY6Jm6h7pCD = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/WI5vyDEVKcPY6Jm6h7pCD/89e1f1d8bd4f9b7e8cbe17d73a8bbfff/Homepage_Hero_Desktop.png',
  description: `SimpliSafe Homepage Hero Image`,
  originalHeight: 2284,
  originalWidth: 4800
}

/**
 * ![ODCamS2 Detects](https://images.ctfassets.net/v6awd0kabi65/t0hh5K6pSYv1E0NfN6ofp/01ea223d720cd235ca464e9a0477ca7e/ODCamS2_Detects.png?w=120&h=120&fit=pad)
 *
 * ODCamS2 Detects
 *
 *
 */
export const IMG_t0hh5K6pSYv1E0NfN6ofp = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/t0hh5K6pSYv1E0NfN6ofp/01ea223d720cd235ca464e9a0477ca7e/ODCamS2_Detects.png',
  description: ``,
  originalHeight: 397,
  originalWidth: 631
}

/**
 * ![Olympus Outdoor Camera - Meet The System](https://images.ctfassets.net/v6awd0kabi65/6yEaoS6HzI093axF4Cxltu/caca251448fb60fd73f284ab49b6207f/Meet_Outdoor_Cam.png?w=120&h=120&fit=pad)
 *
 * Olympus Outdoor Camera - Meet The System
 *
 *
 */
export const IMG_6yEaoS6HzI093axF4Cxltu = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6yEaoS6HzI093axF4Cxltu/caca251448fb60fd73f284ab49b6207f/Meet_Outdoor_Cam.png',
  description: ``,
  originalHeight: 795,
  originalWidth: 1270
}

/**
 * ![Neutral Light Background](https://images.ctfassets.net/v6awd0kabi65/6aisiCVrsapbyFnlqKpP0i/049c59aa60bf43e0b1af3b2cf087f372/neutral_light_100.png?w=120&h=120&fit=pad)
 *
 * Neutral Light Background
 *
 *
 */
export const IMG_6aisiCVrsapbyFnlqKpP0i = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6aisiCVrsapbyFnlqKpP0i/049c59aa60bf43e0b1af3b2cf087f372/neutral_light_100.png',
  description: ``,
  originalHeight: 1177,
  originalWidth: 1268
}

/**
 * ![Homepage UK - Hero Banner - Mobile - Dark](https://images.ctfassets.net/v6awd0kabi65/67B66innS4rtAK7EmTwsrh/7c2666b547425a82eb1748cddba24440/Homepage_Hero_Mobile.png?w=120&h=120&fit=pad)
 *
 * Homepage UK - Hero Banner - Mobile - Dark
 *
 * SimpliSafe Homepage Hero Image
 */
export const IMG_67B66innS4rtAK7EmTwsrh = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/67B66innS4rtAK7EmTwsrh/7c2666b547425a82eb1748cddba24440/Homepage_Hero_Mobile.png',
  description: `SimpliSafe Homepage Hero Image`,
  originalHeight: 2240,
  originalWidth: 2400
}

/**
 * ![Blanket your home 2x](https://images.ctfassets.net/v6awd0kabi65/4y0YuBV1MYQobkJlzf44bi/895dc138b9f09c89cc316a4d955c4b16/meet_hero.jpg?w=120&h=120&fit=pad)
 *
 * Blanket your home 2x
 *
 * SimpliSafe products placed on yellow shelves on the wall
 */
export const IMG_4y0YuBV1MYQobkJlzf44bi = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4y0YuBV1MYQobkJlzf44bi/895dc138b9f09c89cc316a4d955c4b16/meet_hero.jpg',
  description: `SimpliSafe products placed on yellow shelves on the wall`,
  originalHeight: 2250,
  originalWidth: 4336
}

/**
 * ![Header | Installation Options](https://images.ctfassets.net/v6awd0kabi65/4ISQo32VbzFoCuz0sPSEIb/4a53241403c97efe08974cccbd1e3f6d/Navigation_Installation_Options_2.png?w=120&h=120&fit=pad)
 *
 * Header | Installation Options
 *
 * Installation Options
 */
export const IMG_4ISQo32VbzFoCuz0sPSEIb = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4ISQo32VbzFoCuz0sPSEIb/4a53241403c97efe08974cccbd1e3f6d/Navigation_Installation_Options_2.png',
  description: `Installation Options`,
  originalHeight: 456,
  originalWidth: 683
}

/**
 * ![[UK] ODCam app 4](https://images.ctfassets.net/v6awd0kabi65/2pND2fGDwpJhaujr5TJL2X/96ad32dbf69830dbc0a9bbaadff97585/ODCam_app_4.png?w=120&h=120&fit=pad)
 *
 * [UK] ODCam app 4
 *
 *
 */
export const IMG_2pND2fGDwpJhaujr5TJL2X = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2pND2fGDwpJhaujr5TJL2X/96ad32dbf69830dbc0a9bbaadff97585/ODCam_app_4.png',
  description: ``,
  originalHeight: 627,
  originalWidth: 500
}

/**
 * ![Homepage UK - Hero Banner - Tablet - Dark](https://images.ctfassets.net/v6awd0kabi65/2glOSn1IJriK81ojLxHlTo/65234b6ce56edc239e8da0f43d2f599f/Homepage_Hero_Tablet.png?w=120&h=120&fit=pad)
 *
 * Homepage UK - Hero Banner - Tablet - Dark
 *
 * SimpliSafe Homepage Hero Image
 */
export const IMG_2glOSn1IJriK81ojLxHlTo = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2glOSn1IJriK81ojLxHlTo/65234b6ce56edc239e8da0f43d2f599f/Homepage_Hero_Tablet.png',
  description: `SimpliSafe Homepage Hero Image`,
  originalHeight: 2662,
  originalWidth: 4346
}

/**
 * ![Hero - Build my system (olympus) - Mobile](https://images.ctfassets.net/v6awd0kabi65/1ysl2xlOWbEQt38m4z6Ro9/15870293384e6cbae6da7a193ed84f15/Shop_Page_Hero_Mobile.png?w=120&h=120&fit=pad)
 *
 * Hero - Build my system (olympus) - Mobile
 *
 * null
 */
export const IMG_1ysl2xlOWbEQt38m4z6Ro9 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1ysl2xlOWbEQt38m4z6Ro9/15870293384e6cbae6da7a193ed84f15/Shop_Page_Hero_Mobile.png',
  description: `null`,
  originalHeight: 882,
  originalWidth: 1008
}

/**
 * ![[UK] Installation Desktop](https://images.ctfassets.net/v6awd0kabi65/3uVBQT3w3hf6GVjMyiyngG/e2d4ebd5c6e6a175cfc8db9103be8441/Installation_Desktop.png?w=120&h=120&fit=pad)
 *
 * [UK] Installation Desktop
 *
 *
 */
export const IMG_3uVBQT3w3hf6GVjMyiyngG = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3uVBQT3w3hf6GVjMyiyngG/e2d4ebd5c6e6a175cfc8db9103be8441/Installation_Desktop.png',
  description: ``,
  originalHeight: 740,
  originalWidth: 1316
}

/**
 * ![ODCamS2 Emergency](https://images.ctfassets.net/v6awd0kabi65/4OfcOCqTkaT4XPEWPsqXiM/23e326c7c66212355da192009b627293/ODCamS2_Emergency.png?w=120&h=120&fit=pad)
 *
 * ODCamS2 Emergency
 *
 *
 */
export const IMG_4OfcOCqTkaT4XPEWPsqXiM = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4OfcOCqTkaT4XPEWPsqXiM/23e326c7c66212355da192009b627293/ODCamS2_Emergency.png',
  description: ``,
  originalHeight: 397,
  originalWidth: 631
}

/**
 * ![[UK] ODCam app 3](https://images.ctfassets.net/v6awd0kabi65/01aZIzl0994trRU5KMuLP4/6213e4cf6764de6dbe6a0aab5219102b/ODCam_app_3.png?w=120&h=120&fit=pad)
 *
 * [UK] ODCam app 3
 *
 *
 */
export const IMG_01aZIzl0994trRU5KMuLP4 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/01aZIzl0994trRU5KMuLP4/6213e4cf6764de6dbe6a0aab5219102b/ODCam_app_3.png',
  description: ``,
  originalHeight: 627,
  originalWidth: 500
}

/**
 * ![[UK] ODCam app 2](https://images.ctfassets.net/v6awd0kabi65/38GKdDLCrqliHvbbvyES55/8fa12dc95322fbcc01ba333e26b80ff6/ODCam_app_2.png?w=120&h=120&fit=pad)
 *
 * [UK] ODCam app 2
 *
 *
 */
export const IMG_38GKdDLCrqliHvbbvyES55 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/38GKdDLCrqliHvbbvyES55/8fa12dc95322fbcc01ba333e26b80ff6/ODCam_app_2.png',
  description: ``,
  originalHeight: 627,
  originalWidth: 500
}

/**
 * ![[UK] ODCam app 1](https://images.ctfassets.net/v6awd0kabi65/51VX7AOaUBRgDxAkgVeCYh/bedff51fd9a74d852eacf19b6a45c4f2/ODCam_app_1.png?w=120&h=120&fit=pad)
 *
 * [UK] ODCam app 1
 *
 *
 */
export const IMG_51VX7AOaUBRgDxAkgVeCYh = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/51VX7AOaUBRgDxAkgVeCYh/bedff51fd9a74d852eacf19b6a45c4f2/ODCam_app_1.png',
  description: ``,
  originalHeight: 1254,
  originalWidth: 1011
}

/**
 * ![[UK] ODCamS2 diagram 2](https://images.ctfassets.net/v6awd0kabi65/5Fn37EYLH5AG0NLizVp0kh/09756e95f07d02dc784c33562e95784e/ODCamS2_diagram_2.png?w=120&h=120&fit=pad)
 *
 * [UK] ODCamS2 diagram 2
 *
 *
 */
export const IMG_5Fn37EYLH5AG0NLizVp0kh = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5Fn37EYLH5AG0NLizVp0kh/09756e95f07d02dc784c33562e95784e/ODCamS2_diagram_2.png',
  description: ``,
  originalHeight: 2200,
  originalWidth: 2198
}

/**
 * ![[UK] ODCamS2 diagram 1](https://images.ctfassets.net/v6awd0kabi65/23SVqriIUGnHc6GlNet2T/b262cf0696d690f00862f624ff7f3dc1/ODCamS2_diagram_1.png?w=120&h=120&fit=pad)
 *
 * [UK] ODCamS2 diagram 1
 *
 *
 */
export const IMG_23SVqriIUGnHc6GlNet2T = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/23SVqriIUGnHc6GlNet2T/b262cf0696d690f00862f624ff7f3dc1/ODCamS2_diagram_1.png',
  description: ``,
  originalHeight: 2200,
  originalWidth: 2198
}

/**
 * ![[UK] Olympus - Carousel 3 Desktop](https://images.ctfassets.net/v6awd0kabi65/1OLctwyjhYPmixqSl1olsa/770191bdf752484c93b4f47e736a132e/PDP_Carousel_3_Desktop.png?w=120&h=120&fit=pad)
 *
 * [UK] Olympus - Carousel 3 Desktop
 *
 *
 */
export const IMG_1OLctwyjhYPmixqSl1olsa = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1OLctwyjhYPmixqSl1olsa/770191bdf752484c93b4f47e736a132e/PDP_Carousel_3_Desktop.png',
  description: ``,
  originalHeight: 882,
  originalWidth: 1118
}

/**
 * ![[UK] Olympus - Carousel 2 Desktop](https://images.ctfassets.net/v6awd0kabi65/55v1pcIESQS2MNQcmQzsSL/ba6c82b65e6c069c68a5cc9f71b84b0e/PDP_Carousel_2_Desktop.png?w=120&h=120&fit=pad)
 *
 * [UK] Olympus - Carousel 2 Desktop
 *
 *
 */
export const IMG_55v1pcIESQS2MNQcmQzsSL = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/55v1pcIESQS2MNQcmQzsSL/ba6c82b65e6c069c68a5cc9f71b84b0e/PDP_Carousel_2_Desktop.png',
  description: ``,
  originalHeight: 882,
  originalWidth: 1118
}

/**
 * ![[UK] Olympus - Carousel 1 Desktop](https://images.ctfassets.net/v6awd0kabi65/2iDaD4YVC6qwaDk5X4JHJB/d012e8d054b59ec411d21cd8b53fc50d/PDP_Carousel_1_Desktop.png?w=120&h=120&fit=pad)
 *
 * [UK] Olympus - Carousel 1 Desktop
 *
 *
 */
export const IMG_2iDaD4YVC6qwaDk5X4JHJB = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2iDaD4YVC6qwaDk5X4JHJB/d012e8d054b59ec411d21cd8b53fc50d/PDP_Carousel_1_Desktop.png',
  description: ``,
  originalHeight: 882,
  originalWidth: 1118
}

/**
 * ![Package in your home Mobile](https://images.ctfassets.net/v6awd0kabi65/B7VBHFX3CJa8dk693b1vW/c9005a819c32acef78c7afb0d438e9ac/Package_in_your_home_Mobile.png?w=120&h=120&fit=pad)
 *
 * Package in your home Mobile
 *
 *
 */
export const IMG_B7VBHFX3CJa8dk693b1vW = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/B7VBHFX3CJa8dk693b1vW/c9005a819c32acef78c7afb0d438e9ac/Package_in_your_home_Mobile.png',
  description: ``,
  originalHeight: 512,
  originalWidth: 590
}

/**
 * ![Package in your home Desktop](https://images.ctfassets.net/v6awd0kabi65/2xAudPMUnu1CnKtob0e8gL/6b8af164ea4d2b1146f63a90359746d4/Package_in_your_home_Desktop.png?w=120&h=120&fit=pad)
 *
 * Package in your home Desktop
 *
 *
 */
export const IMG_2xAudPMUnu1CnKtob0e8gL = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2xAudPMUnu1CnKtob0e8gL/6b8af164ea4d2b1146f63a90359746d4/Package_in_your_home_Desktop.png',
  description: ``,
  originalHeight: 729,
  originalWidth: 1094
}

/**
 * ![12 best true crime documentaries](https://images.ctfassets.net/v6awd0kabi65/1WHyoHwYLQCghNF5DKHXZs/9dc82314079ac76dba950050946f8af0/amjith-s-6ZUiox8TqtY-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * 12 best true crime documentaries
 *
 * Discover the 12 best true crime documentaries that have captivated audiences worldwide, from groundbreaking classics to modern masterpieces.
 */
export const IMG_1WHyoHwYLQCghNF5DKHXZs = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1WHyoHwYLQCghNF5DKHXZs/9dc82314079ac76dba950050946f8af0/amjith-s-6ZUiox8TqtY-unsplash.jpg',
  description: `Discover the 12 best true crime documentaries that have captivated audiences worldwide, from groundbreaking classics to modern masterpieces.`,
  originalHeight: 4000,
  originalWidth: 6000
}

/**
 * ![Co-op Insurance Whole Home Protection Kit](https://images.ctfassets.net/v6awd0kabi65/FFyRxnDeZLgXX2gDZbSOS/928be00311fc7f88399333d1d4e49b5c/Coop_Package_0325_edited.png?w=120&h=120&fit=pad)
 *
 * Co-op Insurance Whole Home Protection Kit
 *
 * Insurance Whole Home Protection Kit
 */
export const IMG_FFyRxnDeZLgXX2gDZbSOS = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/FFyRxnDeZLgXX2gDZbSOS/928be00311fc7f88399333d1d4e49b5c/Coop_Package_0325_edited.png',
  description: `Insurance Whole Home Protection Kit`,
  originalHeight: 2248,
  originalWidth: 1962
}

/**
 * ![Co-op Insurance Hero banner image](https://images.ctfassets.net/v6awd0kabi65/6MMY8BmKheNLBMMggzemW/00f30d71f69c65deeb59297b3ba77338/Hero.png?w=120&h=120&fit=pad)
 *
 * Co-op Insurance Hero banner image
 *
 * null
 */
export const IMG_6MMY8BmKheNLBMMggzemW = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6MMY8BmKheNLBMMggzemW/00f30d71f69c65deeb59297b3ba77338/Hero.png',
  description: `null`,
  originalHeight: 1300,
  originalWidth: 2888
}

/**
 * ![Shield Modal BG](https://images.ctfassets.net/v6awd0kabi65/2AB2d5pVj16iZItrZqOx5d/5b1db4026879652a81da0900d5610bd9/Shield.png?w=120&h=120&fit=pad)
 *
 * Shield Modal BG
 *
 * Navy blue outline of a shield
 */
export const IMG_2AB2d5pVj16iZItrZqOx5d = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2AB2d5pVj16iZItrZqOx5d/5b1db4026879652a81da0900d5610bd9/Shield.png',
  description: `Navy blue outline of a shield`,
  originalHeight: 1751,
  originalWidth: 1485
}

/**
 * ![Temperature Sensor](https://images.ctfassets.net/v6awd0kabi65/1sPS7mITMysngorbMDJOS3/75e193cd4702837c48af7ee8cfec7fe5/temperature.png?w=120&h=120&fit=pad)
 *
 * Temperature Sensor
 *
 * Image of a temperature sensor on a solid white background
 */
export const IMG_1sPS7mITMysngorbMDJOS3 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1sPS7mITMysngorbMDJOS3/75e193cd4702837c48af7ee8cfec7fe5/temperature.png',
  description: `Image of a temperature sensor on a solid white background`,
  originalHeight: 560,
  originalWidth: 700
}

/**
 * ![Water Sensor](https://images.ctfassets.net/v6awd0kabi65/6letlJhafwjPoXoZOUTFEY/604d2857b612e03c7eaa448f0a1cde3d/water.png?w=120&h=120&fit=pad)
 *
 * Water Sensor
 *
 * Image of water sensor on a solid white background
 */
export const IMG_6letlJhafwjPoXoZOUTFEY = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6letlJhafwjPoXoZOUTFEY/604d2857b612e03c7eaa448f0a1cde3d/water.png',
  description: `Image of water sensor on a solid white background`,
  originalHeight: 600,
  originalWidth: 600
}

/**
 * ![Smoke Detector](https://images.ctfassets.net/v6awd0kabi65/2Sbcjss5JfMJDk7gJIPHBS/cd3aa18ce0801411d4c0a3f31a73b533/smoke.jpg?w=120&h=120&fit=pad)
 *
 * Smoke Detector
 *
 * Image of a smoke detector on a solid white background
 */
export const IMG_2Sbcjss5JfMJDk7gJIPHBS = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2Sbcjss5JfMJDk7gJIPHBS/cd3aa18ce0801411d4c0a3f31a73b533/smoke.jpg',
  description: `Image of a smoke detector on a solid white background`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Carbon Monoxide Sensor](https://images.ctfassets.net/v6awd0kabi65/45QRpcZPo3adRlobwdb3hq/d084a7ca6d25cbf13e6c72f926a0896b/co2.png?w=120&h=120&fit=pad)
 *
 * Carbon Monoxide Sensor
 *
 * Image of a carbon monoxide detector on a solid white background
 */
export const IMG_45QRpcZPo3adRlobwdb3hq = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/45QRpcZPo3adRlobwdb3hq/d084a7ca6d25cbf13e6c72f926a0896b/co2.png',
  description: `Image of a carbon monoxide detector on a solid white background`,
  originalHeight: 599,
  originalWidth: 610
}

/**
 * ![Panic Button](https://images.ctfassets.net/v6awd0kabi65/19lZwHVDpMPbsQ7phLAfPO/444355714135df4fdd9084743b661c80/panic.png?w=120&h=120&fit=pad)
 *
 * Panic Button
 *
 * Image of a panic button on a solid white background
 */
export const IMG_19lZwHVDpMPbsQ7phLAfPO = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/19lZwHVDpMPbsQ7phLAfPO/444355714135df4fdd9084743b661c80/panic.png',
  description: `Image of a panic button on a solid white background`,
  originalHeight: 600,
  originalWidth: 600
}

/**
 * ![Motion Sensor](https://images.ctfassets.net/v6awd0kabi65/5yr32UluZp32nfrU3FlWkM/a0a2e7a492db7435876e252f3d9d93d1/motion.png?w=120&h=120&fit=pad)
 *
 * Motion Sensor
 *
 * Image of a motion sensor on a solid white background
 */
export const IMG_5yr32UluZp32nfrU3FlWkM = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5yr32UluZp32nfrU3FlWkM/a0a2e7a492db7435876e252f3d9d93d1/motion.png',
  description: `Image of a motion sensor on a solid white background`,
  originalHeight: 600,
  originalWidth: 600
}

/**
 * ![Glassbreak Sensor](https://images.ctfassets.net/v6awd0kabi65/4F3ExonC7y0tQ8O4lZ9a4t/21ec83b6838a15ff9e24ea8d1cbdc81b/glassbreak.png?w=120&h=120&fit=pad)
 *
 * Glassbreak Sensor
 *
 * Image of a glassbreak sensor on a solid white background
 */
export const IMG_4F3ExonC7y0tQ8O4lZ9a4t = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4F3ExonC7y0tQ8O4lZ9a4t/21ec83b6838a15ff9e24ea8d1cbdc81b/glassbreak.png',
  description: `Image of a glassbreak sensor on a solid white background`,
  originalHeight: 600,
  originalWidth: 600
}

/**
 * ![Base Station](https://images.ctfassets.net/v6awd0kabi65/139dN5wuBmSiaaz2WAQ5g6/f8ba076798562395cf8e818edfa1aff0/base.jpg?w=120&h=120&fit=pad)
 *
 * Base Station
 *
 * Image of a base station on a solid white background
 */
export const IMG_139dN5wuBmSiaaz2WAQ5g6 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/139dN5wuBmSiaaz2WAQ5g6/f8ba076798562395cf8e818edfa1aff0/base.jpg',
  description: `Image of a base station on a solid white background`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Entry Sensor](https://images.ctfassets.net/v6awd0kabi65/3H83gutAQyOI8Mc1rfdFnU/d1c78698e2c11675af775c357780f507/carousel_entry_sensor.jpeg?w=120&h=120&fit=pad)
 *
 * Entry Sensor
 *
 * Image of an entry sensor on a solid white background
 */
export const IMG_3H83gutAQyOI8Mc1rfdFnU = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3H83gutAQyOI8Mc1rfdFnU/d1c78698e2c11675af775c357780f507/carousel_entry_sensor.jpeg',
  description: `Image of an entry sensor on a solid white background`,
  originalHeight: 600,
  originalWidth: 680
}

/**
 * ![Indoor Camera](https://images.ctfassets.net/v6awd0kabi65/6lQ70X94hbqnOz5gSptpJc/26ca684cdf9dd85ab1dc9f28673af35b/indoor.png?w=120&h=120&fit=pad)
 *
 * Indoor Camera
 *
 * Image of a Simplicam on a solid white background
 */
export const IMG_6lQ70X94hbqnOz5gSptpJc = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6lQ70X94hbqnOz5gSptpJc/26ca684cdf9dd85ab1dc9f28673af35b/indoor.png',
  description: `Image of a Simplicam on a solid white background`,
  originalHeight: 898,
  originalWidth: 898
}

/**
 * ![Smart Lock](https://images.ctfassets.net/v6awd0kabi65/7hVCjiF2CW72XzaUO63D9V/c857706e1bcf6a47d4227f67b35b0726/smartlock.png?w=120&h=120&fit=pad)
 *
 * Smart Lock
 *
 * Image of a smart lock and pin pad on a solid white background
 */
export const IMG_7hVCjiF2CW72XzaUO63D9V = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7hVCjiF2CW72XzaUO63D9V/c857706e1bcf6a47d4227f67b35b0726/smartlock.png',
  description: `Image of a smart lock and pin pad on a solid white background`,
  originalHeight: 898,
  originalWidth: 898
}

/**
 * ![Water Sensor (Transparent)](https://images.ctfassets.net/v6awd0kabi65/4nAq1W1cB1mBDR6X9b8frb/f3814ac58dd2d7fcd2842ea86080896f/water.png?w=120&h=120&fit=pad)
 *
 * Water Sensor (Transparent)
 *
 * Image of a water sensor on a solid white background
 */
export const IMG_4nAq1W1cB1mBDR6X9b8frb = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4nAq1W1cB1mBDR6X9b8frb/f3814ac58dd2d7fcd2842ea86080896f/water.png',
  description: `Image of a water sensor on a solid white background`,
  originalHeight: 400,
  originalWidth: 640
}

/**
 * ![Pro Setup](https://images.ctfassets.net/v6awd0kabi65/4msMFo3ia5cHLBelaoYc6Q/8a5772182a4febb1108b02bd25c862b8/pro.jpg?w=120&h=120&fit=pad)
 *
 * Pro Setup
 *
 * Image of a keypad mounted to a wall with a person arming it
 */
export const IMG_4msMFo3ia5cHLBelaoYc6Q = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4msMFo3ia5cHLBelaoYc6Q/8a5772182a4febb1108b02bd25c862b8/pro.jpg',
  description: `Image of a keypad mounted to a wall with a person arming it`,
  originalHeight: 900,
  originalWidth: 900
}

/**
 * ![Temperature Sensor (Transparent)](https://images.ctfassets.net/v6awd0kabi65/2Cx0DsvcjJXogpyhtYA026/5bfd9fb56e409374844c9a4cd910a4eb/temperature.png?w=120&h=120&fit=pad)
 *
 * Temperature Sensor (Transparent)
 *
 * Image of a temperature sensor on a solid white background
 */
export const IMG_2Cx0DsvcjJXogpyhtYA026 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2Cx0DsvcjJXogpyhtYA026/5bfd9fb56e409374844c9a4cd910a4eb/temperature.png',
  description: `Image of a temperature sensor on a solid white background`,
  originalHeight: 600,
  originalWidth: 408
}

/**
 * ![Smoke Detector (Transparent)](https://images.ctfassets.net/v6awd0kabi65/CVfLvBESqv6BrUEPcQXFA/4878ff2b4d3b7a7719db7e61688ee423/smoke.png?w=120&h=120&fit=pad)
 *
 * Smoke Detector (Transparent)
 *
 * Image of a smoke detector on a solid white background
 */
export const IMG_CVfLvBESqv6BrUEPcQXFA = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/CVfLvBESqv6BrUEPcQXFA/4878ff2b4d3b7a7719db7e61688ee423/smoke.png',
  description: `Image of a smoke detector on a solid white background`,
  originalHeight: 1498,
  originalWidth: 1665
}

/**
 * ![105dB Siren (Transparent)](https://images.ctfassets.net/v6awd0kabi65/4dPpDDaUoFmvKmCptvZhNx/66bed0e7c09af1ab6ffd7ec915ff4ff0/siren.png?w=120&h=120&fit=pad)
 *
 * 105dB Siren (Transparent)
 *
 * Image of a siren on a solid white background
 */
export const IMG_4dPpDDaUoFmvKmCptvZhNx = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4dPpDDaUoFmvKmCptvZhNx/66bed0e7c09af1ab6ffd7ec915ff4ff0/siren.png',
  description: `Image of a siren on a solid white background`,
  originalHeight: 2603,
  originalWidth: 2054
}

/**
 * ![Motion Sensor (Transparent)](https://images.ctfassets.net/v6awd0kabi65/3i6yw77vMmzY7KQj8wns54/57ede9de2926f0cf81fb1f27b426df5e/motion.png?w=120&h=120&fit=pad)
 *
 * Motion Sensor (Transparent)
 *
 * Image of a glassbreak sensor on a solid white background
 */
export const IMG_3i6yw77vMmzY7KQj8wns54 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3i6yw77vMmzY7KQj8wns54/57ede9de2926f0cf81fb1f27b426df5e/motion.png',
  description: `Image of a glassbreak sensor on a solid white background`,
  originalHeight: 1620,
  originalWidth: 1606
}

/**
 * ![Panic Button (Transparent)](https://images.ctfassets.net/v6awd0kabi65/68Wm0Vx5ALfz1VRGRaf29q/0cd1cfa2657299800d54426cf3b7cc43/panic.png?w=120&h=120&fit=pad)
 *
 * Panic Button (Transparent)
 *
 * Image of a panic button on a solid white background
 */
export const IMG_68Wm0Vx5ALfz1VRGRaf29q = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/68Wm0Vx5ALfz1VRGRaf29q/0cd1cfa2657299800d54426cf3b7cc43/panic.png',
  description: `Image of a panic button on a solid white background`,
  originalHeight: 1500,
  originalWidth: 1095
}

/**
 * ![Wireless Outdoor Camera (Transparent)](https://images.ctfassets.net/v6awd0kabi65/2ebrayaENaCRGmTq80j6HB/73e6bf526b3ec5b5fbcb51a9a6b74c41/outdoor.png?w=120&h=120&fit=pad)
 *
 * Wireless Outdoor Camera (Transparent)
 *
 * Image of an outdoor camera on a solid white background
 */
export const IMG_2ebrayaENaCRGmTq80j6HB = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2ebrayaENaCRGmTq80j6HB/73e6bf526b3ec5b5fbcb51a9a6b74c41/outdoor.png',
  description: `Image of an outdoor camera on a solid white background`,
  originalHeight: 288,
  originalWidth: 286
}

/**
 * ![9" x 9" Yard Sign (Transparent)](https://images.ctfassets.net/v6awd0kabi65/3ngRqeN7Wlr5YqPU3TaPOt/ec015318a03c66244cc407be877f72b2/sign.png?w=120&h=120&fit=pad)
 *
 * 9" x 9" Yard Sign (Transparent)
 *
 * Image of a Simplisafe yard sign on a solid white background
 */
export const IMG_3ngRqeN7Wlr5YqPU3TaPOt = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3ngRqeN7Wlr5YqPU3TaPOt/ec015318a03c66244cc407be877f72b2/sign.png',
  description: `Image of a Simplisafe yard sign on a solid white background`,
  originalHeight: 2000,
  originalWidth: 2000
}

/**
 * ![Base Station (Transparent)](https://images.ctfassets.net/v6awd0kabi65/syXtA2wv2GwEk46bHx1qN/659bcd1d3c0088a664e2c329c6e800c6/base.png?w=120&h=120&fit=pad)
 *
 * Base Station (Transparent)
 *
 * Image of a base station on a solid white background
 */
export const IMG_syXtA2wv2GwEk46bHx1qN = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/syXtA2wv2GwEk46bHx1qN/659bcd1d3c0088a664e2c329c6e800c6/base.png',
  description: `Image of a base station on a solid white background`,
  originalHeight: 534,
  originalWidth: 249
}

/**
 * ![Indoor Camera (Transparent)](https://images.ctfassets.net/v6awd0kabi65/15nhH8MzwlG9vRkq4HOKkG/4ffb80be29c6b3197ddddcb9a72a294d/indoor.png?w=120&h=120&fit=pad)
 *
 * Indoor Camera (Transparent)
 *
 * Image of a Simplicam on a solid white background
 */
export const IMG_15nhH8MzwlG9vRkq4HOKkG = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/15nhH8MzwlG9vRkq4HOKkG/4ffb80be29c6b3197ddddcb9a72a294d/indoor.png',
  description: `Image of a Simplicam on a solid white background`,
  originalHeight: 1067,
  originalWidth: 721
}

/**
 * ![Key Fob (Transparent)](https://images.ctfassets.net/v6awd0kabi65/1TJDRKwndnWIcFV826SxjI/cd3436bd089e28f6a9fe0e9f0788a9f5/fob.png?w=120&h=120&fit=pad)
 *
 * Key Fob (Transparent)
 *
 * Image of a keyfob on a solid white background
 */
export const IMG_1TJDRKwndnWIcFV826SxjI = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1TJDRKwndnWIcFV826SxjI/cd3436bd089e28f6a9fe0e9f0788a9f5/fob.png',
  description: `Image of a keyfob on a solid white background`,
  originalHeight: 2945,
  originalWidth: 1251
}

/**
 * ![Glassbreak Sensor (Transparent)](https://images.ctfassets.net/v6awd0kabi65/1qu9S9NY5rPyKy9rE6dOXx/8934fc9aebfc7db97f85be92f617f3df/glassbreak.png?w=120&h=120&fit=pad)
 *
 * Glassbreak Sensor (Transparent)
 *
 * Image of a glassbreak sensor on a solid white background
 */
export const IMG_1qu9S9NY5rPyKy9rE6dOXx = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1qu9S9NY5rPyKy9rE6dOXx/8934fc9aebfc7db97f85be92f617f3df/glassbreak.png',
  description: `Image of a glassbreak sensor on a solid white background`,
  originalHeight: 1620,
  originalWidth: 1606
}

/**
 * ![Entry Sensor (Transparent)](https://images.ctfassets.net/v6awd0kabi65/4VwKAKZNht7NSVC9mABCnS/352bb16460fad2623b24f107835b72b3/entry.png?w=120&h=120&fit=pad)
 *
 * Entry Sensor (Transparent)
 *
 * Image of an entry sensor on a solid white background
 */
export const IMG_4VwKAKZNht7NSVC9mABCnS = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4VwKAKZNht7NSVC9mABCnS/352bb16460fad2623b24f107835b72b3/entry.png',
  description: `Image of an entry sensor on a solid white background`,
  originalHeight: 352,
  originalWidth: 387
}

/**
 * ![Keypad (Transparent)](https://images.ctfassets.net/v6awd0kabi65/1iasco6G4Awx32FFTuZm3W/7163b1e580c7574ef4c3d8ae5ebae6fd/keypad.png?w=120&h=120&fit=pad)
 *
 * Keypad (Transparent)
 *
 * Image of a keypad on a solid white background
 */
export const IMG_1iasco6G4Awx32FFTuZm3W = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1iasco6G4Awx32FFTuZm3W/7163b1e580c7574ef4c3d8ae5ebae6fd/keypad.png',
  description: `Image of a keypad on a solid white background`,
  originalHeight: 456,
  originalWidth: 222
}

/**
 * ![Keypad](https://images.ctfassets.net/v6awd0kabi65/3XwLtL7NtO1GPDz41voMHw/11303145bc1b986984b9fe3de4e48757/keypad.png?w=120&h=120&fit=pad)
 *
 * Keypad
 *
 * Image of a keypad on a solid white background
 */
export const IMG_3XwLtL7NtO1GPDz41voMHw = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3XwLtL7NtO1GPDz41voMHw/11303145bc1b986984b9fe3de4e48757/keypad.png',
  description: `Image of a keypad on a solid white background`,
  originalHeight: 600,
  originalWidth: 600
}

/**
 * ![Outdoor Camera Battery (Transparent)](https://images.ctfassets.net/v6awd0kabi65/59Tps9lcBV8YrlhOLiULtd/b5a1f328a23c6e0cf20f58029509b047/20-0129_Shield.736_copy__1_.png?w=120&h=120&fit=pad)
 *
 * Outdoor Camera Battery (Transparent)
 *
 * Image of a camera battery on a solid white background
 */
export const IMG_59Tps9lcBV8YrlhOLiULtd = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/59Tps9lcBV8YrlhOLiULtd/b5a1f328a23c6e0cf20f58029509b047/20-0129_Shield.736_copy__1_.png',
  description: `Image of a camera battery on a solid white background`,
  originalHeight: 1599,
  originalWidth: 2400
}

/**
 * ![T3 Logo](https://images.ctfassets.net/v6awd0kabi65/gb4WWrMmSezwqxGvnvfm2/fb67105165089333ed6dba559e97bd35/t3.png?w=120&h=120&fit=pad)
 *
 * T3 Logo
 *
 * Image of T3 logo on a red background
 */
export const IMG_gb4WWrMmSezwqxGvnvfm2 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/gb4WWrMmSezwqxGvnvfm2/fb67105165089333ed6dba559e97bd35/t3.png',
  description: `Image of T3 logo on a red background`,
  originalHeight: 120,
  originalWidth: 120
}

/**
 * ![Built for the Unexpected (mobile)](https://images.ctfassets.net/v6awd0kabi65/bNVdPMXmviQxlWJNJE2KC/a6fc4cd654fb8485d0e40268db5aad24/build-for-the-unexpected-mobile.jpg?w=120&h=120&fit=pad)
 *
 * Built for the Unexpected (mobile)
 *
 * Image of a base station on a white background
 */
export const IMG_bNVdPMXmviQxlWJNJE2KC = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/bNVdPMXmviQxlWJNJE2KC/a6fc4cd654fb8485d0e40268db5aad24/build-for-the-unexpected-mobile.jpg',
  description: `Image of a base station on a white background`,
  originalHeight: 4552,
  originalWidth: 2956
}

/**
 * ![Smart Lock (Lifestyle)](https://images.ctfassets.net/v6awd0kabi65/6PX5OUxznSGCkzokmTU8Ps/80efe2c08c1e5b2c5d26f5bcf48c05aa/smartlock_lifestyle.jpg?w=120&h=120&fit=pad)
 *
 * Smart Lock (Lifestyle)
 *
 * Image of a smart lock mounted to a door
 */
export const IMG_6PX5OUxznSGCkzokmTU8Ps = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6PX5OUxznSGCkzokmTU8Ps/80efe2c08c1e5b2c5d26f5bcf48c05aa/smartlock_lifestyle.jpg',
  description: `Image of a smart lock mounted to a door`,
  originalHeight: 1260,
  originalWidth: 2460
}

/**
 * ![Smart Lock (Transparent)](https://images.ctfassets.net/v6awd0kabi65/3p0olIUReUceU5nzx1q1He/bc1b7423bfd862e1db7e30d8b8616a2d/shop-landing_white-lock.png?w=120&h=120&fit=pad)
 *
 * Smart Lock (Transparent)
 *
 * Image of a smart lock on a white background
 */
export const IMG_3p0olIUReUceU5nzx1q1He = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3p0olIUReUceU5nzx1q1He/bc1b7423bfd862e1db7e30d8b8616a2d/shop-landing_white-lock.png',
  description: `Image of a smart lock on a white background`,
  originalHeight: 387,
  originalWidth: 160
}

/**
 * ![Smart Lock](https://images.ctfassets.net/v6awd0kabi65/7sxL6QjSJP2CSeFBbmUoeV/9e6401da90ba7de06a321a7c532b7546/smart_lock.jpg?w=120&h=120&fit=pad)
 *
 * Smart Lock
 *
 * Image of a smart lock on a plain white background
 */
export const IMG_7sxL6QjSJP2CSeFBbmUoeV = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7sxL6QjSJP2CSeFBbmUoeV/9e6401da90ba7de06a321a7c532b7546/smart_lock.jpg',
  description: `Image of a smart lock on a plain white background`,
  originalHeight: 1200,
  originalWidth: 1500
}

/**
 * ![Star](https://images.ctfassets.net/v6awd0kabi65/53GCsr3Ucka1LtMeyTvCVL/fad25f39ce1e29eade4ee92fb733ebbb/star.svg?w=120&h=120&fit=pad)
 *
 * Star
 *
 * Image of a yellow star
 */
export const IMG_53GCsr3Ucka1LtMeyTvCVL = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/53GCsr3Ucka1LtMeyTvCVL/fad25f39ce1e29eade4ee92fb733ebbb/star.svg',
  description: `Image of a yellow star`,
  originalHeight: 15,
  originalWidth: 15
}

/**
 * ![PLA Package - SEO Image](https://images.ctfassets.net/v6awd0kabi65/53Kx63MinKfftuUFhqcQca/1fb525c160fc3d845e25f7c43592c37e/pla.png?w=120&h=120&fit=pad)
 *
 * PLA Package - SEO Image
 *
 * Image of a base station sitting on a table
 */
export const IMG_53Kx63MinKfftuUFhqcQca = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/53Kx63MinKfftuUFhqcQca/1fb525c160fc3d845e25f7c43592c37e/pla.png',
  description: `Image of a base station sitting on a table`,
  originalHeight: 810,
  originalWidth: 810
}

/**
 * ![3 - Whole Home Protection - Water, Smoke & Temp](https://images.ctfassets.net/v6awd0kabi65/2o4umBL1IdM65dO7yq2zxm/aa17352eec266e3c8a28b32fb0d939f8/hazard.png?w=120&h=120&fit=pad)
 *
 * 3 - Whole Home Protection - Water, Smoke & Temp
 *
 * Image of hazard sensors including a smoke detector, water sensor and temperature sensor
 */
export const IMG_2o4umBL1IdM65dO7yq2zxm = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2o4umBL1IdM65dO7yq2zxm/aa17352eec266e3c8a28b32fb0d939f8/hazard.png',
  description: `Image of hazard sensors including a smoke detector, water sensor and temperature sensor`,
  originalHeight: 634,
  originalWidth: 1164
}

/**
 * ![BMS Self Install](https://images.ctfassets.net/v6awd0kabi65/4XVnzPqpzZnQsgOABFsXpU/854cfdf9eb70d3caad09c11203a67b38/self-install.png?w=120&h=120&fit=pad)
 *
 * BMS Self Install
 *
 * Image of a home security system in a box
 */
export const IMG_4XVnzPqpzZnQsgOABFsXpU = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4XVnzPqpzZnQsgOABFsXpU/854cfdf9eb70d3caad09c11203a67b38/self-install.png',
  description: `Image of a home security system in a box`,
  originalHeight: 240,
  originalWidth: 240
}

/**
 * ![BMS Pro Install](https://images.ctfassets.net/v6awd0kabi65/3eYDvY5GKAZK4haI3keur/637d63d154c2a3a7389e85f7c134a816/pro-install.png?w=120&h=120&fit=pad)
 *
 * BMS Pro Install
 *
 * Image of a professional installer mounting an outdoor camera to a home
 */
export const IMG_3eYDvY5GKAZK4haI3keur = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3eYDvY5GKAZK4haI3keur/637d63d154c2a3a7389e85f7c134a816/pro-install.png',
  description: `Image of a professional installer mounting an outdoor camera to a home`,
  originalHeight: 240,
  originalWidth: 240
}

/**
 * ![Meet SimpliSafe, Home Security Done Right](https://images.ctfassets.net/v6awd0kabi65/4pPFMFIvuI70Dv9EaUsTBu/246abcbcbb4217412b5160de7523b969/Meet_SimpliSafe__Home_Security_Done_Right.jpg?w=120&h=120&fit=pad)
 *
 * Meet SimpliSafe, Home Security Done Right
 *
 * Image of a home security system sitting on a tabletop
 */
export const IMG_4pPFMFIvuI70Dv9EaUsTBu = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4pPFMFIvuI70Dv9EaUsTBu/246abcbcbb4217412b5160de7523b969/Meet_SimpliSafe__Home_Security_Done_Right.jpg',
  description: `Image of a home security system sitting on a tabletop`,
  originalHeight: 480,
  originalWidth: 720
}

/**
 * ![WATCH VIDEO](https://videos.ctfassets.net/v6awd0kabi65/3mw5PqOcOUgvgPjftAZUWz/90dcebb81605c13d2b880ecc258f23af/Simplisafe_Homepage_Carousel_Small.mp4?w=120&h=120&fit=pad)
 *
 * WATCH VIDEO
 *
 * Video
 */
export const IMG_3mw5PqOcOUgvgPjftAZUWz = {
  url: 'https://videos.ctfassets.net/v6awd0kabi65/3mw5PqOcOUgvgPjftAZUWz/90dcebb81605c13d2b880ecc258f23af/Simplisafe_Homepage_Carousel_Small.mp4',
  description: `Video`,
  originalHeight: null,
  originalWidth: null
}

/**
 * ![The ultimate moving house checklist - Main](https://images.ctfassets.net/v6awd0kabi65/2FosbT8aNljroIdGOEJjs5/943c14b40f0aa8d52dc288fff774202d/The_Ultimate_-_Main.png?w=120&h=120&fit=pad)
 *
 * The ultimate moving house checklist - Main
 *
 * Image of a puppy poking its head out of a box
 */
export const IMG_2FosbT8aNljroIdGOEJjs5 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2FosbT8aNljroIdGOEJjs5/943c14b40f0aa8d52dc288fff774202d/The_Ultimate_-_Main.png',
  description: `Image of a puppy poking its head out of a box`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Garden Security - Main](https://images.ctfassets.net/v6awd0kabi65/XCHAMoV8qw2LuD5V6WJyE/0720cd4999deb38ae91d8c79c7ff2b98/Garden_Security_-_Main.png?w=120&h=120&fit=pad)
 *
 * Garden Security - Main
 *
 * Image of a tree with a table and chairs under it during a beautiful day
 */
export const IMG_XCHAMoV8qw2LuD5V6WJyE = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/XCHAMoV8qw2LuD5V6WJyE/0720cd4999deb38ae91d8c79c7ff2b98/Garden_Security_-_Main.png',
  description: `Image of a tree with a table and chairs under it during a beautiful day`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Wifi Home Security - Main](https://images.ctfassets.net/v6awd0kabi65/7w9s4WKoRyZSMH3XBSpXeh/b5c40f3d3363c891c4985337eafda670/Wifi_Home_Security_-_Main.png?w=120&h=120&fit=pad)
 *
 * Wifi Home Security - Main
 *
 * Image of a simplicam on a table
 */
export const IMG_7w9s4WKoRyZSMH3XBSpXeh = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7w9s4WKoRyZSMH3XBSpXeh/b5c40f3d3363c891c4985337eafda670/Wifi_Home_Security_-_Main.png',
  description: `Image of a simplicam on a table`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Types of crime and their definitions](https://images.ctfassets.net/v6awd0kabi65/3gpG2IPf9k5uijbnMuOsVm/48ed41ab1b84b2aa2d4b0dbde76c2c13/Types_of_crime_and_their_definitions.png?w=120&h=120&fit=pad)
 *
 * Types of crime and their definitions
 *
 * Image of fingerprints
 */
export const IMG_3gpG2IPf9k5uijbnMuOsVm = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3gpG2IPf9k5uijbnMuOsVm/48ed41ab1b84b2aa2d4b0dbde76c2c13/Types_of_crime_and_their_definitions.png',
  description: `Image of fingerprints`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![How to prevent pet theft](https://images.ctfassets.net/v6awd0kabi65/1g7bgJ1hxYF1HbDJadgAmi/def920edc379d38f4de7abab0d8f7e8d/How_to_prevent_pet_theft.png?w=120&h=120&fit=pad)
 *
 * How to prevent pet theft
 *
 * Image of brown, white, black and gray puppies
 */
export const IMG_1g7bgJ1hxYF1HbDJadgAmi = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1g7bgJ1hxYF1HbDJadgAmi/def920edc379d38f4de7abab0d8f7e8d/How_to_prevent_pet_theft.png',
  description: `Image of brown, white, black and gray puppies`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Blog Default Image](https://images.ctfassets.net/v6awd0kabi65/9DYxv8R9sNvA6bseklPxi/201ac235f89e075427420d451a6614f9/Blog_Default_Image.jpg?w=120&h=120&fit=pad)
 *
 * Blog Default Image
 *
 * Image of the SimpliSafe logo
 */
export const IMG_9DYxv8R9sNvA6bseklPxi = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/9DYxv8R9sNvA6bseklPxi/201ac235f89e075427420d451a6614f9/Blog_Default_Image.jpg',
  description: `Image of the SimpliSafe logo`,
  originalHeight: 250,
  originalWidth: 350
}

/**
 * ![A Complete Guide To Burglar Alarms](https://images.ctfassets.net/v6awd0kabi65/6K9ebunadEi1tcdwyUZIcE/7a610bb378e993ee509e537db496fbc3/A_Complete_Guide_To_Burglar_Alarms.png?w=120&h=120&fit=pad)
 *
 * A Complete Guide To Burglar Alarms
 *
 * Image of a home security system laid out including a base station, keypad, siren, motion and entry sensors
 */
export const IMG_6K9ebunadEi1tcdwyUZIcE = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6K9ebunadEi1tcdwyUZIcE/7a610bb378e993ee509e537db496fbc3/A_Complete_Guide_To_Burglar_Alarms.png',
  description: `Image of a home security system laid out including a base station, keypad, siren, motion and entry sensors`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![History of burglar alarm systems](https://images.ctfassets.net/v6awd0kabi65/1SF7biL8kgg0wC5xxpZFhZ/7fbc2b8bf2e921dfdafe5005ace814cc/History_of_burglar_alarm_systems.png?w=120&h=120&fit=pad)
 *
 * History of burglar alarm systems
 *
 * Image of a keypad mounted to the wall with someone arming it
 */
export const IMG_1SF7biL8kgg0wC5xxpZFhZ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1SF7biL8kgg0wC5xxpZFhZ/7fbc2b8bf2e921dfdafe5005ace814cc/History_of_burglar_alarm_systems.png',
  description: `Image of a keypad mounted to the wall with someone arming it`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Top Winter Home Maintenance Tips](https://images.ctfassets.net/v6awd0kabi65/1GzUPg353EYhYp2w2F6gHG/676592ec16203bcba0684b5f75023251/Top_Winter_Home_Maintenance_Tips.png?w=120&h=120&fit=pad)
 *
 * Top Winter Home Maintenance Tips
 *
 * Image of a large home covered in snow
 */
export const IMG_1GzUPg353EYhYp2w2F6gHG = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1GzUPg353EYhYp2w2F6gHG/676592ec16203bcba0684b5f75023251/Top_Winter_Home_Maintenance_Tips.png',
  description: `Image of a large home covered in snow`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![How to turn your home security into a Santa cam](https://images.ctfassets.net/v6awd0kabi65/r3PxPHOkGlZ9c1tD0kVHH/bcb5a7ff279b63c54947351f8d13dfa3/How_To_Turn_Your_Home_Security_Into_A_Santa_Cam.png?w=120&h=120&fit=pad)
 *
 * How to turn your home security into a Santa cam
 *
 * Image of a phone looking at indoor camera footage of Santa in the living room
 */
export const IMG_r3PxPHOkGlZ9c1tD0kVHH = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/r3PxPHOkGlZ9c1tD0kVHH/bcb5a7ff279b63c54947351f8d13dfa3/How_To_Turn_Your_Home_Security_Into_A_Santa_Cam.png',
  description: `Image of a phone looking at indoor camera footage of Santa in the living room`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![How to make a garage door more secure - Main](https://images.ctfassets.net/v6awd0kabi65/7aDcRy6pr6v24cJabrnrm0/e621ac4a8f6d6ee4d3d4a8dc2ffc920d/Garage_Door_-_Main.png?w=120&h=120&fit=pad)
 *
 * How to make a garage door more secure - Main
 *
 * Image of a large, beautiful home with a pink sky in the background
 */
export const IMG_7aDcRy6pr6v24cJabrnrm0 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7aDcRy6pr6v24cJabrnrm0/e621ac4a8f6d6ee4d3d4a8dc2ffc920d/Garage_Door_-_Main.png',
  description: `Image of a large, beautiful home with a pink sky in the background`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![A guide to two-factor authentication - Main](https://images.ctfassets.net/v6awd0kabi65/1EgDwY3mU8qgEQx78KVmgo/788fa5df55f62634f4374db3b249e5e2/A_guide_to_two-factor_authentication_-_Main.png?w=120&h=120&fit=pad)
 *
 * A guide to two-factor authentication - Main
 *
 * Image of a man in a coffee shop drinking coffee and looking at a laptop
 */
export const IMG_1EgDwY3mU8qgEQx78KVmgo = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1EgDwY3mU8qgEQx78KVmgo/788fa5df55f62634f4374db3b249e5e2/A_guide_to_two-factor_authentication_-_Main.png',
  description: `Image of a man in a coffee shop drinking coffee and looking at a laptop`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Home and Away Mode 101 - Main](https://images.ctfassets.net/v6awd0kabi65/79KoZubFiUDw9sHPtjpxdw/ee4c9dc38d0539fff75ae98f59b12ae3/Home_and_Away_Mode_101_-_Main.png?w=120&h=120&fit=pad)
 *
 * Home and Away Mode 101 - Main
 *
 * Image of a keypad mounted to a wall and someone arming it
 */
export const IMG_79KoZubFiUDw9sHPtjpxdw = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/79KoZubFiUDw9sHPtjpxdw/ee4c9dc38d0539fff75ae98f59b12ae3/Home_and_Away_Mode_101_-_Main.png',
  description: `Image of a keypad mounted to a wall and someone arming it`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Half of UK - Main](https://images.ctfassets.net/v6awd0kabi65/5H2a4BU1Wqs9sVlY3cymRa/6a6bc4e1bebd58cda5657a9b2966a9fb/Half_of_UK_-_Main.png?w=120&h=120&fit=pad)
 *
 * Half of UK - Main
 *
 * Image of a living room with a couch and other home items in it
 */
export const IMG_5H2a4BU1Wqs9sVlY3cymRa = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5H2a4BU1Wqs9sVlY3cymRa/6a6bc4e1bebd58cda5657a9b2966a9fb/Half_of_UK_-_Main.png',
  description: `Image of a living room with a couch and other home items in it`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Where is the best place to put security cameras? - Main](https://images.ctfassets.net/v6awd0kabi65/3USzgoN7hjElO11w4rxBm0/557a29bf460338567c4c9b02651a3570/Where_is_the_best_place_to_put_security_cameras?w=120&h=120&fit=pad)
 *
 * Where is the best place to put security cameras? - Main
 *
 * Image of a bookshelf in a home
 */
export const IMG_3USzgoN7hjElO11w4rxBm0 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3USzgoN7hjElO11w4rxBm0/557a29bf460338567c4c9b02651a3570/Where_is_the_best_place_to_put_security_cameras',
  description: `Image of a bookshelf in a home`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![What are the most common home insurance claims?](https://images.ctfassets.net/v6awd0kabi65/QqjkYOYXYeiXPqVwip94r/095de39ed585ec619f448932babc7c95/What_are_the_most_common_home_insurance_claims?w=120&h=120&fit=pad)
 *
 * What are the most common home insurance claims?
 *
 * Image of apartment buildings
 */
export const IMG_QqjkYOYXYeiXPqVwip94r = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/QqjkYOYXYeiXPqVwip94r/095de39ed585ec619f448932babc7c95/What_are_the_most_common_home_insurance_claims',
  description: `Image of apartment buildings`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Meet SimpliSafe’s Core Components](https://images.ctfassets.net/v6awd0kabi65/GstYjBRoklC41ohKYUIYd/f31e6ebcc61d88ce1adc91f21a0b2786/Meet_Simplisafe_Core.png?w=120&h=120&fit=pad)
 *
 * Meet SimpliSafe’s Core Components
 *
 * Image of a home security system laid on a table including an indoor camera, entry sensor, base station, keypad and motion sensor
 */
export const IMG_GstYjBRoklC41ohKYUIYd = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/GstYjBRoklC41ohKYUIYd/f31e6ebcc61d88ce1adc91f21a0b2786/Meet_Simplisafe_Core.png',
  description: `Image of a home security system laid on a table including an indoor camera, entry sensor, base station, keypad and motion sensor`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![How to protect your home at night](https://images.ctfassets.net/v6awd0kabi65/4XQVKK3VMFGCVWOUjvQyGH/31d44397d2d97a52cce509410f73f536/How_to_protect_your_home_at_night.png?w=120&h=120&fit=pad)
 *
 * How to protect your home at night
 *
 * Image of a city with buildings and cars
 */
export const IMG_4XQVKK3VMFGCVWOUjvQyGH = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4XQVKK3VMFGCVWOUjvQyGH/31d44397d2d97a52cce509410f73f536/How_to_protect_your_home_at_night.png',
  description: `Image of a city with buildings and cars`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![A complete guide to flat security](https://images.ctfassets.net/v6awd0kabi65/55N26iTGtmrO9GZ995s8Hu/9c20a17d93a76d157305ce1245e60256/A_complete_guide_to_flat_security.png?w=120&h=120&fit=pad)
 *
 * A complete guide to flat security
 *
 * Image of flat buildings
 */
export const IMG_55N26iTGtmrO9GZ995s8Hu = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/55N26iTGtmrO9GZ995s8Hu/9c20a17d93a76d157305ce1245e60256/A_complete_guide_to_flat_security.png',
  description: `Image of flat buildings`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![How to keep valuables safe while travelling](https://images.ctfassets.net/v6awd0kabi65/3c8smPtgedPZSNXom4UBWf/7a4d7b993e744dad44d02e9c7674976d/How_to_keep_valuables_safe_while_travelling.png?w=120&h=120&fit=pad)
 *
 * How to keep valuables safe while travelling
 *
 * Image of an island with water surrounding it
 */
export const IMG_3c8smPtgedPZSNXom4UBWf = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3c8smPtgedPZSNXom4UBWf/7a4d7b993e744dad44d02e9c7674976d/How_to_keep_valuables_safe_while_travelling.png',
  description: `Image of an island with water surrounding it`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![How to recover from a burglary](https://images.ctfassets.net/v6awd0kabi65/47oGm6sPJSoEVALjRzXO0W/ae38b14add6b1ebaf7417131288eeee1/How_to_recover_from_a_burglary.png?w=120&h=120&fit=pad)
 *
 * How to recover from a burglary
 *
 * Image of a window seat in front of a window in a home
 */
export const IMG_47oGm6sPJSoEVALjRzXO0W = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/47oGm6sPJSoEVALjRzXO0W/ae38b14add6b1ebaf7417131288eeee1/How_to_recover_from_a_burglary.png',
  description: `Image of a window seat in front of a window in a home`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Staying safe when Black Friday shopping](https://images.ctfassets.net/v6awd0kabi65/A6HxzjPK9fcm2bcpEWuoL/2d3ab4fcbecbffb5c46dacba38ff220a/Staying_safe_when_Black_Friday_shopping.png?w=120&h=120&fit=pad)
 *
 * Staying safe when Black Friday shopping
 *
 * Image of Scrabble tiles spelling out "Black Friday" on a Black background
 */
export const IMG_A6HxzjPK9fcm2bcpEWuoL = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/A6HxzjPK9fcm2bcpEWuoL/2d3ab4fcbecbffb5c46dacba38ff220a/Staying_safe_when_Black_Friday_shopping.png',
  description: `Image of Scrabble tiles spelling out "Black Friday" on a Black background`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![SimpliSafe. Protecting the Magic of Christmas](https://images.ctfassets.net/v6awd0kabi65/3429px5leMsTDWwhtNzW0b/7fba44280e96dc867dfcdf79129b34aa/SimpliSafe._Protecting_the_Magic_of_Christmas.png?w=120&h=120&fit=pad)
 *
 * SimpliSafe. Protecting the Magic of Christmas
 *
 * Image of a family sitting under a Christmas tree in their living room
 */
export const IMG_3429px5leMsTDWwhtNzW0b = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3429px5leMsTDWwhtNzW0b/7fba44280e96dc867dfcdf79129b34aa/SimpliSafe._Protecting_the_Magic_of_Christmas.png',
  description: `Image of a family sitting under a Christmas tree in their living room`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![The SimpliSafe Social Distancing Sweater](https://images.ctfassets.net/v6awd0kabi65/7Cmekwijr53io901VwM9yX/7faf552a88ed6f4cb1c18a0d6b6110bf/The_SimpliSafe_Social_Distancing_Sweater.png?w=120&h=120&fit=pad)
 *
 * The SimpliSafe Social Distancing Sweater
 *
 * Image of a Simplisafe holiday sweater
 */
export const IMG_7Cmekwijr53io901VwM9yX = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7Cmekwijr53io901VwM9yX/7faf552a88ed6f4cb1c18a0d6b6110bf/The_SimpliSafe_Social_Distancing_Sweater.png',
  description: `Image of a Simplisafe holiday sweater`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Secure your home in the darker nights](https://images.ctfassets.net/v6awd0kabi65/3ygX5J2H3vpT4YCvTX9i7H/3daa1fb3a7159d3306b6a8ff6e20a701/Secure_your_home_in_the_darker_nights.jpg?w=120&h=120&fit=pad)
 *
 * Secure your home in the darker nights
 *
 * Image of a keypad mounted on a wall
 */
export const IMG_3ygX5J2H3vpT4YCvTX9i7H = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3ygX5J2H3vpT4YCvTX9i7H/3daa1fb3a7159d3306b6a8ff6e20a701/Secure_your_home_in_the_darker_nights.jpg',
  description: `Image of a keypad mounted on a wall`,
  originalHeight: 481,
  originalWidth: 720
}

/**
 * ![How to be a good neighbour](https://images.ctfassets.net/v6awd0kabi65/5ClzWeP6kYBuw7mnNLxXun/ea24297b77a620973fb91d868e52916b/How_to_be_a_good_neighbour.png?w=120&h=120&fit=pad)
 *
 * How to be a good neighbour
 *
 * Image of 2 doors, one yellow and one green
 */
export const IMG_5ClzWeP6kYBuw7mnNLxXun = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5ClzWeP6kYBuw7mnNLxXun/ea24297b77a620973fb91d868e52916b/How_to_be_a_good_neighbour.png',
  description: `Image of 2 doors, one yellow and one green`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![What to do after a burglary](https://images.ctfassets.net/v6awd0kabi65/3VuSHfGTl8y0cbyf3T5ej8/4fa8858f7b55e8c0ef6bbf6ad304f256/What_to_do_after_a_burglary.png?w=120&h=120&fit=pad)
 *
 * What to do after a burglary
 *
 * Image of a Simplicam on a coffee table in a home
 */
export const IMG_3VuSHfGTl8y0cbyf3T5ej8 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3VuSHfGTl8y0cbyf3T5ej8/4fa8858f7b55e8c0ef6bbf6ad304f256/What_to_do_after_a_burglary.png',
  description: `Image of a Simplicam on a coffee table in a home`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Crime in my area - Main](https://images.ctfassets.net/v6awd0kabi65/2jkWCZnnnzcn18qNqB5ujK/cb6e5447af0531359ba68a43c6f36259/Crime_in_my_area_-_Main.png?w=120&h=120&fit=pad)
 *
 * Crime in my area - Main
 *
 * Image of a city with text on top of it that says "Crime in my area"
 */
export const IMG_2jkWCZnnnzcn18qNqB5ujK = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2jkWCZnnnzcn18qNqB5ujK/cb6e5447af0531359ba68a43c6f36259/Crime_in_my_area_-_Main.png',
  description: `Image of a city with text on top of it that says "Crime in my area"`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Crime in my area - Content 1](https://images.ctfassets.net/v6awd0kabi65/472jlcQ36x8olx2V9ytBJJ/8708b698d81292f778677e7382c9454f/Crime_in_my_area_-_Content_1.png?w=120&h=120&fit=pad)
 *
 * Crime in my area - Content 1
 *
 * Image of crime stats in the UK
 */
export const IMG_472jlcQ36x8olx2V9ytBJJ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/472jlcQ36x8olx2V9ytBJJ/8708b698d81292f778677e7382c9454f/Crime_in_my_area_-_Content_1.png',
  description: `Image of crime stats in the UK`,
  originalHeight: 5900,
  originalWidth: 4167
}

/**
 * ![CRIME IN BRISTOL](https://images.ctfassets.net/v6awd0kabi65/4KopRMVQjaEgmwWq0j4dxM/4ee00de656e05f867c8a0bf9bb9fb209/CRIME_IN_BRISTOL.png?w=120&h=120&fit=pad)
 *
 * CRIME IN BRISTOL
 *
 * Image of bristol
 */
export const IMG_4KopRMVQjaEgmwWq0j4dxM = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4KopRMVQjaEgmwWq0j4dxM/4ee00de656e05f867c8a0bf9bb9fb209/CRIME_IN_BRISTOL.png',
  description: `Image of bristol`,
  originalHeight: 5001,
  originalWidth: 5001
}

/**
 * ![CRIME IN COVENTRY](https://images.ctfassets.net/v6awd0kabi65/49uy3sh4CZK7qP6YaqaT6S/15b90bd7a45d4089a2445e4fc5931e5d/CRIME_IN_COVENTRY.png?w=120&h=120&fit=pad)
 *
 * CRIME IN COVENTRY
 *
 * Image of Coventry
 */
export const IMG_49uy3sh4CZK7qP6YaqaT6S = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/49uy3sh4CZK7qP6YaqaT6S/15b90bd7a45d4089a2445e4fc5931e5d/CRIME_IN_COVENTRY.png',
  description: `Image of Coventry`,
  originalHeight: 5001,
  originalWidth: 5001
}

/**
 * ![CRIME IN DERBY](https://images.ctfassets.net/v6awd0kabi65/1fWuT6Wd8gKeiCO8UL3Zfj/cfbf94b2c10432eeb3274b5521e583a2/CRIME_IN_DERBY.png?w=120&h=120&fit=pad)
 *
 * CRIME IN DERBY
 *
 * Image of Derby
 */
export const IMG_1fWuT6Wd8gKeiCO8UL3Zfj = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1fWuT6Wd8gKeiCO8UL3Zfj/cfbf94b2c10432eeb3274b5521e583a2/CRIME_IN_DERBY.png',
  description: `Image of Derby`,
  originalHeight: 5001,
  originalWidth: 5001
}

/**
 * ![CRIME IN LEEDS](https://images.ctfassets.net/v6awd0kabi65/3viWqTkjzI6GsEJWebw7kN/63cc620c186a4de90b41a40023ba6e52/CRIME_IN_LEEDS.png?w=120&h=120&fit=pad)
 *
 * CRIME IN LEEDS
 *
 * Image of Leeds
 */
export const IMG_3viWqTkjzI6GsEJWebw7kN = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3viWqTkjzI6GsEJWebw7kN/63cc620c186a4de90b41a40023ba6e52/CRIME_IN_LEEDS.png',
  description: `Image of Leeds`,
  originalHeight: 5001,
  originalWidth: 5001
}

/**
 * ![CRIME IN LIVERPOOL](https://images.ctfassets.net/v6awd0kabi65/1mUtqBvJC2NTRISYDllyF0/d6d12d5e2282cf188709dae80a15ff43/CRIME_IN_LIVERPOOL.png?w=120&h=120&fit=pad)
 *
 * CRIME IN LIVERPOOL
 *
 * Image of Liverpool
 */
export const IMG_1mUtqBvJC2NTRISYDllyF0 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1mUtqBvJC2NTRISYDllyF0/d6d12d5e2282cf188709dae80a15ff43/CRIME_IN_LIVERPOOL.png',
  description: `Image of Liverpool`,
  originalHeight: 5001,
  originalWidth: 5001
}

/**
 * ![CRIME IN LONDON](https://images.ctfassets.net/v6awd0kabi65/5PRKghwrcJ24HNrxNgkrKY/e8fdd05bbdb1db649932d17cd5804167/CRIME_IN_LONDON.png?w=120&h=120&fit=pad)
 *
 * CRIME IN LONDON
 *
 * Image of London
 */
export const IMG_5PRKghwrcJ24HNrxNgkrKY = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5PRKghwrcJ24HNrxNgkrKY/e8fdd05bbdb1db649932d17cd5804167/CRIME_IN_LONDON.png',
  description: `Image of London`,
  originalHeight: 5001,
  originalWidth: 5001
}

/**
 * ![CRIME IN MANCHESTER](https://images.ctfassets.net/v6awd0kabi65/4IU5lGqc6No9HWTV0y8tVG/b8da9e3246262e719c9d3ce9d4b67195/CRIME_IN_MANCHESTER.png?w=120&h=120&fit=pad)
 *
 * CRIME IN MANCHESTER
 *
 * Image of Manchester
 */
export const IMG_4IU5lGqc6No9HWTV0y8tVG = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4IU5lGqc6No9HWTV0y8tVG/b8da9e3246262e719c9d3ce9d4b67195/CRIME_IN_MANCHESTER.png',
  description: `Image of Manchester`,
  originalHeight: 5001,
  originalWidth: 5001
}

/**
 * ![CRIME IN NOTTINGHAM](https://images.ctfassets.net/v6awd0kabi65/2D4I3bTaxaYF9fq1vclSVm/fe7833ad001c2d125fb4b2e8c8293db4/CRIME_IN_NOTTINGHAM.png?w=120&h=120&fit=pad)
 *
 * CRIME IN NOTTINGHAM
 *
 * Image of Nottingham
 */
export const IMG_2D4I3bTaxaYF9fq1vclSVm = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2D4I3bTaxaYF9fq1vclSVm/fe7833ad001c2d125fb4b2e8c8293db4/CRIME_IN_NOTTINGHAM.png',
  description: `Image of Nottingham`,
  originalHeight: 5001,
  originalWidth: 5001
}

/**
 * ![How to create a strong password (and remember it)](https://images.ctfassets.net/v6awd0kabi65/2zU13BRr3LpiORRBiKmz3s/ed2eef7cc3160569c33922119bba0c91/How_to_create_a_strong_password__and_remember_it_.png?w=120&h=120&fit=pad)
 *
 * How to create a strong password (and remember it)
 *
 * Image of a locked phone, pencil and glasses sitting on a table
 */
export const IMG_2zU13BRr3LpiORRBiKmz3s = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2zU13BRr3LpiORRBiKmz3s/ed2eef7cc3160569c33922119bba0c91/How_to_create_a_strong_password__and_remember_it_.png',
  description: `Image of a locked phone, pencil and glasses sitting on a table`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Traditional vs Modern Burglar Alarms](https://images.ctfassets.net/v6awd0kabi65/22POzRu7lUyejK1YuXIUPt/24fe624ed5e71ce7f3df229ee5db101e/Traditional_vs_Modern_Burglar_Alarms.png?w=120&h=120&fit=pad)
 *
 * Traditional vs Modern Burglar Alarms
 *
 * Image of a base station on a table in a home with a plant next to it
 */
export const IMG_22POzRu7lUyejK1YuXIUPt = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/22POzRu7lUyejK1YuXIUPt/24fe624ed5e71ce7f3df229ee5db101e/Traditional_vs_Modern_Burglar_Alarms.png',
  description: `Image of a base station on a table in a home with a plant next to it`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![The rise of sneak-in burglaries](https://images.ctfassets.net/v6awd0kabi65/1MLyeDFk0Ct18mEay5srpC/94bb002fc253981dbe134115699d6c1c/The_rise_of_sneak-in_burglaries.png?w=120&h=120&fit=pad)
 *
 * The rise of sneak-in burglaries
 *
 * Image of a police siren flashing blue
 */
export const IMG_1MLyeDFk0Ct18mEay5srpC = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1MLyeDFk0Ct18mEay5srpC/94bb002fc253981dbe134115699d6c1c/The_rise_of_sneak-in_burglaries.png',
  description: `Image of a police siren flashing blue`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![What to do after moving into a new house](https://images.ctfassets.net/v6awd0kabi65/7nhhWHtYFFeT1zLSEtbQ5D/f912ce2d15b28cea1e3cbf46ee98c842/What_to_do_after_moving_into_a_new_house.png?w=120&h=120&fit=pad)
 *
 * What to do after moving into a new house
 *
 * Image of a family in their new home unpacking moving boxes
 */
export const IMG_7nhhWHtYFFeT1zLSEtbQ5D = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7nhhWHtYFFeT1zLSEtbQ5D/f912ce2d15b28cea1e3cbf46ee98c842/What_to_do_after_moving_into_a_new_house.png',
  description: `Image of a family in their new home unpacking moving boxes`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Image - Making your home safer for Christmas](https://images.ctfassets.net/v6awd0kabi65/36mdUAhOe6XWkMue5iGrvV/ab66861799c769fad8762119655e7d7c/Making_Your_Home_Safer_For_Christmmas.png?w=120&h=120&fit=pad)
 *
 * Image - Making your home safer for Christmas
 *
 * Image of a living room with a Christmas tree in front of a fireplace, lights, and gifts under the tree
 */
export const IMG_36mdUAhOe6XWkMue5iGrvV = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/36mdUAhOe6XWkMue5iGrvV/ab66861799c769fad8762119655e7d7c/Making_Your_Home_Safer_For_Christmmas.png',
  description: `Image of a living room with a Christmas tree in front of a fireplace, lights, and gifts under the tree`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Image - 10 security ideas for your home](https://images.ctfassets.net/v6awd0kabi65/6vXxXCJ0LeF11NzieNvff4/b75eef585204756cf613c6a865a22b67/10_security_ideas_for_your_home.png?w=120&h=120&fit=pad)
 *
 * Image - 10 security ideas for your home
 *
 * Image of a SimpliSafe yard sign with a small brown dog sitting next to it
 */
export const IMG_6vXxXCJ0LeF11NzieNvff4 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6vXxXCJ0LeF11NzieNvff4/b75eef585204756cf613c6a865a22b67/10_security_ideas_for_your_home.png',
  description: `Image of a SimpliSafe yard sign with a small brown dog sitting next to it`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Image - wired systems: which is best?](https://images.ctfassets.net/v6awd0kabi65/8gCj85e4OfeafgRUqBQjO/0828e9c28f0e26bd606b2d36403f0f38/wired_systems-_which_is_best?w=120&h=120&fit=pad)
 *
 * Image - wired systems: which is best?
 *
 * Image of a home security system laid out on a table including a base station, keypad, enry sensors, indoor camera and motion sensor
 */
export const IMG_8gCj85e4OfeafgRUqBQjO = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/8gCj85e4OfeafgRUqBQjO/0828e9c28f0e26bd606b2d36403f0f38/wired_systems-_which_is_best',
  description: `Image of a home security system laid out on a table including a base station, keypad, enry sensors, indoor camera and motion sensor`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Image - How to buy the best home security system](https://images.ctfassets.net/v6awd0kabi65/7tTxZYX0Z8saFWLVoPVGFW/0998aa22d8bcdb34059d2152e83bc00a/How_to_buy_the_best_home_security_system.png?w=120&h=120&fit=pad)
 *
 * Image - How to buy the best home security system
 *
 * Image of a SimpliSafe yard sign stuck in the ground in front of a home
 */
export const IMG_7tTxZYX0Z8saFWLVoPVGFW = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7tTxZYX0Z8saFWLVoPVGFW/0998aa22d8bcdb34059d2152e83bc00a/How_to_buy_the_best_home_security_system.png',
  description: `Image of a SimpliSafe yard sign stuck in the ground in front of a home`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Guide to internet safety for kids](https://images.ctfassets.net/v6awd0kabi65/1mFoVDNmorg33AJ21gYuNi/29805aea6ff143e66e845566e14eb000/Guide_to_internet_safety_for_kids.png?w=120&h=120&fit=pad)
 *
 * Guide to internet safety for kids
 *
 * Image of a young girl sitting next to a dog and laughing
 */
export const IMG_1mFoVDNmorg33AJ21gYuNi = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1mFoVDNmorg33AJ21gYuNi/29805aea6ff143e66e845566e14eb000/Guide_to_internet_safety_for_kids.png',
  description: `Image of a young girl sitting next to a dog and laughing`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Image - Wireless security system: everything you need to know](https://images.ctfassets.net/v6awd0kabi65/5Ig53oZaTxmMYdYSiP9iL3/974157b83926fbdf50c49d8d549fee68/Wireless_security_system-_everything_you_need_to_know.png?w=120&h=120&fit=pad)
 *
 * Image - Wireless security system: everything you need to know
 *
 * Image of a base station on a table in a home
 */
export const IMG_5Ig53oZaTxmMYdYSiP9iL3 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5Ig53oZaTxmMYdYSiP9iL3/974157b83926fbdf50c49d8d549fee68/Wireless_security_system-_everything_you_need_to_know.png',
  description: `Image of a base station on a table in a home`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Image - A guide to monitored alarm systems](https://images.ctfassets.net/v6awd0kabi65/mxrrPSDOauMlwl7ktagB5/2bd34a51bfcc3d82030277cbf8499fe2/A_guide_to_monitored_alarm_systems.png?w=120&h=120&fit=pad)
 *
 * Image - A guide to monitored alarm systems
 *
 * Image of a monitoring agent looking at the computer and wearing a headset
 */
export const IMG_mxrrPSDOauMlwl7ktagB5 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/mxrrPSDOauMlwl7ktagB5/2bd34a51bfcc3d82030277cbf8499fe2/A_guide_to_monitored_alarm_systems.png',
  description: `Image of a monitoring agent looking at the computer and wearing a headset`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Set-up a silent alarm and always be protected](https://images.ctfassets.net/v6awd0kabi65/2aPNQYdSY50iAcIGho0trk/bb5f50ebf1003132e8ebe0a2715a5fcc/duressfeature_0.jpeg?w=120&h=120&fit=pad)
 *
 * Set-up a silent alarm and always be protected
 *
 * Image of a police siren flashing blue
 */
export const IMG_2aPNQYdSY50iAcIGho0trk = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2aPNQYdSY50iAcIGho0trk/bb5f50ebf1003132e8ebe0a2715a5fcc/duressfeature_0.jpeg',
  description: `Image of a police siren flashing blue`,
  originalHeight: 466,
  originalWidth: 716
}

/**
 * ![Set-up a silent alarm and always be protected](https://images.ctfassets.net/v6awd0kabi65/5mxxy6onMhg16ydCxXhrBr/38649fb3e3ee7f805eb6d3ad238a0eb3/duressfeature_0.jpeg?w=120&h=120&fit=pad)
 *
 * Set-up a silent alarm and always be protected
 *
 * Image of a police siren flashing blue
 */
export const IMG_5mxxy6onMhg16ydCxXhrBr = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5mxxy6onMhg16ydCxXhrBr/38649fb3e3ee7f805eb6d3ad238a0eb3/duressfeature_0.jpeg',
  description: `Image of a police siren flashing blue`,
  originalHeight: 466,
  originalWidth: 716
}

/**
 * ![The latest anti-crime initiatives in the UK](https://images.ctfassets.net/v6awd0kabi65/w3LyTUbdNmyOjxqNBcqGo/4f0ccc6f61a66652cc040514816e11c3/Untitled_design-53.png?w=120&h=120&fit=pad)
 *
 * The latest anti-crime initiatives in the UK
 *
 * Image of a police siren flashing red and blue
 */
export const IMG_w3LyTUbdNmyOjxqNBcqGo = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/w3LyTUbdNmyOjxqNBcqGo/4f0ccc6f61a66652cc040514816e11c3/Untitled_design-53.png',
  description: `Image of a police siren flashing red and blue`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![How does a smart alarm system work?](https://images.ctfassets.net/v6awd0kabi65/6CYILf8CFGPlX5Ev0Fe6u0/37465b26d581e3611111936f7b946d1a/Untitled_design-73.png?w=120&h=120&fit=pad)
 *
 * How does a smart alarm system work?
 *
 * Image of a keypad mounted to a wall with a set of keys hanging next to it
 */
export const IMG_6CYILf8CFGPlX5Ev0Fe6u0 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6CYILf8CFGPlX5Ev0Fe6u0/37465b26d581e3611111936f7b946d1a/Untitled_design-73.png',
  description: `Image of a keypad mounted to a wall with a set of keys hanging next to it`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Why smart home security is perfect for families](https://images.ctfassets.net/v6awd0kabi65/5OYMQVjh62jvlLePda21II/d8d5d9b034ed3f584cdd302f3ac2f440/Untitled_design-74.png?w=120&h=120&fit=pad)
 *
 * Why smart home security is perfect for families
 *
 * Image of a woman and her child sitting on a bench in front of a picture window
 */
export const IMG_5OYMQVjh62jvlLePda21II = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5OYMQVjh62jvlLePda21II/d8d5d9b034ed3f584cdd302f3ac2f440/Untitled_design-74.png',
  description: `Image of a woman and her child sitting on a bench in front of a picture window`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Tips to keep your bike secure](https://images.ctfassets.net/v6awd0kabi65/7HL5G2rM6ge3nhssWSz13K/dd60c6b7360d133b9cc61acd688bb69f/bike-motionsensor.png?w=120&h=120&fit=pad)
 *
 * Tips to keep your bike secure
 *
 * Image of a bike
 */
export const IMG_7HL5G2rM6ge3nhssWSz13K = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7HL5G2rM6ge3nhssWSz13K/dd60c6b7360d133b9cc61acd688bb69f/bike-motionsensor.png',
  description: `Image of a bike`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Extra PINs to let you know who is coming and going at home](https://images.ctfassets.net/v6awd0kabi65/3VozRlXk6abKlBoZCH9svk/9efd6481a9990e5fc296f7ea01229a0d/pins.png?w=120&h=120&fit=pad)
 *
 * Extra PINs to let you know who is coming and going at home
 *
 * Image of a keypad mounted to a wall with a person arming it in Home mode
 */
export const IMG_3VozRlXk6abKlBoZCH9svk = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3VozRlXk6abKlBoZCH9svk/9efd6481a9990e5fc296f7ea01229a0d/pins.png',
  description: `Image of a keypad mounted to a wall with a person arming it in Home mode`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Things to consider when buying a home for the first time](https://images.ctfassets.net/v6awd0kabi65/2wD6IPfo8AaoZ4q0CVi8Og/12c3a488817a371bf1a82277cc8cb9ab/Untitled_design-78.png?w=120&h=120&fit=pad)
 *
 * Things to consider when buying a home for the first time
 *
 * Image of a jar with coins in it and a label on the front of the jar that says "House Fund"
 */
export const IMG_2wD6IPfo8AaoZ4q0CVi8Og = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2wD6IPfo8AaoZ4q0CVi8Og/12c3a488817a371bf1a82277cc8cb9ab/Untitled_design-78.png',
  description: `Image of a jar with coins in it and a label on the front of the jar that says "House Fund"`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![stampduty](https://images.ctfassets.net/v6awd0kabi65/KlEhu6r8Hzpl1US21B8QF/faea855f8d03997ac5c7a27a4cb3bc5f/stampduty.png?w=120&h=120&fit=pad)
 *
 * stampduty
 *
 * Image of a chart showing the purchase price across multiple residences
 */
export const IMG_KlEhu6r8Hzpl1US21B8QF = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/KlEhu6r8Hzpl1US21B8QF/faea855f8d03997ac5c7a27a4cb3bc5f/stampduty.png',
  description: `Image of a chart showing the purchase price across multiple residences`,
  originalHeight: 423,
  originalWidth: 600
}

/**
 * ![How to find your dream home](https://images.ctfassets.net/v6awd0kabi65/1Xm3fmmHhIWplTBVZCiu8y/596e3afb77fabd02f83e62954d12aeea/Untitled_design-79.png?w=120&h=120&fit=pad)
 *
 * How to find your dream home
 *
 * Image of a row of apartment buildings with greenery around them
 */
export const IMG_1Xm3fmmHhIWplTBVZCiu8y = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1Xm3fmmHhIWplTBVZCiu8y/596e3afb77fabd02f83e62954d12aeea/Untitled_design-79.png',
  description: `Image of a row of apartment buildings with greenery around them`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![14 ways to celebrate Home Improvement Month](https://images.ctfassets.net/v6awd0kabi65/7Cd44q0PXHDTRRxMkju5kZ/2dc8c0636e56fe56e0de4b1f24144d65/Untitled_design-80.png?w=120&h=120&fit=pad)
 *
 * 14 ways to celebrate Home Improvement Month
 *
 * Image of a paint roller covered in green paint
 */
export const IMG_7Cd44q0PXHDTRRxMkju5kZ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7Cd44q0PXHDTRRxMkju5kZ/2dc8c0636e56fe56e0de4b1f24144d65/Untitled_design-80.png',
  description: `Image of a paint roller covered in green paint`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Conquer home improvement with a spring cleaning checklist](https://images.ctfassets.net/v6awd0kabi65/1y5A42zUtbdBvDj4Jl9tIn/52b4ca801597380ebc77dd4e79b3e947/conquer.png?w=120&h=120&fit=pad)
 *
 * Conquer home improvement with a spring cleaning checklist
 *
 * Image of household cleaning items hanging from hooks on the wall including a broom and dustpan
 */
export const IMG_1y5A42zUtbdBvDj4Jl9tIn = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1y5A42zUtbdBvDj4Jl9tIn/52b4ca801597380ebc77dd4e79b3e947/conquer.png',
  description: `Image of household cleaning items hanging from hooks on the wall including a broom and dustpan`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![How to turn your home into a smart home](https://images.ctfassets.net/v6awd0kabi65/3ZvRRagIQubCKcLfXpiDmn/153a7d4a13802b9d53e31a12599455df/how_to.png?w=120&h=120&fit=pad)
 *
 * How to turn your home into a smart home
 *
 * Image of neon purple lines in an interesting pattern on a black background
 */
export const IMG_3ZvRRagIQubCKcLfXpiDmn = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3ZvRRagIQubCKcLfXpiDmn/153a7d4a13802b9d53e31a12599455df/how_to.png',
  description: `Image of neon purple lines in an interesting pattern on a black background`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![How to improve your car security](https://images.ctfassets.net/v6awd0kabi65/6xZLNFoIG2A5V9VrtEXiei/7852f2c53cc6223baffd46de7ffc321a/Car.png?w=120&h=120&fit=pad)
 *
 * How to improve your car security
 *
 * Image of a green car
 */
export const IMG_6xZLNFoIG2A5V9VrtEXiei = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6xZLNFoIG2A5V9VrtEXiei/7852f2c53cc6223baffd46de7ffc321a/Car.png',
  description: `Image of a green car`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![The outdoor garden furniture guide](https://images.ctfassets.net/v6awd0kabi65/6PR4dx5LdcPEgULQoQUqIH/d66ebea09cd6dcc70a48cf48cf361871/outdoor.png?w=120&h=120&fit=pad)
 *
 * The outdoor garden furniture guide
 *
 * Image of a small, round outdoor table with 4 outdoor seats around it and a plant in the middle of the table
 */
export const IMG_6PR4dx5LdcPEgULQoQUqIH = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6PR4dx5LdcPEgULQoQUqIH/d66ebea09cd6dcc70a48cf48cf361871/outdoor.png',
  description: `Image of a small, round outdoor table with 4 outdoor seats around it and a plant in the middle of the table`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![How to create the perfect summer garden](https://images.ctfassets.net/v6awd0kabi65/5Ktnsp7YAQ9mDv2DYqRuff/bd78340f718888f935e1f6cc89092ba8/garden.png?w=120&h=120&fit=pad)
 *
 * How to create the perfect summer garden
 *
 * Image of a home with a beautiful garden and flowers in front of it
 */
export const IMG_5Ktnsp7YAQ9mDv2DYqRuff = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5Ktnsp7YAQ9mDv2DYqRuff/bd78340f718888f935e1f6cc89092ba8/garden.png',
  description: `Image of a home with a beautiful garden and flowers in front of it`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Seven of the best garden gadgets to indulge in](https://images.ctfassets.net/v6awd0kabi65/2iGyLJINKUvDnkIl0tQpRI/3efa97a4f36125e2c04ddb51773adc7e/Untitled_design-40.png?w=120&h=120&fit=pad)
 *
 * Seven of the best garden gadgets to indulge in
 *
 * Image of a bird house hanging from a tree
 */
export const IMG_2iGyLJINKUvDnkIl0tQpRI = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2iGyLJINKUvDnkIl0tQpRI/3efa97a4f36125e2c04ddb51773adc7e/Untitled_design-40.png',
  description: `Image of a bird house hanging from a tree`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Guide for renters and landlords](https://images.ctfassets.net/v6awd0kabi65/6sd98sf2j1bAF6N9m0276w/0e164e7b7605281941ebad632b884df0/Untitled_design-42.png?w=120&h=120&fit=pad)
 *
 * Guide for renters and landlords
 *
 * Image of a woman holding a house key
 */
export const IMG_6sd98sf2j1bAF6N9m0276w = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6sd98sf2j1bAF6N9m0276w/0e164e7b7605281941ebad632b884df0/Untitled_design-42.png',
  description: `Image of a woman holding a house key`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![SimpliSafe arming reminders](https://images.ctfassets.net/v6awd0kabi65/5tSsOMBs2gEOJMOnL8JBnQ/88f0212a8309638377bdc4e820d1a1f7/Untitled_design-43.png?w=120&h=120&fit=pad)
 *
 * SimpliSafe arming reminders
 *
 * Image of a woman looking at her phone
 */
export const IMG_5tSsOMBs2gEOJMOnL8JBnQ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5tSsOMBs2gEOJMOnL8JBnQ/88f0212a8309638377bdc4e820d1a1f7/Untitled_design-43.png',
  description: `Image of a woman looking at her phone`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![SimpliSafe arming reminders](https://images.ctfassets.net/v6awd0kabi65/1mwbcA5kBlcWHViBW5vcSX/0abca956c84855225640f9751f50a2d1/Untitled_design-43.png?w=120&h=120&fit=pad)
 *
 * SimpliSafe arming reminders
 *
 * Image of a woman looking at her phone
 */
export const IMG_1mwbcA5kBlcWHViBW5vcSX = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1mwbcA5kBlcWHViBW5vcSX/0abca956c84855225640f9751f50a2d1/Untitled_design-43.png',
  description: `Image of a woman looking at her phone`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![SP Glassbreak](https://images.ctfassets.net/v6awd0kabi65/6hreKurlLbjB9YOgtBvMfd/5e211c484d598b3164ec90a5bbb76caf/SP_Glassbreak.png?w=120&h=120&fit=pad)
 *
 * SP Glassbreak
 *
 * Image of a glassbreak sensor on a solid white background
 */
export const IMG_6hreKurlLbjB9YOgtBvMfd = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6hreKurlLbjB9YOgtBvMfd/5e211c484d598b3164ec90a5bbb76caf/SP_Glassbreak.png',
  description: `Image of a glassbreak sensor on a solid white background`,
  originalHeight: 600,
  originalWidth: 600
}

/**
 * ![Keypad (Sensor)](https://images.ctfassets.net/v6awd0kabi65/3F9PW3pNiPCbrP6gWqNPjI/f42481e9702bdbedd9191231240bf087/SP_Keypad.png?w=120&h=120&fit=pad)
 *
 * Keypad (Sensor)
 *
 * Image of a keypad on a plain white background
 */
export const IMG_3F9PW3pNiPCbrP6gWqNPjI = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3F9PW3pNiPCbrP6gWqNPjI/f42481e9702bdbedd9191231240bf087/SP_Keypad.png',
  description: `Image of a keypad on a plain white background`,
  originalHeight: 600,
  originalWidth: 600
}

/**
 * ![2025 CNET-US CNET BEST-OF LOGO](https://images.ctfassets.net/v6awd0kabi65/5qECjj8vYgV5ThjxYhWtaw/e5a41e6fed496667c0ce9530e8e863a2/2025_CNET-US_CNET_BEST-OF_LOGO.png?w=120&h=120&fit=pad)
 *
 * 2025 CNET-US CNET BEST-OF LOGO
 *
 * null
 */
export const IMG_5qECjj8vYgV5ThjxYhWtaw = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5qECjj8vYgV5ThjxYhWtaw/e5a41e6fed496667c0ce9530e8e863a2/2025_CNET-US_CNET_BEST-OF_LOGO.png',
  description: `null`,
  originalHeight: 750,
  originalWidth: 750
}

/**
 * ![Stay safe in summer with outdoor home security](https://images.ctfassets.net/v6awd0kabi65/51Mn9WKrAGx5Nqjfjfr4ET/af936a90ed5c82057c23459f69364ad2/pexels-kampus-production-6299265.jpg?w=120&h=120&fit=pad)
 *
 * Stay safe in summer with outdoor home security
 *
 * Image of children running in the backyard while holding balloons
 */
export const IMG_51Mn9WKrAGx5Nqjfjfr4ET = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/51Mn9WKrAGx5Nqjfjfr4ET/af936a90ed5c82057c23459f69364ad2/pexels-kampus-production-6299265.jpg',
  description: `Image of children running in the backyard while holding balloons`,
  originalHeight: 2639,
  originalWidth: 3958
}

/**
 * ![Home renovations with security in mind](https://images.ctfassets.net/v6awd0kabi65/6MW16y56M50FmqpSiim8ZA/dbb05d1ad667296f9e60e26f0a3e0239/pexels-pixabay-276267.jpg?w=120&h=120&fit=pad)
 *
 * Home renovations with security in mind
 *
 * Image of color swatches used during a home renovation
 */
export const IMG_6MW16y56M50FmqpSiim8ZA = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6MW16y56M50FmqpSiim8ZA/dbb05d1ad667296f9e60e26f0a3e0239/pexels-pixabay-276267.jpg',
  description: `Image of color swatches used during a home renovation`,
  originalHeight: 2848,
  originalWidth: 4288
}

/**
 * ![Security during a power cut ](https://images.ctfassets.net/v6awd0kabi65/7aBbcnuzG516qqSffBcwsX/40c75e8dc015248ab15d2840986308f3/nuril-ahsan-vyj-Cs436bU-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * Security during a power cut
 *
 * Image of a man reading by candlelight during a power outtage
 */
export const IMG_7aBbcnuzG516qqSffBcwsX = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7aBbcnuzG516qqSffBcwsX/40c75e8dc015248ab15d2840986308f3/nuril-ahsan-vyj-Cs436bU-unsplash.jpg',
  description: `Image of a man reading by candlelight during a power outtage`,
  originalHeight: 3264,
  originalWidth: 4928
}

/**
 * ![10 best documentaries to watch on Sky Crime](https://images.ctfassets.net/v6awd0kabi65/6Zt1wqGOmttKGdbQcJhTtk/9f33205d3732dee5c0df97b973f7804e/The_Warwick_-__364.jpg?w=120&h=120&fit=pad)
 *
 * 10 best documentaries to watch on Sky Crime
 *
 * Image of a home security kit
 */
export const IMG_6Zt1wqGOmttKGdbQcJhTtk = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6Zt1wqGOmttKGdbQcJhTtk/9f33205d3732dee5c0df97b973f7804e/The_Warwick_-__364.jpg',
  description: `Image of a home security kit`,
  originalHeight: 1667,
  originalWidth: 2500
}

/**
 * ![Home Security Camera Placement](https://images.ctfassets.net/v6awd0kabi65/7tI2oX0re0ROX5cj3fynTP/6443be66dddf019ce22f42ad2b7e3c26/Indoor_Camera_2_SM__1_.jpg?w=120&h=120&fit=pad)
 *
 * Home Security Camera Placement
 *
 * Image of a Simplicam on top of a living room coffee table in a home
 */
export const IMG_7tI2oX0re0ROX5cj3fynTP = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7tI2oX0re0ROX5cj3fynTP/6443be66dddf019ce22f42ad2b7e3c26/Indoor_Camera_2_SM__1_.jpg',
  description: `Image of a Simplicam on top of a living room coffee table in a home`,
  originalHeight: 4000,
  originalWidth: 7110
}

/**
 * ![Checklist for buying a new home](https://images.ctfassets.net/v6awd0kabi65/6CYoGLd7VV7p5C5mX0cX9b/6dc5dc855f9425fa001cb66775dfb7af/unnamed-2.jpg?w=120&h=120&fit=pad)
 *
 * Checklist for buying a new home
 *
 * Image of moving boxes
 */
export const IMG_6CYoGLd7VV7p5C5mX0cX9b = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6CYoGLd7VV7p5C5mX0cX9b/6dc5dc855f9425fa001cb66775dfb7af/unnamed-2.jpg',
  description: `Image of moving boxes`,
  originalHeight: 341,
  originalWidth: 512
}

/**
 * ![Police Camera - HP Banner Image](https://images.ctfassets.net/v6awd0kabi65/5mbs4LEkQgjIZpoFklL2ur/86003de15f43f288480f35ba01ed9bab/agent-camera-robber_image_3x.png?w=120&h=120&fit=pad)
 *
 * Police Camera - HP Banner Image
 *
 * Image of a monitoring agent catching a burglar in the act via the indoor security camera and deterring them by saying "Stop, police are on their way"
 */
export const IMG_5mbs4LEkQgjIZpoFklL2ur = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5mbs4LEkQgjIZpoFklL2ur/86003de15f43f288480f35ba01ed9bab/agent-camera-robber_image_3x.png',
  description: `Image of a monitoring agent catching a burglar in the act via the indoor security camera and deterring them by saying "Stop, police are on their way"`,
  originalHeight: 618,
  originalWidth: 975
}

/**
 * ![ How to prevent pet theft and keep pets safe](https://images.ctfassets.net/v6awd0kabi65/3nN8Fgh4GKDuKcgkVDDGQx/68b9b9839a4903084dd5e517d7c412a1/Low_Res-YardSign_revised_uk__2_.jpg?w=120&h=120&fit=pad)
 *
 *  How to prevent pet theft and keep pets safe
 *
 * Image of Simplisafe yard sign on the front yard of a home
 */
export const IMG_3nN8Fgh4GKDuKcgkVDDGQx = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3nN8Fgh4GKDuKcgkVDDGQx/68b9b9839a4903084dd5e517d7c412a1/Low_Res-YardSign_revised_uk__2_.jpg',
  description: `Image of Simplisafe yard sign on the front yard of a home`,
  originalHeight: 1094,
  originalWidth: 1241
}

/**
 * ![App Control - Doorbell](https://images.ctfassets.net/v6awd0kabi65/38iheGuzSVg8kPQ1aokAnw/7ab753ffcbb7f61c742cc5ff193d059a/App_Screen_art_3x.png?w=120&h=120&fit=pad)
 *
 * App Control - Doorbell
 *
 * Image of Simplisafe app showing a delivery person at the front door through the video doorbell camera
 */
export const IMG_38iheGuzSVg8kPQ1aokAnw = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/38iheGuzSVg8kPQ1aokAnw/7ab753ffcbb7f61c742cc5ff193d059a/App_Screen_art_3x.png',
  description: `Image of Simplisafe app showing a delivery person at the front door through the video doorbell camera`,
  originalHeight: 1881,
  originalWidth: 1500
}

/**
 * ![3 - Whole Home Protection - Water, Smoke/CO & Temp](https://images.ctfassets.net/v6awd0kabi65/7ACYwwcDBRWQTRldD61PTo/f059b2bee00341a480653b951e4b9072/hazard-updated.png?w=120&h=120&fit=pad)
 *
 * 3 - Whole Home Protection - Water, Smoke/CO & Temp
 *
 * Image of home security system products including a water detector, smoke detector and temperature sensor
 */
export const IMG_7ACYwwcDBRWQTRldD61PTo = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7ACYwwcDBRWQTRldD61PTo/f059b2bee00341a480653b951e4b9072/hazard-updated.png',
  description: `Image of home security system products including a water detector, smoke detector and temperature sensor`,
  originalHeight: 634,
  originalWidth: 1164
}

/**
 * ![Scout Alarm Monitoring Mp4](https://videos.ctfassets.net/v6awd0kabi65/4TYpYkCczalldNsdkKpFPP/e37473e6c287f561f5e62762a9e14888/monitoring_video.mp4?w=120&h=120&fit=pad)
 *
 * Scout Alarm Monitoring Mp4
 *
 * Video of indoor security camera
 */
export const IMG_4TYpYkCczalldNsdkKpFPP = {
  url: 'https://videos.ctfassets.net/v6awd0kabi65/4TYpYkCczalldNsdkKpFPP/e37473e6c287f561f5e62762a9e14888/monitoring_video.mp4',
  description: `Video of indoor security camera`,
  originalHeight: null,
  originalWidth: null
}

/**
 * ![scout pdp 60 video](https://videos.ctfassets.net/v6awd0kabi65/5P4Fc2tFoZF7AL0WVDSgm0/eda6379071159a1af93eb3d29f3c4634/scout_pdp_60_video.mp4?w=120&h=120&fit=pad)
 *
 * scout pdp 60 video
 *
 * Video of indoor security system
 */
export const IMG_5P4Fc2tFoZF7AL0WVDSgm0 = {
  url: 'https://videos.ctfassets.net/v6awd0kabi65/5P4Fc2tFoZF7AL0WVDSgm0/eda6379071159a1af93eb3d29f3c4634/scout_pdp_60_video.mp4',
  description: `Video of indoor security system `,
  originalHeight: null,
  originalWidth: null
}

/**
 * ![scout installation video](https://videos.ctfassets.net/v6awd0kabi65/18qfUuN2Hew5m9gw9RMZYz/945db91a2c51151605f500f96ba08786/scout_installation_video.mp4?w=120&h=120&fit=pad)
 *
 * scout installation video
 *
 * Video of indoor security camera installation
 */
export const IMG_18qfUuN2Hew5m9gw9RMZYz = {
  url: 'https://videos.ctfassets.net/v6awd0kabi65/18qfUuN2Hew5m9gw9RMZYz/945db91a2c51151605f500f96ba08786/scout_installation_video.mp4',
  description: `Video of indoor security camera installation`,
  originalHeight: null,
  originalWidth: null
}

/**
 * ![scout hp video](https://videos.ctfassets.net/v6awd0kabi65/1n9HFnD0K2Wc4DVmDMNo6R/0aff81964cfd83e80a0ab505e354b88d/scout_hp_video.mp4?w=120&h=120&fit=pad)
 *
 * scout hp video
 *
 * Video of indoor security camera
 */
export const IMG_1n9HFnD0K2Wc4DVmDMNo6R = {
  url: 'https://videos.ctfassets.net/v6awd0kabi65/1n9HFnD0K2Wc4DVmDMNo6R/0aff81964cfd83e80a0ab505e354b88d/scout_hp_video.mp4',
  description: `Video of indoor security camera`,
  originalHeight: null,
  originalWidth: null
}

/**
 * ![Balto - lifestyle image](https://images.ctfassets.net/v6awd0kabi65/4TfoTdG9x5tV4qKoa7tyWq/f131356e8da8f38fdadad400f1a2261f/image_10.png?w=120&h=120&fit=pad)
 *
 * Balto - lifestyle image
 *
 * Image of motion sensor mounted to a living room wall as a dog safely passes by
 */
export const IMG_4TfoTdG9x5tV4qKoa7tyWq = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4TfoTdG9x5tV4qKoa7tyWq/f131356e8da8f38fdadad400f1a2261f/image_10.png',
  description: `Image of motion sensor mounted to a living room wall as a dog safely passes by`,
  originalHeight: 1060,
  originalWidth: 1060
}

/**
 * ![Hero Banner - Homepage - Tablet - Scout](https://images.ctfassets.net/v6awd0kabi65/5hKVuNUYaNfGpZyMJH7Lt3/9a16ebe7d743ec65a2cd6d4cb275a7f2/Hero_Tablet_scout.png?w=120&h=120&fit=pad)
 *
 * Hero Banner - Homepage - Tablet - Scout
 *
 * Image of a family in their living room with a home security system
 */
export const IMG_5hKVuNUYaNfGpZyMJH7Lt3 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5hKVuNUYaNfGpZyMJH7Lt3/9a16ebe7d743ec65a2cd6d4cb275a7f2/Hero_Tablet_scout.png',
  description: `Image of a family in their living room with a home security system`,
  originalHeight: 1200,
  originalWidth: 2173
}

/**
 * ![4 - Whole Home Protection - Video Doorbell and Bell Box](https://images.ctfassets.net/v6awd0kabi65/21tePQNsUqUAALec4sWfkV/40c52dbbbd28bc5191c612ef8a253d86/Group_130.png?w=120&h=120&fit=pad)
 *
 * 4 - Whole Home Protection - Video Doorbell and Bell Box
 *
 * Image of SimpliSafe video doorbell and bell box products
 */
export const IMG_21tePQNsUqUAALec4sWfkV = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/21tePQNsUqUAALec4sWfkV/40c52dbbbd28bc5191c612ef8a253d86/Group_130.png',
  description: `Image of SimpliSafe video doorbell and bell box products`,
  originalHeight: 949,
  originalWidth: 1746
}

/**
 * ![Warranty Statement Signature](https://images.ctfassets.net/v6awd0kabi65/2DZYqIXm6Amh0MuFKzXYYy/e8a1ffcc86086c2272518a669a780568/signature.png?w=120&h=120&fit=pad)
 *
 * Warranty Statement Signature
 *
 * Image of SimpliSafe founders signature
 */
export const IMG_2DZYqIXm6Amh0MuFKzXYYy = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2DZYqIXm6Amh0MuFKzXYYy/e8a1ffcc86086c2272518a669a780568/signature.png',
  description: `Image of SimpliSafe founders signature`,
  originalHeight: 48,
  originalWidth: 156
}

/**
 * ![Keeping your family safe at a home BBQ](https://images.ctfassets.net/v6awd0kabi65/3Hbuw9qF8nGy2oq3IwWziP/815eb38dc38bf256625090382ff97981/BBQ.png?w=120&h=120&fit=pad)
 *
 * Keeping your family safe at a home BBQ
 *
 * Image of a barbeque
 */
export const IMG_3Hbuw9qF8nGy2oq3IwWziP = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3Hbuw9qF8nGy2oq3IwWziP/815eb38dc38bf256625090382ff97981/BBQ.png',
  description: `Image of a barbeque`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Norton Lifelock Logo](https://images.ctfassets.net/v6awd0kabi65/5Jdg9GmL8c622Sq1dOXYOw/bd3cd3dd79d488695e7db4adf7bc06ef/Norton-Lifelock.webp?w=120&h=120&fit=pad)
 *
 * Norton Lifelock Logo
 *
 * Image of Lifelock by Norton logo
 */
export const IMG_5Jdg9GmL8c622Sq1dOXYOw = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5Jdg9GmL8c622Sq1dOXYOw/bd3cd3dd79d488695e7db4adf7bc06ef/Norton-Lifelock.webp',
  description: `Image of Lifelock by Norton logo`,
  originalHeight: 306,
  originalWidth: 1083
}

/**
 * ![affirm logo (white)](https://images.ctfassets.net/v6awd0kabi65/1j46fYkh9clSMpTzsVeUPp/ba5a803af47f0d5dc256279a4bcf5a87/black_logo-white_bg_copy__2_.png?w=120&h=120&fit=pad)
 *
 * affirm logo (white)
 *
 * Image of affirm logo
 */
export const IMG_1j46fYkh9clSMpTzsVeUPp = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1j46fYkh9clSMpTzsVeUPp/ba5a803af47f0d5dc256279a4bcf5a87/black_logo-white_bg_copy__2_.png',
  description: `Image of affirm logo`,
  originalHeight: 56,
  originalWidth: 140
}

/**
 * ![Affirm Hero - Mobile](https://images.ctfassets.net/v6awd0kabi65/5mCxhOk1nySkr581bcJB1U/8e41f55cdf3d4507aba240fed86609f8/Group_4__1_.png?w=120&h=120&fit=pad)
 *
 * Affirm Hero - Mobile
 *
 * Image of outdoor security camera with the spotlight on in the night
 */
export const IMG_5mCxhOk1nySkr581bcJB1U = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5mCxhOk1nySkr581bcJB1U/8e41f55cdf3d4507aba240fed86609f8/Group_4__1_.png',
  description: `Image of outdoor security camera with the spotlight on in the night`,
  originalHeight: 1026,
  originalWidth: 1125
}

/**
 * ![Affirm Hero - Desktop](https://images.ctfassets.net/v6awd0kabi65/wRa9yrdnSS05CN8R8Zycu/8c68d0b359972b61dacc108b320e9cec/desktop_hero-affirm__prime_cta_3x.png?w=120&h=120&fit=pad)
 *
 * Affirm Hero - Desktop
 *
 * Image of outdoor security camera mounted on the side of a home with the spotlight on in the nighttime
 */
export const IMG_wRa9yrdnSS05CN8R8Zycu = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/wRa9yrdnSS05CN8R8Zycu/8c68d0b359972b61dacc108b320e9cec/desktop_hero-affirm__prime_cta_3x.png',
  description: `Image of outdoor security camera mounted on the side of a home with the spotlight on in the nighttime`,
  originalHeight: 1782,
  originalWidth: 3936
}

/**
 * ![Competitive Comparison Page | Mobile System Banner Image](https://images.ctfassets.net/v6awd0kabi65/1JupDkm1XxkXugGUJLqwjn/97751e4544c50748fab1b7d956e4fdd4/System_Banner_-_Mobile.png?w=120&h=120&fit=pad)
 *
 * Competitive Comparison Page | Mobile System Banner Image
 *
 * Image of home security system featuring an outdoor camera, indoor camera and video doorbell
 */
export const IMG_1JupDkm1XxkXugGUJLqwjn = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1JupDkm1XxkXugGUJLqwjn/97751e4544c50748fab1b7d956e4fdd4/System_Banner_-_Mobile.png',
  description: `Image of home security system featuring an outdoor camera, indoor camera and video doorbell`,
  originalHeight: 344,
  originalWidth: 343
}

/**
 * ![Feature Section - Desktop](https://images.ctfassets.net/v6awd0kabi65/2iEddqw4heR3jDmoQDuY2S/3392b7a9d6c0382a32096640c17dcfff/Feature_Section_-_Desktop.png?w=120&h=120&fit=pad)
 *
 * Feature Section - Desktop
 *
 * Image of a monitoring agent actively deterring an intruder
 */
export const IMG_2iEddqw4heR3jDmoQDuY2S = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2iEddqw4heR3jDmoQDuY2S/3392b7a9d6c0382a32096640c17dcfff/Feature_Section_-_Desktop.png',
  description: `Image of a monitoring agent actively deterring an intruder`,
  originalHeight: 610,
  originalWidth: 578
}

/**
 * ![Options Comparison - DIY](https://images.ctfassets.net/v6awd0kabi65/2C2OHoztyEyOFxOxzweR3x/19b18d94cdb84d12cf1d2905d001e1e5/Options_Comparison_-_DIY.png?w=120&h=120&fit=pad)
 *
 * Options Comparison - DIY
 *
 * Image of a SimpliSafe home security kiti in a box
 */
export const IMG_2C2OHoztyEyOFxOxzweR3x = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2C2OHoztyEyOFxOxzweR3x/19b18d94cdb84d12cf1d2905d001e1e5/Options_Comparison_-_DIY.png',
  description: `Image of a SimpliSafe home security kiti in a box`,
  originalHeight: 390,
  originalWidth: 636
}

/**
 * ![Options Comparison - Pro Install](https://images.ctfassets.net/v6awd0kabi65/1md4MHLECa3FREbwDzgIbk/e6e90574b1404f0ea7c11f29aae0139e/Options_Comparison_-_Pro_Install.png?w=120&h=120&fit=pad)
 *
 * Options Comparison - Pro Install
 *
 * Image of a professional installer mounting an outdoor camera to a home
 */
export const IMG_1md4MHLECa3FREbwDzgIbk = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1md4MHLECa3FREbwDzgIbk/e6e90574b1404f0ea7c11f29aae0139e/Options_Comparison_-_Pro_Install.png',
  description: `Image of a professional installer mounting an outdoor camera to a home`,
  originalHeight: 390,
  originalWidth: 636
}

/**
 * ![Options Comparison - Pro Install - Mobile](https://images.ctfassets.net/v6awd0kabi65/2S0uocpKjAAZPEbSWMZwte/14dce284ce892bededdc9825ad0245cc/Options_Comparison_-_Pro_Install_-_Mobile.png?w=120&h=120&fit=pad)
 *
 * Options Comparison - Pro Install - Mobile
 *
 * Image of a professional installer mounting an outdoor camera to the side of a home
 */
export const IMG_2S0uocpKjAAZPEbSWMZwte = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2S0uocpKjAAZPEbSWMZwte/14dce284ce892bededdc9825ad0245cc/Options_Comparison_-_Pro_Install_-_Mobile.png',
  description: `Image of a professional installer mounting an outdoor camera to the side of a home`,
  originalHeight: 142,
  originalWidth: 168
}

/**
 * ![Competitive Comparison Page | Hero Banner Image](https://images.ctfassets.net/v6awd0kabi65/6JsB67aqNgW59O4IpM8uQR/4c5a427899502b3ec0be290b35678be8/Competitive_-_Desktop.png?w=120&h=120&fit=pad)
 *
 * Competitive Comparison Page | Hero Banner Image
 *
 * Image of a family in their living room with a home security camera mounted on the wall
 */
export const IMG_6JsB67aqNgW59O4IpM8uQR = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6JsB67aqNgW59O4IpM8uQR/4c5a427899502b3ec0be290b35678be8/Competitive_-_Desktop.png',
  description: `Image of a family in their living room with a home security camera mounted on the wall`,
  originalHeight: 1200,
  originalWidth: 2624
}

/**
 * ![Competitive Comparison Page | Hero Banner Image Mobile](https://images.ctfassets.net/v6awd0kabi65/7ikgorpiBwz37621g0olfV/599819e06a38cfea2e41cbf628eeca44/Competitve_-_Mobile.png?w=120&h=120&fit=pad)
 *
 * Competitive Comparison Page | Hero Banner Image Mobile
 *
 * Image of a family in their living room with a home security camera mounted to the wall
 */
export const IMG_7ikgorpiBwz37621g0olfV = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7ikgorpiBwz37621g0olfV/599819e06a38cfea2e41cbf628eeca44/Competitve_-_Mobile.png',
  description: `Image of a family in their living room with a home security camera mounted to the wall`,
  originalHeight: 874,
  originalWidth: 750
}

/**
 * ![SimpliSafe's New TV Advert](https://images.ctfassets.net/v6awd0kabi65/4uSpVKIav8fjHPtS3HI00R/f3a2873ed182aed7756287fa31641ac6/SimpliSafe_by_Ian_Wallman_00642__1___1_.jpg?w=120&h=120&fit=pad)
 *
 * SimpliSafe's New TV Advert
 *
 * Image of a couple on their couch with a dog hodling a SimpliSafe base station
 */
export const IMG_4uSpVKIav8fjHPtS3HI00R = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4uSpVKIav8fjHPtS3HI00R/f3a2873ed182aed7756287fa31641ac6/SimpliSafe_by_Ian_Wallman_00642__1___1_.jpg',
  description: `Image of a couple on their couch with a dog hodling a SimpliSafe base station`,
  originalHeight: 667,
  originalWidth: 1000
}

/**
 * ![Meet Our New TV Advert](https://videos.ctfassets.net/v6awd0kabi65/55Z7JzZOyV8SK7aSLQk2bP/32c2fecd3689ea9e7e8527676ce803fa/230912-SIMPLISAFE-DRTV_ROCKY-FINAL.mp4?w=120&h=120&fit=pad)
 *
 * Meet Our New TV Advert
 *
 * Simplisafe TV advert
 */
export const IMG_55Z7JzZOyV8SK7aSLQk2bP = {
  url: 'https://videos.ctfassets.net/v6awd0kabi65/55Z7JzZOyV8SK7aSLQk2bP/32c2fecd3689ea9e7e8527676ce803fa/230912-SIMPLISAFE-DRTV_ROCKY-FINAL.mp4',
  description: `Simplisafe TV advert`,
  originalHeight: null,
  originalWidth: null
}

/**
 * ![11 autumn safety tips to keep you and your family safe](https://images.ctfassets.net/v6awd0kabi65/162yh5karHEZCBdzOVANNI/9292fa3c38aeaee8d84d4cf893d37f34/greg-shield-kAc0En1s1h8-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * 11 autumn safety tips to keep you and your family safe
 *
 * image of fall leaves
 */
export const IMG_162yh5karHEZCBdzOVANNI = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/162yh5karHEZCBdzOVANNI/9292fa3c38aeaee8d84d4cf893d37f34/greg-shield-kAc0En1s1h8-unsplash.jpg',
  description: `image of fall leaves`,
  originalHeight: 3840,
  originalWidth: 5760
}

/**
 * ![Ecomm UK Hero (Desktop)](https://images.ctfassets.net/v6awd0kabi65/1nl1Ij9UqSQjp1jTXDvPlC/f76abb9439038443750a5c7d933186eb/D-hero2-UK_2x.jpg?w=120&h=120&fit=pad)
 *
 * Ecomm UK Hero (Desktop)
 *
 * Image of a family in their home with a home security system
 */
export const IMG_1nl1Ij9UqSQjp1jTXDvPlC = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1nl1Ij9UqSQjp1jTXDvPlC/f76abb9439038443750a5c7d933186eb/D-hero2-UK_2x.jpg',
  description: `Image of a family in their home with a home security system`,
  originalHeight: 2400,
  originalWidth: 4800
}

/**
 * ![Ecomm UK Hero (Mobile)](https://images.ctfassets.net/v6awd0kabi65/3ZkQO0CVlxVJA4hgyV19tC/bd09a0a67765f37a59a87ec2fd7d41fe/Mobile_768x424.png?w=120&h=120&fit=pad)
 *
 * Ecomm UK Hero (Mobile)
 *
 * Image of a family and their dog in their home with a home security system
 */
export const IMG_3ZkQO0CVlxVJA4hgyV19tC = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3ZkQO0CVlxVJA4hgyV19tC/bd09a0a67765f37a59a87ec2fd7d41fe/Mobile_768x424.png',
  description: `Image of a family and their dog in their home with a home security system`,
  originalHeight: 424,
  originalWidth: 768
}

/**
 * ![Standard Starter Kit (Small Insurance)](https://images.ctfassets.net/v6awd0kabi65/4cpLntMucNFLIVypCorcFJ/4b68f1466479306114866eeceec8145c/Standard_Starter_Kit__Small_Insurance__.png?w=120&h=120&fit=pad)
 *
 * Standard Starter Kit (Small Insurance)
 *
 * Image of home security kit
 */
export const IMG_4cpLntMucNFLIVypCorcFJ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4cpLntMucNFLIVypCorcFJ/4b68f1466479306114866eeceec8145c/Standard_Starter_Kit__Small_Insurance__.png',
  description: `Image of home security kit`,
  originalHeight: 1800,
  originalWidth: 1800
}

/**
 * ![Standard Whole Home Kit (Large Non-Insurance)](https://images.ctfassets.net/v6awd0kabi65/5eaMKmec4dnf64D2eolLzr/b314e5f93bbe40fb4ff58e9c91a69a83/Standard_Whole_Home_Kit__Large_Non-Insurance_.png?w=120&h=120&fit=pad)
 *
 * Standard Whole Home Kit (Large Non-Insurance)
 *
 * Image of home security kit
 */
export const IMG_5eaMKmec4dnf64D2eolLzr = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5eaMKmec4dnf64D2eolLzr/b314e5f93bbe40fb4ff58e9c91a69a83/Standard_Whole_Home_Kit__Large_Non-Insurance_.png',
  description: `Image of home security kit`,
  originalHeight: 1800,
  originalWidth: 1800
}

/**
 * ![Standard Whole Home Kit (Large Insurance)](https://images.ctfassets.net/v6awd0kabi65/66QTzUETmW32EzkJkfXZiH/7a7d358da7deee96d247e774e62d41ea/Standard_Whole_Home_Kit__Large_Insurance_.png?w=120&h=120&fit=pad)
 *
 * Standard Whole Home Kit (Large Insurance)
 *
 * Image of home security kit
 */
export const IMG_66QTzUETmW32EzkJkfXZiH = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/66QTzUETmW32EzkJkfXZiH/7a7d358da7deee96d247e774e62d41ea/Standard_Whole_Home_Kit__Large_Insurance_.png',
  description: `Image of home security kit`,
  originalHeight: 1800,
  originalWidth: 1800
}

/**
 * ![LifeLock Indoor Camera Kit](https://images.ctfassets.net/v6awd0kabi65/3pQpjPq9Y69zVo75dCZOvN/6a5537585abea539b9176b0baf8deae5/LifeLock1.png?w=120&h=120&fit=pad)
 *
 * LifeLock Indoor Camera Kit
 *
 * Image of lifelock home security image
 */
export const IMG_3pQpjPq9Y69zVo75dCZOvN = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3pQpjPq9Y69zVo75dCZOvN/6a5537585abea539b9176b0baf8deae5/LifeLock1.png',
  description: `Image of lifelock home security image`,
  originalHeight: 2769,
  originalWidth: 4654
}

/**
 * ![LifeLock Outdoor](https://images.ctfassets.net/v6awd0kabi65/2wMBiwFyugNWv7lAJg86bh/c9a92365768afce8b0fbe29b90b630cf/LifeLock2.png?w=120&h=120&fit=pad)
 *
 * LifeLock Outdoor
 *
 * Image of Lifelock home security system
 */
export const IMG_2wMBiwFyugNWv7lAJg86bh = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2wMBiwFyugNWv7lAJg86bh/c9a92365768afce8b0fbe29b90b630cf/LifeLock2.png',
  description: `Image of Lifelock home security system`,
  originalHeight: 2764,
  originalWidth: 4654
}

/**
 * ![USAA Package Balto](https://images.ctfassets.net/v6awd0kabi65/4u2VYUwahy3oU1f6Plrk6U/35be3bbfed2cb4423dd99db54c64c7f4/USAA_Package_Balto.jpg?w=120&h=120&fit=pad)
 *
 * USAA Package Balto
 *
 * image of USAA home security package
 */
export const IMG_4u2VYUwahy3oU1f6Plrk6U = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4u2VYUwahy3oU1f6Plrk6U/35be3bbfed2cb4423dd99db54c64c7f4/USAA_Package_Balto.jpg',
  description: `image of USAA home security package`,
  originalHeight: 1124,
  originalWidth: 1274
}

/**
 * ![12 Days of Christmas Safety](https://images.ctfassets.net/v6awd0kabi65/3S0de5Y9EkesvFG3O5HB0P/4d1612354660307c3f6894202b25a9fe/pexels-torsten-dettlaff-195030.jpg?w=120&h=120&fit=pad)
 *
 * 12 Days of Christmas Safety
 *
 * Image of an advent calendar and christmas decoration
 */
export const IMG_3S0de5Y9EkesvFG3O5HB0P = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3S0de5Y9EkesvFG3O5HB0P/4d1612354660307c3f6894202b25a9fe/pexels-torsten-dettlaff-195030.jpg',
  description: `Image of an advent calendar and christmas decoration`,
  originalHeight: 3840,
  originalWidth: 5760
}

/**
 * ![Meet the System Nav ](https://images.ctfassets.net/v6awd0kabi65/2n9okk7IQZPtmVYvSD3KXg/be45e1216816d9c928b3f35e43c8ba2d/Meet_the_System_thumbnail.jpg?w=120&h=120&fit=pad)
 *
 * Meet the System Nav
 *
 * Image of a home security base station and keypad
 */
export const IMG_2n9okk7IQZPtmVYvSD3KXg = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2n9okk7IQZPtmVYvSD3KXg/be45e1216816d9c928b3f35e43c8ba2d/Meet_the_System_thumbnail.jpg',
  description: `Image of a home security base station and keypad`,
  originalHeight: 468,
  originalWidth: 700
}

/**
 * ![Whole home security at an unbeatable price V2](https://images.ctfassets.net/v6awd0kabi65/3E48COmRtPpeHKWuvmmmdF/c0abaddb55c4ab367b60e490b09743f5/image_169.png?w=120&h=120&fit=pad)
 *
 * Whole home security at an unbeatable price V2
 *
 * Image of a home security system with a 100% satisfaction guarantee badge
 */
export const IMG_3E48COmRtPpeHKWuvmmmdF = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3E48COmRtPpeHKWuvmmmdF/c0abaddb55c4ab367b60e490b09743f5/image_169.png',
  description: `Image of a home security system with a 100% satisfaction guarantee badge`,
  originalHeight: 1038,
  originalWidth: 1362
}

/**
 * ![Scout - transparent](https://images.ctfassets.net/v6awd0kabi65/1VzqzNKAfL0SZYiOOaCQCY/3f934f15277915c64fb169d38c30f56f/Scout-3x.png?w=120&h=120&fit=pad)
 *
 * Scout - transparent
 *
 * Image of indoor security camera on a plain white background
 */
export const IMG_1VzqzNKAfL0SZYiOOaCQCY = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1VzqzNKAfL0SZYiOOaCQCY/3f934f15277915c64fb169d38c30f56f/Scout-3x.png',
  description: `Image of indoor security camera on a plain white background`,
  originalHeight: 964,
  originalWidth: 1308
}

/**
 * ![ODMON - Quiz - Existent Outdoor Cameras](https://images.ctfassets.net/v6awd0kabi65/73a9K6XnIlKk3rtowy0AEc/881f723eb9200180bf69985f7a869218/camera.png?w=120&h=120&fit=pad)
 *
 * ODMON - Quiz - Existent Outdoor Cameras
 *
 * Image of outdoor security camera mounted to the side of a house on a sunny day
 */
export const IMG_73a9K6XnIlKk3rtowy0AEc = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/73a9K6XnIlKk3rtowy0AEc/881f723eb9200180bf69985f7a869218/camera.png',
  description: `Image of outdoor security camera mounted to the side of a house on a sunny day`,
  originalHeight: 600,
  originalWidth: 800
}

/**
 * ![ODMON - Quiz - Purchase Kits - Plan 1](https://images.ctfassets.net/v6awd0kabi65/4WIkGImndTRhEvVAfQKrcE/8432a6c8a3c346e5630451ad1fd3a49c/shield_1.png?w=120&h=120&fit=pad)
 *
 * ODMON - Quiz - Purchase Kits - Plan 1
 *
 * Image of outdoor security camera showing that it is monitoring the outside of your home for 24 hours
 */
export const IMG_4WIkGImndTRhEvVAfQKrcE = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4WIkGImndTRhEvVAfQKrcE/8432a6c8a3c346e5630451ad1fd3a49c/shield_1.png',
  description: `Image of outdoor security camera showing that it is monitoring the outside of your home for 24 hours`,
  originalHeight: 570,
  originalWidth: 600
}

/**
 * ![ODMON - Quiz - Purchase Kits - Plan 2](https://images.ctfassets.net/v6awd0kabi65/2OUjxIV4w4gBJcoeWX4Dxe/9ccca91a6cba98bcee660fb0d25a3a11/shield_2.png?w=120&h=120&fit=pad)
 *
 * ODMON - Quiz - Purchase Kits - Plan 2
 *
 * Image of outdoor security camera, showing that it has night vision
 */
export const IMG_2OUjxIV4w4gBJcoeWX4Dxe = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2OUjxIV4w4gBJcoeWX4Dxe/9ccca91a6cba98bcee660fb0d25a3a11/shield_2.png',
  description: `Image of outdoor security camera, showing that it has night vision`,
  originalHeight: 570,
  originalWidth: 600
}

/**
 * ![Ecomm UK Hero (Tablet)](https://images.ctfassets.net/v6awd0kabi65/6J7gCMag8awuxd1DsrttpO/26cc12fe7edc7fbeff38dea523c47be2/J004854_-_SimpliSafe_-_Which_-_iPad_-_2173x1200___3.jpg?w=120&h=120&fit=pad)
 *
 * Ecomm UK Hero (Tablet)
 *
 * Image of a family on their couch in their home, featuring a home security system
 */
export const IMG_6J7gCMag8awuxd1DsrttpO = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6J7gCMag8awuxd1DsrttpO/26cc12fe7edc7fbeff38dea523c47be2/J004854_-_SimpliSafe_-_Which_-_iPad_-_2173x1200___3.jpg',
  description: `Image of a family on their couch in their home, featuring a home security system`,
  originalHeight: 2400,
  originalWidth: 4346
}

/**
 * ![Crime Near You HP component image](https://images.ctfassets.net/v6awd0kabi65/2INwGZM0Jou9nHAQpoaQ5V/7088ea93d870421c0eec8725e5c6cc2b/Houston-crime-img.jpg?w=120&h=120&fit=pad)
 *
 * Crime Near You HP component image
 *
 * Image of a map of Houston
 */
export const IMG_2INwGZM0Jou9nHAQpoaQ5V = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2INwGZM0Jou9nHAQpoaQ5V/7088ea93d870421c0eec8725e5c6cc2b/Houston-crime-img.jpg',
  description: `Image of a map of Houston`,
  originalHeight: 752,
  originalWidth: 1186
}

/**
 * ![ODMON - monitoring agent](https://images.ctfassets.net/v6awd0kabi65/5YcwkF8tM9VMFfrspIomZg/1ca36a8c2dc6feb15d57510074da404e/monitoring_agent_3x.png?w=120&h=120&fit=pad)
 *
 * ODMON - monitoring agent
 *
 * Image of a monitoring agent looking at a computer with a headset on
 */
export const IMG_5YcwkF8tM9VMFfrspIomZg = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5YcwkF8tM9VMFfrspIomZg/1ca36a8c2dc6feb15d57510074da404e/monitoring_agent_3x.png',
  description: `Image of a monitoring agent looking at a computer with a headset on`,
  originalHeight: 663,
  originalWidth: 639
}

/**
 * ![ODMON - Quiz - Purchase Outdoor Camera](https://images.ctfassets.net/v6awd0kabi65/7tKNjDX9lTzwA8RJWadX84/37107736472e01fb8fb0d9813d50f396/New_camera_3x.jpg?w=120&h=120&fit=pad)
 *
 * ODMON - Quiz - Purchase Outdoor Camera
 *
 * Image of outdoor security camera mounted
 */
export const IMG_7tKNjDX9lTzwA8RJWadX84 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7tKNjDX9lTzwA8RJWadX84/37107736472e01fb8fb0d9813d50f396/New_camera_3x.jpg',
  description: `Image of outdoor security camera mounted`,
  originalHeight: 393,
  originalWidth: 1005
}

/**
 * ![ODMON - App Store](https://images.ctfassets.net/v6awd0kabi65/1LZZhX8Tixah9lRPDQeWZH/d4f86e13f1e5f69e4a259ad92a84481d/image__4_.png?w=120&h=120&fit=pad)
 *
 * ODMON - App Store
 *
 * Image of Apple icon saying Download on the App Store
 */
export const IMG_1LZZhX8Tixah9lRPDQeWZH = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1LZZhX8Tixah9lRPDQeWZH/d4f86e13f1e5f69e4a259ad92a84481d/image__4_.png',
  description: `Image of Apple icon saying Download on the App Store`,
  originalHeight: 136,
  originalWidth: 396
}

/**
 * ![ODMON - Google play](https://images.ctfassets.net/v6awd0kabi65/1lpvuD6Dr3YfI0klJZGoF5/bad795758126e2aec2b2780dec064060/image__5_.png?w=120&h=120&fit=pad)
 *
 * ODMON - Google play
 *
 * Image of Google Play icon
 */
export const IMG_1lpvuD6Dr3YfI0klJZGoF5 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1lpvuD6Dr3YfI0klJZGoF5/bad795758126e2aec2b2780dec064060/image__5_.png',
  description: `Image of Google Play icon`,
  originalHeight: 138,
  originalWidth: 468
}

/**
 * ![ODMON - App store QR](https://images.ctfassets.net/v6awd0kabi65/7lChpM4GE20CcKDjImAEDX/896671473eddd236ec4fd8625034425b/Apple.png?w=120&h=120&fit=pad)
 *
 * ODMON - App store QR
 *
 * Image of a SimpliSafe QR code
 */
export const IMG_7lChpM4GE20CcKDjImAEDX = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7lChpM4GE20CcKDjImAEDX/896671473eddd236ec4fd8625034425b/Apple.png',
  description: `Image of a SimpliSafe QR code`,
  originalHeight: 656,
  originalWidth: 656
}

/**
 * ![Video Doorbell (Transparent)](https://images.ctfassets.net/v6awd0kabi65/71A0m3JHDtUztFwItHbmrw/a5b32e3c1cb2037c94f8bc37f0273853/doorbell_transparent.png?w=120&h=120&fit=pad)
 *
 * Video Doorbell (Transparent)
 *
 * Image of video doorbell pro on a plain white background
 */
export const IMG_71A0m3JHDtUztFwItHbmrw = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/71A0m3JHDtUztFwItHbmrw/a5b32e3c1cb2037c94f8bc37f0273853/doorbell_transparent.png',
  description: `Image of video doorbell pro on a plain white background`,
  originalHeight: 320,
  originalWidth: 388
}

/**
 * ![Video Doorbell (Lifestyle)](https://images.ctfassets.net/v6awd0kabi65/2APHguqW0I0X9DFhf0ToLS/38acc7f4c764538fdca397a21aa237b8/doorbell_lifestyle.webp?w=120&h=120&fit=pad)
 *
 * Video Doorbell (Lifestyle)
 *
 * Image of a video doorbell pro mounted to a front door
 */
export const IMG_2APHguqW0I0X9DFhf0ToLS = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2APHguqW0I0X9DFhf0ToLS/38acc7f4c764538fdca397a21aa237b8/doorbell_lifestyle.webp',
  description: `Image of a video doorbell pro mounted to a front door`,
  originalHeight: 747,
  originalWidth: 1439
}

/**
 * ![VDP_Carousel_1.jpg](https://images.ctfassets.net/v6awd0kabi65/5Sw0Nt2dn8zUeMF2MSfPAb/224aca6d04ba5842c840f48ca5eb73f7/VDP_Carousel_1.jpg?w=120&h=120&fit=pad)
 *
 * VDP_Carousel_1.jpg
 *
 * Image of video doorbell pro mounted on a front door with someone pressing the doorbell
 */
export const IMG_5Sw0Nt2dn8zUeMF2MSfPAb = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5Sw0Nt2dn8zUeMF2MSfPAb/224aca6d04ba5842c840f48ca5eb73f7/VDP_Carousel_1.jpg',
  description: `Image of video doorbell pro mounted on a front door with someone pressing the doorbell`,
  originalHeight: 1553,
  originalWidth: 1968
}

/**
 * ![VDP_Carousel_2.jpg](https://images.ctfassets.net/v6awd0kabi65/5zXe4MnGr5Jzpin8rmQSVz/02fdff0643ae058a1ce24336c3d35316/VDP_Carousel_2.jpg?w=120&h=120&fit=pad)
 *
 * VDP_Carousel_2.jpg
 *
 * Image of video doorbell pro, showing how it alerts you when someone approaches your door
 */
export const IMG_5zXe4MnGr5Jzpin8rmQSVz = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5zXe4MnGr5Jzpin8rmQSVz/02fdff0643ae058a1ce24336c3d35316/VDP_Carousel_2.jpg',
  description: `Image of video doorbell pro, showing how it alerts you when someone approaches your door`,
  originalHeight: 1553,
  originalWidth: 1968
}

/**
 * ![VDP_Carousel_3.jpg](https://images.ctfassets.net/v6awd0kabi65/7sm1Urdaoha6HsxWYAPSIR/b972c96281ca6b217dfa48aaa54b4563/VDP_Carousel_3.jpg?w=120&h=120&fit=pad)
 *
 * VDP_Carousel_3.jpg
 *
 * Image of a phone showing SimpliSafe notifications being sent fron the video doorbell pro when someone is at the front door
 */
export const IMG_7sm1Urdaoha6HsxWYAPSIR = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7sm1Urdaoha6HsxWYAPSIR/b972c96281ca6b217dfa48aaa54b4563/VDP_Carousel_3.jpg',
  description: `Image of a phone showing SimpliSafe notifications being sent fron the video doorbell pro when someone is at the front door`,
  originalHeight: 1553,
  originalWidth: 1968
}

/**
 * ![VDP_Carousel_4.jpg](https://images.ctfassets.net/v6awd0kabi65/tWKR8uMEDtD3AeGxF67g7/5685571338c4b1d6ff65e747633b736e/VDP_Carousel_4.jpg?w=120&h=120&fit=pad)
 *
 * VDP_Carousel_4.jpg
 *
 * Image of a woman keeping an eye on her front porch package through the video doorbell camera and protecting it from burglars
 */
export const IMG_tWKR8uMEDtD3AeGxF67g7 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/tWKR8uMEDtD3AeGxF67g7/5685571338c4b1d6ff65e747633b736e/VDP_Carousel_4.jpg',
  description: `Image of a woman keeping an eye on her front porch package through the video doorbell camera and protecting it from burglars`,
  originalHeight: 1553,
  originalWidth: 1968
}

/**
 * ![VDP_Carousel_5.jpg](https://images.ctfassets.net/v6awd0kabi65/2eAYoIxRPzItgu2KB6nt5i/dca06815d9485775db155cbba1b94f47/VDP_Carousel_5.jpg?w=120&h=120&fit=pad)
 *
 * VDP_Carousel_5.jpg
 *
 * Image of a delivery person at the front door which can be seen on the SimpliSafe app through the video doorbell pro
 */
export const IMG_2eAYoIxRPzItgu2KB6nt5i = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2eAYoIxRPzItgu2KB6nt5i/dca06815d9485775db155cbba1b94f47/VDP_Carousel_5.jpg',
  description: `Image of a delivery person at the front door which can be seen on the SimpliSafe app through the video doorbell pro`,
  originalHeight: 1553,
  originalWidth: 1968
}

/**
 * ![Video Doorbell](https://images.ctfassets.net/v6awd0kabi65/5eQPGOanYnWHFWnUZrvy8m/31ec39da0771cf32485717b3f07aedd3/doorbell.png?w=120&h=120&fit=pad)
 *
 * Video Doorbell
 *
 * Image of video doorbell pro on plain white background
 */
export const IMG_5eQPGOanYnWHFWnUZrvy8m = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5eQPGOanYnWHFWnUZrvy8m/31ec39da0771cf32485717b3f07aedd3/doorbell.png',
  description: `Image of video doorbell pro on plain white background`,
  originalHeight: 898,
  originalWidth: 898
}

/**
 * ![System perspective single view - Video Doorbell Pro](https://images.ctfassets.net/v6awd0kabi65/6uu3kO1LbqatHQm3TcyQvZ/719a5855b9cd05bdda43afe9a36ce5f8/508e559d7c96ae44555daa22d2f573d7.png?w=120&h=120&fit=pad)
 *
 * System perspective single view - Video Doorbell Pro
 *
 * Image of video doorbell pro on a plain white background
 */
export const IMG_6uu3kO1LbqatHQm3TcyQvZ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6uu3kO1LbqatHQm3TcyQvZ/719a5855b9cd05bdda43afe9a36ce5f8/508e559d7c96ae44555daa22d2f573d7.png',
  description: `Image of video doorbell pro on a plain white background`,
  originalHeight: 2107,
  originalWidth: 2560
}

/**
 * ![doorbell diagram 2](https://images.ctfassets.net/v6awd0kabi65/5aFu20oMQMjou9WsypprMt/5f905952d45fbed41dac123850adbbf0/VDP_diagram_2.jpg?w=120&h=120&fit=pad)
 *
 * doorbell diagram 2
 *
 * Image showing the doorbell pro LED status light
 */
export const IMG_5aFu20oMQMjou9WsypprMt = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5aFu20oMQMjou9WsypprMt/5f905952d45fbed41dac123850adbbf0/VDP_diagram_2.jpg',
  description: `Image showing the doorbell pro LED status light `,
  originalHeight: 1386,
  originalWidth: 1198
}

/**
 * ![Video doorbell pro - Live feed](https://images.ctfassets.net/v6awd0kabi65/semV7bVZq1I5zVhGGrRgQ/c24cd24b2eb5ca69de70999e31341366/VDP_app_screen1.png?w=120&h=120&fit=pad)
 *
 * Video doorbell pro - Live feed
 *
 * Image of SimpliSafe app showing a delivery person at the front door through the doorbell pro camera
 */
export const IMG_semV7bVZq1I5zVhGGrRgQ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/semV7bVZq1I5zVhGGrRgQ/c24cd24b2eb5ca69de70999e31341366/VDP_app_screen1.png',
  description: `Image of SimpliSafe app showing a delivery person at the front door through the doorbell pro camera`,
  originalHeight: 632,
  originalWidth: 506
}

/**
 * ![VDP_app_screen2.png](https://images.ctfassets.net/v6awd0kabi65/1nr47izOvpWj4K3VIM6cPX/d1fc23a11415457960127718fd1b9a5c/VDP_app_screen2.png?w=120&h=120&fit=pad)
 *
 * VDP_app_screen2.png
 *
 * Image of SimpliSafe app showing the view through video doorbell pro camera
 */
export const IMG_1nr47izOvpWj4K3VIM6cPX = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1nr47izOvpWj4K3VIM6cPX/d1fc23a11415457960127718fd1b9a5c/VDP_app_screen2.png',
  description: `Image of SimpliSafe app showing the view through video doorbell pro camera`,
  originalHeight: 627,
  originalWidth: 500
}

/**
 * ![doorbell diagram 1](https://images.ctfassets.net/v6awd0kabi65/1xMpwBN56E6FwmUsMjQL4G/a9f03f5caa4eb13b2e803ab02a239d78/VDP_diagram_1.jpg?w=120&h=120&fit=pad)
 *
 * doorbell diagram 1
 *
 * Image of video doorbell pro features
 */
export const IMG_1xMpwBN56E6FwmUsMjQL4G = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1xMpwBN56E6FwmUsMjQL4G/a9f03f5caa4eb13b2e803ab02a239d78/VDP_diagram_1.jpg',
  description: `Image of video doorbell pro features`,
  originalHeight: 1386,
  originalWidth: 1198
}

/**
 * ![VDP_app_screen4.png](https://images.ctfassets.net/v6awd0kabi65/5b7UKLrEiwrE1ahYvLc7g4/32669bc7cab085df3a59db4beb9fab85/VDP_app_screen4.png?w=120&h=120&fit=pad)
 *
 * VDP_app_screen4.png
 *
 * Image of doorbell settings through SimpliSafe app
 */
export const IMG_5b7UKLrEiwrE1ahYvLc7g4 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5b7UKLrEiwrE1ahYvLc7g4/32669bc7cab085df3a59db4beb9fab85/VDP_app_screen4.png',
  description: `Image of doorbell settings through SimpliSafe app`,
  originalHeight: 627,
  originalWidth: 500
}

/**
 * ![VDP_Carousel_1.jpg](https://images.ctfassets.net/v6awd0kabi65/5nmtxsPvOhKqBbBxePHS7J/f0930969aa9016f1206949b6b8a28cba/VDP_Carousel_1.jpg?w=120&h=120&fit=pad)
 *
 * VDP_Carousel_1.jpg
 *
 * Image of someone pressing the doorbell on a video doorbell pro that's mounted to a front door
 */
export const IMG_5nmtxsPvOhKqBbBxePHS7J = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5nmtxsPvOhKqBbBxePHS7J/f0930969aa9016f1206949b6b8a28cba/VDP_Carousel_1.jpg',
  description: `Image of someone pressing the doorbell on a video doorbell pro that's mounted to a front door`,
  originalHeight: 1553,
  originalWidth: 1968
}

/**
 * ![VDP_notifications_that_matter_UK.jpg](https://images.ctfassets.net/v6awd0kabi65/7rUfYiQpLrQg4FrBbi6jT9/0167276298ef204616ba1ce848ce04d5/VDP_notifications_that_matter_UK.jpg?w=120&h=120&fit=pad)
 *
 * VDP_notifications_that_matter_UK.jpg
 *
 * Image of SimpliSafe app showing a person at the front door through video doorbell pro
 */
export const IMG_7rUfYiQpLrQg4FrBbi6jT9 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7rUfYiQpLrQg4FrBbi6jT9/0167276298ef204616ba1ce848ce04d5/VDP_notifications_that_matter_UK.jpg',
  description: `Image of SimpliSafe app showing a person at the front door through video doorbell pro`,
  originalHeight: 794,
  originalWidth: 1244
}

/**
 * ![ODMON- Mobile - proactive protection](https://images.ctfassets.net/v6awd0kabi65/6kNkLXSldszxHubIQHYpgP/ea75908ab7660f60005e0b3590694ab5/yard_mob.jpg?w=120&h=120&fit=pad)
 *
 * ODMON- Mobile - proactive protection
 *
 * Image showing how outdoor monitoring protects the outside of your home from potential burglars but remains friendly to friendly faces like a delivery person or dog walker
 */
export const IMG_6kNkLXSldszxHubIQHYpgP = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6kNkLXSldszxHubIQHYpgP/ea75908ab7660f60005e0b3590694ab5/yard_mob.jpg',
  description: `Image showing how outdoor monitoring protects the outside of your home from potential burglars but remains friendly to friendly faces like a delivery person or dog walker`,
  originalHeight: 1616,
  originalWidth: 1616
}

/**
 * ![ODMON - proactive protection](https://images.ctfassets.net/v6awd0kabi65/1VHaUcLI2vBS0yCyiJFnWA/8c095d9ac2d2bf39ac63162bb5646252/yard_DT.jpg?w=120&h=120&fit=pad)
 *
 * ODMON - proactive protection
 *
 * Image showing how outdoor monitoring protects the outside of your home from potential burglars but remains friendly to friendly faces like a delivery person or dog walker
 */
export const IMG_1VHaUcLI2vBS0yCyiJFnWA = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1VHaUcLI2vBS0yCyiJFnWA/8c095d9ac2d2bf39ac63162bb5646252/yard_DT.jpg',
  description: `Image showing how outdoor monitoring protects the outside of your home from potential burglars but remains friendly to friendly faces like a delivery person or dog walker`,
  originalHeight: 1616,
  originalWidth: 3000
}

/**
 * ![ODMON - Live Agents](https://images.ctfassets.net/v6awd0kabi65/2ySMQa0ezAoWOsymSuAPUU/0fc71bfa9ffc94ec335b1166f8624d0f/agent_intruder.jpg?w=120&h=120&fit=pad)
 *
 * ODMON - Live Agents
 *
 * Image of a monitoring agent deterring an intruder through the speaker on the outdoor camera saying "Stop! This is SimpliSafe, you're being recorded."
 */
export const IMG_2ySMQa0ezAoWOsymSuAPUU = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2ySMQa0ezAoWOsymSuAPUU/0fc71bfa9ffc94ec335b1166f8624d0f/agent_intruder.jpg',
  description: `Image of a monitoring agent deterring an intruder through the speaker on the outdoor camera saying "Stop! This is SimpliSafe, you're being recorded."`,
  originalHeight: 794,
  originalWidth: 1244
}

/**
 * ![ODMON - Friendly face](https://images.ctfassets.net/v6awd0kabi65/5ytuDjCV0H2pWSDsIcZhD2/d206e7e84bab42c52faa1363f998d18b/saved_faces.jpg?w=120&h=120&fit=pad)
 *
 * ODMON - Friendly face
 *
 * Image of the SimpliSafe app showing how you can add friendly faces to your outdoor monitoring profile
 */
export const IMG_5ytuDjCV0H2pWSDsIcZhD2 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5ytuDjCV0H2pWSDsIcZhD2/d206e7e84bab42c52faa1363f998d18b/saved_faces.jpg',
  description: `Image of the SimpliSafe app showing how you can add friendly faces to your outdoor monitoring profile`,
  originalHeight: 794,
  originalWidth: 1244
}

/**
 * ![ODMON - Privacy Control](https://images.ctfassets.net/v6awd0kabi65/4mZLvMoNSYcNRlaRKVGsmc/75d94a9ed06fba4b3b094578ed3deb41/privacy.jpg?w=120&h=120&fit=pad)
 *
 * ODMON - Privacy Control
 *
 * Image of SimpliSafe app showing that you can choose which outdoor cameras you would like Live Agents to monitor
 */
export const IMG_4mZLvMoNSYcNRlaRKVGsmc = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4mZLvMoNSYcNRlaRKVGsmc/75d94a9ed06fba4b3b094578ed3deb41/privacy.jpg',
  description: `Image of SimpliSafe app showing that you can choose which outdoor cameras you would like Live Agents to monitor`,
  originalHeight: 794,
  originalWidth: 1244
}

/**
 * ![MeetYourSystem balto](https://images.ctfassets.net/v6awd0kabi65/4SMC8AB1jLMUMNKsfT881z/75e0cac18dd632c8c46adb8a2ae60b28/MeetYourSystem_balto.jpg?w=120&h=120&fit=pad)
 *
 * MeetYourSystem balto
 *
 * Image of motion sensor mounted to a wall of a home showing that it was a 35 foot range and a 90 degree field of view
 */
export const IMG_4SMC8AB1jLMUMNKsfT881z = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4SMC8AB1jLMUMNKsfT881z/75e0cac18dd632c8c46adb8a2ae60b28/MeetYourSystem_balto.jpg',
  description: `Image of motion sensor mounted to a wall of a home showing that it was a 35 foot range and a 90 degree field of view`,
  originalHeight: 910,
  originalWidth: 1087
}

/**
 * ![Simplicam_Carousel_1.jpg](https://images.ctfassets.net/v6awd0kabi65/5dOv3JSzAmcMUbCjhrGhiF/e3049650630e29139fe79f736f418996/Simplicam_Carousel_1.jpg?w=120&h=120&fit=pad)
 *
 * Simplicam_Carousel_1.jpg
 *
 * Image of Simplicam inside a home on a table
 */
export const IMG_5dOv3JSzAmcMUbCjhrGhiF = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5dOv3JSzAmcMUbCjhrGhiF/e3049650630e29139fe79f736f418996/Simplicam_Carousel_1.jpg',
  description: `Image of Simplicam inside a home on a table`,
  originalHeight: 1553,
  originalWidth: 1968
}

/**
 * ![Simplicam_Carousel_2.jpg](https://images.ctfassets.net/v6awd0kabi65/48KhDfxsq8lEFPnU3HQjmM/f8b53cfbde5cd651cb068d6d805cbb6a/Simplicam_Carousel_2.jpg?w=120&h=120&fit=pad)
 *
 * Simplicam_Carousel_2.jpg
 *
 * Image of the Simplicam and it's specific features
 */
export const IMG_48KhDfxsq8lEFPnU3HQjmM = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/48KhDfxsq8lEFPnU3HQjmM/f8b53cfbde5cd651cb068d6d805cbb6a/Simplicam_Carousel_2.jpg',
  description: `Image of the Simplicam and it's specific features`,
  originalHeight: 1553,
  originalWidth: 1968
}

/**
 * ![Simplicam_Carousel_3.jpg](https://images.ctfassets.net/v6awd0kabi65/3SZGjpY6U3yggK8Va9PCWd/cb4e0193c813f1a1568afa584da6996e/Simplicam_Carousel_3.jpg?w=120&h=120&fit=pad)
 *
 * Simplicam_Carousel_3.jpg
 *
 * Image of Simplicam inside a home showing that your privacy is protected
 */
export const IMG_3SZGjpY6U3yggK8Va9PCWd = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3SZGjpY6U3yggK8Va9PCWd/cb4e0193c813f1a1568afa584da6996e/Simplicam_Carousel_3.jpg',
  description: `Image of Simplicam inside a home showing that your privacy is protected`,
  originalHeight: 1553,
  originalWidth: 1968
}

/**
 * ![Simplicam_Carousel_4.jpg](https://images.ctfassets.net/v6awd0kabi65/7r0ZHmF8JaBwQWpREXDet1/fe31778efdd47b6d563b466d7454ddc2/Simplicam_Carousel_4.jpg?w=120&h=120&fit=pad)
 *
 * Simplicam_Carousel_4.jpg
 *
 * Image of the SimpliSafe app on a phone showing that cameras record and store footage for up to 30 days with a monitoring plan
 */
export const IMG_7r0ZHmF8JaBwQWpREXDet1 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7r0ZHmF8JaBwQWpREXDet1/fe31778efdd47b6d563b466d7454ddc2/Simplicam_Carousel_4.jpg',
  description: `Image of the SimpliSafe app on a phone showing that cameras record and store footage for up to 30 days with a monitoring plan`,
  originalHeight: 1553,
  originalWidth: 1968
}

/**
 * ![Simplicam_Carousel_5.jpg](https://images.ctfassets.net/v6awd0kabi65/6hwGAFl52ROzhpCTQxqQwo/707398c00d9181979379894a8caf5b4c/Simplicam_Carousel_5.jpg?w=120&h=120&fit=pad)
 *
 * Simplicam_Carousel_5.jpg
 *
 * Image of Simplicam in a home showing that it has a 120 degree field of view and night vision
 */
export const IMG_6hwGAFl52ROzhpCTQxqQwo = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6hwGAFl52ROzhpCTQxqQwo/707398c00d9181979379894a8caf5b4c/Simplicam_Carousel_5.jpg',
  description: `Image of Simplicam in a home showing that it has a 120 degree field of view and night vision`,
  originalHeight: 1553,
  originalWidth: 1968
}

/**
 * ![Simplicam_stand_alone.png](https://images.ctfassets.net/v6awd0kabi65/11ADDPwN0HAPRtKLZyWDx4/fc145da41063c8a648006db28fd91d48/Simplicam_stand_alone.png?w=120&h=120&fit=pad)
 *
 * Simplicam_stand_alone.png
 *
 * Image of Simplicam product on a plain white background
 */
export const IMG_11ADDPwN0HAPRtKLZyWDx4 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/11ADDPwN0HAPRtKLZyWDx4/fc145da41063c8a648006db28fd91d48/Simplicam_stand_alone.png',
  description: `Image of Simplicam product on a plain white background`,
  originalHeight: 692,
  originalWidth: 908
}

/**
 * ![Simplicam_diagram_1.jpg](https://images.ctfassets.net/v6awd0kabi65/3hpkj7Usy1Z496Rk8Ck1la/24e03ee5adc095ecd3b4d6a047fde8ea/Simplicam_diagram_1.jpg?w=120&h=120&fit=pad)
 *
 * Simplicam_diagram_1.jpg
 *
 * Image of Simplicam features
 */
export const IMG_3hpkj7Usy1Z496Rk8Ck1la = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3hpkj7Usy1Z496Rk8Ck1la/24e03ee5adc095ecd3b4d6a047fde8ea/Simplicam_diagram_1.jpg',
  description: `Image of Simplicam features`,
  originalHeight: 1386,
  originalWidth: 1198
}

/**
 * ![Simplicam_diagram_2.jpg](https://images.ctfassets.net/v6awd0kabi65/3GCHUDyAKfwFE2r5qI7mRL/a96c23ea0faf09a3eebe1513eaa1c9ec/Simplicam_diagram_2.jpg?w=120&h=120&fit=pad)
 *
 * Simplicam_diagram_2.jpg
 *
 * Image of a side view of the Simplicam
 */
export const IMG_3GCHUDyAKfwFE2r5qI7mRL = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3GCHUDyAKfwFE2r5qI7mRL/a96c23ea0faf09a3eebe1513eaa1c9ec/Simplicam_diagram_2.jpg',
  description: `Image of a side view of the Simplicam`,
  originalHeight: 1386,
  originalWidth: 1198
}

/**
 * ![Simplicam_app_1.png](https://images.ctfassets.net/v6awd0kabi65/5q0ijywl28IgVOHs3Q0RU/5646e27dbb8e755ba189cb6984e87bdc/Simplicam_app_1.png?w=120&h=120&fit=pad)
 *
 * Simplicam_app_1.png
 *
 * Image of the SimpliSafe app showing both day and night views from an indoor camera
 */
export const IMG_5q0ijywl28IgVOHs3Q0RU = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5q0ijywl28IgVOHs3Q0RU/5646e27dbb8e755ba189cb6984e87bdc/Simplicam_app_1.png',
  description: `Image of the SimpliSafe app showing both day and night views from an indoor camera`,
  originalHeight: 1254,
  originalWidth: 1000
}

/**
 * ![Simplicam_app_2.png](https://images.ctfassets.net/v6awd0kabi65/7Gjo2uP2lfgovMfGn2JBQw/eb7f129e4af5dd9fc433228ebf278e15/Simplicam_app_2.png?w=120&h=120&fit=pad)
 *
 * Simplicam_app_2.png
 *
 * Simage of the SimpliSafe app showing camera views
 */
export const IMG_7Gjo2uP2lfgovMfGn2JBQw = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7Gjo2uP2lfgovMfGn2JBQw/eb7f129e4af5dd9fc433228ebf278e15/Simplicam_app_2.png',
  description: `Simage of the SimpliSafe app showing camera views`,
  originalHeight: 1254,
  originalWidth: 1000
}

/**
 * ![Simplicam_app_3.png](https://images.ctfassets.net/v6awd0kabi65/5J6MNRnzX3Vn0jnNLaJ1Yc/c39571d9d382e16a25ae1e5a2b74aec6/Simplicam_app_3.png?w=120&h=120&fit=pad)
 *
 * Simplicam_app_3.png
 *
 * Image of SimpliCam settings in the SimpliSafe app
 */
export const IMG_5J6MNRnzX3Vn0jnNLaJ1Yc = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5J6MNRnzX3Vn0jnNLaJ1Yc/c39571d9d382e16a25ae1e5a2b74aec6/Simplicam_app_3.png',
  description: `Image of SimpliCam settings in the SimpliSafe app`,
  originalHeight: 1254,
  originalWidth: 1000
}

/**
 * ![Simplicam settings.png](https://images.ctfassets.net/v6awd0kabi65/437vHOvMEBQIxSj7xzeyH8/394c317fb5d40dfe75b8123036378929/Simplicam_settings.png?w=120&h=120&fit=pad)
 *
 * Simplicam settings.png
 *
 * Image of Simplicam settings in the SimpliSafe app
 */
export const IMG_437vHOvMEBQIxSj7xzeyH8 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/437vHOvMEBQIxSj7xzeyH8/394c317fb5d40dfe75b8123036378929/Simplicam_settings.png',
  description: `Image of Simplicam settings in the SimpliSafe app`,
  originalHeight: 1792,
  originalWidth: 828
}

/**
 * ![Simplicam_catch_them.jpg](https://images.ctfassets.net/v6awd0kabi65/IDgQLyoulZXAJFgBoehuv/f4afa78cda575d8aa2fae937670a01cc/Simplicam_catch_them.jpg?w=120&h=120&fit=pad)
 *
 * Simplicam_catch_them.jpg
 *
 * Image of a phone using the SimpliSafe app to watch an intruder in the home via the indoor security camera
 */
export const IMG_IDgQLyoulZXAJFgBoehuv = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/IDgQLyoulZXAJFgBoehuv/f4afa78cda575d8aa2fae937670a01cc/Simplicam_catch_them.jpg',
  description: `Image of a phone using the SimpliSafe app to watch an intruder in the home via the indoor security camera`,
  originalHeight: 794,
  originalWidth: 1244
}

/**
 * ![Simplicam_privacy_assured.jpg](https://images.ctfassets.net/v6awd0kabi65/3xk7ngMByb76ElroK1G1zN/b8700635b119b992a581ffe10218c6da/Simplicam_privacy_assured.jpg?w=120&h=120&fit=pad)
 *
 * Simplicam_privacy_assured.jpg
 *
 * Image of a family in their living room with an indoor security camera sitting on top of the fireplace
 */
export const IMG_3xk7ngMByb76ElroK1G1zN = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3xk7ngMByb76ElroK1G1zN/b8700635b119b992a581ffe10218c6da/Simplicam_privacy_assured.jpg',
  description: `Image of a family in their living room with an indoor security camera sitting on top of the fireplace`,
  originalHeight: 794,
  originalWidth: 1244
}

/**
 * ![BB_Carousel_1.jpg](https://images.ctfassets.net/v6awd0kabi65/1jX8Z12d2lz72A5EX699tb/758c5bfd4e9a771ff2402ccb2229a8fd/BB_Carousel_1.jpg?w=120&h=120&fit=pad)
 *
 * BB_Carousel_1.jpg
 *
 * image of the bell box product mounted to the front of a house
 */
export const IMG_1jX8Z12d2lz72A5EX699tb = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1jX8Z12d2lz72A5EX699tb/758c5bfd4e9a771ff2402ccb2229a8fd/BB_Carousel_1.jpg',
  description: `image of the bell box product mounted to the front of a house`,
  originalHeight: 1553,
  originalWidth: 1968
}

/**
 * ![BB_Carousel_2.jpg](https://images.ctfassets.net/v6awd0kabi65/2244ep3DpESw2FgcKktjiC/bde264a93bb0a386e1405ee31fc018b8/BB_Carousel_2.jpg?w=120&h=120&fit=pad)
 *
 * BB_Carousel_2.jpg
 *
 * Image of an intruder outside a home that is being deterred by the bell box
 */
export const IMG_2244ep3DpESw2FgcKktjiC = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2244ep3DpESw2FgcKktjiC/bde264a93bb0a386e1405ee31fc018b8/BB_Carousel_2.jpg',
  description: `Image of an intruder outside a home that is being deterred by the bell box`,
  originalHeight: 1553,
  originalWidth: 1968
}

/**
 * ![BB_Carousel_3.jpg](https://images.ctfassets.net/v6awd0kabi65/1XTz9DwV9M3dI0yKo491Vr/9388dc9418dd541a8ad0785f2f74bafb/BB_Carousel_3.jpg?w=120&h=120&fit=pad)
 *
 * BB_Carousel_3.jpg
 *
 * image of the bell box product being mounted to the front of a home
 */
export const IMG_1XTz9DwV9M3dI0yKo491Vr = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1XTz9DwV9M3dI0yKo491Vr/9388dc9418dd541a8ad0785f2f74bafb/BB_Carousel_3.jpg',
  description: `image of the bell box product being mounted to the front of a home`,
  originalHeight: 1553,
  originalWidth: 1968
}

/**
 * ![BB_Carousel_4.jpg](https://images.ctfassets.net/v6awd0kabi65/2LDuoNuD5GbHPtfK7r6vyE/0932028cce3019644b20706e80bf4d89/BB_Carousel_4.jpg?w=120&h=120&fit=pad)
 *
 * BB_Carousel_4.jpg
 *
 * image of the bell box product showing that it has a light to deter intruders
 */
export const IMG_2LDuoNuD5GbHPtfK7r6vyE = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2LDuoNuD5GbHPtfK7r6vyE/0932028cce3019644b20706e80bf4d89/BB_Carousel_4.jpg',
  description: `image of the bell box product showing that it has a light to deter intruders`,
  originalHeight: 1553,
  originalWidth: 1968
}

/**
 * ![BB_Carousel_5.jpg](https://images.ctfassets.net/v6awd0kabi65/5TvGbj51jVXczikZRR45mt/3fbf6cd924b27507e754f40ec9ef5288/BB_Carousel_5.jpg?w=120&h=120&fit=pad)
 *
 * BB_Carousel_5.jpg
 *
 * image of the bell box product mounted to the front of a brick building, showing that it has up to 105dB volume control
 */
export const IMG_5TvGbj51jVXczikZRR45mt = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5TvGbj51jVXczikZRR45mt/3fbf6cd924b27507e754f40ec9ef5288/BB_Carousel_5.jpg',
  description: `image of the bell box product mounted to the front of a brick building, showing that it has up to 105dB volume control`,
  originalHeight: 1553,
  originalWidth: 1968
}

/**
 * ![BB_stand_alone.png](https://images.ctfassets.net/v6awd0kabi65/1Hezs26XSgGGIdvbtDYp6r/0db46b2781aa4bd2878fa60a20f7562a/BB_stand_alone.png?w=120&h=120&fit=pad)
 *
 * BB_stand_alone.png
 *
 * image of the bell box product
 */
export const IMG_1Hezs26XSgGGIdvbtDYp6r = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1Hezs26XSgGGIdvbtDYp6r/0db46b2781aa4bd2878fa60a20f7562a/BB_stand_alone.png',
  description: `image of the bell box product`,
  originalHeight: 692,
  originalWidth: 908
}

/**
 * ![BB_still_image.jpg](https://images.ctfassets.net/v6awd0kabi65/1pvdMvnviaM5YQjoRxkAvr/2f368f29c225858f92744bb3f3cbd2ff/BB_still_image.jpg?w=120&h=120&fit=pad)
 *
 * BB_still_image.jpg
 *
 * Image of the bell box mounted on the front of a home
 */
export const IMG_1pvdMvnviaM5YQjoRxkAvr = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1pvdMvnviaM5YQjoRxkAvr/2f368f29c225858f92744bb3f3cbd2ff/BB_still_image.jpg',
  description: `Image of the bell box mounted on the front of a home`,
  originalHeight: 1152,
  originalWidth: 2048
}

/**
 * ![BB_diagram_1.jpg](https://images.ctfassets.net/v6awd0kabi65/6YRnLmN2tMcXgqJjuooIcU/80236d37e13e91229d813582fc5efad1/BB_diagram_1.jpg?w=120&h=120&fit=pad)
 *
 * BB_diagram_1.jpg
 *
 * Image of the bell box product
 */
export const IMG_6YRnLmN2tMcXgqJjuooIcU = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6YRnLmN2tMcXgqJjuooIcU/80236d37e13e91229d813582fc5efad1/BB_diagram_1.jpg',
  description: `Image of the bell box product`,
  originalHeight: 1386,
  originalWidth: 1198
}

/**
 * ![BB_diagram_2.jpg](https://images.ctfassets.net/v6awd0kabi65/4AJyDXKrgnCtdRgSuNIMCv/fcd42a1919d721f29c6d627f56f2bb5f/BB_diagram_2.jpg?w=120&h=120&fit=pad)
 *
 * BB_diagram_2.jpg
 *
 * Image of the bell box product
 */
export const IMG_4AJyDXKrgnCtdRgSuNIMCv = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4AJyDXKrgnCtdRgSuNIMCv/fcd42a1919d721f29c6d627f56f2bb5f/BB_diagram_2.jpg',
  description: `Image of the bell box product`,
  originalHeight: 1386,
  originalWidth: 1198
}

/**
 * ![BB_Carousel_1.jpg](https://images.ctfassets.net/v6awd0kabi65/59AGC0WxAuYBAKeYtVnLfK/0b010de20d4a8ac5c54a4319e05c2945/BB_Carousel_1.jpg?w=120&h=120&fit=pad)
 *
 * BB_Carousel_1.jpg
 *
 * Image of bell box mounted on the front of a home
 */
export const IMG_59AGC0WxAuYBAKeYtVnLfK = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/59AGC0WxAuYBAKeYtVnLfK/0b010de20d4a8ac5c54a4319e05c2945/BB_Carousel_1.jpg',
  description: `Image of bell box mounted on the front of a home`,
  originalHeight: 1553,
  originalWidth: 1968
}

/**
 * ![BB_Carousel_3.jpg](https://images.ctfassets.net/v6awd0kabi65/2a7XWjqquv6nNBQ7ujSrZf/9beb6306cc1114ab72b72b9fcf771564/BB_Carousel_3.jpg?w=120&h=120&fit=pad)
 *
 * BB_Carousel_3.jpg
 *
 * Image of a man installing a bell box on the front of a brick home
 */
export const IMG_2a7XWjqquv6nNBQ7ujSrZf = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2a7XWjqquv6nNBQ7ujSrZf/9beb6306cc1114ab72b72b9fcf771564/BB_Carousel_3.jpg',
  description: `Image of a man installing a bell box on the front of a brick home`,
  originalHeight: 1553,
  originalWidth: 1968
}

/**
 * ![SL_stand_alone.png](https://images.ctfassets.net/v6awd0kabi65/1duTN5siwZKWdZsOi7w5ut/9dd45b4f7bbe99922fd28d5c105d5d93/SL_stand_alone.png?w=120&h=120&fit=pad)
 *
 * SL_stand_alone.png
 *
 * Image of smart lock on a plain white background
 */
export const IMG_1duTN5siwZKWdZsOi7w5ut = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1duTN5siwZKWdZsOi7w5ut/9dd45b4f7bbe99922fd28d5c105d5d93/SL_stand_alone.png',
  description: `Image of smart lock on a plain white background`,
  originalHeight: 786,
  originalWidth: 1048
}

/**
 * ![SL_diagram_1.jpg](https://images.ctfassets.net/v6awd0kabi65/58LGjUPIlWHMNrHvp3YvWD/f11ced31f266e689b02decbffec6028a/SL_diagram_1.jpg?w=120&h=120&fit=pad)
 *
 * SL_diagram_1.jpg
 *
 * Image of keypad from the smart lock
 */
export const IMG_58LGjUPIlWHMNrHvp3YvWD = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/58LGjUPIlWHMNrHvp3YvWD/f11ced31f266e689b02decbffec6028a/SL_diagram_1.jpg',
  description: `Image of keypad from the smart lock`,
  originalHeight: 1386,
  originalWidth: 1198
}

/**
 * ![SL_diagram_2.jpg](https://images.ctfassets.net/v6awd0kabi65/7cI84pqvI5WJSj0tbIDmLH/7036c9cac0e2401101d6ad39286251af/SL_diagram_2.jpg?w=120&h=120&fit=pad)
 *
 * SL_diagram_2.jpg
 *
 * Image of smart lock product features
 */
export const IMG_7cI84pqvI5WJSj0tbIDmLH = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7cI84pqvI5WJSj0tbIDmLH/7036c9cac0e2401101d6ad39286251af/SL_diagram_2.jpg',
  description: `Image of smart lock product features`,
  originalHeight: 1386,
  originalWidth: 1198
}

/**
 * ![SL_impedes_intruders.jpg](https://images.ctfassets.net/v6awd0kabi65/6YUmF2cjDHtGd2Q8AifGPW/61b11c72c6d47b8f506d2e3a8cee89b3/SL_impedes_intruders.jpg?w=120&h=120&fit=pad)
 *
 * SL_impedes_intruders.jpg
 *
 * Image of a phone showing notifications from SimpliSafe about someone being at your front door, sent through the video doorbell
 */
export const IMG_6YUmF2cjDHtGd2Q8AifGPW = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6YUmF2cjDHtGd2Q8AifGPW/61b11c72c6d47b8f506d2e3a8cee89b3/SL_impedes_intruders.jpg',
  description: `Image of a phone showing notifications from SimpliSafe about someone being at your front door, sent through the video doorbell`,
  originalHeight: 794,
  originalWidth: 1244
}

/**
 * ![SL_built_to_last.jpg](https://images.ctfassets.net/v6awd0kabi65/2uPrH98wsXz909Fr2xt8Ik/5e20faf4f9078b7f4fe682ffa697c4c0/SL_built_to_last.jpg?w=120&h=120&fit=pad)
 *
 * SL_built_to_last.jpg
 *
 * Image of someone punching a a code into a keypad on their front door to open the smart lock
 */
export const IMG_2uPrH98wsXz909Fr2xt8Ik = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2uPrH98wsXz909Fr2xt8Ik/5e20faf4f9078b7f4fe682ffa697c4c0/SL_built_to_last.jpg',
  description: `Image of someone punching a a code into a keypad on their front door to open the smart lock`,
  originalHeight: 794,
  originalWidth: 1244
}

/**
 * ![outdoor security camera.png](https://images.ctfassets.net/v6awd0kabi65/5yl6ud5loN2VVDHLlligPq/f192fd2b51b7813fda7502d46b6f0719/outdoor_security_camera.png?w=120&h=120&fit=pad)
 *
 * outdoor security camera.png
 *
 * Image of outdoor security camera
 */
export const IMG_5yl6ud5loN2VVDHLlligPq = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5yl6ud5loN2VVDHLlligPq/f192fd2b51b7813fda7502d46b6f0719/outdoor_security_camera.png',
  description: `Image of outdoor security camera`,
  originalHeight: 3000,
  originalWidth: 4000
}

/**
 * ![shield diagram 2.png](https://images.ctfassets.net/v6awd0kabi65/3oTzsj0yT6XJLlVzUYAUqW/55d2ef2dfb470ea7fd528e990383aa5e/shield_diagram_2.png?w=120&h=120&fit=pad)
 *
 * shield diagram 2.png
 *
 * Image of outdoor security camera features
 */
export const IMG_3oTzsj0yT6XJLlVzUYAUqW = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3oTzsj0yT6XJLlVzUYAUqW/55d2ef2dfb470ea7fd528e990383aa5e/shield_diagram_2.png',
  description: `Image of outdoor security camera features`,
  originalHeight: 2542,
  originalWidth: 2198
}

/**
 * ![phones-landscape_update.png](https://images.ctfassets.net/v6awd0kabi65/7lphEdNCZv0iMMqs6H0HPT/57f6e1cf7a7b748b15f7ee4e1afddc7b/phones-landscape_update.png?w=120&h=120&fit=pad)
 *
 * phones-landscape_update.png
 *
 * Image of 2 phones each showing outdoor video footage from outdoor cameras through the SimpliSafe app
 */
export const IMG_7lphEdNCZv0iMMqs6H0HPT = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7lphEdNCZv0iMMqs6H0HPT/57f6e1cf7a7b748b15f7ee4e1afddc7b/phones-landscape_update.png',
  description: `Image of 2 phones each showing outdoor video footage from outdoor cameras through the SimpliSafe app`,
  originalHeight: 950,
  originalWidth: 1230
}

/**
 * ![Simplisafe Home Movers pdf](https://assets.ctfassets.net/v6awd0kabi65/6lsg6jdl4WNovvAXw6Llqy/4087d51e45050a90efe18b3e19e1b4d2/J004544_SimpliSafe-Home_Movers_6PP_Digital_2023_Art.pdf?w=120&h=120&fit=pad)
 *
 * Simplisafe Home Movers pdf
 *
 * Simplisafe Home Movers pdf
 */
export const IMG_6lsg6jdl4WNovvAXw6Llqy = {
  url: 'https://assets.ctfassets.net/v6awd0kabi65/6lsg6jdl4WNovvAXw6Llqy/4087d51e45050a90efe18b3e19e1b4d2/J004544_SimpliSafe-Home_Movers_6PP_Digital_2023_Art.pdf',
  description: `Simplisafe Home Movers pdf`,
  originalHeight: null,
  originalWidth: null
}

/**
 * ![ODMON - Advanced AI](https://images.ctfassets.net/v6awd0kabi65/1znLuIrRbjaXaGlZLLwLft/40601bf9836dc176c58dddb557b25674/IMAGE1.webp?w=120&h=120&fit=pad)
 *
 * ODMON - Advanced AI
 *
 * GIF showing outdoor security where an outdoor camera is catching a burgler outside of the house in action and contacting authorities
 */
export const IMG_1znLuIrRbjaXaGlZLLwLft = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1znLuIrRbjaXaGlZLLwLft/40601bf9836dc176c58dddb557b25674/IMAGE1.webp',
  description: `GIF showing outdoor security where an outdoor camera is catching a burgler outside of the house in action and contacting authorities`,
  originalHeight: 794,
  originalWidth: 1244
}

/**
 * ![SS SID Image](https://images.ctfassets.net/v6awd0kabi65/1fKicmCTwedbcooEE6xXSQ/f5522dff085b3b89b2e37648c1cf61db/base_bottom_serial.jpg?w=120&h=120&fit=pad)
 *
 * SS SID Image
 *
 * Image of the bottom of the base station to show where the SID label is
 */
export const IMG_1fKicmCTwedbcooEE6xXSQ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1fKicmCTwedbcooEE6xXSQ/f5522dff085b3b89b2e37648c1cf61db/base_bottom_serial.jpg',
  description: `Image of the bottom of the base station to show where the SID label is `,
  originalHeight: 700,
  originalWidth: 700
}

/**
 * ![Blog Image](https://images.ctfassets.net/v6awd0kabi65/6JD641VGijWvA9H82TeIoE/4289f8adafecaeaed89790ce7f4d16d9/andy-vult-DeyonzU6E4M-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * Blog Image
 *
 * Icon for the blog featuring a woman on her phone outside
 */
export const IMG_6JD641VGijWvA9H82TeIoE = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6JD641VGijWvA9H82TeIoE/4289f8adafecaeaed89790ce7f4d16d9/andy-vult-DeyonzU6E4M-unsplash.jpg',
  description: `Icon for the blog featuring a woman on her phone outside`,
  originalHeight: 3493,
  originalWidth: 5240
}

/**
 * ![Free Professional Installation](https://images.ctfassets.net/v6awd0kabi65/4jojWOiZubBU1sr7eCASEU/071ad704d76d976141601177c0c597f7/pro_install.png?w=120&h=120&fit=pad)
 *
 * Free Professional Installation
 *
 * Icon for professional installation featuring a worker wearing a hard hat
 */
export const IMG_4jojWOiZubBU1sr7eCASEU = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4jojWOiZubBU1sr7eCASEU/071ad704d76d976141601177c0c597f7/pro_install.png',
  description: `Icon for professional installation featuring a worker wearing a hard hat`,
  originalHeight: 248,
  originalWidth: 241
}

/**
 * ![Home Landing Hero Video Poster](https://images.ctfassets.net/v6awd0kabi65/lGVJrVTT4n0CENO8rtVVt/126569c0914308458529964f014b848e/hero-placeholder.jpg?w=120&h=120&fit=pad)
 *
 * Home Landing Hero Video Poster
 *
 * Image of a SimpliSafe yard sign in the grass in front of a home
 */
export const IMG_lGVJrVTT4n0CENO8rtVVt = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/lGVJrVTT4n0CENO8rtVVt/126569c0914308458529964f014b848e/hero-placeholder.jpg',
  description: `Image of a SimpliSafe yard sign in the grass in front of a home`,
  originalHeight: 720,
  originalWidth: 1280
}

/**
 * ![Manual - Original SimpliSafe](https://assets.ctfassets.net/v6awd0kabi65/1VaEl8NgRk5F66sCtXqNtr/0a1e1e4c46cb8175d52bbf9e906f15c4/Original_SimpliSafe.pdf?w=120&h=120&fit=pad)
 *
 * Manual - Original SimpliSafe
 *
 * SimpliSafe product manual
 */
export const IMG_1VaEl8NgRk5F66sCtXqNtr = {
  url: 'https://assets.ctfassets.net/v6awd0kabi65/1VaEl8NgRk5F66sCtXqNtr/0a1e1e4c46cb8175d52bbf9e906f15c4/Original_SimpliSafe.pdf',
  description: `SimpliSafe product manual`,
  originalHeight: null,
  originalWidth: null
}

/**
 * ![Manual - Video Doorbell Pro](https://assets.ctfassets.net/v6awd0kabi65/3PV1xuDACCxcesVg17qJKX/b1566d32b89d471911e43e30f6e4c7fa/Video_Doorbell_Pro.pdf?w=120&h=120&fit=pad)
 *
 * Manual - Video Doorbell Pro
 *
 * Image of video doorbell pro
 */
export const IMG_3PV1xuDACCxcesVg17qJKX = {
  url: 'https://assets.ctfassets.net/v6awd0kabi65/3PV1xuDACCxcesVg17qJKX/b1566d32b89d471911e43e30f6e4c7fa/Video_Doorbell_Pro.pdf',
  description: `Image of video doorbell pro`,
  originalHeight: null,
  originalWidth: null
}

/**
 * ![Manual - Smoke Detector Image](https://images.ctfassets.net/v6awd0kabi65/5zQ4JlSbFtEcIcOmSLCX6f/55ca281e4b9ebde24655d1d4571cb24c/Manual_-_Smoke_Detector.png?w=120&h=120&fit=pad)
 *
 * Manual - Smoke Detector Image
 *
 * Image of smoke detector
 */
export const IMG_5zQ4JlSbFtEcIcOmSLCX6f = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5zQ4JlSbFtEcIcOmSLCX6f/55ca281e4b9ebde24655d1d4571cb24c/Manual_-_Smoke_Detector.png',
  description: `Image of smoke detector`,
  originalHeight: 284,
  originalWidth: 1282
}

/**
 * ![Manual - Smoke & CO Detector Image](https://images.ctfassets.net/v6awd0kabi65/6CuQqkh2ncCn5uSaS7e9Ml/1e2326fd3df648373cc549bd4f2d178f/Red_manuals.jpg?w=120&h=120&fit=pad)
 *
 * Manual - Smoke & CO Detector Image
 *
 * Image of smoke and carbon monoxide detector
 */
export const IMG_6CuQqkh2ncCn5uSaS7e9Ml = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6CuQqkh2ncCn5uSaS7e9Ml/1e2326fd3df648373cc549bd4f2d178f/Red_manuals.jpg',
  description: `Image of smoke and carbon monoxide detector`,
  originalHeight: 284,
  originalWidth: 1282
}

/**
 * ![Manual - CO Detector Image](https://images.ctfassets.net/v6awd0kabi65/4BFzNFygpnGC28ro4WYOVT/9d323fe17ef196376e823bac9b0b09dd/Manual_CO.png?w=120&h=120&fit=pad)
 *
 * Manual - CO Detector Image
 *
 * Image of carbon monoxide detector
 */
export const IMG_4BFzNFygpnGC28ro4WYOVT = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4BFzNFygpnGC28ro4WYOVT/9d323fe17ef196376e823bac9b0b09dd/Manual_CO.png',
  description: `Image of carbon monoxide detector`,
  originalHeight: 284,
  originalWidth: 1282
}

/**
 * ![Manual - Original Wireless Siren Image](https://images.ctfassets.net/v6awd0kabi65/4i2tvIBwcEfDzc2r8y7yTz/5aa6ee9330f13431afb9f868535b7d5c/Manual_Siren.png?w=120&h=120&fit=pad)
 *
 * Manual - Original Wireless Siren Image
 *
 * Image of original wireless siren product
 */
export const IMG_4i2tvIBwcEfDzc2r8y7yTz = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4i2tvIBwcEfDzc2r8y7yTz/5aa6ee9330f13431afb9f868535b7d5c/Manual_Siren.png',
  description: `Image of original wireless siren product`,
  originalHeight: 284,
  originalWidth: 1282
}

/**
 * ![Manual - Smoke & CO (PDF)](https://assets.ctfassets.net/v6awd0kabi65/2uS9y4UXLgkczdsdWSyu1F/92c1d8c06afa8a1e28872b06830d17b1/Smoke_CO_Detector_Manual.pdf?w=120&h=120&fit=pad)
 *
 * Manual - Smoke & CO (PDF)
 *
 * SimpliSafe product manual for smoke and carbon monoxide detector
 */
export const IMG_2uS9y4UXLgkczdsdWSyu1F = {
  url: 'https://assets.ctfassets.net/v6awd0kabi65/2uS9y4UXLgkczdsdWSyu1F/92c1d8c06afa8a1e28872b06830d17b1/Smoke_CO_Detector_Manual.pdf',
  description: `SimpliSafe product manual for smoke and carbon monoxide detector`,
  originalHeight: null,
  originalWidth: null
}

/**
 * ![Manual - CO Detector (PDF)](https://assets.ctfassets.net/v6awd0kabi65/6VnprF1bEJjPEJ1sfe0n1T/1591a82b8cc75eb03ec7d1969eb95b3d/CO_Manual_2021.pdf?w=120&h=120&fit=pad)
 *
 * Manual - CO Detector (PDF)
 *
 * SimpliSafe product manual for carbon monoxide detector
 */
export const IMG_6VnprF1bEJjPEJ1sfe0n1T = {
  url: 'https://assets.ctfassets.net/v6awd0kabi65/6VnprF1bEJjPEJ1sfe0n1T/1591a82b8cc75eb03ec7d1969eb95b3d/CO_Manual_2021.pdf',
  description: `SimpliSafe product manual for carbon monoxide detector`,
  originalHeight: null,
  originalWidth: null
}

/**
 * ![Manual - Smoke Detector (PDF)](https://assets.ctfassets.net/v6awd0kabi65/5clGkoEiPuzmim9Epu4Bnw/42d22a035631904590b9995652db9a6a/SSSD3_Manual_US_version.pdf?w=120&h=120&fit=pad)
 *
 * Manual - Smoke Detector (PDF)
 *
 * SimpliSafe product manual for smoke detector
 */
export const IMG_5clGkoEiPuzmim9Epu4Bnw = {
  url: 'https://assets.ctfassets.net/v6awd0kabi65/5clGkoEiPuzmim9Epu4Bnw/42d22a035631904590b9995652db9a6a/SSSD3_Manual_US_version.pdf',
  description: `SimpliSafe product manual for smoke detector`,
  originalHeight: null,
  originalWidth: null
}

/**
 * ![What Now? 5 Steps to Take After a Home-Break In](https://images.ctfassets.net/v6awd0kabi65/67L4oWjthXJ63wwnWBDugo/6757545f65e58de4517a5fc1785c4e15/Low_Res-House_Intruder_496_FIN_WEBX.jpg?w=120&h=120&fit=pad)
 *
 * What Now? 5 Steps to Take After a Home-Break In
 *
 * Image of a burglar in a home being caught by the indoor security system
 */
export const IMG_67L4oWjthXJ63wwnWBDugo = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/67L4oWjthXJ63wwnWBDugo/6757545f65e58de4517a5fc1785c4e15/Low_Res-House_Intruder_496_FIN_WEBX.jpg',
  description: `Image of a burglar in a home being caught by the indoor security system`,
  originalHeight: 1667,
  originalWidth: 2500
}

/**
 * ![Outdoor Camera - short width](https://images.ctfassets.net/v6awd0kabi65/4m2OkKAh8SJ8bfXBXlTt2n/54ded545e8d67e6824bd2615f676aa2f/image__8_.png?w=120&h=120&fit=pad)
 *
 * Outdoor Camera - short width
 *
 * Image of an outdoor security camera mounted
 */
export const IMG_4m2OkKAh8SJ8bfXBXlTt2n = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4m2OkKAh8SJ8bfXBXlTt2n/54ded545e8d67e6824bd2615f676aa2f/image__8_.png',
  description: `Image of an outdoor security camera mounted`,
  originalHeight: 1096,
  originalWidth: 936
}

/**
 * ![Business security page - Banner image](https://images.ctfassets.net/v6awd0kabi65/1M6n2p2ZdLChe0DdXCBWWs/b6bea948d4dbf66c2d3c0c3ec9205ee8/SMB_Business_Page_Image.webp?w=120&h=120&fit=pad)
 *
 * Business security page - Banner image
 *
 * Image of a keypad mounted on the wall of a home
 */
export const IMG_1M6n2p2ZdLChe0DdXCBWWs = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1M6n2p2ZdLChe0DdXCBWWs/b6bea948d4dbf66c2d3c0c3ec9205ee8/SMB_Business_Page_Image.webp',
  description: `Image of a keypad mounted on the wall of a home`,
  originalHeight: 685,
  originalWidth: 1440
}

/**
 * ![Manual - Original Wireless Siren (PDF)](https://assets.ctfassets.net/v6awd0kabi65/2Jkk7ak0ILPYyz2nZDZp04/683079a483a039bf92c0e0a0b88c95c1/Original_Wireless_Siren.pdf?w=120&h=120&fit=pad)
 *
 * Manual - Original Wireless Siren (PDF)
 *
 * SimpliSafe product manual for wireless siren
 */
export const IMG_2Jkk7ak0ILPYyz2nZDZp04 = {
  url: 'https://assets.ctfassets.net/v6awd0kabi65/2Jkk7ak0ILPYyz2nZDZp04/683079a483a039bf92c0e0a0b88c95c1/Original_Wireless_Siren.pdf',
  description: `SimpliSafe product manual for wireless siren`,
  originalHeight: null,
  originalWidth: null
}

/**
 * ![Hero - Shop packages US](https://images.ctfassets.net/v6awd0kabi65/BpfIp6WTVyYLGgAJ5JTZs/2f1b1251cb421a149f6a020db899c375/desktop-Hero_Packages_comp_2x_1_3x.jpg?w=120&h=120&fit=pad)
 *
 * Hero - Shop packages US
 *
 * Image of a home security system including a base station, keypad, motion sensor and 3 entry sensors
 */
export const IMG_BpfIp6WTVyYLGgAJ5JTZs = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/BpfIp6WTVyYLGgAJ5JTZs/2f1b1251cb421a149f6a020db899c375/desktop-Hero_Packages_comp_2x_1_3x.jpg',
  description: `Image of a home security system including a base station, keypad, motion sensor and 3 entry sensors`,
  originalHeight: 1800,
  originalWidth: 2160
}

/**
 * ![Hero - Build my system scout](https://images.ctfassets.net/v6awd0kabi65/8bR6gRr9KQRSCPLBDTNNm/a1b11c17b5f37f0a3d5dc35a0490468a/Hero_Larger2_1_3x.jpg?w=120&h=120&fit=pad)
 *
 * Hero - Build my system scout
 *
 * Image of home security sensors floating on a bright yellow background
 */
export const IMG_8bR6gRr9KQRSCPLBDTNNm = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/8bR6gRr9KQRSCPLBDTNNm/a1b11c17b5f37f0a3d5dc35a0490468a/Hero_Larger2_1_3x.jpg',
  description: `Image of home security sensors floating on a bright yellow background`,
  originalHeight: 1800,
  originalWidth: 2160
}

/**
 * ![Manual - Gen 3 SimpliSafe](https://assets.ctfassets.net/v6awd0kabi65/OlUOdVum5H41utNjGOvxh/b4d001fd1f223e93bf505bcfa448c7d7/manual_ss3_uk_072121__1_.pdf?w=120&h=120&fit=pad)
 *
 * Manual - Gen 3 SimpliSafe
 *
 * SimpliSafe product manual
 */
export const IMG_OlUOdVum5H41utNjGOvxh = {
  url: 'https://assets.ctfassets.net/v6awd0kabi65/OlUOdVum5H41utNjGOvxh/b4d001fd1f223e93bf505bcfa448c7d7/manual_ss3_uk_072121__1_.pdf',
  description: `SimpliSafe product manual`,
  originalHeight: null,
  originalWidth: null
}

/**
 * ![privacy-hero-desktop-08-24](https://images.ctfassets.net/v6awd0kabi65/5REFm0xWrOOLNww54zjm6U/ab3821669d2c3631666dd5eb61f6a3df/simplisafe_privacy_illustration_01.jpg?w=120&h=120&fit=pad)
 *
 * privacy-hero-desktop-08-24
 *
 * Image of a family sitting on a couch together in their home with an indoor security camera in view
 */
export const IMG_5REFm0xWrOOLNww54zjm6U = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5REFm0xWrOOLNww54zjm6U/ab3821669d2c3631666dd5eb61f6a3df/simplisafe_privacy_illustration_01.jpg',
  description: `Image of a family sitting on a couch together in their home with an indoor security camera in view`,
  originalHeight: 633,
  originalWidth: 1322
}

/**
 * ![Odmon Hero - Mobile](https://images.ctfassets.net/v6awd0kabi65/6xN4I7fHP1KGs8QgADxMaT/dfd28e7f8ee6683db6e04df35338699f/M-hero-x3.jpg?w=120&h=120&fit=pad)
 *
 * Odmon Hero - Mobile
 *
 * Image of an outdoor security camera and entry sensor
 */
export const IMG_6xN4I7fHP1KGs8QgADxMaT = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6xN4I7fHP1KGs8QgADxMaT/dfd28e7f8ee6683db6e04df35338699f/M-hero-x3.jpg',
  description: `Image of an outdoor security camera and entry sensor`,
  originalHeight: 996,
  originalWidth: 1200
}

/**
 * ![Odmon Hero - Desktop](https://images.ctfassets.net/v6awd0kabi65/7LKEP9ADV7Q7PWEhmVxOoV/481157b5f944e3e73f28eda933e4c107/D-hero-3x.png?w=120&h=120&fit=pad)
 *
 * Odmon Hero - Desktop
 *
 * Image of home security sensors including an outdoor camera, indoor camera, motion sensor and video doorbell
 */
export const IMG_7LKEP9ADV7Q7PWEhmVxOoV = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7LKEP9ADV7Q7PWEhmVxOoV/481157b5f944e3e73f28eda933e4c107/D-hero-3x.png',
  description: `Image of home security sensors including an outdoor camera, indoor camera, motion sensor and video doorbell`,
  originalHeight: 1950,
  originalWidth: 3531
}

/**
 * ![Odmon Hero - Tablet](https://images.ctfassets.net/v6awd0kabi65/2GSg0sEQgjwHcZWLkWXPim/f5624b056c254b4697dfaef3cff078e1/T-hero-x3.png?w=120&h=120&fit=pad)
 *
 * Odmon Hero - Tablet
 *
 * Image of home security sensors including an outdoor camera and an indoor camera
 */
export const IMG_2GSg0sEQgjwHcZWLkWXPim = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2GSg0sEQgjwHcZWLkWXPim/f5624b056c254b4697dfaef3cff078e1/T-hero-x3.png',
  description: `Image of home security sensors including an outdoor camera and an indoor camera`,
  originalHeight: 1626,
  originalWidth: 2625
}

/**
 * ![ODMON Quiz Image](https://images.ctfassets.net/v6awd0kabi65/69DPXF1HEn2ut0vVVWFSUK/920518fddb75c93759b845c13d00a288/System_quiz_odmon.png?w=120&h=120&fit=pad)
 *
 * ODMON Quiz Image
 *
 * Image of home security sensors including a keypad, smoke detector, outdoor camera, entry sensor and glassbreak sensor
 */
export const IMG_69DPXF1HEn2ut0vVVWFSUK = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/69DPXF1HEn2ut0vVVWFSUK/920518fddb75c93759b845c13d00a288/System_quiz_odmon.png',
  description: `Image of home security sensors including a keypad, smoke detector, outdoor camera, entry sensor and glassbreak sensor`,
  originalHeight: 950,
  originalWidth: 1326
}

/**
 * ![privacy hero banner desktop](https://images.ctfassets.net/v6awd0kabi65/20CYYyYNks27qgFOfemyiN/b05fb11cd7f563ecf398eaf8afc013a0/simplisafe_privacy_illustration_01_2__6_.png?w=120&h=120&fit=pad)
 *
 * privacy hero banner desktop
 *
 * Image of a family sitting on the couch together in their home with an indoor security camera in view
 */
export const IMG_20CYYyYNks27qgFOfemyiN = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/20CYYyYNks27qgFOfemyiN/b05fb11cd7f563ecf398eaf8afc013a0/simplisafe_privacy_illustration_01_2__6_.png',
  description: `Image of a family sitting on the couch together in their home with an indoor security camera in view`,
  originalHeight: 1899,
  originalWidth: 3951
}

/**
 * ![privacy hero banner tablet](https://images.ctfassets.net/v6awd0kabi65/2JZXoL3Rwucaxe5nZhTE0H/19f6cbb6976301855162b15ec6e6eeb1/simplisafe_privacy_illustration_01_2__7_.png?w=120&h=120&fit=pad)
 *
 * privacy hero banner tablet
 *
 * Image of a family sitting on a couch together in their home with an indoor security camera in view
 */
export const IMG_2JZXoL3Rwucaxe5nZhTE0H = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2JZXoL3Rwucaxe5nZhTE0H/19f6cbb6976301855162b15ec6e6eeb1/simplisafe_privacy_illustration_01_2__7_.png',
  description: `Image of a family sitting on a couch together in their home with an indoor security camera in view`,
  originalHeight: 1086,
  originalWidth: 2268
}

/**
 * ![privacy hero banner mobile](https://images.ctfassets.net/v6awd0kabi65/7AE5sVzeiqArEuJH9JZgQl/e7220aba2f3ee9ede873a8874c02433c/simplisafe_privacy_illustration_01_2__8_.png?w=120&h=120&fit=pad)
 *
 * privacy hero banner mobile
 *
 * Image of a family sitting on the couch together in their home with an indoor security camera in view
 */
export const IMG_7AE5sVzeiqArEuJH9JZgQl = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7AE5sVzeiqArEuJH9JZgQl/e7220aba2f3ee9ede873a8874c02433c/simplisafe_privacy_illustration_01_2__8_.png',
  description: `Image of a family sitting on the couch together in their home with an indoor security camera in view`,
  originalHeight: 960,
  originalWidth: 1125
}

/**
 * ![OM Video Poster](https://images.ctfassets.net/v6awd0kabi65/6sCX1Z933cL4cm84o9T5Z2/d5dadd546ef75b7741ebceb51ccb0ba1/Video_still.jpg?w=120&h=120&fit=pad)
 *
 * OM Video Poster
 *
 * Image of the outside of a home being protected by outdoor security cameras
 */
export const IMG_6sCX1Z933cL4cm84o9T5Z2 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6sCX1Z933cL4cm84o9T5Z2/d5dadd546ef75b7741ebceb51ccb0ba1/Video_still.jpg',
  description: `Image of the outside of a home being protected by outdoor security cameras`,
  originalHeight: 1152,
  originalWidth: 2054
}

/**
 * ![App Control - Cameras](https://images.ctfassets.net/v6awd0kabi65/ZYB8WxMtOe454lse5FG2D/245a3035bef443d0b9ac49107e79e61b/cameras3.png?w=120&h=120&fit=pad)
 *
 * App Control - Cameras
 *
 * Image of a phone with the SimpliSafe app pulled up, looking at the view from security cameras
 */
export const IMG_ZYB8WxMtOe454lse5FG2D = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/ZYB8WxMtOe454lse5FG2D/245a3035bef443d0b9ac49107e79e61b/cameras3.png',
  description: `Image of a phone with the SimpliSafe app pulled up, looking at the view from security cameras`,
  originalHeight: 1881,
  originalWidth: 1500
}

/**
 * ![Home security and home safety for kids](https://images.ctfassets.net/v6awd0kabi65/3Q0kT1TDe5h3FXk4oi2u7p/4ad7fe4b3e22542897f6437cf09c674a/Home_security_and_home_safety_for_kids.png?w=120&h=120&fit=pad)
 *
 * Home security and home safety for kids
 *
 * Image of 2 children coloring at a table in their home with an indoor security camera in view
 */
export const IMG_3Q0kT1TDe5h3FXk4oi2u7p = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3Q0kT1TDe5h3FXk4oi2u7p/4ad7fe4b3e22542897f6437cf09c674a/Home_security_and_home_safety_for_kids.png',
  description: `Image of 2 children coloring at a table in their home with an indoor security camera in view`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![security expert w/ headset](https://images.ctfassets.net/v6awd0kabi65/4l8DenaxSNBl1LH3mmDLMv/bf48f65c0fa96a5373b61f7b7c4cfa70/image__16_.png?w=120&h=120&fit=pad)
 *
 * security expert w/ headset
 *
 * Image of a home security specialist wearing a headset and speaking to a customer
 */
export const IMG_4l8DenaxSNBl1LH3mmDLMv = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4l8DenaxSNBl1LH3mmDLMv/bf48f65c0fa96a5373b61f7b7c4cfa70/image__16_.png',
  description: `Image of a home security specialist wearing a headset and speaking to a customer`,
  originalHeight: 1184,
  originalWidth: 1239
}

/**
 * ![Icon Instagram](https://images.ctfassets.net/v6awd0kabi65/3O9YUMhll4Ef7XZGbwIJDU/f645ff24175c1ebcd54a6fed7c0c171b/instagram.png?w=120&h=120&fit=pad)
 *
 * Icon Instagram
 *
 * Image of Instagram icon
 */
export const IMG_3O9YUMhll4Ef7XZGbwIJDU = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3O9YUMhll4Ef7XZGbwIJDU/f645ff24175c1ebcd54a6fed7c0c171b/instagram.png',
  description: `Image of Instagram icon`,
  originalHeight: 240,
  originalWidth: 240
}

/**
 * ![Icon TikTok](https://images.ctfassets.net/v6awd0kabi65/3IIO0M9JrsJS56gXuVF6fq/ce3f7d7aca170a73a44cc77cd70bdcbf/tiktok.png?w=120&h=120&fit=pad)
 *
 * Icon TikTok
 *
 * Image of tik tok icon
 */
export const IMG_3IIO0M9JrsJS56gXuVF6fq = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3IIO0M9JrsJS56gXuVF6fq/ce3f7d7aca170a73a44cc77cd70bdcbf/tiktok.png',
  description: `Image of tik tok icon`,
  originalHeight: 240,
  originalWidth: 240
}

/**
 * ![Carbon Monoxide Detector 2024-10-25](https://images.ctfassets.net/v6awd0kabi65/0gJCWNkrn66Ilh5n6PIvH/cc5d314d0eef37fdd7c8af6afa1162ce/Red_Instruction_6_Mounted_to_Ceiling_1818_F_16bit_1.jpg?w=120&h=120&fit=pad)
 *
 * Carbon Monoxide Detector 2024-10-25
 *
 * Image of a carbon monoxide detector mounted to the ceiling of a house
 */
export const IMG_0gJCWNkrn66Ilh5n6PIvH = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/0gJCWNkrn66Ilh5n6PIvH/cc5d314d0eef37fdd7c8af6afa1162ce/Red_Instruction_6_Mounted_to_Ceiling_1818_F_16bit_1.jpg',
  description: `Image of a carbon monoxide detector mounted to the ceiling of a house`,
  originalHeight: 1096,
  originalWidth: 1641
}

/**
 * ![Smart Lock V2](https://images.ctfassets.net/v6awd0kabi65/79S42n9MO5K9Ry2joQZ3LL/e707b3f129e994f69a21a6cd011bb449/Braun_Black_1.jpg?w=120&h=120&fit=pad)
 *
 * Smart Lock V2
 *
 * Image of a black smart lock mounted on a door
 */
export const IMG_79S42n9MO5K9Ry2joQZ3LL = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/79S42n9MO5K9Ry2joQZ3LL/e707b3f129e994f69a21a6cd011bb449/Braun_Black_1.jpg',
  description: `Image of a black smart lock mounted on a door`,
  originalHeight: 1426,
  originalWidth: 1905
}

/**
 * ![shield diagram 1.png](https://images.ctfassets.net/v6awd0kabi65/2zhmjcamFOJxNMv1byCGOo/5c3cc8a9c0a45a338e863ac2220f069c/shield_diagram.jpg?w=120&h=120&fit=pad)
 *
 * shield diagram 1.png
 *
 * Image of an outdoor security camera on a navy blue background
 */
export const IMG_2zhmjcamFOJxNMv1byCGOo = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2zhmjcamFOJxNMv1byCGOo/5c3cc8a9c0a45a338e863ac2220f069c/shield_diagram.jpg',
  description: `Image of an outdoor security camera on a navy blue background`,
  originalHeight: 2542,
  originalWidth: 2198
}

/**
 * ![Olympus - w background](https://images.ctfassets.net/v6awd0kabi65/1Cm3jebuXKFPPMEicZlUk6/cfc5439061458716d33d60fbd2a5361e/Olympus_-_w_background.png?w=120&h=120&fit=pad)
 *
 * Olympus - w background
 *
 * Image of an outdoor security camera mounted on a house
 */
export const IMG_1Cm3jebuXKFPPMEicZlUk6 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1Cm3jebuXKFPPMEicZlUk6/cfc5439061458716d33d60fbd2a5361e/Olympus_-_w_background.png',
  description: `Image of an outdoor security camera mounted on a house`,
  originalHeight: 1070,
  originalWidth: 1528
}

/**
 * ![App Control - Cameras - ODMON](https://images.ctfassets.net/v6awd0kabi65/4WmsMErxVXBFHEjlFnRcD1/d1395151eec00f6c8f2fedb934fe651d/AppScreenArt-Cameras.png?w=120&h=120&fit=pad)
 *
 * App Control - Cameras - ODMON
 *
 * Image of a phone with views from the SimpliSafe app
 */
export const IMG_4WmsMErxVXBFHEjlFnRcD1 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4WmsMErxVXBFHEjlFnRcD1/d1395151eec00f6c8f2fedb934fe651d/AppScreenArt-Cameras.png',
  description: `Image of a phone with views from the SimpliSafe app`,
  originalHeight: 1254,
  originalWidth: 1000
}

/**
 * ![App Control - Doorbell - ODMON ](https://images.ctfassets.net/v6awd0kabi65/77eZKHHyg4KdFR2T2WhH90/296918cb5380b3aafc5981febb4d266c/AppScreenArt-Doorbell.png?w=120&h=120&fit=pad)
 *
 * App Control - Doorbell - ODMON
 *
 * Image of a phone viewing footage from the indoor security system via the SimpliSafe app
 */
export const IMG_77eZKHHyg4KdFR2T2WhH90 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/77eZKHHyg4KdFR2T2WhH90/296918cb5380b3aafc5981febb4d266c/AppScreenArt-Doorbell.png',
  description: `Image of a phone viewing footage from the indoor security system via the SimpliSafe app`,
  originalHeight: 1254,
  originalWidth: 1000
}

/**
 * ![App Control - Alerts](https://images.ctfassets.net/v6awd0kabi65/50wlqz44dQwAzOoxzmPO90/32cfef2bf2f0220150c90afce74686ab/AppScreenArt-Alerts.png?w=120&h=120&fit=pad)
 *
 * App Control - Alerts
 *
 * Image of a phone showing notifications from SimpliSafe
 */
export const IMG_50wlqz44dQwAzOoxzmPO90 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/50wlqz44dQwAzOoxzmPO90/32cfef2bf2f0220150c90afce74686ab/AppScreenArt-Alerts.png',
  description: `Image of a phone showing notifications from SimpliSafe`,
  originalHeight: 1254,
  originalWidth: 1000
}

/**
 * ![Outdoor Camera Bundle - 1 Camera](https://images.ctfassets.net/v6awd0kabi65/4BKVDDh2WMakj79qqzYq6O/37cde170ecffc26607c1e21850a7bd2d/1_Cam.png?w=120&h=120&fit=pad)
 *
 * Outdoor Camera Bundle - 1 Camera
 *
 * Image of an outdoor security camera on a plain white background
 */
export const IMG_4BKVDDh2WMakj79qqzYq6O = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4BKVDDh2WMakj79qqzYq6O/37cde170ecffc26607c1e21850a7bd2d/1_Cam.png',
  description: `Image of an outdoor security camera on a plain white background`,
  originalHeight: 144,
  originalWidth: 143
}

/**
 * ![Outdoor Camera Bundle - 2 Cameras](https://images.ctfassets.net/v6awd0kabi65/3Egjb6lgCgJXTheIPy5aif/ec3b7cacad2d1cf0d34f78886d3cd8b1/2_Cams.png?w=120&h=120&fit=pad)
 *
 * Outdoor Camera Bundle - 2 Cameras
 *
 * Image of 2 outdoor security cameras
 */
export const IMG_3Egjb6lgCgJXTheIPy5aif = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3Egjb6lgCgJXTheIPy5aif/ec3b7cacad2d1cf0d34f78886d3cd8b1/2_Cams.png',
  description: `Image of 2 outdoor security cameras`,
  originalHeight: 144,
  originalWidth: 143
}

/**
 * ![Outdoor Camera Bundle - 3 Cameras](https://images.ctfassets.net/v6awd0kabi65/5HlA4s7m0tD9hlrihYP5cW/a09288a7f070aac04fc9c2aabca8f582/3_Cams.png?w=120&h=120&fit=pad)
 *
 * Outdoor Camera Bundle - 3 Cameras
 *
 * Image of 3 outdoor security cameras
 */
export const IMG_5HlA4s7m0tD9hlrihYP5cW = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5HlA4s7m0tD9hlrihYP5cW/a09288a7f070aac04fc9c2aabca8f582/3_Cams.png',
  description: `Image of 3 outdoor security cameras`,
  originalHeight: 144,
  originalWidth: 143
}

/**
 * ![Outdoor Camera Bundle - 4 Cameras](https://images.ctfassets.net/v6awd0kabi65/5B1eePLcw2pGFa0yizvmKF/4c44673faf71c817319c2506ba419e7f/4_Cams.png?w=120&h=120&fit=pad)
 *
 * Outdoor Camera Bundle - 4 Cameras
 *
 * Image of 4 outdoor security cameras
 */
export const IMG_5B1eePLcw2pGFa0yizvmKF = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5B1eePLcw2pGFa0yizvmKF/4c44673faf71c817319c2506ba419e7f/4_Cams.png',
  description: `Image of 4 outdoor security cameras`,
  originalHeight: 144,
  originalWidth: 143
}

/**
 * ![Smart Lock Series 2 Black (Transparent) ](https://images.ctfassets.net/v6awd0kabi65/2U1MwuUscuLfqnuycDpIXh/610bf3cc57a898c5c3f5dd653b37d5d8/Braun_black.png?w=120&h=120&fit=pad)
 *
 * Smart Lock Series 2 Black (Transparent)
 *
 * Image of black smart lock on a plain white background
 */
export const IMG_2U1MwuUscuLfqnuycDpIXh = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2U1MwuUscuLfqnuycDpIXh/610bf3cc57a898c5c3f5dd653b37d5d8/Braun_black.png',
  description: `Image of black smart lock on a plain white background`,
  originalHeight: 640,
  originalWidth: 480
}

/**
 * ![Monitoring Desktop](https://images.ctfassets.net/v6awd0kabi65/2eL0e1lh9b2LSu3lhJs4Zf/6a563056f8c38759a0f022ecd3c91e5c/PrivComponent_art-D.jpg?w=120&h=120&fit=pad)
 *
 * Monitoring Desktop
 *
 * Image of home security system products including an outdoor camera, video doorbell, indoor camera and motion sensor
 */
export const IMG_2eL0e1lh9b2LSu3lhJs4Zf = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2eL0e1lh9b2LSu3lhJs4Zf/6a563056f8c38759a0f022ecd3c91e5c/PrivComponent_art-D.jpg',
  description: `Image of home security system products including an outdoor camera, video doorbell, indoor camera and motion sensor`,
  originalHeight: 2694,
  originalWidth: 3876
}

/**
 * ![404 - Hero Banner](https://images.ctfassets.net/v6awd0kabi65/2yy8P7iz1lk1Bovnje8weG/b1b5317fa5c146c0e323c49a4726620a/404Hero_D.jpg?w=120&h=120&fit=pad)
 *
 * 404 - Hero Banner
 *
 * Image of outdoor security camera mounted on the side of a house
 */
export const IMG_2yy8P7iz1lk1Bovnje8weG = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2yy8P7iz1lk1Bovnje8weG/b1b5317fa5c146c0e323c49a4726620a/404Hero_D.jpg',
  description: `Image of outdoor security camera mounted on the side of a house`,
  originalHeight: 1562,
  originalWidth: 3840
}

/**
 * ![404 - Shop Packages (mobile)](https://images.ctfassets.net/v6awd0kabi65/3VXzIS8KLkWftOPpwkWJSN/beb202b69d687dcb00b661491778750c/404_Packages.jpg?w=120&h=120&fit=pad)
 *
 * 404 - Shop Packages (mobile)
 *
 * Image of a home security system including a base station, keypad, outdoor camera, entry sensors and a motion sensor
 */
export const IMG_3VXzIS8KLkWftOPpwkWJSN = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3VXzIS8KLkWftOPpwkWJSN/beb202b69d687dcb00b661491778750c/404_Packages.jpg',
  description: `Image of a home security system including a base station, keypad, outdoor camera, entry sensors and a motion sensor`,
  originalHeight: 1176,
  originalWidth: 1624
}

/**
 * ![404 - Build System](https://images.ctfassets.net/v6awd0kabi65/5rLVCdFLXCvSZr3zZUVCDR/206e07c2539e6587001640f04d7f55b6/404_BMSAsset.jpg?w=120&h=120&fit=pad)
 *
 * 404 - Build System
 *
 * Image of home security system sensors floating on a bright yellow background
 */
export const IMG_5rLVCdFLXCvSZr3zZUVCDR = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5rLVCdFLXCvSZr3zZUVCDR/206e07c2539e6587001640f04d7f55b6/404_BMSAsset.jpg',
  description: `Image of home security system sensors floating on a bright yellow background`,
  originalHeight: 1176,
  originalWidth: 1624
}

/**
 * ![404 - Hero Banner (mobile)](https://images.ctfassets.net/v6awd0kabi65/65jJTduJkHGAp9o0yoIeqM/b38fdca0f0caed9d4b726b178cf8f955/404Hero_M.jpg?w=120&h=120&fit=pad)
 *
 * 404 - Hero Banner (mobile)
 *
 * Image of outdoor security camera mounted on the side of a house
 */
export const IMG_65jJTduJkHGAp9o0yoIeqM = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/65jJTduJkHGAp9o0yoIeqM/b38fdca0f0caed9d4b726b178cf8f955/404Hero_M.jpg',
  description: `Image of outdoor security camera mounted on the side of a house`,
  originalHeight: 1332,
  originalWidth: 1500
}

/**
 * ![404 - Our Recommendation](https://images.ctfassets.net/v6awd0kabi65/6sYXLIk3bQKRcuMvyA5edj/36e674abc247d5320c3c58c891040419/404_Recommendation.jpg?w=120&h=120&fit=pad)
 *
 * 404 - Our Recommendation
 *
 * Image of 2 security specialists standing back to back with their arms crossed, wearing SimpliSafe uniforms
 */
export const IMG_6sYXLIk3bQKRcuMvyA5edj = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6sYXLIk3bQKRcuMvyA5edj/36e674abc247d5320c3c58c891040419/404_Recommendation.jpg',
  description: `Image of 2 security specialists standing back to back with their arms crossed, wearing SimpliSafe uniforms`,
  originalHeight: 1176,
  originalWidth: 1624
}

/**
 * ![404 - Build System (mobile)](https://images.ctfassets.net/v6awd0kabi65/6ZQ6Ec4apIoh56eChMZrrC/3a5356bd360d935184d315ca8e7c5427/404_BMSAsset.jpg?w=120&h=120&fit=pad)
 *
 * 404 - Build System (mobile)
 *
 * Image of home security system products floating on a bright yellow background
 */
export const IMG_6ZQ6Ec4apIoh56eChMZrrC = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6ZQ6Ec4apIoh56eChMZrrC/3a5356bd360d935184d315ca8e7c5427/404_BMSAsset.jpg',
  description: `Image of home security system products floating on a bright yellow background`,
  originalHeight: 1176,
  originalWidth: 1624
}

/**
 * ![Contact Us - Image](https://images.ctfassets.net/v6awd0kabi65/37GoFc5s6ZzkA9XqBCPPhN/fa84b45d72ece4f0d1c7a9a65b7194e1/New_2__2_.png?w=120&h=120&fit=pad)
 *
 * Contact Us - Image
 *
 * Image of home security system products including base station, entry sensors, temperature sensor, keypad and motion sensor
 */
export const IMG_37GoFc5s6ZzkA9XqBCPPhN = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/37GoFc5s6ZzkA9XqBCPPhN/fa84b45d72ece4f0d1c7a9a65b7194e1/New_2__2_.png',
  description: `Image of home security system products including base station, entry sensors, temperature sensor, keypad and motion sensor`,
  originalHeight: 2900,
  originalWidth: 4800
}

/**
 * ![ODMON Dog Video Banner Experiment ](https://images.ctfassets.net/v6awd0kabi65/27sFOaHc2LshblLKbU1Va9/e9d6addc792893daf80fba473941ef51/dogs_video_banner.png?w=120&h=120&fit=pad)
 *
 * ODMON Dog Video Banner Experiment
 *
 * Image of 2 dogs, outside, looking at each other with a fence in between them
 */
export const IMG_27sFOaHc2LshblLKbU1Va9 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/27sFOaHc2LshblLKbU1Va9/e9d6addc792893daf80fba473941ef51/dogs_video_banner.png',
  description: `Image of 2 dogs, outside, looking at each other with a fence in between them`,
  originalHeight: 379,
  originalWidth: 675
}

/**
 * ![Installation Hero - Mobile](https://images.ctfassets.net/v6awd0kabi65/5JRszCR0c7KUrZh6oBgm0w/184a871b36edcb15339d29fb69b29ae0/InstallHero-T.jpg?w=120&h=120&fit=pad)
 *
 * Installation Hero - Mobile
 *
 * Image of video doorbell and motion sensor products
 */
export const IMG_5JRszCR0c7KUrZh6oBgm0w = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5JRszCR0c7KUrZh6oBgm0w/184a871b36edcb15339d29fb69b29ae0/InstallHero-T.jpg',
  description: `Image of video doorbell and motion sensor products`,
  originalHeight: 1400,
  originalWidth: 1500
}

/**
 * ![Installation Hero - Tablet](https://images.ctfassets.net/v6awd0kabi65/66p7piiLYJunK02kCWPizi/949368c9964b5b45ecaa92d27725bf07/InstallHero-T.jpg?w=120&h=120&fit=pad)
 *
 * Installation Hero - Tablet
 *
 * Image of video doorbell and motion sensor products
 */
export const IMG_66p7piiLYJunK02kCWPizi = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/66p7piiLYJunK02kCWPizi/949368c9964b5b45ecaa92d27725bf07/InstallHero-T.jpg',
  description: `Image of video doorbell and motion sensor products`,
  originalHeight: 1400,
  originalWidth: 1500
}

/**
 * ![Scout - transparent](https://images.ctfassets.net/v6awd0kabi65/7J0nzHyEtO3BUPk82sqiN0/c13036eb781f3d83d6f0814dcde19e63/Scout-3x.png?w=120&h=120&fit=pad)
 *
 * Scout - transparent
 *
 * Image of indoor security camera on a white background
 */
export const IMG_7J0nzHyEtO3BUPk82sqiN0 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7J0nzHyEtO3BUPk82sqiN0/c13036eb781f3d83d6f0814dcde19e63/Scout-3x.png',
  description: `Image of indoor security camera on a white background`,
  originalHeight: 964,
  originalWidth: 1308
}

/**
 * ![Scout diagram v2 - shutter open 1@2x](https://images.ctfassets.net/v6awd0kabi65/7tU8EMr6rDlMdjFbuSvpJw/b6ca2f1c67125f4ab9c4400db618e995/Scout_diagram_v2_-_shutter_open_1_2x_-_jpg.jpg?w=120&h=120&fit=pad)
 *
 * Scout diagram v2 - shutter open 1@2x
 *
 * Image of indoor security camera
 */
export const IMG_7tU8EMr6rDlMdjFbuSvpJw = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7tU8EMr6rDlMdjFbuSvpJw/b6ca2f1c67125f4ab9c4400db618e995/Scout_diagram_v2_-_shutter_open_1_2x_-_jpg.jpg',
  description: `Image of indoor security camera`,
  originalHeight: 1378,
  originalWidth: 1194
}

/**
 * ![Live Guard Protection](https://images.ctfassets.net/v6awd0kabi65/6DFdNkksuAKCAg7ojHb7oa/afbab0589dd8875bce873294cfa4c1d9/Scout_q.jpg?w=120&h=120&fit=pad)
 *
 * Live Guard Protection
 *
 * Image of an intruder in a house being caught by the indoor security camera
 */
export const IMG_6DFdNkksuAKCAg7ojHb7oa = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6DFdNkksuAKCAg7ojHb7oa/afbab0589dd8875bce873294cfa4c1d9/Scout_q.jpg',
  description: `Image of an intruder in a house being caught by the indoor security camera`,
  originalHeight: 1056,
  originalWidth: 1932
}

/**
 * ![Alarm Moment - Fire](https://images.ctfassets.net/v6awd0kabi65/ZNDPXmOd2Rjr4cF7ZBohF/35a87df378ae532b48e55d4dddaac25c/fire_2x_q.jpg?w=120&h=120&fit=pad)
 *
 * Alarm Moment - Fire
 *
 * Image of a couple in their bedroom being alerted of a fire in their home from the smoke detector
 */
export const IMG_ZNDPXmOd2Rjr4cF7ZBohF = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/ZNDPXmOd2Rjr4cF7ZBohF/35a87df378ae532b48e55d4dddaac25c/fire_2x_q.jpg',
  description: `Image of a couple in their bedroom being alerted of a fire in their home from the smoke detector`,
  originalHeight: 1056,
  originalWidth: 1932
}

/**
 * ![scout uk pdp video mp4](https://videos.ctfassets.net/v6awd0kabi65/Q68Bqx9aRQq0KtfrYFyiK/8e24da0dd8d70732b74d175d1852f8cf/scout_uk_pdp.mp4?w=120&h=120&fit=pad)
 *
 * scout uk pdp video mp4
 *
 * Video of indoor security camera
 */
export const IMG_Q68Bqx9aRQq0KtfrYFyiK = {
  url: 'https://videos.ctfassets.net/v6awd0kabi65/Q68Bqx9aRQq0KtfrYFyiK/8e24da0dd8d70732b74d175d1852f8cf/scout_uk_pdp.mp4',
  description: `Video of indoor security camera`,
  originalHeight: null,
  originalWidth: null
}

/**
 * ![App Widget - Motion ](https://images.ctfassets.net/v6awd0kabi65/6pqJEUiCCXtPitl0efrfTa/77b0cbc1c024eaee3746c9db6b3f83a4/image__11_.png?w=120&h=120&fit=pad)
 *
 * App Widget - Motion
 *
 * Image of the app on a phone showing the view of a living room through the indoor security camera
 */
export const IMG_6pqJEUiCCXtPitl0efrfTa = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6pqJEUiCCXtPitl0efrfTa/77b0cbc1c024eaee3746c9db6b3f83a4/image__11_.png',
  description: `Image of the app on a phone showing the view of a living room through the indoor security camera`,
  originalHeight: 1254,
  originalWidth: 1000
}

/**
 * ![Scout diagram v2 - shutter closed 1@2x](https://images.ctfassets.net/v6awd0kabi65/vlYJLsCKAtZIvkFVaqcN3/247bd04ac1b9099ac6955a33b4f4f7e9/Scout_diagram_v2_-_shutter_closed_1_2x_-_jpg.jpg?w=120&h=120&fit=pad)
 *
 * Scout diagram v2 - shutter closed 1@2x
 *
 * Image of indoor security camera mounted
 */
export const IMG_vlYJLsCKAtZIvkFVaqcN3 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/vlYJLsCKAtZIvkFVaqcN3/247bd04ac1b9099ac6955a33b4f4f7e9/Scout_diagram_v2_-_shutter_closed_1_2x_-_jpg.jpg',
  description: `Image of indoor security camera mounted`,
  originalHeight: 1378,
  originalWidth: 1194
}

/**
 * ![App Widget - Alerts](https://images.ctfassets.net/v6awd0kabi65/6LhcgEixxL17WwjVDgTH9a/56314313650db8dced96d219d3f2e18c/image__10_.png?w=120&h=120&fit=pad)
 *
 * App Widget - Alerts
 *
 * Image of the app showing view from indoor camera
 */
export const IMG_6LhcgEixxL17WwjVDgTH9a = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6LhcgEixxL17WwjVDgTH9a/56314313650db8dced96d219d3f2e18c/image__10_.png',
  description: `Image of the app showing view from indoor camera`,
  originalHeight: 1254,
  originalWidth: 1000
}

/**
 * ![Alarm Moment - Water](https://images.ctfassets.net/v6awd0kabi65/6FPObnRIgxYPuGYJJRCSnC/96b2e183ad0ec7a22603abd1703a6141/water_2x_q.jpg?w=120&h=120&fit=pad)
 *
 * Alarm Moment - Water
 *
 * Image of a woman learning about a burst pipe in her basement because of the water sensor
 */
export const IMG_6FPObnRIgxYPuGYJJRCSnC = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6FPObnRIgxYPuGYJJRCSnC/96b2e183ad0ec7a22603abd1703a6141/water_2x_q.jpg',
  description: `Image of a woman learning about a burst pipe in her basement because of the water sensor`,
  originalHeight: 1056,
  originalWidth: 1932
}

/**
 * ![scout uk pdp video webm](https://videos.ctfassets.net/v6awd0kabi65/eDRGuzk9f13YVnsQZBeRu/376c23e0205b1ec8f6c751dabb29e799/scout_uk_pdp.webm?w=120&h=120&fit=pad)
 *
 * scout uk pdp video webm
 *
 * Video of indoor security camera
 */
export const IMG_eDRGuzk9f13YVnsQZBeRu = {
  url: 'https://videos.ctfassets.net/v6awd0kabi65/eDRGuzk9f13YVnsQZBeRu/376c23e0205b1ec8f6c751dabb29e799/scout_uk_pdp.webm',
  description: `Video of indoor security camera`,
  originalHeight: null,
  originalWidth: null
}

/**
 * ![Alarm Moment - Package theft](https://images.ctfassets.net/v6awd0kabi65/4xXJHecRJBtZjqehoEaVZm/605445cd185d842fca155d37c634e00e/package_q.jpg?w=120&h=120&fit=pad)
 *
 * Alarm Moment - Package theft
 *
 * Image of a woman monitoring packages on her front door through the video doorbell
 */
export const IMG_4xXJHecRJBtZjqehoEaVZm = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4xXJHecRJBtZjqehoEaVZm/605445cd185d842fca155d37c634e00e/package_q.jpg',
  description: `Image of a woman monitoring packages on her front door through the video doorbell`,
  originalHeight: 1056,
  originalWidth: 1932
}

/**
 * ![App Widget - Live Feed](https://images.ctfassets.net/v6awd0kabi65/2AKzGOmweLRCTXA0ftQ92n/adef68665f65978dcef15faeb99504a4/image__9_.png?w=120&h=120&fit=pad)
 *
 * App Widget - Live Feed
 *
 * Image of the app on a phone showing both day and night views
 */
export const IMG_2AKzGOmweLRCTXA0ftQ92n = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2AKzGOmweLRCTXA0ftQ92n/adef68665f65978dcef15faeb99504a4/image__9_.png',
  description: `Image of the app on a phone showing both day and night views`,
  originalHeight: 627,
  originalWidth: 500
}

/**
 * ![New Quiz Image](https://images.ctfassets.net/v6awd0kabi65/4mI9KaGvxh51fi1GYOSaVr/8f53b5f5885938a5c7c3f97b375fbef3/System_quiz_odmon.png?w=120&h=120&fit=pad)
 *
 * New Quiz Image
 *
 * Image of home security sensors including a keypad, entry sensor, glassbreak sensor, smoke detector and outdoor camera
 */
export const IMG_4mI9KaGvxh51fi1GYOSaVr = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4mI9KaGvxh51fi1GYOSaVr/8f53b5f5885938a5c7c3f97b375fbef3/System_quiz_odmon.png',
  description: `Image of home security sensors including a keypad, entry sensor, glassbreak sensor, smoke detector and outdoor camera`,
  originalHeight: 950,
  originalWidth: 1326
}

/**
 * ![SimpliSafe HS r-wordmark-b-y-RGB (4)](https://images.ctfassets.net/v6awd0kabi65/69ynGfiNyJxlmjTru3pmbV/71abf3f44eec818621f8342131fa30e5/SimpliSafe_HS_r-wordmark-b-y-RGB__4_.png?w=120&h=120&fit=pad)
 *
 * SimpliSafe HS r-wordmark-b-y-RGB (4)
 *
 *
 */
export const IMG_69ynGfiNyJxlmjTru3pmbV = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/69ynGfiNyJxlmjTru3pmbV/71abf3f44eec818621f8342131fa30e5/SimpliSafe_HS_r-wordmark-b-y-RGB__4_.png',
  description: ``,
  originalHeight: 4501,
  originalWidth: 8001
}

/**
 * ![wifi extender](https://images.ctfassets.net/v6awd0kabi65/Ck2qyUovl6h53KjRGAPFp/83f9fe306cca421f16ad91a8b3103938/TL-WA854RE_UK_-3.0_package__normal_1553648766154k.jpg?w=120&h=120&fit=pad)
 *
 * wifi extender
 *
 *
 */
export const IMG_Ck2qyUovl6h53KjRGAPFp = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/Ck2qyUovl6h53KjRGAPFp/83f9fe306cca421f16ad91a8b3103938/TL-WA854RE_UK_-3.0_package__normal_1553648766154k.jpg',
  description: ``,
  originalHeight: 590,
  originalWidth: 590
}

/**
 * ![SimpliSafe HS r-wordmark-b-y-RGB](https://images.ctfassets.net/v6awd0kabi65/4qZBcpj0WjLkMPtqvdwVEz/0b4f2822bcc025b82dc94efdab856276/SimpliSafe_HS_r-wordmark-b-y-RGB.png?w=120&h=120&fit=pad)
 *
 * SimpliSafe HS r-wordmark-b-y-RGB
 *
 *
 */
export const IMG_4qZBcpj0WjLkMPtqvdwVEz = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4qZBcpj0WjLkMPtqvdwVEz/0b4f2822bcc025b82dc94efdab856276/SimpliSafe_HS_r-wordmark-b-y-RGB.png',
  description: ``,
  originalHeight: 4501,
  originalWidth: 8001
}

/**
 * ![Fast Charging](https://images.ctfassets.net/v6awd0kabi65/3HkSNfQvaK7yLPNqfrf34H/9c4c3936fc25395f471219bef60ea659/ImgGallery_Scout-5.jpg?w=120&h=120&fit=pad)
 *
 * Fast Charging
 *
 * Scout Fast Charging
 */
export const IMG_3HkSNfQvaK7yLPNqfrf34H = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3HkSNfQvaK7yLPNqfrf34H/9c4c3936fc25395f471219bef60ea659/ImgGallery_Scout-5.jpg',
  description: `Scout Fast Charging`,
  originalHeight: 1552,
  originalWidth: 1968
}

/**
 * ![Scout Sensor](https://images.ctfassets.net/v6awd0kabi65/vErNBFFERCtDMhjJN7xVO/85f16a8d27f54e455377404b6bc9d194/ImgGallery_Scout-main.jpg?w=120&h=120&fit=pad)
 *
 * Scout Sensor
 *
 * Scout Sensor
 */
export const IMG_vErNBFFERCtDMhjJN7xVO = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/vErNBFFERCtDMhjJN7xVO/85f16a8d27f54e455377404b6bc9d194/ImgGallery_Scout-main.jpg',
  description: `Scout Sensor`,
  originalHeight: 1552,
  originalWidth: 1968
}

/**
 * ![Wine, On Time (User Stories- Background)](https://images.ctfassets.net/v6awd0kabi65/6z7Bit26qLwUbDUA0lSv1h/b49786265adc230f30a960a194f0147c/image_164.png?w=120&h=120&fit=pad)
 *
 * Wine, On Time (User Stories- Background)
 *
 * Wine, On Time (User Stories- Background)
 */
export const IMG_6z7Bit26qLwUbDUA0lSv1h = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6z7Bit26qLwUbDUA0lSv1h/b49786265adc230f30a960a194f0147c/image_164.png',
  description: `Wine, On Time (User Stories- Background)`,
  originalHeight: 856,
  originalWidth: 1360
}

/**
 * ![Glassbreak Sensor (User Stories - Device)](https://images.ctfassets.net/v6awd0kabi65/23SGmIzXs8oqoFEga5lm3f/7b6d4aded284223420096d5c1c5e95af/Glassbreak.png?w=120&h=120&fit=pad)
 *
 * Glassbreak Sensor (User Stories - Device)
 *
 * Glassbreak Sensor (User Stories - Device)
 */
export const IMG_23SGmIzXs8oqoFEga5lm3f = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/23SGmIzXs8oqoFEga5lm3f/7b6d4aded284223420096d5c1c5e95af/Glassbreak.png',
  description: `Glassbreak Sensor (User Stories - Device)`,
  originalHeight: 940,
  originalWidth: 712
}

/**
 * ![Water Sensor (User Stories - Device)](https://images.ctfassets.net/v6awd0kabi65/1mL6BBJPClb968ilhokSoC/7274ba25c28d47f2d580a4b95ea4b6f7/Water_Sensor.png?w=120&h=120&fit=pad)
 *
 * Water Sensor (User Stories - Device)
 *
 * Water Sensor (User Stories - Device)
 */
export const IMG_1mL6BBJPClb968ilhokSoC = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1mL6BBJPClb968ilhokSoC/7274ba25c28d47f2d580a4b95ea4b6f7/Water_Sensor.png',
  description: `Water Sensor (User Stories - Device)`,
  originalHeight: 940,
  originalWidth: 712
}

/**
 * ![Wireless Indoor Camera Motion Detection of a Dog](https://images.ctfassets.net/v6awd0kabi65/1akPVgx2fFp5rC6w6YZKVm/34d880a37a940098820b01e67b06731e/DogImg_2x.png?w=120&h=120&fit=pad)
 *
 * Wireless Indoor Camera Motion Detection of a Dog
 *
 * Image of a dog being flagged as a pet during the advanced motion detection feature of the Wireless Indoor Camera.
 */
export const IMG_1akPVgx2fFp5rC6w6YZKVm = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1akPVgx2fFp5rC6w6YZKVm/34d880a37a940098820b01e67b06731e/DogImg_2x.png',
  description: `Image of a dog being flagged as a pet during the advanced motion detection feature of the Wireless Indoor Camera.`,
  originalHeight: 794,
  originalWidth: 1244
}

/**
 * ![Alarm Moment - Break-in](https://images.ctfassets.net/v6awd0kabi65/lzPxx0ferIthUcXSTFsdI/720361a0a2c4773e28437d37b15a66c0/break_in_2x_-qly.jpg?w=120&h=120&fit=pad)
 *
 * Alarm Moment - Break-in
 *
 * null
 */
export const IMG_lzPxx0ferIthUcXSTFsdI = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/lzPxx0ferIthUcXSTFsdI/720361a0a2c4773e28437d37b15a66c0/break_in_2x_-qly.jpg',
  description: `null`,
  originalHeight: 1056,
  originalWidth: 1932
}

/**
 * ![Simplisafe](https://images.ctfassets.net/v6awd0kabi65/1Lt8YFKwt7rQ5U8TZ5pnvq/cd8a81e1b1078c2ec53f583632bba295/SimplisafeLogo.png?w=120&h=120&fit=pad)
 *
 * Simplisafe
 *
 * SimpliSafe
 */
export const IMG_1Lt8YFKwt7rQ5U8TZ5pnvq = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1Lt8YFKwt7rQ5U8TZ5pnvq/cd8a81e1b1078c2ec53f583632bba295/SimplisafeLogo.png',
  description: `SimpliSafe`,
  originalHeight: 99,
  originalWidth: 540
}

/**
 * ![Video Doorbell (User Stories - Device)](https://images.ctfassets.net/v6awd0kabi65/7t1r0nxpXmcFWEcYNplzEj/2c9f5a4c66a86244517003dbf1a4cf7d/Video_Doorbell.png?w=120&h=120&fit=pad)
 *
 * Video Doorbell (User Stories - Device)
 *
 * Video Doorbell (User Stories - Device)
 */
export const IMG_7t1r0nxpXmcFWEcYNplzEj = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7t1r0nxpXmcFWEcYNplzEj/2c9f5a4c66a86244517003dbf1a4cf7d/Video_Doorbell.png',
  description: `Video Doorbell (User Stories - Device)`,
  originalHeight: 940,
  originalWidth: 712
}

/**
 * ![customer support yellow](https://images.ctfassets.net/v6awd0kabi65/7M1ctCRAsch4jPh9d69wNQ/88c8d51f2fbf08eb7dede9f41d3f2afc/png_Support-60_2x.png?w=120&h=120&fit=pad)
 *
 * customer support yellow
 *
 *
 */
export const IMG_7M1ctCRAsch4jPh9d69wNQ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7M1ctCRAsch4jPh9d69wNQ/88c8d51f2fbf08eb7dede9f41d3f2afc/png_Support-60_2x.png',
  description: ``,
  originalHeight: 120,
  originalWidth: 120
}

/**
 * ![Hitting the panic button (User Stories - Background)](https://images.ctfassets.net/v6awd0kabi65/7jv3LXBflLOQ2D43VdoxcK/f3b1b336a49b4618390677777e21bb40/image_118.png?w=120&h=120&fit=pad)
 *
 * Hitting the panic button (User Stories - Background)
 *
 * Hitting the panic button (User Stories - Background)
 */
export const IMG_7jv3LXBflLOQ2D43VdoxcK = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7jv3LXBflLOQ2D43VdoxcK/f3b1b336a49b4618390677777e21bb40/image_118.png',
  description: `Hitting the panic button (User Stories - Background)`,
  originalHeight: 856,
  originalWidth: 1360
}

/**
 * ![Wedding day flood (User Stories- Background)](https://images.ctfassets.net/v6awd0kabi65/6pKPtQH7L23AEFiN4wkRiE/91222c5b27ffb3efd72b535f29d2287c/image_163.png?w=120&h=120&fit=pad)
 *
 * Wedding day flood (User Stories- Background)
 *
 * Wedding day flood (User Stories- Background)
 */
export const IMG_6pKPtQH7L23AEFiN4wkRiE = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6pKPtQH7L23AEFiN4wkRiE/91222c5b27ffb3efd72b535f29d2287c/image_163.png',
  description: `Wedding day flood (User Stories- Background)`,
  originalHeight: 856,
  originalWidth: 1372
}

/**
 * ![SimpliSafe FASTProtect TECHNOLOGY (Hero Banner)](https://images.ctfassets.net/v6awd0kabi65/2n3tf5tm52On6IHyXzXBJb/83cc957e06636649db3dc464a85f2d4c/image_2.png?w=120&h=120&fit=pad)
 *
 * SimpliSafe FASTProtect TECHNOLOGY (Hero Banner)
 *
 * SimpliSafe FASTProtect TECHNOLOGY (Hero Banner)
 */
export const IMG_2n3tf5tm52On6IHyXzXBJb = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2n3tf5tm52On6IHyXzXBJb/83cc957e06636649db3dc464a85f2d4c/image_2.png',
  description: `SimpliSafe FASTProtect TECHNOLOGY (Hero Banner)`,
  originalHeight: 186,
  originalWidth: 331
}

/**
 * ![Scout UK Video Poster ](https://images.ctfassets.net/v6awd0kabi65/7KjAowFloU0onXPr69vIPr/5e5f936c90e5fec0eb45cdcc06cf1b4e/scout_video_poster_1.jpg?w=120&h=120&fit=pad)
 *
 * Scout UK Video Poster
 *
 * Scout UK Video Poster
 */
export const IMG_7KjAowFloU0onXPr69vIPr = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7KjAowFloU0onXPr69vIPr/5e5f936c90e5fec0eb45cdcc06cf1b4e/scout_video_poster_1.jpg',
  description: `Scout UK Video Poster`,
  originalHeight: 1124,
  originalWidth: 1996
}

/**
 * ![Mounting options](https://images.ctfassets.net/v6awd0kabi65/2Mk39e7J0MM02gvaVSxxzn/5e25539a35414a93a6a2ac366f4c85d8/ImgGallery_Scout-3.jpg?w=120&h=120&fit=pad)
 *
 * Mounting options
 *
 * Scout Mounting options
 */
export const IMG_2Mk39e7J0MM02gvaVSxxzn = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2Mk39e7J0MM02gvaVSxxzn/5e25539a35414a93a6a2ac366f4c85d8/ImgGallery_Scout-3.jpg',
  description: `Scout Mounting options`,
  originalHeight: 1552,
  originalWidth: 1968
}

/**
 * ![Panic Button (User Stories - Device)](https://images.ctfassets.net/v6awd0kabi65/3FC36QJsip4tAVuVAp0rRt/e1050afbaa45da9faaa1280980733c6e/Panic_Button.png?w=120&h=120&fit=pad)
 *
 * Panic Button (User Stories - Device)
 *
 * Panic Button (User Stories - Device)
 */
export const IMG_3FC36QJsip4tAVuVAp0rRt = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3FC36QJsip4tAVuVAp0rRt/e1050afbaa45da9faaa1280980733c6e/Panic_Button.png',
  description: `Panic Button (User Stories - Device)`,
  originalHeight: 940,
  originalWidth: 712
}

/**
 * ![24/7 monitoring by professional agents (Hero Banner - Desktop)](https://images.ctfassets.net/v6awd0kabi65/6pVH7CTJxiB4Lx2pgiqgYo/2056510e351a4c66ec644d8cd01a4765/230411_SimpliSafe_MonitoringCenter_B_Screen_091_Panorama_FIN_1.png?w=120&h=120&fit=pad)
 *
 * 24/7 monitoring by professional agents (Hero Banner - Desktop)
 *
 * 24/7 monitoring by professional agents (Hero Banner - Desktop)
 */
export const IMG_6pVH7CTJxiB4Lx2pgiqgYo = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6pVH7CTJxiB4Lx2pgiqgYo/2056510e351a4c66ec644d8cd01a4765/230411_SimpliSafe_MonitoringCenter_B_Screen_091_Panorama_FIN_1.png',
  description: `24/7 monitoring by professional agents (Hero Banner - Desktop)`,
  originalHeight: 1437,
  originalWidth: 3144
}

/**
 * ![Whole home security at an unbeatable price (Dead End Component II)](https://images.ctfassets.net/v6awd0kabi65/7l0o0nsnpaTWNQvZER9GWn/251d7631ebb6b381217f85a8832d9320/image_169.png?w=120&h=120&fit=pad)
 *
 * Whole home security at an unbeatable price (Dead End Component II)
 *
 * Whole home security at an unbeatable price
 */
export const IMG_7l0o0nsnpaTWNQvZER9GWn = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7l0o0nsnpaTWNQvZER9GWn/251d7631ebb6b381217f85a8832d9320/image_169.png',
  description: `Whole home security at an unbeatable price`,
  originalHeight: 1038,
  originalWidth: 1362
}

/**
 * ![Alarm Moment - Temp](https://images.ctfassets.net/v6awd0kabi65/6wWdAKndtWXrMUkdUIi8A3/c8d7804569d556f612dc92d7a0c588d7/temp_hot_2x_q.jpg?w=120&h=120&fit=pad)
 *
 * Alarm Moment - Temp
 *
 * null
 */
export const IMG_6wWdAKndtWXrMUkdUIi8A3 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6wWdAKndtWXrMUkdUIi8A3/c8d7804569d556f612dc92d7a0c588d7/temp_hot_2x_q.jpg',
  description: `null`,
  originalHeight: 1056,
  originalWidth: 1932
}

/**
 * ![SimpliSafe Open Source Disclosure](https://assets.ctfassets.net/v6awd0kabi65/542HyVZ9FXtuYNBUe0UCtx/a5b755fb58a6ac56e1ec27b40bb4604a/SimpliSafe-Open_Source_Disclosure.pdf?w=120&h=120&fit=pad)
 *
 * SimpliSafe Open Source Disclosure
 *
 * SimpliSafe Open Source Disclosure
 */
export const IMG_542HyVZ9FXtuYNBUe0UCtx = {
  url: 'https://assets.ctfassets.net/v6awd0kabi65/542HyVZ9FXtuYNBUe0UCtx/a5b755fb58a6ac56e1ec27b40bb4604a/SimpliSafe-Open_Source_Disclosure.pdf',
  description: `SimpliSafe Open Source Disclosure`,
  originalHeight: null,
  originalWidth: null
}

/**
 * ![Compact size](https://images.ctfassets.net/v6awd0kabi65/7wfHq0hlGEXDpHGZwSwkt8/b31e7ec62ed247a6d46df6c8697fe080/ImgGallery_Scout-4.jpg?w=120&h=120&fit=pad)
 *
 * Compact size
 *
 * Scout Compact size
 */
export const IMG_7wfHq0hlGEXDpHGZwSwkt8 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7wfHq0hlGEXDpHGZwSwkt8/b31e7ec62ed247a6d46df6c8697fe080/ImgGallery_Scout-4.jpg',
  description: `Scout Compact size`,
  originalHeight: 1552,
  originalWidth: 1968
}

/**
 * ![App Widget - Settings](https://images.ctfassets.net/v6awd0kabi65/H74O3Ee2bdvZmRW0HSW4o/0e8a2bd3de91a71d7f0365ce34aad24c/image__12_.png?w=120&h=120&fit=pad)
 *
 * App Widget - Settings
 *
 * null
 */
export const IMG_H74O3Ee2bdvZmRW0HSW4o = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/H74O3Ee2bdvZmRW0HSW4o/0e8a2bd3de91a71d7f0365ce34aad24c/image__12_.png',
  description: `null`,
  originalHeight: 1254,
  originalWidth: 1000
}

/**
 * ![Wildfires & looting (User Stories- Background)](https://images.ctfassets.net/v6awd0kabi65/24hXqllSTgT5ZXUCOSJz4G/e8c95a73d4ec0d6bdac2b13bc9e59515/photo.png?w=120&h=120&fit=pad)
 *
 * Wildfires & looting (User Stories- Background)
 *
 * Wildfires & looting (User Stories- Background)
 */
export const IMG_24hXqllSTgT5ZXUCOSJz4G = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/24hXqllSTgT5ZXUCOSJz4G/e8c95a73d4ec0d6bdac2b13bc9e59515/photo.png',
  description: `Wildfires & looting (User Stories- Background)`,
  originalHeight: 856,
  originalWidth: 1372
}

/**
 * ![24/7 monitoring by professional agents (Hero Banner - Mobile)](https://images.ctfassets.net/v6awd0kabi65/g7byqrCtiLAWW2aGMmYXy/9cd7c69d26187a894ad40ab82d53fc77/230411_SimpliSafe_MonitoringCenter_B_Screen_091_Panorama_FIN_2__1_.png?w=120&h=120&fit=pad)
 *
 * 24/7 monitoring by professional agents (Hero Banner - Mobile)
 *
 * 24/7 monitoring by professional agents (Hero Banner - Mobile)
 */
export const IMG_g7byqrCtiLAWW2aGMmYXy = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/g7byqrCtiLAWW2aGMmYXy/9cd7c69d26187a894ad40ab82d53fc77/230411_SimpliSafe_MonitoringCenter_B_Screen_091_Panorama_FIN_2__1_.png',
  description: `24/7 monitoring by professional agents (Hero Banner - Mobile)`,
  originalHeight: 968,
  originalWidth: 1500
}

/**
 * ![wireless indoor camera shutter close animation](https://images.ctfassets.net/v6awd0kabi65/5yrwXp2towEMwlQiXnZ44z/2b06d389963c5e3c95546165f7d91c75/shutter-close-0123.webp?w=120&h=120&fit=pad)
 *
 * wireless indoor camera shutter close animation
 *
 * Image of the Wireless Indoor Camera opening and closing its shutter.
 */
export const IMG_5yrwXp2towEMwlQiXnZ44z = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5yrwXp2towEMwlQiXnZ44z/2b06d389963c5e3c95546165f7d91c75/shutter-close-0123.webp',
  description: `Image of the Wireless Indoor Camera opening and closing its shutter.`,
  originalHeight: 730,
  originalWidth: 1300
}

/**
 * ![Outdoor Camera (User Stories - Device)](https://images.ctfassets.net/v6awd0kabi65/CA7XYdmjGssQ6mS5HbkSm/b092c4a0667e10b149b56d791cea5a3b/Shield.png?w=120&h=120&fit=pad)
 *
 * Outdoor Camera (User Stories - Device)
 *
 * Outdoor Camera (User Stories - Device)
 */
export const IMG_CA7XYdmjGssQ6mS5HbkSm = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/CA7XYdmjGssQ6mS5HbkSm/b092c4a0667e10b149b56d791cea5a3b/Shield.png',
  description: `Outdoor Camera (User Stories - Device)`,
  originalHeight: 940,
  originalWidth: 712
}

/**
 * ![Pizza rolls fiasco (User Stories- Background)](https://images.ctfassets.net/v6awd0kabi65/6Unve0CS3kzToZhQaIJYgs/17db5c1ebf864eb0301b4d2391ca0a49/image_163__1_.png?w=120&h=120&fit=pad)
 *
 * Pizza rolls fiasco (User Stories- Background)
 *
 * Pizza rolls fiasco (User Stories- Background)
 */
export const IMG_6Unve0CS3kzToZhQaIJYgs = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6Unve0CS3kzToZhQaIJYgs/17db5c1ebf864eb0301b4d2391ca0a49/image_163__1_.png',
  description: `Pizza rolls fiasco (User Stories- Background)`,
  originalHeight: 856,
  originalWidth: 1372
}

/**
 * ![Smoke Alarm (User Stories - Device)](https://images.ctfassets.net/v6awd0kabi65/50bSFBLIbPjX8HTiVxd6E4/cd545acdf121de109862d623fd6ff039/Smoke.png?w=120&h=120&fit=pad)
 *
 * Smoke Alarm (User Stories - Device)
 *
 * Smoke Alarm (User Stories - Device)
 */
export const IMG_50bSFBLIbPjX8HTiVxd6E4 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/50bSFBLIbPjX8HTiVxd6E4/cd545acdf121de109862d623fd6ff039/Smoke.png',
  description: `Smoke Alarm (User Stories - Device)`,
  originalHeight: 940,
  originalWidth: 712
}

/**
 * ![Scout diagram v2 - shutter closed](https://images.ctfassets.net/v6awd0kabi65/1bs50yZsBalBnNeDUjdif3/e0e3261112241bf75652a215c4f6c7d3/Scout_diagram_v2_-_shutter_closed_1.jpg?w=120&h=120&fit=pad)
 *
 * Scout diagram v2 - shutter closed
 *
 * Scout diagram v2 - shutter closed
 */
export const IMG_1bs50yZsBalBnNeDUjdif3 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1bs50yZsBalBnNeDUjdif3/e0e3261112241bf75652a215c4f6c7d3/Scout_diagram_v2_-_shutter_closed_1.jpg',
  description: `Scout diagram v2 - shutter closed`,
  originalHeight: 1378,
  originalWidth: 1194
}

/**
 * ![Affirm card content](https://images.ctfassets.net/v6awd0kabi65/2jNxZIeOlbvD91J1sQ36L3/20b752cbf917517badad97d5a40dd1f0/affirm_cart.svg?w=120&h=120&fit=pad)
 *
 * Affirm card content
 *
 * Affirm logo for the card content on the cart page
 */
export const IMG_2jNxZIeOlbvD91J1sQ36L3 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2jNxZIeOlbvD91J1sQ36L3/20b752cbf917517badad97d5a40dd1f0/affirm_cart.svg',
  description: `Affirm logo for the card content on the cart page`,
  originalHeight: 36,
  originalWidth: 90
}

/**
 * ![Ping-pong sized hail (User Stories - Background)](https://images.ctfassets.net/v6awd0kabi65/758hlfe5DXy9bqmrNZDoMR/149758fcc0282f82b4ee115c89985ebc/broken_window_1_1.png?w=120&h=120&fit=pad)
 *
 * Ping-pong sized hail (User Stories - Background)
 *
 * Ping-pong sized hail (User Stories - Background)
 */
export const IMG_758hlfe5DXy9bqmrNZDoMR = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/758hlfe5DXy9bqmrNZDoMR/149758fcc0282f82b4ee115c89985ebc/broken_window_1_1.png',
  description: `Ping-pong sized hail (User Stories - Background)`,
  originalHeight: 856,
  originalWidth: 1372
}

/**
 * ![Easy Install](https://images.ctfassets.net/v6awd0kabi65/22mL2McOXvaYhNEXcN7Xzd/5664a5cb591edddb4a5b012f4965c774/ImgGallery_Scout-2.jpg?w=120&h=120&fit=pad)
 *
 * Easy Install
 *
 * Scout Easy Install
 */
export const IMG_22mL2McOXvaYhNEXcN7Xzd = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/22mL2McOXvaYhNEXcN7Xzd/5664a5cb591edddb4a5b012f4965c774/ImgGallery_Scout-2.jpg',
  description: `Scout Easy Install`,
  originalHeight: 1552,
  originalWidth: 1968
}

/**
 * ![Flag - UK](https://images.ctfassets.net/v6awd0kabi65/5MMPLIN2zyLziluVdBuyH2/a4678d656fbae9d304564104bdb5aeba/uk-flag.png?w=120&h=120&fit=pad)
 *
 * Flag - UK
 *
 * United Kingdom
 */
export const IMG_5MMPLIN2zyLziluVdBuyH2 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5MMPLIN2zyLziluVdBuyH2/a4678d656fbae9d304564104bdb5aeba/uk-flag.png',
  description: `United Kingdom`,
  originalHeight: 36,
  originalWidth: 60
}

/**
 * ![Flag - USA](https://images.ctfassets.net/v6awd0kabi65/4wR7qeW9R8527OrIv7y3Lz/21b6c78054843c22be188750bc3b860d/Flag_-_USA.png?w=120&h=120&fit=pad)
 *
 * Flag - USA
 *
 * United States
 */
export const IMG_4wR7qeW9R8527OrIv7y3Lz = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4wR7qeW9R8527OrIv7y3Lz/21b6c78054843c22be188750bc3b860d/Flag_-_USA.png',
  description: `United States`,
  originalHeight: 36,
  originalWidth: 60
}

/**
 * ![Satisfaction Guarantee (Primary)](https://images.ctfassets.net/v6awd0kabi65/58kixll8YSHkhLmkPxrfGO/d291fd53ba1aa99310e76ab49fc308c0/100-seal_2x.png?w=120&h=120&fit=pad)
 *
 * Satisfaction Guarantee (Primary)
 *
 * 100% Satisfaction Guarantee
 */
export const IMG_58kixll8YSHkhLmkPxrfGO = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/58kixll8YSHkhLmkPxrfGO/d291fd53ba1aa99310e76ab49fc308c0/100-seal_2x.png',
  description: `100% Satisfaction Guarantee`,
  originalHeight: 440,
  originalWidth: 436
}

/**
 * ![Scout diagram v2 - shutter open](https://images.ctfassets.net/v6awd0kabi65/1z1JuS2nSCuaInMCcz9fcO/16141992ab65489c48b1a1471ddb0256/Scout_diagram_v2_-_shutter_open_1.jpg?w=120&h=120&fit=pad)
 *
 * Scout diagram v2 - shutter open
 *
 * Scout diagram v2 - shutter open
 */
export const IMG_1z1JuS2nSCuaInMCcz9fcO = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1z1JuS2nSCuaInMCcz9fcO/16141992ab65489c48b1a1471ddb0256/Scout_diagram_v2_-_shutter_open_1.jpg',
  description: `Scout diagram v2 - shutter open`,
  originalHeight: 1378,
  originalWidth: 1194
}

/**
 * ![Indoor Camera - Privacy Page - 08-24](https://images.ctfassets.net/v6awd0kabi65/pPCcaHBWucMLCMsJmbSSa/bd38ae5ced33f1a800fa36c6841fc07c/simplisafe_privacy_illustration_03.jpg?w=120&h=120&fit=pad)
 *
 * Indoor Camera - Privacy Page - 08-24
 *
 * SimpliSafe Indoor Camera
 */
export const IMG_pPCcaHBWucMLCMsJmbSSa = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/pPCcaHBWucMLCMsJmbSSa/bd38ae5ced33f1a800fa36c6841fc07c/simplisafe_privacy_illustration_03.jpg',
  description: `SimpliSafe Indoor Camera`,
  originalHeight: 490,
  originalWidth: 600
}

/**
 * ![Shield UK](https://images.ctfassets.net/v6awd0kabi65/7fLRyuQcZrZ5Iet7lbGEe6/734dfac51d2cecb0712ffda63a178c22/meet_outdoor_cam-uk.jpg?w=120&h=120&fit=pad)
 *
 * Shield UK
 *
 *
 */
export const IMG_7fLRyuQcZrZ5Iet7lbGEe6 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7fLRyuQcZrZ5Iet7lbGEe6/734dfac51d2cecb0712ffda63a178c22/meet_outdoor_cam-uk.jpg',
  description: ``,
  originalHeight: 1804,
  originalWidth: 2884
}

/**
 * ![Installation Hero - Desktop](https://images.ctfassets.net/v6awd0kabi65/6vYapQRUdZJ6uCCLnAMcGq/9b927a176d2116f2564d400980794f1b/InstallHero-D.jpg?w=120&h=120&fit=pad)
 *
 * Installation Hero - Desktop
 *
 * null
 */
export const IMG_6vYapQRUdZJ6uCCLnAMcGq = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6vYapQRUdZJ6uCCLnAMcGq/9b927a176d2116f2564d400980794f1b/InstallHero-D.jpg',
  description: `null`,
  originalHeight: 1622,
  originalWidth: 3098
}

/**
 * ![10 tips for a secure home this Easter](https://images.ctfassets.net/v6awd0kabi65/7AKu8gyLuez9eLQwtyDEd4/39ff89e368767b041a47e46042e57add/sebastian-staines-NV4YaqJ2eZY-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * 10 tips for a secure home this Easter
 *
 * Are you ready for a relaxing and safe Easter holiday? SimpliSafe's handy guide will help you make sure you are egg-stra-safe with your home security!
 */
export const IMG_7AKu8gyLuez9eLQwtyDEd4 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7AKu8gyLuez9eLQwtyDEd4/39ff89e368767b041a47e46042e57add/sebastian-staines-NV4YaqJ2eZY-unsplash.jpg',
  description: `Are you ready for a relaxing and safe Easter holiday? SimpliSafe's handy guide will help you make sure you are egg-stra-safe with your home security!`,
  originalHeight: 2495,
  originalWidth: 4065
}

/**
 * ![Refurbished System - 16 Piece Outdoor Kit](https://images.ctfassets.net/v6awd0kabi65/Lld3ttBzKh8Llu8HbEcOm/3295cbdc726476fd258de09d7ec7877a/Refurb-Pkg-16piece.jpg?w=120&h=120&fit=pad)
 *
 * Refurbished System - 16 Piece Outdoor Kit
 *
 *
 */
export const IMG_Lld3ttBzKh8Llu8HbEcOm = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/Lld3ttBzKh8Llu8HbEcOm/3295cbdc726476fd258de09d7ec7877a/Refurb-Pkg-16piece.jpg',
  description: ``,
  originalHeight: 3499,
  originalWidth: 3500
}

/**
 * ![Refurbished System - 11 Piece Outdoor Kit](https://images.ctfassets.net/v6awd0kabi65/3hzDxz6NnxR3S5xImCtRu4/49aea60e51eb3f3dd860f0916db84421/Refurb-Pkg-11piece.jpg?w=120&h=120&fit=pad)
 *
 * Refurbished System - 11 Piece Outdoor Kit
 *
 *
 */
export const IMG_3hzDxz6NnxR3S5xImCtRu4 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3hzDxz6NnxR3S5xImCtRu4/49aea60e51eb3f3dd860f0916db84421/Refurb-Pkg-11piece.jpg',
  description: ``,
  originalHeight: 3500,
  originalWidth: 3500
}

/**
 * ![Refurbished System - 12 Piece Essentials Kit](https://images.ctfassets.net/v6awd0kabi65/2tywUa9wSv06lui0OdkjB6/d394079318fdf15b9ca71095020f5151/Refurb-Pkg-12piece.jpg?w=120&h=120&fit=pad)
 *
 * Refurbished System - 12 Piece Essentials Kit
 *
 *
 */
export const IMG_2tywUa9wSv06lui0OdkjB6 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2tywUa9wSv06lui0OdkjB6/d394079318fdf15b9ca71095020f5151/Refurb-Pkg-12piece.jpg',
  description: ``,
  originalHeight: 3499,
  originalWidth: 3500
}

/**
 * ![Refurbished System - 9 Piece Essentials Kit](https://images.ctfassets.net/v6awd0kabi65/a37Jx03kwU67l1pfT5Ddi/b598b994b8b4508cfbeb19d3c961329b/Refurb-Pkg-9piece.jpg?w=120&h=120&fit=pad)
 *
 * Refurbished System - 9 Piece Essentials Kit
 *
 *
 */
export const IMG_a37Jx03kwU67l1pfT5Ddi = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/a37Jx03kwU67l1pfT5Ddi/b598b994b8b4508cfbeb19d3c961329b/Refurb-Pkg-9piece.jpg',
  description: ``,
  originalHeight: 3500,
  originalWidth: 3500
}

/**
 * ![Olympus Facing Right - /home-security-shop ](https://images.ctfassets.net/v6awd0kabi65/mWdspLzm9Xp54ckLGAkvu/3f5d103915865c8e55576c60b152bf6b/Olympus_D.png?w=120&h=120&fit=pad)
 *
 * Olympus Facing Right - /home-security-shop
 *
 *
 */
export const IMG_mWdspLzm9Xp54ckLGAkvu = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/mWdspLzm9Xp54ckLGAkvu/3f5d103915865c8e55576c60b152bf6b/Olympus_D.png',
  description: ``,
  originalHeight: 416,
  originalWidth: 475
}

/**
 * ![Hero Banner - Tablet - Dark](https://images.ctfassets.net/v6awd0kabi65/upK0Xs3NLwOeRF4aLcgxL/2c184f52638ef6c9c3f064716bd93087/T-hero.jpg?w=120&h=120&fit=pad)
 *
 * Hero Banner - Tablet - Dark
 *
 * Hero Image
 */
export const IMG_upK0Xs3NLwOeRF4aLcgxL = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/upK0Xs3NLwOeRF4aLcgxL/2c184f52638ef6c9c3f064716bd93087/T-hero.jpg',
  description: `Hero Image`,
  originalHeight: 2394,
  originalWidth: 4336
}

/**
 * ![Hero Banner - Homepage - Dark - To the right](https://images.ctfassets.net/v6awd0kabi65/65wwnTdDJAmgSnpM4W1PjP/8bc5fa0df28122b3b3dc77af328d1957/D-hero.jpg?w=120&h=120&fit=pad)
 *
 * Hero Banner - Homepage - Dark - To the right
 *
 * Hero image
 */
export const IMG_65wwnTdDJAmgSnpM4W1PjP = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/65wwnTdDJAmgSnpM4W1PjP/8bc5fa0df28122b3b3dc77af328d1957/D-hero.jpg',
  description: `Hero image`,
  originalHeight: 2392,
  originalWidth: 4782
}

/**
 * ![Hero Banner - Mobile - Dark](https://images.ctfassets.net/v6awd0kabi65/148Q9UYNpQPM30oWEley12/acf8683a652d1726fd2e5d4466bc42ba/M-hero.jpg?w=120&h=120&fit=pad)
 *
 * Hero Banner - Mobile - Dark
 *
 * Hero Image
 */
export const IMG_148Q9UYNpQPM30oWEley12 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/148Q9UYNpQPM30oWEley12/acf8683a652d1726fd2e5d4466bc42ba/M-hero.jpg',
  description: `Hero Image`,
  originalHeight: 1400,
  originalWidth: 1500
}

/**
 * ![Where should I place home security sensors?](https://images.ctfassets.net/v6awd0kabi65/4J4i6NZLdENNmBTiGSZX5a/a05b22063038905610378c351f26d5b2/800x450_6.png?w=120&h=120&fit=pad)
 *
 * Where should I place home security sensors?
 *
 * Proper placement is key for the effectiveness of your home security sensors. Learn where to install motion sensors, entry sensors and glassbreak sensors.
 */
export const IMG_4J4i6NZLdENNmBTiGSZX5a = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4J4i6NZLdENNmBTiGSZX5a/a05b22063038905610378c351f26d5b2/800x450_6.png',
  description: `Proper placement is key for the effectiveness of your home security sensors. Learn where to install motion sensors, entry sensors and glassbreak sensors.`,
  originalHeight: 450,
  originalWidth: 800
}

/**
 * ![Complete guide to water sensors](https://images.ctfassets.net/v6awd0kabi65/HfACnJp19MPzHzuPa5TZL/765bf24ecba2dcc25b4252bdd46c6d9a/Untitled_design__10_.png?w=120&h=120&fit=pad)
 *
 * Complete guide to water sensors
 *
 *
 */
export const IMG_HfACnJp19MPzHzuPa5TZL = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/HfACnJp19MPzHzuPa5TZL/765bf24ecba2dcc25b4252bdd46c6d9a/Untitled_design__10_.png',
  description: ``,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Does home insurance cover water damage?](https://images.ctfassets.net/v6awd0kabi65/5U3U3E7NcvHk6zMrEPJMrz/78704626bab051ea4fa3c92ac6e37af5/Untitled_design__9_.png?w=120&h=120&fit=pad)
 *
 * Does home insurance cover water damage?
 *
 * Does home insurance cover water damage? Explore the types of water damage typically included in home insurance policies and tips for safeguarding your home.
 */
export const IMG_5U3U3E7NcvHk6zMrEPJMrz = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5U3U3E7NcvHk6zMrEPJMrz/78704626bab051ea4fa3c92ac6e37af5/Untitled_design__9_.png',
  description: `Does home insurance cover water damage? Explore the types of water damage typically included in home insurance policies and tips for safeguarding your home.`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Homepage - Mobile](https://images.ctfassets.net/v6awd0kabi65/nbZnuTmuPiYKcvby6WOWZ/cf07fbeac128d5a00e6e79397d8542c4/PartnerHero-M.jpg?w=120&h=120&fit=pad)
 *
 * Homepage - Mobile
 *
 * Whole home protection
 */
export const IMG_nbZnuTmuPiYKcvby6WOWZ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/nbZnuTmuPiYKcvby6WOWZ/cf07fbeac128d5a00e6e79397d8542c4/PartnerHero-M.jpg',
  description: `Whole home protection`,
  originalHeight: 848,
  originalWidth: 1536
}

/**
 * ![ODCamS2 advanced AI](https://images.ctfassets.net/v6awd0kabi65/7t8z0NOL3FHqujrCurWW6A/4c8c6aa6f092a37528e95d45d3587b7d/ODCamS2_advanced_AI.jpg?w=120&h=120&fit=pad)
 *
 * ODCamS2 advanced AI
 *
 *
 */
export const IMG_7t8z0NOL3FHqujrCurWW6A = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7t8z0NOL3FHqujrCurWW6A/4c8c6aa6f092a37528e95d45d3587b7d/ODCamS2_advanced_AI.jpg',
  description: ``,
  originalHeight: 1207,
  originalWidth: 1905
}

/**
 * ![Homepage - Hero - Desktop](https://images.ctfassets.net/v6awd0kabi65/7L3C5wP1qvNIghghpO6BOs/86321c2cf5b104824d3385520e9f8453/PartnerHero-D.jpg?w=120&h=120&fit=pad)
 *
 * Homepage - Hero - Desktop
 *
 * Whole Home Protection
 */
export const IMG_7L3C5wP1qvNIghghpO6BOs = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7L3C5wP1qvNIghghpO6BOs/86321c2cf5b104824d3385520e9f8453/PartnerHero-D.jpg',
  description: `Whole Home Protection`,
  originalHeight: 2391,
  originalWidth: 4782
}

/**
 * ![Secured Systems](https://images.ctfassets.net/v6awd0kabi65/7dWLidlgDj6bpThb3JX3Xp/aa8fbda38e0209b18961eefd30e62800/PrivComponent_art-D.jpg?w=120&h=120&fit=pad)
 *
 * Secured Systems
 *
 * Secured Systems
 */
export const IMG_7dWLidlgDj6bpThb3JX3Xp = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7dWLidlgDj6bpThb3JX3Xp/aa8fbda38e0209b18961eefd30e62800/PrivComponent_art-D.jpg',
  description: `Secured Systems`,
  originalHeight: 2694,
  originalWidth: 3876
}

/**
 * ![404 - Our Recommendation (mobile)](https://images.ctfassets.net/v6awd0kabi65/6rBmlliCTHU9AT8B6xfng3/0a43e7044377c3efa9ba181dbf02a415/404_Recommendation.jpg?w=120&h=120&fit=pad)
 *
 * 404 - Our Recommendation (mobile)
 *
 * null
 */
export const IMG_6rBmlliCTHU9AT8B6xfng3 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6rBmlliCTHU9AT8B6xfng3/0a43e7044377c3efa9ba181dbf02a415/404_Recommendation.jpg',
  description: `null`,
  originalHeight: 1176,
  originalWidth: 1624
}

/**
 * ![Monitoring Mob](https://images.ctfassets.net/v6awd0kabi65/5XmFB9CV8bQuyBxXbUbrBg/1b5850e1a721798d761f5b749f36a1da/PrivComponent_art-D.jpg?w=120&h=120&fit=pad)
 *
 * Monitoring Mob
 *
 *
 */
export const IMG_5XmFB9CV8bQuyBxXbUbrBg = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5XmFB9CV8bQuyBxXbUbrBg/1b5850e1a721798d761f5b749f36a1da/PrivComponent_art-D.jpg',
  description: ``,
  originalHeight: 2694,
  originalWidth: 3876
}

/**
 * ![404 - Shop Packages](https://images.ctfassets.net/v6awd0kabi65/4UTUV7acAPLQtZykS7war6/9cb1b4950e259cc0cb327b019d909d6d/404_Packages.jpg?w=120&h=120&fit=pad)
 *
 * 404 - Shop Packages
 *
 * null
 */
export const IMG_4UTUV7acAPLQtZykS7war6 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4UTUV7acAPLQtZykS7war6/9cb1b4950e259cc0cb327b019d909d6d/404_Packages.jpg',
  description: `null`,
  originalHeight: 1176,
  originalWidth: 1624
}

/**
 * ![Yard Sign with Background](https://images.ctfassets.net/v6awd0kabi65/3Dg2i68TFPFOGbi35S0Oc/fcbbf660fa250368d118da045e5d61d5/Group_1.png?w=120&h=120&fit=pad)
 *
 * Yard Sign with Background
 *
 * SimpliSafe Yard Sign with Background
 */
export const IMG_3Dg2i68TFPFOGbi35S0Oc = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3Dg2i68TFPFOGbi35S0Oc/fcbbf660fa250368d118da045e5d61d5/Group_1.png',
  description: `SimpliSafe Yard Sign with Background`,
  originalHeight: 850,
  originalWidth: 1096
}

/**
 * ![Newsweek America's Best Customer Service 2025](https://images.ctfassets.net/v6awd0kabi65/3aPO8RfSjwoD7HLMeS8pQE/b2ec063e8df1029e0b894f2a740282fb/Newsweek_BCS2025_Logo_Basic.png?w=120&h=120&fit=pad)
 *
 * Newsweek America's Best Customer Service 2025
 *
 * Newsweek America's Best Customer Service 2025
 */
export const IMG_3aPO8RfSjwoD7HLMeS8pQE = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3aPO8RfSjwoD7HLMeS8pQE/b2ec063e8df1029e0b894f2a740282fb/Newsweek_BCS2025_Logo_Basic.png',
  description: `Newsweek America's Best Customer Service 2025`,
  originalHeight: 3977,
  originalWidth: 3341
}

/**
 * ![What Causes Orbs on Security Camera Footage?](https://images.ctfassets.net/v6awd0kabi65/2m5bnRaMM76N4ACnvrfOUz/5934bc6691d8487adc5b6e4ca856ce5d/Crime-hero_D.jpg?w=120&h=120&fit=pad)
 *
 * What Causes Orbs on Security Camera Footage?
 *
 *
 */
export const IMG_2m5bnRaMM76N4ACnvrfOUz = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2m5bnRaMM76N4ACnvrfOUz/5934bc6691d8487adc5b6e4ca856ce5d/Crime-hero_D.jpg',
  description: ``,
  originalHeight: 405,
  originalWidth: 1312
}

/**
 * ![Privacy - Secured System - Mobile](https://images.ctfassets.net/v6awd0kabi65/2bq7s0L6Q0KL28pZRYUBVf/c041919b043510c50263bd537363309b/PrivComponent_art-M.jpg?w=120&h=120&fit=pad)
 *
 * Privacy - Secured System - Mobile
 *
 * SimpliSafe Components
 */
export const IMG_2bq7s0L6Q0KL28pZRYUBVf = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2bq7s0L6Q0KL28pZRYUBVf/c041919b043510c50263bd537363309b/PrivComponent_art-M.jpg',
  description: `SimpliSafe Components`,
  originalHeight: 888,
  originalWidth: 1372
}

/**
 * ![Wireless Outdoor Camera](https://images.ctfassets.net/v6awd0kabi65/1XUCPkNJPce1S32Mc8WKRr/704234ef45643b3db8f091aa7889b11e/meet_outdoor_cam.jpg?w=120&h=120&fit=pad)
 *
 * Wireless Outdoor Camera
 *
 *
 */
export const IMG_1XUCPkNJPce1S32Mc8WKRr = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1XUCPkNJPce1S32Mc8WKRr/704234ef45643b3db8f091aa7889b11e/meet_outdoor_cam.jpg',
  description: ``,
  originalHeight: 1804,
  originalWidth: 2884
}

/**
 * ![Homepage - Hero - Tablet](https://images.ctfassets.net/v6awd0kabi65/1Guqt88IC0sjbsZvsHLJyU/205213a652cc31e158f7025e74784710/PartnerHero-T.jpg?w=120&h=120&fit=pad)
 *
 * Homepage - Hero - Tablet
 *
 * Whole home protection
 */
export const IMG_1Guqt88IC0sjbsZvsHLJyU = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1Guqt88IC0sjbsZvsHLJyU/205213a652cc31e158f7025e74784710/PartnerHero-T.jpg',
  description: `Whole home protection`,
  originalHeight: 2394,
  originalWidth: 4336
}

/**
 * ![SimpliSafe Window Decal](https://images.ctfassets.net/v6awd0kabi65/04W6LcpD6SlfjuJSPqBzJ/bdd18902c47c5f0dd0c7bde05475f0ac/Window_decal_image.png?w=120&h=120&fit=pad)
 *
 * SimpliSafe Window Decal
 *
 * SimpliSafe Window Decal
 */
export const IMG_04W6LcpD6SlfjuJSPqBzJ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/04W6LcpD6SlfjuJSPqBzJ/bdd18902c47c5f0dd0c7bde05475f0ac/Window_decal_image.png',
  description: `SimpliSafe Window Decal`,
  originalHeight: 640,
  originalWidth: 640
}

/**
 * ![Dogs with Products Hero - Mobile](https://images.ctfassets.net/v6awd0kabi65/7m29lk4BFjhdmY4DMAfjUO/4bfe327f575ce35289df89e31f721bba/NEW_MOBILE_PALS.png?w=120&h=120&fit=pad)
 *
 * Dogs with Products Hero - Mobile
 *
 *
 */
export const IMG_7m29lk4BFjhdmY4DMAfjUO = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7m29lk4BFjhdmY4DMAfjUO/4bfe327f575ce35289df89e31f721bba/NEW_MOBILE_PALS.png',
  description: ``,
  originalHeight: 1992,
  originalWidth: 2400
}

/**
 * ![Dog + House - Mobile](https://images.ctfassets.net/v6awd0kabi65/6Qw68T0TbpL6hgNfTsX2by/4b3b9b57544d783f6b6f049fd1bf7d32/Brutus_House_Mobile.png?w=120&h=120&fit=pad)
 *
 * Dog + House - Mobile
 *
 *
 */
export const IMG_6Qw68T0TbpL6hgNfTsX2by = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6Qw68T0TbpL6hgNfTsX2by/4b3b9b57544d783f6b6f049fd1bf7d32/Brutus_House_Mobile.png',
  description: ``,
  originalHeight: 1992,
  originalWidth: 2413
}

/**
 * ![Why is my smoke detector beeping? Reasons and quick fixes ](https://images.ctfassets.net/v6awd0kabi65/2cgvhUxo66LaQhGsEpuDbp/36cf655d13fa67f6042b9943fe88a654/Untitled_design__8_.png?w=120&h=120&fit=pad)
 *
 * Why is my smoke detector beeping? Reasons and quick fixes
 *
 *
 */
export const IMG_2cgvhUxo66LaQhGsEpuDbp = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2cgvhUxo66LaQhGsEpuDbp/36cf655d13fa67f6042b9943fe88a654/Untitled_design__8_.png',
  description: ``,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Dog + House - Desktop](https://images.ctfassets.net/v6awd0kabi65/36BbnfhJwix2QwD34NJrRI/a58f3929ce564744f99d641f54af3503/Variation_2_Desktop_NEW.png?w=120&h=120&fit=pad)
 *
 * Dog + House - Desktop
 *
 *
 */
export const IMG_36BbnfhJwix2QwD34NJrRI = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/36BbnfhJwix2QwD34NJrRI/a58f3929ce564744f99d641f54af3503/Variation_2_Desktop_NEW.png',
  description: ``,
  originalHeight: 1300,
  originalWidth: 2880
}

/**
 * ![Dogs with Products Hero - Desktop](https://images.ctfassets.net/v6awd0kabi65/OmGuri91kWQCzIW04VEeV/1a6ea85d8caddec19f65f0ea2e846970/Variation_1_Desktop_NEW.png?w=120&h=120&fit=pad)
 *
 * Dogs with Products Hero - Desktop
 *
 *
 */
export const IMG_OmGuri91kWQCzIW04VEeV = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/OmGuri91kWQCzIW04VEeV/1a6ea85d8caddec19f65f0ea2e846970/Variation_1_Desktop_NEW.png',
  description: ``,
  originalHeight: 1300,
  originalWidth: 2880
}

/**
 * ![Dog + House - Tablet](https://images.ctfassets.net/v6awd0kabi65/3uidtyeXr8pPvq8FAJo6mc/84dfdfe119830bfcab5ffdb9e7051753/Variation_2_Tablet_240870_BRND_COTG_BrutusHouse.png?w=120&h=120&fit=pad)
 *
 * Dog + House - Tablet
 *
 *
 */
export const IMG_3uidtyeXr8pPvq8FAJo6mc = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3uidtyeXr8pPvq8FAJo6mc/84dfdfe119830bfcab5ffdb9e7051753/Variation_2_Tablet_240870_BRND_COTG_BrutusHouse.png',
  description: ``,
  originalHeight: 1200,
  originalWidth: 2173
}

/**
 * ![Dogs with Products Hero - Tablet](https://images.ctfassets.net/v6awd0kabi65/300Y6PK5NYAf1O7rzzNl0a/23a8d8e3e914a4bbd682904d681778e5/Variation_1_Tablet_240870_BRND_COTG_Pals_screenfix.png?w=120&h=120&fit=pad)
 *
 * Dogs with Products Hero - Tablet
 *
 *
 */
export const IMG_300Y6PK5NYAf1O7rzzNl0a = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/300Y6PK5NYAf1O7rzzNl0a/23a8d8e3e914a4bbd682904d681778e5/Variation_1_Tablet_240870_BRND_COTG_Pals_screenfix.png',
  description: ``,
  originalHeight: 1200,
  originalWidth: 2173
}

/**
 * ![A Guide to Motion Detectors: How They Work](https://images.ctfassets.net/v6awd0kabi65/4Ve6H8Q4MCAXbf4c4irRzE/45b97c0ae5541b75ed09660f18547e23/Spring_Product_Refresh_2022_-_Motion_Sensor_-_Balto_Day__1__1.jpg?w=120&h=120&fit=pad)
 *
 * A Guide to Motion Detectors: How They Work
 *
 *
 */
export const IMG_4Ve6H8Q4MCAXbf4c4irRzE = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4Ve6H8Q4MCAXbf4c4irRzE/45b97c0ae5541b75ed09660f18547e23/Spring_Product_Refresh_2022_-_Motion_Sensor_-_Balto_Day__1__1.jpg',
  description: ``,
  originalHeight: 2250,
  originalWidth: 3000
}

/**
 * ![DIY home security system keypad](https://images.ctfassets.net/v6awd0kabi65/8uzs6yLPFNVmlmAQoOEc7/b74c83f2107d5b66317384190eb5aa60/Keypad_1.jpg?w=120&h=120&fit=pad)
 *
 * DIY home security system keypad
 *
 *
 */
export const IMG_8uzs6yLPFNVmlmAQoOEc7 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/8uzs6yLPFNVmlmAQoOEc7/b74c83f2107d5b66317384190eb5aa60/Keypad_1.jpg',
  description: ``,
  originalHeight: 2000,
  originalWidth: 3000
}

/**
 * ![What's the difference between robbery & burglary?](https://images.ctfassets.net/v6awd0kabi65/4AeM6Z1QcGcjnbu73uzP4F/b8c347e5586c858c344b900fb11d30bc/Spring_Product_Refresh_2022_-_Outdoor_-_Shield_Camera_at_Night.jpg?w=120&h=120&fit=pad)
 *
 * What's the difference between robbery & burglary?
 *
 *
 */
export const IMG_4AeM6Z1QcGcjnbu73uzP4F = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4AeM6Z1QcGcjnbu73uzP4F/b8c347e5586c858c344b900fb11d30bc/Spring_Product_Refresh_2022_-_Outdoor_-_Shield_Camera_at_Night.jpg',
  description: ``,
  originalHeight: 2250,
  originalWidth: 3000
}

/**
 * ![How to prevent your home from flooding](https://images.ctfassets.net/v6awd0kabi65/4Ov7YUyJ2JQwnZqg1Gq9Tx/277740ed3ee2ceef1754a7bd5ecdae8d/Water_Sensor_0461_F_8bit-min.jpg?w=120&h=120&fit=pad)
 *
 * How to prevent your home from flooding
 *
 *
 */
export const IMG_4Ov7YUyJ2JQwnZqg1Gq9Tx = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4Ov7YUyJ2JQwnZqg1Gq9Tx/277740ed3ee2ceef1754a7bd5ecdae8d/Water_Sensor_0461_F_8bit-min.jpg',
  description: ``,
  originalHeight: 2001,
  originalWidth: 3000
}

/**
 * ![Homeowner Holding Phone 1443 F 16bit snooze](https://images.ctfassets.net/v6awd0kabi65/7hwKBk8sf6UIzV1PBI8M9d/716fe4b03ad402d9470098e638eb74a7/Homeowner_Holding_Phone_1443_F_16bit_snooze.jpg?w=120&h=120&fit=pad)
 *
 * Homeowner Holding Phone 1443 F 16bit snooze
 *
 *
 */
export const IMG_7hwKBk8sf6UIzV1PBI8M9d = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7hwKBk8sf6UIzV1PBI8M9d/716fe4b03ad402d9470098e638eb74a7/Homeowner_Holding_Phone_1443_F_16bit_snooze.jpg',
  description: ``,
  originalHeight: 2001,
  originalWidth: 3000
}

/**
 * ![Spring Product Refresh 2022 - Keypad at Night](https://images.ctfassets.net/v6awd0kabi65/2kKOgZtRuxp8IbzLGdXc8D/b0affa98641a2b650f12a4c4c3f65b5b/Spring_Product_Refresh_2022_-_Keypad_at_Night-min.jpg?w=120&h=120&fit=pad)
 *
 * Spring Product Refresh 2022 - Keypad at Night
 *
 *
 */
export const IMG_2kKOgZtRuxp8IbzLGdXc8D = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2kKOgZtRuxp8IbzLGdXc8D/b0affa98641a2b650f12a4c4c3f65b5b/Spring_Product_Refresh_2022_-_Keypad_at_Night-min.jpg',
  description: ``,
  originalHeight: 2250,
  originalWidth: 3000
}

/**
 * ![Copy of Low Res-Spring Product Refresh 2022 - Keypad at Night](https://images.ctfassets.net/v6awd0kabi65/2AImyjQvNmK5KDcDlRZhAE/3728f0bdbd900b22cab41b1765ad55df/Copy_of_Low_Res-Spring_Product_Refresh_2022_-_Keypad_at_Night-min.jpg?w=120&h=120&fit=pad)
 *
 * Copy of Low Res-Spring Product Refresh 2022 - Keypad at Night
 *
 *
 */
export const IMG_2AImyjQvNmK5KDcDlRZhAE = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2AImyjQvNmK5KDcDlRZhAE/3728f0bdbd900b22cab41b1765ad55df/Copy_of_Low_Res-Spring_Product_Refresh_2022_-_Keypad_at_Night-min.jpg',
  description: ``,
  originalHeight: 2250,
  originalWidth: 3000
}

/**
 * ![237092 ODM Beta ProductImagery Intruder 2 Front Yard SS3 2084](https://images.ctfassets.net/v6awd0kabi65/2GkhPsa8ywIAXVckCmRj6p/313e23bf030cc7eeae537e3a7ed75d69/237092_ODM_Beta_ProductImagery_Intruder_2_Front_Yard_SS3_2084-min.jpg?w=120&h=120&fit=pad)
 *
 * 237092 ODM Beta ProductImagery Intruder 2 Front Yard SS3 2084
 *
 *
 */
export const IMG_2GkhPsa8ywIAXVckCmRj6p = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2GkhPsa8ywIAXVckCmRj6p/313e23bf030cc7eeae537e3a7ed75d69/237092_ODM_Beta_ProductImagery_Intruder_2_Front_Yard_SS3_2084-min.jpg',
  description: ``,
  originalHeight: 2001,
  originalWidth: 3000
}

/**
 * ![Choosing a Safe Word & Other Aspects of Professional Monitoring](https://images.ctfassets.net/v6awd0kabi65/2m6yNf3tkiwENfNa1HgYsl/44f8b7c1fb62a838e2fb4e8bd99759a9/Homeowner_Holding_Phone_1443_F_8bit.jpg?w=120&h=120&fit=pad)
 *
 * Choosing a Safe Word & Other Aspects of Professional Monitoring
 *
 *
 */
export const IMG_2m6yNf3tkiwENfNa1HgYsl = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2m6yNf3tkiwENfNa1HgYsl/44f8b7c1fb62a838e2fb4e8bd99759a9/Homeowner_Holding_Phone_1443_F_8bit.jpg',
  description: ``,
  originalHeight: 2001,
  originalWidth: 3000
}

/**
 * ![Installing and Removing SimpliSafe Sensors: A Comprehensive Guide](https://images.ctfassets.net/v6awd0kabi65/60Cc1I9MYSpBRJHXO1tNjT/db8144c3ffc782d3cf40b763b5ff646d/Spring_Product_Refresh_2022_-_Motion_Sensor_-_Balto_Day-min.jpg?w=120&h=120&fit=pad)
 *
 * Installing and Removing SimpliSafe Sensors: A Comprehensive Guide
 *
 *
 */
export const IMG_60Cc1I9MYSpBRJHXO1tNjT = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/60Cc1I9MYSpBRJHXO1tNjT/db8144c3ffc782d3cf40b763b5ff646d/Spring_Product_Refresh_2022_-_Motion_Sensor_-_Balto_Day-min.jpg',
  description: ``,
  originalHeight: 2250,
  originalWidth: 3000
}

/**
 * ![What Are the Benefits of a Smart Smoke Detector?](https://images.ctfassets.net/v6awd0kabi65/4b8Hd4smM7PaAwhnlbs6el/86d160e45f0139c24daf3ed33eaff713/Red_Bedroom_Wide_1360_F_8bit.jpg?w=120&h=120&fit=pad)
 *
 * What Are the Benefits of a Smart Smoke Detector?
 *
 *
 */
export const IMG_4b8Hd4smM7PaAwhnlbs6el = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4b8Hd4smM7PaAwhnlbs6el/86d160e45f0139c24daf3ed33eaff713/Red_Bedroom_Wide_1360_F_8bit.jpg',
  description: ``,
  originalHeight: 2192,
  originalWidth: 3000
}

/**
 * ![237134 PMK Spring2024-ODM BRAUN ODM MonitoringStation Shot 03 2642 CSR Edit](https://images.ctfassets.net/v6awd0kabi65/2lrh9wlqtzr4kpBRhwfCFL/9a007896bc6af0b4012c2d983f2af005/237134_PMK_Spring2024-ODM_BRAUN_ODM_MonitoringStation_Shot_03_2642_CSR_Edit.jpg?w=120&h=120&fit=pad)
 *
 * 237134 PMK Spring2024-ODM BRAUN ODM MonitoringStation Shot 03 2642 CSR Edit
 *
 *
 */
export const IMG_2lrh9wlqtzr4kpBRhwfCFL = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2lrh9wlqtzr4kpBRhwfCFL/9a007896bc6af0b4012c2d983f2af005/237134_PMK_Spring2024-ODM_BRAUN_ODM_MonitoringStation_Shot_03_2642_CSR_Edit.jpg',
  description: ``,
  originalHeight: 2001,
  originalWidth: 3000
}

/**
 * ![Home security essentials: How to make your home safer ](https://images.ctfassets.net/v6awd0kabi65/1jh5FCPDZy7iZkkQWnB0kJ/93bf154dd5f4439cbeaa11f56e74bee9/Untitled_design__7_.png?w=120&h=120&fit=pad)
 *
 * Home security essentials: How to make your home safer
 *
 * Hoping to level up your home security? Deter burglars and keep your home, family and valuables safe with these 15 home security essentials.
 */
export const IMG_1jh5FCPDZy7iZkkQWnB0kJ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1jh5FCPDZy7iZkkQWnB0kJ/93bf154dd5f4439cbeaa11f56e74bee9/Untitled_design__7_.png',
  description: `Hoping to level up your home security? Deter burglars and keep your home, family and valuables safe with these 15 home security essentials.`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![SL Series 2 Carousel 4](https://images.ctfassets.net/v6awd0kabi65/1uHYI1zrJQAwDhZWkiAgWu/3bf7dd628753f4906cde74d570232bac/Braun_4FW.jpg?w=120&h=120&fit=pad)
 *
 * SL Series 2 Carousel 4
 *
 *
 */
export const IMG_1uHYI1zrJQAwDhZWkiAgWu = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1uHYI1zrJQAwDhZWkiAgWu/3bf7dd628753f4906cde74d570232bac/Braun_4FW.jpg',
  description: ``,
  originalHeight: 1323,
  originalWidth: 1677
}

/**
 * ![30 best true crime books](https://images.ctfassets.net/v6awd0kabi65/4NiKh7TyM5sN7wzIxsQMQc/53c9c136aa0698b34ab5fa398a157aa2/tom-hermans-9BoqXzEeQqM-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * 30 best true crime books
 *
 * Are you a true crime lover? Check out our list of the 30 best true crime books to enjoy from the comfort and security of your own home.
 */
export const IMG_4NiKh7TyM5sN7wzIxsQMQc = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4NiKh7TyM5sN7wzIxsQMQc/53c9c136aa0698b34ab5fa398a157aa2/tom-hermans-9BoqXzEeQqM-unsplash.jpg',
  description: `Are you a true crime lover? Check out our list of the 30 best true crime books to enjoy from the comfort and security of your own home.`,
  originalHeight: 4000,
  originalWidth: 6000
}

/**
 * ![BMS v3 - Carousel - Outdoor Camera (Shield) - Image 1](https://images.ctfassets.net/v6awd0kabi65/4I1vglZoBcswWLTzwo4DZd/cd434032593b9a08128c0c02db3575df/Shield_1FW.jpg?w=120&h=120&fit=pad)
 *
 * BMS v3 - Carousel - Outdoor Camera (Shield) - Image 1
 *
 * BMS v3 - Carousel - Outdoor Camera (Shield) - Image 1
 */
export const IMG_4I1vglZoBcswWLTzwo4DZd = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4I1vglZoBcswWLTzwo4DZd/cd434032593b9a08128c0c02db3575df/Shield_1FW.jpg',
  description: `BMS v3 - Carousel - Outdoor Camera (Shield) - Image 1`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![HowItWorks](https://images.ctfassets.net/v6awd0kabi65/3Cu8ppHCFxqlm7A92TeWPx/cf2fe5737def6148cc0e070dda5edb87/HowItWorks.jpg?w=120&h=120&fit=pad)
 *
 * HowItWorks
 *
 *
 */
export const IMG_3Cu8ppHCFxqlm7A92TeWPx = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3Cu8ppHCFxqlm7A92TeWPx/cf2fe5737def6148cc0e070dda5edb87/HowItWorks.jpg',
  description: ``,
  originalHeight: 1380,
  originalWidth: 2000
}

/**
 * ![meet hero](https://images.ctfassets.net/v6awd0kabi65/2bsC744tsES9ho29dx2j5z/86e7a6be4fef3607f5048df70d7295c4/meet_hero.jpg?w=120&h=120&fit=pad)
 *
 * meet hero
 *
 *
 */
export const IMG_2bsC744tsES9ho29dx2j5z = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2bsC744tsES9ho29dx2j5z/86e7a6be4fef3607f5048df70d7295c4/meet_hero.jpg',
  description: ``,
  originalHeight: 2250,
  originalWidth: 4336
}

/**
 * ![Product - Outdoor Camera Bundle - Carousel Thumbnail Image 2](https://images.ctfassets.net/v6awd0kabi65/7DWaYLIfgAwWJ5IjGql0i2/dacd229a8fd6d29567a361b70b9e8509/Thumbnail__3_.jpg?w=120&h=120&fit=pad)
 *
 * Product - Outdoor Camera Bundle - Carousel Thumbnail Image 2
 *
 * Crisp HD video, day or night
 */
export const IMG_7DWaYLIfgAwWJ5IjGql0i2 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7DWaYLIfgAwWJ5IjGql0i2/dacd229a8fd6d29567a361b70b9e8509/Thumbnail__3_.jpg',
  description: `Crisp HD video, day or night`,
  originalHeight: 484,
  originalWidth: 484
}

/**
 * ![Product - Outdoor Camera Bundle - Carousel Image 5](https://images.ctfassets.net/v6awd0kabi65/3jGtyS4X4lrzmpY3gxQfeq/2f7f6b72fc1a4df4165eb9530674a10b/Carousel_1_19.png?w=120&h=120&fit=pad)
 *
 * Product - Outdoor Camera Bundle - Carousel Image 5
 *
 * Install with rechargable battery or power cable
 */
export const IMG_3jGtyS4X4lrzmpY3gxQfeq = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3jGtyS4X4lrzmpY3gxQfeq/2f7f6b72fc1a4df4165eb9530674a10b/Carousel_1_19.png',
  description: `Install with rechargable battery or power cable`,
  originalHeight: 1200,
  originalWidth: 1278
}

/**
 * ![Product - Outdoor Camera Bundle - Carousel Image 4](https://images.ctfassets.net/v6awd0kabi65/4bwZJr9wbI3bOlPqGoAlwB/0643262bfa42bd24b648b432fa0938d7/Carousel_1_18.png?w=120&h=120&fit=pad)
 *
 * Product - Outdoor Camera Bundle - Carousel Image 4
 *
 * Withstands snow, rain, and extreme temperatures
 */
export const IMG_4bwZJr9wbI3bOlPqGoAlwB = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4bwZJr9wbI3bOlPqGoAlwB/0643262bfa42bd24b648b432fa0938d7/Carousel_1_18.png',
  description: `Withstands snow, rain, and extreme temperatures`,
  originalHeight: 1200,
  originalWidth: 1278
}

/**
 * ![Product - Outdoor Camera Bundle - Carousel Image 3](https://images.ctfassets.net/v6awd0kabi65/3kYqoreVvYg9qaWPK2g2er/f8d5776816d6a6cfdcabcd357747aac6/Carousel_1_17.png?w=120&h=120&fit=pad)
 *
 * Product - Outdoor Camera Bundle - Carousel Image 3
 *
 * Startle intruders with motion-activated spotlight
 */
export const IMG_3kYqoreVvYg9qaWPK2g2er = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3kYqoreVvYg9qaWPK2g2er/f8d5776816d6a6cfdcabcd357747aac6/Carousel_1_17.png',
  description: `Startle intruders with motion-activated spotlight`,
  originalHeight: 1200,
  originalWidth: 1278
}

/**
 * ![Product - Outdoor Camera Bundle - Carousel Image 2](https://images.ctfassets.net/v6awd0kabi65/1HBDQCjTpPErWIB2n2Gjo1/c6bf53d0720b71baa665bcd378d7f7a3/Carousel_1_16.png?w=120&h=120&fit=pad)
 *
 * Product - Outdoor Camera Bundle - Carousel Image 2
 *
 * Crisp HD video, day or night
 */
export const IMG_1HBDQCjTpPErWIB2n2Gjo1 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1HBDQCjTpPErWIB2n2Gjo1/c6bf53d0720b71baa665bcd378d7f7a3/Carousel_1_16.png',
  description: `Crisp HD video, day or night`,
  originalHeight: 1200,
  originalWidth: 1278
}

/**
 * ![Product - Outdoor Camera Bundle - Carousel Image 1](https://images.ctfassets.net/v6awd0kabi65/1DEvAHO2jdadOFNp1wdInb/766fb133537842138eeb25424d7df567/Carousel_1_20.jpg?w=120&h=120&fit=pad)
 *
 * Product - Outdoor Camera Bundle - Carousel Image 1
 *
 * The outdoor camera over a blue background
 */
export const IMG_1DEvAHO2jdadOFNp1wdInb = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1DEvAHO2jdadOFNp1wdInb/766fb133537842138eeb25424d7df567/Carousel_1_20.jpg',
  description: `The outdoor camera over a blue background`,
  originalHeight: 1800,
  originalWidth: 1917
}

/**
 * ![Product - Outdoor Camera Bundle - Carousel Thumbnail Image 5](https://images.ctfassets.net/v6awd0kabi65/2nFCaOTtYll8lKYqAvmgWt/5f26b49f6ddc4a72a1f81d518095f52c/DH25_LG_20008_R_1.jpg?w=120&h=120&fit=pad)
 *
 * Product - Outdoor Camera Bundle - Carousel Thumbnail Image 5
 *
 * Install with rechargable battery or power cable
 */
export const IMG_2nFCaOTtYll8lKYqAvmgWt = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2nFCaOTtYll8lKYqAvmgWt/5f26b49f6ddc4a72a1f81d518095f52c/DH25_LG_20008_R_1.jpg',
  description: `Install with rechargable battery or power cable`,
  originalHeight: 484,
  originalWidth: 484
}

/**
 * ![Product - Outdoor Camera Bundle - Carousel Thumbnail Image 4](https://images.ctfassets.net/v6awd0kabi65/1cjULipSu93pzlb9cLYmGp/f074996cc2c2b0804d5a938967dc7b86/237134_PMK_Spring2024-ODM_BRAUN_Olympus_Wireless_AM_0511_FNL_1.jpg?w=120&h=120&fit=pad)
 *
 * Product - Outdoor Camera Bundle - Carousel Thumbnail Image 4
 *
 * Withstands snow, rain, and extreme temperatures
 */
export const IMG_1cjULipSu93pzlb9cLYmGp = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1cjULipSu93pzlb9cLYmGp/f074996cc2c2b0804d5a938967dc7b86/237134_PMK_Spring2024-ODM_BRAUN_Olympus_Wireless_AM_0511_FNL_1.jpg',
  description: `Withstands snow, rain, and extreme temperatures`,
  originalHeight: 484,
  originalWidth: 508
}

/**
 * ![Product - Outdoor Camera Bundle - Carousel Thumbnail Image 3](https://images.ctfassets.net/v6awd0kabi65/4QvH6twHUs3cme9ofpKDPs/21e15dce0e33a7257d3684db140ca0fd/ImgGallery_Scout-4_1.jpg?w=120&h=120&fit=pad)
 *
 * Product - Outdoor Camera Bundle - Carousel Thumbnail Image 3
 *
 * Startle intruders with motion-activated spotlight
 */
export const IMG_4QvH6twHUs3cme9ofpKDPs = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4QvH6twHUs3cme9ofpKDPs/21e15dce0e33a7257d3684db140ca0fd/ImgGallery_Scout-4_1.jpg',
  description: `Startle intruders with motion-activated spotlight`,
  originalHeight: 484,
  originalWidth: 484
}

/**
 * ![Product - Outdoor Camera Bundle - Carousel Thumbnail Image 1](https://images.ctfassets.net/v6awd0kabi65/58khik8xgymaT8FT6XlYj7/4f4eb9eddc7f0cffb69290248c6ffd0f/Thumbnail_1.jpg?w=120&h=120&fit=pad)
 *
 * Product - Outdoor Camera Bundle - Carousel Thumbnail Image 1
 *
 * The outdoor camera over a blue background
 */
export const IMG_58khik8xgymaT8FT6XlYj7 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/58khik8xgymaT8FT6XlYj7/4f4eb9eddc7f0cffb69290248c6ffd0f/Thumbnail_1.jpg',
  description: `The outdoor camera over a blue background`,
  originalHeight: 484,
  originalWidth: 484
}

/**
 * ![ID Number Location](https://images.ctfassets.net/v6awd0kabi65/7oFzASS9ZQX6thaINKKIjY/1c99edbabd53f537a3e0d307f7f6095c/image_17.png?w=120&h=120&fit=pad)
 *
 * ID Number Location
 *
 * ID badge with ID number location highlighted
 */
export const IMG_7oFzASS9ZQX6thaINKKIjY = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7oFzASS9ZQX6thaINKKIjY/1c99edbabd53f537a3e0d307f7f6095c/image_17.png',
  description: `ID badge with ID number location highlighted`,
  originalHeight: 855,
  originalWidth: 555
}

/**
 * ![Header | Professional Monitoring](https://images.ctfassets.net/v6awd0kabi65/3X477mLg2byYfBD0MzmdMe/ccb844f5bdcb60a065f6ebe45cc27fe4/Nav_monitorAsset_3x.png?w=120&h=120&fit=pad)
 *
 * Header | Professional Monitoring
 *
 * 24/7 security monitoring
 */
export const IMG_3X477mLg2byYfBD0MzmdMe = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3X477mLg2byYfBD0MzmdMe/ccb844f5bdcb60a065f6ebe45cc27fe4/Nav_monitorAsset_3x.png',
  description: `24/7 security monitoring`,
  originalHeight: 702,
  originalWidth: 1050
}

/**
 * ![USAA Outdoor Kit](https://images.ctfassets.net/v6awd0kabi65/78b8yYarkwj41igr7XqVlx/bee9ece28b91010e7f35dffce8636569/large-USAA-ODMON-Kit-Flat-Lay2.png?w=120&h=120&fit=pad)
 *
 * USAA Outdoor Kit
 *
 * USAA Outdoor Kit Image
 */
export const IMG_78b8yYarkwj41igr7XqVlx = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/78b8yYarkwj41igr7XqVlx/bee9ece28b91010e7f35dffce8636569/large-USAA-ODMON-Kit-Flat-Lay2.png',
  description: `USAA Outdoor Kit Image`,
  originalHeight: 1039,
  originalWidth: 1280
}

/**
 * ![OnTech](https://images.ctfassets.net/v6awd0kabi65/1wrcWRzpeRNdU29IH14EFi/7a525a3c17c74feb5888afec287e0159/OnTech.jpg?w=120&h=120&fit=pad)
 *
 * OnTech
 *
 *
 */
export const IMG_1wrcWRzpeRNdU29IH14EFi = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1wrcWRzpeRNdU29IH14EFi/7a525a3c17c74feb5888afec287e0159/OnTech.jpg',
  description: ``,
  originalHeight: 1024,
  originalWidth: 1272
}

/**
 * ![SelfInstall](https://images.ctfassets.net/v6awd0kabi65/6N0VU9h6zijI3V3zoZfeVr/91cf6bfc62337743aee395f88b547de9/SelfInstall.jpg?w=120&h=120&fit=pad)
 *
 * SelfInstall
 *
 *
 */
export const IMG_6N0VU9h6zijI3V3zoZfeVr = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6N0VU9h6zijI3V3zoZfeVr/91cf6bfc62337743aee395f88b547de9/SelfInstall.jpg',
  description: ``,
  originalHeight: 1024,
  originalWidth: 1272
}

/**
 * ![Smart Lock Series 2 (Transparent) ](https://images.ctfassets.net/v6awd0kabi65/kaGvUKj1O4nvbEZheyTcg/e59cb98c49aeca472ac3d82e4cfd59ab/Braun_white.png?w=120&h=120&fit=pad)
 *
 * Smart Lock Series 2 (Transparent)
 *
 *
 */
export const IMG_kaGvUKj1O4nvbEZheyTcg = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/kaGvUKj1O4nvbEZheyTcg/e59cb98c49aeca472ac3d82e4cfd59ab/Braun_white.png',
  description: ``,
  originalHeight: 640,
  originalWidth: 480
}

/**
 * ![Smart Lock Series 2 - Product Modal](https://images.ctfassets.net/v6awd0kabi65/6LpumkPs5ydUD4daKScGYZ/3e33d9e6a481830473f20fdb3bb51f28/1fa6d47c677d6af805776e2da4a9c26d.jpeg?w=120&h=120&fit=pad)
 *
 * Smart Lock Series 2 - Product Modal
 *
 * Smart Lock Series 2 - Product Modal
 */
export const IMG_6LpumkPs5ydUD4daKScGYZ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6LpumkPs5ydUD4daKScGYZ/3e33d9e6a481830473f20fdb3bb51f28/1fa6d47c677d6af805776e2da4a9c26d.jpeg',
  description: `Smart Lock Series 2 - Product Modal`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Beyond the Doorbell: Why You Need a Complete Home Security System](https://images.ctfassets.net/v6awd0kabi65/1EXXD8rn6lAJQhhL9ChbeE/133dbcff62b2cb254fc7cfc8dfc7a5e0/image__51___1_.png?w=120&h=120&fit=pad)
 *
 * Beyond the Doorbell: Why You Need a Complete Home Security System
 *
 * A video doorbell is a good start, but it's not enough to fully protect your home. Discover why you need a complete home security system like SimpliSafe, including sensors for fire, flood, and intrusion detection, for comprehensive peace of mind.
 */
export const IMG_1EXXD8rn6lAJQhhL9ChbeE = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1EXXD8rn6lAJQhhL9ChbeE/133dbcff62b2cb254fc7cfc8dfc7a5e0/image__51___1_.png',
  description: `A video doorbell is a good start, but it's not enough to fully protect your home. Discover why you need a complete home security system like SimpliSafe, including sensors for fire, flood, and intrusion detection, for comprehensive peace of mind.`,
  originalHeight: 1095,
  originalWidth: 1321
}

/**
 * ![Pro Monitoring Agent - Outdoor Security Camera Bundle](https://images.ctfassets.net/v6awd0kabi65/4pAzHQAw6gxkNuJLTQwUJg/62f57a4b6701d2bcd08cd1f8ab4774d8/pro-mon-agent.jpg?w=120&h=120&fit=pad)
 *
 * Pro Monitoring Agent - Outdoor Security Camera Bundle
 *
 *
 */
export const IMG_4pAzHQAw6gxkNuJLTQwUJg = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4pAzHQAw6gxkNuJLTQwUJg/62f57a4b6701d2bcd08cd1f8ab4774d8/pro-mon-agent.jpg',
  description: ``,
  originalHeight: 794,
  originalWidth: 1262
}

/**
 * ![App Widget Image - Settings - Outdoor Security Camera Bundle](https://images.ctfassets.net/v6awd0kabi65/53e2FVktkz4bsGmIGa9suc/13821b28c41b0ccaa3753915a4ea99cf/app-widget-4.png?w=120&h=120&fit=pad)
 *
 * App Widget Image - Settings - Outdoor Security Camera Bundle
 *
 *
 */
export const IMG_53e2FVktkz4bsGmIGa9suc = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/53e2FVktkz4bsGmIGa9suc/13821b28c41b0ccaa3753915a4ea99cf/app-widget-4.png',
  description: ``,
  originalHeight: 1254,
  originalWidth: 1000
}

/**
 * ![App Widget Image - Motion - Outdoor Security Camera Bundle](https://images.ctfassets.net/v6awd0kabi65/okxX3BMAxg8ABOIjquNTc/fedfd1f32a26fb4b3f02c7551d3cfed2/app-widget-3.png?w=120&h=120&fit=pad)
 *
 * App Widget Image - Motion - Outdoor Security Camera Bundle
 *
 *
 */
export const IMG_okxX3BMAxg8ABOIjquNTc = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/okxX3BMAxg8ABOIjquNTc/fedfd1f32a26fb4b3f02c7551d3cfed2/app-widget-3.png',
  description: ``,
  originalHeight: 1254,
  originalWidth: 1000
}

/**
 * ![App Widget Image - Alerts - Outdoor Security Camera Bundle](https://images.ctfassets.net/v6awd0kabi65/4kPMexQOnJlGxncCPQ7erF/791f8a7161cc4af521d1de58f0eac844/app-widget-2.png?w=120&h=120&fit=pad)
 *
 * App Widget Image - Alerts - Outdoor Security Camera Bundle
 *
 *
 */
export const IMG_4kPMexQOnJlGxncCPQ7erF = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4kPMexQOnJlGxncCPQ7erF/791f8a7161cc4af521d1de58f0eac844/app-widget-2.png',
  description: ``,
  originalHeight: 1254,
  originalWidth: 1000
}

/**
 * ![App Widget Image - Live feed - Outdoor Security Camera Bundle](https://images.ctfassets.net/v6awd0kabi65/4p0k5gXw2dyvhtmM7jzigG/87567228b69cf8f56dee02682dafd5ad/app-widget-1.png?w=120&h=120&fit=pad)
 *
 * App Widget Image - Live feed - Outdoor Security Camera Bundle
 *
 *
 */
export const IMG_4p0k5gXw2dyvhtmM7jzigG = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4p0k5gXw2dyvhtmM7jzigG/87567228b69cf8f56dee02682dafd5ad/app-widget-1.png',
  description: ``,
  originalHeight: 1254,
  originalWidth: 1011
}

/**
 * ![Deter intruders before they get inside - Outdoor Security Camera Bundle](https://images.ctfassets.net/v6awd0kabi65/6RKCy8ghWyS8w8kYEzGic7/5daf1a0f63b4945d865b181a90977048/Deter_intruders_before_they_get_inside.jpg?w=120&h=120&fit=pad)
 *
 * Deter intruders before they get inside - Outdoor Security Camera Bundle
 *
 *
 */
export const IMG_6RKCy8ghWyS8w8kYEzGic7 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6RKCy8ghWyS8w8kYEzGic7/5daf1a0f63b4945d865b181a90977048/Deter_intruders_before_they_get_inside.jpg',
  description: ``,
  originalHeight: 794,
  originalWidth: 1262
}

/**
 * ![Capture it all, day and night - Outdoor Security Camera Bundle](https://images.ctfassets.net/v6awd0kabi65/7G7rIQKpFkA12BiWwXAQrt/76c1f874a9674bce7f29e65e628aa6d6/Capture_it_all__day_and_night.jpg?w=120&h=120&fit=pad)
 *
 * Capture it all, day and night - Outdoor Security Camera Bundle
 *
 *
 */
export const IMG_7G7rIQKpFkA12BiWwXAQrt = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7G7rIQKpFkA12BiWwXAQrt/76c1f874a9674bce7f29e65e628aa6d6/Capture_it_all__day_and_night.jpg',
  description: ``,
  originalHeight: 795,
  originalWidth: 1262
}

/**
 * ![Social media posts that help burglars](https://images.ctfassets.net/v6awd0kabi65/7EozImZt4duZ5F42NynIji/d3fdc4f756faef111974b379c8a6b9e7/pexels-kerde-severin-1542252__1_.jpg?w=120&h=120&fit=pad)
 *
 * Social media posts that help burglars
 *
 * Find out how social media posts can help burglars steal from your home, what burglars look for on social media, and how to protect yourself online.
 */
export const IMG_7EozImZt4duZ5F42NynIji = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7EozImZt4duZ5F42NynIji/d3fdc4f756faef111974b379c8a6b9e7/pexels-kerde-severin-1542252__1_.jpg',
  description: `Find out how social media posts can help burglars steal from your home, what burglars look for on social media, and how to protect yourself online.`,
  originalHeight: 2176,
  originalWidth: 3264
}

/**
 * ![How to Keep Your Home Secure in a Metro Area](https://images.ctfassets.net/v6awd0kabi65/4yHX4LnxSgxc6l0OivbqaF/28e3cec8690ae7eea41d5183f5231c81/mauro-mora-31-pOduwZGE-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * How to Keep Your Home Secure in a Metro Area
 *
 *
 */
export const IMG_4yHX4LnxSgxc6l0OivbqaF = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4yHX4LnxSgxc6l0OivbqaF/28e3cec8690ae7eea41d5183f5231c81/mauro-mora-31-pOduwZGE-unsplash.jpg',
  description: ``,
  originalHeight: 3343,
  originalWidth: 5016
}

/**
 * ![16 most common accidents at Christmas](https://images.ctfassets.net/v6awd0kabi65/7KcPNRqB7ecq4JfkrLWTAL/ebd6188c3f704b11a7cb759011269e43/Christmas-tree-lights.jpg?w=120&h=120&fit=pad)
 *
 * 16 most common accidents at Christmas
 *
 *
 */
export const IMG_7KcPNRqB7ecq4JfkrLWTAL = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7KcPNRqB7ecq4JfkrLWTAL/ebd6188c3f704b11a7cb759011269e43/Christmas-tree-lights.jpg',
  description: ``,
  originalHeight: 388,
  originalWidth: 585
}

/**
 * ![How to keep Christmas presents safe](https://images.ctfassets.net/v6awd0kabi65/5ggLQKG0iWcTzbmNfxgQS6/6af6ce9f7593e4796c30610bba3bbb08/festive-christmas-gift-stockcake.webp?w=120&h=120&fit=pad)
 *
 * How to keep Christmas presents safe
 *
 *
 */
export const IMG_5ggLQKG0iWcTzbmNfxgQS6 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5ggLQKG0iWcTzbmNfxgQS6/6af6ce9f7593e4796c30610bba3bbb08/festive-christmas-gift-stockcake.webp',
  description: ``,
  originalHeight: 408,
  originalWidth: 728
}

/**
 * ![how to report a break in to the police](https://images.ctfassets.net/v6awd0kabi65/2xO678dV5tTMavJYGfgO3i/3d826f70ffa51fab4aea3e8c8eeb29ac/police-4566193_1280__1_.jpg?w=120&h=120&fit=pad)
 *
 * how to report a break in to the police
 *
 *
 */
export const IMG_2xO678dV5tTMavJYGfgO3i = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2xO678dV5tTMavJYGfgO3i/3d826f70ffa51fab4aea3e8c8eeb29ac/police-4566193_1280__1_.jpg',
  description: ``,
  originalHeight: 853,
  originalWidth: 1280
}

/**
 * ![Beyond the doorbell](https://images.ctfassets.net/v6awd0kabi65/4yl0cIV5NqrPuWekohW6tz/d6935eaa1ced208fda6bd8d538bd28b2/Low_Res-Spring_Product_Refresh_2022_-_Video_Doorbell_Pro_Day.jpg?w=120&h=120&fit=pad)
 *
 * Beyond the doorbell
 *
 *
 */
export const IMG_4yl0cIV5NqrPuWekohW6tz = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4yl0cIV5NqrPuWekohW6tz/d6935eaa1ced208fda6bd8d538bd28b2/Low_Res-Spring_Product_Refresh_2022_-_Video_Doorbell_Pro_Day.jpg',
  description: ``,
  originalHeight: 8736,
  originalWidth: 11648
}

/**
 * ![AGOP Intruder Scan](https://images.ctfassets.net/v6awd0kabi65/6joVKaGHteJR5Rv1iEJZDU/83f35d0a5bd84d7fe3616be9102e111a/240358_Ecom_ODMON_Intruder.webp?w=120&h=120&fit=pad)
 *
 * AGOP Intruder Scan
 *
 *
 */
export const IMG_6joVKaGHteJR5Rv1iEJZDU = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6joVKaGHteJR5Rv1iEJZDU/83f35d0a5bd84d7fe3616be9102e111a/240358_Ecom_ODMON_Intruder.webp',
  description: ``,
  originalHeight: 794,
  originalWidth: 1244
}

/**
 * ![Motion Sensor vs. Water Sensor: Which should you choose?](https://images.ctfassets.net/v6awd0kabi65/7lTK4b2l6iEOK9uBaHL9Af/fd8643f759b82cfb225844f936b10ef9/SS-D1-353__2_.jpg?w=120&h=120&fit=pad)
 *
 * Motion Sensor vs. Water Sensor: Which should you choose?
 *
 * Compare motion sensors and water sensors to decide which is best for your home. Learn how each device works and their benefits, for whole home protection.
 */
export const IMG_7lTK4b2l6iEOK9uBaHL9Af = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7lTK4b2l6iEOK9uBaHL9Af/fd8643f759b82cfb225844f936b10ef9/SS-D1-353__2_.jpg',
  description: `Compare motion sensors and water sensors to decide which is best for your home. Learn how each device works and their benefits, for whole home protection.`,
  originalHeight: 3127,
  originalWidth: 4690
}

/**
 * ![8 home security New Year’s resolutions](https://images.ctfassets.net/v6awd0kabi65/2799Yp9v2fgk8tMHxDE0A5/5d04e243ca641fdf32b69e8fa4b2a096/annie-spratt-Ef1H5YTTmZ8-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * 8 home security New Year’s resolutions
 *
 * Discover our New Year's resolutions for enhancing home security and protecting your property. Read more for a safe and secure new year.
 */
export const IMG_2799Yp9v2fgk8tMHxDE0A5 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2799Yp9v2fgk8tMHxDE0A5/5d04e243ca641fdf32b69e8fa4b2a096/annie-spratt-Ef1H5YTTmZ8-unsplash.jpg',
  description: `Discover our New Year's resolutions for enhancing home security and protecting your property. Read more for a safe and secure new year. `,
  originalHeight: 2929,
  originalWidth: 4000
}

/**
 * ![App Control- Controls](https://images.ctfassets.net/v6awd0kabi65/4Z794ao9hfY826K8Tt4FXz/df24e43e75ad26de15cbd22b7ce46c23/AppScreenArt-Controls.png?w=120&h=120&fit=pad)
 *
 * App Control- Controls
 *
 *
 */
export const IMG_4Z794ao9hfY826K8Tt4FXz = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4Z794ao9hfY826K8Tt4FXz/df24e43e75ad26de15cbd22b7ce46c23/AppScreenArt-Controls.png',
  description: ``,
  originalHeight: 1254,
  originalWidth: 1001
}

/**
 * ![Understanding the Importance of Business Security](https://images.ctfassets.net/v6awd0kabi65/4O2iVvaaZEFQvqZ45ya6qu/5a09fe8597a846c814d77c1e5409b0bb/centre-for-ageing-better-ZlOlRnWk8zU-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * Understanding the Importance of Business Security
 *
 *
 */
export const IMG_4O2iVvaaZEFQvqZ45ya6qu = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4O2iVvaaZEFQvqZ45ya6qu/5a09fe8597a846c814d77c1e5409b0bb/centre-for-ageing-better-ZlOlRnWk8zU-unsplash.jpg',
  description: ``,
  originalHeight: 4024,
  originalWidth: 6046
}

/**
 * ![Essential Home Security Tips for Seniors](https://images.ctfassets.net/v6awd0kabi65/3FnWbMPN9JVeEeYzAGM5EO/e3d3fe2b68bec942fc323d654fa5d159/richard-sagredo-IzIERuIwJWo-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * Essential Home Security Tips for Seniors
 *
 *
 */
export const IMG_3FnWbMPN9JVeEeYzAGM5EO = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3FnWbMPN9JVeEeYzAGM5EO/e3d3fe2b68bec942fc323d654fa5d159/richard-sagredo-IzIERuIwJWo-unsplash.jpg',
  description: ``,
  originalHeight: 2454,
  originalWidth: 3068
}

/**
 * ![Visa Offer Redemption - BG Image (mobile)](https://images.ctfassets.net/v6awd0kabi65/3jetXNO1VJmKA82LyDOURi/974b3068e1dcd22e6dcd7ffb2b89885f/Visa_Hero_mobile.jpg?w=120&h=120&fit=pad)
 *
 * Visa Offer Redemption - BG Image (mobile)
 *
 *
 */
export const IMG_3jetXNO1VJmKA82LyDOURi = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3jetXNO1VJmKA82LyDOURi/974b3068e1dcd22e6dcd7ffb2b89885f/Visa_Hero_mobile.jpg',
  description: ``,
  originalHeight: 1924,
  originalWidth: 686
}

/**
 * ![Visa Offer Redemption - BG Image (tablet)](https://images.ctfassets.net/v6awd0kabi65/4zaw2ics3mtVtrebB6gfmb/c42fb9027d80a0943b9e4f7f336008c6/Visa_Hero_tablet.jpg?w=120&h=120&fit=pad)
 *
 * Visa Offer Redemption - BG Image (tablet)
 *
 *
 */
export const IMG_4zaw2ics3mtVtrebB6gfmb = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4zaw2ics3mtVtrebB6gfmb/c42fb9027d80a0943b9e4f7f336008c6/Visa_Hero_tablet.jpg',
  description: ``,
  originalHeight: 1224,
  originalWidth: 1890
}

/**
 * ![Visa Offer Redepmtion - Background Image](https://images.ctfassets.net/v6awd0kabi65/1MHTVk1jKz17LBmBDNUOm2/61b4d0c4b7b491941e96a8793fab7491/Visa_Hero_desktop.jpg?w=120&h=120&fit=pad)
 *
 * Visa Offer Redepmtion - Background Image
 *
 *
 */
export const IMG_1MHTVk1jKz17LBmBDNUOm2 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1MHTVk1jKz17LBmBDNUOm2/61b4d0c4b7b491941e96a8793fab7491/Visa_Hero_desktop.jpg',
  description: ``,
  originalHeight: 1300,
  originalWidth: 2732
}

/**
 * ![iPhoneX Basic Alarm Screen](https://images.ctfassets.net/v6awd0kabi65/4ju8RHivPNhZIeWF0WJ75X/d59499ce3b41e0179b10cd56e0281f3d/AppScreenArt-Alarms.png?w=120&h=120&fit=pad)
 *
 * iPhoneX Basic Alarm Screen
 *
 *
 */
export const IMG_4ju8RHivPNhZIeWF0WJ75X = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4ju8RHivPNhZIeWF0WJ75X/d59499ce3b41e0179b10cd56e0281f3d/AppScreenArt-Alarms.png',
  description: ``,
  originalHeight: 1254,
  originalWidth: 1001
}

/**
 * ![The Importance of Door Alarm Sensors for Home Security](https://images.ctfassets.net/v6awd0kabi65/44wOnRLcnDqDcQbLUVasFj/5dab276f4f4d58929a1ed16b25206d70/L1160432_edit.png?w=120&h=120&fit=pad)
 *
 * The Importance of Door Alarm Sensors for Home Security
 *
 *
 */
export const IMG_44wOnRLcnDqDcQbLUVasFj = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/44wOnRLcnDqDcQbLUVasFj/5dab276f4f4d58929a1ed16b25206d70/L1160432_edit.png',
  description: ``,
  originalHeight: 1334,
  originalWidth: 2000
}

/**
 * ![New Home Protection Kit](https://images.ctfassets.net/v6awd0kabi65/1laSfxGYMWcZfp0XC1fn4A/1e49cf262298f397d2aefb764455357f/GI-Anywhere_flat-lay.png?w=120&h=120&fit=pad)
 *
 * New Home Protection Kit
 *
 *
 */
export const IMG_1laSfxGYMWcZfp0XC1fn4A = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1laSfxGYMWcZfp0XC1fn4A/1e49cf262298f397d2aefb764455357f/GI-Anywhere_flat-lay.png',
  description: ``,
  originalHeight: 1559,
  originalWidth: 1920
}

/**
 * ![How to Protect Your Rental Properties](https://images.ctfassets.net/v6awd0kabi65/337reZNC4iUfSXNDtYfObF/6d1e6c4786c3b14945e968aaabc1f865/patrick-perkins-3wylDrjxH-E-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * How to Protect Your Rental Properties
 *
 *
 */
export const IMG_337reZNC4iUfSXNDtYfObF = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/337reZNC4iUfSXNDtYfObF/6d1e6c4786c3b14945e968aaabc1f865/patrick-perkins-3wylDrjxH-E-unsplash.jpg',
  description: ``,
  originalHeight: 2232,
  originalWidth: 3000
}

/**
 * ![Quiz Property Image](https://images.ctfassets.net/v6awd0kabi65/7bO64u6XmUiU9HojJJEE59/62809cbd490dde5943fde96ff0c24c9a/quiz-property.png?w=120&h=120&fit=pad)
 *
 * Quiz Property Image
 *
 * null
 */
export const IMG_7bO64u6XmUiU9HojJJEE59 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7bO64u6XmUiU9HojJJEE59/62809cbd490dde5943fde96ff0c24c9a/quiz-property.png',
  description: `null`,
  originalHeight: 578,
  originalWidth: 813
}

/**
 * ![ODMON Media page hero - Desktop](https://images.ctfassets.net/v6awd0kabi65/4FbPSUfcnyNQPiu1uGfoE2/2d366f760c941858185a168026fe7622/Desktop.png?w=120&h=120&fit=pad)
 *
 * ODMON Media page hero - Desktop
 *
 *
 */
export const IMG_4FbPSUfcnyNQPiu1uGfoE2 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4FbPSUfcnyNQPiu1uGfoE2/2d366f760c941858185a168026fe7622/Desktop.png',
  description: ``,
  originalHeight: 1306,
  originalWidth: 1498
}

/**
 * ![ODMON Media page hero - Mobile](https://images.ctfassets.net/v6awd0kabi65/DWCc4b5bEHgEX0GtZDFYl/f44c7c798bf922bd2a5aa6e7a06eea6a/mobile.png?w=120&h=120&fit=pad)
 *
 * ODMON Media page hero - Mobile
 *
 *
 */
export const IMG_DWCc4b5bEHgEX0GtZDFYl = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/DWCc4b5bEHgEX0GtZDFYl/f44c7c798bf922bd2a5aa6e7a06eea6a/mobile.png',
  description: ``,
  originalHeight: 1219,
  originalWidth: 1355
}

/**
 * ![Anywhere - Desktop](https://images.ctfassets.net/v6awd0kabi65/5qcH7YCFU4CR90UJk3hmpJ/758d34410f41eba7801d9a02ebbdde6e/CB_SimpliSafe_LandingPageImage_FINAL_1_-_Desktop__1_.jpg?w=120&h=120&fit=pad)
 *
 * Anywhere - Desktop
 *
 *
 */
export const IMG_5qcH7YCFU4CR90UJk3hmpJ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5qcH7YCFU4CR90UJk3hmpJ/758d34410f41eba7801d9a02ebbdde6e/CB_SimpliSafe_LandingPageImage_FINAL_1_-_Desktop__1_.jpg',
  description: ``,
  originalHeight: 600,
  originalWidth: 1201
}

/**
 * ![Anywhere - Tablet](https://images.ctfassets.net/v6awd0kabi65/2xxUqqswGYwb9BEsldk5ya/90a46473463a4bdf36f303afc845a1ac/CB_SimpliSafe_LandingPageImage_FINAL_1_-_Tablet.jpg?w=120&h=120&fit=pad)
 *
 * Anywhere - Tablet
 *
 *
 */
export const IMG_2xxUqqswGYwb9BEsldk5ya = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2xxUqqswGYwb9BEsldk5ya/90a46473463a4bdf36f303afc845a1ac/CB_SimpliSafe_LandingPageImage_FINAL_1_-_Tablet.jpg',
  description: ``,
  originalHeight: 600,
  originalWidth: 1086
}

/**
 * ![Anywhere - Mobile](https://images.ctfassets.net/v6awd0kabi65/1eIh8m8uKDLnAwe2sBTF0V/c725cfe06dfdd8bf494dfa8bc7689442/CB_SimpliSafe_LandingPageImage_FINAL_1_-_Mobile.jpg?w=120&h=120&fit=pad)
 *
 * Anywhere - Mobile
 *
 *
 */
export const IMG_1eIh8m8uKDLnAwe2sBTF0V = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1eIh8m8uKDLnAwe2sBTF0V/c725cfe06dfdd8bf494dfa8bc7689442/CB_SimpliSafe_LandingPageImage_FINAL_1_-_Mobile.jpg',
  description: ``,
  originalHeight: 212,
  originalWidth: 384
}

/**
 * ![The Complete Guide to Commercial Security Systems](https://images.ctfassets.net/v6awd0kabi65/6CtqxaqNKCJSYFVRzQUzXi/139f5fb59c38e34004a32b59e3044924/artem-gavrysh-F6-U5fGAOik-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * The Complete Guide to Commercial Security Systems
 *
 *
 */
export const IMG_6CtqxaqNKCJSYFVRzQUzXi = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6CtqxaqNKCJSYFVRzQUzXi/139f5fb59c38e34004a32b59e3044924/artem-gavrysh-F6-U5fGAOik-unsplash.jpg',
  description: ``,
  originalHeight: 3232,
  originalWidth: 4879
}

/**
 * ![Anywhere Hero](https://images.ctfassets.net/v6awd0kabi65/nOK8RP21mZC0asqq9jyZY/f192838c201f09b00edca7339984b1eb/CB_SimpliSafe_LandingPageImage_FINAL_1.jpg?w=120&h=120&fit=pad)
 *
 * Anywhere Hero
 *
 *
 */
export const IMG_nOK8RP21mZC0asqq9jyZY = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/nOK8RP21mZC0asqq9jyZY/f192838c201f09b00edca7339984b1eb/CB_SimpliSafe_LandingPageImage_FINAL_1.jpg',
  description: ``,
  originalHeight: 3192,
  originalWidth: 7180
}

/**
 * ![How to Choose the Right Locksmith When You're Locked Out of Your House](https://images.ctfassets.net/v6awd0kabi65/6UGgbbde9M7tN2yj28RO1u/18218056ee1f1a9da1d2e3b1568421a5/Carousel_Slide_1_Obsidian.jpg?w=120&h=120&fit=pad)
 *
 * How to Choose the Right Locksmith When You're Locked Out of Your House
 *
 *
 */
export const IMG_6UGgbbde9M7tN2yj28RO1u = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6UGgbbde9M7tN2yj28RO1u/18218056ee1f1a9da1d2e3b1568421a5/Carousel_Slide_1_Obsidian.jpg',
  description: ``,
  originalHeight: 882,
  originalWidth: 1118
}

/**
 * ![When Do Most Burglaries Occur?](https://images.ctfassets.net/v6awd0kabi65/7I6TqfuyXavAda9RRLSz1I/c79092602a2da56a2aa7f774e63b58be/Low_Res-Scout_House_Intruder_792_FIN_WEBX.jpg?w=120&h=120&fit=pad)
 *
 * When Do Most Burglaries Occur?
 *
 *
 */
export const IMG_7I6TqfuyXavAda9RRLSz1I = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7I6TqfuyXavAda9RRLSz1I/c79092602a2da56a2aa7f774e63b58be/Low_Res-Scout_House_Intruder_792_FIN_WEBX.jpg',
  description: ``,
  originalHeight: 1667,
  originalWidth: 2500
}

/**
 * ![14 home security tips for dog owners](https://images.ctfassets.net/v6awd0kabi65/6VHYHzarwLtxbpxsYS2gyC/56e211dd537c7ff4594a29141a0fa799/Low_Res-MEDIA_-_Scout_Watchtower_-_Native_Ad_4_-_627_x_627_-_DOGGO.jpg?w=120&h=120&fit=pad)
 *
 * 14 home security tips for dog owners
 * 
 * 

 */
export const IMG_6VHYHzarwLtxbpxsYS2gyC = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6VHYHzarwLtxbpxsYS2gyC/56e211dd537c7ff4594a29141a0fa799/Low_Res-MEDIA_-_Scout_Watchtower_-_Native_Ad_4_-_627_x_627_-_DOGGO.jpg',
  description: `
`,
  originalHeight: 627,
  originalWidth: 627
}

/**
 * ![Home Security Shop BMS Column](https://images.ctfassets.net/v6awd0kabi65/1yCPckxJE3XqTYQ13sqvQn/0caaab03530e8427255212c9d2d8ca7f/Home_Security_Shop_BMS.png?w=120&h=120&fit=pad)
 *
 * Home Security Shop BMS Column
 *
 *
 */
export const IMG_1yCPckxJE3XqTYQ13sqvQn = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1yCPckxJE3XqTYQ13sqvQn/0caaab03530e8427255212c9d2d8ca7f/Home_Security_Shop_BMS.png',
  description: ``,
  originalHeight: 1200,
  originalWidth: 1440
}

/**
 * ![Everything you need to know about fire alarms](https://images.ctfassets.net/v6awd0kabi65/7JpBleYrQh45LfSiDOtUQm/14c267c8f7a3ba71e982ef8391c214d4/Everything_you_need_to_know_about_fire_alarms.jpg?w=120&h=120&fit=pad)
 *
 * Everything you need to know about fire alarms
 *
 *
 */
export const IMG_7JpBleYrQh45LfSiDOtUQm = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7JpBleYrQh45LfSiDOtUQm/14c267c8f7a3ba71e982ef8391c214d4/Everything_you_need_to_know_about_fire_alarms.jpg',
  description: ``,
  originalHeight: 1308,
  originalWidth: 1961
}

/**
 * ![Pro Install](https://images.ctfassets.net/v6awd0kabi65/Ojp4sriAMWTTmkPLXcTCi/9af026d3a4694ba676a1e2b59f4bbec7/attachment.jpeg?w=120&h=120&fit=pad)
 *
 * Pro Install
 *
 * null
 */
export const IMG_Ojp4sriAMWTTmkPLXcTCi = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/Ojp4sriAMWTTmkPLXcTCi/9af026d3a4694ba676a1e2b59f4bbec7/attachment.jpeg',
  description: `null`,
  originalHeight: 480,
  originalWidth: 480
}

/**
 * ![Smart Lock Series 2](https://images.ctfassets.net/v6awd0kabi65/27GCc2IFr2Ln90kp4I4OR9/b7cdb5d949459e01865090634520a194/See_Details.png?w=120&h=120&fit=pad)
 *
 * Smart Lock Series 2
 *
 *
 */
export const IMG_27GCc2IFr2Ln90kp4I4OR9 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/27GCc2IFr2Ln90kp4I4OR9/b7cdb5d949459e01865090634520a194/See_Details.png',
  description: ``,
  originalHeight: 944,
  originalWidth: 936
}

/**
 * ![Leaf Home (for water)](https://images.ctfassets.net/v6awd0kabi65/3IiC40KYhBY6x523Cmd3vs/045f090b72d1d033a7375a52639d66bd/LHWS-Logo-Stacked_All-White__1_.png?w=120&h=120&fit=pad)
 *
 * Leaf Home (for water)
 *
 *
 */
export const IMG_3IiC40KYhBY6x523Cmd3vs = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3IiC40KYhBY6x523Cmd3vs/045f090b72d1d033a7375a52639d66bd/LHWS-Logo-Stacked_All-White__1_.png',
  description: ``,
  originalHeight: 520,
  originalWidth: 1456
}

/**
 * ![meet the product - smart lock series 2](https://images.ctfassets.net/v6awd0kabi65/4gAkEbOwY7Qq8IyE722oqP/57ac4ff801e7d29d4de2ddac23d461a7/ezgif.com-gif-to-webp-converter__6_.webp?w=120&h=120&fit=pad)
 *
 * meet the product - smart lock series 2
 *
 *
 */
export const IMG_4gAkEbOwY7Qq8IyE722oqP = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4gAkEbOwY7Qq8IyE722oqP/57ac4ff801e7d29d4de2ddac23d461a7/ezgif.com-gif-to-webp-converter__6_.webp',
  description: ``,
  originalHeight: 1118,
  originalWidth: 1920
}

/**
 * ![Installation](https://images.ctfassets.net/v6awd0kabi65/2XdYlkSMgGsxRVKwUh8Uak/61c6ee41ae4f963029052d9184d20cd3/Installation_NEW.jpg?w=120&h=120&fit=pad)
 *
 * Installation
 *
 *
 */
export const IMG_2XdYlkSMgGsxRVKwUh8Uak = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2XdYlkSMgGsxRVKwUh8Uak/61c6ee41ae4f963029052d9184d20cd3/Installation_NEW.jpg',
  description: ``,
  originalHeight: 740,
  originalWidth: 1316
}

/**
 * ![Smart Design, Built to Last](https://images.ctfassets.net/v6awd0kabi65/7tFtecpw6qKr7ku0iLdNAm/880cab9080b00d6cbbae4d42c0849e69/Smart_Design__Built_to_Last.jpg?w=120&h=120&fit=pad)
 *
 * Smart Design, Built to Last
 *
 *
 */
export const IMG_7tFtecpw6qKr7ku0iLdNAm = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7tFtecpw6qKr7ku0iLdNAm/880cab9080b00d6cbbae4d42c0849e69/Smart_Design__Built_to_Last.jpg',
  description: ``,
  originalHeight: 794,
  originalWidth: 1262
}

/**
 * ![Impedes Intruders](https://images.ctfassets.net/v6awd0kabi65/1HXnGAz2qP7wvyBgwdoap3/d706d0059cc44a1039f097d658dd4add/Impedes_Intruders.jpg?w=120&h=120&fit=pad)
 *
 * Impedes Intruders
 *
 *
 */
export const IMG_1HXnGAz2qP7wvyBgwdoap3 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1HXnGAz2qP7wvyBgwdoap3/d706d0059cc44a1039f097d658dd4add/Impedes_Intruders.jpg',
  description: ``,
  originalHeight: 794,
  originalWidth: 1244
}

/**
 * ![Smart Lock Series 2 - Settings tab](https://images.ctfassets.net/v6awd0kabi65/535ZK7hKQ3OziOIQHcvPxJ/b6d411fc2875c3ea340a8b79892a4941/App_Screen_art_settings.png?w=120&h=120&fit=pad)
 *
 * Smart Lock Series 2 - Settings tab
 *
 *
 */
export const IMG_535ZK7hKQ3OziOIQHcvPxJ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/535ZK7hKQ3OziOIQHcvPxJ/b6d411fc2875c3ea340a8b79892a4941/App_Screen_art_settings.png',
  description: ``,
  originalHeight: 1917,
  originalWidth: 1500
}

/**
 * ![Smart Lock Series 2 - Timeline tab](https://images.ctfassets.net/v6awd0kabi65/Y4B4HxzEKDvdGHWfYeRji/f19e6e1a11314cb341726d6b3b8dc56b/App_Screen_art_timeline.png?w=120&h=120&fit=pad)
 *
 * Smart Lock Series 2 - Timeline tab
 *
 *
 */
export const IMG_Y4B4HxzEKDvdGHWfYeRji = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/Y4B4HxzEKDvdGHWfYeRji/f19e6e1a11314cb341726d6b3b8dc56b/App_Screen_art_timeline.png',
  description: ``,
  originalHeight: 1881,
  originalWidth: 1500
}

/**
 * ![Smart Lock Series 2 - Remote tab](https://images.ctfassets.net/v6awd0kabi65/2BLg0i0DijeW04rIDImamQ/4a95f989043c2f38b882ff1ddc6c1286/App_Screen_art.png?w=120&h=120&fit=pad)
 *
 * Smart Lock Series 2 - Remote tab
 *
 *
 */
export const IMG_2BLg0i0DijeW04rIDImamQ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2BLg0i0DijeW04rIDImamQ/4a95f989043c2f38b882ff1ddc6c1286/App_Screen_art.png',
  description: ``,
  originalHeight: 1917,
  originalWidth: 1517
}

/**
 * ![Smartlock white render standing shadow](https://images.ctfassets.net/v6awd0kabi65/5ewenegTwDGrnJE0F6mLZ2/1970560f77b899eaf190a13c261d7f1b/Smartlock_white_render_standing_shadow_3.png?w=120&h=120&fit=pad)
 *
 * Smartlock white render standing shadow
 *
 *
 */
export const IMG_5ewenegTwDGrnJE0F6mLZ2 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5ewenegTwDGrnJE0F6mLZ2/1970560f77b899eaf190a13c261d7f1b/Smartlock_white_render_standing_shadow_3.png',
  description: ``,
  originalHeight: 1074,
  originalWidth: 1572
}

/**
 * ![Smart Lock Series 2 Try it Risk Free Obsidian](https://images.ctfassets.net/v6awd0kabi65/6qrsTSSjk6n4tD0vJNFN9f/fec7e46f75769d4ee78ea8e8c80049f8/Product_Smartlock_NEW_black_comp_standing_final_2.png?w=120&h=120&fit=pad)
 *
 * Smart Lock Series 2 Try it Risk Free Obsidian
 *
 *
 */
export const IMG_6qrsTSSjk6n4tD0vJNFN9f = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6qrsTSSjk6n4tD0vJNFN9f/fec7e46f75769d4ee78ea8e8c80049f8/Product_Smartlock_NEW_black_comp_standing_final_2.png',
  description: ``,
  originalHeight: 716,
  originalWidth: 1048
}

/**
 * ![SL Series 2 Carousel 1 - Cloud](https://images.ctfassets.net/v6awd0kabi65/60RY8dZegDlwgyBPNYFeSF/a47229ff595e10fd49805fcd033f3a2d/Carousel_Slide_1_Cloud_3x.jpg?w=120&h=120&fit=pad)
 *
 * SL Series 2 Carousel 1 - Cloud
 *
 *
 */
export const IMG_60RY8dZegDlwgyBPNYFeSF = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/60RY8dZegDlwgyBPNYFeSF/a47229ff595e10fd49805fcd033f3a2d/Carousel_Slide_1_Cloud_3x.jpg',
  description: ``,
  originalHeight: 1323,
  originalWidth: 1677
}

/**
 * ![SL Series 2 Carousel 3](https://images.ctfassets.net/v6awd0kabi65/MguYkMgyP8XTot0LVFDmD/9a8d16f78d76ce79a5ece178372e4397/Carousel_Slide_3_3x.jpg?w=120&h=120&fit=pad)
 *
 * SL Series 2 Carousel 3
 *
 *
 */
export const IMG_MguYkMgyP8XTot0LVFDmD = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/MguYkMgyP8XTot0LVFDmD/9a8d16f78d76ce79a5ece178372e4397/Carousel_Slide_3_3x.jpg',
  description: ``,
  originalHeight: 1323,
  originalWidth: 1677
}

/**
 * ![SL Series 2 Carousel 2](https://images.ctfassets.net/v6awd0kabi65/28fGwFSXJtizsrxSFEgwZd/2fa6087e4399bd187d91c78c5e958607/Carousel_Slide_2_3x.jpg?w=120&h=120&fit=pad)
 *
 * SL Series 2 Carousel 2
 *
 *
 */
export const IMG_28fGwFSXJtizsrxSFEgwZd = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/28fGwFSXJtizsrxSFEgwZd/2fa6087e4399bd187d91c78c5e958607/Carousel_Slide_2_3x.jpg',
  description: ``,
  originalHeight: 1323,
  originalWidth: 1677
}

/**
 * ![SL Series 2 Carousel 1](https://images.ctfassets.net/v6awd0kabi65/67LdsFvX6jBe2UKkvijDIr/ab53456078fe0f53726d4473b7eec9be/PDP_Hero_Image_3x.jpg?w=120&h=120&fit=pad)
 *
 * SL Series 2 Carousel 1
 *
 *
 */
export const IMG_67LdsFvX6jBe2UKkvijDIr = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/67LdsFvX6jBe2UKkvijDIr/ab53456078fe0f53726d4473b7eec9be/PDP_Hero_Image_3x.jpg',
  description: ``,
  originalHeight: 1323,
  originalWidth: 1677
}

/**
 * ![Product - Olympus Outdoor Camera](https://images.ctfassets.net/v6awd0kabi65/4SxzADbJPybeaicaLYvXFy/0ed158bd679d046ea88571e569dd3572/Olympus_outdoor_camera_-_looking_left.png?w=120&h=120&fit=pad)
 *
 * Product - Olympus Outdoor Camera
 *
 *
 */
export const IMG_4SxzADbJPybeaicaLYvXFy = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4SxzADbJPybeaicaLYvXFy/0ed158bd679d046ea88571e569dd3572/Olympus_outdoor_camera_-_looking_left.png',
  description: ``,
  originalHeight: 416,
  originalWidth: 476
}

/**
 * ![ODMON Nexted Experience Hero - Desktop](https://images.ctfassets.net/v6awd0kabi65/MpdT43p783K1X3q3bJb8i/b042d6b1b9ec23507eb5a99826bf6694/D_hero.jpg?w=120&h=120&fit=pad)
 *
 * ODMON Nexted Experience Hero - Desktop
 *
 *
 */
export const IMG_MpdT43p783K1X3q3bJb8i = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/MpdT43p783K1X3q3bJb8i/b042d6b1b9ec23507eb5a99826bf6694/D_hero.jpg',
  description: ``,
  originalHeight: 2400,
  originalWidth: 4800
}

/**
 * ![ODMON Nexted Experience Hero - Tablet](https://images.ctfassets.net/v6awd0kabi65/9pIkdYQ34RgIgZWf5yeQy/62d6f2cea1bd2ef5c16ac04f87839c39/T_hero_1600.png?w=120&h=120&fit=pad)
 *
 * ODMON Nexted Experience Hero - Tablet
 *
 *
 */
export const IMG_9pIkdYQ34RgIgZWf5yeQy = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/9pIkdYQ34RgIgZWf5yeQy/62d6f2cea1bd2ef5c16ac04f87839c39/T_hero_1600.png',
  description: ``,
  originalHeight: 1084,
  originalWidth: 1600
}

/**
 * ![ODMON Nexted Experience Hero - Mobile](https://images.ctfassets.net/v6awd0kabi65/7l0DwzZP2qV3Rfu7xwLBw2/d8512de1b750d7ac3ba9c58cf9d2cf69/M_hero_700.png?w=120&h=120&fit=pad)
 *
 * ODMON Nexted Experience Hero - Mobile
 *
 *
 */
export const IMG_7l0DwzZP2qV3Rfu7xwLBw2 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7l0DwzZP2qV3Rfu7xwLBw2/d8512de1b750d7ac3ba9c58cf9d2cf69/M_hero_700.png',
  description: ``,
  originalHeight: 700,
  originalWidth: 700
}

/**
 * ![LeafFilter](https://images.ctfassets.net/v6awd0kabi65/4VeFXO5yODqcQFt5NAN4tQ/d100cf921571d84e1bc18d49873780a9/2018_LeafFilter_Logos_USA_RGB_AllWhite__3_.png?w=120&h=120&fit=pad)
 *
 * LeafFilter
 *
 *
 */
export const IMG_4VeFXO5yODqcQFt5NAN4tQ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4VeFXO5yODqcQFt5NAN4tQ/d100cf921571d84e1bc18d49873780a9/2018_LeafFilter_Logos_USA_RGB_AllWhite__3_.png',
  description: ``,
  originalHeight: 345,
  originalWidth: 1024
}

/**
 * ![LeafHome Kit](https://images.ctfassets.net/v6awd0kabi65/x5ZcNTyhsWsetBoDkoL8l/350a21e111c3a25048e3e0043ebdde5a/240761_flat-lay__2_.jpg?w=120&h=120&fit=pad)
 *
 * LeafHome Kit
 *
 *
 */
export const IMG_x5ZcNTyhsWsetBoDkoL8l = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/x5ZcNTyhsWsetBoDkoL8l/350a21e111c3a25048e3e0043ebdde5a/240761_flat-lay__2_.jpg',
  description: ``,
  originalHeight: 1559,
  originalWidth: 1920
}

/**
 * ![Keeping Teenagers Safe at Home](https://images.ctfassets.net/v6awd0kabi65/9QYMVdm0vtzE7PzJ2xUBV/271411ca73db400c1e43106d0cde7e3e/surface-iVfJwaovHUo-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * Keeping Teenagers Safe at Home
 *
 *
 */
export const IMG_9QYMVdm0vtzE7PzJ2xUBV = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/9QYMVdm0vtzE7PzJ2xUBV/271411ca73db400c1e43106d0cde7e3e/surface-iVfJwaovHUo-unsplash.jpg',
  description: ``,
  originalHeight: 5504,
  originalWidth: 8256
}

/**
 * ![USAA Peak Hero Image](https://images.ctfassets.net/v6awd0kabi65/6jTT2aCd0SfkDxTCe2ZRL/d364e91f12b2c9c3d2729b59b62f6003/240554_USAA_EcommHero.jpg?w=120&h=120&fit=pad)
 *
 * USAA Peak Hero Image
 *
 *
 */
export const IMG_6jTT2aCd0SfkDxTCe2ZRL = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6jTT2aCd0SfkDxTCe2ZRL/d364e91f12b2c9c3d2729b59b62f6003/240554_USAA_EcommHero.jpg',
  description: ``,
  originalHeight: 1200,
  originalWidth: 2400
}

/**
 * ![Co-op Carousel Image 3](https://images.ctfassets.net/v6awd0kabi65/WTuIcLya1YM9lTpziAyJw/c863bfec4d5ca5e1179f90257d7b57ab/Carousel_3_Desktop_2x.jpg?w=120&h=120&fit=pad)
 *
 * Co-op Carousel Image 3
 *
 *
 */
export const IMG_WTuIcLya1YM9lTpziAyJw = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/WTuIcLya1YM9lTpziAyJw/c863bfec4d5ca5e1179f90257d7b57ab/Carousel_3_Desktop_2x.jpg',
  description: ``,
  originalHeight: 1200,
  originalWidth: 1247
}

/**
 * ![Co-Op Carousel Image 5](https://images.ctfassets.net/v6awd0kabi65/7EYMA9hWZWetLwkfuDGj5c/b50bc2aa705c25993f4a1cd990b6dbfc/Carousel_5_Desktop.jpg?w=120&h=120&fit=pad)
 *
 * Co-Op Carousel Image 5
 *
 *
 */
export const IMG_7EYMA9hWZWetLwkfuDGj5c = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7EYMA9hWZWetLwkfuDGj5c/b50bc2aa705c25993f4a1cd990b6dbfc/Carousel_5_Desktop.jpg',
  description: ``,
  originalHeight: 1200,
  originalWidth: 1246
}

/**
 * ![Co-Op Carousel Image 5 Mobile](https://images.ctfassets.net/v6awd0kabi65/6dVEa7ae2TDI9t1IsLOiMf/d7aa909a2ead775116bf106bbb6d095c/Carousel_5_Mobile.jpg?w=120&h=120&fit=pad)
 *
 * Co-Op Carousel Image 5 Mobile
 *
 *
 */
export const IMG_6dVEa7ae2TDI9t1IsLOiMf = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6dVEa7ae2TDI9t1IsLOiMf/d7aa909a2ead775116bf106bbb6d095c/Carousel_5_Mobile.jpg',
  description: ``,
  originalHeight: 660,
  originalWidth: 686
}

/**
 * ![Co-Op Carousel Image 3 Mobile](https://images.ctfassets.net/v6awd0kabi65/5xxg3byzMjpsl2t3Aidm1q/4902137412f579ff8f7c1c7b02fdbe38/Carousel_3_Mobile_2x.jpg?w=120&h=120&fit=pad)
 *
 * Co-Op Carousel Image 3 Mobile
 *
 *
 */
export const IMG_5xxg3byzMjpsl2t3Aidm1q = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5xxg3byzMjpsl2t3Aidm1q/4902137412f579ff8f7c1c7b02fdbe38/Carousel_3_Mobile_2x.jpg',
  description: ``,
  originalHeight: 660,
  originalWidth: 686
}

/**
 * ![Co-Op Carousel Image 2 Mobile](https://images.ctfassets.net/v6awd0kabi65/5Tz5fZv8lokJlpRR0eqMzM/c3c9f36c8bdb4f3ca492427ba04747de/Carousel_2_Mobile_2x.jpg?w=120&h=120&fit=pad)
 *
 * Co-Op Carousel Image 2 Mobile
 *
 *
 */
export const IMG_5Tz5fZv8lokJlpRR0eqMzM = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5Tz5fZv8lokJlpRR0eqMzM/c3c9f36c8bdb4f3ca492427ba04747de/Carousel_2_Mobile_2x.jpg',
  description: ``,
  originalHeight: 660,
  originalWidth: 686
}

/**
 * ![Co-Op Carousel Image 2](https://images.ctfassets.net/v6awd0kabi65/5eWpWD6y98slevgNKJQlCK/9d17100ac38116ce68be38f10dc06127/Carousel_2_Desktop_2x.jpg?w=120&h=120&fit=pad)
 *
 * Co-Op Carousel Image 2
 *
 *
 */
export const IMG_5eWpWD6y98slevgNKJQlCK = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5eWpWD6y98slevgNKJQlCK/9d17100ac38116ce68be38f10dc06127/Carousel_2_Desktop_2x.jpg',
  description: ``,
  originalHeight: 1200,
  originalWidth: 1246
}

/**
 * ![Co-Op Insurance Logo](https://images.ctfassets.net/v6awd0kabi65/50xiC7cXTQ602N0lywwJdM/1557f7d1fa8fd226de46c7e94e57db33/INS_COP97666_CoopInsuranceLogos-04.png?w=120&h=120&fit=pad)
 *
 * Co-Op Insurance Logo
 *
 *
 */
export const IMG_50xiC7cXTQ602N0lywwJdM = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/50xiC7cXTQ602N0lywwJdM/1557f7d1fa8fd226de46c7e94e57db33/INS_COP97666_CoopInsuranceLogos-04.png',
  description: ``,
  originalHeight: 348,
  originalWidth: 964
}

/**
 * ![Co-Op Carousel Image 1 Mobile](https://images.ctfassets.net/v6awd0kabi65/4Hrrp1IqoVykhIGVm6QSGF/53a3166a0b3ccdb7374c825838061d17/Carousel_1_Mobile_2x.jpg?w=120&h=120&fit=pad)
 *
 * Co-Op Carousel Image 1 Mobile
 *
 *
 */
export const IMG_4Hrrp1IqoVykhIGVm6QSGF = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4Hrrp1IqoVykhIGVm6QSGF/53a3166a0b3ccdb7374c825838061d17/Carousel_1_Mobile_2x.jpg',
  description: ``,
  originalHeight: 660,
  originalWidth: 686
}

/**
 * ![Co-Op Carousel Image 6](https://images.ctfassets.net/v6awd0kabi65/4eFTOusvRHgWTeg2J9LTVL/fe18a8d20d17fd81ee2d10b87726a33e/Carousel_6_Desktop_2x.jpg?w=120&h=120&fit=pad)
 *
 * Co-Op Carousel Image 6
 *
 *
 */
export const IMG_4eFTOusvRHgWTeg2J9LTVL = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4eFTOusvRHgWTeg2J9LTVL/fe18a8d20d17fd81ee2d10b87726a33e/Carousel_6_Desktop_2x.jpg',
  description: ``,
  originalHeight: 1200,
  originalWidth: 1246
}

/**
 * ![Co-Op Carousel Image 6 Mobile](https://images.ctfassets.net/v6awd0kabi65/3zAa4gsBlRnP2YUeXmu0YS/2b7c02c1ed8af20e8168f64acf24a1be/Carousel_6_Mobile_2x.jpg?w=120&h=120&fit=pad)
 *
 * Co-Op Carousel Image 6 Mobile
 *
 *
 */
export const IMG_3zAa4gsBlRnP2YUeXmu0YS = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3zAa4gsBlRnP2YUeXmu0YS/2b7c02c1ed8af20e8168f64acf24a1be/Carousel_6_Mobile_2x.jpg',
  description: ``,
  originalHeight: 660,
  originalWidth: 686
}

/**
 * ![Co-Op Carousel Image 1](https://images.ctfassets.net/v6awd0kabi65/3bCj4G1bfbTcYlXMTLHxVN/f81c8a7f5d4ce3d52a8e050a2c2a7c84/Carousel_1_Desktop_2x.jpg?w=120&h=120&fit=pad)
 *
 * Co-Op Carousel Image 1
 *
 *
 */
export const IMG_3bCj4G1bfbTcYlXMTLHxVN = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3bCj4G1bfbTcYlXMTLHxVN/f81c8a7f5d4ce3d52a8e050a2c2a7c84/Carousel_1_Desktop_2x.jpg',
  description: ``,
  originalHeight: 1200,
  originalWidth: 1246
}

/**
 * ![Co-Op Carousel Image 4 Mobile](https://images.ctfassets.net/v6awd0kabi65/34n8o08XIZ39KAe3uCV113/e2f85cf72f6f741aa1a313eaf09b5bc6/Carousel_4_Mobile_2x.jpg?w=120&h=120&fit=pad)
 *
 * Co-Op Carousel Image 4 Mobile
 *
 *
 */
export const IMG_34n8o08XIZ39KAe3uCV113 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/34n8o08XIZ39KAe3uCV113/e2f85cf72f6f741aa1a313eaf09b5bc6/Carousel_4_Mobile_2x.jpg',
  description: ``,
  originalHeight: 660,
  originalWidth: 686
}

/**
 * ![Co-Op Carousel Image 4](https://images.ctfassets.net/v6awd0kabi65/2fxNagHXkRaFRLVeRcuJXH/b90d2aee1ec6f019f555aa4309f6e333/Carousel_4_Desktop_2x.jpg?w=120&h=120&fit=pad)
 *
 * Co-Op Carousel Image 4
 *
 *
 */
export const IMG_2fxNagHXkRaFRLVeRcuJXH = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2fxNagHXkRaFRLVeRcuJXH/b90d2aee1ec6f019f555aa4309f6e333/Carousel_4_Desktop_2x.jpg',
  description: ``,
  originalHeight: 1200,
  originalWidth: 1247
}

/**
 * ![USAA Whole Home Cropped](https://images.ctfassets.net/v6awd0kabi65/rRIzjb8SA45rjSmwvvX6U/1a86d6b6035fd4d48696ffa52f44761a/240754_USAA_Flatlay_b.jpg?w=120&h=120&fit=pad)
 *
 * USAA Whole Home Cropped
 *
 *
 */
export const IMG_rRIzjb8SA45rjSmwvvX6U = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/rRIzjb8SA45rjSmwvvX6U/1a86d6b6035fd4d48696ffa52f44761a/240754_USAA_Flatlay_b.jpg',
  description: ``,
  originalHeight: 958,
  originalWidth: 829
}

/**
 * ![USAA Whole Home Kit Uncropped](https://images.ctfassets.net/v6awd0kabi65/BjyM1R7PFN1LrqQHzTHvd/74f973f7d7f8b69e79fe2229542f1b57/PRTNR_237143_USAA_Flatlay_01.png?w=120&h=120&fit=pad)
 *
 * USAA Whole Home Kit Uncropped
 *
 * USAA Whole Home Kit
 */
export const IMG_BjyM1R7PFN1LrqQHzTHvd = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/BjyM1R7PFN1LrqQHzTHvd/74f973f7d7f8b69e79fe2229542f1b57/PRTNR_237143_USAA_Flatlay_01.png',
  description: `USAA Whole Home Kit`,
  originalHeight: 958,
  originalWidth: 958
}

/**
 * ![240754 USAA Flatlay A](https://images.ctfassets.net/v6awd0kabi65/6DcUPJa9LsGI1Z48p9vNMa/834a121fd7c2219fa314b573cc084c7f/240754_USAA_Flatlay_A.jpg?w=120&h=120&fit=pad)
 *
 * 240754 USAA Flatlay A
 *
 *
 */
export const IMG_6DcUPJa9LsGI1Z48p9vNMa = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6DcUPJa9LsGI1Z48p9vNMa/834a121fd7c2219fa314b573cc084c7f/240754_USAA_Flatlay_A.jpg',
  description: ``,
  originalHeight: 958,
  originalWidth: 958
}

/**
 * ![National Preparedness Month: Fortify Your Home](https://images.ctfassets.net/v6awd0kabi65/15yO6EbnDPleTesmvAnYPn/af6181796f58c5617be0797cad08287b/Low_Res-01122021_SimpliSafe_Shield_0174_NoPlant.jpg?w=120&h=120&fit=pad)
 *
 * National Preparedness Month: Fortify Your Home
 *
 *
 */
export const IMG_15yO6EbnDPleTesmvAnYPn = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/15yO6EbnDPleTesmvAnYPn/af6181796f58c5617be0797cad08287b/Low_Res-01122021_SimpliSafe_Shield_0174_NoPlant.jpg',
  description: ``,
  originalHeight: 2089,
  originalWidth: 2785
}

/**
 * ![ODMON Launch - Alarm Moment - Break-in](https://images.ctfassets.net/v6awd0kabi65/V3kY03h94bAJ9S1CzXHIG/ce4bc92f57aad2607931676dfa3f26a2/OD_alarmMoment2.jpg?w=120&h=120&fit=pad)
 *
 * ODMON Launch - Alarm Moment - Break-in
 *
 *
 */
export const IMG_V3kY03h94bAJ9S1CzXHIG = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/V3kY03h94bAJ9S1CzXHIG/ce4bc92f57aad2607931676dfa3f26a2/OD_alarmMoment2.jpg',
  description: ``,
  originalHeight: 1056,
  originalWidth: 1932
}

/**
 * ![Professional monitoring, from the outside in (Hero Banner, Mobile)](https://images.ctfassets.net/v6awd0kabi65/T2vcrqiRB33zKraOXkfcI/2a22913eb65651192134a88e3ab9ff60/Monitoring_hero_mobile.jpg?w=120&h=120&fit=pad)
 *
 * Professional monitoring, from the outside in (Hero Banner, Mobile)
 *
 * Professional monitoring, from the outside in (Hero Banner, Mobile)
 */
export const IMG_T2vcrqiRB33zKraOXkfcI = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/T2vcrqiRB33zKraOXkfcI/2a22913eb65651192134a88e3ab9ff60/Monitoring_hero_mobile.jpg',
  description: `Professional monitoring, from the outside in (Hero Banner, Mobile)`,
  originalHeight: 450,
  originalWidth: 750
}

/**
 * ![Stepper - Emergency Response](https://images.ctfassets.net/v6awd0kabi65/mqQKRXjPCu4NhPqdnKo5u/9e5c61c19dea957c719e72e9d1f5415d/3rd_img.png?w=120&h=120&fit=pad)
 *
 * Stepper - Emergency Response
 *
 *
 */
export const IMG_mqQKRXjPCu4NhPqdnKo5u = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/mqQKRXjPCu4NhPqdnKo5u/9e5c61c19dea957c719e72e9d1f5415d/3rd_img.png',
  description: ``,
  originalHeight: 468,
  originalWidth: 562
}

/**
 * ![Outdoor Camera Series 2 (User Stories - Device)](https://images.ctfassets.net/v6awd0kabi65/66md40vkBYjgeec9MXEpHJ/fe6e41023f78154826f3370bcb15c540/Olympus__1_.png?w=120&h=120&fit=pad)
 *
 * Outdoor Camera Series 2 (User Stories - Device)
 *
 * Outdoor Camera Series 2 (User Stories - Device)
 */
export const IMG_66md40vkBYjgeec9MXEpHJ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/66md40vkBYjgeec9MXEpHJ/fe6e41023f78154826f3370bcb15c540/Olympus__1_.png',
  description: `Outdoor Camera Series 2 (User Stories - Device)`,
  originalHeight: 1880,
  originalWidth: 1424
}

/**
 * ![Help prevent crime (User Stories- Background)](https://images.ctfassets.net/v6awd0kabi65/454JBJi6wedxqntlJwxoJA/0e7f0147bb105f6b1a7db4cdb1b73522/SavedDay_preventCrime.jpg?w=120&h=120&fit=pad)
 *
 * Help prevent crime (User Stories- Background)
 *
 * Help prevent crime (User Stories- Background)
 */
export const IMG_454JBJi6wedxqntlJwxoJA = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/454JBJi6wedxqntlJwxoJA/0e7f0147bb105f6b1a7db4cdb1b73522/SavedDay_preventCrime.jpg',
  description: `Help prevent crime (User Stories- Background)`,
  originalHeight: 730,
  originalWidth: 1170
}

/**
 * ![Olympus - face-matching Feature](https://images.ctfassets.net/v6awd0kabi65/2KQy1SMpC4BQsZHxLL6TQ7/10d747e34c4a7cef993b57e9b2769ef8/IntruderScan.webp?w=120&h=120&fit=pad)
 *
 * Olympus - face-matching Feature
 *
 *
 */
export const IMG_2KQy1SMpC4BQsZHxLL6TQ7 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2KQy1SMpC4BQsZHxLL6TQ7/10d747e34c4a7cef993b57e9b2769ef8/IntruderScan.webp',
  description: ``,
  originalHeight: 794,
  originalWidth: 1244
}

/**
 * ![Professional monitoring, from the outside in (Hero Banner, Desktop)](https://images.ctfassets.net/v6awd0kabi65/1W25zAWuJwFbCxjzDvSn5q/e36995c9717cb535fba3f320093bebbe/Monitoring_hero_desktop.jpg?w=120&h=120&fit=pad)
 *
 * Professional monitoring, from the outside in (Hero Banner, Desktop)
 *
 * Professional monitoring, from the outside in (Hero Banner, Desktop)
 */
export const IMG_1W25zAWuJwFbCxjzDvSn5q = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1W25zAWuJwFbCxjzDvSn5q/e36995c9717cb535fba3f320093bebbe/Monitoring_hero_desktop.jpg',
  description: `Professional monitoring, from the outside in (Hero Banner, Desktop)`,
  originalHeight: 958,
  originalWidth: 2096
}

/**
 * ![Professional monitoring, from the outside in (Hero Banner, Tablet)](https://images.ctfassets.net/v6awd0kabi65/1nAP9bMffVvjUGJZTboIBf/ccaa35aeb2d6d01c59ddc212b8b98566/Monitoring_hero_tablet.jpg?w=120&h=120&fit=pad)
 *
 * Professional monitoring, from the outside in (Hero Banner, Tablet)
 *
 * Professional monitoring, from the outside in (Hero Banner, Tablet)
 */
export const IMG_1nAP9bMffVvjUGJZTboIBf = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1nAP9bMffVvjUGJZTboIBf/ccaa35aeb2d6d01c59ddc212b8b98566/Monitoring_hero_tablet.jpg',
  description: `Professional monitoring, from the outside in (Hero Banner, Tablet)`,
  originalHeight: 1084,
  originalWidth: 1640
}

/**
 * ![ODMON Launch - Alarm Moment - Outdoor](https://images.ctfassets.net/v6awd0kabi65/1gEVGivzjCTlp341WvH1KC/1d1afc11c11cd5933f083e3fa627ea5b/OD_alarmMoment1.jpg?w=120&h=120&fit=pad)
 *
 * ODMON Launch - Alarm Moment - Outdoor
 *
 *
 */
export const IMG_1gEVGivzjCTlp341WvH1KC = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1gEVGivzjCTlp341WvH1KC/1d1afc11c11cd5933f083e3fa627ea5b/OD_alarmMoment1.jpg',
  description: ``,
  originalHeight: 1056,
  originalWidth: 1933
}

/**
 * ![Refurbished - 11 Piece Outdoor](https://images.ctfassets.net/v6awd0kabi65/4DuDzvxRXzwH0aZeqgbIxT/0ab50c379425bcecab57f9d9e28a00a6/11-Piece-Refurb.jpg?w=120&h=120&fit=pad)
 *
 * Refurbished - 11 Piece Outdoor
 *
 *
 */
export const IMG_4DuDzvxRXzwH0aZeqgbIxT = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4DuDzvxRXzwH0aZeqgbIxT/0ab50c379425bcecab57f9d9e28a00a6/11-Piece-Refurb.jpg',
  description: ``,
  originalHeight: 2333,
  originalWidth: 3500
}

/**
 * ![Refurbished - 16 Piece Outdoor](https://images.ctfassets.net/v6awd0kabi65/33LxRo0eNaHDbDXqKlVkkw/3048b361b905a8a9b570db0174ce1174/16-Piece-Refurb2.jpg?w=120&h=120&fit=pad)
 *
 * Refurbished - 16 Piece Outdoor
 *
 *
 */
export const IMG_33LxRo0eNaHDbDXqKlVkkw = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/33LxRo0eNaHDbDXqKlVkkw/3048b361b905a8a9b570db0174ce1174/16-Piece-Refurb2.jpg',
  description: ``,
  originalHeight: 2333,
  originalWidth: 3500
}

/**
 * ![Refurbished - 12 Piece Essentials](https://images.ctfassets.net/v6awd0kabi65/3kH8O04nbrBmDPoXUXZuc4/91f0d5951568939aa044ac7681e7f3af/12-Piece-Refurb.jpg?w=120&h=120&fit=pad)
 *
 * Refurbished - 12 Piece Essentials
 *
 *
 */
export const IMG_3kH8O04nbrBmDPoXUXZuc4 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3kH8O04nbrBmDPoXUXZuc4/91f0d5951568939aa044ac7681e7f3af/12-Piece-Refurb.jpg',
  description: ``,
  originalHeight: 2333,
  originalWidth: 3500
}

/**
 * ![Refurbished - 9 Piece Essentials](https://images.ctfassets.net/v6awd0kabi65/Tf03XeQ63SRlGtTpPvY0N/94cc39e48fd0194c6b17889661988d13/9-Piece-Refurb.jpg?w=120&h=120&fit=pad)
 *
 * Refurbished - 9 Piece Essentials
 *
 *
 */
export const IMG_Tf03XeQ63SRlGtTpPvY0N = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/Tf03XeQ63SRlGtTpPvY0N/94cc39e48fd0194c6b17889661988d13/9-Piece-Refurb.jpg',
  description: ``,
  originalHeight: 2333,
  originalWidth: 3500
}

/**
 * ![The Lighthouse (Odmon Package Lead Image)](https://images.ctfassets.net/v6awd0kabi65/1QeaQoU0gMUut5yzmcCUFM/b76427aa6bfe966063a95221bc733621/Lighthouse_lineup.jpg?w=120&h=120&fit=pad)
 *
 * The Lighthouse (Odmon Package Lead Image)
 *
 * The Lighthouse
 */
export const IMG_1QeaQoU0gMUut5yzmcCUFM = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1QeaQoU0gMUut5yzmcCUFM/b76427aa6bfe966063a95221bc733621/Lighthouse_lineup.jpg',
  description: `The Lighthouse`,
  originalHeight: 1738,
  originalWidth: 1738
}

/**
 * ![The Beacon (Odmon Package Lead Image)](https://images.ctfassets.net/v6awd0kabi65/PCWgU0BaVnG3Htfi31nmH/f24059fe09919380e5ed377ffc94370a/Beacon_lineup.jpg?w=120&h=120&fit=pad)
 *
 * The Beacon (Odmon Package Lead Image)
 *
 * The Beacon
 */
export const IMG_PCWgU0BaVnG3Htfi31nmH = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/PCWgU0BaVnG3Htfi31nmH/f24059fe09919380e5ed377ffc94370a/Beacon_lineup.jpg',
  description: `The Beacon`,
  originalHeight: 1738,
  originalWidth: 1738
}

/**
 * ![Stepper - Agent Engagement](https://images.ctfassets.net/v6awd0kabi65/6wXcQ8HblbyqkQnuy32gu3/afeb9fcdf8b068581026a19208784e0f/2nd_img.png?w=120&h=120&fit=pad)
 *
 * Stepper - Agent Engagement
 *
 *
 */
export const IMG_6wXcQ8HblbyqkQnuy32gu3 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6wXcQ8HblbyqkQnuy32gu3/afeb9fcdf8b068581026a19208784e0f/2nd_img.png',
  description: ``,
  originalHeight: 468,
  originalWidth: 562
}

/**
 * ![Stepper - Detection](https://images.ctfassets.net/v6awd0kabi65/5jE48hpZst9IkNsuDen7A9/4f2b516d17d3f0df630c07fe2e25ab26/1st_img.png?w=120&h=120&fit=pad)
 *
 * Stepper - Detection
 *
 *
 */
export const IMG_5jE48hpZst9IkNsuDen7A9 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5jE48hpZst9IkNsuDen7A9/4f2b516d17d3f0df630c07fe2e25ab26/1st_img.png',
  description: ``,
  originalHeight: 468,
  originalWidth: 562
}

/**
 * ![How much does home security cost?](https://images.ctfassets.net/v6awd0kabi65/5GBNmufYCTULLfCasyt550/9785003d9db959390ea1a1c22f1befdb/237134_PMK_Spring2024-ODM_BRAUN_Braun_FrontDoor_OnTech_Family_4647.jpg?w=120&h=120&fit=pad)
 *
 * How much does home security cost?
 *
 *
 */
export const IMG_5GBNmufYCTULLfCasyt550 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5GBNmufYCTULLfCasyt550/9785003d9db959390ea1a1c22f1befdb/237134_PMK_Spring2024-ODM_BRAUN_Braun_FrontDoor_OnTech_Family_4647.jpg',
  description: ``,
  originalHeight: 5464,
  originalWidth: 8192
}

/**
 * ![Refurb Filler Image](https://images.ctfassets.net/v6awd0kabi65/7pNivMZmFXvtd8XkWeri1Z/93b8dda1a82148795cf6f740aa681ace/recommended-system-keypad-base-station.png?w=120&h=120&fit=pad)
 *
 * Refurb Filler Image
 *
 *
 */
export const IMG_7pNivMZmFXvtd8XkWeri1Z = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7pNivMZmFXvtd8XkWeri1Z/93b8dda1a82148795cf6f740aa681ace/recommended-system-keypad-base-station.png',
  description: ``,
  originalHeight: 566,
  originalWidth: 799
}

/**
 * ![Installation](https://images.ctfassets.net/v6awd0kabi65/2Kc2dmx24mnjhUeS0P433J/42d3e537fa5e4ff399a714d0e404151a/Installation_still.png?w=120&h=120&fit=pad)
 *
 * Installation
 *
 *
 */
export const IMG_2Kc2dmx24mnjhUeS0P433J = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2Kc2dmx24mnjhUeS0P433J/42d3e537fa5e4ff399a714d0e404151a/Installation_still.png',
  description: ``,
  originalHeight: 740,
  originalWidth: 1316
}

/**
 * ![ODCamS2 app 4](https://images.ctfassets.net/v6awd0kabi65/1pcCEnx5V7hIpxOmGlRW5t/15f85307f3b16298e8e7f3cf6b310bec/ODCam_app_4.png?w=120&h=120&fit=pad)
 *
 * ODCamS2 app 4
 *
 *
 */
export const IMG_1pcCEnx5V7hIpxOmGlRW5t = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1pcCEnx5V7hIpxOmGlRW5t/15f85307f3b16298e8e7f3cf6b310bec/ODCam_app_4.png',
  description: ``,
  originalHeight: 1254,
  originalWidth: 1000
}

/**
 * ![ODCamS2 app 3](https://images.ctfassets.net/v6awd0kabi65/7tWyLh46nR77mkSUTHeDmL/8a08452d144d16bd3f69991352b8c875/ODCamS2_app_3.png?w=120&h=120&fit=pad)
 *
 * ODCamS2 app 3
 *
 *
 */
export const IMG_7tWyLh46nR77mkSUTHeDmL = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7tWyLh46nR77mkSUTHeDmL/8a08452d144d16bd3f69991352b8c875/ODCamS2_app_3.png',
  description: ``,
  originalHeight: 1254,
  originalWidth: 1011
}

/**
 * ![ODCamS2 app 2](https://images.ctfassets.net/v6awd0kabi65/4Z8llcbmkzgCXrcPei3edz/037b48a6198f2dbcdffea79e7a600411/ODCamS2_app_2.png?w=120&h=120&fit=pad)
 *
 * ODCamS2 app 2
 *
 *
 */
export const IMG_4Z8llcbmkzgCXrcPei3edz = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4Z8llcbmkzgCXrcPei3edz/037b48a6198f2dbcdffea79e7a600411/ODCamS2_app_2.png',
  description: ``,
  originalHeight: 1254,
  originalWidth: 1000
}

/**
 * ![ODCamS2 app 1](https://images.ctfassets.net/v6awd0kabi65/5uEnfO1IJzZYUgUIBirqLw/102523b08e216865601a00b768a04200/ODCamS2_app_1.png?w=120&h=120&fit=pad)
 *
 * ODCamS2 app 1
 *
 *
 */
export const IMG_5uEnfO1IJzZYUgUIBirqLw = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5uEnfO1IJzZYUgUIBirqLw/102523b08e216865601a00b768a04200/ODCamS2_app_1.png',
  description: ``,
  originalHeight: 1254,
  originalWidth: 1011
}

/**
 * ![ODCamS2 Carousel 3](https://images.ctfassets.net/v6awd0kabi65/2c1OzQYxzOvgPspPF4Rhtd/f2c33c498a10a98bacec5778ea6f3d6a/ODCam_Carousel_3.jpg?w=120&h=120&fit=pad)
 *
 * ODCamS2 Carousel 3
 *
 *
 */
export const IMG_2c1OzQYxzOvgPspPF4Rhtd = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2c1OzQYxzOvgPspPF4Rhtd/f2c33c498a10a98bacec5778ea6f3d6a/ODCam_Carousel_3.jpg',
  description: ``,
  originalHeight: 882,
  originalWidth: 1118
}

/**
 * ![How it works - mobile app](https://images.ctfassets.net/v6awd0kabi65/7hsvAkBgaVTjJj3D8FU9Lt/58b38209d87f2579c9519a35cdec212b/1707aa0f-5d29-4a88-9b7a-4b5b7c269b58.png?w=120&h=120&fit=pad)
 *
 * How it works - mobile app
 *
 * A phone showing the mobile app with a label "Everything is okay"
 */
export const IMG_7hsvAkBgaVTjJj3D8FU9Lt = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7hsvAkBgaVTjJj3D8FU9Lt/58b38209d87f2579c9519a35cdec212b/1707aa0f-5d29-4a88-9b7a-4b5b7c269b58.png',
  description: `A phone showing the mobile app with a label "Everything is okay"`,
  originalHeight: 870,
  originalWidth: 1260
}

/**
 * ![How it works - keypad](https://images.ctfassets.net/v6awd0kabi65/pwzBt33cL6NlKAdBbAsn0/a813dc3e240aff7b00ceadad3772d021/76dfb86c-a7fa-47aa-af61-015258871f7e.webp?w=120&h=120&fit=pad)
 *
 * How it works - keypad
 *
 * A key pad being pressed
 */
export const IMG_pwzBt33cL6NlKAdBbAsn0 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/pwzBt33cL6NlKAdBbAsn0/a813dc3e240aff7b00ceadad3772d021/76dfb86c-a7fa-47aa-af61-015258871f7e.webp',
  description: `A key pad being pressed`,
  originalHeight: 870,
  originalWidth: 1260
}

/**
 * ![How it works - Kit image 1](https://images.ctfassets.net/v6awd0kabi65/5Bg653wnRwokoAYwTfNmaQ/c25966ac5cfeb0da23c75a41df29baac/d43d5ab1-3ae7-4bf1-8690-877e2da22284.webp?w=120&h=120&fit=pad)
 *
 * How it works - Kit image 1
 *
 * How it works - Kit image 1
 */
export const IMG_5Bg653wnRwokoAYwTfNmaQ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5Bg653wnRwokoAYwTfNmaQ/c25966ac5cfeb0da23c75a41df29baac/d43d5ab1-3ae7-4bf1-8690-877e2da22284.webp',
  description: `How it works - Kit image 1`,
  originalHeight: 870,
  originalWidth: 1260
}

/**
 * ![Support Icon](https://images.ctfassets.net/v6awd0kabi65/3vhXYtGGaidTD63fCBKAhY/f40989ee3a3b8562871b53a75b354b26/support-icon.webp?w=120&h=120&fit=pad)
 *
 * Support Icon
 *
 * Support Icon
 */
export const IMG_3vhXYtGGaidTD63fCBKAhY = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3vhXYtGGaidTD63fCBKAhY/f40989ee3a3b8562871b53a75b354b26/support-icon.webp',
  description: `Support Icon`,
  originalHeight: 259,
  originalWidth: 260
}

/**
 * ![Icon learn](https://images.ctfassets.net/v6awd0kabi65/7iehLW5ujoIvBvxESCYgd6/11623514aa0d8df82254e9517a2da386/icon_learn.png?w=120&h=120&fit=pad)
 *
 * Icon learn
 *
 * Learn icon
 */
export const IMG_7iehLW5ujoIvBvxESCYgd6 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7iehLW5ujoIvBvxESCYgd6/11623514aa0d8df82254e9517a2da386/icon_learn.png',
  description: `Learn icon`,
  originalHeight: 66,
  originalWidth: 74
}

/**
 * ![Icon expert](https://images.ctfassets.net/v6awd0kabi65/wq6rPTN1ITjECA0sBl52E/3b44dacf53ab402893107949df8a1f13/icon_expert.png?w=120&h=120&fit=pad)
 *
 * Icon expert
 *
 * Expert Icon
 */
export const IMG_wq6rPTN1ITjECA0sBl52E = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/wq6rPTN1ITjECA0sBl52E/3b44dacf53ab402893107949df8a1f13/icon_expert.png',
  description: `Expert Icon`,
  originalHeight: 54,
  originalWidth: 68
}

/**
 * ![Icon money](https://images.ctfassets.net/v6awd0kabi65/HB1Lh3AKSxc5rM9eVap4i/ebf641173ebf49d071c887bd61b4e66d/icon_money.png?w=120&h=120&fit=pad)
 *
 * Icon money
 *
 * Money Icon
 */
export const IMG_HB1Lh3AKSxc5rM9eVap4i = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/HB1Lh3AKSxc5rM9eVap4i/ebf641173ebf49d071c887bd61b4e66d/icon_money.png',
  description: `Money Icon`,
  originalHeight: 54,
  originalWidth: 74
}

/**
 * ![Icon support](https://images.ctfassets.net/v6awd0kabi65/7keeyBYHgUsHD4hzxQLPHI/d30766dfc5d28b97d923c2bae455824c/icon_support.png?w=120&h=120&fit=pad)
 *
 * Icon support
 *
 * Support icon
 */
export const IMG_7keeyBYHgUsHD4hzxQLPHI = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7keeyBYHgUsHD4hzxQLPHI/d30766dfc5d28b97d923c2bae455824c/icon_support.png',
  description: `Support icon`,
  originalHeight: 73,
  originalWidth: 55
}

/**
 * ![Icon set up](https://images.ctfassets.net/v6awd0kabi65/5SWiSnlv7Rq4ojcELFdhJt/3dc2bf13b53de28832d91909a222f364/icon_setup.png?w=120&h=120&fit=pad)
 *
 * Icon set up
 *
 * Easy to set up icon
 */
export const IMG_5SWiSnlv7Rq4ojcELFdhJt = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5SWiSnlv7Rq4ojcELFdhJt/3dc2bf13b53de28832d91909a222f364/icon_setup.png',
  description: `Easy to set up icon`,
  originalHeight: 74,
  originalWidth: 61
}

/**
 * ![Header | Professional Monitoring - Odmon](https://images.ctfassets.net/v6awd0kabi65/2gnj0MqS2RvadjpecJDG6K/f906dea538ade4631ed1fe9d16e3a744/Monitoring_nav.jpg?w=120&h=120&fit=pad)
 *
 * Header | Professional Monitoring - Odmon
 *
 * Professional Monitoring
 */
export const IMG_2gnj0MqS2RvadjpecJDG6K = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2gnj0MqS2RvadjpecJDG6K/f906dea538ade4631ed1fe9d16e3a744/Monitoring_nav.jpg',
  description: `Professional Monitoring`,
  originalHeight: 573,
  originalWidth: 856
}

/**
 * ![Header | Installation Options - Odmon](https://images.ctfassets.net/v6awd0kabi65/75LoLEcNP7nJnbsRPpG3W6/2f20561ec200a7ebc101bd029cefa2a6/Install_nav__1_.jpg?w=120&h=120&fit=pad)
 *
 * Header | Installation Options - Odmon
 *
 * Installation Options
 */
export const IMG_75LoLEcNP7nJnbsRPpG3W6 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/75LoLEcNP7nJnbsRPpG3W6/2f20561ec200a7ebc101bd029cefa2a6/Install_nav__1_.jpg',
  description: `Installation Options`,
  originalHeight: 573,
  originalWidth: 856
}

/**
 * ![Header | Outdoor Basic Package - Odmon](https://images.ctfassets.net/v6awd0kabi65/2S40uNCo4M8wvKgkKPQ17m/1019f56f1661c585e2da932fc0b46efc/Lighthouse.jpg?w=120&h=120&fit=pad)
 *
 * Header | Outdoor Basic Package - Odmon
 *
 * Outdoor Basic Package
 */
export const IMG_2S40uNCo4M8wvKgkKPQ17m = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2S40uNCo4M8wvKgkKPQ17m/1019f56f1661c585e2da932fc0b46efc/Lighthouse.jpg',
  description: `Outdoor Basic Package`,
  originalHeight: 684,
  originalWidth: 1023
}

/**
 * ![Header | Outdoor Elite Package - Odmon](https://images.ctfassets.net/v6awd0kabi65/4bC09EpnddkbaJd0Rw1GS8/6794b0ab7d32854926012fb1ffa559a8/Beacon.jpg?w=120&h=120&fit=pad)
 *
 * Header | Outdoor Elite Package - Odmon
 *
 * Outdoor Elite Package
 */
export const IMG_4bC09EpnddkbaJd0Rw1GS8 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4bC09EpnddkbaJd0Rw1GS8/6794b0ab7d32854926012fb1ffa559a8/Beacon.jpg',
  description: `Outdoor Elite Package`,
  originalHeight: 684,
  originalWidth: 1023
}

/**
 * ![Header | Customize A Package - Odmon](https://images.ctfassets.net/v6awd0kabi65/26vernKYKmkWfqIw6BiBFm/38aa00b6844cbc380f598d99f79e2da8/Customize_Art.png?w=120&h=120&fit=pad)
 *
 * Header | Customize A Package - Odmon
 *
 * Customize a Package
 */
export const IMG_26vernKYKmkWfqIw6BiBFm = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/26vernKYKmkWfqIw6BiBFm/38aa00b6844cbc380f598d99f79e2da8/Customize_Art.png',
  description: `Customize a Package`,
  originalHeight: 343,
  originalWidth: 342
}

/**
 * ![Make convenient, equal payments with automatic payments](https://images.ctfassets.net/v6awd0kabi65/7Ku6r2bIvCflnlot18j0Gw/6645b7bbfa08422c6cbe9828d06fe62a/image__3_.png?w=120&h=120&fit=pad)
 *
 * Make convenient, equal payments with automatic payments
 *
 *
 */
export const IMG_7Ku6r2bIvCflnlot18j0Gw = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7Ku6r2bIvCflnlot18j0Gw/6645b7bbfa08422c6cbe9828d06fe62a/image__3_.png',
  description: ``,
  originalHeight: 818,
  originalWidth: 854
}

/**
 * ![At checkout, select Affirm and create an account](https://images.ctfassets.net/v6awd0kabi65/5fMETHdT0tEoOON2gSiFHx/b6ae828fa5c44a3b74dc26c3ec5a3442/image__1_.png?w=120&h=120&fit=pad)
 *
 * At checkout, select Affirm and create an account
 *
 *
 */
export const IMG_5fMETHdT0tEoOON2gSiFHx = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5fMETHdT0tEoOON2gSiFHx/b6ae828fa5c44a3b74dc26c3ec5a3442/image__1_.png',
  description: ``,
  originalHeight: 818,
  originalWidth: 854
}

/**
 * ![Compare and select the payment schedule that works best for you](https://images.ctfassets.net/v6awd0kabi65/r7P257pzhH0j8Z55gorcB/363c267b6dd70ce68f141fa3d84b1869/image__2_.png?w=120&h=120&fit=pad)
 *
 * Compare and select the payment schedule that works best for you
 *
 *
 */
export const IMG_r7P257pzhH0j8Z55gorcB = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/r7P257pzhH0j8Z55gorcB/363c267b6dd70ce68f141fa3d84b1869/image__2_.png',
  description: ``,
  originalHeight: 818,
  originalWidth: 854
}

/**
 * ![Desktop - Spring Product Refresh 2022 - Outdoor - Shield Camera at Night](https://images.ctfassets.net/v6awd0kabi65/1BeMOp8UPKMeyUGkmRHhtM/50dbd2cb55ad123488e86d5cec675b8e/image.png?w=120&h=120&fit=pad)
 *
 * Desktop - Spring Product Refresh 2022 - Outdoor - Shield Camera at Night
 *
 *
 */
export const IMG_1BeMOp8UPKMeyUGkmRHhtM = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1BeMOp8UPKMeyUGkmRHhtM/50dbd2cb55ad123488e86d5cec675b8e/image.png',
  description: ``,
  originalHeight: 1200,
  originalWidth: 2624
}

/**
 * ![Mission - Privacy Page - 08-24](https://images.ctfassets.net/v6awd0kabi65/16IJdV9lAbEqCs3h4qYBo1/311a96846e15dbbeb04c13d8bb11af2b/simplisafe_privacy_illustration_05.jpg?w=120&h=120&fit=pad)
 *
 * Mission - Privacy Page - 08-24
 *
 * Agents
 */
export const IMG_16IJdV9lAbEqCs3h4qYBo1 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/16IJdV9lAbEqCs3h4qYBo1/311a96846e15dbbeb04c13d8bb11af2b/simplisafe_privacy_illustration_05.jpg',
  description: `Agents`,
  originalHeight: 490,
  originalWidth: 600
}

/**
 * ![You control your data - Privacy Page - 08-24](https://images.ctfassets.net/v6awd0kabi65/3jwWOz6CwaGo2ZKsoEsjsk/0a960270098e1d33eaf149734cda6ba5/simplisafe_privacy_illustration_04.jpg?w=120&h=120&fit=pad)
 *
 * You control your data - Privacy Page - 08-24
 *
 * Checking mobile app
 */
export const IMG_3jwWOz6CwaGo2ZKsoEsjsk = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3jwWOz6CwaGo2ZKsoEsjsk/0a960270098e1d33eaf149734cda6ba5/simplisafe_privacy_illustration_04.jpg',
  description: `Checking mobile app`,
  originalHeight: 490,
  originalWidth: 600
}

/**
 * ![More security - Privacy Page - 08-24](https://images.ctfassets.net/v6awd0kabi65/636u64Y9esBEJk3dL4fY4N/c51bd775b099fe86b48c8ecb1bb7a90f/simplisafe_privacy_illustration_02.jpg?w=120&h=120&fit=pad)
 *
 * More security - Privacy Page - 08-24
 *
 * Adjusting SimpliCam
 */
export const IMG_636u64Y9esBEJk3dL4fY4N = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/636u64Y9esBEJk3dL4fY4N/c51bd775b099fe86b48c8ecb1bb7a90f/simplisafe_privacy_illustration_02.jpg',
  description: `Adjusting SimpliCam`,
  originalHeight: 490,
  originalWidth: 600
}

/**
 * ![Verifypass logo](https://images.ctfassets.net/v6awd0kabi65/2PqD8P0e5BtfboJ3MaJtRl/d6f6b9a0ba2535013986cb26b0b59f59/image__14_.webp?w=120&h=120&fit=pad)
 *
 * Verifypass logo
 *
 *
 */
export const IMG_2PqD8P0e5BtfboJ3MaJtRl = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2PqD8P0e5BtfboJ3MaJtRl/d6f6b9a0ba2535013986cb26b0b59f59/image__14_.webp',
  description: ``,
  originalHeight: 80,
  originalWidth: 236
}

/**
 * ![First Responders - Police](https://images.ctfassets.net/v6awd0kabi65/2yh3DzBMkitaktKYLFAYzk/7c2ba3eabf45d3e83ba1dbc619150db6/police.png?w=120&h=120&fit=pad)
 *
 * First Responders - Police
 *
 *
 */
export const IMG_2yh3DzBMkitaktKYLFAYzk = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2yh3DzBMkitaktKYLFAYzk/7c2ba3eabf45d3e83ba1dbc619150db6/police.png',
  description: ``,
  originalHeight: 542,
  originalWidth: 620
}

/**
 * ![First Responders - Teachers](https://images.ctfassets.net/v6awd0kabi65/7j7Qy5P9QbOKqD1uPHci6S/7e799b6f5d652314917a42eef429a8de/teachers.png?w=120&h=120&fit=pad)
 *
 * First Responders - Teachers
 *
 *
 */
export const IMG_7j7Qy5P9QbOKqD1uPHci6S = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7j7Qy5P9QbOKqD1uPHci6S/7e799b6f5d652314917a42eef429a8de/teachers.png',
  description: ``,
  originalHeight: 542,
  originalWidth: 620
}

/**
 * ![First Responders - Medical](https://images.ctfassets.net/v6awd0kabi65/2djgK9j6Z6wNJLXfFf6S2R/095c182806ebe47fe7b6cf45e86b8444/medical.png?w=120&h=120&fit=pad)
 *
 * First Responders - Medical
 *
 *
 */
export const IMG_2djgK9j6Z6wNJLXfFf6S2R = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2djgK9j6Z6wNJLXfFf6S2R/095c182806ebe47fe7b6cf45e86b8444/medical.png',
  description: ``,
  originalHeight: 542,
  originalWidth: 620
}

/**
 * ![First Responders - Military](https://images.ctfassets.net/v6awd0kabi65/1JK2X4IGWReVSpTLFjmcl8/f92b1fa624f0b11d9b28a760428be735/military.png?w=120&h=120&fit=pad)
 *
 * First Responders - Military
 *
 *
 */
export const IMG_1JK2X4IGWReVSpTLFjmcl8 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1JK2X4IGWReVSpTLFjmcl8/f92b1fa624f0b11d9b28a760428be735/military.png',
  description: ``,
  originalHeight: 542,
  originalWidth: 620
}

/**
 * ![Protectors page - Repeat icon](https://images.ctfassets.net/v6awd0kabi65/2CAClGWhrfSHLh1OqIf6Y0/84963b3df28a3c0d5cab69f49c16c130/image__17_.png?w=120&h=120&fit=pad)
 *
 * Protectors page - Repeat icon
 *
 *
 */
export const IMG_2CAClGWhrfSHLh1OqIf6Y0 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2CAClGWhrfSHLh1OqIf6Y0/84963b3df28a3c0d5cab69f49c16c130/image__17_.png',
  description: ``,
  originalHeight: 152,
  originalWidth: 152
}

/**
 * ![protectors checkout icon](https://images.ctfassets.net/v6awd0kabi65/3EAAzxKMaQ3BZz8k0k4sb1/02f5f9c6d5444bf10d08667d4b4f26da/image__16_.png?w=120&h=120&fit=pad)
 *
 * protectors checkout icon
 *
 *
 */
export const IMG_3EAAzxKMaQ3BZz8k0k4sb1 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3EAAzxKMaQ3BZz8k0k4sb1/02f5f9c6d5444bf10d08667d4b4f26da/image__16_.png',
  description: ``,
  originalHeight: 152,
  originalWidth: 152
}

/**
 * ![VerifyPassIcon](https://images.ctfassets.net/v6awd0kabi65/4opZgFXtu8qogPXEO4JlFW/ff5609560a9cebe19634daa25984cae0/image__15_.png?w=120&h=120&fit=pad)
 *
 * VerifyPassIcon
 *
 *
 */
export const IMG_4opZgFXtu8qogPXEO4JlFW = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4opZgFXtu8qogPXEO4JlFW/ff5609560a9cebe19634daa25984cae0/image__15_.png',
  description: ``,
  originalHeight: 152,
  originalWidth: 152
}

/**
 * ![Back to School Safety](https://images.ctfassets.net/v6awd0kabi65/2Fpqse418tR758yAraBT7Q/57e5e878626c04587251a854e2194bef/Low_Res-Kids_Living_Room_023_FIN_WEBX.jpg?w=120&h=120&fit=pad)
 *
 * Back to School Safety
 *
 *
 */
export const IMG_2Fpqse418tR758yAraBT7Q = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2Fpqse418tR758yAraBT7Q/57e5e878626c04587251a854e2194bef/Low_Res-Kids_Living_Room_023_FIN_WEBX.jpg',
  description: ``,
  originalHeight: 1667,
  originalWidth: 2500
}

/**
 * ![First Responder Hero](https://images.ctfassets.net/v6awd0kabi65/5vskiLTQKrWYM2cve00pkd/22b2a4f3166ee8854b4af5351dda141b/hero_first-responder_3x.jpg?w=120&h=120&fit=pad)
 *
 * First Responder Hero
 *
 * A soldier in uniform returns home, reaching out with a teddy bear. A smiling boy runs towards him, with another adult in the background
 */
export const IMG_5vskiLTQKrWYM2cve00pkd = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5vskiLTQKrWYM2cve00pkd/22b2a4f3166ee8854b4af5351dda141b/hero_first-responder_3x.jpg',
  description: `A soldier in uniform returns home, reaching out with a teddy bear. A smiling boy runs towards him, with another adult in the background`,
  originalHeight: 1800,
  originalWidth: 3936
}

/**
 * ![Entry Sensor 1 (BMS - More Details Experience - Sensor Modal)](https://images.ctfassets.net/v6awd0kabi65/6dgOPEo75Zl5KBnGZ77Mq6/52667b1858fc3e2a85110f67e37b6d27/Entry_1FW.jpg?w=120&h=120&fit=pad)
 *
 * Entry Sensor 1 (BMS - More Details Experience - Sensor Modal)
 *
 * Entry Sensor
 */
export const IMG_6dgOPEo75Zl5KBnGZ77Mq6 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6dgOPEo75Zl5KBnGZ77Mq6/52667b1858fc3e2a85110f67e37b6d27/Entry_1FW.jpg',
  description: `Entry Sensor`,
  originalHeight: 1112,
  originalWidth: 1824
}

/**
 * ![Yard Sign](https://images.ctfassets.net/v6awd0kabi65/3Z9Ub4fyokWrXdQNdpjvx7/2c39d2db4a521291647a37c718b41062/Yard_sign_image.png?w=120&h=120&fit=pad)
 *
 * Yard Sign
 *
 * SimpliSafe Yard Sign
 */
export const IMG_3Z9Ub4fyokWrXdQNdpjvx7 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3Z9Ub4fyokWrXdQNdpjvx7/2c39d2db4a521291647a37c718b41062/Yard_sign_image.png',
  description: `SimpliSafe Yard Sign`,
  originalHeight: 320,
  originalWidth: 320
}

/**
 * ![ODCamS2 Carousel 1](https://images.ctfassets.net/v6awd0kabi65/519jS2de9Ok2zAPWshmpgO/209b12660d517ac28dcee731b7bbbe93/ODCamS2_Carousel_1.png?w=120&h=120&fit=pad)
 *
 * ODCamS2 Carousel 1
 *
 *
 */
export const IMG_519jS2de9Ok2zAPWshmpgO = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/519jS2de9Ok2zAPWshmpgO/209b12660d517ac28dcee731b7bbbe93/ODCamS2_Carousel_1.png',
  description: ``,
  originalHeight: 882,
  originalWidth: 1118
}

/**
 * ![ODCamS2 Carousel 4](https://images.ctfassets.net/v6awd0kabi65/3t2Y3fXL3QvyVG69Tu7pkw/1c4e01feb2739051404d7cff993d0d56/ODCamS2_Carousel_4.png?w=120&h=120&fit=pad)
 *
 * ODCamS2 Carousel 4
 *
 *
 */
export const IMG_3t2Y3fXL3QvyVG69Tu7pkw = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3t2Y3fXL3QvyVG69Tu7pkw/1c4e01feb2739051404d7cff993d0d56/ODCamS2_Carousel_4.png',
  description: ``,
  originalHeight: 882,
  originalWidth: 1118
}

/**
 * ![ODCamS2 Carousel 5](https://images.ctfassets.net/v6awd0kabi65/2JaRgCAruFeqIgN84K6pDR/6bf40c88373d012c381d803cbd84a846/ODCamS2_Carousel_5.png?w=120&h=120&fit=pad)
 *
 * ODCamS2 Carousel 5
 *
 *
 */
export const IMG_2JaRgCAruFeqIgN84K6pDR = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2JaRgCAruFeqIgN84K6pDR/6bf40c88373d012c381d803cbd84a846/ODCamS2_Carousel_5.png',
  description: ``,
  originalHeight: 882,
  originalWidth: 1118
}

/**
 * ![Installation still](https://images.ctfassets.net/v6awd0kabi65/6QgS4kQAbOPmy2mWZly5bC/b2425d298e7e8438c4a78fa17af848b7/Installation_still.png?w=120&h=120&fit=pad)
 *
 * Installation still
 *
 *
 */
export const IMG_6QgS4kQAbOPmy2mWZly5bC = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6QgS4kQAbOPmy2mWZly5bC/b2425d298e7e8438c4a78fa17af848b7/Installation_still.png',
  description: ``,
  originalHeight: 740,
  originalWidth: 1316
}

/**
 * ![Home safety and security during a heatwave](https://images.ctfassets.net/v6awd0kabi65/2WPUN5UUyO2hhPqTW5E7gy/12dbd28d0b0fc5d11aa709a38134c279/pexels-pixabay-161420.jpg?w=120&h=120&fit=pad)
 *
 * Home safety and security during a heatwave
 *
 * null
 */
export const IMG_2WPUN5UUyO2hhPqTW5E7gy = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2WPUN5UUyO2hhPqTW5E7gy/12dbd28d0b0fc5d11aa709a38134c279/pexels-pixabay-161420.jpg',
  description: `null`,
  originalHeight: 3648,
  originalWidth: 5472
}

/**
 * ![12 things burglars don’t want you to know](https://images.ctfassets.net/v6awd0kabi65/4dJ0yjyOONbTcLJAHKyfev/df7e2f0e7676617b8e0159b596904bc7/pexels-life-of-pix-4291.jpg?w=120&h=120&fit=pad)
 *
 * 12 things burglars don’t want you to know
 *
 *
 */
export const IMG_4dJ0yjyOONbTcLJAHKyfev = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4dJ0yjyOONbTcLJAHKyfev/df7e2f0e7676617b8e0159b596904bc7/pexels-life-of-pix-4291.jpg',
  description: ``,
  originalHeight: 3840,
  originalWidth: 5760
}

/**
 * ![The Ultimate Guide to Securing Your Sliding Glass Door](https://images.ctfassets.net/v6awd0kabi65/1Wf9ebFGzWF8EHag1OWCm7/41999b08d91657eea1815c10c7d83a6e/dylan-ferreira-iek0Lov5FoU-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * The Ultimate Guide to Securing Your Sliding Glass Door
 *
 *
 */
export const IMG_1Wf9ebFGzWF8EHag1OWCm7 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1Wf9ebFGzWF8EHag1OWCm7/41999b08d91657eea1815c10c7d83a6e/dylan-ferreira-iek0Lov5FoU-unsplash.jpg',
  description: ``,
  originalHeight: 2615,
  originalWidth: 4648
}

/**
 * ![Home security checklist before leaving your home | SimpliSafe](https://images.ctfassets.net/v6awd0kabi65/7sdXmJ8Zq3cvyZ3KPoVnXc/b01d35f6d28d4c67beb27fbb250f73a4/Untitled_design__6_.png?w=120&h=120&fit=pad)
 *
 * Home security checklist before leaving your home | SimpliSafe
 *
 * Ensure your home's safety with our security checklist. Learn essential measures to protect your property and gain peace of mind every time you leave.
 */
export const IMG_7sdXmJ8Zq3cvyZ3KPoVnXc = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7sdXmJ8Zq3cvyZ3KPoVnXc/b01d35f6d28d4c67beb27fbb250f73a4/Untitled_design__6_.png',
  description: `Ensure your home's safety with our security checklist. Learn essential measures to protect your property and gain peace of mind every time you leave.`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![12 travel tips to protect your home whilst you're away | SimpliSafe](https://images.ctfassets.net/v6awd0kabi65/4ZO6zdEOOl8Zwi5mYZXDUM/bf6c3a71e1e66115f740bf11745f4a34/Untitled_design__5_.png?w=120&h=120&fit=pad)
 *
 * 12 travel tips to protect your home whilst you're away | SimpliSafe
 *
 * Don’t ruin your holiday with worries about your home security! Follow these travel tips to protect your home security when on holiday.
 */
export const IMG_4ZO6zdEOOl8Zwi5mYZXDUM = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4ZO6zdEOOl8Zwi5mYZXDUM/bf6c3a71e1e66115f740bf11745f4a34/Untitled_design__5_.png',
  description: `Don’t ruin your holiday with worries about your home security! Follow these travel tips to protect your home security when on holiday.`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Employee Code of Conduct](https://assets.ctfassets.net/v6awd0kabi65/2J938nDY8b6MQC4AucbZs5/c588e6671b082b94709004789950d05b/SimpliRight_Code_External_-_Final_May24.pdf?w=120&h=120&fit=pad)
 *
 * Employee Code of Conduct
 *
 *
 */
export const IMG_2J938nDY8b6MQC4AucbZs5 = {
  url: 'https://assets.ctfassets.net/v6awd0kabi65/2J938nDY8b6MQC4AucbZs5/c588e6671b082b94709004789950d05b/SimpliRight_Code_External_-_Final_May24.pdf',
  description: ``,
  originalHeight: null,
  originalWidth: null
}

/**
 * ![ODCamS2 standalone-1040](https://images.ctfassets.net/v6awd0kabi65/4EhyZ00lK7QyrREyCzxw5b/cb20324f785e8acb63ae9057e8465a08/ODCam_standalone-1040.png?w=120&h=120&fit=pad)
 *
 * ODCamS2 standalone-1040
 *
 *
 */
export const IMG_4EhyZ00lK7QyrREyCzxw5b = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4EhyZ00lK7QyrREyCzxw5b/cb20324f785e8acb63ae9057e8465a08/ODCam_standalone-1040.png',
  description: ``,
  originalHeight: 758,
  originalWidth: 1040
}

/**
 * ![ODCamS2 active guard outdoor protection](https://images.ctfassets.net/v6awd0kabi65/6Js7WgK1k3jDL4PpmGu8Sg/e9bb2a6c104fd819b537f6f68111e79b/ODCamS2_active_guard_outdoor_protection.png?w=120&h=120&fit=pad)
 *
 * ODCamS2 active guard outdoor protection
 *
 *
 */
export const IMG_6Js7WgK1k3jDL4PpmGu8Sg = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6Js7WgK1k3jDL4PpmGu8Sg/e9bb2a6c104fd819b537f6f68111e79b/ODCamS2_active_guard_outdoor_protection.png',
  description: ``,
  originalHeight: 1056,
  originalWidth: 1932
}

/**
 * ![ODCamS2 diagram 2](https://images.ctfassets.net/v6awd0kabi65/4XhBNw0xPnQTd8hiUaPVjs/01c7b04de289df5a9cf61d9a5ac214f8/ODCamS2_diagram_2.png?w=120&h=120&fit=pad)
 *
 * ODCamS2 diagram 2
 *
 *
 */
export const IMG_4XhBNw0xPnQTd8hiUaPVjs = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4XhBNw0xPnQTd8hiUaPVjs/01c7b04de289df5a9cf61d9a5ac214f8/ODCamS2_diagram_2.png',
  description: ``,
  originalHeight: 2542,
  originalWidth: 2198
}

/**
 * ![Important Security Tips To Keep Home And Family Secure](https://images.ctfassets.net/v6awd0kabi65/41DLlTS5gqpi4oFxlzNWNW/0e5ebe26673efb84ae6ea93112d2ef05/pexels-fotios-photos-1909014.jpg?w=120&h=120&fit=pad)
 *
 * Important Security Tips To Keep Home And Family Secure
 *
 * Keep your loved ones safe with our top home security tips. From complete home safety tips to keeping kids and pets safe - we have tons of tips to share.
 */
export const IMG_41DLlTS5gqpi4oFxlzNWNW = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/41DLlTS5gqpi4oFxlzNWNW/0e5ebe26673efb84ae6ea93112d2ef05/pexels-fotios-photos-1909014.jpg',
  description: `Keep your loved ones safe with our top home security tips. From complete home safety tips to keeping kids and pets safe - we have tons of tips to share.`,
  originalHeight: 4000,
  originalWidth: 6000
}

/**
 * ![How to trick burglars into thinking an empty home is occupied](https://images.ctfassets.net/v6awd0kabi65/58oRd8u6GOHpl4whkmprWl/ad87880db14f68dbe13445114460c98a/Untitled_design__3_.png?w=120&h=120&fit=pad)
 *
 * How to trick burglars into thinking an empty home is occupied
 *
 *
 */
export const IMG_58oRd8u6GOHpl4whkmprWl = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/58oRd8u6GOHpl4whkmprWl/ad87880db14f68dbe13445114460c98a/Untitled_design__3_.png',
  description: ``,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Press Kit - keypad white](https://images.ctfassets.net/v6awd0kabi65/4TBVKW1zRbI9Ku2UKjahC5/6d759878d95d59158a05fe266d458b74/ss_presskit10.jpg?w=120&h=120&fit=pad)
 *
 * Press Kit - keypad white
 *
 *
 */
export const IMG_4TBVKW1zRbI9Ku2UKjahC5 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4TBVKW1zRbI9Ku2UKjahC5/6d759878d95d59158a05fe266d458b74/ss_presskit10.jpg',
  description: ``,
  originalHeight: 3600,
  originalWidth: 5760
}

/**
 * ![Press kit - base station image](https://images.ctfassets.net/v6awd0kabi65/3OBRmOYwOBMhPZaWLc1zUj/8c758e1312b0c5011e556ea9366ec24a/ss_presskit3.jpg?w=120&h=120&fit=pad)
 *
 * Press kit - base station image
 *
 *
 */
export const IMG_3OBRmOYwOBMhPZaWLc1zUj = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3OBRmOYwOBMhPZaWLc1zUj/8c758e1312b0c5011e556ea9366ec24a/ss_presskit3.jpg',
  description: ``,
  originalHeight: 3879,
  originalWidth: 3906
}

/**
 * ![Press Kit - SimpliSafe water sensor](https://images.ctfassets.net/v6awd0kabi65/3Xz5I9lAptPUzIt3zM3fmD/927ab231f9aa37d0fa674fdfe660a992/ss_presskit20.jpg?w=120&h=120&fit=pad)
 *
 * Press Kit - SimpliSafe water sensor
 *
 * SimpliSafe water sensor
 */
export const IMG_3Xz5I9lAptPUzIt3zM3fmD = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3Xz5I9lAptPUzIt3zM3fmD/927ab231f9aa37d0fa674fdfe660a992/ss_presskit20.jpg',
  description: `SimpliSafe water sensor`,
  originalHeight: 3600,
  originalWidth: 5760
}

/**
 * ![Press Kit - SimpliCam](https://images.ctfassets.net/v6awd0kabi65/x3t5Y4LSKl3kxYr5XmZTw/105bccd2ffc858ecf1aa43ff57296e4d/ss_presskit19.jpg?w=120&h=120&fit=pad)
 *
 * Press Kit - SimpliCam
 *
 * SimpliCam
 */
export const IMG_x3t5Y4LSKl3kxYr5XmZTw = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/x3t5Y4LSKl3kxYr5XmZTw/105bccd2ffc858ecf1aa43ff57296e4d/ss_presskit19.jpg',
  description: `SimpliCam`,
  originalHeight: 2782,
  originalWidth: 3983
}

/**
 * ![Press Kit - Freeze sensor](https://images.ctfassets.net/v6awd0kabi65/68ebPBfEXi3yZu636J5Slj/312ab0fa7192291a52e9a78f17b671df/ss_presskit18.jpg?w=120&h=120&fit=pad)
 *
 * Press Kit - Freeze sensor
 *
 * Simplisafe Freeze sensor
 */
export const IMG_68ebPBfEXi3yZu636J5Slj = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/68ebPBfEXi3yZu636J5Slj/312ab0fa7192291a52e9a78f17b671df/ss_presskit18.jpg',
  description: `Simplisafe Freeze sensor`,
  originalHeight: 3600,
  originalWidth: 5760
}

/**
 * ![Press Kit - SimpliSafe Siren](https://images.ctfassets.net/v6awd0kabi65/1TAL3lXqIXVGuwiHYJihXr/2e62f741d0cf4c93528482232bd47cf8/ss_presskit17.jpg?w=120&h=120&fit=pad)
 *
 * Press Kit - SimpliSafe Siren
 *
 * SimpliSafe extra siren
 */
export const IMG_1TAL3lXqIXVGuwiHYJihXr = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1TAL3lXqIXVGuwiHYJihXr/2e62f741d0cf4c93528482232bd47cf8/ss_presskit17.jpg',
  description: `SimpliSafe extra siren`,
  originalHeight: 3600,
  originalWidth: 5760
}

/**
 * ![Press Kit - SimpliSafe Keyfob](https://images.ctfassets.net/v6awd0kabi65/7AuoYUHCVG3wCEwlORR4NJ/551abb8c100b3d0351cd3ea16e684b04/ss_presskit16.jpg?w=120&h=120&fit=pad)
 *
 * Press Kit - SimpliSafe Keyfob
 *
 *
 */
export const IMG_7AuoYUHCVG3wCEwlORR4NJ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7AuoYUHCVG3wCEwlORR4NJ/551abb8c100b3d0351cd3ea16e684b04/ss_presskit16.jpg',
  description: ``,
  originalHeight: 3600,
  originalWidth: 5760
}

/**
 * ![Press Kit - SimpliSafe Panic button](https://images.ctfassets.net/v6awd0kabi65/3zZWCZCTINaPSYC7UTMCZa/7d64494f8f32614016648b65e3e1dd74/ss_presskit15.jpg?w=120&h=120&fit=pad)
 *
 * Press Kit - SimpliSafe Panic button
 *
 * SimpliSafe Panic button
 */
export const IMG_3zZWCZCTINaPSYC7UTMCZa = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3zZWCZCTINaPSYC7UTMCZa/7d64494f8f32614016648b65e3e1dd74/ss_presskit15.jpg',
  description: `SimpliSafe Panic button`,
  originalHeight: 3600,
  originalWidth: 5760
}

/**
 * ![PressKit - SimpliSafe Entry Sensor](https://images.ctfassets.net/v6awd0kabi65/1WiA1gsAd9ad8Jy5lCejBU/5c7a5dd461e60c1548f3bb47946263c0/ss_presskit14.jpg?w=120&h=120&fit=pad)
 *
 * PressKit - SimpliSafe Entry Sensor
 *
 * SimpliSafe Entry sensor
 */
export const IMG_1WiA1gsAd9ad8Jy5lCejBU = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1WiA1gsAd9ad8Jy5lCejBU/5c7a5dd461e60c1548f3bb47946263c0/ss_presskit14.jpg',
  description: `SimpliSafe Entry sensor`,
  originalHeight: 3600,
  originalWidth: 5760
}

/**
 * ![Press Kit - Glassbreak](https://images.ctfassets.net/v6awd0kabi65/7DUVFOgpvo2Srea8hniWQj/e3eff1cedf4bff2e5df8160a29ea9d27/ss_presskit13.jpg?w=120&h=120&fit=pad)
 *
 * Press Kit - Glassbreak
 *
 * SimpliSafe glassbreak Sensor
 */
export const IMG_7DUVFOgpvo2Srea8hniWQj = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7DUVFOgpvo2Srea8hniWQj/e3eff1cedf4bff2e5df8160a29ea9d27/ss_presskit13.jpg',
  description: `SimpliSafe glassbreak Sensor`,
  originalHeight: 3125,
  originalWidth: 5000
}

/**
 * ![Press Kit - Motion Sensor](https://images.ctfassets.net/v6awd0kabi65/4SxiVdrweiai7l3S4B3hlA/87404c7c1a1fdaac8b884391ebf4a1ca/ss_presskit12.jpg?w=120&h=120&fit=pad)
 *
 * Press Kit - Motion Sensor
 *
 * SimpliSafe motion Sensor
 */
export const IMG_4SxiVdrweiai7l3S4B3hlA = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4SxiVdrweiai7l3S4B3hlA/87404c7c1a1fdaac8b884391ebf4a1ca/ss_presskit12.jpg',
  description: `SimpliSafe motion Sensor`,
  originalHeight: 3125,
  originalWidth: 5000
}

/**
 * ![Press Kit - SimpliSafe keypad obsidian](https://images.ctfassets.net/v6awd0kabi65/6cybOuCPpPlbrls0UeGSoR/80ce51342cbf3ce9b4c3d6abc60f8539/ss_presskit11.jpg?w=120&h=120&fit=pad)
 *
 * Press Kit - SimpliSafe keypad obsidian
 *
 * SimpliSafe keypad obsidian
 */
export const IMG_6cybOuCPpPlbrls0UeGSoR = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6cybOuCPpPlbrls0UeGSoR/80ce51342cbf3ce9b4c3d6abc60f8539/ss_presskit11.jpg',
  description: `SimpliSafe keypad obsidian`,
  originalHeight: 3600,
  originalWidth: 5760
}

/**
 * ![Press Kit - SimpliSafe Base 1](https://images.ctfassets.net/v6awd0kabi65/6f7hhuvTGSUCCyYqdZhGcY/075214c52f7293f47e0fb9f8f63d1710/ss_presskit9.jpg?w=120&h=120&fit=pad)
 *
 * Press Kit - SimpliSafe Base 1
 *
 * SimpliSafe Base Station cloud
 */
export const IMG_6f7hhuvTGSUCCyYqdZhGcY = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6f7hhuvTGSUCCyYqdZhGcY/075214c52f7293f47e0fb9f8f63d1710/ss_presskit9.jpg',
  description: `SimpliSafe Base Station cloud`,
  originalHeight: 3600,
  originalWidth: 5760
}

/**
 * ![Press Kit - SimpliSafe Girl](https://images.ctfassets.net/v6awd0kabi65/2pCxFnrkTdqpmf5bBX3ST9/17605c81e265de84e19cc63b9fb4051f/ss_presskit7.jpg?w=120&h=120&fit=pad)
 *
 * Press Kit - SimpliSafe Girl
 *
 * SimpliSafe Base station obsidian
 */
export const IMG_2pCxFnrkTdqpmf5bBX3ST9 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2pCxFnrkTdqpmf5bBX3ST9/17605c81e265de84e19cc63b9fb4051f/ss_presskit7.jpg',
  description: `SimpliSafe Base station obsidian`,
  originalHeight: 3840,
  originalWidth: 5006
}

/**
 * ![Press kit - Keypad](https://images.ctfassets.net/v6awd0kabi65/1ZqXtlukjkVuaMXG9KCe8B/9e2429b5719a5ab1780325d66e9e35df/ss_presskit4.jpg?w=120&h=120&fit=pad)
 *
 * Press kit - Keypad
 *
 * Keypad Cloud
 */
export const IMG_1ZqXtlukjkVuaMXG9KCe8B = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1ZqXtlukjkVuaMXG9KCe8B/9e2429b5719a5ab1780325d66e9e35df/ss_presskit4.jpg',
  description: `Keypad Cloud`,
  originalHeight: 1786,
  originalWidth: 2525
}

/**
 * ![Press kit - SimpliSafe Full System - black](https://images.ctfassets.net/v6awd0kabi65/38Ixuuis171OcVuwFpMwJ6/18991c7d4810efe227eadc19e110ff8f/ss_presskit2.png?w=120&h=120&fit=pad)
 *
 * Press kit - SimpliSafe Full System - black
 *
 * SimpliSafe Full system (black)
 */
export const IMG_38Ixuuis171OcVuwFpMwJ6 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/38Ixuuis171OcVuwFpMwJ6/18991c7d4810efe227eadc19e110ff8f/ss_presskit2.png',
  description: `SimpliSafe Full system (black)`,
  originalHeight: 1804,
  originalWidth: 2738
}

/**
 * ![Press kit - Simplisafe Full System (white)](https://images.ctfassets.net/v6awd0kabi65/1ulQQ8J3Ahuu65u0Q97K13/a36746ebae1c4542075613d67809ecd2/ss_presskit1.jpg?w=120&h=120&fit=pad)
 *
 * Press kit - Simplisafe Full System (white)
 *
 *
 */
export const IMG_1ulQQ8J3Ahuu65u0Q97K13 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1ulQQ8J3Ahuu65u0Q97K13/a36746ebae1c4542075613d67809ecd2/ss_presskit1.jpg',
  description: ``,
  originalHeight: 3031,
  originalWidth: 4070
}

/**
 * ![glassbreak sensor](https://images.ctfassets.net/v6awd0kabi65/7mJq11URr1oY0uT46nBajY/0f7398a2eaa3700078f3517da2bc1870/glassbreak_sensor.png?w=120&h=120&fit=pad)
 *
 * glassbreak sensor
 *
 * glassbreak sensor
 */
export const IMG_7mJq11URr1oY0uT46nBajY = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7mJq11URr1oY0uT46nBajY/0f7398a2eaa3700078f3517da2bc1870/glassbreak_sensor.png',
  description: `glassbreak sensor`,
  originalHeight: 1620,
  originalWidth: 2100
}

/**
 * ![Water sensor](https://images.ctfassets.net/v6awd0kabi65/64Blz2uXatGDA6Qslz1zIY/e631bc6a467e03eca175923e03ae1e3a/Water_sensor.png?w=120&h=120&fit=pad)
 *
 * Water sensor
 *
 * SimpliSafe Water Sensor
 */
export const IMG_64Blz2uXatGDA6Qslz1zIY = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/64Blz2uXatGDA6Qslz1zIY/e631bc6a467e03eca175923e03ae1e3a/Water_sensor.png',
  description: `SimpliSafe Water Sensor`,
  originalHeight: 2107,
  originalWidth: 2560
}

/**
 * ![Apartment 1 - Motion Glassbreak](https://images.ctfassets.net/v6awd0kabi65/5RC30cWcLof153aOMwvTxs/8003ee5ffe92ba8c7963d4c9b6dfc95c/Apartment_1_-_Motion_Glassbreak.png?w=120&h=120&fit=pad)
 *
 * Apartment 1 - Motion Glassbreak
 *
 *
 */
export const IMG_5RC30cWcLof153aOMwvTxs = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5RC30cWcLof153aOMwvTxs/8003ee5ffe92ba8c7963d4c9b6dfc95c/Apartment_1_-_Motion_Glassbreak.png',
  description: ``,
  originalHeight: 389,
  originalWidth: 525
}

/**
 * ![water-floorplan](https://images.ctfassets.net/v6awd0kabi65/3PbXDr3nRFZFtZv3ctUW0V/09f499fcb37858d29766c75c7587164f/water-floorplan.png?w=120&h=120&fit=pad)
 *
 * water-floorplan
 *
 * Water floorplan
 */
export const IMG_3PbXDr3nRFZFtZv3ctUW0V = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3PbXDr3nRFZFtZv3ctUW0V/09f499fcb37858d29766c75c7587164f/water-floorplan.png',
  description: `Water floorplan`,
  originalHeight: 976,
  originalWidth: 1322
}

/**
 * ![Rhythm Outdoor 5 piece flat overlay](https://images.ctfassets.net/v6awd0kabi65/3LjrwJwHfngwVSxzo0ukDj/6a27754facdc830db2e906e1d6b15f50/Rhythm_Outdoor_5_piece_flat_overlay.png?w=120&h=120&fit=pad)
 *
 * Rhythm Outdoor 5 piece flat overlay
 *
 * Rhythm Outdoor 5 piece flat overlay
 */
export const IMG_3LjrwJwHfngwVSxzo0ukDj = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3LjrwJwHfngwVSxzo0ukDj/6a27754facdc830db2e906e1d6b15f50/Rhythm_Outdoor_5_piece_flat_overlay.png',
  description: `Rhythm Outdoor 5 piece flat overlay`,
  originalHeight: 2992,
  originalWidth: 5318
}

/**
 * ![Rhythm Indoor 7 piece flatlay](https://images.ctfassets.net/v6awd0kabi65/3hvSv9q8CR6eQ3FCqLFgyF/be9a84d819a00d078f84502fe717e1a4/Rhythm_Indoor_7_piece_overlay.png?w=120&h=120&fit=pad)
 *
 * Rhythm Indoor 7 piece flatlay
 *
 * Rhythm Indoor 7 piece flatlay
 */
export const IMG_3hvSv9q8CR6eQ3FCqLFgyF = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3hvSv9q8CR6eQ3FCqLFgyF/be9a84d819a00d078f84502fe717e1a4/Rhythm_Indoor_7_piece_overlay.png',
  description: `Rhythm Indoor 7 piece flatlay`,
  originalHeight: 1800,
  originalWidth: 1800
}

/**
 * ![RhythmEnergy Logo](https://images.ctfassets.net/v6awd0kabi65/3BPsccWvTLxRcffjnXcudD/eac206bbcb2e761c27068c3092888dea/RhythmEnergy_Logo_White_446h__1_.png?w=120&h=120&fit=pad)
 *
 * RhythmEnergy Logo
 *
 * Rhythm Energy Logo
 */
export const IMG_3BPsccWvTLxRcffjnXcudD = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3BPsccWvTLxRcffjnXcudD/eac206bbcb2e761c27068c3092888dea/RhythmEnergy_Logo_White_446h__1_.png',
  description: `Rhythm Energy Logo`,
  originalHeight: 446,
  originalWidth: 1201
}

/**
 * ![Nationwide 8pc Flatplay](https://images.ctfassets.net/v6awd0kabi65/1bmablrLhEiT1OCOdaHY6v/1ddb7fea99b496477af87911ab4fa1b5/Pkg_Nationwide__1_.jpg?w=120&h=120&fit=pad)
 *
 * Nationwide 8pc Flatplay
 *
 * 8 pieces of SimpliSafe equipment
 */
export const IMG_1bmablrLhEiT1OCOdaHY6v = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1bmablrLhEiT1OCOdaHY6v/1ddb7fea99b496477af87911ab4fa1b5/Pkg_Nationwide__1_.jpg',
  description: `8 pieces of SimpliSafe equipment`,
  originalHeight: 1245,
  originalWidth: 1245
}

/**
 * ![SimpliSafe CEO Christian Cerda Recognized as EY Entrepreneur Of The Year® 2024 New England Award Winner](https://images.ctfassets.net/v6awd0kabi65/58V3vwdWWaAbCjvikkTB9c/eb9300bfcbb0a09168808e614a3ccb35/IMG_9002.jpg?w=120&h=120&fit=pad)
 *
 * SimpliSafe CEO Christian Cerda Recognized as EY Entrepreneur Of The Year® 2024 New England Award Winner
 *
 *
 */
export const IMG_58V3vwdWWaAbCjvikkTB9c = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/58V3vwdWWaAbCjvikkTB9c/eb9300bfcbb0a09168808e614a3ccb35/IMG_9002.jpg',
  description: ``,
  originalHeight: 5712,
  originalWidth: 4284
}

/**
 * ![Manual - Gen 3 SimpliSafe Image](https://images.ctfassets.net/v6awd0kabi65/7ChIcUi83vXiLgQHwi5JtB/90885763582a1022e6a55fd706d4afbf/Manual_-_All_New_SimpliSafe.png?w=120&h=120&fit=pad)
 *
 * Manual - Gen 3 SimpliSafe Image
 *
 *
 */
export const IMG_7ChIcUi83vXiLgQHwi5JtB = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7ChIcUi83vXiLgQHwi5JtB/90885763582a1022e6a55fd706d4afbf/Manual_-_All_New_SimpliSafe.png',
  description: ``,
  originalHeight: 284,
  originalWidth: 1280
}

/**
 * ![Manual - Video Doorbell Pro Image](https://images.ctfassets.net/v6awd0kabi65/2SCZsmZ3y6l3N6AumzhZp6/8f490852c975b622c92f70a3e2cfd9be/Manual_VDP.png?w=120&h=120&fit=pad)
 *
 * Manual - Video Doorbell Pro Image
 *
 *
 */
export const IMG_2SCZsmZ3y6l3N6AumzhZp6 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2SCZsmZ3y6l3N6AumzhZp6/8f490852c975b622c92f70a3e2cfd9be/Manual_VDP.png',
  description: ``,
  originalHeight: 284,
  originalWidth: 1280
}

/**
 * ![Low Res-01122021 SimpliSafe Shield 0174 NoPlant](https://images.ctfassets.net/v6awd0kabi65/6FdKDpVmuxEG8LgIl6dtPQ/809be326d8a9090e7048a92c13a5f1f9/Low_Res-01122021_SimpliSafe_Shield_0174_NoPlant.jpg?w=120&h=120&fit=pad)
 *
 * Low Res-01122021 SimpliSafe Shield 0174 NoPlant
 *
 *
 */
export const IMG_6FdKDpVmuxEG8LgIl6dtPQ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6FdKDpVmuxEG8LgIl6dtPQ/809be326d8a9090e7048a92c13a5f1f9/Low_Res-01122021_SimpliSafe_Shield_0174_NoPlant.jpg',
  description: ``,
  originalHeight: 2089,
  originalWidth: 2785
}

/**
 * ![Find the right system - Children in Living Room Tall](https://images.ctfassets.net/v6awd0kabi65/7r7M1oxy0ZwvzHH8YK4jC/f55d1044b848c4e9b5be82f889c74960/children-in-living-room-tall.jpg?w=120&h=120&fit=pad)
 *
 * Find the right system - Children in Living Room Tall
 *
 *
 */
export const IMG_7r7M1oxy0ZwvzHH8YK4jC = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7r7M1oxy0ZwvzHH8YK4jC/f55d1044b848c4e9b5be82f889c74960/children-in-living-room-tall.jpg',
  description: ``,
  originalHeight: 1954,
  originalWidth: 1280
}

/**
 * ![Find the right system - Safety](https://images.ctfassets.net/v6awd0kabi65/3L7YdvUDcanCQoby8OW81b/caa292bbebe2db750926fda5d78e1968/FTRS_-_Safety.jpeg?w=120&h=120&fit=pad)
 *
 * Find the right system - Safety
 *
 *
 */
export const IMG_3L7YdvUDcanCQoby8OW81b = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3L7YdvUDcanCQoby8OW81b/caa292bbebe2db750926fda5d78e1968/FTRS_-_Safety.jpeg',
  description: ``,
  originalHeight: 401,
  originalWidth: 476
}

/**
 * ![The Starter](https://images.ctfassets.net/v6awd0kabi65/3cp1QM0RacYaf8pGA1PwqF/37a4e7f15131675fb1a6595478174022/ESSENTIALS-Balto.jpg?w=120&h=120&fit=pad)
 *
 * The Starter
 *
 * An image of all of the components included in The Starter package.
 */
export const IMG_3cp1QM0RacYaf8pGA1PwqF = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3cp1QM0RacYaf8pGA1PwqF/37a4e7f15131675fb1a6595478174022/ESSENTIALS-Balto.jpg',
  description: `An image of all of the components included in The Starter package.`,
  originalHeight: 1800,
  originalWidth: 2500
}

/**
 * ![Everything You Need to Know About Home Mode](https://images.ctfassets.net/v6awd0kabi65/4eH31wHOIUofxEvnU8YZst/abaaee6ad45dc4e22d68cf48583d003d/Designing_the_Perfect_Smart_Home_Security_System.jpg?w=120&h=120&fit=pad)
 *
 * Everything You Need to Know About Home Mode
 *
 *
 */
export const IMG_4eH31wHOIUofxEvnU8YZst = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4eH31wHOIUofxEvnU8YZst/abaaee6ad45dc4e22d68cf48583d003d/Designing_the_Perfect_Smart_Home_Security_System.jpg',
  description: ``,
  originalHeight: 1667,
  originalWidth: 2500
}

/**
 * ![How does professional monitoring work?](https://images.ctfassets.net/v6awd0kabi65/je48kE3IUPQmg3Mp8MjcA/b6293e40f41b877e0690e786568efe81/Untitled_design__4_.png?w=120&h=120&fit=pad)
 *
 * How does professional monitoring work?
 *
 * Professional monitoring takes your home security to the next level, but how does it work? Find out more about what professional monitoring can do for you.
 */
export const IMG_je48kE3IUPQmg3Mp8MjcA = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/je48kE3IUPQmg3Mp8MjcA/b6293e40f41b877e0690e786568efe81/Untitled_design__4_.png',
  description: `Professional monitoring takes your home security to the next level, but how does it work? Find out more about what professional monitoring can do for you.`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Partner With Us - Electric - MJ Carr Electrical Services](https://images.ctfassets.net/v6awd0kabi65/3P08Gf0AC5zoq7x4QNO3AR/6ff0c7baacecdd2c58a4f564c547f622/MJ_Carr_Electrical_Services_-_Massachusetts.png?w=120&h=120&fit=pad)
 *
 * Partner With Us - Electric - MJ Carr Electrical Services
 *
 *
 */
export const IMG_3P08Gf0AC5zoq7x4QNO3AR = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3P08Gf0AC5zoq7x4QNO3AR/6ff0c7baacecdd2c58a4f564c547f622/MJ_Carr_Electrical_Services_-_Massachusetts.png',
  description: ``,
  originalHeight: 320,
  originalWidth: 320
}

/**
 * ![ Window Decals (1)](https://images.ctfassets.net/v6awd0kabi65/KGgHUxHS56aeRMmiHVEKZ/3e5969d190743ac815740f72c6417c6d/Product_Window-Decal.png?w=120&h=120&fit=pad)
 *
 *  Window Decals (1)
 *
 *
 */
export const IMG_KGgHUxHS56aeRMmiHVEKZ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/KGgHUxHS56aeRMmiHVEKZ/3e5969d190743ac815740f72c6417c6d/Product_Window-Decal.png',
  description: ``,
  originalHeight: 1023,
  originalWidth: 1023
}

/**
 * ![What is the Loudest Burglar Alarm Siren?](https://images.ctfassets.net/v6awd0kabi65/4BilFj55lQlpLkC9bpWcyv/8cc675f3c0b4415f2473a766677b2f5e/Low_Res-Siren_Outside_Front_Door_0204_F_8bit.jpg?w=120&h=120&fit=pad)
 *
 * What is the Loudest Burglar Alarm Siren?
 *
 *
 */
export const IMG_4BilFj55lQlpLkC9bpWcyv = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4BilFj55lQlpLkC9bpWcyv/8cc675f3c0b4415f2473a766677b2f5e/Low_Res-Siren_Outside_Front_Door_0204_F_8bit.jpg',
  description: ``,
  originalHeight: 1299,
  originalWidth: 1948
}

/**
 * ![Manchester Square](https://images.ctfassets.net/v6awd0kabi65/1V1rxPyscvBbKaTvdlvGJ5/386f7c17fd5ac55f905d0975f4f08a1b/Manchester_Square.png?w=120&h=120&fit=pad)
 *
 * Manchester Square
 *
 *
 */
export const IMG_1V1rxPyscvBbKaTvdlvGJ5 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1V1rxPyscvBbKaTvdlvGJ5/386f7c17fd5ac55f905d0975f4f08a1b/Manchester_Square.png',
  description: ``,
  originalHeight: 372,
  originalWidth: 372
}

/**
 * ![CRIME IN THE LIVERPOOL](https://images.ctfassets.net/v6awd0kabi65/5zUAKjZTRyYj3MTxXdkt39/f4946dbf6e4a898d7db358aa2f326eee/Liverpool_City_Image.png?w=120&h=120&fit=pad)
 *
 * CRIME IN THE LIVERPOOL
 *
 *
 */
export const IMG_5zUAKjZTRyYj3MTxXdkt39 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5zUAKjZTRyYj3MTxXdkt39/f4946dbf6e4a898d7db358aa2f326eee/Liverpool_City_Image.png',
  description: ``,
  originalHeight: 1018,
  originalWidth: 2880
}

/**
 * ![Crime in Manchester](https://images.ctfassets.net/v6awd0kabi65/6zY6pzix6cejDcDZMfrk6g/07648bb05583c90901d9603c473741e1/Manchester_City_Image.png?w=120&h=120&fit=pad)
 *
 * Crime in Manchester
 *
 *
 */
export const IMG_6zY6pzix6cejDcDZMfrk6g = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6zY6pzix6cejDcDZMfrk6g/07648bb05583c90901d9603c473741e1/Manchester_City_Image.png',
  description: ``,
  originalHeight: 1018,
  originalWidth: 2880
}

/**
 * ![Birmingham City](https://images.ctfassets.net/v6awd0kabi65/5s4lNjWPgqxqCsh3BEPv4T/0933b529345ef3aeebe58e75ed20411b/Birmingham_City.png?w=120&h=120&fit=pad)
 *
 * Birmingham City
 *
 *
 */
export const IMG_5s4lNjWPgqxqCsh3BEPv4T = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5s4lNjWPgqxqCsh3BEPv4T/0933b529345ef3aeebe58e75ed20411b/Birmingham_City.png',
  description: ``,
  originalHeight: 1018,
  originalWidth: 2880
}

/**
 * ![Nottingham City](https://images.ctfassets.net/v6awd0kabi65/4N5fJQDh5DW1AVK81Dhn03/63085ae6a569e5ca1cd65a8e4391c152/Nottingham_City.png?w=120&h=120&fit=pad)
 *
 * Nottingham City
 *
 *
 */
export const IMG_4N5fJQDh5DW1AVK81Dhn03 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4N5fJQDh5DW1AVK81Dhn03/63085ae6a569e5ca1cd65a8e4391c152/Nottingham_City.png',
  description: ``,
  originalHeight: 1018,
  originalWidth: 2880
}

/**
 * ![CRIME IN BERBY](https://images.ctfassets.net/v6awd0kabi65/6PqubrdFSz46kZch2PUaRb/a09afc3cfb987ef851b6a5986db12c53/Leicester_City_Image.png?w=120&h=120&fit=pad)
 *
 * CRIME IN BERBY
 *
 *
 */
export const IMG_6PqubrdFSz46kZch2PUaRb = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6PqubrdFSz46kZch2PUaRb/a09afc3cfb987ef851b6a5986db12c53/Leicester_City_Image.png',
  description: ``,
  originalHeight: 1018,
  originalWidth: 2880
}

/**
 * ![CRIME IN THE DERBY](https://images.ctfassets.net/v6awd0kabi65/2B28D1LqHswYEXdCHoVR9i/aa6b65c39d7343ac47aae17a106d5766/Derby_City_Image.png?w=120&h=120&fit=pad)
 *
 * CRIME IN THE DERBY
 *
 *
 */
export const IMG_2B28D1LqHswYEXdCHoVR9i = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2B28D1LqHswYEXdCHoVR9i/aa6b65c39d7343ac47aae17a106d5766/Derby_City_Image.png',
  description: ``,
  originalHeight: 1018,
  originalWidth: 2880
}

/**
 * ![London city](https://images.ctfassets.net/v6awd0kabi65/16wUaQ5pIAVM9LC96neBum/78c67acfe9e38a2a0b17e07e70fb62f8/London_City.png?w=120&h=120&fit=pad)
 *
 * London city
 *
 *
 */
export const IMG_16wUaQ5pIAVM9LC96neBum = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/16wUaQ5pIAVM9LC96neBum/78c67acfe9e38a2a0b17e07e70fb62f8/London_City.png',
  description: ``,
  originalHeight: 1018,
  originalWidth: 2880
}

/**
 * ![Bristol City](https://images.ctfassets.net/v6awd0kabi65/39ie2hL53Tv5rkHRxzpGR0/ea9c6468bf4b39d330945bf949f627d3/Bristol_City.png?w=120&h=120&fit=pad)
 *
 * Bristol City
 *
 *
 */
export const IMG_39ie2hL53Tv5rkHRxzpGR0 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/39ie2hL53Tv5rkHRxzpGR0/ea9c6468bf4b39d330945bf949f627d3/Bristol_City.png',
  description: ``,
  originalHeight: 1018,
  originalWidth: 2880
}

/**
 * ![CRIME IN COVENTRY](https://images.ctfassets.net/v6awd0kabi65/5BkOEZlWMW8rxin0f3Ysvf/565130deb8d9bbba2d42215233f4da1c/Coventry_City_Image.png?w=120&h=120&fit=pad)
 *
 * CRIME IN COVENTRY
 *
 *
 */
export const IMG_5BkOEZlWMW8rxin0f3Ysvf = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5BkOEZlWMW8rxin0f3Ysvf/565130deb8d9bbba2d42215233f4da1c/Coventry_City_Image.png',
  description: ``,
  originalHeight: 1018,
  originalWidth: 2880
}

/**
 * ![Leeds City](https://images.ctfassets.net/v6awd0kabi65/KlAPSl6gFppnluu14sEHH/d5aae5639296c429515d58b4789f5e04/Leeds_City.png?w=120&h=120&fit=pad)
 *
 * Leeds City
 *
 *
 */
export const IMG_KlAPSl6gFppnluu14sEHH = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/KlAPSl6gFppnluu14sEHH/d5aae5639296c429515d58b4789f5e04/Leeds_City.png',
  description: ``,
  originalHeight: 1018,
  originalWidth: 2880
}

/**
 * ![Coverntry Square](https://images.ctfassets.net/v6awd0kabi65/7xZfSwE2WxjjaLLL7zFTc3/a1711a4441f348ba597e875936591f86/Coverntry_Square.png?w=120&h=120&fit=pad)
 *
 * Coverntry Square
 *
 *
 */
export const IMG_7xZfSwE2WxjjaLLL7zFTc3 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7xZfSwE2WxjjaLLL7zFTc3/a1711a4441f348ba597e875936591f86/Coverntry_Square.png',
  description: ``,
  originalHeight: 508,
  originalWidth: 520
}

/**
 * ![Leeds Square](https://images.ctfassets.net/v6awd0kabi65/4OnVrjVLBpZOrDDB3iZbUl/f26d26e64e2f4c375cedebeb82a8941f/Leeds_Square.png?w=120&h=120&fit=pad)
 *
 * Leeds Square
 *
 *
 */
export const IMG_4OnVrjVLBpZOrDDB3iZbUl = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4OnVrjVLBpZOrDDB3iZbUl/f26d26e64e2f4c375cedebeb82a8941f/Leeds_Square.png',
  description: ``,
  originalHeight: 508,
  originalWidth: 520
}

/**
 * ![Bristol Square](https://images.ctfassets.net/v6awd0kabi65/UVgv8OctG4DSKSQiWN48R/3edb1f9c7e75d9ab73faece20da3bc24/Bristol_Square.png?w=120&h=120&fit=pad)
 *
 * Bristol Square
 *
 *
 */
export const IMG_UVgv8OctG4DSKSQiWN48R = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/UVgv8OctG4DSKSQiWN48R/3edb1f9c7e75d9ab73faece20da3bc24/Bristol_Square.png',
  description: ``,
  originalHeight: 508,
  originalWidth: 520
}

/**
 * ![Derby Square](https://images.ctfassets.net/v6awd0kabi65/7HMPw6HhjhQlqSmf167Cnm/230a0fe1b786070e7899551e2707141a/Derby_Square.png?w=120&h=120&fit=pad)
 *
 * Derby Square
 *
 *
 */
export const IMG_7HMPw6HhjhQlqSmf167Cnm = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7HMPw6HhjhQlqSmf167Cnm/230a0fe1b786070e7899551e2707141a/Derby_Square.png',
  description: ``,
  originalHeight: 508,
  originalWidth: 520
}

/**
 * ![Leicester Square](https://images.ctfassets.net/v6awd0kabi65/2PxpWd1nmVCfGIr4kBaly7/815833ba89f902cf1be899d989b60152/Leicester_Square.png?w=120&h=120&fit=pad)
 *
 * Leicester Square
 *
 *
 */
export const IMG_2PxpWd1nmVCfGIr4kBaly7 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2PxpWd1nmVCfGIr4kBaly7/815833ba89f902cf1be899d989b60152/Leicester_Square.png',
  description: ``,
  originalHeight: 508,
  originalWidth: 520
}

/**
 * ![Nottingham Square](https://images.ctfassets.net/v6awd0kabi65/2tCbiu2zKhzZFlOMwzceNn/cb03d3f2c41c35aaabb1cbb7cac78ea3/Nottingham_Square.png?w=120&h=120&fit=pad)
 *
 * Nottingham Square
 *
 *
 */
export const IMG_2tCbiu2zKhzZFlOMwzceNn = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2tCbiu2zKhzZFlOMwzceNn/cb03d3f2c41c35aaabb1cbb7cac78ea3/Nottingham_Square.png',
  description: ``,
  originalHeight: 508,
  originalWidth: 520
}

/**
 * ![Birmingham Square](https://images.ctfassets.net/v6awd0kabi65/2RpXZozfJNHBGn501GBtGl/76f3c3caecb0d170a554c3b03301dde3/Birmingham_Square.png?w=120&h=120&fit=pad)
 *
 * Birmingham Square
 *
 *
 */
export const IMG_2RpXZozfJNHBGn501GBtGl = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2RpXZozfJNHBGn501GBtGl/76f3c3caecb0d170a554c3b03301dde3/Birmingham_Square.png',
  description: ``,
  originalHeight: 508,
  originalWidth: 520
}

/**
 * ![Liverpool Square](https://images.ctfassets.net/v6awd0kabi65/tsRCiSBKfaqSoNaBwgeKI/9cdece42d9e5c5ef301cedb1c659b6c5/Liverpool_Square.png?w=120&h=120&fit=pad)
 *
 * Liverpool Square
 *
 *
 */
export const IMG_tsRCiSBKfaqSoNaBwgeKI = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/tsRCiSBKfaqSoNaBwgeKI/9cdece42d9e5c5ef301cedb1c659b6c5/Liverpool_Square.png',
  description: ``,
  originalHeight: 508,
  originalWidth: 520
}

/**
 * ![Ryan McMahon](https://images.ctfassets.net/v6awd0kabi65/3grCmroEfRrLYxkd3ixr4j/05d0ed90a02e8c869f0aeb18a0525708/ryanmcmahon.png?w=120&h=120&fit=pad)
 *
 * Ryan McMahon
 *
 *
 */
export const IMG_3grCmroEfRrLYxkd3ixr4j = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3grCmroEfRrLYxkd3ixr4j/05d0ed90a02e8c869f0aeb18a0525708/ryanmcmahon.png',
  description: ``,
  originalHeight: 200,
  originalWidth: 200
}

/**
 * ![Lindsey Chilton](https://images.ctfassets.net/v6awd0kabi65/2s5zNXqojYOSWKZnVzsx78/d918ceb3ea26c76e977e0b1f7807d153/lindsey.png?w=120&h=120&fit=pad)
 *
 * Lindsey Chilton
 *
 *
 */
export const IMG_2s5zNXqojYOSWKZnVzsx78 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2s5zNXqojYOSWKZnVzsx78/d918ceb3ea26c76e977e0b1f7807d153/lindsey.png',
  description: ``,
  originalHeight: 200,
  originalWidth: 200
}

/**
 * !['Partner With Us' Page Hero](https://images.ctfassets.net/v6awd0kabi65/10x9CqfXc7I7qADhncvMot/b4a9d80851105a9177be7ce389315f70/partner_base-hero_2x.jpg?w=120&h=120&fit=pad)
 *
 * 'Partner With Us' Page Hero
 *
 *
 */
export const IMG_10x9CqfXc7I7qADhncvMot = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/10x9CqfXc7I7qADhncvMot/b4a9d80851105a9177be7ce389315f70/partner_base-hero_2x.jpg',
  description: ``,
  originalHeight: 1200,
  originalWidth: 2624
}

/**
 * ![London Square](https://images.ctfassets.net/v6awd0kabi65/7MyhaTohozpUc6YejrfyNg/7db4d9ab73e967003ae3e239a8e510a6/London_Square.png?w=120&h=120&fit=pad)
 *
 * London Square
 *
 *
 */
export const IMG_7MyhaTohozpUc6YejrfyNg = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7MyhaTohozpUc6YejrfyNg/7db4d9ab73e967003ae3e239a8e510a6/London_Square.png',
  description: ``,
  originalHeight: 508,
  originalWidth: 520
}

/**
 * ![United Kingdom (UK)](https://images.ctfassets.net/v6awd0kabi65/cfei6KKrKVegqyDwysrL7/d91ece8f38e536d7cd5809f0898c9342/United_Kingdom__UK_.jpg?w=120&h=120&fit=pad)
 *
 * United Kingdom (UK)
 *
 *
 */
export const IMG_cfei6KKrKVegqyDwysrL7 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/cfei6KKrKVegqyDwysrL7/d91ece8f38e536d7cd5809f0898c9342/United_Kingdom__UK_.jpg',
  description: ``,
  originalHeight: 1527,
  originalWidth: 4320
}

/**
 * ![Baby Safety and Smart Home Security: A Guide for New Parents](https://images.ctfassets.net/v6awd0kabi65/5cIjHjHDdidt7NEjCdSsfr/a6751e83dee61be47f0d675bcc9c64c9/kelly-sikkema-FqqaJI9OxMI-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * Baby Safety and Smart Home Security: A Guide for New Parents
 *
 *
 */
export const IMG_5cIjHjHDdidt7NEjCdSsfr = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5cIjHjHDdidt7NEjCdSsfr/a6751e83dee61be47f0d675bcc9c64c9/kelly-sikkema-FqqaJI9OxMI-unsplash.jpg',
  description: ``,
  originalHeight: 3470,
  originalWidth: 4685
}

/**
 * ![Say Hello - Outdoor Camera](https://images.ctfassets.net/v6awd0kabi65/2w6nwRQaUw1yQw4sIKamnI/a7f6b4a620b3807f2ae0210676bc8d23/Say_hello_-_Outdoor_Camera.jpeg?w=120&h=120&fit=pad)
 *
 * Say Hello - Outdoor Camera
 *
 * Outdoor Camera
 */
export const IMG_2w6nwRQaUw1yQw4sIKamnI = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2w6nwRQaUw1yQw4sIKamnI/a7f6b4a620b3807f2ae0210676bc8d23/Say_hello_-_Outdoor_Camera.jpeg',
  description: `Outdoor Camera`,
  originalHeight: 1200,
  originalWidth: 1601
}

/**
 * ![Apartment 1 - Simplicam](https://images.ctfassets.net/v6awd0kabi65/hCot8mm1cN71IiAZgmU6g/a9ed8b98a96c1be957e77d28786f1c1e/Apartment_1_-_Simplicam.png?w=120&h=120&fit=pad)
 *
 * Apartment 1 - Simplicam
 *
 * Floorplan image shows where a Simplicam would be located within an apartment
 */
export const IMG_hCot8mm1cN71IiAZgmU6g = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/hCot8mm1cN71IiAZgmU6g/a9ed8b98a96c1be957e77d28786f1c1e/Apartment_1_-_Simplicam.png',
  description: `Floorplan image shows where a Simplicam would be located within an apartment`,
  originalHeight: 389,
  originalWidth: 525
}

/**
 * ![Apartment 1 - MOTION SENSOR](https://images.ctfassets.net/v6awd0kabi65/2bydzPSoyG0HIfwDhBuNd7/db7ab0bf428e9dc544c832ab9c981f96/Apartment_1_-_Motion_Glassbreak.png?w=120&h=120&fit=pad)
 *
 * Apartment 1 - MOTION SENSOR
 *
 * Floorplan image shows where motion sensors would be located within an apartment
 */
export const IMG_2bydzPSoyG0HIfwDhBuNd7 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2bydzPSoyG0HIfwDhBuNd7/db7ab0bf428e9dc544c832ab9c981f96/Apartment_1_-_Motion_Glassbreak.png',
  description: `Floorplan image shows where motion sensors would be located within an apartment`,
  originalHeight: 389,
  originalWidth: 525
}

/**
 * ![Apartment 1 - Entry Sensor](https://images.ctfassets.net/v6awd0kabi65/3TaRNo8iNHtMsQFSKv0sUG/2e0496fbdeca45498ea4cfe670f3d26f/Apartment_1_-_Entry_Sensor.png?w=120&h=120&fit=pad)
 *
 * Apartment 1 - Entry Sensor
 *
 * Floorplan image shows where entry sensors would be located within an apartment
 */
export const IMG_3TaRNo8iNHtMsQFSKv0sUG = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3TaRNo8iNHtMsQFSKv0sUG/2e0496fbdeca45498ea4cfe670f3d26f/Apartment_1_-_Entry_Sensor.png',
  description: `Floorplan image shows where entry sensors would be located within an apartment`,
  originalHeight: 389,
  originalWidth: 525
}

/**
 * ![Apartment 1 - Wireless Keypad](https://images.ctfassets.net/v6awd0kabi65/1IddSgyFW5VOv7B71A8mtN/50de67c3acc1acd2adcc3acd36ce14f8/Apartment_1_-_Wireless_Keypad.png?w=120&h=120&fit=pad)
 *
 * Apartment 1 - Wireless Keypad
 *
 * Floorplan image shows where a wireless keypad would be located within an apartment
 */
export const IMG_1IddSgyFW5VOv7B71A8mtN = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1IddSgyFW5VOv7B71A8mtN/50de67c3acc1acd2adcc3acd36ce14f8/Apartment_1_-_Wireless_Keypad.png',
  description: `Floorplan image shows where a wireless keypad would be located within an apartment`,
  originalHeight: 389,
  originalWidth: 525
}

/**
 * ![Apartment 1 - BASE STATION](https://images.ctfassets.net/v6awd0kabi65/77begJbpEH30O02PMXWswc/4563c4b121001e980ebf68154ffc6388/Apartment_1_-_Base_Station.png?w=120&h=120&fit=pad)
 *
 * Apartment 1 - BASE STATION
 *
 * Floorplan image shows where a base station would be located within an apartment
 */
export const IMG_77begJbpEH30O02PMXWswc = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/77begJbpEH30O02PMXWswc/4563c4b121001e980ebf68154ffc6388/Apartment_1_-_Base_Station.png',
  description: `Floorplan image shows where a base station would be located within an apartment`,
  originalHeight: 389,
  originalWidth: 525
}

/**
 * ![Outdoor Security Camera](https://images.ctfassets.net/v6awd0kabi65/2y0cokZXIa1Bm2FBeKK4vQ/180531ea3479552cda20ae5ac6a25e2a/Outdoor_Camera_render_standing_shadow.png?w=120&h=120&fit=pad)
 *
 * Outdoor Security Camera
 *
 * Outdoor Security Camera
 */
export const IMG_2y0cokZXIa1Bm2FBeKK4vQ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2y0cokZXIa1Bm2FBeKK4vQ/180531ea3479552cda20ae5ac6a25e2a/Outdoor_Camera_render_standing_shadow.png',
  description: `Outdoor Security Camera`,
  originalHeight: 3000,
  originalWidth: 4000
}

/**
 * ![Motion Balto](https://images.ctfassets.net/v6awd0kabi65/4MmT2LBKaACtzuG6NDiBq2/8667d221d25520a2845f4d0067b1b623/Motion_Sensor_Gen_2_render_standing_png.png?w=120&h=120&fit=pad)
 *
 * Motion Balto
 *
 * Motion Balto
 */
export const IMG_4MmT2LBKaACtzuG6NDiBq2 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4MmT2LBKaACtzuG6NDiBq2/8667d221d25520a2845f4d0067b1b623/Motion_Sensor_Gen_2_render_standing_png.png',
  description: `Motion Balto`,
  originalHeight: 3000,
  originalWidth: 4000
}

/**
 * ![Entry sensor blue](https://images.ctfassets.net/v6awd0kabi65/76j08fKFpKUmbV1KONQ4BE/f39c8b04708fc10a8cd38acd02ae0c2c/entry_trans_clean.png?w=120&h=120&fit=pad)
 *
 * Entry sensor blue
 *
 * Entry sensor blue
 */
export const IMG_76j08fKFpKUmbV1KONQ4BE = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/76j08fKFpKUmbV1KONQ4BE/f39c8b04708fc10a8cd38acd02ae0c2c/entry_trans_clean.png',
  description: `Entry sensor blue`,
  originalHeight: 1163,
  originalWidth: 1437
}

/**
 * ![KeyPad Option 1](https://images.ctfassets.net/v6awd0kabi65/4WiI5TUsW7MIcBv1qmNcFP/99d844fbf39ac02b66e10022c03b375f/KeyPad_Option_1.png?w=120&h=120&fit=pad)
 *
 * KeyPad Option 1
 *
 * KeyPad Option 1
 */
export const IMG_4WiI5TUsW7MIcBv1qmNcFP = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4WiI5TUsW7MIcBv1qmNcFP/99d844fbf39ac02b66e10022c03b375f/KeyPad_Option_1.png',
  description: `KeyPad Option 1`,
  originalHeight: 2107,
  originalWidth: 2560
}

/**
 * ![Base Station Front Transparent](https://images.ctfassets.net/v6awd0kabi65/2yDPUVs7zBZUfNhTJKeTVt/35dcab7b94816bbae600315d7fdbadb4/Base_Station_Front__2___1_.png?w=120&h=120&fit=pad)
 *
 * Base Station Front Transparent
 *
 * Base Station Front Transparent
 */
export const IMG_2yDPUVs7zBZUfNhTJKeTVt = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2yDPUVs7zBZUfNhTJKeTVt/35dcab7b94816bbae600315d7fdbadb4/Base_Station_Front__2___1_.png',
  description: `Base Station Front Transparent`,
  originalHeight: 2159,
  originalWidth: 3840
}

/**
 * ![Indoor Camera Front View BlueLight](https://images.ctfassets.net/v6awd0kabi65/5WbVEaI7RKdrMFYP9Z2kzN/dbe297cc7eb5311f1af04748f578152c/Indoor_Camera_Front_View_BlueLight.png?w=120&h=120&fit=pad)
 *
 * Indoor Camera Front View BlueLight
 *
 * Indoor Camera Front View BlueLight
 */
export const IMG_5WbVEaI7RKdrMFYP9Z2kzN = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5WbVEaI7RKdrMFYP9Z2kzN/dbe297cc7eb5311f1af04748f578152c/Indoor_Camera_Front_View_BlueLight.png',
  description: `Indoor Camera Front View BlueLight`,
  originalHeight: 2580,
  originalWidth: 3840
}

/**
 * ![Venture Solar 9 piece flatlay](https://images.ctfassets.net/v6awd0kabi65/QzZPapv9HapcThiJR3Wmj/b0bb95b1392f2d0165fa9d53d9942ca1/Pkg_VentureSolar9pc.png?w=120&h=120&fit=pad)
 *
 * Venture Solar 9 piece flatlay
 *
 * Venture Solar 9 piece flatlay
 */
export const IMG_QzZPapv9HapcThiJR3Wmj = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/QzZPapv9HapcThiJR3Wmj/b0bb95b1392f2d0165fa9d53d9942ca1/Pkg_VentureSolar9pc.png',
  description: `Venture Solar 9 piece flatlay`,
  originalHeight: 1800,
  originalWidth: 2500
}

/**
 * ![Expert Review Grand Designs](https://images.ctfassets.net/v6awd0kabi65/3Yk2CSFz84KprPq2t0oyU8/9a4cdd86877e58c49106f1634f496079/GD.png?w=120&h=120&fit=pad)
 *
 * Expert Review Grand Designs
 *
 * Expert Review Grand Designs
 */
export const IMG_3Yk2CSFz84KprPq2t0oyU8 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3Yk2CSFz84KprPq2t0oyU8/9a4cdd86877e58c49106f1634f496079/GD.png',
  description: `Expert Review Grand Designs`,
  originalHeight: 242,
  originalWidth: 242
}

/**
 * ![Expert Review Neighborhood Watch](https://images.ctfassets.net/v6awd0kabi65/2zLbCUSDMAqzV7LqBPgxzE/d3e3f8568fda9d60604995b5df46cca5/NW.png?w=120&h=120&fit=pad)
 *
 * Expert Review Neighborhood Watch
 *
 * Expert Review Neighborhood Watch
 */
export const IMG_2zLbCUSDMAqzV7LqBPgxzE = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2zLbCUSDMAqzV7LqBPgxzE/d3e3f8568fda9d60604995b5df46cca5/NW.png',
  description: `Expert Review Neighborhood Watch`,
  originalHeight: 1950,
  originalWidth: 2011
}

/**
 * ![HeadsetPerson](https://images.ctfassets.net/v6awd0kabi65/38pnle7Gelcon8fo9h5btf/dd865005d7f0525d5268a4fc44fc80c5/HeadsetPerson.png?w=120&h=120&fit=pad)
 *
 * HeadsetPerson
 *
 *
 */
export const IMG_38pnle7Gelcon8fo9h5btf = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/38pnle7Gelcon8fo9h5btf/dd865005d7f0525d5268a4fc44fc80c5/HeadsetPerson.png',
  description: ``,
  originalHeight: 80,
  originalWidth: 81
}

/**
 * ![OverNight](https://images.ctfassets.net/v6awd0kabi65/2XiYxsh8amJeHBCcj81u6v/97121dfde7343af4738379d43e7b0b8a/OverNight.png?w=120&h=120&fit=pad)
 *
 * OverNight
 *
 *
 */
export const IMG_2XiYxsh8amJeHBCcj81u6v = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2XiYxsh8amJeHBCcj81u6v/97121dfde7343af4738379d43e7b0b8a/OverNight.png',
  description: ``,
  originalHeight: 80,
  originalWidth: 81
}

/**
 * ![FullPlan](https://images.ctfassets.net/v6awd0kabi65/27iwWy8ilrgqeM8wzgZqQw/d5692236f67c1839e1e38d207f3bb199/FullPlan.png?w=120&h=120&fit=pad)
 *
 * FullPlan
 *
 *
 */
export const IMG_27iwWy8ilrgqeM8wzgZqQw = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/27iwWy8ilrgqeM8wzgZqQw/d5692236f67c1839e1e38d207f3bb199/FullPlan.png',
  description: ``,
  originalHeight: 80,
  originalWidth: 81
}

/**
 * ![Visa gift card](https://images.ctfassets.net/v6awd0kabi65/6xAC58lHR8hnLdem1gKLbU/01804a6956a3c5f97b7afb223d838026/visa_gift_card.png?w=120&h=120&fit=pad)
 *
 * Visa gift card
 *
 * Free $100 Visa Gift Card Promotion
 */
export const IMG_6xAC58lHR8hnLdem1gKLbU = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6xAC58lHR8hnLdem1gKLbU/01804a6956a3c5f97b7afb223d838026/visa_gift_card.png',
  description: `Free $100 Visa Gift Card Promotion`,
  originalHeight: 248,
  originalWidth: 353
}

/**
 * ![How Landscaping Can Help With Home Security](https://images.ctfassets.net/v6awd0kabi65/1eJ4Nohuo72hyrISkBrMkQ/e8bf063f4cb1fe76860f45cf7b905d71/Low_Res-8C8A0462-id.jpg?w=120&h=120&fit=pad)
 *
 * How Landscaping Can Help With Home Security
 *
 *
 */
export const IMG_1eJ4Nohuo72hyrISkBrMkQ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1eJ4Nohuo72hyrISkBrMkQ/e8bf063f4cb1fe76860f45cf7b905d71/Low_Res-8C8A0462-id.jpg',
  description: ``,
  originalHeight: 1134,
  originalWidth: 2016
}

/**
 * ![New york post - logo](https://images.ctfassets.net/v6awd0kabi65/52dGvmOTVmR7Noc9hYqxX4/deca9062d67c8306efcb1052f7f18c8d/ny-post-logo.webp?w=120&h=120&fit=pad)
 *
 * New york post - logo
 *
 *
 */
export const IMG_52dGvmOTVmR7Noc9hYqxX4 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/52dGvmOTVmR7Noc9hYqxX4/deca9062d67c8306efcb1052f7f18c8d/ny-post-logo.webp',
  description: ``,
  originalHeight: 178,
  originalWidth: 1178
}

/**
 * ![Evening Standard Logo - 2021](https://images.ctfassets.net/v6awd0kabi65/4YCDfrvFMpO763pOALdJXy/0840592a49ac361a1d4e42f79cb29511/ES_BestTopPick_2021.webp?w=120&h=120&fit=pad)
 *
 * Evening Standard Logo - 2021
 *
 * Evening Standard. ES Best Top Pick, 2021
 */
export const IMG_4YCDfrvFMpO763pOALdJXy = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4YCDfrvFMpO763pOALdJXy/0840592a49ac361a1d4e42f79cb29511/ES_BestTopPick_2021.webp',
  description: `Evening Standard. ES Best Top Pick, 2021`,
  originalHeight: 1207,
  originalWidth: 1080
}

/**
 * ![T3 Platinum Award 2022](https://images.ctfassets.net/v6awd0kabi65/5X5OsfxAW6Fc2Zj3HZDlHC/4332592ce96648e80579a5b9e8bf601b/T3.png?w=120&h=120&fit=pad)
 *
 * T3 Platinum Award 2022
 *
 * T3: Platinum Award March 2022
 */
export const IMG_5X5OsfxAW6Fc2Zj3HZDlHC = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5X5OsfxAW6Fc2Zj3HZDlHC/4332592ce96648e80579a5b9e8bf601b/T3.png',
  description: `T3: Platinum Award March 2022`,
  originalHeight: 444,
  originalWidth: 440
}

/**
 * ![US News Logo](https://images.ctfassets.net/v6awd0kabi65/4RGr4AOGk5D9LIYXMcsuY7/4e4ad1518ad97e24df86cc44b4c1df98/logo_usnews-white.webp?w=120&h=120&fit=pad)
 *
 * US News Logo
 *
 * U.S. News and World Report
 */
export const IMG_4RGr4AOGk5D9LIYXMcsuY7 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4RGr4AOGk5D9LIYXMcsuY7/4e4ad1518ad97e24df86cc44b4c1df98/logo_usnews-white.webp',
  description: `U.S. News and World Report`,
  originalHeight: 68,
  originalWidth: 418
}

/**
 * ![ZD Net](https://images.ctfassets.net/v6awd0kabi65/7s9wKSxRh7K1OJWkCdCt3n/f21c9586ae0e6b39bdf8ae5a9a27f1e6/ZD_Net.png?w=120&h=120&fit=pad)
 *
 * ZD Net
 *
 * ZD Net
 */
export const IMG_7s9wKSxRh7K1OJWkCdCt3n = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7s9wKSxRh7K1OJWkCdCt3n/f21c9586ae0e6b39bdf8ae5a9a27f1e6/ZD_Net.png',
  description: `ZD Net`,
  originalHeight: 100,
  originalWidth: 158
}

/**
 * ![Digital Trends](https://images.ctfassets.net/v6awd0kabi65/5glkkgraoMQBI8FncmxmpT/7a07dee4ca27f91b8508d0f889bca3bf/Digital_Trends.png?w=120&h=120&fit=pad)
 *
 * Digital Trends
 *
 *
 */
export const IMG_5glkkgraoMQBI8FncmxmpT = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5glkkgraoMQBI8FncmxmpT/7a07dee4ca27f91b8508d0f889bca3bf/Digital_Trends.png',
  description: ``,
  originalHeight: 70,
  originalWidth: 412
}

/**
 * ![US News](https://images.ctfassets.net/v6awd0kabi65/5p86kP6L5N3LPrr1ET2QH3/513d9379fc9c303d3a186678f4e3d0c1/US_News.png?w=120&h=120&fit=pad)
 *
 * US News
 *
 *
 */
export const IMG_5p86kP6L5N3LPrr1ET2QH3 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5p86kP6L5N3LPrr1ET2QH3/513d9379fc9c303d3a186678f4e3d0c1/US_News.png',
  description: ``,
  originalHeight: 130,
  originalWidth: 508
}

/**
 * ![Facebook Review logo](https://images.ctfassets.net/v6awd0kabi65/410QNF2riSjgH4gXpBOEux/4d67c8f4a4e7703b7f95687becf1c643/review-logo_Facebook.png?w=120&h=120&fit=pad)
 *
 * Facebook Review logo
 *
 *
 */
export const IMG_410QNF2riSjgH4gXpBOEux = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/410QNF2riSjgH4gXpBOEux/4d67c8f4a4e7703b7f95687becf1c643/review-logo_Facebook.png',
  description: ``,
  originalHeight: 68,
  originalWidth: 340
}

/**
 * ![Apple Insider](https://images.ctfassets.net/v6awd0kabi65/5yrlATcVfgUC1Jc1tW78bJ/ba47134b04511170ab6d78693df8e5de/Apple_Insider.png?w=120&h=120&fit=pad)
 *
 * Apple Insider
 *
 *
 */
export const IMG_5yrlATcVfgUC1Jc1tW78bJ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5yrlATcVfgUC1Jc1tW78bJ/ba47134b04511170ab6d78693df8e5de/Apple_Insider.png',
  description: ``,
  originalHeight: 100,
  originalWidth: 338
}

/**
 * ![Angie's List](https://images.ctfassets.net/v6awd0kabi65/6WGTY9EEVXPdbmrzHBLWCh/34187be7c7c22e0d6e65a03a9980957b/Angie_s_List.png?w=120&h=120&fit=pad)
 *
 * Angie's List
 *
 *
 */
export const IMG_6WGTY9EEVXPdbmrzHBLWCh = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6WGTY9EEVXPdbmrzHBLWCh/34187be7c7c22e0d6e65a03a9980957b/Angie_s_List.png',
  description: ``,
  originalHeight: 81,
  originalWidth: 450
}

/**
 * ![Today Icon](https://images.ctfassets.net/v6awd0kabi65/6WvrJ8jHfXzqMJVBqtR1d3/5bb2d347919b9d934e4c383d2b107dfc/Today_Icon.png?w=120&h=120&fit=pad)
 *
 * Today Icon
 *
 *
 */
export const IMG_6WvrJ8jHfXzqMJVBqtR1d3 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6WvrJ8jHfXzqMJVBqtR1d3/5bb2d347919b9d934e4c383d2b107dfc/Today_Icon.png',
  description: ``,
  originalHeight: 40,
  originalWidth: 53
}

/**
 * ![Glassbreak](https://images.ctfassets.net/v6awd0kabi65/14pD8tdfDaH0Tpjx2xV2p4/23ed8af882329d5438dacb53cf0961d3/Low_Res-Glassbreak.jpeg?w=120&h=120&fit=pad)
 *
 * Glassbreak
 *
 * Glassbreak sensor sitting on a shelf next to some kitchen vessels
 */
export const IMG_14pD8tdfDaH0Tpjx2xV2p4 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/14pD8tdfDaH0Tpjx2xV2p4/23ed8af882329d5438dacb53cf0961d3/Low_Res-Glassbreak.jpeg',
  description: `Glassbreak sensor sitting on a shelf next to some kitchen vessels`,
  originalHeight: 1092,
  originalWidth: 1456
}

/**
 * ![Popular Science](https://images.ctfassets.net/v6awd0kabi65/5IF1Pgm5unOhWfqvIrSuw3/007efe26a78598d7b7b84e01bd20c286/Popular_Science.png?w=120&h=120&fit=pad)
 *
 * Popular Science
 *
 *
 */
export const IMG_5IF1Pgm5unOhWfqvIrSuw3 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5IF1Pgm5unOhWfqvIrSuw3/007efe26a78598d7b7b84e01bd20c286/Popular_Science.png',
  description: ``,
  originalHeight: 472,
  originalWidth: 1302
}

/**
 * ![Amazon 4.5 Stars](https://images.ctfassets.net/v6awd0kabi65/2foQJzePKBdwnjRXKeKpwF/71a636ffae1504fdbd70dbfa3fc8f917/Amazon_4.5_Stars.png?w=120&h=120&fit=pad)
 *
 * Amazon 4.5 Stars
 *
 *
 */
export const IMG_2foQJzePKBdwnjRXKeKpwF = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2foQJzePKBdwnjRXKeKpwF/71a636ffae1504fdbd70dbfa3fc8f917/Amazon_4.5_Stars.png',
  description: ``,
  originalHeight: 196,
  originalWidth: 306
}

/**
 * ![PC Mag](https://images.ctfassets.net/v6awd0kabi65/sPliyeoFHDONG7Px6tQs6/cb84d883d452df7f96eb04d7228326f4/PC_Mag.png?w=120&h=120&fit=pad)
 *
 * PC Mag
 *
 * PC Mag review
 */
export const IMG_sPliyeoFHDONG7Px6tQs6 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/sPliyeoFHDONG7Px6tQs6/cb84d883d452df7f96eb04d7228326f4/PC_Mag.png',
  description: `PC Mag review`,
  originalHeight: 100,
  originalWidth: 100
}

/**
 * ![Tech Crunch](https://images.ctfassets.net/v6awd0kabi65/1O7zfurgPyQqjlojOBEfLT/88c34e7bfd3f1d13c503c31597acfc61/Tech_Crunch.png?w=120&h=120&fit=pad)
 *
 * Tech Crunch
 *
 *
 */
export const IMG_1O7zfurgPyQqjlojOBEfLT = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1O7zfurgPyQqjlojOBEfLT/88c34e7bfd3f1d13c503c31597acfc61/Tech_Crunch.png',
  description: ``,
  originalHeight: 66,
  originalWidth: 343
}

/**
 * ![Popular Mechanics](https://images.ctfassets.net/v6awd0kabi65/486DRI0rheXhZw76lyozGk/631bb61e0a62e3107e3af0dbe78059d4/Popular_Mechanics.png?w=120&h=120&fit=pad)
 *
 * Popular Mechanics
 *
 *
 */
export const IMG_486DRI0rheXhZw76lyozGk = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/486DRI0rheXhZw76lyozGk/631bb61e0a62e3107e3af0dbe78059d4/Popular_Mechanics.png',
  description: ``,
  originalHeight: 376,
  originalWidth: 900
}

/**
 * ![Venture Solar Logo](https://images.ctfassets.net/v6awd0kabi65/3surWHU8XJz8WupJGOdl4z/5869fe3e7e6fb50ebccbd9a7a10beda3/VentureSolar_PrimaryLogo_White.png?w=120&h=120&fit=pad)
 *
 * Venture Solar Logo
 *
 * Venture Solar Logo
 */
export const IMG_3surWHU8XJz8WupJGOdl4z = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3surWHU8XJz8WupJGOdl4z/5869fe3e7e6fb50ebccbd9a7a10beda3/VentureSolar_PrimaryLogo_White.png',
  description: `Venture Solar Logo`,
  originalHeight: 534,
  originalWidth: 4363
}

/**
 * ![Newsweek America's Best Customer Service 2024](https://images.ctfassets.net/v6awd0kabi65/3DTUGIquyV64OFfWua1sqK/e32a21830836a1e53049a694f953f6cf/Newsweek_BCS2024_Logo_Basic_1.png?w=120&h=120&fit=pad)
 *
 * Newsweek America's Best Customer Service 2024
 *
 * Newsweek: America's Best Customer Service 2024
 */
export const IMG_3DTUGIquyV64OFfWua1sqK = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3DTUGIquyV64OFfWua1sqK/e32a21830836a1e53049a694f953f6cf/Newsweek_BCS2024_Logo_Basic_1.png',
  description: `Newsweek: America's Best Customer Service 2024`,
  originalHeight: 591,
  originalWidth: 500
}

/**
 * ![How to Protect a Vulnerable Home Entryway The Garage](https://images.ctfassets.net/v6awd0kabi65/59eT90pH4phSi3oRjbpA2L/5f0ec482b9d1a441859a291737c4cf86/How_to_Protect_a_Vulnerable_Home_Entryway__The_Garage.jpg?w=120&h=120&fit=pad)
 *
 * How to Protect a Vulnerable Home Entryway The Garage
 *
 *
 */
export const IMG_59eT90pH4phSi3oRjbpA2L = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/59eT90pH4phSi3oRjbpA2L/5f0ec482b9d1a441859a291737c4cf86/How_to_Protect_a_Vulnerable_Home_Entryway__The_Garage.jpg',
  description: ``,
  originalHeight: 3648,
  originalWidth: 5472
}

/**
 * ![ Non-Insurance Starter Kit](https://images.ctfassets.net/v6awd0kabi65/1gpaNi9uJgcnpyefst06uj/e81985973a75a67491d5c9ae08d4af2d/Standard_Starter_Kit__Small_Non-Insurance____1_.webp?w=120&h=120&fit=pad)
 *
 *  Non-Insurance Starter Kit
 *
 *
 */
export const IMG_1gpaNi9uJgcnpyefst06uj = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1gpaNi9uJgcnpyefst06uj/e81985973a75a67491d5c9ae08d4af2d/Standard_Starter_Kit__Small_Non-Insurance____1_.webp',
  description: ``,
  originalHeight: 1800,
  originalWidth: 1800
}

/**
 * ![SimpliSafe_CEO_4_24](https://images.ctfassets.net/v6awd0kabi65/6erfaNuFYdVn8u684o5UYR/8268186ebab45c141a70fd7b34535d45/Screenshot_2024-04-17_at_11.30.04_AM.png?w=120&h=120&fit=pad)
 *
 * SimpliSafe_CEO_4_24
 *
 *
 */
export const IMG_6erfaNuFYdVn8u684o5UYR = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6erfaNuFYdVn8u684o5UYR/8268186ebab45c141a70fd7b34535d45/Screenshot_2024-04-17_at_11.30.04_AM.png',
  description: ``,
  originalHeight: 774,
  originalWidth: 1176
}

/**
 * ![Coda cart 2x](https://images.ctfassets.net/v6awd0kabi65/5zR69LSoNiwTFGqJW1VsGg/780263227566c67f3d7783866e7735a6/Coda_cart_2x.jpg?w=120&h=120&fit=pad)
 *
 * Coda cart 2x
 *
 *
 */
export const IMG_5zR69LSoNiwTFGqJW1VsGg = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5zR69LSoNiwTFGqJW1VsGg/780263227566c67f3d7783866e7735a6/Coda_cart_2x.jpg',
  description: ``,
  originalHeight: 1828,
  originalWidth: 1822
}

/**
 * ![ODM Beta Site Graphics - IMAGE 3 - You are always in control of your privacy](https://images.ctfassets.net/v6awd0kabi65/7DDLBvZZY8MNl0yA94rKU3/49a3cd344e87dfb9d2cc11f2d87a5e07/ODM_Beta_Site_Graphics_-_IMAGE_3_-_You_are_always_in_control_of_your_privacy.jpg?w=120&h=120&fit=pad)
 *
 * ODM Beta Site Graphics - IMAGE 3 - You are always in control of your privacy
 *
 *
 */
export const IMG_7DDLBvZZY8MNl0yA94rKU3 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7DDLBvZZY8MNl0yA94rKU3/49a3cd344e87dfb9d2cc11f2d87a5e07/ODM_Beta_Site_Graphics_-_IMAGE_3_-_You_are_always_in_control_of_your_privacy.jpg',
  description: ``,
  originalHeight: 1191,
  originalWidth: 1866
}

/**
 * ![ODM BETA SITE GRAPHICS - IMAGE 2 - Agent Camera Intruder @3x](https://images.ctfassets.net/v6awd0kabi65/6AmniMuwCG4EUZVHTDGP12/989a23d6eba2ff5d234c4858048976e7/ODM_BETA_SITE_GRAPHICS_-_IMAGE_2_-_Agent_Camera_Intruder__3x.jpg?w=120&h=120&fit=pad)
 *
 * ODM BETA SITE GRAPHICS - IMAGE 2 - Agent Camera Intruder @3x
 *
 *
 */
export const IMG_6AmniMuwCG4EUZVHTDGP12 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6AmniMuwCG4EUZVHTDGP12/989a23d6eba2ff5d234c4858048976e7/ODM_BETA_SITE_GRAPHICS_-_IMAGE_2_-_Agent_Camera_Intruder__3x.jpg',
  description: ``,
  originalHeight: 3573,
  originalWidth: 5598
}

/**
 * ![Which? Best Buy 2024](https://images.ctfassets.net/v6awd0kabi65/7eH4KhA049wM5ZTOOmWyWd/f83fc66d5fbf4e0c6e966a843900b695/Burglar_Alarms_January_2024.png?w=120&h=120&fit=pad)
 *
 * Which? Best Buy 2024
 *
 * Which? Best Buy: Burglar Alarms January 2024
 */
export const IMG_7eH4KhA049wM5ZTOOmWyWd = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7eH4KhA049wM5ZTOOmWyWd/f83fc66d5fbf4e0c6e966a843900b695/Burglar_Alarms_January_2024.png',
  description: `Which? Best Buy: Burglar Alarms January 2024`,
  originalHeight: 2348,
  originalWidth: 2952
}

/**
 * ![US News Best Home Security System 2023-24](https://images.ctfassets.net/v6awd0kabi65/6uVhRdfLw8y6L3x78SiCuM/f673482e13d78cdc6a1c78048e2fffec/360_reviews.png?w=120&h=120&fit=pad)
 *
 * US News Best Home Security System 2023-24
 *
 * US News & World Report: 360 Reviews Best Home Security Systems 2023-24
 */
export const IMG_6uVhRdfLw8y6L3x78SiCuM = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6uVhRdfLw8y6L3x78SiCuM/f673482e13d78cdc6a1c78048e2fffec/360_reviews.png',
  description: `US News & World Report: 360 Reviews Best Home Security Systems 2023-24 `,
  originalHeight: 445,
  originalWidth: 440
}

/**
 * ![CNET Editor's Choice Award 2023 (black bg)](https://images.ctfassets.net/v6awd0kabi65/5zlpfQRe1KzOKCKjbPvjsB/68f1df781bc44794bd7baccccb09f02f/CNET_ECA_2023.png?w=120&h=120&fit=pad)
 *
 * CNET Editor's Choice Award 2023 (black bg)
 *
 * CNET: 2023 Editors' Choice Award
 */
export const IMG_5zlpfQRe1KzOKCKjbPvjsB = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5zlpfQRe1KzOKCKjbPvjsB/68f1df781bc44794bd7baccccb09f02f/CNET_ECA_2023.png',
  description: `CNET: 2023 Editors' Choice Award`,
  originalHeight: 402,
  originalWidth: 311
}

/**
 * ![CNET Editor's Choice Award 2023 (white bg)](https://images.ctfassets.net/v6awd0kabi65/6Fk167pQyK44F3g51qYJ5U/a546114a51187c45d2166ef3315d9574/CNET.png?w=120&h=120&fit=pad)
 *
 * CNET Editor's Choice Award 2023 (white bg)
 *
 * CNET: 2023 Editors' Choice Award
 */
export const IMG_6Fk167pQyK44F3g51qYJ5U = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6Fk167pQyK44F3g51qYJ5U/a546114a51187c45d2166ef3315d9574/CNET.png',
  description: `CNET: 2023 Editors' Choice Award`,
  originalHeight: 432,
  originalWidth: 334
}

/**
 * ![Home Movers Image](https://images.ctfassets.net/v6awd0kabi65/XAxyWhds68rzSs2C7ZLPw/bc8435066f1e9aecae92ae6fed80a114/home-movers-desktop.jpg?w=120&h=120&fit=pad)
 *
 * Home Movers Image
 *
 *
 */
export const IMG_XAxyWhds68rzSs2C7ZLPw = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/XAxyWhds68rzSs2C7ZLPw/bc8435066f1e9aecae92ae6fed80a114/home-movers-desktop.jpg',
  description: ``,
  originalHeight: 701,
  originalWidth: 932
}

/**
 * ![Securitas Logo](https://images.ctfassets.net/v6awd0kabi65/14yvmHmnTfhVxjMrhJfnPc/a13bda668a42b3417718e4b7aedfd2ac/6914eebdef1d35c5cf9382f432173c37.png?w=120&h=120&fit=pad)
 *
 * Securitas Logo
 *
 * Securitas Logo
 */
export const IMG_14yvmHmnTfhVxjMrhJfnPc = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/14yvmHmnTfhVxjMrhJfnPc/a13bda668a42b3417718e4b7aedfd2ac/6914eebdef1d35c5cf9382f432173c37.png',
  description: `Securitas Logo`,
  originalHeight: 900,
  originalWidth: 1440
}

/**
 * ![Landing Page: Cameras Tablet](https://images.ctfassets.net/v6awd0kabi65/6iKVX2EDrTKckyAYLd8Ena/2f87ea3d16972820c1881befe7ee609b/image__6_.png?w=120&h=120&fit=pad)
 *
 * Landing Page: Cameras Tablet
 *
 * Simplisafe doorbell, outdoor camera, and cellphone with the Simplisafe App opened up
 */
export const IMG_6iKVX2EDrTKckyAYLd8Ena = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6iKVX2EDrTKckyAYLd8Ena/2f87ea3d16972820c1881befe7ee609b/image__6_.png',
  description: `Simplisafe doorbell, outdoor camera, and cellphone with the Simplisafe App opened up`,
  originalHeight: 1308,
  originalWidth: 2304
}

/**
 * ![Landing Page: Cameras Mobile](https://images.ctfassets.net/v6awd0kabi65/3HkxDiCasLkRmwKqYhwni1/18a977d4a89a6ce164a5b13b188904a6/mobile-hero2_1.png?w=120&h=120&fit=pad)
 *
 * Landing Page: Cameras Mobile
 *
 * Simplisafe doorbell, outdoor camera, and cellphone with the Simplisafe App opened up
 */
export const IMG_3HkxDiCasLkRmwKqYhwni1 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3HkxDiCasLkRmwKqYhwni1/18a977d4a89a6ce164a5b13b188904a6/mobile-hero2_1.png',
  description: `Simplisafe doorbell, outdoor camera, and cellphone with the Simplisafe App opened up`,
  originalHeight: 1092,
  originalWidth: 1128
}

/**
 * ![Landing Page: Cameras Desktop](https://images.ctfassets.net/v6awd0kabi65/38O3RdlweihJCuFCIW5KSY/d775a4ef43211cf18f0bf4e4612dd3ec/Camera_set__1_.png?w=120&h=120&fit=pad)
 *
 * Landing Page: Cameras Desktop
 *
 * Simplisafe doorbell, outdoor camera, and cellphone with the Simplisafe App opened up
 */
export const IMG_38O3RdlweihJCuFCIW5KSY = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/38O3RdlweihJCuFCIW5KSY/d775a4ef43211cf18f0bf4e4612dd3ec/Camera_set__1_.png',
  description: `Simplisafe doorbell, outdoor camera, and cellphone with the Simplisafe App opened up`,
  originalHeight: 1800,
  originalWidth: 3936
}

/**
 * ![cdc-F98Mv9O6LfI-unsplash](https://images.ctfassets.net/v6awd0kabi65/3p1TFa0B2orIKwDjSriCtD/e3b756230df6f87495f75d72ba1d81fe/cdc-F98Mv9O6LfI-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * cdc-F98Mv9O6LfI-unsplash
 *
 *
 */
export const IMG_3p1TFa0B2orIKwDjSriCtD = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3p1TFa0B2orIKwDjSriCtD/e3b756230df6f87495f75d72ba1d81fe/cdc-F98Mv9O6LfI-unsplash.jpg',
  description: ``,
  originalHeight: 2731,
  originalWidth: 4096
}

/**
 * ![brooke-cagle-8jp-6SjVibM-unsplash](https://images.ctfassets.net/v6awd0kabi65/6J2qGswEBtTx7ryjhaX14C/25d1ff4118468dfb99ca86586493e8b3/brooke-cagle-8jp-6SjVibM-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * brooke-cagle-8jp-6SjVibM-unsplash
 *
 *
 */
export const IMG_6J2qGswEBtTx7ryjhaX14C = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6J2qGswEBtTx7ryjhaX14C/25d1ff4118468dfb99ca86586493e8b3/brooke-cagle-8jp-6SjVibM-unsplash.jpg',
  description: ``,
  originalHeight: 3548,
  originalWidth: 5322
}

/**
 * ![video doorbell pro iphone notifications](https://images.ctfassets.net/v6awd0kabi65/3HOg1C29w0KCTv6u8v79Uy/cdd656fddd3b9f95dae7f76b28654afe/image__13_.png?w=120&h=120&fit=pad)
 *
 * video doorbell pro iphone notifications
 *
 *
 */
export const IMG_3HOg1C29w0KCTv6u8v79Uy = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3HOg1C29w0KCTv6u8v79Uy/cdd656fddd3b9f95dae7f76b28654afe/image__13_.png',
  description: ``,
  originalHeight: 316,
  originalWidth: 461
}

/**
 * ![The Independent Advisor Simplisafe Tower ](https://images.ctfassets.net/v6awd0kabi65/6nBnviCIlnz1sKQHXzp21v/8a50934e407c1008a1bec810ec82692b/Untitled_design__3_.png?w=120&h=120&fit=pad)
 *
 * The Independent Advisor Simplisafe Tower
 *
 *
 */
export const IMG_6nBnviCIlnz1sKQHXzp21v = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6nBnviCIlnz1sKQHXzp21v/8a50934e407c1008a1bec810ec82692b/Untitled_design__3_.png',
  description: ``,
  originalHeight: 1272,
  originalWidth: 1920
}

/**
 * ![SL Carousel 1](https://images.ctfassets.net/v6awd0kabi65/4lieu5uzxowlhFMpynCqm3/5eb13d9ded05bdd04a517bc4e4ce2949/SL_Carousel_1.jpg?w=120&h=120&fit=pad)
 *
 * SL Carousel 1
 *
 *
 */
export const IMG_4lieu5uzxowlhFMpynCqm3 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4lieu5uzxowlhFMpynCqm3/5eb13d9ded05bdd04a517bc4e4ce2949/SL_Carousel_1.jpg',
  description: ``,
  originalHeight: 1553,
  originalWidth: 1968
}

/**
 * ![smart lock risk free image obsidian](https://images.ctfassets.net/v6awd0kabi65/tiRuUMD0uyuPIcP2nrPKt/2e1173b7f69fa89486fbb181a05fac1f/image__12_.png?w=120&h=120&fit=pad)
 *
 * smart lock risk free image obsidian
 *
 *
 */
export const IMG_tiRuUMD0uyuPIcP2nrPKt = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/tiRuUMD0uyuPIcP2nrPKt/2e1173b7f69fa89486fbb181a05fac1f/image__12_.png',
  description: ``,
  originalHeight: 992,
  originalWidth: 984
}

/**
 * ![smart lock risk free image white](https://images.ctfassets.net/v6awd0kabi65/7eQW3zBEI2xvi4Kx01USRF/0138f133840dec320fba859be87326a5/image__11_.png?w=120&h=120&fit=pad)
 *
 * smart lock risk free image white
 *
 *
 */
export const IMG_7eQW3zBEI2xvi4Kx01USRF = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7eQW3zBEI2xvi4Kx01USRF/0138f133840dec320fba859be87326a5/image__11_.png',
  description: ``,
  originalHeight: 992,
  originalWidth: 984
}

/**
 * ![04152019 SimpliSafe](https://images.ctfassets.net/v6awd0kabi65/nMG62HzIjUeJoH2LU3l5a/421974bd61dfef09becdc4f9902988fa/04152019_SimpliSafe.png?w=120&h=120&fit=pad)
 *
 * 04152019 SimpliSafe
 *
 *
 */
export const IMG_nMG62HzIjUeJoH2LU3l5a = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/nMG62HzIjUeJoH2LU3l5a/421974bd61dfef09becdc4f9902988fa/04152019_SimpliSafe.png',
  description: ``,
  originalHeight: 1334,
  originalWidth: 2000
}

/**
 * ![SL Lock](https://images.ctfassets.net/v6awd0kabi65/7prSVpHjxtB2KdGvH5BAO7/39e945f835ef8c496c3767c14eff92a3/SL_Lock.jpeg?w=120&h=120&fit=pad)
 *
 * SL Lock
 *
 *
 */
export const IMG_7prSVpHjxtB2KdGvH5BAO7 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7prSVpHjxtB2KdGvH5BAO7/39e945f835ef8c496c3767c14eff92a3/SL_Lock.jpeg',
  description: ``,
  originalHeight: 659,
  originalWidth: 1114
}

/**
 * ![SL_Pinpad](https://images.ctfassets.net/v6awd0kabi65/6V98UYhuUlEvYIw3SX0fJJ/8961fe31b2a575edf5288adac0072a34/SL_Pinpad.jpeg?w=120&h=120&fit=pad)
 *
 * SL_Pinpad
 *
 *
 */
export const IMG_6V98UYhuUlEvYIw3SX0fJJ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6V98UYhuUlEvYIw3SX0fJJ/8961fe31b2a575edf5288adac0072a34/SL_Pinpad.jpeg',
  description: ``,
  originalHeight: 1511,
  originalWidth: 1200
}

/**
 * ![Alarm Moment - Package theft](https://images.ctfassets.net/v6awd0kabi65/6toQ2EgazM58ksGSxRB1vv/a854cfb371a8dfcdd5880b3d23c443c4/package_q.jpg?w=120&h=120&fit=pad)
 *
 * Alarm Moment - Package theft
 *
 *
 */
export const IMG_6toQ2EgazM58ksGSxRB1vv = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6toQ2EgazM58ksGSxRB1vv/a854cfb371a8dfcdd5880b3d23c443c4/package_q.jpg',
  description: ``,
  originalHeight: 1056,
  originalWidth: 1932
}

/**
 * ![Alarm Moment - Temp](https://images.ctfassets.net/v6awd0kabi65/2kLJKdokoXhqvWibaAQQq1/8aae5a36569c1d5cf4552dae2a783282/temp_hot_2x_q.jpg?w=120&h=120&fit=pad)
 *
 * Alarm Moment - Temp
 *
 *
 */
export const IMG_2kLJKdokoXhqvWibaAQQq1 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2kLJKdokoXhqvWibaAQQq1/8aae5a36569c1d5cf4552dae2a783282/temp_hot_2x_q.jpg',
  description: ``,
  originalHeight: 1056,
  originalWidth: 1932
}

/**
 * ![Alarm Moment - Water](https://images.ctfassets.net/v6awd0kabi65/4VCj3kLYoNj48WBdzQapRw/fc43568ad7a8e339eb68a71d88a3f619/water_2x_q.jpg?w=120&h=120&fit=pad)
 *
 * Alarm Moment - Water
 *
 *
 */
export const IMG_4VCj3kLYoNj48WBdzQapRw = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4VCj3kLYoNj48WBdzQapRw/fc43568ad7a8e339eb68a71d88a3f619/water_2x_q.jpg',
  description: ``,
  originalHeight: 1056,
  originalWidth: 1932
}

/**
 * ![Alarm Moment - Fire](https://images.ctfassets.net/v6awd0kabi65/1VsnTiiAvu3fBiOHNVbXTY/0fef43ec7702a505e714ae1f4d6013a2/fire_2x_q.jpg?w=120&h=120&fit=pad)
 *
 * Alarm Moment - Fire
 *
 *
 */
export const IMG_1VsnTiiAvu3fBiOHNVbXTY = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1VsnTiiAvu3fBiOHNVbXTY/0fef43ec7702a505e714ae1f4d6013a2/fire_2x_q.jpg',
  description: ``,
  originalHeight: 1056,
  originalWidth: 1932
}

/**
 * ![Alarm Moment - Break-in](https://images.ctfassets.net/v6awd0kabi65/B0amp82UybsNZRk8whwTc/5df1210b483f6d10cfdd64f15c1dd8e6/break_in_2x_-qly.webp?w=120&h=120&fit=pad)
 *
 * Alarm Moment - Break-in
 *
 *
 */
export const IMG_B0amp82UybsNZRk8whwTc = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/B0amp82UybsNZRk8whwTc/5df1210b483f6d10cfdd64f15c1dd8e6/break_in_2x_-qly.webp',
  description: ``,
  originalHeight: 1056,
  originalWidth: 1932
}

/**
 * ![ODCam Carousel 5](https://images.ctfassets.net/v6awd0kabi65/uQH5eZx2cgX2P3ienWVo7/49eb2c742300e9fb8566e02e064ce4f8/ODCam_Carousel_5.jpg?w=120&h=120&fit=pad)
 *
 * ODCam Carousel 5
 *
 *
 */
export const IMG_uQH5eZx2cgX2P3ienWVo7 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/uQH5eZx2cgX2P3ienWVo7/49eb2c742300e9fb8566e02e064ce4f8/ODCam_Carousel_5.jpg',
  description: ``,
  originalHeight: 1553,
  originalWidth: 1968
}

/**
 * ![ODCam deter intruders](https://images.ctfassets.net/v6awd0kabi65/7xWN51WXBcU2z7KYKmCqz6/cd226db684fa3d2a34e67d069aa961cf/ODCam_deter_intruders.jpg?w=120&h=120&fit=pad)
 *
 * ODCam deter intruders
 *
 *
 */
export const IMG_7xWN51WXBcU2z7KYKmCqz6 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7xWN51WXBcU2z7KYKmCqz6/cd226db684fa3d2a34e67d069aa961cf/ODCam_deter_intruders.jpg',
  description: ``,
  originalHeight: 794,
  originalWidth: 1244
}

/**
 * ![ODCam app 4](https://images.ctfassets.net/v6awd0kabi65/587wDhlBvY5323Sm8yduCi/11c2d33835b767390c8c80bd6c3d4f08/ODCam_app_4.png?w=120&h=120&fit=pad)
 *
 * ODCam app 4
 *
 *
 */
export const IMG_587wDhlBvY5323Sm8yduCi = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/587wDhlBvY5323Sm8yduCi/11c2d33835b767390c8c80bd6c3d4f08/ODCam_app_4.png',
  description: ``,
  originalHeight: 1254,
  originalWidth: 1000
}

/**
 * ![ODCam app 3](https://images.ctfassets.net/v6awd0kabi65/3ylur0g22nZVBiH0dOCmJr/997f021acc50c6be537450be001e5a72/ODCam_app_3.png?w=120&h=120&fit=pad)
 *
 * ODCam app 3
 *
 *
 */
export const IMG_3ylur0g22nZVBiH0dOCmJr = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3ylur0g22nZVBiH0dOCmJr/997f021acc50c6be537450be001e5a72/ODCam_app_3.png',
  description: ``,
  originalHeight: 1254,
  originalWidth: 1000
}

/**
 * ![ODCam app 2](https://images.ctfassets.net/v6awd0kabi65/486pGLI3a7MLCTmxleoC43/8e182d5753afab41fb14308c1613046f/ODCam_app_2.png?w=120&h=120&fit=pad)
 *
 * ODCam app 2
 *
 *
 */
export const IMG_486pGLI3a7MLCTmxleoC43 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/486pGLI3a7MLCTmxleoC43/8e182d5753afab41fb14308c1613046f/ODCam_app_2.png',
  description: ``,
  originalHeight: 1254,
  originalWidth: 1000
}

/**
 * ![ODCam app 1](https://images.ctfassets.net/v6awd0kabi65/4aIw5RvbqAqVTum97KhoKZ/32ee2c0934d478a1db679be11fc68682/ODCam_app_1.png?w=120&h=120&fit=pad)
 *
 * ODCam app 1
 *
 *
 */
export const IMG_4aIw5RvbqAqVTum97KhoKZ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4aIw5RvbqAqVTum97KhoKZ/32ee2c0934d478a1db679be11fc68682/ODCam_app_1.png',
  description: ``,
  originalHeight: 1254,
  originalWidth: 1000
}

/**
 * ![smart lock app widget settings](https://images.ctfassets.net/v6awd0kabi65/USgpjs2lUUTfFGZz3O4Sv/98c6bbc843304f9dd328630ead2a9f44/smart_lock_app_widget_settings.png?w=120&h=120&fit=pad)
 *
 * smart lock app widget settings
 *
 *
 */
export const IMG_USgpjs2lUUTfFGZz3O4Sv = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/USgpjs2lUUTfFGZz3O4Sv/98c6bbc843304f9dd328630ead2a9f44/smart_lock_app_widget_settings.png',
  description: ``,
  originalHeight: 2532,
  originalWidth: 1170
}

/**
 * ![smart lock app widget timeline](https://images.ctfassets.net/v6awd0kabi65/734HGKd0usGgecLXbqcHA5/f8c27706c6eeba653de4664d708b1019/smart_lock_app_widget_timeline.png?w=120&h=120&fit=pad)
 *
 * smart lock app widget timeline
 *
 *
 */
export const IMG_734HGKd0usGgecLXbqcHA5 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/734HGKd0usGgecLXbqcHA5/f8c27706c6eeba653de4664d708b1019/smart_lock_app_widget_timeline.png',
  description: ``,
  originalHeight: 2532,
  originalWidth: 1170
}

/**
 * ![smart lock app widget remote](https://images.ctfassets.net/v6awd0kabi65/1EP89zSYeTjd5Ca6WXiYtm/e6e6e388c716eca89f1ab27116291a95/smart_lock_app_widget_remote.jpeg?w=120&h=120&fit=pad)
 *
 * smart lock app widget remote
 *
 *
 */
export const IMG_1EP89zSYeTjd5Ca6WXiYtm = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1EP89zSYeTjd5Ca6WXiYtm/e6e6e388c716eca89f1ab27116291a95/smart_lock_app_widget_remote.jpeg',
  description: ``,
  originalHeight: 2532,
  originalWidth: 1170
}

/**
 * ![Low Res-Scout House Intruder 792 FIN WEBX](https://images.ctfassets.net/v6awd0kabi65/56wUcKI0uYfCH29h6yfkBW/8f1e1de0c95125704546d79de964e65c/Low_Res-Scout_House_Intruder_792_FIN_WEBX.jpg?w=120&h=120&fit=pad)
 *
 * Low Res-Scout House Intruder 792 FIN WEBX
 *
 *
 */
export const IMG_56wUcKI0uYfCH29h6yfkBW = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/56wUcKI0uYfCH29h6yfkBW/8f1e1de0c95125704546d79de964e65c/Low_Res-Scout_House_Intruder_792_FIN_WEBX.jpg',
  description: ``,
  originalHeight: 1667,
  originalWidth: 2500
}

/**
 * ![tierra-mallorca-JXI2Ap8dTNc-unsplash](https://images.ctfassets.net/v6awd0kabi65/60Kq0K6eqPlRR5VxGLNzkA/015c7b489760c6c6b470ebfdd2c55ac8/tierra-mallorca-JXI2Ap8dTNc-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * tierra-mallorca-JXI2Ap8dTNc-unsplash
 *
 *
 */
export const IMG_60Kq0K6eqPlRR5VxGLNzkA = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/60Kq0K6eqPlRR5VxGLNzkA/015c7b489760c6c6b470ebfdd2c55ac8/tierra-mallorca-JXI2Ap8dTNc-unsplash.jpg',
  description: ``,
  originalHeight: 3448,
  originalWidth: 4592
}

/**
 * ![6 Tips on How to Feel Safe Living Alone](https://images.ctfassets.net/v6awd0kabi65/1u8PN6VwAe9h9SDvcD1KHb/a9f9ca79cedd098117f8ebc85ccd310a/6_Tips_on_How_to_Feel_Safe_Living_Alone.jpg?w=120&h=120&fit=pad)
 *
 * 6 Tips on How to Feel Safe Living Alone
 *
 *
 */
export const IMG_1u8PN6VwAe9h9SDvcD1KHb = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1u8PN6VwAe9h9SDvcD1KHb/a9f9ca79cedd098117f8ebc85ccd310a/6_Tips_on_How_to_Feel_Safe_Living_Alone.jpg',
  description: ``,
  originalHeight: 4320,
  originalWidth: 6480
}

/**
 * ![Hero Eve Fam](https://images.ctfassets.net/v6awd0kabi65/OOMTG4jFSAv711gfQHc1v/3f0f7f75889af56a6a9372144fdb6cbd/Hero_Eve_Fam.png?w=120&h=120&fit=pad)
 *
 * Hero Eve Fam
 *
 *
 */
export const IMG_OOMTG4jFSAv711gfQHc1v = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/OOMTG4jFSAv711gfQHc1v/3f0f7f75889af56a6a9372144fdb6cbd/Hero_Eve_Fam.png',
  description: ``,
  originalHeight: 3000,
  originalWidth: 4000
}

/**
 * ![SimpliSafe Bell Box - Brick wall](https://images.ctfassets.net/v6awd0kabi65/4N2FhjbHto1ImebYsoPhce/6185f54000eddd22c8ac88a767f76437/bell_box.png?w=120&h=120&fit=pad)
 *
 * SimpliSafe Bell Box - Brick wall
 *
 * SimpliSafe Bell Box on a brick wall
 */
export const IMG_4N2FhjbHto1ImebYsoPhce = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4N2FhjbHto1ImebYsoPhce/6185f54000eddd22c8ac88a767f76437/bell_box.png',
  description: `SimpliSafe Bell Box on a brick wall`,
  originalHeight: 1666,
  originalWidth: 1996
}

/**
 * ![SimpliSafe Bell Box](https://images.ctfassets.net/v6awd0kabi65/1Lo3p3R471tiMlMoUOMfeB/fe33aae5229dac5ea92c805003555196/Eve_render_standing_shadow.png?w=120&h=120&fit=pad)
 *
 * SimpliSafe Bell Box
 *
 * SimpliSafe Bell Box
 */
export const IMG_1Lo3p3R471tiMlMoUOMfeB = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1Lo3p3R471tiMlMoUOMfeB/fe33aae5229dac5ea92c805003555196/Eve_render_standing_shadow.png',
  description: `SimpliSafe Bell Box`,
  originalHeight: 1050,
  originalWidth: 1400
}

/**
 * ![SimpliSafe Bell Box - Transparent](https://images.ctfassets.net/v6awd0kabi65/1VzXyJjW5FZ7x4pB5YAClR/b4e8a7737bacb7691e041946ed410ff3/Eve_render_standing_shadow_cropped.png?w=120&h=120&fit=pad)
 *
 * SimpliSafe Bell Box - Transparent
 *
 * SimpliSafe Bell Box - BMS
 */
export const IMG_1VzXyJjW5FZ7x4pB5YAClR = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1VzXyJjW5FZ7x4pB5YAClR/b4e8a7737bacb7691e041946ed410ff3/Eve_render_standing_shadow_cropped.png',
  description: `SimpliSafe Bell Box - BMS`,
  originalHeight: 815,
  originalWidth: 1120
}

/**
 * ![Icon Youtube](https://images.ctfassets.net/v6awd0kabi65/4IXB3UVo3SrhoRFXXhm4VY/c5807ef1c12f30bfc0a56f93c846ca74/footer_youtube-logo.png?w=120&h=120&fit=pad)
 *
 * Icon Youtube
 *
 *
 */
export const IMG_4IXB3UVo3SrhoRFXXhm4VY = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4IXB3UVo3SrhoRFXXhm4VY/c5807ef1c12f30bfc0a56f93c846ca74/footer_youtube-logo.png',
  description: ``,
  originalHeight: 240,
  originalWidth: 240
}

/**
 * ![Icon Facebook](https://images.ctfassets.net/v6awd0kabi65/5EIPbWqI2Us8REZdGWfiF1/7dc7e3b359421bf112efa2cfa3ada3d5/footer_facebook-logo.png?w=120&h=120&fit=pad)
 *
 * Icon Facebook
 *
 *
 */
export const IMG_5EIPbWqI2Us8REZdGWfiF1 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5EIPbWqI2Us8REZdGWfiF1/7dc7e3b359421bf112efa2cfa3ada3d5/footer_facebook-logo.png',
  description: ``,
  originalHeight: 240,
  originalWidth: 240
}

/**
 * ![Icon Twitter](https://images.ctfassets.net/v6awd0kabi65/6mQNXJicH3fux0NFaL7IE9/a0a621d29b4c18c270db600e13f43464/footer_twitter-logo.png?w=120&h=120&fit=pad)
 *
 * Icon Twitter
 *
 *
 */
export const IMG_6mQNXJicH3fux0NFaL7IE9 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6mQNXJicH3fux0NFaL7IE9/a0a621d29b4c18c270db600e13f43464/footer_twitter-logo.png',
  description: ``,
  originalHeight: 240,
  originalWidth: 240
}

/**
 * ![Product - Smart Lock Main Menu Link](https://images.ctfassets.net/v6awd0kabi65/78tG2VMJmvUsDIkX7UgNN4/426836bedfc26b2f76d1b0f960a2826b/seamless-simple_lock.png?w=120&h=120&fit=pad)
 *
 * Product - Smart Lock Main Menu Link
 *
 * Product - Smart Lock
 */
export const IMG_78tG2VMJmvUsDIkX7UgNN4 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/78tG2VMJmvUsDIkX7UgNN4/426836bedfc26b2f76d1b0f960a2826b/seamless-simple_lock.png',
  description: `Product - Smart Lock`,
  originalHeight: 2604,
  originalWidth: 1184
}

/**
 * ![Logo](https://images.ctfassets.net/v6awd0kabi65/7MpXvhtaXO8MeT22h2QFkb/e3447ae8ebebd28e1bf943a493fce10c/SimpliSafe-wordmark-RGB_2x.png?w=120&h=120&fit=pad)
 *
 * Logo
 *
 *
 */
export const IMG_7MpXvhtaXO8MeT22h2QFkb = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7MpXvhtaXO8MeT22h2QFkb/e3447ae8ebebd28e1bf943a493fce10c/SimpliSafe-wordmark-RGB_2x.png',
  description: ``,
  originalHeight: 88,
  originalWidth: 384
}

/**
 * ![Bell Box - Link icon](https://images.ctfassets.net/v6awd0kabi65/67nlVVHZMWDHnnwUUZ4GaY/eafe2f1045d931432a7d1282f2b62595/1579ef64-51b8-456a-a56b-9a947eff52c6.png?w=120&h=120&fit=pad)
 *
 * Bell Box - Link icon
 *
 *
 */
export const IMG_67nlVVHZMWDHnnwUUZ4GaY = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/67nlVVHZMWDHnnwUUZ4GaY/eafe2f1045d931432a7d1282f2b62595/1579ef64-51b8-456a-a56b-9a947eff52c6.png',
  description: ``,
  originalHeight: 134,
  originalWidth: 134
}

/**
 * ![Product - Shield Outdoor Camera](https://images.ctfassets.net/v6awd0kabi65/6kLKm97nW9o104gVbWdLd3/9f74ee0df0af5eb0dbd882fe3db7d18f/Product_-_Shield_2x__1_.png?w=120&h=120&fit=pad)
 *
 * Product - Shield Outdoor Camera
 *
 * Product - Shield Outdoor Camera
 */
export const IMG_6kLKm97nW9o104gVbWdLd3 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6kLKm97nW9o104gVbWdLd3/9f74ee0df0af5eb0dbd882fe3db7d18f/Product_-_Shield_2x__1_.png',
  description: `Product - Shield Outdoor Camera`,
  originalHeight: 846,
  originalWidth: 1000
}

/**
 * ![Product - Video Doorbell (Nav)](https://images.ctfassets.net/v6awd0kabi65/2gKQClx9ExfSUTIAWViTVm/4a974aff0b8afd8e92fe425bd8d1da07/nav_prod-doorbell.png?w=120&h=120&fit=pad)
 *
 * Product - Video Doorbell (Nav)
 *
 * Product - Video Doorbell
 */
export const IMG_2gKQClx9ExfSUTIAWViTVm = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2gKQClx9ExfSUTIAWViTVm/4a974aff0b8afd8e92fe425bd8d1da07/nav_prod-doorbell.png',
  description: `Product - Video Doorbell`,
  originalHeight: 112,
  originalWidth: 112
}

/**
 * ![indoor camera NEW](https://images.ctfassets.net/v6awd0kabi65/6Vp05RfXG8EL6WdhOUc2MJ/538a5ed46858dfaf160145e2eaef19fb/indoor_camera_NEW.png?w=120&h=120&fit=pad)
 *
 * indoor camera NEW
 *
 *
 */
export const IMG_6Vp05RfXG8EL6WdhOUc2MJ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6Vp05RfXG8EL6WdhOUc2MJ/538a5ed46858dfaf160145e2eaef19fb/indoor_camera_NEW.png',
  description: ``,
  originalHeight: 112,
  originalWidth: 112
}

/**
 * ![Shop - Build My System (Nav)](https://images.ctfassets.net/v6awd0kabi65/1jVkWIvnHYadp3k2aMgQrj/872d1617f0e675becb0f410acbb33ee5/nav-BMS__1_.png?w=120&h=120&fit=pad)
 *
 * Shop - Build My System (Nav)
 *
 * White Base Station - Click To Build Your Own System
 */
export const IMG_1jVkWIvnHYadp3k2aMgQrj = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1jVkWIvnHYadp3k2aMgQrj/872d1617f0e675becb0f410acbb33ee5/nav-BMS__1_.png',
  description: `White Base Station - Click To Build Your Own System`,
  originalHeight: 184,
  originalWidth: 184
}

/**
 * ![Shop - Security Systems (Nav)](https://images.ctfassets.net/v6awd0kabi65/3zVZdVqWftdhdWUnA18EpG/c52392bd5f7be1bd8fab71e7da3648ee/nav-system__1_.png?w=120&h=120&fit=pad)
 *
 * Shop - Security Systems (Nav)
 *
 * White Base Station - Click For Shop Page
 */
export const IMG_3zVZdVqWftdhdWUnA18EpG = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3zVZdVqWftdhdWUnA18EpG/c52392bd5f7be1bd8fab71e7da3648ee/nav-system__1_.png',
  description: `White Base Station - Click For Shop Page`,
  originalHeight: 184,
  originalWidth: 184
}

/**
 * ![Ecomm UK Hero Image (Which) - Desktop](https://images.ctfassets.net/v6awd0kabi65/3GqSMtUIri31o1ZGHP0XB4/bef78c30e429b2bad6be7f125cce7ccf/J004854_-_SimpliSafe_-_Which_-_Web_-_4800x2400___1.jpg?w=120&h=120&fit=pad)
 *
 * Ecomm UK Hero Image (Which) - Desktop
 *
 *
 */
export const IMG_3GqSMtUIri31o1ZGHP0XB4 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3GqSMtUIri31o1ZGHP0XB4/bef78c30e429b2bad6be7f125cce7ccf/J004854_-_SimpliSafe_-_Which_-_Web_-_4800x2400___1.jpg',
  description: ``,
  originalHeight: 2400,
  originalWidth: 4800
}

/**
 * ![Ecomm UK Hero Image (Which) - Mobile](https://images.ctfassets.net/v6awd0kabi65/17WrkcBWdxlzz69ONRfj57/8355378ff007a4e38c65c3ce1723f9ac/Which__Mobile_Final.png?w=120&h=120&fit=pad)
 *
 * Ecomm UK Hero Image (Which) - Mobile
 *
 *
 */
export const IMG_17WrkcBWdxlzz69ONRfj57 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/17WrkcBWdxlzz69ONRfj57/8355378ff007a4e38c65c3ce1723f9ac/Which__Mobile_Final.png',
  description: ``,
  originalHeight: 848,
  originalWidth: 1536
}

/**
 * ![SimpliSafe FASTProtect TECHNOLOGY (Hero Banner)](https://images.ctfassets.net/v6awd0kabi65/3xHT0YII4xHF38K6JYzrn4/a4b66587025e592210d0a00d2b500b23/image_2.png?w=120&h=120&fit=pad)
 *
 * SimpliSafe FASTProtect TECHNOLOGY (Hero Banner)
 *
 * SimpliSafe FASTProtect TECHNOLOGY (Hero Banner)
 */
export const IMG_3xHT0YII4xHF38K6JYzrn4 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3xHT0YII4xHF38K6JYzrn4/a4b66587025e592210d0a00d2b500b23/image_2.png',
  description: `SimpliSafe FASTProtect TECHNOLOGY (Hero Banner)`,
  originalHeight: 186,
  originalWidth: 331
}

/**
 * ![24/7 monitoring by professional agents (Hero Banner - Desktop)](https://images.ctfassets.net/v6awd0kabi65/16nZv13lIqKBb7VdFPTecW/5a7ae19a0b1d38e30f3f0ac38eaaf5f6/230411_SimpliSafe_MonitoringCenter_B_Screen_091_Panorama_FIN_1.png?w=120&h=120&fit=pad)
 *
 * 24/7 monitoring by professional agents (Hero Banner - Desktop)
 *
 * 24/7 monitoring by professional agents (Hero Banner - Desktop)
 */
export const IMG_16nZv13lIqKBb7VdFPTecW = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/16nZv13lIqKBb7VdFPTecW/5a7ae19a0b1d38e30f3f0ac38eaaf5f6/230411_SimpliSafe_MonitoringCenter_B_Screen_091_Panorama_FIN_1.png',
  description: `24/7 monitoring by professional agents (Hero Banner - Desktop)`,
  originalHeight: 1437,
  originalWidth: 3144
}

/**
 * ![24/7 monitoring by professional agents (Hero Banner - Mobile)](https://images.ctfassets.net/v6awd0kabi65/73Q2c2hS13wE3GUAYay7CF/7576f955f43d5ee738c071670ac126cd/230411_SimpliSafe_MonitoringCenter_B_Screen_091_Panorama_FIN_2__1_.png?w=120&h=120&fit=pad)
 *
 * 24/7 monitoring by professional agents (Hero Banner - Mobile)
 *
 * 24/7 monitoring by professional agents (Hero Banner - Mobile)
 */
export const IMG_73Q2c2hS13wE3GUAYay7CF = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/73Q2c2hS13wE3GUAYay7CF/7576f955f43d5ee738c071670ac126cd/230411_SimpliSafe_MonitoringCenter_B_Screen_091_Panorama_FIN_2__1_.png',
  description: `24/7 monitoring by professional agents (Hero Banner - Mobile)`,
  originalHeight: 968,
  originalWidth: 1500
}

/**
 * ![VDP_app_screen3.png](https://images.ctfassets.net/v6awd0kabi65/pFSlLGFqTSePsWgYvd2QS/9111bc7987e44c2cca5743203b572fa6/VDP_app_screen3.png?w=120&h=120&fit=pad)
 *
 * VDP_app_screen3.png
 *
 * null
 */
export const IMG_pFSlLGFqTSePsWgYvd2QS = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/pFSlLGFqTSePsWgYvd2QS/9111bc7987e44c2cca5743203b572fa6/VDP_app_screen3.png',
  description: `null`,
  originalHeight: 627,
  originalWidth: 500
}

/**
 * ![Video Doorbell](https://images.ctfassets.net/v6awd0kabi65/71ArBte10MXuHfaazYyr6S/8e88227698c99c839a5f10716352a07c/doorbell.png?w=120&h=120&fit=pad)
 *
 * Video Doorbell
 *
 * null
 */
export const IMG_71ArBte10MXuHfaazYyr6S = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/71ArBte10MXuHfaazYyr6S/8e88227698c99c839a5f10716352a07c/doorbell.png',
  description: `null`,
  originalHeight: 1204,
  originalWidth: 1500
}

/**
 * ![Meet The System - Entry Sensor](https://images.ctfassets.net/v6awd0kabi65/63zGV5FNAXwSQOhgIwkrIg/4995534b0a4c413ae244dd2729424e38/meet_sensor-trans-entry.png?w=120&h=120&fit=pad)
 *
 * Meet The System - Entry Sensor
 *
 * Entry Sensor
 */
export const IMG_63zGV5FNAXwSQOhgIwkrIg = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/63zGV5FNAXwSQOhgIwkrIg/4995534b0a4c413ae244dd2729424e38/meet_sensor-trans-entry.png',
  description: `Entry Sensor`,
  originalHeight: 260,
  originalWidth: 260
}

/**
 * ![ODMON - Google play QR](https://images.ctfassets.net/v6awd0kabi65/5RLz3lqENtnzSo6p2LbtuD/bf63a0004229eb7ad4539dbe546f8c4b/Google.png?w=120&h=120&fit=pad)
 *
 * ODMON - Google play QR
 *
 * null
 */
export const IMG_5RLz3lqENtnzSo6p2LbtuD = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5RLz3lqENtnzSo6p2LbtuD/bf63a0004229eb7ad4539dbe546f8c4b/Google.png',
  description: `null`,
  originalHeight: 656,
  originalWidth: 656
}

/**
 * ![Beach phone (Travel Landing) - Tablet](https://images.ctfassets.net/v6awd0kabi65/6inqwvM0QCqKu0yqmpoex4/48bef6ed88a52960a3f375b6299963fb/image.png?w=120&h=120&fit=pad)
 *
 * Beach phone (Travel Landing) - Tablet
 *
 * phone with simplisafe app open on the screen while the user is on a beach
 */
export const IMG_6inqwvM0QCqKu0yqmpoex4 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6inqwvM0QCqKu0yqmpoex4/48bef6ed88a52960a3f375b6299963fb/image.png',
  description: `phone with simplisafe app open on the screen while the user is on a beach`,
  originalHeight: 1308,
  originalWidth: 2304
}

/**
 * ![Beach phone (Travel Landing) - Mobile](https://images.ctfassets.net/v6awd0kabi65/6B72MBO7E9MVJjEPX6oC5z/fccb39e256a7780d1d3611c1ae15696f/mobile-hero2__2_.png?w=120&h=120&fit=pad)
 *
 * Beach phone (Travel Landing) - Mobile
 *
 * phone with simplisafe app open on the screen while the user is on a beach
 */
export const IMG_6B72MBO7E9MVJjEPX6oC5z = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6B72MBO7E9MVJjEPX6oC5z/fccb39e256a7780d1d3611c1ae15696f/mobile-hero2__2_.png',
  description: `phone with simplisafe app open on the screen while the user is on a beach`,
  originalHeight: 1078,
  originalWidth: 874
}

/**
 * ![Beach phone (Travel Landing) - Desktop](https://images.ctfassets.net/v6awd0kabi65/5KlqrHxIxjHccjNGE50sxX/3ff565212563c990fdc77713317add3e/Hero_-_Near_and_Far.png?w=120&h=120&fit=pad)
 *
 * Beach phone (Travel Landing) - Desktop
 *
 * phone with simplisafe app open on the screen while the user is on a beach
 */
export const IMG_5KlqrHxIxjHccjNGE50sxX = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5KlqrHxIxjHccjNGE50sxX/3ff565212563c990fdc77713317add3e/Hero_-_Near_and_Far.png',
  description: `phone with simplisafe app open on the screen while the user is on a beach`,
  originalHeight: 1800,
  originalWidth: 3936
}

/**
 * ![AMA Logo](https://images.ctfassets.net/v6awd0kabi65/5iyRiKehyQa7XQKjRDRm8y/39cf3831ffbf4a4a529febb72c2d04d7/ama-logo-large.png?w=120&h=120&fit=pad)
 *
 * AMA Logo
 *
 *
 */
export const IMG_5iyRiKehyQa7XQKjRDRm8y = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5iyRiKehyQa7XQKjRDRm8y/39cf3831ffbf4a4a529febb72c2d04d7/ama-logo-large.png',
  description: ``,
  originalHeight: 104,
  originalWidth: 356
}

/**
 * ![Meet the system - satisfaction guaranteed](https://images.ctfassets.net/v6awd0kabi65/45xt9mf1wSNiiUF4F4TUDH/2868ee455b856d66a84b86610805f430/core-components_2x__1_.jpeg?w=120&h=120&fit=pad)
 *
 * Meet the system - satisfaction guaranteed
 *
 * Meet the system
 */
export const IMG_45xt9mf1wSNiiUF4F4TUDH = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/45xt9mf1wSNiiUF4F4TUDH/2868ee455b856d66a84b86610805f430/core-components_2x__1_.jpeg',
  description: `Meet the system`,
  originalHeight: 980,
  originalWidth: 1334
}

/**
 * ![Scout MTS desktop](https://images.ctfassets.net/v6awd0kabi65/5sK6UHEIZmXc1JHEDtbZRC/c1d66cc2d7ab33a7b22fc942cf44bb78/Scout_MTS_desktop.jpg?w=120&h=120&fit=pad)
 *
 * Scout MTS desktop
 *
 * Scout wireless camera
 */
export const IMG_5sK6UHEIZmXc1JHEDtbZRC = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5sK6UHEIZmXc1JHEDtbZRC/c1d66cc2d7ab33a7b22fc942cf44bb78/Scout_MTS_desktop.jpg',
  description: `Scout wireless camera`,
  originalHeight: 894,
  originalWidth: 1192
}

/**
 * ![Google Trusted Store](https://images.ctfassets.net/v6awd0kabi65/1JG1aZbOkTk2OXFDeGTNoN/954dd5ca7cf40b708b8f1415e81bd43c/Google_5_Stars.png?w=120&h=120&fit=pad)
 *
 * Google Trusted Store
 *
 *
 */
export const IMG_1JG1aZbOkTk2OXFDeGTNoN = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1JG1aZbOkTk2OXFDeGTNoN/954dd5ca7cf40b708b8f1415e81bd43c/Google_5_Stars.png',
  description: ``,
  originalHeight: 208,
  originalWidth: 376
}

/**
 * ![The Verge Logo](https://images.ctfassets.net/v6awd0kabi65/5PQA2ah7l3Vr9UUr6QEMki/449c89009f3575b204371dbf6bd8bd46/The_Verge_Logo.png?w=120&h=120&fit=pad)
 *
 * The Verge Logo
 *
 * The Verge's Review
 */
export const IMG_5PQA2ah7l3Vr9UUr6QEMki = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5PQA2ah7l3Vr9UUr6QEMki/449c89009f3575b204371dbf6bd8bd46/The_Verge_Logo.png',
  description: `The Verge's Review`,
  originalHeight: 50,
  originalWidth: 309
}

/**
 * ![The Verge Background](https://images.ctfassets.net/v6awd0kabi65/2vqFCCC3h3ATWyNer0QaTI/26751e7144a388ee7bb0fec7af0a02ca/The_Verge_Background.png?w=120&h=120&fit=pad)
 *
 * The Verge Background
 *
 *
 */
export const IMG_2vqFCCC3h3ATWyNer0QaTI = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2vqFCCC3h3ATWyNer0QaTI/26751e7144a388ee7bb0fec7af0a02ca/The_Verge_Background.png',
  description: ``,
  originalHeight: 1036,
  originalWidth: 1280
}

/**
 * ![Important Security Tips To Keep Home And Family Secure](https://images.ctfassets.net/v6awd0kabi65/aULqIKa686o9gOwaNRmPR/3a2819b50402717b84dc7f7e8898abe0/Screenshot_2024-02-14_at_09.04.20.png?w=120&h=120&fit=pad)
 *
 * Important Security Tips To Keep Home And Family Secure
 *
 *
 */
export const IMG_aULqIKa686o9gOwaNRmPR = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/aULqIKa686o9gOwaNRmPR/3a2819b50402717b84dc7f7e8898abe0/Screenshot_2024-02-14_at_09.04.20.png',
  description: ``,
  originalHeight: 1208,
  originalWidth: 1706
}

/**
 * ![Low Res-House Intruder 496 FIN WEBX](https://images.ctfassets.net/v6awd0kabi65/5deTcdRB1nQyTLACKCRr2p/7aaad3a35740d1ef3473dfd96f6b9fc5/Low_Res-House_Intruder_496_FIN_WEBX.jpg?w=120&h=120&fit=pad)
 *
 * Low Res-House Intruder 496 FIN WEBX
 *
 *
 */
export const IMG_5deTcdRB1nQyTLACKCRr2p = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5deTcdRB1nQyTLACKCRr2p/7aaad3a35740d1ef3473dfd96f6b9fc5/Low_Res-House_Intruder_496_FIN_WEBX.jpg',
  description: ``,
  originalHeight: 1667,
  originalWidth: 2500
}

/**
 * ![ODMON - Quiz - Purchase Shields](https://images.ctfassets.net/v6awd0kabi65/iMG6gtCgaD86BUosvn3fQ/33f4f16533245ef506e44536a1962ac2/kit.png?w=120&h=120&fit=pad)
 *
 * ODMON - Quiz - Purchase Shields
 *
 * null
 */
export const IMG_iMG6gtCgaD86BUosvn3fQ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/iMG6gtCgaD86BUosvn3fQ/33f4f16533245ef506e44536a1962ac2/kit.png',
  description: `null`,
  originalHeight: 392,
  originalWidth: 1005
}

/**
 * ![Live Guard Protection](https://images.ctfassets.net/v6awd0kabi65/71XlTVUhUseB3jMO23KrXk/499681dc25316e669e6a266c513654a2/Scout_q.jpg?w=120&h=120&fit=pad)
 *
 * Live Guard Protection
 *
 * Illustration Live Guard Protection
 */
export const IMG_71XlTVUhUseB3jMO23KrXk = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/71XlTVUhUseB3jMO23KrXk/499681dc25316e669e6a266c513654a2/Scout_q.jpg',
  description: `Illustration Live Guard Protection`,
  originalHeight: 1056,
  originalWidth: 1932
}

/**
 * ![Scout diagram v2 - shutter open 1@2x](https://images.ctfassets.net/v6awd0kabi65/4WSlUE6UGvbl1btiwZ5Exo/d1522f9176a12a1ba2ab3a0e52fe738d/Scout_diagram_v2_-_shutter_open_1_2x_-_jpg.jpg?w=120&h=120&fit=pad)
 *
 * Scout diagram v2 - shutter open 1@2x
 *
 *
 */
export const IMG_4WSlUE6UGvbl1btiwZ5Exo = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4WSlUE6UGvbl1btiwZ5Exo/d1522f9176a12a1ba2ab3a0e52fe738d/Scout_diagram_v2_-_shutter_open_1_2x_-_jpg.jpg',
  description: ``,
  originalHeight: 1378,
  originalWidth: 1194
}

/**
 * ![Scout diagram v2 - shutter closed 1@2x](https://images.ctfassets.net/v6awd0kabi65/5NZr5ROjgQWDZZJAtqAfp3/a360f0e99b4f9571affdabe70b33e71a/Scout_diagram_v2_-_shutter_closed_1_2x_-_jpg.jpg?w=120&h=120&fit=pad)
 *
 * Scout diagram v2 - shutter closed 1@2x
 *
 *
 */
export const IMG_5NZr5ROjgQWDZZJAtqAfp3 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5NZr5ROjgQWDZZJAtqAfp3/a360f0e99b4f9571affdabe70b33e71a/Scout_diagram_v2_-_shutter_closed_1_2x_-_jpg.jpg',
  description: ``,
  originalHeight: 1378,
  originalWidth: 1194
}

/**
 * ![Blue Cross x SimpliSafe](https://images.ctfassets.net/v6awd0kabi65/3tEIS83dIFSpj0PPzvtouQ/b4771756ec89775c3bd36b00d436d2af/SimpliSafe_x_Blue_Cross__2___1_.png?w=120&h=120&fit=pad)
 *
 * Blue Cross x SimpliSafe
 *
 *
 */
export const IMG_3tEIS83dIFSpj0PPzvtouQ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3tEIS83dIFSpj0PPzvtouQ/b4771756ec89775c3bd36b00d436d2af/SimpliSafe_x_Blue_Cross__2___1_.png',
  description: ``,
  originalHeight: 1080,
  originalWidth: 1080
}

/**
 * ![Wireless Indoor Camera Motion Detection of a Dog](https://images.ctfassets.net/v6awd0kabi65/3hkaYuCpwjhZvhox6j0Sie/ef66cc58654053d2ff55f1e168eff80c/DogImg_2x.png?w=120&h=120&fit=pad)
 *
 * Wireless Indoor Camera Motion Detection of a Dog
 *
 * Image of a dog being flagged as a pet during the advanced motion detection feature of the Wireless Indoor Camera.
 */
export const IMG_3hkaYuCpwjhZvhox6j0Sie = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3hkaYuCpwjhZvhox6j0Sie/ef66cc58654053d2ff55f1e168eff80c/DogImg_2x.png',
  description: `Image of a dog being flagged as a pet during the advanced motion detection feature of the Wireless Indoor Camera.`,
  originalHeight: 794,
  originalWidth: 1244
}

/**
 * ![wireless indoor camera shutter close animation](https://images.ctfassets.net/v6awd0kabi65/2Qaibco6BySmV0iLc7jHYK/133775e7e599bee13dcd2dfdae2e2774/shutter-close-0123.webp?w=120&h=120&fit=pad)
 *
 * wireless indoor camera shutter close animation
 *
 * Image of the Wireless Indoor Camera opening and closing its shutter.
 */
export const IMG_2Qaibco6BySmV0iLc7jHYK = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2Qaibco6BySmV0iLc7jHYK/133775e7e599bee13dcd2dfdae2e2774/shutter-close-0123.webp',
  description: `Image of the Wireless Indoor Camera opening and closing its shutter.`,
  originalHeight: 730,
  originalWidth: 1300
}

/**
 * ![Whole home security at an unbeatable price](https://images.ctfassets.net/v6awd0kabi65/muWXpRLZYLkTe9ILZurKb/9106cfd737cf26aa5a6c2d817b7f6294/Frame_1028__1_.png?w=120&h=120&fit=pad)
 *
 * Whole home security at an unbeatable price
 *
 * Whole home security at an unbeatable price
 */
export const IMG_muWXpRLZYLkTe9ILZurKb = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/muWXpRLZYLkTe9ILZurKb/9106cfd737cf26aa5a6c2d817b7f6294/Frame_1028__1_.png',
  description: `Whole home security at an unbeatable price`,
  originalHeight: 1384,
  originalWidth: 1810
}

/**
 * ![Simplisafe Base (Cropped)](https://images.ctfassets.net/v6awd0kabi65/1Jw5FLrdD2JSFLqHRtTtlL/3de7c07204cfce67018dfa5e45dd05c5/partnerHeroMobile.jpg?w=120&h=120&fit=pad)
 *
 * Simplisafe Base (Cropped)
 *
 * SimpliSafe Base Station
 */
export const IMG_1Jw5FLrdD2JSFLqHRtTtlL = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1Jw5FLrdD2JSFLqHRtTtlL/3de7c07204cfce67018dfa5e45dd05c5/partnerHeroMobile.jpg',
  description: `SimpliSafe Base Station`,
  originalHeight: 764,
  originalWidth: 1028
}

/**
 * ![Standard Partner Hero Image](https://images.ctfassets.net/v6awd0kabi65/3g5nZj9KLagPKMlTfXZmPY/b4cf69d780814bc0c14baacb23729235/ss_presskit3.jpg?w=120&h=120&fit=pad)
 *
 * Standard Partner Hero Image
 *
 * SimpliSafe Base Station
 */
export const IMG_3g5nZj9KLagPKMlTfXZmPY = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3g5nZj9KLagPKMlTfXZmPY/b4cf69d780814bc0c14baacb23729235/ss_presskit3.jpg',
  description: `SimpliSafe Base Station`,
  originalHeight: 3879,
  originalWidth: 3906
}

/**
 * ![AAA Member Benefit](https://images.ctfassets.net/v6awd0kabi65/BkSTIqTdDL12F5uKfpv7U/0fb8e97b0e5a37ba327c64ab198975d5/aaa-member-logo.webp?w=120&h=120&fit=pad)
 *
 * AAA Member Benefit
 *
 * AAA Discount Rewards
 */
export const IMG_BkSTIqTdDL12F5uKfpv7U = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/BkSTIqTdDL12F5uKfpv7U/0fb8e97b0e5a37ba327c64ab198975d5/aaa-member-logo.webp',
  description: `AAA Discount Rewards`,
  originalHeight: 98,
  originalWidth: 319
}

/**
 * ![AMAC](https://images.ctfassets.net/v6awd0kabi65/6y0uWHzNDKmw9e1GxGIafn/c8dfa23bd0a1e00efb8e7348c5f636de/amac_member_logo.webp?w=120&h=120&fit=pad)
 *
 * AMAC
 *
 * AMAC Logo
 */
export const IMG_6y0uWHzNDKmw9e1GxGIafn = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6y0uWHzNDKmw9e1GxGIafn/c8dfa23bd0a1e00efb8e7348c5f636de/amac_member_logo.webp',
  description: `AMAC Logo`,
  originalHeight: 92,
  originalWidth: 320
}

/**
 * ![August](https://images.ctfassets.net/v6awd0kabi65/5U8EuI2i297xoNRnHg5NhC/ab31840bdc9097c270e68d8a02ddcac6/august-logo-dt.webp?w=120&h=120&fit=pad)
 *
 * August
 *
 * August Logo
 */
export const IMG_5U8EuI2i297xoNRnHg5NhC = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5U8EuI2i297xoNRnHg5NhC/ab31840bdc9097c270e68d8a02ddcac6/august-logo-dt.webp',
  description: `August Logo`,
  originalHeight: 51,
  originalWidth: 160
}

/**
 * ![LifeMart](https://images.ctfassets.net/v6awd0kabi65/6YK1l6nmbZz56PHTTR5Nw0/feb3d9b280c6bc91eaa519351fb5947e/lifemart-member-logo.webp?w=120&h=120&fit=pad)
 *
 * LifeMart
 *
 * LifeMart Logo
 */
export const IMG_6YK1l6nmbZz56PHTTR5Nw0 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6YK1l6nmbZz56PHTTR5Nw0/feb3d9b280c6bc91eaa519351fb5947e/lifemart-member-logo.webp',
  description: `LifeMart Logo`,
  originalHeight: 68,
  originalWidth: 160
}

/**
 * ![Paddio](https://images.ctfassets.net/v6awd0kabi65/EX2tCtZIkAdFgi3pPZ5vT/20a121bfae12c1f84219e64ff777a9ed/Paddio-Logo.webp?w=120&h=120&fit=pad)
 *
 * Paddio
 *
 * Paddio Logo
 */
export const IMG_EX2tCtZIkAdFgi3pPZ5vT = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/EX2tCtZIkAdFgi3pPZ5vT/20a121bfae12c1f84219e64ff777a9ed/Paddio-Logo.webp',
  description: `Paddio Logo`,
  originalHeight: 110,
  originalWidth: 318
}

/**
 * ![United](https://images.ctfassets.net/v6awd0kabi65/6OuGdZBHmC3stiMVMDo0vF/9807a1c74f27430ef15b170fd19fbb8c/united.webp?w=120&h=120&fit=pad)
 *
 * United
 *
 * United Logo
 */
export const IMG_6OuGdZBHmC3stiMVMDo0vF = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6OuGdZBHmC3stiMVMDo0vF/9807a1c74f27430ef15b170fd19fbb8c/united.webp',
  description: `United Logo`,
  originalHeight: 52,
  originalWidth: 159
}

/**
 * ![App Widget - Settings](https://images.ctfassets.net/v6awd0kabi65/2Nh4OZbMemSgyittpkce8D/feba300901f521faeded6f8ba6bb475e/settings.png?w=120&h=120&fit=pad)
 *
 * App Widget - Settings
 *
 *
 */
export const IMG_2Nh4OZbMemSgyittpkce8D = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2Nh4OZbMemSgyittpkce8D/feba300901f521faeded6f8ba6bb475e/settings.png',
  description: ``,
  originalHeight: 1254,
  originalWidth: 1000
}

/**
 * ![App Widget - Motion ](https://images.ctfassets.net/v6awd0kabi65/6hkwZU8jQDYxOCH6OZHa2f/441f3b42886287ca0b8736828f3177ff/motion.png?w=120&h=120&fit=pad)
 *
 * App Widget - Motion
 *
 *
 */
export const IMG_6hkwZU8jQDYxOCH6OZHa2f = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6hkwZU8jQDYxOCH6OZHa2f/441f3b42886287ca0b8736828f3177ff/motion.png',
  description: ``,
  originalHeight: 1254,
  originalWidth: 1000
}

/**
 * ![App Widget - Alerts](https://images.ctfassets.net/v6awd0kabi65/4PNAPJnSzB2mV8JAvGFQQW/a378f55e874e899be19031018208d837/alerts.png?w=120&h=120&fit=pad)
 *
 * App Widget - Alerts
 *
 *
 */
export const IMG_4PNAPJnSzB2mV8JAvGFQQW = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4PNAPJnSzB2mV8JAvGFQQW/a378f55e874e899be19031018208d837/alerts.png',
  description: ``,
  originalHeight: 1254,
  originalWidth: 1000
}

/**
 * ![App Widget - Live Feed](https://images.ctfassets.net/v6awd0kabi65/2xsgiEFsmEeRLomWyaUT7I/f16d54d41db97367e7562c413ed513a9/live_feed.png?w=120&h=120&fit=pad)
 *
 * App Widget - Live Feed
 *
 *
 */
export const IMG_2xsgiEFsmEeRLomWyaUT7I = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2xsgiEFsmEeRLomWyaUT7I/f16d54d41db97367e7562c413ed513a9/live_feed.png',
  description: ``,
  originalHeight: 627,
  originalWidth: 500
}

/**
 * ![Header | Get An Expert Recommendation](https://images.ctfassets.net/v6awd0kabi65/27PoVXtX9nH9n7IBEBE0Sr/062562d1a62032b9524cb28f36b2cbaa/230411_SimpliSafe_MonitoringCenter_CSA_077_FIN_1.png?w=120&h=120&fit=pad)
 *
 * Header | Get An Expert Recommendation
 *
 * Get An Expert Recommendation
 */
export const IMG_27PoVXtX9nH9n7IBEBE0Sr = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/27PoVXtX9nH9n7IBEBE0Sr/062562d1a62032b9524cb28f36b2cbaa/230411_SimpliSafe_MonitoringCenter_CSA_077_FIN_1.png',
  description: `Get An Expert Recommendation`,
  originalHeight: 363,
  originalWidth: 643
}

/**
 * ![Homeowner Holding Phone](https://images.ctfassets.net/v6awd0kabi65/2U4r5fAxm72ZgFLukJ2wI2/71ef4f230a0af0f535020f864956b546/Homeowner_Holding_Phone_1443_F_8bit.jpg?w=120&h=120&fit=pad)
 *
 * Homeowner Holding Phone
 *
 *
 */
export const IMG_2U4r5fAxm72ZgFLukJ2wI2 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2U4r5fAxm72ZgFLukJ2wI2/71ef4f230a0af0f535020f864956b546/Homeowner_Holding_Phone_1443_F_8bit.jpg',
  description: ``,
  originalHeight: 683,
  originalWidth: 1024
}

/**
 * ![How to fit a wireless burglar alarm system](https://images.ctfassets.net/v6awd0kabi65/3mpG8Vc6QfSuZahdaZnsvD/860f85cec64913e23d0f715edb0bd268/Eve_Bell_Box_3317_UK__2___1_.png?w=120&h=120&fit=pad)
 *
 * How to fit a wireless burglar alarm system
 *
 *
 */
export const IMG_3mpG8Vc6QfSuZahdaZnsvD = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3mpG8Vc6QfSuZahdaZnsvD/860f85cec64913e23d0f715edb0bd268/Eve_Bell_Box_3317_UK__2___1_.png',
  description: ``,
  originalHeight: 812,
  originalWidth: 1217
}

/**
 * ![More protection. Extra peace of mind](https://images.ctfassets.net/v6awd0kabi65/4zCVXQPqQrxHa2bvac2hId/43b26251fc5603032573e92f792983b4/image__6_.png?w=120&h=120&fit=pad)
 *
 * More protection. Extra peace of mind
 *
 *
 */
export const IMG_4zCVXQPqQrxHa2bvac2hId = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4zCVXQPqQrxHa2bvac2hId/43b26251fc5603032573e92f792983b4/image__6_.png',
  description: ``,
  originalHeight: 450,
  originalWidth: 800
}

/**
 * ![Office Protection Kit](https://images.ctfassets.net/v6awd0kabi65/2MVqopRRMHK1xBPO32F50T/e6da95a0f2a859a395c3d8b0c3295812/OfficeProtectionKit_Balto.jpg?w=120&h=120&fit=pad)
 *
 * Office Protection Kit
 *
 * SimpliSafe Office Protection Kit
 */
export const IMG_2MVqopRRMHK1xBPO32F50T = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2MVqopRRMHK1xBPO32F50T/e6da95a0f2a859a395c3d8b0c3295812/OfficeProtectionKit_Balto.jpg',
  description: `SimpliSafe Office Protection Kit`,
  originalHeight: 2189,
  originalWidth: 2736
}

/**
 * ![Store Protection Kit](https://images.ctfassets.net/v6awd0kabi65/2rmtGXSXdDW0ry6cm75zyB/0b3db7ac05e2592f02f5e415e0a5cff6/Storefront-System_Balto.jpg?w=120&h=120&fit=pad)
 *
 * Store Protection Kit
 *
 * SimpliSafe Store Protection Kit
 */
export const IMG_2rmtGXSXdDW0ry6cm75zyB = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2rmtGXSXdDW0ry6cm75zyB/0b3db7ac05e2592f02f5e415e0a5cff6/Storefront-System_Balto.jpg',
  description: `SimpliSafe Store Protection Kit`,
  originalHeight: 1505,
  originalWidth: 1706
}

/**
 * ![Refurbished System (14 pieces)](https://images.ctfassets.net/v6awd0kabi65/3af46IEuJX9ieTZxKTe9C0/30929ab9b00d2fe0a2f63b75d81ff28a/Refurb-Pkg3-motion.jpg?w=120&h=120&fit=pad)
 *
 * Refurbished System (14 pieces)
 *
 * SimpliSafe Refurbished System 14 pieces
 */
export const IMG_3af46IEuJX9ieTZxKTe9C0 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3af46IEuJX9ieTZxKTe9C0/30929ab9b00d2fe0a2f63b75d81ff28a/Refurb-Pkg3-motion.jpg',
  description: `SimpliSafe Refurbished System 14 pieces`,
  originalHeight: 3500,
  originalWidth: 3500
}

/**
 * ![Refurbished System (13 pieces)](https://images.ctfassets.net/v6awd0kabi65/4GJYOGhOXYNqCYq1Nrazfn/6daf758c590ec33b7c4c00b7a2164e08/Refurb-Pkg2-motion.jpg?w=120&h=120&fit=pad)
 *
 * Refurbished System (13 pieces)
 *
 * SimpliSafe Refurbished System 13 pieces
 */
export const IMG_4GJYOGhOXYNqCYq1Nrazfn = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4GJYOGhOXYNqCYq1Nrazfn/6daf758c590ec33b7c4c00b7a2164e08/Refurb-Pkg2-motion.jpg',
  description: `SimpliSafe Refurbished System 13 pieces`,
  originalHeight: 3500,
  originalWidth: 3500
}

/**
 * ![Refurbished System (6 pieces)](https://images.ctfassets.net/v6awd0kabi65/4nOtDNVZkUDRQMbwyDFrcs/4b3a5c17d9945ab9ada6e6f6fb8348af/Refurb-Pkg1-motion.jpg?w=120&h=120&fit=pad)
 *
 * Refurbished System (6 pieces)
 *
 * SimpliSafe Refurbished System 6 pieces
 */
export const IMG_4nOtDNVZkUDRQMbwyDFrcs = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4nOtDNVZkUDRQMbwyDFrcs/4b3a5c17d9945ab9ada6e6f6fb8348af/Refurb-Pkg1-motion.jpg',
  description: `SimpliSafe Refurbished System 6 pieces`,
  originalHeight: 3500,
  originalWidth: 3500
}

/**
 * ![Restaurant Protection Kit](https://images.ctfassets.net/v6awd0kabi65/7wCFXTVndfEy2y6zMijrwg/5a88876ab395ebce4fcf23147731f2db/RestaurantProtectionKit_Balto.jpg?w=120&h=120&fit=pad)
 *
 * Restaurant Protection Kit
 *
 * SimpliSafe Restaurant Protection Kit
 */
export const IMG_7wCFXTVndfEy2y6zMijrwg = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7wCFXTVndfEy2y6zMijrwg/5a88876ab395ebce4fcf23147731f2db/RestaurantProtectionKit_Balto.jpg',
  description: `SimpliSafe Restaurant Protection Kit`,
  originalHeight: 1338,
  originalWidth: 1462
}

/**
 * ![Business Essentials System](https://images.ctfassets.net/v6awd0kabi65/2Pmr6oKhtI4gF7ayoNlvTT/fe3338904ae827d6ed7d50194406f389/ESSENTIALS-Balto.jpg?w=120&h=120&fit=pad)
 *
 * Business Essentials System
 *
 * SimpliSafe Business Essentials System
 */
export const IMG_2Pmr6oKhtI4gF7ayoNlvTT = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2Pmr6oKhtI4gF7ayoNlvTT/fe3338904ae827d6ed7d50194406f389/ESSENTIALS-Balto.jpg',
  description: `SimpliSafe Business Essentials System`,
  originalHeight: 1800,
  originalWidth: 2500
}

/**
 * ![How to keep pets safe in cold weather](https://images.ctfassets.net/v6awd0kabi65/6MOiXhwp21St7Vb4E8UCaB/4eddb4a59afd14c7bed620d970818d79/pexels-andrew-kota-3791641.jpg?w=120&h=120&fit=pad)
 *
 * How to keep pets safe in cold weather
 *
 *
 */
export const IMG_6MOiXhwp21St7Vb4E8UCaB = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6MOiXhwp21St7Vb4E8UCaB/4eddb4a59afd14c7bed620d970818d79/pexels-andrew-kota-3791641.jpg',
  description: ``,
  originalHeight: 1707,
  originalWidth: 2560
}

/**
 * ![18 winter home safety tips](https://images.ctfassets.net/v6awd0kabi65/3HwCrt64SBW2FL34LTHNA4/0458c304e84e38338c5aae5ea1ccd03c/pexels-andrew-james-millward-12036309.jpg?w=120&h=120&fit=pad)
 *
 * 18 winter home safety tips
 *
 *
 */
export const IMG_3HwCrt64SBW2FL34LTHNA4 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3HwCrt64SBW2FL34LTHNA4/0458c304e84e38338c5aae5ea1ccd03c/pexels-andrew-james-millward-12036309.jpg',
  description: ``,
  originalHeight: 3000,
  originalWidth: 4000
}

/**
 * ![How paper shredding & recycling helps security](https://images.ctfassets.net/v6awd0kabi65/7H2bhCRAZDYlZWaMPYAYFP/d2dda97b070ed889e5e95566fba06439/Secure-Shredding-Services.jpeg?w=120&h=120&fit=pad)
 *
 * How paper shredding & recycling helps security
 *
 *
 */
export const IMG_7H2bhCRAZDYlZWaMPYAYFP = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7H2bhCRAZDYlZWaMPYAYFP/d2dda97b070ed889e5e95566fba06439/Secure-Shredding-Services.jpeg',
  description: ``,
  originalHeight: 1280,
  originalWidth: 1920
}

/**
 * ![Base Station - Features](https://images.ctfassets.net/v6awd0kabi65/5xI4O4Jsn2LacGhtYg9j8O/c957943df4a901e9d9afd3df0baf1314/desktop_base-sq_2x.jpg?w=120&h=120&fit=pad)
 *
 * Base Station - Features
 *
 * A base station on a table
 */
export const IMG_5xI4O4Jsn2LacGhtYg9j8O = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5xI4O4Jsn2LacGhtYg9j8O/c957943df4a901e9d9afd3df0baf1314/desktop_base-sq_2x.jpg',
  description: `A base station on a table`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![PerkSpot Logo](https://images.ctfassets.net/v6awd0kabi65/2sAyviSs0I61Bo1IJna2cJ/766530609252459bd46b1dbf8395f37e/perkspot-logo-new.png?w=120&h=120&fit=pad)
 *
 * PerkSpot Logo
 *
 * PerkSpot
 */
export const IMG_2sAyviSs0I61Bo1IJna2cJ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2sAyviSs0I61Bo1IJna2cJ/766530609252459bd46b1dbf8395f37e/perkspot-logo-new.png',
  description: `PerkSpot`,
  originalHeight: 147,
  originalWidth: 271
}

/**
 * ![Bell Box Replacement Kit](https://images.ctfassets.net/v6awd0kabi65/3jaUpSsIsLk9erXsKbMv7z/b003f725f429942e8bad9f074cee46db/Eve_Mount__1_.jpeg?w=120&h=120&fit=pad)
 *
 * Bell Box Replacement Kit
 *
 * Bell Box Replacement Kit
 */
export const IMG_3jaUpSsIsLk9erXsKbMv7z = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3jaUpSsIsLk9erXsKbMv7z/b003f725f429942e8bad9f074cee46db/Eve_Mount__1_.jpeg',
  description: `Bell Box Replacement Kit`,
  originalHeight: 2364,
  originalWidth: 2570
}

/**
 * ![Back to School Home Safety Tips](https://images.ctfassets.net/v6awd0kabi65/2Gsg4evdlun5SgW1YgFHJV/6b628f25237964c48627476ca9b59fb9/note-thanun-CYlPykF-qAM-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * Back to School Home Safety Tips
 *
 *
 */
export const IMG_2Gsg4evdlun5SgW1YgFHJV = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2Gsg4evdlun5SgW1YgFHJV/6b628f25237964c48627476ca9b59fb9/note-thanun-CYlPykF-qAM-unsplash.jpg',
  description: ``,
  originalHeight: 3264,
  originalWidth: 3643
}

/**
 * ![Shop - Indoor Camera](https://images.ctfassets.net/v6awd0kabi65/4HkQOAyvIe1OOuuYjDCcJj/2cb33b9b088f5081b8db9864e7cd3572/Scout_-_Home_Shop.png?w=120&h=120&fit=pad)
 *
 * Shop - Indoor Camera
 *
 *
 */
export const IMG_4HkQOAyvIe1OOuuYjDCcJj = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4HkQOAyvIe1OOuuYjDCcJj/2cb33b9b088f5081b8db9864e7cd3572/Scout_-_Home_Shop.png',
  description: ``,
  originalHeight: 390,
  originalWidth: 452
}

/**
 * ![Benefits of SimpliSafe Scout](https://images.ctfassets.net/v6awd0kabi65/7e1hT6DJeh1F38xbRkYxY4/fce4ee2a8084adf29bf8df357841465c/benefits_of_simplisafe_scout.png?w=120&h=120&fit=pad)
 *
 * Benefits of SimpliSafe Scout
 *
 * Benefits of SimpliSafe Scout
 */
export const IMG_7e1hT6DJeh1F38xbRkYxY4 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7e1hT6DJeh1F38xbRkYxY4/fce4ee2a8084adf29bf8df357841465c/benefits_of_simplisafe_scout.png',
  description: `Benefits of SimpliSafe Scout`,
  originalHeight: 1221,
  originalWidth: 1833
}

/**
 * ![SmokeCO Sensor BMS V2](https://images.ctfassets.net/v6awd0kabi65/5eracumYMSRCoaTGL2VkTb/0c086cc656214c30038dc471a6c56820/SmokeCO-img.jpg?w=120&h=120&fit=pad)
 *
 * SmokeCO Sensor BMS V2
 *
 * SmokeCO Sensor
 */
export const IMG_5eracumYMSRCoaTGL2VkTb = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5eracumYMSRCoaTGL2VkTb/0c086cc656214c30038dc471a6c56820/SmokeCO-img.jpg',
  description: `SmokeCO Sensor`,
  originalHeight: 320,
  originalWidth: 320
}

/**
 * ![Keypad BMS V2](https://images.ctfassets.net/v6awd0kabi65/4YAYVQA8xIoCOSepLAXQxi/5b8bfe62bf3954f9e4f8fa1be45e434e/KeypadRequired-img.jpg?w=120&h=120&fit=pad)
 *
 * Keypad BMS V2
 *
 *
 */
export const IMG_4YAYVQA8xIoCOSepLAXQxi = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4YAYVQA8xIoCOSepLAXQxi/5b8bfe62bf3954f9e4f8fa1be45e434e/KeypadRequired-img.jpg',
  description: ``,
  originalHeight: 646,
  originalWidth: 300
}

/**
 * ![Prosetup BMS V2](https://images.ctfassets.net/v6awd0kabi65/732DcsGfaBanz15C7J20KP/087d9c6230e2d7c1ff218cf649c4af9d/ProInstall-img.jpg?w=120&h=120&fit=pad)
 *
 * Prosetup BMS V2
 *
 * Man installing Wireless Outdoor Camera
 */
export const IMG_732DcsGfaBanz15C7J20KP = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/732DcsGfaBanz15C7J20KP/087d9c6230e2d7c1ff218cf649c4af9d/ProInstall-img.jpg',
  description: `Man installing Wireless Outdoor Camera`,
  originalHeight: 640,
  originalWidth: 640
}

/**
 * ![Yardsign BMS V2](https://images.ctfassets.net/v6awd0kabi65/1FLs15NJnCZmkm7wrj7zB0/3714d5c50833d4290102dc1646a65b08/Yardsign-img.jpg?w=120&h=120&fit=pad)
 *
 * Yardsign BMS V2
 *
 * Yardsign
 */
export const IMG_1FLs15NJnCZmkm7wrj7zB0 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1FLs15NJnCZmkm7wrj7zB0/3714d5c50833d4290102dc1646a65b08/Yardsign-img.jpg',
  description: `Yardsign`,
  originalHeight: 320,
  originalWidth: 320
}

/**
 * ![Keypad BMS V2](https://images.ctfassets.net/v6awd0kabi65/uzxqbxRdy6oyaWEv0cd4F/cc1fe6f6492af5b734a4023f348b31d5/Keypad-img.jpg?w=120&h=120&fit=pad)
 *
 * Keypad BMS V2
 *
 * Keypad
 */
export const IMG_uzxqbxRdy6oyaWEv0cd4F = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/uzxqbxRdy6oyaWEv0cd4F/cc1fe6f6492af5b734a4023f348b31d5/Keypad-img.jpg',
  description: `Keypad`,
  originalHeight: 320,
  originalWidth: 320
}

/**
 * ![Siren BMS V2](https://images.ctfassets.net/v6awd0kabi65/3XyXdSLPEhfpnv2qRYt6N2/8f9c91188bd16a04df73096ffb0859e1/Siren-img.jpg?w=120&h=120&fit=pad)
 *
 * Siren BMS V2
 *
 * Extra Loud Siren
 */
export const IMG_3XyXdSLPEhfpnv2qRYt6N2 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3XyXdSLPEhfpnv2qRYt6N2/8f9c91188bd16a04df73096ffb0859e1/Siren-img.jpg',
  description: `Extra Loud Siren`,
  originalHeight: 320,
  originalWidth: 320
}

/**
 * ![Doorbell Camera BMS V2](https://images.ctfassets.net/v6awd0kabi65/6j4mRlL3mxvjAfUX28SQYX/52117ea7edc74e7c5dddbc96319be14d/Doorbell-img.jpg?w=120&h=120&fit=pad)
 *
 * Doorbell Camera BMS V2
 *
 * Doorbell Camera
 */
export const IMG_6j4mRlL3mxvjAfUX28SQYX = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6j4mRlL3mxvjAfUX28SQYX/52117ea7edc74e7c5dddbc96319be14d/Doorbell-img.jpg',
  description: `Doorbell Camera`,
  originalHeight: 320,
  originalWidth: 320
}

/**
 * ![Keyfob BMS V2 ](https://images.ctfassets.net/v6awd0kabi65/YElryZ1QMm5IzLXx0X90z/e656dce566b3bab97f6e81655244d5c4/Keyfob-img.jpg?w=120&h=120&fit=pad)
 *
 * Keyfob BMS V2
 *
 * Keyfob
 */
export const IMG_YElryZ1QMm5IzLXx0X90z = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/YElryZ1QMm5IzLXx0X90z/e656dce566b3bab97f6e81655244d5c4/Keyfob-img.jpg',
  description: `Keyfob`,
  originalHeight: 320,
  originalWidth: 320
}

/**
 * ![Panic Sensor BMS V2](https://images.ctfassets.net/v6awd0kabi65/6QKG5VTEv95oeXIJzAO89z/18e3338e2579cc641ebafd17cc2fe6f4/Panic-img.jpg?w=120&h=120&fit=pad)
 *
 * Panic Sensor BMS V2
 *
 * Panic Sensor
 */
export const IMG_6QKG5VTEv95oeXIJzAO89z = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6QKG5VTEv95oeXIJzAO89z/18e3338e2579cc641ebafd17cc2fe6f4/Panic-img.jpg',
  description: `Panic Sensor`,
  originalHeight: 320,
  originalWidth: 320
}

/**
 * ![Temp Sensor BMS V2](https://images.ctfassets.net/v6awd0kabi65/2hXQ9fOOHQk7Zp1ly7mAru/8671dac6ec3a26fd7dc577f12e9830ac/Temp-img.jpg?w=120&h=120&fit=pad)
 *
 * Temp Sensor BMS V2
 *
 * Temp Sensor
 */
export const IMG_2hXQ9fOOHQk7Zp1ly7mAru = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2hXQ9fOOHQk7Zp1ly7mAru/8671dac6ec3a26fd7dc577f12e9830ac/Temp-img.jpg',
  description: `Temp Sensor`,
  originalHeight: 320,
  originalWidth: 320
}

/**
 * ![Smoke Sensor BMS V2](https://images.ctfassets.net/v6awd0kabi65/21cPF8jgdRG82v4fQN7Lsc/a9389467b6301e29f8488ac8571cc28b/Smoke-img.jpg?w=120&h=120&fit=pad)
 *
 * Smoke Sensor BMS V2
 *
 * Smoke Sensor
 */
export const IMG_21cPF8jgdRG82v4fQN7Lsc = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/21cPF8jgdRG82v4fQN7Lsc/a9389467b6301e29f8488ac8571cc28b/Smoke-img.jpg',
  description: `Smoke Sensor`,
  originalHeight: 320,
  originalWidth: 320
}

/**
 * ![Water Sensor BMS V2](https://images.ctfassets.net/v6awd0kabi65/5eFdvqMg8Ut7Oo7FSZxE9V/28f66210e75ada95df50cc758ab79f5a/Water-img.jpg?w=120&h=120&fit=pad)
 *
 * Water Sensor BMS V2
 *
 * Water Sensor
 */
export const IMG_5eFdvqMg8Ut7Oo7FSZxE9V = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5eFdvqMg8Ut7Oo7FSZxE9V/28f66210e75ada95df50cc758ab79f5a/Water-img.jpg',
  description: `Water Sensor`,
  originalHeight: 320,
  originalWidth: 320
}

/**
 * ![Outdoorcam Sensor BMS V2](https://images.ctfassets.net/v6awd0kabi65/4w9w5X40qMuC8MeanL6WVe/db04452ead94d604db76eb301fbe63eb/Outdoorcam-img.jpg?w=120&h=120&fit=pad)
 *
 * Outdoorcam Sensor BMS V2
 *
 * Outdoorcam Sensor
 */
export const IMG_4w9w5X40qMuC8MeanL6WVe = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4w9w5X40qMuC8MeanL6WVe/db04452ead94d604db76eb301fbe63eb/Outdoorcam-img.jpg',
  description: `Outdoorcam Sensor`,
  originalHeight: 320,
  originalWidth: 320
}

/**
 * ![Simplicam Sensor BMS V2](https://images.ctfassets.net/v6awd0kabi65/BgkMrCGrFLAO546cZv8MC/63493a9b2ca99eefec010127a7905ee4/Simplicam-img.jpg?w=120&h=120&fit=pad)
 *
 * Simplicam Sensor BMS V2
 *
 * Simplicam Sensor
 */
export const IMG_BgkMrCGrFLAO546cZv8MC = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/BgkMrCGrFLAO546cZv8MC/63493a9b2ca99eefec010127a7905ee4/Simplicam-img.jpg',
  description: `Simplicam Sensor`,
  originalHeight: 320,
  originalWidth: 320
}

/**
 * ![Smart Alarm Indoor Camera](https://images.ctfassets.net/v6awd0kabi65/1theLVLFCEvOBlpNoHcCIk/a2bbca8234d5ca3f04853279072bc3c4/Scoutcam-img.jpg?w=120&h=120&fit=pad)
 *
 * Smart Alarm Indoor Camera
 *
 * Smart Alarm Indoor Camera
 */
export const IMG_1theLVLFCEvOBlpNoHcCIk = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1theLVLFCEvOBlpNoHcCIk/a2bbca8234d5ca3f04853279072bc3c4/Scoutcam-img.jpg',
  description: `Smart Alarm Indoor Camera`,
  originalHeight: 320,
  originalWidth: 320
}

/**
 * ![Glassbreak Sensor (BMS V2)](https://images.ctfassets.net/v6awd0kabi65/5DCkrLqPo9pZiukvf10V5W/2e344da0db9a1e89d0ccf71f38095dff/Glassbreak-img.jpg?w=120&h=120&fit=pad)
 *
 * Glassbreak Sensor (BMS V2)
 *
 * Glassbreak Sensor
 */
export const IMG_5DCkrLqPo9pZiukvf10V5W = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5DCkrLqPo9pZiukvf10V5W/2e344da0db9a1e89d0ccf71f38095dff/Glassbreak-img.jpg',
  description: `Glassbreak Sensor`,
  originalHeight: 320,
  originalWidth: 320
}

/**
 * ![Motion Sensor BMS V2](https://images.ctfassets.net/v6awd0kabi65/5wIntQd1brrQCNxZYdeOWP/f5484ee0ea9f4d235a97b36a1bb48ed1/Motion_Sensor.png?w=120&h=120&fit=pad)
 *
 * Motion Sensor BMS V2
 *
 * Motion Sensor
 */
export const IMG_5wIntQd1brrQCNxZYdeOWP = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5wIntQd1brrQCNxZYdeOWP/f5484ee0ea9f4d235a97b36a1bb48ed1/Motion_Sensor.png',
  description: `Motion Sensor`,
  originalHeight: 320,
  originalWidth: 320
}

/**
 * ![Entry Sensor BMS V2](https://images.ctfassets.net/v6awd0kabi65/1zXc4tQQ6XbZJkTEq27RMP/bf5bae581a5abc342c6754c60c64fc0f/Entry_Sensor.png?w=120&h=120&fit=pad)
 *
 * Entry Sensor BMS V2
 *
 * Entry Sensor
 */
export const IMG_1zXc4tQQ6XbZJkTEq27RMP = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1zXc4tQQ6XbZJkTEq27RMP/bf5bae581a5abc342c6754c60c64fc0f/Entry_Sensor.png',
  description: `Entry Sensor`,
  originalHeight: 320,
  originalWidth: 320
}

/**
 * ![BF/CM Hero](https://images.ctfassets.net/v6awd0kabi65/rlYnJ6ZazXsjN2nrSLCIX/7dda6100eccb37084d3aee10798c8717/D-hero2_2x.jpg?w=120&h=120&fit=pad)
 *
 * BF/CM Hero
 *
 *
 */
export const IMG_rlYnJ6ZazXsjN2nrSLCIX = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/rlYnJ6ZazXsjN2nrSLCIX/7dda6100eccb37084d3aee10798c8717/D-hero2_2x.jpg',
  description: ``,
  originalHeight: 2400,
  originalWidth: 4800
}

/**
 * ![UK DogAI](https://images.ctfassets.net/v6awd0kabi65/5tt9nGw63EYABoxB8VeY8h/6795dcc5483a88d573dcb524861616f1/UK_DogAI.jpg?w=120&h=120&fit=pad)
 *
 * UK DogAI
 *
 * Image of a dog being flagged as a pet during the advanced motion detection feature of the Wireless Indoor Camera.
 */
export const IMG_5tt9nGw63EYABoxB8VeY8h = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5tt9nGw63EYABoxB8VeY8h/6795dcc5483a88d573dcb524861616f1/UK_DogAI.jpg',
  description: `Image of a dog being flagged as a pet during the advanced motion detection feature of the Wireless Indoor Camera.`,
  originalHeight: 1366,
  originalWidth: 2048
}

/**
 * ![Designing the Perfect Smart Home Security System](https://images.ctfassets.net/v6awd0kabi65/1SSVprxnFHTRFdORG7QrBF/594ff1a2ad16fb19e9582e775c69f9f3/Designing_the_Perfect_Smart_Home_Security_System.jpg?w=120&h=120&fit=pad)
 *
 * Designing the Perfect Smart Home Security System
 *
 *
 */
export const IMG_1SSVprxnFHTRFdORG7QrBF = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1SSVprxnFHTRFdORG7QrBF/594ff1a2ad16fb19e9582e775c69f9f3/Designing_the_Perfect_Smart_Home_Security_System.jpg',
  description: ``,
  originalHeight: 1667,
  originalWidth: 2500
}

/**
 * ![The Ultimate Guide To Smart Video Doorbells 2024](https://images.ctfassets.net/v6awd0kabi65/1yCJMxdaUznSPrOqaQQxTN/569aa75c4eaef7738e51d4bf49b2d2ff/The_Ultimate_Guide_To_Smart_Video_Doorbells_2024.jpg?w=120&h=120&fit=pad)
 *
 * The Ultimate Guide To Smart Video Doorbells 2024
 *
 *
 */
export const IMG_1yCJMxdaUznSPrOqaQQxTN = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1yCJMxdaUznSPrOqaQQxTN/569aa75c4eaef7738e51d4bf49b2d2ff/The_Ultimate_Guide_To_Smart_Video_Doorbells_2024.jpg',
  description: ``,
  originalHeight: 1875,
  originalWidth: 2500
}

/**
 * ![What is the Average Room Temperature](https://images.ctfassets.net/v6awd0kabi65/5XgIqaaWs6q3zHHBqlD0OJ/93050712abb802bd8c1dfc4d1866283b/What_is_the_Average_Room_Temperature_.jpg?w=120&h=120&fit=pad)
 *
 * What is the Average Room Temperature
 *
 *
 */
export const IMG_5XgIqaaWs6q3zHHBqlD0OJ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5XgIqaaWs6q3zHHBqlD0OJ/93050712abb802bd8c1dfc4d1866283b/What_is_the_Average_Room_Temperature_.jpg',
  description: ``,
  originalHeight: 3648,
  originalWidth: 5472
}

/**
 * ![The Ultimate Guide to Choosing the Right Home Security System](https://images.ctfassets.net/v6awd0kabi65/70Q2b5Ebdqxr6ftecYrseJ/fda949faada44255b8146958e1a9bbfa/The_Ultimate_Guide_to_Choosing_the_Right_Home_Security_System.jpg?w=120&h=120&fit=pad)
 *
 * The Ultimate Guide to Choosing the Right Home Security System
 *
 *
 */
export const IMG_70Q2b5Ebdqxr6ftecYrseJ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/70Q2b5Ebdqxr6ftecYrseJ/fda949faada44255b8146958e1a9bbfa/The_Ultimate_Guide_to_Choosing_the_Right_Home_Security_System.jpg',
  description: ``,
  originalHeight: 3000,
  originalWidth: 4500
}

/**
 * ![Everything you need to know about fire alarms](https://images.ctfassets.net/v6awd0kabi65/2jrKUQ4Q4jifHl1zjEmCBg/f19ee2b7b8ecd646c24fcb3b78206f19/Everything_you_need_to_know_about_fire_alarms.jpg?w=120&h=120&fit=pad)
 *
 * Everything you need to know about fire alarms
 *
 *
 */
export const IMG_2jrKUQ4Q4jifHl1zjEmCBg = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2jrKUQ4Q4jifHl1zjEmCBg/f19ee2b7b8ecd646c24fcb3b78206f19/Everything_you_need_to_know_about_fire_alarms.jpg',
  description: ``,
  originalHeight: 1308,
  originalWidth: 1961
}

/**
 * ![How to Protect Your Home During Winter Storm Season](https://images.ctfassets.net/v6awd0kabi65/ibO3T5stUKlOnSEWHLnnp/47052cba0cfeed91d448ec3213e3b7ed/How_to_Protect_Your_Home_During_Winter_Storm_Season.jpg?w=120&h=120&fit=pad)
 *
 * How to Protect Your Home During Winter Storm Season
 *
 * How to Protect Your Home During Winter Storm Season
 */
export const IMG_ibO3T5stUKlOnSEWHLnnp = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/ibO3T5stUKlOnSEWHLnnp/47052cba0cfeed91d448ec3213e3b7ed/How_to_Protect_Your_Home_During_Winter_Storm_Season.jpg',
  description: `How to Protect Your Home During Winter Storm Season`,
  originalHeight: 1486,
  originalWidth: 2880
}

/**
 * ![A complete Christmas home security checklist](https://images.ctfassets.net/v6awd0kabi65/1jWF6WRIhAdS3NIuZ3XokB/ff719e3433f24d325772881a99136a7e/Untitled_design-21.png?w=120&h=120&fit=pad)
 *
 * A complete Christmas home security checklist
 *
 * Make sure you can rest easy during the most wonderful time of the year, with the help of SimpliSafe's complete Christmas home security checklist.
 */
export const IMG_1jWF6WRIhAdS3NIuZ3XokB = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1jWF6WRIhAdS3NIuZ3XokB/ff719e3433f24d325772881a99136a7e/Untitled_design-21.png',
  description: `Make sure you can rest easy during the most wonderful time of the year, with the help of SimpliSafe's complete Christmas home security checklist.`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![A complete Christmas home security checklist ](https://images.ctfassets.net/v6awd0kabi65/5paqCC5RXojrwqY3w2jdnd/a6f886b673cb685a4e1c4197dee4b531/Untitled_design-21.png?w=120&h=120&fit=pad)
 *
 * A complete Christmas home security checklist
 *
 * Make sure you can rest easy during the most wonderful time of the year, with the help of SimpliSafe's complete Christmas home security checklist.
 */
export const IMG_5paqCC5RXojrwqY3w2jdnd = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5paqCC5RXojrwqY3w2jdnd/a6f886b673cb685a4e1c4197dee4b531/Untitled_design-21.png',
  description: `Make sure you can rest easy during the most wonderful time of the year, with the help of SimpliSafe's complete Christmas home security checklist.`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Survey14 - Sandwich Generation Blog Post](https://images.ctfassets.net/v6awd0kabi65/Dlc76wKARn1shlrG1yN0s/badd58ce15ddf97e4de74074d7dae71e/survey14.png?w=120&h=120&fit=pad)
 *
 * Survey14 - Sandwich Generation Blog Post
 *
 *
 */
export const IMG_Dlc76wKARn1shlrG1yN0s = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/Dlc76wKARn1shlrG1yN0s/badd58ce15ddf97e4de74074d7dae71e/survey14.png',
  description: ``,
  originalHeight: 1324,
  originalWidth: 1800
}

/**
 * ![Survey13 - Sandwich Generation Blog Post](https://images.ctfassets.net/v6awd0kabi65/6VIZ7iSiCHXh3CVZmufOlC/22ec46e09ccc9569b1128a76c018fb90/survey13.png?w=120&h=120&fit=pad)
 *
 * Survey13 - Sandwich Generation Blog Post
 *
 *
 */
export const IMG_6VIZ7iSiCHXh3CVZmufOlC = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6VIZ7iSiCHXh3CVZmufOlC/22ec46e09ccc9569b1128a76c018fb90/survey13.png',
  description: ``,
  originalHeight: 896,
  originalWidth: 1712
}

/**
 * ![Survey12 - Sandwich Generation Blog Post](https://images.ctfassets.net/v6awd0kabi65/2HwohrQZTvOPF7YbXG8h2S/df6d09abdf64258e5e29de7b81c97982/survey12.png?w=120&h=120&fit=pad)
 *
 * Survey12 - Sandwich Generation Blog Post
 *
 *
 */
export const IMG_2HwohrQZTvOPF7YbXG8h2S = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2HwohrQZTvOPF7YbXG8h2S/df6d09abdf64258e5e29de7b81c97982/survey12.png',
  description: ``,
  originalHeight: 1466,
  originalWidth: 1832
}

/**
 * ![Survey11 - Sandwich Generation Blog Post](https://images.ctfassets.net/v6awd0kabi65/mJwCTKZ3qstKUlT1P3yMB/0851b33eb544829c2e3e922d75d08817/survey11.png?w=120&h=120&fit=pad)
 *
 * Survey11 - Sandwich Generation Blog Post
 *
 *
 */
export const IMG_mJwCTKZ3qstKUlT1P3yMB = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/mJwCTKZ3qstKUlT1P3yMB/0851b33eb544829c2e3e922d75d08817/survey11.png',
  description: ``,
  originalHeight: 982,
  originalWidth: 1788
}

/**
 * ![Survey10 - Sandwich Generation Blog Post](https://images.ctfassets.net/v6awd0kabi65/5kBc0OYaBGFKAbZxHtDKE9/049006ff7005f6ef4f8482e97d35dd20/survey10.png?w=120&h=120&fit=pad)
 *
 * Survey10 - Sandwich Generation Blog Post
 *
 *
 */
export const IMG_5kBc0OYaBGFKAbZxHtDKE9 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5kBc0OYaBGFKAbZxHtDKE9/049006ff7005f6ef4f8482e97d35dd20/survey10.png',
  description: ``,
  originalHeight: 954,
  originalWidth: 1750
}

/**
 * ![Survey9 - Sandwich Generation Blog Post](https://images.ctfassets.net/v6awd0kabi65/41uHLO072QhXJukyySjT3T/ca4d8786df4ded9660b21d17938935ab/survey9.png?w=120&h=120&fit=pad)
 *
 * Survey9 - Sandwich Generation Blog Post
 *
 *
 */
export const IMG_41uHLO072QhXJukyySjT3T = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/41uHLO072QhXJukyySjT3T/ca4d8786df4ded9660b21d17938935ab/survey9.png',
  description: ``,
  originalHeight: 1050,
  originalWidth: 1766
}

/**
 * ![Survey8 - Sandwich Generation Blog Post](https://images.ctfassets.net/v6awd0kabi65/6Nd1HPChF7ZhFBxb5PxQxV/19424e0c549802b51b209350ecd7a864/survey8.png?w=120&h=120&fit=pad)
 *
 * Survey8 - Sandwich Generation Blog Post
 *
 *
 */
export const IMG_6Nd1HPChF7ZhFBxb5PxQxV = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6Nd1HPChF7ZhFBxb5PxQxV/19424e0c549802b51b209350ecd7a864/survey8.png',
  description: ``,
  originalHeight: 890,
  originalWidth: 1924
}

/**
 * ![Survey7 - Sandwich Generation Blog Post](https://images.ctfassets.net/v6awd0kabi65/52fhDukgOygdFXc3SIU4Ev/eee8d98c14b71e073d46a837b00c3ae0/survey7.png?w=120&h=120&fit=pad)
 *
 * Survey7 - Sandwich Generation Blog Post
 *
 *
 */
export const IMG_52fhDukgOygdFXc3SIU4Ev = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/52fhDukgOygdFXc3SIU4Ev/eee8d98c14b71e073d46a837b00c3ae0/survey7.png',
  description: ``,
  originalHeight: 524,
  originalWidth: 1774
}

/**
 * ![Survey6 - Sandwich Generation Blog Post](https://images.ctfassets.net/v6awd0kabi65/69sf2LzOCYO40u6GXinc5z/a06fc6f5b1d048689f63a84ec3c8e355/survey6.png?w=120&h=120&fit=pad)
 *
 * Survey6 - Sandwich Generation Blog Post
 *
 *
 */
export const IMG_69sf2LzOCYO40u6GXinc5z = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/69sf2LzOCYO40u6GXinc5z/a06fc6f5b1d048689f63a84ec3c8e355/survey6.png',
  description: ``,
  originalHeight: 1316,
  originalWidth: 1876
}

/**
 * ![Survey5 - Sandwich Generation Blog Post](https://images.ctfassets.net/v6awd0kabi65/45bfUZGEliSlrSHeokpnS5/520076fa2a5c0b69dfdbdba41268256c/survey5.png?w=120&h=120&fit=pad)
 *
 * Survey5 - Sandwich Generation Blog Post
 *
 *
 */
export const IMG_45bfUZGEliSlrSHeokpnS5 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/45bfUZGEliSlrSHeokpnS5/520076fa2a5c0b69dfdbdba41268256c/survey5.png',
  description: ``,
  originalHeight: 1026,
  originalWidth: 1838
}

/**
 * ![Survey4 - Sandwich Generation Blog Post](https://images.ctfassets.net/v6awd0kabi65/2U8PvNaV9yYUmfv7QaGG7x/a260fc5fc51ae313011d7fd664d6f6a9/survey4.png?w=120&h=120&fit=pad)
 *
 * Survey4 - Sandwich Generation Blog Post
 *
 *
 */
export const IMG_2U8PvNaV9yYUmfv7QaGG7x = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2U8PvNaV9yYUmfv7QaGG7x/a260fc5fc51ae313011d7fd664d6f6a9/survey4.png',
  description: ``,
  originalHeight: 724,
  originalWidth: 1726
}

/**
 * ![Survey3 - Sandwich Generation Blog Post](https://images.ctfassets.net/v6awd0kabi65/4tyK5ST84r3mmabVvBOlZS/3985da80053222c4a828544fcd3ed859/survey3.png?w=120&h=120&fit=pad)
 *
 * Survey3 - Sandwich Generation Blog Post
 *
 *
 */
export const IMG_4tyK5ST84r3mmabVvBOlZS = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4tyK5ST84r3mmabVvBOlZS/3985da80053222c4a828544fcd3ed859/survey3.png',
  description: ``,
  originalHeight: 1018,
  originalWidth: 1750
}

/**
 * ![Survey2 - Sandwich Generation Blog Post](https://images.ctfassets.net/v6awd0kabi65/4Dbl1J70KETy6lcI15tx8H/c7e941d28977317c4a3306259d15b98c/survey2.png?w=120&h=120&fit=pad)
 *
 * Survey2 - Sandwich Generation Blog Post
 *
 *
 */
export const IMG_4Dbl1J70KETy6lcI15tx8H = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4Dbl1J70KETy6lcI15tx8H/c7e941d28977317c4a3306259d15b98c/survey2.png',
  description: ``,
  originalHeight: 896,
  originalWidth: 1798
}

/**
 * ![Survey1 - Sandwich Generation Blog Post](https://images.ctfassets.net/v6awd0kabi65/2rTy9WEMRqfbv1slAtxLC/8d3554ad1d974bc36ee48875b0864fa5/Survey1.png?w=120&h=120&fit=pad)
 *
 * Survey1 - Sandwich Generation Blog Post
 *
 *
 */
export const IMG_2rTy9WEMRqfbv1slAtxLC = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2rTy9WEMRqfbv1slAtxLC/8d3554ad1d974bc36ee48875b0864fa5/Survey1.png',
  description: ``,
  originalHeight: 1092,
  originalWidth: 1752
}

/**
 * ![Sandwich Generation Blog Post](https://images.ctfassets.net/v6awd0kabi65/2g5YSWMC3DyoqR9BqebaIj/d70cb3af3fb605ea99eebbd085f62431/Sandwich_Gen_Blog_Post.jpg?w=120&h=120&fit=pad)
 *
 * Sandwich Generation Blog Post
 *
 *
 */
export const IMG_2g5YSWMC3DyoqR9BqebaIj = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2g5YSWMC3DyoqR9BqebaIj/d70cb3af3fb605ea99eebbd085f62431/Sandwich_Gen_Blog_Post.jpg',
  description: ``,
  originalHeight: 4402,
  originalWidth: 4132
}

/**
 * ![How paper shredding & recycling helps security](https://images.ctfassets.net/v6awd0kabi65/7By1Cn5SF8IFDxXbUgocFZ/a4eb0c1e7ad94844164995db4d4705d0/36877313-scrap-of-shredded-paper-background.jpeg?w=120&h=120&fit=pad)
 *
 * How paper shredding & recycling helps security
 *
 *
 */
export const IMG_7By1Cn5SF8IFDxXbUgocFZ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7By1Cn5SF8IFDxXbUgocFZ/a4eb0c1e7ad94844164995db4d4705d0/36877313-scrap-of-shredded-paper-background.jpeg',
  description: ``,
  originalHeight: 867,
  originalWidth: 1300
}

/**
 * ![HUB Whole Home Kit](https://images.ctfassets.net/v6awd0kabi65/5MoanckQP5a1XpnRQLQ4z9/2b96b25ca014bc4cc5c8ff4f30f111ad/HUB-12-Piece-Square.png?w=120&h=120&fit=pad)
 *
 * HUB Whole Home Kit
 *
 * An image of all of the components included in The HUB Whole Home Kit.
 */
export const IMG_5MoanckQP5a1XpnRQLQ4z9 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5MoanckQP5a1XpnRQLQ4z9/2b96b25ca014bc4cc5c8ff4f30f111ad/HUB-12-Piece-Square.png',
  description: `An image of all of the components included in The HUB Whole Home Kit.`,
  originalHeight: 1796,
  originalWidth: 1804
}

/**
 * ![Neighbourhood Watch UK - Logo](https://images.ctfassets.net/v6awd0kabi65/6CkYI9FPyTNWu6GvsMao2n/1c3c69968a690c60b4dcc6f4771a8690/nw-logo-600.png?w=120&h=120&fit=pad)
 *
 * Neighbourhood Watch UK - Logo
 *
 * Neighbourhood Watch 1982-Today logo
 */
export const IMG_6CkYI9FPyTNWu6GvsMao2n = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6CkYI9FPyTNWu6GvsMao2n/1c3c69968a690c60b4dcc6f4771a8690/nw-logo-600.png',
  description: `Neighbourhood Watch 1982-Today logo`,
  originalHeight: 189,
  originalWidth: 600
}

/**
 * ![Recommended System - Keypad Base-Station](https://images.ctfassets.net/v6awd0kabi65/2xu9EgF4foPd6pk7iF3Qcb/3989802b8668ad80d863a32f3e65ef54/recommended-system-keypad-base-station.png?w=120&h=120&fit=pad)
 *
 * Recommended System - Keypad Base-Station
 *
 *
 */
export const IMG_2xu9EgF4foPd6pk7iF3Qcb = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2xu9EgF4foPd6pk7iF3Qcb/3989802b8668ad80d863a32f3e65ef54/recommended-system-keypad-base-station.png',
  description: ``,
  originalHeight: 1416,
  originalWidth: 2000
}

/**
 * ![SimpliSafe announces Neighbourhood Watch as its new charity partner](https://images.ctfassets.net/v6awd0kabi65/8pUQnU88RzqeXSbEUEvK2/1cb0007a139bdef5a3ca6db28319be78/Untitled_design-20.png?w=120&h=120&fit=pad)
 *
 * SimpliSafe announces Neighbourhood Watch as its new charity partner
 *
 *
 */
export const IMG_8pUQnU88RzqeXSbEUEvK2 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/8pUQnU88RzqeXSbEUEvK2/1cb0007a139bdef5a3ca6db28319be78/Untitled_design-20.png',
  description: ``,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![The Foundation (Package Lead Image Experiment)](https://images.ctfassets.net/v6awd0kabi65/2jTAIyn6xqm3wUE0wPom6K/21afcf3a8ca0ca457d1b0b60b4916e16/The_Foundation.jpg?w=120&h=120&fit=pad)
 *
 * The Foundation (Package Lead Image Experiment)
 *
 * The Foundation
 */
export const IMG_2jTAIyn6xqm3wUE0wPom6K = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2jTAIyn6xqm3wUE0wPom6K/21afcf3a8ca0ca457d1b0b60b4916e16/The_Foundation.jpg',
  description: `The Foundation`,
  originalHeight: 3500,
  originalWidth: 3500
}

/**
 * ![The Essentials (Package Lead Image Experiment)](https://images.ctfassets.net/v6awd0kabi65/YOs6DmyUf7pRKHRIJ5aom/524ca0901b6d07c8ef451b378b886fe6/The_Essentials.jpg?w=120&h=120&fit=pad)
 *
 * The Essentials (Package Lead Image Experiment)
 *
 * The Essentials
 */
export const IMG_YOs6DmyUf7pRKHRIJ5aom = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/YOs6DmyUf7pRKHRIJ5aom/524ca0901b6d07c8ef451b378b886fe6/The_Essentials.jpg',
  description: `The Essentials`,
  originalHeight: 3500,
  originalWidth: 3500
}

/**
 * ![The Hearth (Package Lead Image Experiment)](https://images.ctfassets.net/v6awd0kabi65/2E3PFuqKUxvvVUx7yrA2oI/2c16f147d8eb81896664580e0a04cf51/The_Hearth.jpg?w=120&h=120&fit=pad)
 *
 * The Hearth (Package Lead Image Experiment)
 *
 * The Hearth
 */
export const IMG_2E3PFuqKUxvvVUx7yrA2oI = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2E3PFuqKUxvvVUx7yrA2oI/2c16f147d8eb81896664580e0a04cf51/The_Hearth.jpg',
  description: `The Hearth`,
  originalHeight: 3500,
  originalWidth: 3500
}

/**
 * ![The Knox (Package Lead Image Experiment)](https://images.ctfassets.net/v6awd0kabi65/5iNBtgaLzxh8X9qwy8yaf/78d8904fb40d3a6483a03b3d099606c9/The_Knox.jpg?w=120&h=120&fit=pad)
 *
 * The Knox (Package Lead Image Experiment)
 *
 * The Knox
 */
export const IMG_5iNBtgaLzxh8X9qwy8yaf = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5iNBtgaLzxh8X9qwy8yaf/78d8904fb40d3a6483a03b3d099606c9/The_Knox.jpg',
  description: `The Knox`,
  originalHeight: 3500,
  originalWidth: 3500
}

/**
 * ![The Lighthouse (Package Lead Image Experiment)](https://images.ctfassets.net/v6awd0kabi65/5KQkcCpDalWEbMfhWnAyLQ/a6f3e45c883a032f0f46681bf4fef65f/The_Lighthouse_PDP.jpg?w=120&h=120&fit=pad)
 *
 * The Lighthouse (Package Lead Image Experiment)
 *
 * The Lighthouse
 */
export const IMG_5KQkcCpDalWEbMfhWnAyLQ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5KQkcCpDalWEbMfhWnAyLQ/a6f3e45c883a032f0f46681bf4fef65f/The_Lighthouse_PDP.jpg',
  description: `The Lighthouse`,
  originalHeight: 2334,
  originalWidth: 2334
}

/**
 * ![The Beacon (Package Lead Image Experiment)](https://images.ctfassets.net/v6awd0kabi65/S8iwJHuGLoCCiSLXLBEop/00dda197f556c0243098bd84f4f69adf/The_Beacon.jpg?w=120&h=120&fit=pad)
 *
 * The Beacon (Package Lead Image Experiment)
 *
 * The Beacon
 */
export const IMG_S8iwJHuGLoCCiSLXLBEop = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/S8iwJHuGLoCCiSLXLBEop/00dda197f556c0243098bd84f4f69adf/The_Beacon.jpg',
  description: `The Beacon`,
  originalHeight: 3500,
  originalWidth: 3500
}

/**
 * ![The Haven (Package Lead Image Experiment)](https://images.ctfassets.net/v6awd0kabi65/5lKlk66FfQ9VPoyP92QKNq/4f3d8c55183e7c2cb4eb73489d824b2f/The_Haven.jpg?w=120&h=120&fit=pad)
 *
 * The Haven (Package Lead Image Experiment)
 *
 * The Haven
 */
export const IMG_5lKlk66FfQ9VPoyP92QKNq = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5lKlk66FfQ9VPoyP92QKNq/4f3d8c55183e7c2cb4eb73489d824b2f/The_Haven.jpg',
  description: `The Haven`,
  originalHeight: 3500,
  originalWidth: 3500
}

/**
 * ![HUB Starter Kit](https://images.ctfassets.net/v6awd0kabi65/01IGr77LychfppQa5llQqi/d332472a3f9329face0a46722f93d340/HUB-7-Piece-Square.png?w=120&h=120&fit=pad)
 *
 * HUB Starter Kit
 *
 * An image of all of the components included in The HUB Starter Kit.
 */
export const IMG_01IGr77LychfppQa5llQqi = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/01IGr77LychfppQa5llQqi/d332472a3f9329face0a46722f93d340/HUB-7-Piece-Square.png',
  description: `An image of all of the components included in The HUB Starter Kit.`,
  originalHeight: 1796,
  originalWidth: 1804
}

/**
 * ![Refurbished System (12 pieces)](https://images.ctfassets.net/v6awd0kabi65/7kfKD9o7A8e9bAjShCXrCh/5829c911f3bc23a924e1c0fd47891399/Refurb-Pkg2-noMotion.jpg?w=120&h=120&fit=pad)
 *
 * Refurbished System (12 pieces)
 *
 *
 */
export const IMG_7kfKD9o7A8e9bAjShCXrCh = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7kfKD9o7A8e9bAjShCXrCh/5829c911f3bc23a924e1c0fd47891399/Refurb-Pkg2-noMotion.jpg',
  description: ``,
  originalHeight: 3109,
  originalWidth: 3109
}

/**
 * ![Refurbished System (4 pieces) - No Motion](https://images.ctfassets.net/v6awd0kabi65/5AXxBEWkC1fqzgIU1Ece7W/f6decc9c76e1c14059892dfd3d102ef1/Refurb-Pkg1-noMotion.jpg?w=120&h=120&fit=pad)
 *
 * Refurbished System (4 pieces) - No Motion
 *
 *
 */
export const IMG_5AXxBEWkC1fqzgIU1Ece7W = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5AXxBEWkC1fqzgIU1Ece7W/f6decc9c76e1c14059892dfd3d102ef1/Refurb-Pkg1-noMotion.jpg',
  description: ``,
  originalHeight: 2333,
  originalWidth: 2333
}

/**
 * ![Refurbished System (12 pieces)](https://images.ctfassets.net/v6awd0kabi65/2la8KFkqCiDpX5uMIWtVG6/2418da1b9015975b44c4e5a3e0afb0e0/Refurb-Pkg3-noMotion.jpg?w=120&h=120&fit=pad)
 *
 * Refurbished System (12 pieces)
 *
 *
 */
export const IMG_2la8KFkqCiDpX5uMIWtVG6 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2la8KFkqCiDpX5uMIWtVG6/2418da1b9015975b44c4e5a3e0afb0e0/Refurb-Pkg3-noMotion.jpg',
  description: ``,
  originalHeight: 3146,
  originalWidth: 3146
}

/**
 * ![Office Workers Blog](https://images.ctfassets.net/v6awd0kabi65/6QPJczP1ZO0pllP5wl2F5F/aa2f29897b2f37e657e1f885619ae20a/proxyclick-visitor-management-system-l90zRbWvCoE-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * Office Workers Blog
 *
 *
 */
export const IMG_6QPJczP1ZO0pllP5wl2F5F = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6QPJczP1ZO0pllP5wl2F5F/aa2f29897b2f37e657e1f885619ae20a/proxyclick-visitor-management-system-l90zRbWvCoE-unsplash.jpg',
  description: ``,
  originalHeight: 3848,
  originalWidth: 5772
}

/**
 * ![Affirm Hero - Tablet](https://images.ctfassets.net/v6awd0kabi65/7o3JvDSNYs4MWog1p6liJw/db26fb2fb1b7c425444a85b11d8b1f5e/tablet_hero-affirm__prime_cta_3x.png?w=120&h=120&fit=pad)
 *
 * Affirm Hero - Tablet
 *
 *
 */
export const IMG_7o3JvDSNYs4MWog1p6liJw = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7o3JvDSNYs4MWog1p6liJw/db26fb2fb1b7c425444a85b11d8b1f5e/tablet_hero-affirm__prime_cta_3x.png',
  description: ``,
  originalHeight: 1200,
  originalWidth: 2304
}

/**
 * ![Hero Banner - Homepage - Dark](https://images.ctfassets.net/v6awd0kabi65/2JPhzrtAI4m5wZL83Q61Cz/33c502198c535118aa6a13e4e0a3d009/D-hero2_2x.jpg?w=120&h=120&fit=pad)
 *
 * Hero Banner - Homepage - Dark
 *
 * Hero image
 */
export const IMG_2JPhzrtAI4m5wZL83Q61Cz = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2JPhzrtAI4m5wZL83Q61Cz/33c502198c535118aa6a13e4e0a3d009/D-hero2_2x.jpg',
  description: `Hero image`,
  originalHeight: 2400,
  originalWidth: 4800
}

/**
 * ![How can we prevent burglars from climbing walls?](https://images.ctfassets.net/v6awd0kabi65/6n0L0YdYrVJ2bT3ooKL5j4/090d09365c79cbd7500a30b25e7e146c/Untitled_design-9.png?w=120&h=120&fit=pad)
 *
 * How can we prevent burglars from climbing walls?
 *
 *
 */
export const IMG_6n0L0YdYrVJ2bT3ooKL5j4 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6n0L0YdYrVJ2bT3ooKL5j4/090d09365c79cbd7500a30b25e7e146c/Untitled_design-9.png',
  description: ``,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![9 educational home safety activities for kids](https://images.ctfassets.net/v6awd0kabi65/3ZyJLJXhgkS3Iwpp1Ee5k8/c7808330c18c56f5063e2cbc1ec579b6/pexels-ksenia-chernaya-8535193.jpg?w=120&h=120&fit=pad)
 *
 * 9 educational home safety activities for kids
 *
 *
 */
export const IMG_3ZyJLJXhgkS3Iwpp1Ee5k8 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3ZyJLJXhgkS3Iwpp1Ee5k8/c7808330c18c56f5063e2cbc1ec579b6/pexels-ksenia-chernaya-8535193.jpg',
  description: ``,
  originalHeight: 2804,
  originalWidth: 4200
}

/**
 * ![14 home security tips for cat owners](https://images.ctfassets.net/v6awd0kabi65/UnoouuDsSwbYQ7QGjIv54/29daa77cff44584b68381b99c051d00e/pexels-roman-castillo-17749219.jpg?w=120&h=120&fit=pad)
 *
 * 14 home security tips for cat owners
 *
 *
 */
export const IMG_UnoouuDsSwbYQ7QGjIv54 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/UnoouuDsSwbYQ7QGjIv54/29daa77cff44584b68381b99c051d00e/pexels-roman-castillo-17749219.jpg',
  description: ``,
  originalHeight: 3438,
  originalWidth: 5157
}

/**
 * ![12 ways to keep your home safe whilst moving house](https://images.ctfassets.net/v6awd0kabi65/4AWTGRXdgbo9sSVu78snGc/3549b11a7012c17b7dd1ccb917734e2b/pexels-ketut-subiyanto-4246191.jpg?w=120&h=120&fit=pad)
 *
 * 12 ways to keep your home safe whilst moving house
 *
 *
 */
export const IMG_4AWTGRXdgbo9sSVu78snGc = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4AWTGRXdgbo9sSVu78snGc/3549b11a7012c17b7dd1ccb917734e2b/pexels-ketut-subiyanto-4246191.jpg',
  description: ``,
  originalHeight: 3740,
  originalWidth: 5610
}

/**
 * ![Blog - Teachers giveaway](https://images.ctfassets.net/v6awd0kabi65/43ZR0dLF2J4Y0ryec8Fcxm/18fd42d22a1f0f37fd4565a926d5ccdd/blog-teachers.png?w=120&h=120&fit=pad)
 *
 * Blog - Teachers giveaway
 *
 *
 */
export const IMG_43ZR0dLF2J4Y0ryec8Fcxm = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/43ZR0dLF2J4Y0ryec8Fcxm/18fd42d22a1f0f37fd4565a926d5ccdd/blog-teachers.png',
  description: ``,
  originalHeight: 1564,
  originalWidth: 2350
}

/**
 * ![Movers - Mobile](https://images.ctfassets.net/v6awd0kabi65/3y2gA1p9tn5YeWe6Ao2WFP/d3c6505d86ae4593c4b4207b351c5796/Movers_-_Mobile.png?w=120&h=120&fit=pad)
 *
 * Movers - Mobile
 *
 *
 */
export const IMG_3y2gA1p9tn5YeWe6Ao2WFP = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3y2gA1p9tn5YeWe6Ao2WFP/d3c6505d86ae4593c4b4207b351c5796/Movers_-_Mobile.png',
  description: ``,
  originalHeight: 368,
  originalWidth: 375
}

/**
 * ![Movers - Tablet](https://images.ctfassets.net/v6awd0kabi65/1T7BYEsnhDLjclvN616QoA/07b8b49407c145b967cc1ba06aab69e9/Movers_-_Tablet.png?w=120&h=120&fit=pad)
 *
 * Movers - Tablet
 *
 *
 */
export const IMG_1T7BYEsnhDLjclvN616QoA = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1T7BYEsnhDLjclvN616QoA/07b8b49407c145b967cc1ba06aab69e9/Movers_-_Tablet.png',
  description: ``,
  originalHeight: 380,
  originalWidth: 768
}

/**
 * ![Movers - Desktop](https://images.ctfassets.net/v6awd0kabi65/44jKoC5dedED9IjDTyYAHt/92e268f667dc993854a7e2da462f87a8/Movers_-_Desktop.png?w=120&h=120&fit=pad)
 *
 * Movers - Desktop
 *
 *
 */
export const IMG_44jKoC5dedED9IjDTyYAHt = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/44jKoC5dedED9IjDTyYAHt/92e268f667dc993854a7e2da462f87a8/Movers_-_Desktop.png',
  description: ``,
  originalHeight: 612,
  originalWidth: 1312
}

/**
 * ![How to secure your home during the school summer holidays](https://images.ctfassets.net/v6awd0kabi65/1xOzgBM5a0eiTBbWQKVE5E/cbbb47d6bd66da67b38f44e64eaf7882/torsten-dederichs-XRcEsQKTWGk-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * How to secure your home during the school summer holidays
 *
 * The school summer holidays are great fun, but they don't come without their dangers. Learn how to secure your home during the school holidays with SimpliSafe.
 */
export const IMG_1xOzgBM5a0eiTBbWQKVE5E = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1xOzgBM5a0eiTBbWQKVE5E/cbbb47d6bd66da67b38f44e64eaf7882/torsten-dederichs-XRcEsQKTWGk-unsplash.jpg',
  description: `The school summer holidays are great fun, but they don't come without their dangers. Learn how to secure your home during the school holidays with SimpliSafe.`,
  originalHeight: 3731,
  originalWidth: 5596
}

/**
 * ![Icon - Secure home](https://images.ctfassets.net/v6awd0kabi65/1bnDHtKS4cUBGUue0NziA5/ce63dc6622b964fe42f195ae19d1cf4f/Type_Secure_Home.png?w=120&h=120&fit=pad)
 *
 * Icon - Secure home
 *
 * Icon - Secure home
 */
export const IMG_1bnDHtKS4cUBGUue0NziA5 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1bnDHtKS4cUBGUue0NziA5/ce63dc6622b964fe42f195ae19d1cf4f/Type_Secure_Home.png',
  description: `Icon - Secure home`,
  originalHeight: 160,
  originalWidth: 160
}

/**
 * ![Homepage UK Hero Mobile](https://images.ctfassets.net/v6awd0kabi65/3XlHNnF10LXKOxpTSkX1jn/f6c701ea9e529599246239deb1e911b2/image-20230713-232254.png?w=120&h=120&fit=pad)
 *
 * Homepage UK Hero Mobile
 *
 * Whole home protection
 */
export const IMG_3XlHNnF10LXKOxpTSkX1jn = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3XlHNnF10LXKOxpTSkX1jn/f6c701ea9e529599246239deb1e911b2/image-20230713-232254.png',
  description: `Whole home protection`,
  originalHeight: 1026,
  originalWidth: 1123
}

/**
 * ![Whole Home Protection UK - Hazard sensors](https://images.ctfassets.net/v6awd0kabi65/1ADCCclQPHz2gN3trlDt5u/a0305d3c5d9fa1354c52ff903434c911/Group_972.png?w=120&h=120&fit=pad)
 *
 * Whole Home Protection UK - Hazard sensors
 *
 * Whole Home Protection - Hazard sensors
 */
export const IMG_1ADCCclQPHz2gN3trlDt5u = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1ADCCclQPHz2gN3trlDt5u/a0305d3c5d9fa1354c52ff903434c911/Group_972.png',
  description: `Whole Home Protection - Hazard sensors`,
  originalHeight: 627,
  originalWidth: 1161
}

/**
 * ![App Control - UK Home](https://images.ctfassets.net/v6awd0kabi65/6LT6dvk157aAfFdKyeG2Kf/d01c90602d62bcfa3ebcad52d66588e9/App_Screen_art.png?w=120&h=120&fit=pad)
 *
 * App Control - UK Home
 *
 * SimpliSafe App Control
 */
export const IMG_6LT6dvk157aAfFdKyeG2Kf = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6LT6dvk157aAfFdKyeG2Kf/d01c90602d62bcfa3ebcad52d66588e9/App_Screen_art.png',
  description: `SimpliSafe App Control`,
  originalHeight: 1254,
  originalWidth: 1000
}

/**
 * ![Homepage UK Hero Tablet](https://images.ctfassets.net/v6awd0kabi65/KxYHJgUonnczIDSkZ8auC/2091bcddb4238e111d10b0553a991fef/tablet_hero_2x.png?w=120&h=120&fit=pad)
 *
 * Homepage UK Hero Tablet
 *
 * Whole home protection
 */
export const IMG_KxYHJgUonnczIDSkZ8auC = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/KxYHJgUonnczIDSkZ8auC/2091bcddb4238e111d10b0553a991fef/tablet_hero_2x.png',
  description: `Whole home protection`,
  originalHeight: 1358,
  originalWidth: 2460
}

/**
 * ![Homepage UK Hero Desktop](https://images.ctfassets.net/v6awd0kabi65/6Qzv4ylAsMpoHkoJLDFK1z/27926e391b05815a4b412bcc23660f03/desktop_hero_2x.png?w=120&h=120&fit=pad)
 *
 * Homepage UK Hero Desktop
 *
 * Whole home protection
 */
export const IMG_6Qzv4ylAsMpoHkoJLDFK1z = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6Qzv4ylAsMpoHkoJLDFK1z/27926e391b05815a4b412bcc23660f03/desktop_hero_2x.png',
  description: `Whole home protection`,
  originalHeight: 1174,
  originalWidth: 2880
}

/**
 * ![Hero Banner - Homepage - Mobile - Balto](https://images.ctfassets.net/v6awd0kabi65/W7pYEpXlbcvR66myKfMMm/e769e0aae273c07a9ac2a0b3f34c50f8/Hero_Mobile.jpg?w=120&h=120&fit=pad)
 *
 * Hero Banner - Homepage - Mobile - Balto
 *
 * Whole Home Protection
 */
export const IMG_W7pYEpXlbcvR66myKfMMm = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/W7pYEpXlbcvR66myKfMMm/e769e0aae273c07a9ac2a0b3f34c50f8/Hero_Mobile.jpg',
  description: `Whole Home Protection`,
  originalHeight: 864,
  originalWidth: 1562
}

/**
 * ![The Haven Product Image](https://images.ctfassets.net/v6awd0kabi65/v8iwuLEMfcwW6YiQcsnPL/81b7da1941e1ea77466068aa732c7843/HAVEN-Balto.jpg?w=120&h=120&fit=pad)
 *
 * The Haven Product Image
 *
 *
 */
export const IMG_v8iwuLEMfcwW6YiQcsnPL = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/v8iwuLEMfcwW6YiQcsnPL/81b7da1941e1ea77466068aa732c7843/HAVEN-Balto.jpg',
  description: ``,
  originalHeight: 1800,
  originalWidth: 2500
}

/**
 * ![The Knox](https://images.ctfassets.net/v6awd0kabi65/A5xmO7RldwrsGw1ynoRPA/ed29e67dd45fca3326493bee77404018/KNOX-Balto.jpg?w=120&h=120&fit=pad)
 *
 * The Knox
 *
 * An image of all of the components included in The Knox package.
 */
export const IMG_A5xmO7RldwrsGw1ynoRPA = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/A5xmO7RldwrsGw1ynoRPA/ed29e67dd45fca3326493bee77404018/KNOX-Balto.jpg',
  description: `An image of all of the components included in The Knox package. `,
  originalHeight: 1800,
  originalWidth: 2500
}

/**
 * ![Find the right system - Homepage - Balto](https://images.ctfassets.net/v6awd0kabi65/7FApwfEA91pNmqu35jzIoy/2e3d385e0ee8dbfd021102a9073846dc/find-right-system_3x.png?w=120&h=120&fit=pad)
 *
 * Find the right system - Homepage - Balto
 *
 * A SimpliSafe Base Station and Keypad with some other pieces in the background on a stand
 */
export const IMG_7FApwfEA91pNmqu35jzIoy = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7FApwfEA91pNmqu35jzIoy/2e3d385e0ee8dbfd021102a9073846dc/find-right-system_3x.png',
  description: `A SimpliSafe Base Station and Keypad with some other pieces in the background on a stand`,
  originalHeight: 790,
  originalWidth: 1600
}

/**
 * ![Hero Banner - Homepage - Desktop - Balto](https://images.ctfassets.net/v6awd0kabi65/6PvoMI5MoBaq2cqirKqXxG/fb3e2fb839bbac2ff452ee733bf84947/Hero_Desktop.jpg?w=120&h=120&fit=pad)
 *
 * Hero Banner - Homepage - Desktop - Balto
 *
 * Whole Home Protection
 */
export const IMG_6PvoMI5MoBaq2cqirKqXxG = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6PvoMI5MoBaq2cqirKqXxG/fb3e2fb839bbac2ff452ee733bf84947/Hero_Desktop.jpg',
  description: `Whole Home Protection`,
  originalHeight: 2400,
  originalWidth: 4800
}

/**
 * ![Hero Banner - Homepage - Tablet - Balto](https://images.ctfassets.net/v6awd0kabi65/4poMS4nXLYnC2HPmkiRWux/e112d91d1a71cb56d5fd2d6af0dcba89/Hero_Tablet.jpg?w=120&h=120&fit=pad)
 *
 * Hero Banner - Homepage - Tablet - Balto
 *
 * Whole Home Protection
 */
export const IMG_4poMS4nXLYnC2HPmkiRWux = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4poMS4nXLYnC2HPmkiRWux/e112d91d1a71cb56d5fd2d6af0dcba89/Hero_Tablet.jpg',
  description: `Whole Home Protection`,
  originalHeight: 2400,
  originalWidth: 4346
}

/**
 * ![2 - Whole Home Protection - Burglary Sensors (Balto)](https://images.ctfassets.net/v6awd0kabi65/4nKS97ikNM7reYj2kLbuZy/c914a5df1f8918f1b8a23919ac9a6161/burglary-sensors_3x__1_.png?w=120&h=120&fit=pad)
 *
 * 2 - Whole Home Protection - Burglary Sensors (Balto)
 *
 * Burglary Sensors
 */
export const IMG_4nKS97ikNM7reYj2kLbuZy = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4nKS97ikNM7reYj2kLbuZy/c914a5df1f8918f1b8a23919ac9a6161/burglary-sensors_3x__1_.png',
  description: `Burglary Sensors`,
  originalHeight: 950,
  originalWidth: 1740
}

/**
 * ![The Beacon](https://images.ctfassets.net/v6awd0kabi65/3ovozp4O17JSYnPrJUmWXa/70b72ec966c1514db214f21bc1882158/BEACON-Balto_020623.png?w=120&h=120&fit=pad)
 *
 * The Beacon
 *
 *
 */
export const IMG_3ovozp4O17JSYnPrJUmWXa = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3ovozp4O17JSYnPrJUmWXa/70b72ec966c1514db214f21bc1882158/BEACON-Balto_020623.png',
  description: ``,
  originalHeight: 1800,
  originalWidth: 2500
}

/**
 * ![The Lighthouse](https://images.ctfassets.net/v6awd0kabi65/319QMbeAbeEpuezsLgMPmS/ad27b254106105e0b0ce821c7eccf0b5/LIGHTHOUSE-Balto.jpg?w=120&h=120&fit=pad)
 *
 * The Lighthouse
 *
 * An image of all of the components included in The Lighthouse package.
 */
export const IMG_319QMbeAbeEpuezsLgMPmS = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/319QMbeAbeEpuezsLgMPmS/ad27b254106105e0b0ce821c7eccf0b5/LIGHTHOUSE-Balto.jpg',
  description: `An image of all of the components included in The Lighthouse package. `,
  originalHeight: 1800,
  originalWidth: 2500
}

/**
 * ![The Foundation](https://images.ctfassets.net/v6awd0kabi65/2QO9yejHIwq39OaFghXMqW/52229dc484ce991a42d8bf51228a4ca4/FOUNDATION-Balto.jpg?w=120&h=120&fit=pad)
 *
 * The Foundation
 *
 * An image of all of the components included in The Foundation package.
 */
export const IMG_2QO9yejHIwq39OaFghXMqW = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2QO9yejHIwq39OaFghXMqW/52229dc484ce991a42d8bf51228a4ca4/FOUNDATION-Balto.jpg',
  description: `An image of all of the components included in The Foundation package. `,
  originalHeight: 1800,
  originalWidth: 2500
}

/**
 * ![The Hearth](https://images.ctfassets.net/v6awd0kabi65/2jK8uJ0XIpRBlhTCurwQGq/f8e8c6070610a82e9d21ccad01b63f34/HEARTH-Balto.jpg?w=120&h=120&fit=pad)
 *
 * The Hearth
 *
 * An image of all of the components included in The Hearth package.
 */
export const IMG_2jK8uJ0XIpRBlhTCurwQGq = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2jK8uJ0XIpRBlhTCurwQGq/f8e8c6070610a82e9d21ccad01b63f34/HEARTH-Balto.jpg',
  description: `An image of all of the components included in The Hearth package. `,
  originalHeight: 1800,
  originalWidth: 2500
}

/**
 * ![UK Package Tower](https://images.ctfassets.net/v6awd0kabi65/1sfSjwJfNU5r5nT0W48hbs/f88144bbc10ec3b163e0efab23c01310/UK_Package_Tower.jpg?w=120&h=120&fit=pad)
 *
 * UK Package Tower
 *
 *
 */
export const IMG_1sfSjwJfNU5r5nT0W48hbs = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1sfSjwJfNU5r5nT0W48hbs/f88144bbc10ec3b163e0efab23c01310/UK_Package_Tower.jpg',
  description: ``,
  originalHeight: 1170,
  originalWidth: 1625
}

/**
 * ![UK Package Edinburgh](https://images.ctfassets.net/v6awd0kabi65/5MY4tIvoypnXECitat8vsP/abb6c3962a0a266a75b8eb8af352b896/UK_Package_Edinburgh.jpg?w=120&h=120&fit=pad)
 *
 * UK Package Edinburgh
 *
 *
 */
export const IMG_5MY4tIvoypnXECitat8vsP = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5MY4tIvoypnXECitat8vsP/abb6c3962a0a266a75b8eb8af352b896/UK_Package_Edinburgh.jpg',
  description: ``,
  originalHeight: 1124,
  originalWidth: 1274
}

/**
 * ![BMS Balto (1)](https://images.ctfassets.net/v6awd0kabi65/5UbvhajX2GPERM0iz9i0tC/989b5af82030f776d0bf403ef775fc0b/BMS_Balto__1_.jpg?w=120&h=120&fit=pad)
 *
 * BMS Balto (1)
 *
 *
 */
export const IMG_5UbvhajX2GPERM0iz9i0tC = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5UbvhajX2GPERM0iz9i0tC/989b5af82030f776d0bf403ef775fc0b/BMS_Balto__1_.jpg',
  description: ``,
  originalHeight: 320,
  originalWidth: 320
}

/**
 * ![Motion V2 In Home](https://images.ctfassets.net/v6awd0kabi65/Sw4dAR6zm0oUaXTbjlSxV/edea028e28497c30823f121942e90634/Packages_in-home-balto.png?w=120&h=120&fit=pad)
 *
 * Motion V2 In Home
 *
 *
 */
export const IMG_Sw4dAR6zm0oUaXTbjlSxV = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/Sw4dAR6zm0oUaXTbjlSxV/edea028e28497c30823f121942e90634/Packages_in-home-balto.png',
  description: ``,
  originalHeight: 730,
  originalWidth: 1100
}

/**
 * ![10 home safety tips for summer](https://images.ctfassets.net/v6awd0kabi65/5v6NxlM58Qspx4L7NeESpJ/2ea2c8b81bfa42df2872d4dd76bda503/Untitled_design-7.png?w=120&h=120&fit=pad)
 *
 * 10 home safety tips for summer
 *
 * Find out our top 10 home safety tips for summer to keep you and your home safe. From installing security to social media safety - our complete guide has it all.
 */
export const IMG_5v6NxlM58Qspx4L7NeESpJ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5v6NxlM58Qspx4L7NeESpJ/2ea2c8b81bfa42df2872d4dd76bda503/Untitled_design-7.png',
  description: `Find out our top 10 home safety tips for summer to keep you and your home safe. From installing security to social media safety - our complete guide has it all.`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![10 home safety tips for summer ](https://images.ctfassets.net/v6awd0kabi65/2kgcwbxKan8eIJN3jjMOPy/4ca56c1373c1d40669305a014f63d4fa/Untitled_design-7.png?w=120&h=120&fit=pad)
 *
 * 10 home safety tips for summer
 *
 * 10 home safety tips for summer
 */
export const IMG_2kgcwbxKan8eIJN3jjMOPy = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2kgcwbxKan8eIJN3jjMOPy/4ca56c1373c1d40669305a014f63d4fa/Untitled_design-7.png',
  description: `10 home safety tips for summer `,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![20 important questions to ask when buying a home](https://images.ctfassets.net/v6awd0kabi65/3Trqf5gLkxjiJ5HWT80zGO/8beb56fc858c35cb03399f7d482b9212/tierra-mallorca-rgJ1J8SDEAY-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * 20 important questions to ask when buying a home
 *
 *
 */
export const IMG_3Trqf5gLkxjiJ5HWT80zGO = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3Trqf5gLkxjiJ5HWT80zGO/8beb56fc858c35cb03399f7d482b9212/tierra-mallorca-rgJ1J8SDEAY-unsplash.jpg',
  description: ``,
  originalHeight: 3448,
  originalWidth: 4592
}

/**
 * ![Hero Banner - Homepage - Mobile - Scout](https://images.ctfassets.net/v6awd0kabi65/1ogkmlTNptRjWI249unp1q/c5830b20227f15a6d26b77f9f79d6470/Hero_Mobile_scout.png?w=120&h=120&fit=pad)
 *
 * Hero Banner - Homepage - Mobile - Scout
 *
 * Whole Home Protection
 */
export const IMG_1ogkmlTNptRjWI249unp1q = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1ogkmlTNptRjWI249unp1q/c5830b20227f15a6d26b77f9f79d6470/Hero_Mobile_scout.png',
  description: `Whole Home Protection`,
  originalHeight: 424,
  originalWidth: 768
}

/**
 * ![Hero Banner - Homepage - Desktop - Scout](https://images.ctfassets.net/v6awd0kabi65/2GjfE4H1FwseGNOJr0RbTK/22213b0fe4f0435c2ee77e2f127c6dfa/Hero_Desktop_scout.png?w=120&h=120&fit=pad)
 *
 * Hero Banner - Homepage - Desktop - Scout
 *
 * Whole Home Protection
 */
export const IMG_2GjfE4H1FwseGNOJr0RbTK = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2GjfE4H1FwseGNOJr0RbTK/22213b0fe4f0435c2ee77e2f127c6dfa/Hero_Desktop_scout.png',
  description: `Whole Home Protection`,
  originalHeight: 1200,
  originalWidth: 2400
}

/**
 * ![How to get the most out of your SimpliSafe system](https://images.ctfassets.net/v6awd0kabi65/3ey4IRjFyCvOBY07r5zfFZ/b0bf390b82258d91adc04c085c8fbb10/keypad_new1200x1200.webp?w=120&h=120&fit=pad)
 *
 * How to get the most out of your SimpliSafe system
 *
 * Now you have a home security system, make sure you’re using it to its full potential. Here are six ways you can use your SimpliSafe whether you’re home or away.
 */
export const IMG_3ey4IRjFyCvOBY07r5zfFZ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3ey4IRjFyCvOBY07r5zfFZ/b0bf390b82258d91adc04c085c8fbb10/keypad_new1200x1200.webp',
  description: `Now you have a home security system, make sure you’re using it to its full potential. Here are six ways you can use your SimpliSafe whether you’re home or away.`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Ohmkat Power Supply](https://images.ctfassets.net/v6awd0kabi65/3sBnJ0HA5shy9szfRoZBf3/5250e98b468dbb7f03f54aebf728d686/ohmkat-power-supply_copy.jpeg?w=120&h=120&fit=pad)
 *
 * Ohmkat Power Supply
 *
 * Ohmkat Power Supply
 */
export const IMG_3sBnJ0HA5shy9szfRoZBf3 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3sBnJ0HA5shy9szfRoZBf3/5250e98b468dbb7f03f54aebf728d686/ohmkat-power-supply_copy.jpeg',
  description: `Ohmkat Power Supply`,
  originalHeight: 355,
  originalWidth: 264
}

/**
 * ![Ohmkat Power Supply and Chime](https://images.ctfassets.net/v6awd0kabi65/1CzzqnnY81nwRcQnMZUriQ/1dfa8d564b271ce3b40882d15e3d2088/ohmkat-power-supply-and-chime_copy.jpeg?w=120&h=120&fit=pad)
 *
 * Ohmkat Power Supply and Chime
 *
 * Ohmkat Power Supply and Chime
 */
export const IMG_1CzzqnnY81nwRcQnMZUriQ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1CzzqnnY81nwRcQnMZUriQ/1dfa8d564b271ce3b40882d15e3d2088/ohmkat-power-supply-and-chime_copy.jpeg',
  description: `Ohmkat Power Supply and Chime`,
  originalHeight: 246,
  originalWidth: 427
}

/**
 * ![privacy-hero-desktop](https://images.ctfassets.net/v6awd0kabi65/7DKEYjIYpM4hStGSFMI9iA/7c0884aab2beada1c32f59bedb125e53/01-desktop.png?w=120&h=120&fit=pad)
 *
 * privacy-hero-desktop
 *
 *
 */
export const IMG_7DKEYjIYpM4hStGSFMI9iA = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7DKEYjIYpM4hStGSFMI9iA/7c0884aab2beada1c32f59bedb125e53/01-desktop.png',
  description: ``,
  originalHeight: 1266,
  originalWidth: 2624
}

/**
 * ![privacy-hero-tablet](https://images.ctfassets.net/v6awd0kabi65/2MBV4XEHtSBZXVBeaHsn0c/4c8ec7071fcf008ea83dc7eabb5b3ec6/01-tablet.png?w=120&h=120&fit=pad)
 *
 * privacy-hero-tablet
 *
 *
 */
export const IMG_2MBV4XEHtSBZXVBeaHsn0c = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2MBV4XEHtSBZXVBeaHsn0c/4c8ec7071fcf008ea83dc7eabb5b3ec6/01-tablet.png',
  description: ``,
  originalHeight: 698,
  originalWidth: 1536
}

/**
 * ![privacy-hero-mobile](https://images.ctfassets.net/v6awd0kabi65/2YgujJALullkAb3pSpYgfg/de98ff28a2ad931285041a024d391099/01-mobile.png?w=120&h=120&fit=pad)
 *
 * privacy-hero-mobile
 *
 *
 */
export const IMG_2YgujJALullkAb3pSpYgfg = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2YgujJALullkAb3pSpYgfg/de98ff28a2ad931285041a024d391099/01-mobile.png',
  description: ``,
  originalHeight: 640,
  originalWidth: 750
}

/**
 * ![Privacy By Design - Yard Sign](https://images.ctfassets.net/v6awd0kabi65/6U88b8E4HjvERveVSA2BCV/51f92232240f5d23dde5554eed8252b6/image_1__2_.png?w=120&h=120&fit=pad)
 *
 * Privacy By Design - Yard Sign
 *
 * SimpliSafe Yard Sign
 */
export const IMG_6U88b8E4HjvERveVSA2BCV = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6U88b8E4HjvERveVSA2BCV/51f92232240f5d23dde5554eed8252b6/image_1__2_.png',
  description: `SimpliSafe Yard Sign`,
  originalHeight: 980,
  originalWidth: 1200
}

/**
 * ![Privacy - Your Are In Control](https://images.ctfassets.net/v6awd0kabi65/1pdrSljAt6pn4JGP1t8LWN/1ae5d49382c42ddecf3f79c89d8ecf96/image_1__3_.png?w=120&h=120&fit=pad)
 *
 * Privacy - Your Are In Control
 *
 * SimpliSafe Mobile App
 */
export const IMG_1pdrSljAt6pn4JGP1t8LWN = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1pdrSljAt6pn4JGP1t8LWN/1ae5d49382c42ddecf3f79c89d8ecf96/image_1__3_.png',
  description: `SimpliSafe Mobile App`,
  originalHeight: 980,
  originalWidth: 1200
}

/**
 * ![Privacy - Single-Minded Mission](https://images.ctfassets.net/v6awd0kabi65/6Jx9p17pODvEl6D1k7TGIB/aa93279991cf1c1952357d85ee063883/Frame_1208__3_.png?w=120&h=120&fit=pad)
 *
 * Privacy - Single-Minded Mission
 *
 * Dog sitting on the couch
 */
export const IMG_6Jx9p17pODvEl6D1k7TGIB = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6Jx9p17pODvEl6D1k7TGIB/aa93279991cf1c1952357d85ee063883/Frame_1208__3_.png',
  description: `Dog sitting on the couch`,
  originalHeight: 980,
  originalWidth: 1200
}

/**
 * ![Indoor Camera - Privacy by design](https://images.ctfassets.net/v6awd0kabi65/5zSt4esO1YV04PwDwSDr9p/760211185f18d2096061c29b8607f1b3/Frame_1208__2_.png?w=120&h=120&fit=pad)
 *
 * Indoor Camera - Privacy by design
 *
 * SimpliSafe Indoor Camera
 */
export const IMG_5zSt4esO1YV04PwDwSDr9p = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5zSt4esO1YV04PwDwSDr9p/760211185f18d2096061c29b8607f1b3/Frame_1208__2_.png',
  description: `SimpliSafe Indoor Camera`,
  originalHeight: 980,
  originalWidth: 1200
}

/**
 * ![New app feature: Scheduled Arming has landed!](https://images.ctfassets.net/v6awd0kabi65/1DBaqogh1sXqSeaL93tFgw/93def1dddf5690cfefd2a0d573030954/scheduled_arming__1_.png?w=120&h=120&fit=pad)
 *
 * New app feature: Scheduled Arming has landed!
 *
 *
 */
export const IMG_1DBaqogh1sXqSeaL93tFgw = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1DBaqogh1sXqSeaL93tFgw/93def1dddf5690cfefd2a0d573030954/scheduled_arming__1_.png',
  description: ``,
  originalHeight: 618,
  originalWidth: 380
}

/**
 * ![How to get the most out of your SimpliSafe system](https://images.ctfassets.net/v6awd0kabi65/6YCxhI63SKRx2QcNea5kw5/4ce0d9cc8a960f2f8cd8025acaa5799c/Untitled_design-6.png?w=120&h=120&fit=pad)
 *
 * How to get the most out of your SimpliSafe system
 *
 * Now you have a home security system, make sure you’re using it to its full potential. Here are six ways you can use your SimpliSafe whether you’re home or away.
 */
export const IMG_6YCxhI63SKRx2QcNea5kw5 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6YCxhI63SKRx2QcNea5kw5/4ce0d9cc8a960f2f8cd8025acaa5799c/Untitled_design-6.png',
  description: `Now you have a home security system, make sure you’re using it to its full potential. Here are six ways you can use your SimpliSafe whether you’re home or away.`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Balto - Transparent BG](https://images.ctfassets.net/v6awd0kabi65/3Hjnbfnav3JsAK94bqT0jE/aa12b1ae056354525ae2b29c7915cdaa/gen3_balto_transparent.jpg?w=120&h=120&fit=pad)
 *
 * Balto - Transparent BG
 *
 *
 */
export const IMG_3Hjnbfnav3JsAK94bqT0jE = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3Hjnbfnav3JsAK94bqT0jE/aa12b1ae056354525ae2b29c7915cdaa/gen3_balto_transparent.jpg',
  description: ``,
  originalHeight: 772,
  originalWidth: 772
}

/**
 * ![SimpliSafe Father’s Day System Giveaway](https://images.ctfassets.net/v6awd0kabi65/4q74ptSz8mTWr90gud75wl/1bc04c70d74e44914be7fcecadc76065/SimpliSafe_Father___s_Day_System_Giveaway_.jpeg?w=120&h=120&fit=pad)
 *
 * SimpliSafe Father’s Day System Giveaway
 *
 * SimpliSafe Father’s Day System Giveaway
 */
export const IMG_4q74ptSz8mTWr90gud75wl = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4q74ptSz8mTWr90gud75wl/1bc04c70d74e44914be7fcecadc76065/SimpliSafe_Father___s_Day_System_Giveaway_.jpeg',
  description: `SimpliSafe Father’s Day System Giveaway `,
  originalHeight: 341,
  originalWidth: 512
}

/**
 * ![Balto Gray](https://images.ctfassets.net/v6awd0kabi65/3P4hbVCbMGtqd9LwerTV49/7dd3781ebdbb2a9f89b60373e9675a5e/gen3_balto_gray.jpg?w=120&h=120&fit=pad)
 *
 * Balto Gray
 *
 *
 */
export const IMG_3P4hbVCbMGtqd9LwerTV49 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3P4hbVCbMGtqd9LwerTV49/7dd3781ebdbb2a9f89b60373e9675a5e/gen3_balto_gray.jpg',
  description: ``,
  originalHeight: 772,
  originalWidth: 772
}

/**
 * ![Find the right system - New homepage/landing page](https://images.ctfassets.net/v6awd0kabi65/Yu71icrMlxjoQltnYtlnt/9b9d338aebd4bdde9b55d17272b0622d/Find_the_right_system.png?w=120&h=120&fit=pad)
 *
 * Find the right system - New homepage/landing page
 *
 * A SimpliSafe Base Station and Keypad with some other pieces in the background on a stand
 */
export const IMG_Yu71icrMlxjoQltnYtlnt = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/Yu71icrMlxjoQltnYtlnt/9b9d338aebd4bdde9b55d17272b0622d/Find_the_right_system.png',
  description: `A SimpliSafe Base Station and Keypad with some other pieces in the background on a stand`,
  originalHeight: 790,
  originalWidth: 1600
}

/**
 * ![2 - Whole Home Protection - Burglary Sensors](https://images.ctfassets.net/v6awd0kabi65/7vfH1Cc0BC5nGI5y2LZ0k4/d97ec2a0e6250fa9c46f03702594ee43/burglary-sensors.png?w=120&h=120&fit=pad)
 *
 * 2 - Whole Home Protection - Burglary Sensors
 *
 * Burglary Sensors
 */
export const IMG_7vfH1Cc0BC5nGI5y2LZ0k4 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7vfH1Cc0BC5nGI5y2LZ0k4/d97ec2a0e6250fa9c46f03702594ee43/burglary-sensors.png',
  description: `Burglary Sensors`,
  originalHeight: 634,
  originalWidth: 1164
}

/**
 * ![1 - Whole Home Protection - Outdoor and Indoor Cameras](https://images.ctfassets.net/v6awd0kabi65/6lTvle31Jc5ggM2pjh8Ckn/2ebf92cbcefa0bc91d4d380e356dcf80/indoor-outdoor-cameras.png?w=120&h=120&fit=pad)
 *
 * 1 - Whole Home Protection - Outdoor and Indoor Cameras
 *
 * Outdoor and Indoor Cameras
 */
export const IMG_6lTvle31Jc5ggM2pjh8Ckn = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6lTvle31Jc5ggM2pjh8Ckn/2ebf92cbcefa0bc91d4d380e356dcf80/indoor-outdoor-cameras.png',
  description: `Outdoor and Indoor Cameras`,
  originalHeight: 634,
  originalWidth: 1164
}

/**
 * ![Hero Banner - Homepage - Tablet](https://images.ctfassets.net/v6awd0kabi65/6hTnZAVTL5ztDUfO3ty7ij/7e3a0ec3e8eac4eb37cce10c6d33ac8c/hero_tablet_old_camera.png?w=120&h=120&fit=pad)
 *
 * Hero Banner - Homepage - Tablet
 *
 * Whole Home Protection
 */
export const IMG_6hTnZAVTL5ztDUfO3ty7ij = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6hTnZAVTL5ztDUfO3ty7ij/7e3a0ec3e8eac4eb37cce10c6d33ac8c/hero_tablet_old_camera.png',
  description: `Whole Home Protection`,
  originalHeight: 1200,
  originalWidth: 2173
}

/**
 * ![0 - Whole Home Protection - Outdoor and Indoor Cameras (Pre-launch)](https://images.ctfassets.net/v6awd0kabi65/5CgNRcD9JZa4hI8bZMhV7A/66334557d87837afbd16378c3c38a269/indoor-outdoor-prelaunch.png?w=120&h=120&fit=pad)
 *
 * 0 - Whole Home Protection - Outdoor and Indoor Cameras (Pre-launch)
 *
 * Outdoor and Indoor Cameras
 */
export const IMG_5CgNRcD9JZa4hI8bZMhV7A = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5CgNRcD9JZa4hI8bZMhV7A/66334557d87837afbd16378c3c38a269/indoor-outdoor-prelaunch.png',
  description: `Outdoor and Indoor Cameras`,
  originalHeight: 634,
  originalWidth: 1164
}

/**
 * ![Hero Banner - Homepage - Mobile](https://images.ctfassets.net/v6awd0kabi65/4xpsnLBp3uKWqWuHnIc5a5/b44afb7f85c702da0a3106ff546dcfa2/Hero_Mobile.png?w=120&h=120&fit=pad)
 *
 * Hero Banner - Homepage - Mobile
 *
 * Whole Home Protection
 */
export const IMG_4xpsnLBp3uKWqWuHnIc5a5 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4xpsnLBp3uKWqWuHnIc5a5/b44afb7f85c702da0a3106ff546dcfa2/Hero_Mobile.png',
  description: `Whole Home Protection`,
  originalHeight: 424,
  originalWidth: 768
}

/**
 * ![4 - Whole Home Protection - Doorbell and Smart Lock](https://images.ctfassets.net/v6awd0kabi65/4PodeoLoMBwfw7NiY7xs6v/d37880f60b77c157d99d71dd2160ea1e/video-doorbell-smart-lock.png?w=120&h=120&fit=pad)
 *
 * 4 - Whole Home Protection - Doorbell and Smart Lock
 *
 * Doorbell and Smart Lock
 */
export const IMG_4PodeoLoMBwfw7NiY7xs6v = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4PodeoLoMBwfw7NiY7xs6v/d37880f60b77c157d99d71dd2160ea1e/video-doorbell-smart-lock.png',
  description: `Doorbell and Smart Lock`,
  originalHeight: 634,
  originalWidth: 1164
}

/**
 * ![Real time agents](https://images.ctfassets.net/v6awd0kabi65/485NQEr4JUie3FE2IIlZ7B/1e97e3549a5e54728a1bf00595e63e35/image_143_3x.png?w=120&h=120&fit=pad)
 *
 * Real time agents
 *
 * See intruders. Speak to them
 */
export const IMG_485NQEr4JUie3FE2IIlZ7B = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/485NQEr4JUie3FE2IIlZ7B/1e97e3549a5e54728a1bf00595e63e35/image_143_3x.png',
  description: `See intruders. Speak to them`,
  originalHeight: 294,
  originalWidth: 543
}

/**
 * ![Wireless Indoor Camera (Background)](https://images.ctfassets.net/v6awd0kabi65/3uB4kYgtZwn1hg1eHpQcNU/fc29078e4b22b0474ad6cc1f472306bf/Wireless_Indoor.png?w=120&h=120&fit=pad)
 *
 * Wireless Indoor Camera (Background)
 *
 *
 */
export const IMG_3uB4kYgtZwn1hg1eHpQcNU = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3uB4kYgtZwn1hg1eHpQcNU/fc29078e4b22b0474ad6cc1f472306bf/Wireless_Indoor.png',
  description: ``,
  originalHeight: 1224,
  originalWidth: 936
}

/**
 * ![7.5W Power Adapter for Wireless Indoor Camera Image](https://images.ctfassets.net/v6awd0kabi65/2TLXaauirhnG8baE70yNTy/0caef16f9bfe9ae6d453a17fc4dfa376/7.5w_power_adapter.jpg?w=120&h=120&fit=pad)
 *
 * 7.5W Power Adapter for Wireless Indoor Camera Image
 *
 *
 */
export const IMG_2TLXaauirhnG8baE70yNTy = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2TLXaauirhnG8baE70yNTy/0caef16f9bfe9ae6d453a17fc4dfa376/7.5w_power_adapter.jpg',
  description: ``,
  originalHeight: 320,
  originalWidth: 320
}

/**
 * ![Hero Banner - Homepage - Desktop](https://images.ctfassets.net/v6awd0kabi65/2cQqcEjIhWfDnqZ7t3mANq/bd6c9117df17fb8f61a10f6da951551e/Hero_desktop_old_camera.png?w=120&h=120&fit=pad)
 *
 * Hero Banner - Homepage - Desktop
 *
 * Whole Home Protection
 */
export const IMG_2cQqcEjIhWfDnqZ7t3mANq = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2cQqcEjIhWfDnqZ7t3mANq/bd6c9117df17fb8f61a10f6da951551e/Hero_desktop_old_camera.png',
  description: `Whole Home Protection`,
  originalHeight: 1200,
  originalWidth: 2400
}

/**
 * ![New app feature: Scheduled Arming has landed!](https://images.ctfassets.net/v6awd0kabi65/ptDG0z8i30S75LXvxfQrO/4ebfaf65c5cc1bca1982052fb26553d2/scheduled_arming.png?w=120&h=120&fit=pad)
 *
 * New app feature: Scheduled Arming has landed!
 *
 *
 */
export const IMG_ptDG0z8i30S75LXvxfQrO = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/ptDG0z8i30S75LXvxfQrO/4ebfaf65c5cc1bca1982052fb26553d2/scheduled_arming.png',
  description: ``,
  originalHeight: 898,
  originalWidth: 413
}

/**
 * ![Wifi-extender-background](https://images.ctfassets.net/v6awd0kabi65/2AXfYwYi6TcoGqlw7gJkBn/f92268f289bd3ed251ee5a1e5c72e957/wi-fi-extender-background.png?w=120&h=120&fit=pad)
 *
 * Wifi-extender-background
 *
 *
 */
export const IMG_2AXfYwYi6TcoGqlw7gJkBn = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2AXfYwYi6TcoGqlw7gJkBn/f92268f289bd3ed251ee5a1e5c72e957/wi-fi-extender-background.png',
  description: ``,
  originalHeight: 398,
  originalWidth: 604
}

/**
 * ![Wifi-extender](https://images.ctfassets.net/v6awd0kabi65/76kvKoUTcClbotKJgj9mKB/591bc868b7a41ec9ee4b2ec9dd4acd54/wi-fi-extender.png?w=120&h=120&fit=pad)
 *
 * Wifi-extender
 *
 *
 */
export const IMG_76kvKoUTcClbotKJgj9mKB = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/76kvKoUTcClbotKJgj9mKB/591bc868b7a41ec9ee4b2ec9dd4acd54/wi-fi-extender.png',
  description: ``,
  originalHeight: 1087,
  originalWidth: 1001
}

/**
 * ![Extra Entry Magnet](https://images.ctfassets.net/v6awd0kabi65/3IRJQKzgYiuu8fcHCOcRWA/b7d67cbc18224ddae0897e9b162777a5/entry_transparent_1__1_.png?w=120&h=120&fit=pad)
 *
 * Extra Entry Magnet
 *
 *
 */
export const IMG_3IRJQKzgYiuu8fcHCOcRWA = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3IRJQKzgYiuu8fcHCOcRWA/b7d67cbc18224ddae0897e9b162777a5/entry_transparent_1__1_.png',
  description: ``,
  originalHeight: 427,
  originalWidth: 171
}

/**
 * ![Outdoor Kit (for the Indoor Cam)](https://images.ctfassets.net/v6awd0kabi65/c7GSNhBORUGB9mJMxmM81/3dbe6ce5e84698a91e1cdfe95d29ef52/entry_transparent_1.png?w=120&h=120&fit=pad)
 *
 * Outdoor Kit (for the Indoor Cam)
 *
 *
 */
export const IMG_c7GSNhBORUGB9mJMxmM81 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/c7GSNhBORUGB9mJMxmM81/3dbe6ce5e84698a91e1cdfe95d29ef52/entry_transparent_1.png',
  description: ``,
  originalHeight: 346,
  originalWidth: 369
}

/**
 * ![wi-fi-extender](https://images.ctfassets.net/v6awd0kabi65/4hoaDzfgpMQ3ZMwlYosj2h/f49692284763c8201ead823a6fdbe7ff/wi-fi-extender.png?w=120&h=120&fit=pad)
 *
 * wi-fi-extender
 *
 *
 */
export const IMG_4hoaDzfgpMQ3ZMwlYosj2h = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4hoaDzfgpMQ3ZMwlYosj2h/f49692284763c8201ead823a6fdbe7ff/wi-fi-extender.png',
  description: ``,
  originalHeight: 1087,
  originalWidth: 1001
}

/**
 * ![What is a temperature sensor and why do I need one?](https://images.ctfassets.net/v6awd0kabi65/7oEr3nemJEzP8WsE1GmjHt/d6d689089e998c1e4823b74f66b5d6e9/Temperature.jpeg?w=120&h=120&fit=pad)
 *
 * What is a temperature sensor and why do I need one?
 *
 *
 */
export const IMG_7oEr3nemJEzP8WsE1GmjHt = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7oEr3nemJEzP8WsE1GmjHt/d6d689089e998c1e4823b74f66b5d6e9/Temperature.jpeg',
  description: ``,
  originalHeight: 1003,
  originalWidth: 1800
}

/**
 * ![img - A Guide to Pet-Friendly Home Security](https://images.ctfassets.net/v6awd0kabi65/7EawJ6QTMEZA7Kc7Y4QMEa/546afa42ebb325cec510ded6eff4babe/jamie-street-s9Tf1eBDFqw-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * img - A Guide to Pet-Friendly Home Security
 *
 *
 */
export const IMG_7EawJ6QTMEZA7Kc7Y4QMEa = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7EawJ6QTMEZA7Kc7Y4QMEa/546afa42ebb325cec510ded6eff4babe/jamie-street-s9Tf1eBDFqw-unsplash.jpg',
  description: ``,
  originalHeight: 3843,
  originalWidth: 5124
}

/**
 * ![ 6 holiday scams to be aware of this summer](https://images.ctfassets.net/v6awd0kabi65/6EnaOf1kdy97Idir1JcsLe/21d044aff9aa680093659e4a87c460a7/pexels-sora-shimazaki-5935787.jpg?w=120&h=120&fit=pad)
 *
 *  6 holiday scams to be aware of this summer
 *
 *
 */
export const IMG_6EnaOf1kdy97Idir1JcsLe = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6EnaOf1kdy97Idir1JcsLe/21d044aff9aa680093659e4a87c460a7/pexels-sora-shimazaki-5935787.jpg',
  description: ``,
  originalHeight: 4000,
  originalWidth: 6000
}

/**
 * ![11 essential tips to keep your holiday home safe](https://images.ctfassets.net/v6awd0kabi65/71QLrlzPumwadD6SscqMWk/35c54233bdfeab879c5fbeac5bfecee7/Untitled_design-5.png?w=120&h=120&fit=pad)
 *
 * 11 essential tips to keep your holiday home safe
 *
 * Own a holiday home that you rent out to guests? Follow our holiday home security tips to keep your home and guests safe whilst they’re on their travels.
 */
export const IMG_71QLrlzPumwadD6SscqMWk = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/71QLrlzPumwadD6SscqMWk/35c54233bdfeab879c5fbeac5bfecee7/Untitled_design-5.png',
  description: `Own a holiday home that you rent out to guests? Follow our holiday home security tips to keep your home and guests safe whilst they’re on their travels.`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Top tips for hiding valuables at home](https://images.ctfassets.net/v6awd0kabi65/50X9SPSfIVLpd8r2n9PU1X/87fbed9855c802346be7ee59b73ec310/Untitled_design-4.png?w=120&h=120&fit=pad)
 *
 * Top tips for hiding valuables at home
 *
 *
 */
export const IMG_50X9SPSfIVLpd8r2n9PU1X = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/50X9SPSfIVLpd8r2n9PU1X/87fbed9855c802346be7ee59b73ec310/Untitled_design-4.png',
  description: ``,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Mothers_Day_Give_Away](https://images.ctfassets.net/v6awd0kabi65/1ZwKavxzg4AvigOhtUAtgG/b86c2f65f4e5b779f8ebc8eff9cdd5c2/Screenshot_2023-05-04_at_12.11.59_AM.png?w=120&h=120&fit=pad)
 *
 * Mothers_Day_Give_Away
 *
 * Mothers_Day_Give_Away
 */
export const IMG_1ZwKavxzg4AvigOhtUAtgG = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1ZwKavxzg4AvigOhtUAtgG/b86c2f65f4e5b779f8ebc8eff9cdd5c2/Screenshot_2023-05-04_at_12.11.59_AM.png',
  description: `Mothers_Day_Give_Away`,
  originalHeight: 1063,
  originalWidth: 798
}

/**
 * ![Crystal Caligiuri - Chief Customer Experience Officer](https://images.ctfassets.net/v6awd0kabi65/FwYLdCJDYbgWwI7ESQuQT/a1f1922dcc2051db560b373845c9c3e2/image__35_.png?w=120&h=120&fit=pad)
 *
 * Crystal Caligiuri - Chief Customer Experience Officer
 *
 * Crystal Caligiuri - Chief Customer Experience Officer
 */
export const IMG_FwYLdCJDYbgWwI7ESQuQT = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/FwYLdCJDYbgWwI7ESQuQT/a1f1922dcc2051db560b373845c9c3e2/image__35_.png',
  description: `Crystal Caligiuri - Chief Customer Experience Officer`,
  originalHeight: 1032,
  originalWidth: 1032
}

/**
 * ![Sundas Pasha Fick Headshot](https://images.ctfassets.net/v6awd0kabi65/2iS5FQkF8hPmyMb7wM4hqJ/678de6ea0a34a736add369df135e70ca/Sundas_Pasha_Fick_Headshot.jpg?w=120&h=120&fit=pad)
 *
 * Sundas Pasha Fick Headshot
 *
 * Sundas Pasha Fick Headshot
 */
export const IMG_2iS5FQkF8hPmyMb7wM4hqJ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2iS5FQkF8hPmyMb7wM4hqJ/678de6ea0a34a736add369df135e70ca/Sundas_Pasha_Fick_Headshot.jpg',
  description: `Sundas Pasha Fick Headshot`,
  originalHeight: 1239,
  originalWidth: 1399
}

/**
 * ![Simplicam_on_mantel](https://images.ctfassets.net/v6awd0kabi65/2BbDUeYhM0SLnyEbT0vHVw/3825445457fa9e110ac22d77fe187720/Simplicam_On_Mantel_Family_0834_F_8bit.jpg?w=120&h=120&fit=pad)
 *
 * Simplicam_on_mantel
 *
 * Simplicam_on_mantel
 */
export const IMG_2BbDUeYhM0SLnyEbT0vHVw = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2BbDUeYhM0SLnyEbT0vHVw/3825445457fa9e110ac22d77fe187720/Simplicam_On_Mantel_Family_0834_F_8bit.jpg',
  description: `Simplicam_on_mantel`,
  originalHeight: 3824,
  originalWidth: 5734
}

/**
 * ![The ultimate home security spring cleaning guide](https://images.ctfassets.net/v6awd0kabi65/1OaMoT6yVvr2J6PhMgmFsH/ce550669ce272229ce96092553847de3/maarten-deckers-0-frPETzEVs-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * The ultimate home security spring cleaning guide
 *
 * Doing a spring clean? Spring clean your home with our spring cleaning safety tips to keep your home safe and secure.
 */
export const IMG_1OaMoT6yVvr2J6PhMgmFsH = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1OaMoT6yVvr2J6PhMgmFsH/ce550669ce272229ce96092553847de3/maarten-deckers-0-frPETzEVs-unsplash.jpg',
  description: `Doing a spring clean? Spring clean your home with our spring cleaning safety tips to keep your home safe and secure.`,
  originalHeight: 3000,
  originalWidth: 4500
}

/**
 * ![img - Security Benefits of Glass Break Sensors](https://images.ctfassets.net/v6awd0kabi65/3q9JzFpwVsE5SY3HzFMb2P/7902223c912e47f9cee637d94a1bf4df/7.jpg?w=120&h=120&fit=pad)
 *
 * img - Security Benefits of Glass Break Sensors
 *
 *
 */
export const IMG_3q9JzFpwVsE5SY3HzFMb2P = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3q9JzFpwVsE5SY3HzFMb2P/7902223c912e47f9cee637d94a1bf4df/7.jpg',
  description: ``,
  originalHeight: 341,
  originalWidth: 512
}

/**
 * ![img - How Outdoor Video Cameras Work:  Day Vs. Night](https://images.ctfassets.net/v6awd0kabi65/37hFQlP4gZVVZEOEoXjsbK/acc284dcbab6c6181d3b2451913f87a8/5.jpg?w=120&h=120&fit=pad)
 *
 * img - How Outdoor Video Cameras Work:  Day Vs. Night
 *
 *
 */
export const IMG_37hFQlP4gZVVZEOEoXjsbK = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/37hFQlP4gZVVZEOEoXjsbK/acc284dcbab6c6181d3b2451913f87a8/5.jpg',
  description: ``,
  originalHeight: 341,
  originalWidth: 512
}

/**
 * ![img - Video Doorbell Installation Basics: 101](https://images.ctfassets.net/v6awd0kabi65/4E7kI1B62Bucwm3MtFJlzS/4ac83004bab4cf6363071ec4d1b392cd/4.jpg?w=120&h=120&fit=pad)
 *
 * img - Video Doorbell Installation Basics: 101
 *
 *
 */
export const IMG_4E7kI1B62Bucwm3MtFJlzS = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4E7kI1B62Bucwm3MtFJlzS/4ac83004bab4cf6363071ec4d1b392cd/4.jpg',
  description: ``,
  originalHeight: 341,
  originalWidth: 512
}

/**
 * ![img - How to Secure Basement Windows](https://images.ctfassets.net/v6awd0kabi65/3qNKz6Cne4Gm1Lv7VZgqi7/546987e8c7658bb6d464157c82932e7b/3.jpg?w=120&h=120&fit=pad)
 *
 * img - How to Secure Basement Windows
 *
 *
 */
export const IMG_3qNKz6Cne4Gm1Lv7VZgqi7 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3qNKz6Cne4Gm1Lv7VZgqi7/546987e8c7658bb6d464157c82932e7b/3.jpg',
  description: ``,
  originalHeight: 341,
  originalWidth: 512
}

/**
 * ![Does a Home Security System Reduce Your Insurance Costs?](https://images.ctfassets.net/v6awd0kabi65/4D3n2QgoUQRixwB0bKxull/4f3df0aaffc18352ea5ebfb97265552d/2.jpg?w=120&h=120&fit=pad)
 *
 * Does a Home Security System Reduce Your Insurance Costs?
 *
 *
 */
export const IMG_4D3n2QgoUQRixwB0bKxull = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4D3n2QgoUQRixwB0bKxull/4f3df0aaffc18352ea5ebfb97265552d/2.jpg',
  description: ``,
  originalHeight: 385,
  originalWidth: 512
}

/**
 * ![How to install and maintain smoke detectors](https://images.ctfassets.net/v6awd0kabi65/2s6OfqrZ4skOk4J9EFlXGS/a9ec7e3dd4e26f811e72af9370f3e42c/__DSC0759__1_.jpg?w=120&h=120&fit=pad)
 *
 * How to install and maintain smoke detectors
 *
 *
 */
export const IMG_2s6OfqrZ4skOk4J9EFlXGS = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2s6OfqrZ4skOk4J9EFlXGS/a9ec7e3dd4e26f811e72af9370f3e42c/__DSC0759__1_.jpg',
  description: ``,
  originalHeight: 563,
  originalWidth: 1000
}

/**
 * ![How to Burglar Proof Your Windows](https://images.ctfassets.net/v6awd0kabi65/6XFCjy6UlERxmkEwwYXGi5/fdc4f8cda84730a8d1e02e856fcf6908/how-to-burglar-proof-your-windows.png?w=120&h=120&fit=pad)
 *
 * How to Burglar Proof Your Windows
 *
 *
 */
export const IMG_6XFCjy6UlERxmkEwwYXGi5 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6XFCjy6UlERxmkEwwYXGi5/fdc4f8cda84730a8d1e02e856fcf6908/how-to-burglar-proof-your-windows.png',
  description: ``,
  originalHeight: 340,
  originalWidth: 512
}

/**
 * ![What are the Benefits of a Smart Smoke Detector?](https://images.ctfassets.net/v6awd0kabi65/2X2kkq9SOIvi8wpAemekgY/b7bc62b2051ffdcf5cfccbbe18eda7b2/benefits-of-a-smart-smoke-detector.png?w=120&h=120&fit=pad)
 *
 * What are the Benefits of a Smart Smoke Detector?
 *
 *
 */
export const IMG_2X2kkq9SOIvi8wpAemekgY = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2X2kkq9SOIvi8wpAemekgY/b7bc62b2051ffdcf5cfccbbe18eda7b2/benefits-of-a-smart-smoke-detector.png',
  description: ``,
  originalHeight: 376,
  originalWidth: 512
}

/**
 * ![Blog - How to Choose a Smart Door Lock](https://images.ctfassets.net/v6awd0kabi65/1bmXnGAduWSUmEjAl5fGSa/4a0997ee945ff3f4fc550ad3c5d81120/how-to-choose-a-smart-door-lock.png?w=120&h=120&fit=pad)
 *
 * Blog - How to Choose a Smart Door Lock
 *
 *
 */
export const IMG_1bmXnGAduWSUmEjAl5fGSa = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1bmXnGAduWSUmEjAl5fGSa/4a0997ee945ff3f4fc550ad3c5d81120/how-to-choose-a-smart-door-lock.png',
  description: ``,
  originalHeight: 302,
  originalWidth: 512
}

/**
 * ![What to Know About Wireless Home Security Systems](https://images.ctfassets.net/v6awd0kabi65/55NUSIUzvydd6ZyQiJiOjF/d89bc1552e52e017b196bd3aefb33563/blog-preview-3.png?w=120&h=120&fit=pad)
 *
 * What to Know About Wireless Home Security Systems
 *
 *
 */
export const IMG_55NUSIUzvydd6ZyQiJiOjF = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/55NUSIUzvydd6ZyQiJiOjF/d89bc1552e52e017b196bd3aefb33563/blog-preview-3.png',
  description: ``,
  originalHeight: 341,
  originalWidth: 512
}

/**
 * ![The Benefits of Installing a Wireless Home Security System](https://images.ctfassets.net/v6awd0kabi65/3l3BIX8uwJBIDl3bx0CS0y/06c9f5dd004b41b79d41b8c1a64980c0/preview-blog-1.jpeg?w=120&h=120&fit=pad)
 *
 * The Benefits of Installing a Wireless Home Security System
 *
 *
 */
export const IMG_3l3BIX8uwJBIDl3bx0CS0y = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3l3BIX8uwJBIDl3bx0CS0y/06c9f5dd004b41b79d41b8c1a64980c0/preview-blog-1.jpeg',
  description: ``,
  originalHeight: 384,
  originalWidth: 512
}

/**
 * ![Why You Should Invest in a Home Security System](https://images.ctfassets.net/v6awd0kabi65/PX7VqHrrhcNy2Iklbd0B4/3399a153ca4aafa08cf1ffe68c2185b9/blog-preview-2.jpeg?w=120&h=120&fit=pad)
 *
 * Why You Should Invest in a Home Security System
 *
 *
 */
export const IMG_PX7VqHrrhcNy2Iklbd0B4 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/PX7VqHrrhcNy2Iklbd0B4/3399a153ca4aafa08cf1ffe68c2185b9/blog-preview-2.jpeg',
  description: ``,
  originalHeight: 288,
  originalWidth: 512
}

/**
 * ![What is a Bell Box? And why do you need one?](https://images.ctfassets.net/v6awd0kabi65/vgGDNdtvsy5nB7lIygvHa/bf837da77b802d199354d91ae63496d6/unnamed__1_.png?w=120&h=120&fit=pad)
 *
 * What is a Bell Box? And why do you need one?
 *
 *
 */
export const IMG_vgGDNdtvsy5nB7lIygvHa = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/vgGDNdtvsy5nB7lIygvHa/bf837da77b802d199354d91ae63496d6/unnamed__1_.png',
  description: ``,
  originalHeight: 416,
  originalWidth: 512
}

/**
 * ![What is a Bell Box? And why do you need one?](https://images.ctfassets.net/v6awd0kabi65/1U2Nkas2eRXlvg3GJRyvbV/50fd7f89cf1308e36977a3ceac12fefc/unnamed__1_.png?w=120&h=120&fit=pad)
 *
 * What is a Bell Box? And why do you need one?
 *
 *
 */
export const IMG_1U2Nkas2eRXlvg3GJRyvbV = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1U2Nkas2eRXlvg3GJRyvbV/50fd7f89cf1308e36977a3ceac12fefc/unnamed__1_.png',
  description: ``,
  originalHeight: 390,
  originalWidth: 480
}

/**
 * ![Android snooze straight](https://images.ctfassets.net/v6awd0kabi65/4acRFfnPTdoZLDV0HHrT8F/e8a4ab270b78bd526bf84475597e9e85/Android_snooze_straight.jpg?w=120&h=120&fit=pad)
 *
 * Android snooze straight
 *
 *
 */
export const IMG_4acRFfnPTdoZLDV0HHrT8F = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4acRFfnPTdoZLDV0HHrT8F/e8a4ab270b78bd526bf84475597e9e85/Android_snooze_straight.jpg',
  description: ``,
  originalHeight: 2400,
  originalWidth: 3200
}

/**
 * ![iPhone snooze straight](https://images.ctfassets.net/v6awd0kabi65/3wQypfx9Tv5fJHeMN8bEPM/5f0ebfce20939b75065fcbb642c47972/iPhone_snooze_straight.jpg?w=120&h=120&fit=pad)
 *
 * iPhone snooze straight
 *
 *
 */
export const IMG_3wQypfx9Tv5fJHeMN8bEPM = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3wQypfx9Tv5fJHeMN8bEPM/5f0ebfce20939b75065fcbb642c47972/iPhone_snooze_straight.jpg',
  description: ``,
  originalHeight: 2400,
  originalWidth: 3200
}

/**
 * ![2023 Trend Report Under One Roof](https://images.ctfassets.net/v6awd0kabi65/2jGc4tqeSn0erqF28GZWve/6cd96e545e94a118db20b916b8669cab/2023_Trend_Report.jpg?w=120&h=120&fit=pad)
 *
 * 2023 Trend Report Under One Roof
 *
 *
 */
export const IMG_2jGc4tqeSn0erqF28GZWve = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2jGc4tqeSn0erqF28GZWve/6cd96e545e94a118db20b916b8669cab/2023_Trend_Report.jpg',
  description: ``,
  originalHeight: 1152,
  originalWidth: 1152
}

/**
 * ![Home security for the hybrid worker](https://images.ctfassets.net/v6awd0kabi65/6AQoKmARvvW1oAk89OhQ2Y/81046fbdfc71f856a8c1950b6ceaa615/domenico-loia-hGV2TfOh0ns-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * Home security for the hybrid worker
 *
 *
 */
export const IMG_6AQoKmARvvW1oAk89OhQ2Y = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6AQoKmARvvW1oAk89OhQ2Y/81046fbdfc71f856a8c1950b6ceaa615/domenico-loia-hGV2TfOh0ns-unsplash.jpg',
  description: ``,
  originalHeight: 3899,
  originalWidth: 5848
}

/**
 * ![Ground floor flat security tips](https://images.ctfassets.net/v6awd0kabi65/76bmE7OiBNVVo7PGEBHjpo/a7364a6148e06e9f35e9ef46b7bbe2ba/sergio-rola-rpnL45a3-m8-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * Ground floor flat security tips
 *
 *
 */
export const IMG_76bmE7OiBNVVo7PGEBHjpo = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/76bmE7OiBNVVo7PGEBHjpo/a7364a6148e06e9f35e9ef46b7bbe2ba/sergio-rola-rpnL45a3-m8-unsplash.jpg',
  description: ``,
  originalHeight: 2307,
  originalWidth: 4184
}

/**
 * ![How to prevent your home from flooding](https://images.ctfassets.net/v6awd0kabi65/1YDLdIUCu8HH02lHi4vFvF/b9c508571aa68a4b44b4aa0ccc821524/Water_Sensor_0461_F_8bit.jpeg?w=120&h=120&fit=pad)
 *
 * How to prevent your home from flooding
 *
 *
 */
export const IMG_1YDLdIUCu8HH02lHi4vFvF = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1YDLdIUCu8HH02lHi4vFvF/b9c508571aa68a4b44b4aa0ccc821524/Water_Sensor_0461_F_8bit.jpeg',
  description: ``,
  originalHeight: 2201,
  originalWidth: 3300
}

/**
 * ![What's the difference between robbery & burglary?](https://images.ctfassets.net/v6awd0kabi65/2yzud22TfPgKS2uNuQA53d/1403ca9a6336d4f2f800a89f4e1e1e5a/Spring_Product_Refresh_2022_-_Outdoor_-_Shield_Camera_at_Night.jpeg?w=120&h=120&fit=pad)
 *
 * What's the difference between robbery & burglary?
 *
 *
 */
export const IMG_2yzud22TfPgKS2uNuQA53d = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2yzud22TfPgKS2uNuQA53d/1403ca9a6336d4f2f800a89f4e1e1e5a/Spring_Product_Refresh_2022_-_Outdoor_-_Shield_Camera_at_Night.jpeg',
  description: ``,
  originalHeight: 2250,
  originalWidth: 3000
}

/**
 * ![A complete guide to contact sensors](https://images.ctfassets.net/v6awd0kabi65/69jqTXrEz9Xeyg55c0EYBM/7c43fc49a33067fb1a1c9ccf4ab0b9a0/8C8A0907.jpg?w=120&h=120&fit=pad)
 *
 * A complete guide to contact sensors
 *
 * What are contact sensors? How do they work? And where should you install them? SimpliSafe shares all in their complete guide.
 */
export const IMG_69jqTXrEz9Xeyg55c0EYBM = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/69jqTXrEz9Xeyg55c0EYBM/7c43fc49a33067fb1a1c9ccf4ab0b9a0/8C8A0907.jpg',
  description: `What are contact sensors? How do they work? And where should you install them? SimpliSafe shares all in their complete guide. `,
  originalHeight: 1575,
  originalWidth: 2800
}

/**
 * ![A guide to porch light security](https://images.ctfassets.net/v6awd0kabi65/5OnVtLbzgSSUu4ZRqikH3Y/759b8c704c7c209e20a602e262d274df/francesca-tosolini-XcVm8mn7NUM-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * A guide to porch light security
 *
 * Keep the entrance to your home safe and protected with SimpliSafe’s comprehensive guide to porch light security.
 */
export const IMG_5OnVtLbzgSSUu4ZRqikH3Y = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5OnVtLbzgSSUu4ZRqikH3Y/759b8c704c7c209e20a602e262d274df/francesca-tosolini-XcVm8mn7NUM-unsplash.jpg',
  description: `Keep the entrance to your home safe and protected with SimpliSafe’s comprehensive guide to porch light security. `,
  originalHeight: 3297,
  originalWidth: 4945
}

/**
 * ![What to teach your children about home safety](https://images.ctfassets.net/v6awd0kabi65/5DMD50lKUA7KjxVWSTWfwe/4fd8c79e238006d67c278001ede0be73/jimmy-dean-Qngdf0kgGB4-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * What to teach your children about home safety
 *
 *
 */
export const IMG_5DMD50lKUA7KjxVWSTWfwe = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5DMD50lKUA7KjxVWSTWfwe/4fd8c79e238006d67c278001ede0be73/jimmy-dean-Qngdf0kgGB4-unsplash.jpg',
  description: ``,
  originalHeight: 4144,
  originalWidth: 6196
}

/**
 * ![How to prevent a house fire](https://images.ctfassets.net/v6awd0kabi65/6pBqn8N09r4o4cl8E9KSdn/32132f89ea397d55a38adcf9d72dfc6b/unnamed.jpeg?w=120&h=120&fit=pad)
 *
 * How to prevent a house fire
 *
 *
 */
export const IMG_6pBqn8N09r4o4cl8E9KSdn = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6pBqn8N09r4o4cl8E9KSdn/32132f89ea397d55a38adcf9d72dfc6b/unnamed.jpeg',
  description: ``,
  originalHeight: 1003,
  originalWidth: 1600
}

/**
 * ![The best ways to protect your Black Friday buys](https://images.ctfassets.net/v6awd0kabi65/5j4AUOAWXs8afFBIhEPBZ2/daa677858c3e5d2fd66bbf6512c1d6bd/unnamed.jpeg?w=120&h=120&fit=pad)
 *
 * The best ways to protect your Black Friday buys
 *
 *
 */
export const IMG_5j4AUOAWXs8afFBIhEPBZ2 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5j4AUOAWXs8afFBIhEPBZ2/daa677858c3e5d2fd66bbf6512c1d6bd/unnamed.jpeg',
  description: ``,
  originalHeight: 1066,
  originalWidth: 1600
}

/**
 * ![How to protect your home when it’s for sale](https://images.ctfassets.net/v6awd0kabi65/2nFm3Xh1cVdooyekX4ukVK/f697606a78ead6c17552d45fa7796aae/unnamed.jpeg?w=120&h=120&fit=pad)
 *
 * How to protect your home when it’s for sale
 *
 *
 */
export const IMG_2nFm3Xh1cVdooyekX4ukVK = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2nFm3Xh1cVdooyekX4ukVK/f697606a78ead6c17552d45fa7796aae/unnamed.jpeg',
  description: ``,
  originalHeight: 1068,
  originalWidth: 1600
}

/**
 * ![Preventing fire damage in the home](https://images.ctfassets.net/v6awd0kabi65/5bFXqnRzHzL5pHM8I6pVBg/5d4225d7bf6d490e938e95071d08b918/680x600_smoke_ss2.webp?w=120&h=120&fit=pad)
 *
 * Preventing fire damage in the home
 *
 *
 */
export const IMG_5bFXqnRzHzL5pHM8I6pVBg = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5bFXqnRzHzL5pHM8I6pVBg/5d4225d7bf6d490e938e95071d08b918/680x600_smoke_ss2.webp',
  description: ``,
  originalHeight: 529,
  originalWidth: 600
}

/**
 * ![How to protect yourself from phishing emails](https://images.ctfassets.net/v6awd0kabi65/3aX807Z1SEc6z2amOliJs/760ec0219d6880fedefff6004df32706/unnamed.jpeg?w=120&h=120&fit=pad)
 *
 * How to protect yourself from phishing emails
 *
 *
 */
export const IMG_3aX807Z1SEc6z2amOliJs = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3aX807Z1SEc6z2amOliJs/760ec0219d6880fedefff6004df32706/unnamed.jpeg',
  description: ``,
  originalHeight: 1200,
  originalWidth: 1600
}

/**
 * ![How to protect your home if it’s on Airbnb](https://images.ctfassets.net/v6awd0kabi65/3FhGf1IgbU07oBfwFNmkkq/c933312b1cbe9dfb64dcc5e51ce05361/eilis-garvey-htIxmylBznU-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * How to protect your home if it’s on Airbnb
 *
 * Planning on putting your home on Airbnb? Ensure total protection of your belongings and property with the help of SimpliSafe.
 */
export const IMG_3FhGf1IgbU07oBfwFNmkkq = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3FhGf1IgbU07oBfwFNmkkq/c933312b1cbe9dfb64dcc5e51ce05361/eilis-garvey-htIxmylBznU-unsplash.jpg',
  description: `Planning on putting your home on Airbnb? Ensure total protection of your belongings and property with the help of SimpliSafe. `,
  originalHeight: 2658,
  originalWidth: 4000
}

/**
 * ![How to stay safe on dark nights](https://images.ctfassets.net/v6awd0kabi65/7kansL0XD16SklzXCOYF4k/09945b5bbc2ed16dc6aa8e1eb826a5d4/johannes-roth-gSkOR3a47JM-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * How to stay safe on dark nights
 *
 * Protect yourself and your home, especially when the sun goes down, with SimpliSafe’s top tips for staying safe on dark nights.
 */
export const IMG_7kansL0XD16SklzXCOYF4k = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7kansL0XD16SklzXCOYF4k/09945b5bbc2ed16dc6aa8e1eb826a5d4/johannes-roth-gSkOR3a47JM-unsplash.jpg',
  description: `Protect yourself and your home, especially when the sun goes down, with SimpliSafe’s top tips for staying safe on dark nights. `,
  originalHeight: 3992,
  originalWidth: 5976
}

/**
 * ![How to avoid common scams](https://images.ctfassets.net/v6awd0kabi65/6FRmdOu0iXTO1jG1GLm25H/68898b2aa07903ec474798205b093d00/unnamed.jpeg?w=120&h=120&fit=pad)
 *
 * How to avoid common scams
 *
 *
 */
export const IMG_6FRmdOu0iXTO1jG1GLm25H = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6FRmdOu0iXTO1jG1GLm25H/68898b2aa07903ec474798205b093d00/unnamed.jpeg',
  description: ``,
  originalHeight: 1143,
  originalWidth: 1600
}

/**
 * ![Four must-have home security gadgets you need](https://images.ctfassets.net/v6awd0kabi65/730rybzHFONr3h5UbILlQU/e2328bdf634f4f06aa45dcfc3ad92c80/Hero_Eve_Fam_png.png?w=120&h=120&fit=pad)
 *
 * Four must-have home security gadgets you need
 *
 * Wanting to improve your home’s security? Here are some new home security gadgets you need to add to your wishlist.
 */
export const IMG_730rybzHFONr3h5UbILlQU = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/730rybzHFONr3h5UbILlQU/e2328bdf634f4f06aa45dcfc3ad92c80/Hero_Eve_Fam_png.png',
  description: `Wanting to improve your home’s security? Here are some new home security gadgets you need to add to your wishlist. `,
  originalHeight: 1013,
  originalWidth: 1350
}

/**
 * ![5 important smartphone safety tips](https://images.ctfassets.net/v6awd0kabi65/2Jr4m9tPXb4rMxwOjMcfhb/7842d30e4e83235aafc441556f35b501/unnamed.png?w=120&h=120&fit=pad)
 *
 * 5 important smartphone safety tips
 *
 *
 */
export const IMG_2Jr4m9tPXb4rMxwOjMcfhb = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2Jr4m9tPXb4rMxwOjMcfhb/7842d30e4e83235aafc441556f35b501/unnamed.png',
  description: ``,
  originalHeight: 341,
  originalWidth: 512
}

/**
 * ![8 safety questions you should ask your new landlord](https://images.ctfassets.net/v6awd0kabi65/3hW65Q3l4VPRCFWDq9Dy6q/72a1e117f3de673671c588c0fe92c66c/romain-dancre-doplSDELX7E-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * 8 safety questions you should ask your new landlord
 *
 *
 */
export const IMG_3hW65Q3l4VPRCFWDq9Dy6q = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3hW65Q3l4VPRCFWDq9Dy6q/72a1e117f3de673671c588c0fe92c66c/romain-dancre-doplSDELX7E-unsplash.jpg',
  description: ``,
  originalHeight: 4480,
  originalWidth: 5973
}

/**
 * ![How to prevent water damage in your home](https://images.ctfassets.net/v6awd0kabi65/57884OKQ58e4K2EkthCUJ4/a50a60cdaa04f2ff8180aa5e98f8e0a0/cdc-aeh1dbI_a7I-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * How to prevent water damage in your home
 *
 *
 */
export const IMG_57884OKQ58e4K2EkthCUJ4 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/57884OKQ58e4K2EkthCUJ4/a50a60cdaa04f2ff8180aa5e98f8e0a0/cdc-aeh1dbI_a7I-unsplash.jpg',
  description: ``,
  originalHeight: 2731,
  originalWidth: 4096
}

/**
 * ![How to secure your home when you’re on holiday](https://images.ctfassets.net/v6awd0kabi65/0ikfmF6nGcFxygWENf3vc/4bcc48b068465a560c7e5cb5659fb91d/unnamed.jpeg?w=120&h=120&fit=pad)
 *
 * How to secure your home when you’re on holiday
 *
 *
 */
export const IMG_0ikfmF6nGcFxygWENf3vc = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/0ikfmF6nGcFxygWENf3vc/4bcc48b068465a560c7e5cb5659fb91d/unnamed.jpeg',
  description: ``,
  originalHeight: 1066,
  originalWidth: 1600
}

/**
 * ![ Five Christmas scams to look out for](https://images.ctfassets.net/v6awd0kabi65/5ZALThKBbOc7v1f7Au7rj2/745c301a0059be67ac38a0deb147884f/ksenia-yakovleva-GJUi5qfkh-g-unsplash.jpg?w=120&h=120&fit=pad)
 *
 *  Five Christmas scams to look out for
 *
 * Stay protected this Christmas, as SimpliSafe shares five Christmas scams to look out for, and how to avoid them.
 */
export const IMG_5ZALThKBbOc7v1f7Au7rj2 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5ZALThKBbOc7v1f7Au7rj2/745c301a0059be67ac38a0deb147884f/ksenia-yakovleva-GJUi5qfkh-g-unsplash.jpg',
  description: `Stay protected this Christmas, as SimpliSafe shares five Christmas scams to look out for, and how to avoid them.`,
  originalHeight: 3456,
  originalWidth: 5184
}

/**
 * ![Do outdoor cameras really deter burglars?](https://images.ctfassets.net/v6awd0kabi65/6nxX6uGFXlbbqnMcZwSZrr/7da324966ac3e4b930e2a2774d7c086d/Outdoor_Camera_3331.png?w=120&h=120&fit=pad)
 *
 * Do outdoor cameras really deter burglars?
 *
 *
 */
export const IMG_6nxX6uGFXlbbqnMcZwSZrr = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6nxX6uGFXlbbqnMcZwSZrr/7da324966ac3e4b930e2a2774d7c086d/Outdoor_Camera_3331.png',
  description: ``,
  originalHeight: 2717,
  originalWidth: 3004
}

/**
 * ![A guide to panic buttons](https://images.ctfassets.net/v6awd0kabi65/63SfzAnzVVya9W0FO4Diwb/adeccbaab8ffdfa02e54c6338580c5e2/Spring_Product_Refresh_2022_-_Panic_Button.jpg?w=120&h=120&fit=pad)
 *
 * A guide to panic buttons
 *
 * Send for help in an instant with the SimpliSafe Panic Button. Unsure how to use one? This is our comprehensive guide to panic buttons.
 */
export const IMG_63SfzAnzVVya9W0FO4Diwb = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/63SfzAnzVVya9W0FO4Diwb/adeccbaab8ffdfa02e54c6338580c5e2/Spring_Product_Refresh_2022_-_Panic_Button.jpg',
  description: `Send for help in an instant with the SimpliSafe Panic Button. Unsure how to use one? This is our comprehensive guide to panic buttons.`,
  originalHeight: 1500,
  originalWidth: 2000
}

/**
 * ![Seven techniques used by burglars](https://images.ctfassets.net/v6awd0kabi65/6ueLg6kEmtHQKWkSVqGN6E/867421ce224dd05e10c6aa0fba083ca7/Untitled_design.png?w=120&h=120&fit=pad)
 *
 * Seven techniques used by burglars
 *
 * Think like a burglar to stop them in their tracks. Here are seven techniques used by burglars, so you know what to look out for. Secure your home today.
 */
export const IMG_6ueLg6kEmtHQKWkSVqGN6E = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6ueLg6kEmtHQKWkSVqGN6E/867421ce224dd05e10c6aa0fba083ca7/Untitled_design.png',
  description: `Think like a burglar to stop them in their tracks. Here are seven techniques used by burglars, so you know what to look out for. Secure your home today. `,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![How to prevent frozen pipes in your home](https://images.ctfassets.net/v6awd0kabi65/28rv3BDOoDztoV2PPpBQ1Z/81d6c615665b817c0397523709a47dc9/annie-spratt-MMh57gXsTug-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * How to prevent frozen pipes in your home
 *
 *
 */
export const IMG_28rv3BDOoDztoV2PPpBQ1Z = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/28rv3BDOoDztoV2PPpBQ1Z/81d6c615665b817c0397523709a47dc9/annie-spratt-MMh57gXsTug-unsplash.jpg',
  description: ``,
  originalHeight: 5304,
  originalWidth: 7952
}

/**
 * ![Top 5 Tips for Holiday Home Safety ](https://images.ctfassets.net/v6awd0kabi65/6jGCIYYS1ENJpXiqghaCTf/11a32988a2dcb4bd4e1baa38dc915cd3/sven-brandsma-EcE80JehiOs-unsplash.jpeg?w=120&h=120&fit=pad)
 *
 * Top 5 Tips for Holiday Home Safety
 *
 *
 */
export const IMG_6jGCIYYS1ENJpXiqghaCTf = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6jGCIYYS1ENJpXiqghaCTf/11a32988a2dcb4bd4e1baa38dc915cd3/sven-brandsma-EcE80JehiOs-unsplash.jpeg',
  description: ``,
  originalHeight: 3493,
  originalWidth: 4657
}

/**
 * ![Get Your Home Ready for Winter](https://images.ctfassets.net/v6awd0kabi65/46jex74Ag46B0tuCB2gIO2/039a8a59e7c861ff6ae5a9e6ae66ffc3/Snowy_window_SS_Blog.jpeg?w=120&h=120&fit=pad)
 *
 * Get Your Home Ready for Winter
 *
 *
 */
export const IMG_46jex74Ag46B0tuCB2gIO2 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/46jex74Ag46B0tuCB2gIO2/039a8a59e7c861ff6ae5a9e6ae66ffc3/Snowy_window_SS_Blog.jpeg',
  description: ``,
  originalHeight: 2863,
  originalWidth: 3817
}

/**
 * ![Purchasing SimpliSafe using Klarna](https://images.ctfassets.net/v6awd0kabi65/65pYENNmgaVAsabMa122D2/d32acfe4dd83d78fa7f12641b9966531/rupixen-com-Q59HmzK38eQ-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * Purchasing SimpliSafe using Klarna
 *
 *
 */
export const IMG_65pYENNmgaVAsabMa122D2 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/65pYENNmgaVAsabMa122D2/d32acfe4dd83d78fa7f12641b9966531/rupixen-com-Q59HmzK38eQ-unsplash.jpg',
  description: ``,
  originalHeight: 3456,
  originalWidth: 5184
}

/**
 * ![How good is your home’s security? ](https://images.ctfassets.net/v6awd0kabi65/1fvh4A3yRC5YxBiUmkl7WT/4bd42557a70ddc6563910991c5c9e2a3/kirsten-drew-v-wkJZ4Dbac-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * How good is your home’s security?
 *
 * Exactly how good is your home’s security? Optimise your current system today to ensure that your property is protected for years to come.
 */
export const IMG_1fvh4A3yRC5YxBiUmkl7WT = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1fvh4A3yRC5YxBiUmkl7WT/4bd42557a70ddc6563910991c5c9e2a3/kirsten-drew-v-wkJZ4Dbac-unsplash.jpg',
  description: `Exactly how good is your home’s security? Optimise your current system today to ensure that your property is protected for years to come. `,
  originalHeight: 3281,
  originalWidth: 4921
}

/**
 * ![How to upgrade your security system](https://images.ctfassets.net/v6awd0kabi65/1OwUHIRZOufKngBvdyT5J6/0e2b035e7fe0e8ac2898e31670fe8e18/unnamed__1_.jpeg?w=120&h=120&fit=pad)
 *
 * How to upgrade your security system
 *
 *
 */
export const IMG_1OwUHIRZOufKngBvdyT5J6 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1OwUHIRZOufKngBvdyT5J6/0e2b035e7fe0e8ac2898e31670fe8e18/unnamed__1_.jpeg',
  description: ``,
  originalHeight: 341,
  originalWidth: 512
}

/**
 * ![How to avoid holiday booking scams ](https://images.ctfassets.net/v6awd0kabi65/2JmxVrfsoJQi3iEBHXSNdC/c9d9ce94870df41ffc8b7c10c27b5e63/manuel-moreno-DGa0LQ0yDPc-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * How to avoid holiday booking scams
 *
 *
 */
export const IMG_2JmxVrfsoJQi3iEBHXSNdC = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2JmxVrfsoJQi3iEBHXSNdC/c9d9ce94870df41ffc8b7c10c27b5e63/manuel-moreno-DGa0LQ0yDPc-unsplash.jpg',
  description: ``,
  originalHeight: 2848,
  originalWidth: 4288
}

/**
 * ![What to do if your smartphone is stolen | SimpliSafe](https://images.ctfassets.net/v6awd0kabi65/2uxmDnnxVmZceWmC9i2CVb/1e79678881e0372ef349eee0ebd0cc9d/jonas-leupe-wK-elt11pF0-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * What to do if your smartphone is stolen | SimpliSafe
 *
 *
 */
export const IMG_2uxmDnnxVmZceWmC9i2CVb = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2uxmDnnxVmZceWmC9i2CVb/1e79678881e0372ef349eee0ebd0cc9d/jonas-leupe-wK-elt11pF0-unsplash.jpg',
  description: ``,
  originalHeight: 3951,
  originalWidth: 5926
}

/**
 * ![The best ways to keep your shed secure | SimpliSafe ](https://images.ctfassets.net/v6awd0kabi65/6wrnUL69tE0R0eUBd8nHC3/d6d6727f4a6fdfbed65c47df362142a0/marina-khrapova-m2_eBXP66g8-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * The best ways to keep your shed secure | SimpliSafe
 *
 *
 */
export const IMG_6wrnUL69tE0R0eUBd8nHC3 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6wrnUL69tE0R0eUBd8nHC3/d6d6727f4a6fdfbed65c47df362142a0/marina-khrapova-m2_eBXP66g8-unsplash.jpg',
  description: ``,
  originalHeight: 3000,
  originalWidth: 4500
}

/**
 * ![Why do we need home security systems?](https://images.ctfassets.net/v6awd0kabi65/PZompGb9NAb0dKPJyOiLj/eda326796edd3b1d577247fff332a1f0/josh-shaw-gOfgHombju0-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * Why do we need home security systems?
 *
 *
 */
export const IMG_PZompGb9NAb0dKPJyOiLj = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/PZompGb9NAb0dKPJyOiLj/eda326796edd3b1d577247fff332a1f0/josh-shaw-gOfgHombju0-unsplash.jpg',
  description: ``,
  originalHeight: 2427,
  originalWidth: 3640
}

/**
 * ![SimpliSafe Updated logo](https://images.ctfassets.net/v6awd0kabi65/34G4azdAUNJAwEfIKy5c57/8e984f2c6ff4143f1ea634e84643c471/External_vendor_logo.png?w=120&h=120&fit=pad)
 *
 * SimpliSafe Updated logo
 *
 *
 */
export const IMG_34G4azdAUNJAwEfIKy5c57 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/34G4azdAUNJAwEfIKy5c57/8e984f2c6ff4143f1ea634e84643c471/External_vendor_logo.png',
  description: ``,
  originalHeight: 80,
  originalWidth: 310
}

/**
 * ![How Landscaping Can Increase  Your Home Security](https://images.ctfassets.net/v6awd0kabi65/6Vacts5tzSIvDTIq2OaxPZ/901a191d2c5dec0f425db48e5144e49f/ronnie-george-z11gbBo13ro-unsplash.jpeg?w=120&h=120&fit=pad)
 *
 * How Landscaping Can Increase  Your Home Security
 *
 *
 */
export const IMG_6Vacts5tzSIvDTIq2OaxPZ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6Vacts5tzSIvDTIq2OaxPZ/901a191d2c5dec0f425db48e5144e49f/ronnie-george-z11gbBo13ro-unsplash.jpeg',
  description: ``,
  originalHeight: 3648,
  originalWidth: 5472
}

/**
 * ![Back to School Safety Tips](https://images.ctfassets.net/v6awd0kabi65/I7m2Vr7GNZmUXuuRZZ9B1/ba6cbc0552922220e49983add70d5ed3/wonderlane-zXxPr5eeGVk-unsplash.jpeg?w=120&h=120&fit=pad)
 *
 * Back to School Safety Tips
 *
 *
 */
export const IMG_I7m2Vr7GNZmUXuuRZZ9B1 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/I7m2Vr7GNZmUXuuRZZ9B1/ba6cbc0552922220e49983add70d5ed3/wonderlane-zXxPr5eeGVk-unsplash.jpeg',
  description: ``,
  originalHeight: 3096,
  originalWidth: 4128
}

/**
 * ![National Emergency Preparedness Month:  Tips to Fortify Your Home Before the Unexpected Occurs](https://images.ctfassets.net/v6awd0kabi65/2FlatOR1RxRbsF9WTkcPrg/f033351f439f56cd97a7c418016fd98b/andrew-teoh-SKrgZQgYy2g-unsplash.jpeg?w=120&h=120&fit=pad)
 *
 * National Emergency Preparedness Month:  Tips to Fortify Your Home Before the Unexpected Occurs
 *
 *
 */
export const IMG_2FlatOR1RxRbsF9WTkcPrg = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2FlatOR1RxRbsF9WTkcPrg/f033351f439f56cd97a7c418016fd98b/andrew-teoh-SKrgZQgYy2g-unsplash.jpeg',
  description: ``,
  originalHeight: 3448,
  originalWidth: 4592
}

/**
 * ![Outdoor Shield Camera At Night](https://images.ctfassets.net/v6awd0kabi65/7ru82AwrokrDrZmcCrFlyQ/2542e91698ec85ecb9833c2fe1ada241/Spring_Product_Refresh_2022_-_Outdoor_-_Shield_Camera_at_Night_resized.jpg?w=120&h=120&fit=pad)
 *
 * Outdoor Shield Camera At Night
 *
 * Outdoor Shield Camera At Night
 */
export const IMG_7ru82AwrokrDrZmcCrFlyQ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7ru82AwrokrDrZmcCrFlyQ/2542e91698ec85ecb9833c2fe1ada241/Spring_Product_Refresh_2022_-_Outdoor_-_Shield_Camera_at_Night_resized.jpg',
  description: `Outdoor Shield Camera At Night`,
  originalHeight: 1875,
  originalWidth: 2500
}

/**
 * ![Staying safe when living at university](https://images.ctfassets.net/v6awd0kabi65/4LINx7Wipe0GFOt2aCXerC/b791691c08021513c1411cf5bcdade82/dom-fou-YRMWVcdyhmI-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * Staying safe when living at university
 *
 * SimpliSafe shares their best tips for staying safe when living at university, to ensure complete security during this next big life chapter.
 */
export const IMG_4LINx7Wipe0GFOt2aCXerC = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4LINx7Wipe0GFOt2aCXerC/b791691c08021513c1411cf5bcdade82/dom-fou-YRMWVcdyhmI-unsplash.jpg',
  description: `SimpliSafe shares their best tips for staying safe when living at university, to ensure complete security during this next big life chapter. `,
  originalHeight: 2072,
  originalWidth: 2763
}

/**
 * ![How burglars use social media](https://images.ctfassets.net/v6awd0kabi65/3nuGy8sCHA5uuLID4pM6uF/92a47a36c21b42c0c24bfa2676854579/unnamed.jpeg?w=120&h=120&fit=pad)
 *
 * How burglars use social media
 *
 *
 */
export const IMG_3nuGy8sCHA5uuLID4pM6uF = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3nuGy8sCHA5uuLID4pM6uF/92a47a36c21b42c0c24bfa2676854579/unnamed.jpeg',
  description: ``,
  originalHeight: 898,
  originalWidth: 1600
}

/**
 * ![Securing your new home](https://images.ctfassets.net/v6awd0kabi65/4iXtfZ9IrAAUc7MQVbKv4D/6db52289f6bdf09a943d2eddda017e67/unnamed-3.jpg?w=120&h=120&fit=pad)
 *
 * Securing your new home
 *
 *
 */
export const IMG_4iXtfZ9IrAAUc7MQVbKv4D = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4iXtfZ9IrAAUc7MQVbKv4D/6db52289f6bdf09a943d2eddda017e67/unnamed-3.jpg',
  description: ``,
  originalHeight: 341,
  originalWidth: 512
}

/**
 * ![How to secure your social media | SimpliSafe](https://images.ctfassets.net/v6awd0kabi65/1I609HDGlH49evm02cMNxm/88d5232f6aa6ac149238ebe4f73e3f93/unnamed.jpg?w=120&h=120&fit=pad)
 *
 * How to secure your social media | SimpliSafe
 *
 *
 */
export const IMG_1I609HDGlH49evm02cMNxm = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1I609HDGlH49evm02cMNxm/88d5232f6aa6ac149238ebe4f73e3f93/unnamed.jpg',
  description: ``,
  originalHeight: 341,
  originalWidth: 512
}

/**
 * ![Security concerns in the summer & how to fix them](https://images.ctfassets.net/v6awd0kabi65/70CtVAGhMDipnmKoKuj0Tk/cec7b571ac6bffb80dcd65eef69aa518/unnamed.jpeg?w=120&h=120&fit=pad)
 *
 * Security concerns in the summer & how to fix them
 *
 *
 */
export const IMG_70CtVAGhMDipnmKoKuj0Tk = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/70CtVAGhMDipnmKoKuj0Tk/cec7b571ac6bffb80dcd65eef69aa518/unnamed.jpeg',
  description: ``,
  originalHeight: 1066,
  originalWidth: 1600
}

/**
 * ![5 ways to help your neighbours in Neighbours Week 2022](https://images.ctfassets.net/v6awd0kabi65/7mX6OiDpyHBbwzJIj1U0RK/58ebaee08c41d761a598cc526676b2f3/unnamed.jpeg?w=120&h=120&fit=pad)
 *
 * 5 ways to help your neighbours in Neighbours Week 2022
 *
 *
 */
export const IMG_7mX6OiDpyHBbwzJIj1U0RK = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7mX6OiDpyHBbwzJIj1U0RK/58ebaee08c41d761a598cc526676b2f3/unnamed.jpeg',
  description: ``,
  originalHeight: 1066,
  originalWidth: 1600
}

/**
 * ![Travel Tips: Protect Your Home While You’re Away this Summer](https://images.ctfassets.net/v6awd0kabi65/3od5n832r68chzwsl8depO/cccbbda84ff91109cb01edc8e9cc8c7b/jeshoots-com-mSESwdMZr-A-unsplash.jpeg?w=120&h=120&fit=pad)
 *
 * Travel Tips: Protect Your Home While You’re Away this Summer
 *
 *
 */
export const IMG_3od5n832r68chzwsl8depO = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3od5n832r68chzwsl8depO/cccbbda84ff91109cb01edc8e9cc8c7b/jeshoots-com-mSESwdMZr-A-unsplash.jpeg',
  description: ``,
  originalHeight: 3600,
  originalWidth: 5400
}

/**
 * ![How to set up an outdoor security camera](https://images.ctfassets.net/v6awd0kabi65/7CJYMyNUJGonaa5gVtkoeM/40657b18b09cec196068f88d99fc5824/unnamed.png?w=120&h=120&fit=pad)
 *
 * How to set up an outdoor security camera
 *
 *
 */
export const IMG_7CJYMyNUJGonaa5gVtkoeM = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7CJYMyNUJGonaa5gVtkoeM/40657b18b09cec196068f88d99fc5824/unnamed.png',
  description: ``,
  originalHeight: 780,
  originalWidth: 1170
}

/**
 * ![The best ways to stay safe abroad](https://images.ctfassets.net/v6awd0kabi65/6gfo627qdjw3vFGHQCdaei/7cf8895cb2881e7bf9f5d7749cff0016/Untitled_design-58.png?w=120&h=120&fit=pad)
 *
 * The best ways to stay safe abroad
 *
 * Heading off on your travels? Ensure that nothing ruins your time away, with SimpliSafe’s list of the best ways to stay safe abroad.
 */
export const IMG_6gfo627qdjw3vFGHQCdaei = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6gfo627qdjw3vFGHQCdaei/7cf8895cb2881e7bf9f5d7749cff0016/Untitled_design-58.png',
  description: `Heading off on your travels? Ensure that nothing ruins your time away, with SimpliSafe’s list of the best ways to stay safe abroad. `,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Safety and security tips for sporty people](https://images.ctfassets.net/v6awd0kabi65/6dpp8TS4ot9i356UlmbR5L/4ad5094d81d369862e9589f25efbfc31/run.jpeg?w=120&h=120&fit=pad)
 *
 * Safety and security tips for sporty people
 *
 *
 */
export const IMG_6dpp8TS4ot9i356UlmbR5L = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6dpp8TS4ot9i356UlmbR5L/4ad5094d81d369862e9589f25efbfc31/run.jpeg',
  description: ``,
  originalHeight: 268,
  originalWidth: 512
}

/**
 * ![dog lying on bed](https://images.ctfassets.net/v6awd0kabi65/2sgS4oY2IVPa3dgmLKVMyV/2c172ab67781a452ebcb9f36eec5bddc/dog_lying_on_bed.jpg?w=120&h=120&fit=pad)
 *
 * dog lying on bed
 *
 *
 */
export const IMG_2sgS4oY2IVPa3dgmLKVMyV = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2sgS4oY2IVPa3dgmLKVMyV/2c172ab67781a452ebcb9f36eec5bddc/dog_lying_on_bed.jpg',
  description: ``,
  originalHeight: 624,
  originalWidth: 936
}

/**
 * ![can your dog protect your home](https://images.ctfassets.net/v6awd0kabi65/3n91m0rLPEN9rWkpoSVl5/2ff51e741c46c16b1e2ca154ab5aabbf/can_your_dog_protect_your_home.jpg?w=120&h=120&fit=pad)
 *
 * can your dog protect your home
 *
 *
 */
export const IMG_3n91m0rLPEN9rWkpoSVl5 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3n91m0rLPEN9rWkpoSVl5/2ff51e741c46c16b1e2ca154ab5aabbf/can_your_dog_protect_your_home.jpg',
  description: ``,
  originalHeight: 632,
  originalWidth: 932
}

/**
 * ![how much should a home security system cost](https://images.ctfassets.net/v6awd0kabi65/1266knCAK1Uf73NfOB52jC/e74cf8fcfd20b52632b17a8341f670bb/White_Base_1__1_.jpg?w=120&h=120&fit=pad)
 *
 * how much should a home security system cost
 *
 *
 */
export const IMG_1266knCAK1Uf73NfOB52jC = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1266knCAK1Uf73NfOB52jC/e74cf8fcfd20b52632b17a8341f670bb/White_Base_1__1_.jpg',
  description: ``,
  originalHeight: 4000,
  originalWidth: 6000
}

/**
 * ![no-contract home security system](https://images.ctfassets.net/v6awd0kabi65/1UhYbbeO3p3SM1v30S3bbu/0474e630ba7725ba1165add93a03cbf4/No_Contract_Home_Security_System.jpg?w=120&h=120&fit=pad)
 *
 * no-contract home security system
 *
 *
 */
export const IMG_1UhYbbeO3p3SM1v30S3bbu = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1UhYbbeO3p3SM1v30S3bbu/0474e630ba7725ba1165add93a03cbf4/No_Contract_Home_Security_System.jpg',
  description: ``,
  originalHeight: 4000,
  originalWidth: 6000
}

/**
 * ![smart home security](https://images.ctfassets.net/v6awd0kabi65/709YxfMREpa3prhLTAJVWt/833361148e405b5dbe6bee10e27b13c4/smart_home_security__1_.jpg?w=120&h=120&fit=pad)
 *
 * smart home security
 *
 *
 */
export const IMG_709YxfMREpa3prhLTAJVWt = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/709YxfMREpa3prhLTAJVWt/833361148e405b5dbe6bee10e27b13c4/smart_home_security__1_.jpg',
  description: ``,
  originalHeight: 2782,
  originalWidth: 4181
}

/**
 * ![small business case study](https://images.ctfassets.net/v6awd0kabi65/1dh9X11x3Oe8He781KrbMy/623a725567506fdc29ead0c46958c7ae/small_business_case_study__1_.jpg?w=120&h=120&fit=pad)
 *
 * small business case study
 *
 *
 */
export const IMG_1dh9X11x3Oe8He781KrbMy = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1dh9X11x3Oe8He781KrbMy/623a725567506fdc29ead0c46958c7ae/small_business_case_study__1_.jpg',
  description: ``,
  originalHeight: 6000,
  originalWidth: 9000
}

/**
 * ![What’s the best home security system for apartments?](https://images.ctfassets.net/v6awd0kabi65/4Vp8uLV9B7TcKFjGQNOYYB/11519439624f2aa33e9cc1aa00a87824/unnamed.jpeg?w=120&h=120&fit=pad)
 *
 * What’s the best home security system for apartments?
 *
 *
 */
export const IMG_4Vp8uLV9B7TcKFjGQNOYYB = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4Vp8uLV9B7TcKFjGQNOYYB/11519439624f2aa33e9cc1aa00a87824/unnamed.jpeg',
  description: ``,
  originalHeight: 381,
  originalWidth: 512
}

/**
 * ![4 security tips for when the clocks go forward](https://images.ctfassets.net/v6awd0kabi65/1iccGcYNQ75kG6LWKbEBj2/e1c54e01127f17705d7c8fae10ffea90/Untitled_design-57.png?w=120&h=120&fit=pad)
 *
 * 4 security tips for when the clocks go forward
 *
 * When the winter transitions into spring - welcoming longer, warmer days - stay prepared with these security tips for when the clocks go forward.
 */
export const IMG_1iccGcYNQ75kG6LWKbEBj2 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1iccGcYNQ75kG6LWKbEBj2/e1c54e01127f17705d7c8fae10ffea90/Untitled_design-57.png',
  description: `When the winter transitions into spring - welcoming longer, warmer days - stay prepared with these security tips for when the clocks go forward.`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Burnt Out Stove](https://images.ctfassets.net/v6awd0kabi65/5IJi8zmiLLOMhxIfE6I4aA/8f783cd1a53c54c259c08f3590881c2b/242706860_10225209183634665_6209834015827181706_n.jpg?w=120&h=120&fit=pad)
 *
 * Burnt Out Stove
 *
 *
 */
export const IMG_5IJi8zmiLLOMhxIfE6I4aA = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5IJi8zmiLLOMhxIfE6I4aA/8f783cd1a53c54c259c08f3590881c2b/242706860_10225209183634665_6209834015827181706_n.jpg',
  description: ``,
  originalHeight: 2016,
  originalWidth: 976
}

/**
 * ![Worthington Family Fire](https://images.ctfassets.net/v6awd0kabi65/4lMA5osSTdJVe6vUChPuF7/a06cbc1ae779344f2dfbdfcb10c060aa/242625738_10225209184234680_1619286732142982824_n.jpg?w=120&h=120&fit=pad)
 *
 * Worthington Family Fire
 *
 *
 */
export const IMG_4lMA5osSTdJVe6vUChPuF7 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4lMA5osSTdJVe6vUChPuF7/a06cbc1ae779344f2dfbdfcb10c060aa/242625738_10225209184234680_1619286732142982824_n.jpg',
  description: ``,
  originalHeight: 2016,
  originalWidth: 976
}

/**
 * ![Smoke Detector - Feature](https://images.ctfassets.net/v6awd0kabi65/D5qnd9bSzigeP9PnRIjEt/0e5bb42cc60f524d441562de87de65e9/desktop_smoke-sq_2x.jpg?w=120&h=120&fit=pad)
 *
 * Smoke Detector - Feature
 *
 * smoke detector displayed
 */
export const IMG_D5qnd9bSzigeP9PnRIjEt = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/D5qnd9bSzigeP9PnRIjEt/0e5bb42cc60f524d441562de87de65e9/desktop_smoke-sq_2x.jpg',
  description: `smoke detector displayed`,
  originalHeight: 1199,
  originalWidth: 1200
}

/**
 * ![Six ways to make your home more private](https://images.ctfassets.net/v6awd0kabi65/6xH9HaMOZjxOsnN6znNRGp/b464156faa830245c7c1e07d56967ee1/paige-cody-bOVZ_f3fbQM-unsplash_copy.jpg?w=120&h=120&fit=pad)
 *
 * Six ways to make your home more private
 *
 *
 */
export const IMG_6xH9HaMOZjxOsnN6znNRGp = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6xH9HaMOZjxOsnN6znNRGp/b464156faa830245c7c1e07d56967ee1/paige-cody-bOVZ_f3fbQM-unsplash_copy.jpg',
  description: ``,
  originalHeight: 4016,
  originalWidth: 6016
}

/**
 * ![wired vs wireless home security systems](https://images.ctfassets.net/v6awd0kabi65/xaaSKTcxd50U7d5zIvnki/bec23f69b0597dfc7194da63e42b2312/wired_vs_wireless_home_security_systems__1_.jpg?w=120&h=120&fit=pad)
 *
 * wired vs wireless home security systems
 *
 *
 */
export const IMG_xaaSKTcxd50U7d5zIvnki = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/xaaSKTcxd50U7d5zIvnki/bec23f69b0597dfc7194da63e42b2312/wired_vs_wireless_home_security_systems__1_.jpg',
  description: ``,
  originalHeight: 4000,
  originalWidth: 7114
}

/**
 * ![ Whole home protection with SimpliSafe](https://images.ctfassets.net/v6awd0kabi65/2arHSE40W4tTA1TOu3XipE/b7f78564377f0500baa802d61c9d5431/spacejoy-YI2YkyaREHk-unsplash.webp?w=120&h=120&fit=pad)
 *
 *  Whole home protection with SimpliSafe
 *
 *
 */
export const IMG_2arHSE40W4tTA1TOu3XipE = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2arHSE40W4tTA1TOu3XipE/b7f78564377f0500baa802d61c9d5431/spacejoy-YI2YkyaREHk-unsplash.webp',
  description: ``,
  originalHeight: 2880,
  originalWidth: 2880
}

/**
 * ![Is my home a target for burglars?](https://images.ctfassets.net/v6awd0kabi65/35nIv72QS6e1jHJ9VEHwo9/baef3b911d1d5eb20507a68d0caf0ace/Untitled_design-56.png?w=120&h=120&fit=pad)
 *
 * Is my home a target for burglars?
 *
 * Could your home be a target for burglars? SimpliSafe highlights exactly what you should avoid to improve your home security.
 */
export const IMG_35nIv72QS6e1jHJ9VEHwo9 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/35nIv72QS6e1jHJ9VEHwo9/baef3b911d1d5eb20507a68d0caf0ace/Untitled_design-56.png',
  description: `Could your home be a target for burglars? SimpliSafe highlights exactly what you should avoid to improve your home security.`,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![How to keep your most loved possessions safe](https://images.ctfassets.net/v6awd0kabi65/20z82UHCGzXoBuN7HvAs5H/c92f549c2b6ea7ea429b519da15b7924/obi-onyeador-SCUPx5far-M-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * How to keep your most loved possessions safe
 *
 * Prevent the risk of a break-in with SimpliSafe’s complete guide on how to keep your most loved possessions safe.
 */
export const IMG_20z82UHCGzXoBuN7HvAs5H = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/20z82UHCGzXoBuN7HvAs5H/c92f549c2b6ea7ea429b519da15b7924/obi-onyeador-SCUPx5far-M-unsplash.jpg',
  description: `Prevent the risk of a break-in with SimpliSafe’s complete guide on how to keep your most loved possessions safe. `,
  originalHeight: 5723,
  originalWidth: 7848
}

/**
 * ![Top burglar deterrents for your home](https://images.ctfassets.net/v6awd0kabi65/1C52aapJBa8pZwrxUeZFfk/abaf6d814e5644dc32f8e9c812fe931f/jamie-street-h6mj_9bCvBk-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * Top burglar deterrents for your home
 *
 * Secure your home for years to come with SimpliSafe, as we run through the top burglar deterrents for your home.
 */
export const IMG_1C52aapJBa8pZwrxUeZFfk = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1C52aapJBa8pZwrxUeZFfk/abaf6d814e5644dc32f8e9c812fe931f/jamie-street-h6mj_9bCvBk-unsplash.jpg',
  description: `Secure your home for years to come with SimpliSafe, as we run through the top burglar deterrents for your home. `,
  originalHeight: 3019,
  originalWidth: 4606
}

/**
 * ![Indoor Camera Placement](https://images.ctfassets.net/v6awd0kabi65/3nMq31A9fpV0nYkNNlHn1h/b3a4106eb8e083a3c46c1ef2fb8e7277/Indoor_Camera__1_.jpg?w=120&h=120&fit=pad)
 *
 * Indoor Camera Placement
 *
 *
 */
export const IMG_3nMq31A9fpV0nYkNNlHn1h = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3nMq31A9fpV0nYkNNlHn1h/b3a4106eb8e083a3c46c1ef2fb8e7277/Indoor_Camera__1_.jpg',
  description: ``,
  originalHeight: 4000,
  originalWidth: 7114
}

/**
 * ![Security tips for working from home](https://images.ctfassets.net/v6awd0kabi65/2v3A3qS0LQlSCWQwpQ2CBX/47cef3a4cac6f678e8a165a9e3d4cba9/Picture_1.jpg?w=120&h=120&fit=pad)
 *
 * Security tips for working from home
 *
 *
 */
export const IMG_2v3A3qS0LQlSCWQwpQ2CBX = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2v3A3qS0LQlSCWQwpQ2CBX/47cef3a4cac6f678e8a165a9e3d4cba9/Picture_1.jpg',
  description: ``,
  originalHeight: 604,
  originalWidth: 904
}

/**
 * ![DIY home security system](https://images.ctfassets.net/v6awd0kabi65/3Kzbem0JgLN3JEsTK50IOT/a91df5910abd0af531a78f4ba5a9d717/DIY_home_security_system.webp?w=120&h=120&fit=pad)
 *
 * DIY home security system
 *
 *
 */
export const IMG_3Kzbem0JgLN3JEsTK50IOT = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3Kzbem0JgLN3JEsTK50IOT/a91df5910abd0af531a78f4ba5a9d717/DIY_home_security_system.webp',
  description: ``,
  originalHeight: 1200,
  originalWidth: 1500
}

/**
 * ![What to do if you’re at home during a break-in](https://images.ctfassets.net/v6awd0kabi65/2PPvKzDBwfBgQWiwwadr7I/9a517ef1b37c8ad228fca1207fead4a6/Screenshot_2022-02-01_at_16.27.13.png?w=120&h=120&fit=pad)
 *
 * What to do if you’re at home during a break-in
 *
 * Keep yourself and your family safe during an emergency with SimpliSafe's guide on what to do if you're at home during a break-in.
 */
export const IMG_2PPvKzDBwfBgQWiwwadr7I = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2PPvKzDBwfBgQWiwwadr7I/9a517ef1b37c8ad228fca1207fead4a6/Screenshot_2022-02-01_at_16.27.13.png',
  description: `Keep yourself and your family safe during an emergency with SimpliSafe's guide on what to do if you're at home during a break-in.`,
  originalHeight: 662,
  originalWidth: 996
}

/**
 * ![A complete guide to home security for the elderly](https://images.ctfassets.net/v6awd0kabi65/6DVM5j2EDRVMzXkBXapx9F/93cc543a1204eeb54291372b216d1af5/cdc-ddKBuWekZr0-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * A complete guide to home security for the elderly
 *
 *
 */
export const IMG_6DVM5j2EDRVMzXkBXapx9F = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6DVM5j2EDRVMzXkBXapx9F/93cc543a1204eeb54291372b216d1af5/cdc-ddKBuWekZr0-unsplash.jpg',
  description: ``,
  originalHeight: 2731,
  originalWidth: 4096
}

/**
 * ![Home security resolutions for a safer 2022](https://images.ctfassets.net/v6awd0kabi65/7FRSJJgyfosnNCbc4w87vO/0aae56e3bb9a19a468fdf269c2129998/pexels-photomix-company-101808.jpg?w=120&h=120&fit=pad)
 *
 * Home security resolutions for a safer 2022
 *
 * As we head into the new year, we've put together a list of some home security resolutions to help you have a safer 2022.
 */
export const IMG_7FRSJJgyfosnNCbc4w87vO = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7FRSJJgyfosnNCbc4w87vO/0aae56e3bb9a19a468fdf269c2129998/pexels-photomix-company-101808.jpg',
  description: `As we head into the new year, we've put together a list of some home security resolutions to help you have a safer 2022.`,
  originalHeight: 3072,
  originalWidth: 4608
}

/**
 * ![How To Prevent False Alarms](https://images.ctfassets.net/v6awd0kabi65/4BuCPfdieRMvGIsmndxKJG/26f0f4300c714cec5e9d5712344dbe5e/800x450_3.png?w=120&h=120&fit=pad)
 *
 * How To Prevent False Alarms
 *
 *
 */
export const IMG_4BuCPfdieRMvGIsmndxKJG = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4BuCPfdieRMvGIsmndxKJG/26f0f4300c714cec5e9d5712344dbe5e/800x450_3.png',
  description: ``,
  originalHeight: 450,
  originalWidth: 800
}

/**
 * ![Update on Scottish legislation change for fire and smoke detectors](https://images.ctfassets.net/v6awd0kabi65/5oMc6EakHxDAl0k2AxsUeR/d5b224c4b8b46825222693eda726d8c7/smoke_grey__1__copy.jpg?w=120&h=120&fit=pad)
 *
 * Update on Scottish legislation change for fire and smoke detectors
 *
 * If you’re a customer based in Scotland, you will be aware that the law on fire alarms is changing from February 2022...
 */
export const IMG_5oMc6EakHxDAl0k2AxsUeR = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5oMc6EakHxDAl0k2AxsUeR/d5b224c4b8b46825222693eda726d8c7/smoke_grey__1__copy.jpg',
  description: `If you’re a customer based in Scotland, you will be aware that the law on fire alarms is changing from February 2022...`,
  originalHeight: 1478,
  originalWidth: 1856
}

/**
 * ![How to avoid doorstep scams](https://images.ctfassets.net/v6awd0kabi65/52qQWISx4LFaNELvejWXi0/c21eeb390975a19150829e3caa34697a/viktor-forgacs-fHYztTcPZvU-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * How to avoid doorstep scams
 *
 *
 */
export const IMG_52qQWISx4LFaNELvejWXi0 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/52qQWISx4LFaNELvejWXi0/c21eeb390975a19150829e3caa34697a/viktor-forgacs-fHYztTcPZvU-unsplash.jpg',
  description: ``,
  originalHeight: 2808,
  originalWidth: 4164
}

/**
 * ![Home security when you're away](https://images.ctfassets.net/v6awd0kabi65/6Zn9bllMteYs7RfQK6tDMw/27df34960a878c77d722307c66d3f28a/brian-babb-XbwHrt87mQ0-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * Home security when you're away
 *
 *
 */
export const IMG_6Zn9bllMteYs7RfQK6tDMw = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6Zn9bllMteYs7RfQK6tDMw/27df34960a878c77d722307c66d3f28a/brian-babb-XbwHrt87mQ0-unsplash.jpg',
  description: ``,
  originalHeight: 3577,
  originalWidth: 5362
}

/**
 * ![As seen on the gadget show](https://images.ctfassets.net/v6awd0kabi65/4DczUlBXUtrJ88TFBYZmkp/4e668e9dd4f01abfbce3b9e7c0967484/asSeenOnTheGadgetShow.png?w=120&h=120&fit=pad)
 *
 * As seen on the gadget show
 *
 *
 */
export const IMG_4DczUlBXUtrJ88TFBYZmkp = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4DczUlBXUtrJ88TFBYZmkp/4e668e9dd4f01abfbce3b9e7c0967484/asSeenOnTheGadgetShow.png',
  description: ``,
  originalHeight: 894,
  originalWidth: 1125
}

/**
 * ![Top smart home trends for 2022 ](https://images.ctfassets.net/v6awd0kabi65/F0KyvbhLmLVzuRePBPHDA/717d74006d4e649403a6fe2d34685db6/ihor-saveliev-_aN6zIDRLfQ-unsplash__1_.jpg?w=120&h=120&fit=pad)
 *
 * Top smart home trends for 2022
 *
 * What are the top smart home trends to look out for in 2022? Add to your wishlist with SimpliSafe’s biggest predictions.
 */
export const IMG_F0KyvbhLmLVzuRePBPHDA = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/F0KyvbhLmLVzuRePBPHDA/717d74006d4e649403a6fe2d34685db6/ihor-saveliev-_aN6zIDRLfQ-unsplash__1_.jpg',
  description: `What are the top smart home trends to look out for in 2022? Add to your wishlist with SimpliSafe’s biggest predictions. `,
  originalHeight: 2782,
  originalWidth: 4181
}

/**
 * ![The best staycation ideas and how to keep safe](https://images.ctfassets.net/v6awd0kabi65/5EYQuEPI0o0XdjSiusBCAR/55146ef06545cca9ac4c0444e667e18a/pexels-cliford-mervil-2398220.jpg?w=120&h=120&fit=pad)
 *
 * The best staycation ideas and how to keep safe
 *
 *
 */
export const IMG_5EYQuEPI0o0XdjSiusBCAR = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5EYQuEPI0o0XdjSiusBCAR/55146ef06545cca9ac4c0444e667e18a/pexels-cliford-mervil-2398220.jpg',
  description: ``,
  originalHeight: 4912,
  originalWidth: 7360
}

/**
 * ![How to keep my pet from triggering my alarm](https://images.ctfassets.net/v6awd0kabi65/5h0RmW8WJY0eCXeYLuGAaY/e073a55c16b6f49a3310a3a2b66b5045/robert-larsson-TkwzP_frzl4-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * How to keep my pet from triggering my alarm
 *
 *
 */
export const IMG_5h0RmW8WJY0eCXeYLuGAaY = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5h0RmW8WJY0eCXeYLuGAaY/e073a55c16b6f49a3310a3a2b66b5045/robert-larsson-TkwzP_frzl4-unsplash.jpg',
  description: ``,
  originalHeight: 2666,
  originalWidth: 4000
}

/**
 * ![CCTV, Gates, and Beware of the Dog: What Brits are most using to keep their home safe](https://images.ctfassets.net/v6awd0kabi65/47OIKx1uO8v5KTNkhAYgzN/99900fb3656538cd54e2bd70befb23bd/Outdoor_camera_with_light.jpg?w=120&h=120&fit=pad)
 *
 * CCTV, Gates, and Beware of the Dog: What Brits are most using to keep their home safe
 *
 *
 */
export const IMG_47OIKx1uO8v5KTNkhAYgzN = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/47OIKx1uO8v5KTNkhAYgzN/99900fb3656538cd54e2bd70befb23bd/Outdoor_camera_with_light.jpg',
  description: ``,
  originalHeight: 1706,
  originalWidth: 3000
}

/**
 * ![What is a smart home?](https://images.ctfassets.net/v6awd0kabi65/0HRhV0ABk3K4Uj4LLJU2G/efddd42f3c3b106b868132c9624e1956/smart_home.jpeg?w=120&h=120&fit=pad)
 *
 * What is a smart home?
 *
 *
 */
export const IMG_0HRhV0ABk3K4Uj4LLJU2G = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/0HRhV0ABk3K4Uj4LLJU2G/efddd42f3c3b106b868132c9624e1956/smart_home.jpeg',
  description: ``,
  originalHeight: 341,
  originalWidth: 512
}

/**
 * ![How to protect your home's value](https://images.ctfassets.net/v6awd0kabi65/1RVweIBI1usJ5J2PRCRo7l/65d7030369d49588e9016fee69c8c089/olivier-collet-ZU62GJP-XC4-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * How to protect your home's value
 *
 *
 */
export const IMG_1RVweIBI1usJ5J2PRCRo7l = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1RVweIBI1usJ5J2PRCRo7l/65d7030369d49588e9016fee69c8c089/olivier-collet-ZU62GJP-XC4-unsplash.jpg',
  description: ``,
  originalHeight: 2211,
  originalWidth: 3932
}

/**
 * ![How to secure your home ready for a baby](https://images.ctfassets.net/v6awd0kabi65/1xqHpvz2hK2HjrzOcC5PGn/8e6503a78c0bbef1cac30c6a8fdc24bb/Untitled_design-55.png?w=120&h=120&fit=pad)
 *
 * How to secure your home ready for a baby
 *
 * Keep your little one safe and sound for years to come with SimpliSafe’s tips on how to secure your home ready for a baby.
 */
export const IMG_1xqHpvz2hK2HjrzOcC5PGn = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1xqHpvz2hK2HjrzOcC5PGn/8e6503a78c0bbef1cac30c6a8fdc24bb/Untitled_design-55.png',
  description: `Keep your little one safe and sound for years to come with SimpliSafe’s tips on how to secure your home ready for a baby. `,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Best places to hide Christmas presents in your home ](https://images.ctfassets.net/v6awd0kabi65/1dP3yobrpvYHZmXZboBgep/da79485668c42a6309304cf5af1cbbb0/lore-schodts-bNPIoil02tU-unsplash.jpg?w=120&h=120&fit=pad)
 *
 * Best places to hide Christmas presents in your home
 *
 *
 */
export const IMG_1dP3yobrpvYHZmXZboBgep = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1dP3yobrpvYHZmXZboBgep/da79485668c42a6309304cf5af1cbbb0/lore-schodts-bNPIoil02tU-unsplash.jpg',
  description: ``,
  originalHeight: 3937,
  originalWidth: 5897
}

/**
 * ![How to build a summer house step by step](https://images.ctfassets.net/v6awd0kabi65/3xd4QMsxL3cSdX6w05Vmc6/84853e0e8206bfde475cb3a48591949d/Untitled_design-54.png?w=120&h=120&fit=pad)
 *
 * How to build a summer house step by step
 *
 * Be the envy of the street, and give your garden an exciting update by following our guide on how to build a beautiful summer house step by step.
 */
export const IMG_3xd4QMsxL3cSdX6w05Vmc6 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3xd4QMsxL3cSdX6w05Vmc6/84853e0e8206bfde475cb3a48591949d/Untitled_design-54.png',
  description: `Be the envy of the street, and give your garden an exciting update by following our guide on how to build a beautiful summer house step by step. `,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![The latest anti-crime initiatives in the UK](https://images.ctfassets.net/v6awd0kabi65/3aniDxz4bqnVcW69vPconm/3337ca856268ebcc4e78e15bcb5b4b21/Untitled_design-53.png?w=120&h=120&fit=pad)
 *
 * The latest anti-crime initiatives in the UK
 *
 *
 */
export const IMG_3aniDxz4bqnVcW69vPconm = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3aniDxz4bqnVcW69vPconm/3337ca856268ebcc4e78e15bcb5b4b21/Untitled_design-53.png',
  description: ``,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![ 5 home security tips for the summer](https://images.ctfassets.net/v6awd0kabi65/1fvNYPd9iukvmcFWtS5vk7/28275e2f510cf03fd72242d7f12dab74/Untitled_design-52.png?w=120&h=120&fit=pad)
 *
 *  5 home security tips for the summer
 *
 *
 */
export const IMG_1fvNYPd9iukvmcFWtS5vk7 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1fvNYPd9iukvmcFWtS5vk7/28275e2f510cf03fd72242d7f12dab74/Untitled_design-52.png',
  description: ``,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![How to travel alone and do it safely ](https://images.ctfassets.net/v6awd0kabi65/6mWefDhkLr67KjZEW1N302/841292fdb7a38678c3d389b0424d5e82/pexels-samuel-theo-manat-silitonga-848573.jpg?w=120&h=120&fit=pad)
 *
 * How to travel alone and do it safely
 *
 *
 */
export const IMG_6mWefDhkLr67KjZEW1N302 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6mWefDhkLr67KjZEW1N302/841292fdb7a38678c3d389b0424d5e82/pexels-samuel-theo-manat-silitonga-848573.jpg',
  description: ``,
  originalHeight: 3942,
  originalWidth: 3942
}

/**
 * ![Is the professional monitoring right for me?](https://images.ctfassets.net/v6awd0kabi65/ai4IHIzTnMaA5ys8zCZu5/8a889f2bbc93227db91c1c68177d306b/Call_Center_Stock-cropped.jpg?w=120&h=120&fit=pad)
 *
 * Is the professional monitoring right for me?
 *
 *
 */
export const IMG_ai4IHIzTnMaA5ys8zCZu5 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/ai4IHIzTnMaA5ys8zCZu5/8a889f2bbc93227db91c1c68177d306b/Call_Center_Stock-cropped.jpg',
  description: ``,
  originalHeight: 379,
  originalWidth: 569
}

/**
 * ![Is professional monitoring right for me?](https://images.ctfassets.net/v6awd0kabi65/3zor9tpRng2jxcUklf3y1V/7a7643f440ef3f1a4d1034cb29105623/Call_Center_Stock-cropped.jpg?w=120&h=120&fit=pad)
 *
 * Is professional monitoring right for me?
 *
 *
 */
export const IMG_3zor9tpRng2jxcUklf3y1V = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3zor9tpRng2jxcUklf3y1V/7a7643f440ef3f1a4d1034cb29105623/Call_Center_Stock-cropped.jpg',
  description: ``,
  originalHeight: 379,
  originalWidth: 569
}

/**
 * ![The Internet of Things explained](https://images.ctfassets.net/v6awd0kabi65/5lcO76ndx0RdgLPXv9EwKi/47e5f86c13c4eaa29d8b0c7d0741f119/pexels-alena-darmel-6940339.jpg?w=120&h=120&fit=pad)
 *
 * The Internet of Things explained
 *
 *
 */
export const IMG_5lcO76ndx0RdgLPXv9EwKi = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5lcO76ndx0RdgLPXv9EwKi/47e5f86c13c4eaa29d8b0c7d0741f119/pexels-alena-darmel-6940339.jpg',
  description: ``,
  originalHeight: 3333,
  originalWidth: 5000
}

/**
 * ![How to avoid being mugged ](https://images.ctfassets.net/v6awd0kabi65/11mJ6PkdwkciQlw9P6u2KU/9d390a83b209e28fc50b690f0d956cf9/pexels-tim-douglas-6567383.jpg?w=120&h=120&fit=pad)
 *
 * How to avoid being mugged
 *
 *
 */
export const IMG_11mJ6PkdwkciQlw9P6u2KU = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/11mJ6PkdwkciQlw9P6u2KU/9d390a83b209e28fc50b690f0d956cf9/pexels-tim-douglas-6567383.jpg',
  description: ``,
  originalHeight: 4000,
  originalWidth: 6000
}

/**
 * ![Your social media has been hacked, what do you do next?](https://images.ctfassets.net/v6awd0kabi65/3OlvSQGZNMINOzw8mzmkpI/efa77ffbc554126a1303e148b0801b12/pexels-vlada-karpovich-4050415.jpg?w=120&h=120&fit=pad)
 *
 * Your social media has been hacked, what do you do next?
 *
 *
 */
export const IMG_3OlvSQGZNMINOzw8mzmkpI = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3OlvSQGZNMINOzw8mzmkpI/efa77ffbc554126a1303e148b0801b12/pexels-vlada-karpovich-4050415.jpg',
  description: ``,
  originalHeight: 4254,
  originalWidth: 6381
}

/**
 * ![Your social media has been hacked, what do you do next?](https://images.ctfassets.net/v6awd0kabi65/5TjI335P1xmr1F4Zoyievi/d7d47f09a87011b9ba28fc13a0da8f0c/pexels-vlada-karpovich-4050415.jpg?w=120&h=120&fit=pad)
 *
 * Your social media has been hacked, what do you do next?
 *
 *
 */
export const IMG_5TjI335P1xmr1F4Zoyievi = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5TjI335P1xmr1F4Zoyievi/d7d47f09a87011b9ba28fc13a0da8f0c/pexels-vlada-karpovich-4050415.jpg',
  description: ``,
  originalHeight: 4254,
  originalWidth: 6381
}

/**
 * ![A guide to home security for winter](https://images.ctfassets.net/v6awd0kabi65/7m4aIP7sgF8oaXsHL8tyFO/5ead9f882b27cd8f60e2bf2c475921b7/xmas.jpeg?w=120&h=120&fit=pad)
 *
 * A guide to home security for winter
 *
 *
 */
export const IMG_7m4aIP7sgF8oaXsHL8tyFO = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7m4aIP7sgF8oaXsHL8tyFO/5ead9f882b27cd8f60e2bf2c475921b7/xmas.jpeg',
  description: ``,
  originalHeight: 341,
  originalWidth: 512
}

/**
 * ![Ways to improve your doorstep and parcel security](https://images.ctfassets.net/v6awd0kabi65/3NCHbIRRb04PTYvoMmMSXR/80d508aa43efb19de438f958129d0acb/Untitled_design-50.png?w=120&h=120&fit=pad)
 *
 * Ways to improve your doorstep and parcel security
 *
 *
 */
export const IMG_3NCHbIRRb04PTYvoMmMSXR = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3NCHbIRRb04PTYvoMmMSXR/80d508aa43efb19de438f958129d0acb/Untitled_design-50.png',
  description: ``,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![7 great things you can do with a home security system](https://images.ctfassets.net/v6awd0kabi65/6IvQdAKZtaI5nsy7aW81PH/8cc0b2264388bb72fb3bad7f4c9afa68/Untitled_design-48.png?w=120&h=120&fit=pad)
 *
 * 7 great things you can do with a home security system
 *
 *
 */
export const IMG_6IvQdAKZtaI5nsy7aW81PH = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6IvQdAKZtaI5nsy7aW81PH/8cc0b2264388bb72fb3bad7f4c9afa68/Untitled_design-48.png',
  description: ``,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![Did you know about National Home Security Month?](https://images.ctfassets.net/v6awd0kabi65/EJ7NI6GOIOzSlWexpAO1a/6c909e1326aa792dbd0e120f3ccb6d73/Untitled_design-47.png?w=120&h=120&fit=pad)
 *
 * Did you know about National Home Security Month?
 *
 *
 */
export const IMG_EJ7NI6GOIOzSlWexpAO1a = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/EJ7NI6GOIOzSlWexpAO1a/6c909e1326aa792dbd0e120f3ccb6d73/Untitled_design-47.png',
  description: ``,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![How to build a home security system, step-by-step | SimpliSafe](https://images.ctfassets.net/v6awd0kabi65/5ygqxGL94bp3M9MwcleEa5/14fa17e6a74169a281fbddac421ce281/How_to_build_a_home_security_system__step-by-step.png?w=120&h=120&fit=pad)
 *
 * How to build a home security system, step-by-step | SimpliSafe
 *
 *
 */
export const IMG_5ygqxGL94bp3M9MwcleEa5 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5ygqxGL94bp3M9MwcleEa5/14fa17e6a74169a281fbddac421ce281/How_to_build_a_home_security_system__step-by-step.png',
  description: ``,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![simplicam body2](https://images.ctfassets.net/v6awd0kabi65/4W8Gs4rDeQAoPh6kLKuRLX/ae48f78c2a5971efcb5096a0279107e1/simplicambody2.jpeg?w=120&h=120&fit=pad)
 *
 * simplicam body2
 *
 * security camera
 */
export const IMG_4W8Gs4rDeQAoPh6kLKuRLX = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4W8Gs4rDeQAoPh6kLKuRLX/ae48f78c2a5971efcb5096a0279107e1/simplicambody2.jpeg',
  description: `security camera`,
  originalHeight: 335,
  originalWidth: 650
}

/**
 * ![simplicam body1](https://images.ctfassets.net/v6awd0kabi65/35B0UEMslOmVuB84SVoldH/3750ad14fdb0e77c208955a0bcac7e72/simplicambody1.jpeg?w=120&h=120&fit=pad)
 *
 * simplicam body1
 *
 * SimpliCam Integration
 */
export const IMG_35B0UEMslOmVuB84SVoldH = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/35B0UEMslOmVuB84SVoldH/3750ad14fdb0e77c208955a0bcac7e72/simplicambody1.jpeg',
  description: `SimpliCam Integration`,
  originalHeight: 433,
  originalWidth: 650
}

/**
 * ![Security Camera Next Level](https://images.ctfassets.net/v6awd0kabi65/2xyxpKAjhFfRteuiP1Xs2G/5991e290cee35ad2dbd974f390131025/simplicamfeature.png?w=120&h=120&fit=pad)
 *
 * Security Camera Next Level
 *
 * SimpliCam Integration
 */
export const IMG_2xyxpKAjhFfRteuiP1Xs2G = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2xyxpKAjhFfRteuiP1Xs2G/5991e290cee35ad2dbd974f390131025/simplicamfeature.png',
  description: `SimpliCam Integration`,
  originalHeight: 466,
  originalWidth: 716
}

/**
 * ![siren body2](https://images.ctfassets.net/v6awd0kabi65/4rPsO0zBxk8XFMqduGLrBs/e2dda57a49786d2c2008d17d83fe9db5/sirenbody2.png?w=120&h=120&fit=pad)
 *
 * siren body2
 *
 * protect your art
 */
export const IMG_4rPsO0zBxk8XFMqduGLrBs = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4rPsO0zBxk8XFMqduGLrBs/e2dda57a49786d2c2008d17d83fe9db5/sirenbody2.png',
  description: `protect your art`,
  originalHeight: 366,
  originalWidth: 650
}

/**
 * ![siren body1](https://images.ctfassets.net/v6awd0kabi65/6Sb0jIdd9QOsMZ8aautsSz/8da8e887b3cba6023ada0d85824bce79/sirenbody1.jpeg?w=120&h=120&fit=pad)
 *
 * siren body1
 *
 * protect your art
 */
export const IMG_6Sb0jIdd9QOsMZ8aautsSz = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6Sb0jIdd9QOsMZ8aautsSz/8da8e887b3cba6023ada0d85824bce79/sirenbody1.jpeg',
  description: `protect your art`,
  originalHeight: 392,
  originalWidth: 650
}

/**
 * ![Home Security Siren](https://images.ctfassets.net/v6awd0kabi65/41zbg5KAiAApGhAyx69YBf/69694dd356440bb8ffc7606fe7bb800b/sirenfeature.png?w=120&h=120&fit=pad)
 *
 * Home Security Siren
 *
 * Extra Auxiliary Siren
 */
export const IMG_41zbg5KAiAApGhAyx69YBf = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/41zbg5KAiAApGhAyx69YBf/69694dd356440bb8ffc7606fe7bb800b/sirenfeature.png',
  description: `Extra Auxiliary Siren`,
  originalHeight: 466,
  originalWidth: 716
}

/**
 * ![Key Fob - Feature](https://images.ctfassets.net/v6awd0kabi65/W9YBpb42jmvxxD3My6P9a/4229c63839f82b06eb10bf265b34b9ec/desktop_keyfob-sq_2x.jpg?w=120&h=120&fit=pad)
 *
 * Key Fob - Feature
 *
 * keyfob in hand
 */
export const IMG_W9YBpb42jmvxxD3My6P9a = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/W9YBpb42jmvxxD3My6P9a/4229c63839f82b06eb10bf265b34b9ec/desktop_keyfob-sq_2x.jpg',
  description: `keyfob in hand`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![keychain body1](https://images.ctfassets.net/v6awd0kabi65/5mtQ4NvkxnVGhOTIJJDs8R/7367d7c2dd330ca2267c96bfd169b391/keychainbody1.jpeg?w=120&h=120&fit=pad)
 *
 * keychain body1
 *
 * keychain remote
 */
export const IMG_5mtQ4NvkxnVGhOTIJJDs8R = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5mtQ4NvkxnVGhOTIJJDs8R/7367d7c2dd330ca2267c96bfd169b391/keychainbody1.jpeg',
  description: `keychain remote`,
  originalHeight: 366,
  originalWidth: 650
}

/**
 * ![HSW - Keyfob - Modal](https://images.ctfassets.net/v6awd0kabi65/6RD4aNmSK55YyUpCp6S6Ii/e358b60e46a5cee391e26d46dc8fe079/key-fob_modal.jpeg?w=120&h=120&fit=pad)
 *
 * HSW - Keyfob - Modal
 *
 * Image of a Black Keyfob with three buttons - from left to right: off, home, and away
 */
export const IMG_6RD4aNmSK55YyUpCp6S6Ii = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6RD4aNmSK55YyUpCp6S6Ii/e358b60e46a5cee391e26d46dc8fe079/key-fob_modal.jpeg',
  description: `Image of a Black Keyfob with three buttons - from left to right: off, home, and away`,
  originalHeight: 3600,
  originalWidth: 5760
}

/**
 * ![motion detector diagram](https://images.ctfassets.net/v6awd0kabi65/6rLEekVLxnwxC26EOLLe5Z/043d5a994545b40fb9f187c9e6614779/motion_sensor_home_security.jpeg?w=120&h=120&fit=pad)
 *
 * motion detector diagram
 *
 * Motion Detector Diagram
 */
export const IMG_6rLEekVLxnwxC26EOLLe5Z = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6rLEekVLxnwxC26EOLLe5Z/043d5a994545b40fb9f187c9e6614779/motion_sensor_home_security.jpeg',
  description: `Motion Detector Diagram`,
  originalHeight: 464,
  originalWidth: 650
}

/**
 * ![smoke detector placement house diagram](https://images.ctfassets.net/v6awd0kabi65/6ODGjQR0ThFsUjBNagdBtP/522f9ff1040347fc127540a4ca814bc6/smoke_detector_placement_house_diagram.png?w=120&h=120&fit=pad)
 *
 * smoke detector placement house diagram
 *
 * recommended smoke detector placement diagram
 */
export const IMG_6ODGjQR0ThFsUjBNagdBtP = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6ODGjQR0ThFsUjBNagdBtP/522f9ff1040347fc127540a4ca814bc6/smoke_detector_placement_house_diagram.png',
  description: `recommended smoke detector placement diagram`,
  originalHeight: 410,
  originalWidth: 500
}

/**
 * ![smoke detector action](https://images.ctfassets.net/v6awd0kabi65/5ZPFbHc6jXmYvxC3pyAUfz/b03672b872f6a58c41df6ed7a3aa42d0/smoke_detector_action.png?w=120&h=120&fit=pad)
 *
 * smoke detector action
 *
 * Smoke Detector in action
 */
export const IMG_5ZPFbHc6jXmYvxC3pyAUfz = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5ZPFbHc6jXmYvxC3pyAUfz/b03672b872f6a58c41df6ed7a3aa42d0/smoke_detector_action.png',
  description: `Smoke Detector in action`,
  originalHeight: 466,
  originalWidth: 716
}

/**
 * ![Smoke and Carbon Monoxide Detectors](https://images.ctfassets.net/v6awd0kabi65/1NrfZxhL5qDXbGtyuk1zdy/eeacb19c7103f2c6de482f678d255c07/smoke_co_detector.png?w=120&h=120&fit=pad)
 *
 * Smoke and Carbon Monoxide Detectors
 *
 * Smoke and Carbon Monoxide Detectors
 */
export const IMG_1NrfZxhL5qDXbGtyuk1zdy = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1NrfZxhL5qDXbGtyuk1zdy/eeacb19c7103f2c6de482f678d255c07/smoke_co_detector.png',
  description: `Smoke and Carbon Monoxide Detectors`,
  originalHeight: 466,
  originalWidth: 716
}

/**
 * ![instagram30](https://images.ctfassets.net/v6awd0kabi65/26zANv9S6YBiZjnlM8hrlG/edb28d72ac52fb2ca41a1b63f8e75631/instagram30.jpeg?w=120&h=120&fit=pad)
 *
 * instagram30
 *
 * motion sensor pets
 */
export const IMG_26zANv9S6YBiZjnlM8hrlG = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/26zANv9S6YBiZjnlM8hrlG/edb28d72ac52fb2ca41a1b63f8e75631/instagram30.jpeg',
  description: `motion sensor pets`,
  originalHeight: 799,
  originalWidth: 640
}

/**
 * ![motion alarm cats](https://images.ctfassets.net/v6awd0kabi65/17NzyBu0u6ScFTgQn6xiXb/bd3eda421a3ed319e348f387ca07474f/motionpetfeature.jpeg?w=120&h=120&fit=pad)
 *
 * motion alarm cats
 *
 * motion sensor dogs
 */
export const IMG_17NzyBu0u6ScFTgQn6xiXb = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/17NzyBu0u6ScFTgQn6xiXb/bd3eda421a3ed319e348f387ca07474f/motionpetfeature.jpeg',
  description: `motion sensor dogs`,
  originalHeight: 466,
  originalWidth: 716
}

/**
 * ![Keypad - Features](https://images.ctfassets.net/v6awd0kabi65/71YWxpptUlmMJVCiATO4hv/56ff10caf2467be1981633f9014b7444/desktop_extrakp-sq_2x.jpg?w=120&h=120&fit=pad)
 *
 * Keypad - Features
 *
 * keypad (cloud) placed on a wall
 */
export const IMG_71YWxpptUlmMJVCiATO4hv = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/71YWxpptUlmMJVCiATO4hv/56ff10caf2467be1981633f9014b7444/desktop_extrakp-sq_2x.jpg',
  description: `keypad (cloud) placed on a wall`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Glassbreak Sensor - Features](https://images.ctfassets.net/v6awd0kabi65/6qj9fB5vsOTUJQRel8WKKc/83df6d9ee5bc904d54be6f582cb2f41f/desktop_glassbreak-sq_2x.jpg?w=120&h=120&fit=pad)
 *
 * Glassbreak Sensor - Features
 *
 * glassbreak sensor on table
 */
export const IMG_6qj9fB5vsOTUJQRel8WKKc = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6qj9fB5vsOTUJQRel8WKKc/83df6d9ee5bc904d54be6f582cb2f41f/desktop_glassbreak-sq_2x.jpg',
  description: `glassbreak sensor on table`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Entry sensor in action](https://images.ctfassets.net/v6awd0kabi65/20T04ffwTExM9QehuzWgxj/edfa60018dbb1b19d98b2311290e6480/entry_sensor_in_action.gif?w=120&h=120&fit=pad)
 *
 * Entry sensor in action
 *
 * An entry sensor in action
 */
export const IMG_20T04ffwTExM9QehuzWgxj = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/20T04ffwTExM9QehuzWgxj/edfa60018dbb1b19d98b2311290e6480/entry_sensor_in_action.gif',
  description: `An entry sensor in action`,
  originalHeight: 202,
  originalWidth: 326
}

/**
 * ![entry sensor reed switch small](https://images.ctfassets.net/v6awd0kabi65/5USlVZKeKJTbmYwpNZfTc0/8c87de1bc874c4e3655ce4c650e3daa2/entry_sensor_reed_switch_small.png?w=120&h=120&fit=pad)
 *
 * entry sensor reed switch small
 *
 * Reed Switch diagram
 */
export const IMG_5USlVZKeKJTbmYwpNZfTc0 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5USlVZKeKJTbmYwpNZfTc0/8c87de1bc874c4e3655ce4c650e3daa2/entry_sensor_reed_switch_small.png',
  description: `Reed Switch diagram`,
  originalHeight: 385,
  originalWidth: 540
}

/**
 * ![Secret Alerts](https://images.ctfassets.net/v6awd0kabi65/3A5shFzlpyyFWejuXGdSNY/761ffd57116e845b51a24f522f6b150f/secret_alerts.jpg?w=120&h=120&fit=pad)
 *
 * Secret Alerts
 *
 *
 */
export const IMG_3A5shFzlpyyFWejuXGdSNY = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3A5shFzlpyyFWejuXGdSNY/761ffd57116e845b51a24f522f6b150f/secret_alerts.jpg',
  description: ``,
  originalHeight: 882,
  originalWidth: 1554
}

/**
 * ![Blake blue light armed](https://videos.ctfassets.net/v6awd0kabi65/6o5E84p9DkhUVzG6iR5C3w/fc975be2c2f9005c799bfb55e4613b9b/blake_blue_light_armed.mp4?w=120&h=120&fit=pad)
 *
 * Blake blue light armed
 *
 * Blake blue light armed
 */
export const IMG_6o5E84p9DkhUVzG6iR5C3w = {
  url: 'https://videos.ctfassets.net/v6awd0kabi65/6o5E84p9DkhUVzG6iR5C3w/fc975be2c2f9005c799bfb55e4613b9b/blake_blue_light_armed.mp4',
  description: `Blake blue light armed`,
  originalHeight: null,
  originalWidth: null
}

/**
 * ![Blake blue light flashing](https://videos.ctfassets.net/v6awd0kabi65/3dfbRRTFMjRIiWWUDpI30F/470183051ff0231da7538ebb1ea3ce57/blake_blue_light_flashing.mp4?w=120&h=120&fit=pad)
 *
 * Blake blue light flashing
 *
 * Blake blue light flashing
 */
export const IMG_3dfbRRTFMjRIiWWUDpI30F = {
  url: 'https://videos.ctfassets.net/v6awd0kabi65/3dfbRRTFMjRIiWWUDpI30F/470183051ff0231da7538ebb1ea3ce57/blake_blue_light_flashing.mp4',
  description: `Blake blue light flashing`,
  originalHeight: null,
  originalWidth: null
}

/**
 * ![Extra PIN body2](https://images.ctfassets.net/v6awd0kabi65/5c3kpuMSEpkK5zjgy1EPQE/637745a53895dcfb22911c7858dd63b8/extraPINbody2.jpeg?w=120&h=120&fit=pad)
 *
 * Extra PIN body2
 *
 * Security alarm PIN
 */
export const IMG_5c3kpuMSEpkK5zjgy1EPQE = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5c3kpuMSEpkK5zjgy1EPQE/637745a53895dcfb22911c7858dd63b8/extraPINbody2.jpeg',
  description: `Security alarm PIN`,
  originalHeight: 450,
  originalWidth: 650
}

/**
 * ![Extra PIN body1](https://images.ctfassets.net/v6awd0kabi65/6HInaez6bUaIhVXWIeRXw2/020166aad7549a55ea582d586b63da76/extraPINbody1.jpeg?w=120&h=120&fit=pad)
 *
 * Extra PIN body1
 *
 * home security PIN
 */
export const IMG_6HInaez6bUaIhVXWIeRXw2 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6HInaez6bUaIhVXWIeRXw2/020166aad7549a55ea582d586b63da76/extraPINbody1.jpeg',
  description: `home security PIN`,
  originalHeight: 450,
  originalWidth: 650
}

/**
 * ![Extra PIN Protection](https://images.ctfassets.net/v6awd0kabi65/1AUwrDuBu4yO9eXTSmBUcp/86f321c8b3b087e31f0556fb6a3098cf/extraPINfeature.jpeg?w=120&h=120&fit=pad)
 *
 * Extra PIN Protection
 *
 * Additional PIN safety
 */
export const IMG_1AUwrDuBu4yO9eXTSmBUcp = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1AUwrDuBu4yO9eXTSmBUcp/86f321c8b3b087e31f0556fb6a3098cf/extraPINfeature.jpeg',
  description: `Additional PIN safety`,
  originalHeight: 466,
  originalWidth: 716
}

/**
 * ![Win one of 3 x £100 SimpliSafe accessory vouchers](https://images.ctfassets.net/v6awd0kabi65/4hrlW8pjQsSdBCIPRfPJOO/9d84f04804fdde73ebeafb2ade93a164/800_x_450_No_Button_Video_Preview_Competition_August.png?w=120&h=120&fit=pad)
 *
 * Win one of 3 x £100 SimpliSafe accessory vouchers
 *
 * null
 */
export const IMG_4hrlW8pjQsSdBCIPRfPJOO = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4hrlW8pjQsSdBCIPRfPJOO/9d84f04804fdde73ebeafb2ade93a164/800_x_450_No_Button_Video_Preview_Competition_August.png',
  description: `null`,
  originalHeight: 450,
  originalWidth: 800
}

/**
 * ![Buyers guide home security](https://images.ctfassets.net/v6awd0kabi65/59HRsJTUVOPqC2cW7ho2ZL/53179b586c139780093fd512c4fe0fba/Buyersguidehomesecurity.gif?w=120&h=120&fit=pad)
 *
 * Buyers guide home security
 *
 * Buyers guide home security
 */
export const IMG_59HRsJTUVOPqC2cW7ho2ZL = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/59HRsJTUVOPqC2cW7ho2ZL/53179b586c139780093fd512c4fe0fba/Buyersguidehomesecurity.gif',
  description: `Buyers guide home security`,
  originalHeight: 600,
  originalWidth: 650
}

/**
 * ![Choose monitoring body2](https://images.ctfassets.net/v6awd0kabi65/4sgilSa51fWirmhU3t9D1q/5eb7c290235e994efc21c3f46ac749c2/choosemonitoringbody2.png?w=120&h=120&fit=pad)
 *
 * Choose monitoring body2
 *
 * Smart alert monitoring
 */
export const IMG_4sgilSa51fWirmhU3t9D1q = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4sgilSa51fWirmhU3t9D1q/5eb7c290235e994efc21c3f46ac749c2/choosemonitoringbody2.png',
  description: `Smart alert monitoring`,
  originalHeight: 466,
  originalWidth: 716
}

/**
 * ![Keypad White](https://images.ctfassets.net/v6awd0kabi65/1QdtwVvBwKTGWEzCFRIWkx/eb8ba1bb4cf25852804709794c79408b/carousel_keypad-white.jpg?w=120&h=120&fit=pad)
 *
 * Keypad White
 *
 * SimpliSafe Keypad
 */
export const IMG_1QdtwVvBwKTGWEzCFRIWkx = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1QdtwVvBwKTGWEzCFRIWkx/eb8ba1bb4cf25852804709794c79408b/carousel_keypad-white.jpg',
  description: `SimpliSafe Keypad`,
  originalHeight: 600,
  originalWidth: 680
}

/**
 * ![how to select the right pin ](https://images.ctfassets.net/v6awd0kabi65/2gYru9bduMilkhpXuariub/b0f7213d5ee64ba66eb4ac1f12c99f54/_MG_0035_color__1_.jpg?w=120&h=120&fit=pad)
 *
 * how to select the right pin
 *
 *
 */
export const IMG_2gYru9bduMilkhpXuariub = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2gYru9bduMilkhpXuariub/b0f7213d5ee64ba66eb4ac1f12c99f54/_MG_0035_color__1_.jpg',
  description: ``,
  originalHeight: 3744,
  originalWidth: 5616
}

/**
 * ![Protect restaurant body2](https://images.ctfassets.net/v6awd0kabi65/5RvIqrgdhSnuJ7GD8tcmJJ/84ac90988573eaef4c1f999b33ed85c7/protectrestaurantbody2.jpg?w=120&h=120&fit=pad)
 *
 * Protect restaurant body2
 *
 * Restaurant management
 */
export const IMG_5RvIqrgdhSnuJ7GD8tcmJJ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5RvIqrgdhSnuJ7GD8tcmJJ/84ac90988573eaef4c1f999b33ed85c7/protectrestaurantbody2.jpg',
  description: `Restaurant management`,
  originalHeight: 435,
  originalWidth: 650
}

/**
 * ![Protect Restaurant body1](https://images.ctfassets.net/v6awd0kabi65/4lJTAz63DebhEVH5n86Y8Z/e20f309a7ab076d723427c95da96b4ca/protectrestaurantbody1.jpeg?w=120&h=120&fit=pad)
 *
 * Protect Restaurant body1
 *
 * Restaurant security
 */
export const IMG_4lJTAz63DebhEVH5n86Y8Z = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4lJTAz63DebhEVH5n86Y8Z/e20f309a7ab076d723427c95da96b4ca/protectrestaurantbody1.jpeg',
  description: `Restaurant security`,
  originalHeight: 434,
  originalWidth: 650
}

/**
 * ![Security for your restaurant](https://images.ctfassets.net/v6awd0kabi65/57l7Bp03LK2l3uWGqeV1h/fd55f7ccd0d96e509c79c16d8acb4b29/protectrestaurantfeature.jpeg?w=120&h=120&fit=pad)
 *
 * Security for your restaurant
 *
 * Restaurant Protection
 */
export const IMG_57l7Bp03LK2l3uWGqeV1h = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/57l7Bp03LK2l3uWGqeV1h/fd55f7ccd0d96e509c79c16d8acb4b29/protectrestaurantfeature.jpeg',
  description: `Restaurant Protection`,
  originalHeight: 466,
  originalWidth: 716
}

/**
 * ![Layered body7](https://images.ctfassets.net/v6awd0kabi65/2Mv2YMSVbMyOl3pCFVjRIT/08e0d3a6dd9db22f2ad66a8371ca4a4c/layeredbody7.jpg?w=120&h=120&fit=pad)
 *
 * Layered body7
 *
 * Panic alarm
 */
export const IMG_2Mv2YMSVbMyOl3pCFVjRIT = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2Mv2YMSVbMyOl3pCFVjRIT/08e0d3a6dd9db22f2ad66a8371ca4a4c/layeredbody7.jpg',
  description: `Panic alarm`,
  originalHeight: 423,
  originalWidth: 650
}

/**
 * ![basement safety](https://images.ctfassets.net/v6awd0kabi65/7kfdBw6dZPDRzRMPpEujYZ/c891c5e6f7fd58ebc3dd3317a6eb26d7/_DSC2669.jpg?w=120&h=120&fit=pad)
 *
 * basement safety
 *
 *
 */
export const IMG_7kfdBw6dZPDRzRMPpEujYZ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7kfdBw6dZPDRzRMPpEujYZ/c891c5e6f7fd58ebc3dd3317a6eb26d7/_DSC2669.jpg',
  description: ``,
  originalHeight: 1406,
  originalWidth: 2500
}

/**
 * ![Serial Small](https://images.ctfassets.net/v6awd0kabi65/7s93Jd8yIu6w1k1yHpdFs7/e37c04be220b32a74f397d1bcc4f52fd/serial_small.jpg?w=120&h=120&fit=pad)
 *
 * Serial Small
 *
 * SimpliSafe Serial
 */
export const IMG_7s93Jd8yIu6w1k1yHpdFs7 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7s93Jd8yIu6w1k1yHpdFs7/e37c04be220b32a74f397d1bcc4f52fd/serial_small.jpg',
  description: `SimpliSafe Serial`,
  originalHeight: 330,
  originalWidth: 330
}

/**
 * ![Entry Sensor - Features](https://images.ctfassets.net/v6awd0kabi65/5yfy7q38e2wl57mrMCapXX/129a0aecc3d8af1bc3620995edc9be24/desktop_entry-sq_2x.jpg?w=120&h=120&fit=pad)
 *
 * Entry Sensor - Features
 *
 * entry sensor on door frame
 */
export const IMG_5yfy7q38e2wl57mrMCapXX = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5yfy7q38e2wl57mrMCapXX/129a0aecc3d8af1bc3620995edc9be24/desktop_entry-sq_2x.jpg',
  description: `entry sensor on door frame`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Untitled design-40](https://images.ctfassets.net/v6awd0kabi65/5dAU8dE1NElj1xK9hRS4hO/86b8b011d3d500a5bb8ddf6f14c19b0b/Untitled_design-40.webp?w=120&h=120&fit=pad)
 *
 * Untitled design-40
 *
 *
 */
export const IMG_5dAU8dE1NElj1xK9hRS4hO = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5dAU8dE1NElj1xK9hRS4hO/86b8b011d3d500a5bb8ddf6f14c19b0b/Untitled_design-40.webp',
  description: ``,
  originalHeight: 513,
  originalWidth: 715
}

/**
 * ![CRIME IN LEICESTER](https://images.ctfassets.net/v6awd0kabi65/34odxqqKEuHuc3ohwoSLvB/4a83135d964d581b939c84870a25f89d/CRIME_IN_LEICESTER.png?w=120&h=120&fit=pad)
 *
 * CRIME IN LEICESTER
 *
 * null
 */
export const IMG_34odxqqKEuHuc3ohwoSLvB = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/34odxqqKEuHuc3ohwoSLvB/4a83135d964d581b939c84870a25f89d/CRIME_IN_LEICESTER.png',
  description: `null`,
  originalHeight: 5001,
  originalWidth: 5001
}

/**
 * ![Half of UK - Content 2](https://images.ctfassets.net/v6awd0kabi65/6VGBXLLjVIP5vdcSAANDwh/ae103ced7cc1fc2f275d809adb650078/Half_of_UK_-_Content_2.png?w=120&h=120&fit=pad)
 *
 * Half of UK - Content 2
 *
 * Moving Screen
 */
export const IMG_6VGBXLLjVIP5vdcSAANDwh = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6VGBXLLjVIP5vdcSAANDwh/ae103ced7cc1fc2f275d809adb650078/Half_of_UK_-_Content_2.png',
  description: `Moving Screen`,
  originalHeight: 846,
  originalWidth: 1200
}

/**
 * ![Half of UK - Content 1](https://images.ctfassets.net/v6awd0kabi65/4tBEXjVDhAA90coUUffbKN/dde8aeb1ef24ba3771167a64fc5bb121/Half_of_UK_-_Content_1.png?w=120&h=120&fit=pad)
 *
 * Half of UK - Content 1
 *
 * Moving Screen
 */
export const IMG_4tBEXjVDhAA90coUUffbKN = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4tBEXjVDhAA90coUUffbKN/dde8aeb1ef24ba3771167a64fc5bb121/Half_of_UK_-_Content_1.png',
  description: `Moving Screen`,
  originalHeight: 846,
  originalWidth: 1200
}

/**
 * ![Home and Away Mode 101 - Content 5](https://images.ctfassets.net/v6awd0kabi65/2GvCgNheho4IQwF1Le9U2L/184d4d4f21ec55f4955cdd514ced6fb4/Home_and_Away_Mode_101_-_Content_5.png?w=120&h=120&fit=pad)
 *
 * Home and Away Mode 101 - Content 5
 *
 * table 4
 */
export const IMG_2GvCgNheho4IQwF1Le9U2L = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2GvCgNheho4IQwF1Le9U2L/184d4d4f21ec55f4955cdd514ced6fb4/Home_and_Away_Mode_101_-_Content_5.png',
  description: `table 4`,
  originalHeight: 660,
  originalWidth: 1334
}

/**
 * ![Home and Away Mode 101 - Content 4](https://images.ctfassets.net/v6awd0kabi65/7GVWpFOF1Y6uE5zynqDmyz/bd95936909b7f81ad595153eb222a5b6/Home_and_Away_Mode_101_-_Content_4.png?w=120&h=120&fit=pad)
 *
 * Home and Away Mode 101 - Content 4
 *
 * table 3
 */
export const IMG_7GVWpFOF1Y6uE5zynqDmyz = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7GVWpFOF1Y6uE5zynqDmyz/bd95936909b7f81ad595153eb222a5b6/Home_and_Away_Mode_101_-_Content_4.png',
  description: `table 3`,
  originalHeight: 450,
  originalWidth: 1116
}

/**
 * ![Home and Away Mode 101 - Content 3](https://images.ctfassets.net/v6awd0kabi65/B9iIlxbZ28NwiVC44LacT/0bd9b91d97187e654938c9af42099cc6/Home_and_Away_Mode_101_-_Content_3.png?w=120&h=120&fit=pad)
 *
 * Home and Away Mode 101 - Content 3
 *
 * table 2
 */
export const IMG_B9iIlxbZ28NwiVC44LacT = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/B9iIlxbZ28NwiVC44LacT/0bd9b91d97187e654938c9af42099cc6/Home_and_Away_Mode_101_-_Content_3.png',
  description: `table 2`,
  originalHeight: 450,
  originalWidth: 1116
}

/**
 * ![Home and Away Mode 101 - Content 2](https://images.ctfassets.net/v6awd0kabi65/REpA8x82nBSOd98X484n9/0dcbb498445fe9992afa2dcca4bda8bf/Home_and_Away_Mode_101_-_Content_2.png?w=120&h=120&fit=pad)
 *
 * Home and Away Mode 101 - Content 2
 *
 * table 1
 */
export const IMG_REpA8x82nBSOd98X484n9 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/REpA8x82nBSOd98X484n9/0dcbb498445fe9992afa2dcca4bda8bf/Home_and_Away_Mode_101_-_Content_2.png',
  description: `table 1`,
  originalHeight: 499,
  originalWidth: 1334
}

/**
 * ![Home and Away Mode 101 - Content 1](https://images.ctfassets.net/v6awd0kabi65/7o2i9LdY7eGNRJAqHGuEHL/b1ef010533bdfd3f6f9f89366af3e03f/Home_and_Away_Mode_101_-_Content_1.png?w=120&h=120&fit=pad)
 *
 * Home and Away Mode 101 - Content 1
 *
 * key fob
 */
export const IMG_7o2i9LdY7eGNRJAqHGuEHL = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7o2i9LdY7eGNRJAqHGuEHL/b1ef010533bdfd3f6f9f89366af3e03f/Home_and_Away_Mode_101_-_Content_1.png',
  description: `key fob`,
  originalHeight: 672,
  originalWidth: 732
}

/**
 * ![outdoor-camera-mount-background](https://images.ctfassets.net/v6awd0kabi65/7hgBGn50GxjTKTYyZY3KZQ/23a5509348ba25d752130d338be4ab2f/outdoor-camera-mount-background.png?w=120&h=120&fit=pad)
 *
 * outdoor-camera-mount-background
 *
 *
 */
export const IMG_7hgBGn50GxjTKTYyZY3KZQ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7hgBGn50GxjTKTYyZY3KZQ/23a5509348ba25d752130d338be4ab2f/outdoor-camera-mount-background.png',
  description: ``,
  originalHeight: 1684,
  originalWidth: 2490
}

/**
 * ![wi-fi-extender-background](https://images.ctfassets.net/v6awd0kabi65/6Tk5QXETbLgZUkEwoIoTFb/a4df3b6ff13c113c5223b8b6ec5463e8/wi-fi-extender-background.png?w=120&h=120&fit=pad)
 *
 * wi-fi-extender-background
 *
 *
 */
export const IMG_6Tk5QXETbLgZUkEwoIoTFb = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6Tk5QXETbLgZUkEwoIoTFb/a4df3b6ff13c113c5223b8b6ec5463e8/wi-fi-extender-background.png',
  description: ``,
  originalHeight: 398,
  originalWidth: 604
}

/**
 * ![window-decals-background](https://images.ctfassets.net/v6awd0kabi65/1aZfEIJhT22QrDEayaRwV4/0e07551dd1e1b219bec917aa32a4d384/window-decals-background.png?w=120&h=120&fit=pad)
 *
 * window-decals-background
 *
 *
 */
export const IMG_1aZfEIJhT22QrDEayaRwV4 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1aZfEIJhT22QrDEayaRwV4/0e07551dd1e1b219bec917aa32a4d384/window-decals-background.png',
  description: ``,
  originalHeight: 430,
  originalWidth: 554
}

/**
 * ![window-decals](https://images.ctfassets.net/v6awd0kabi65/1XmPBhTQBOIVhu0LCsqG8/01b7cf8d73ce949bf3ae96a42bdac178/window-decals.png?w=120&h=120&fit=pad)
 *
 * window-decals
 *
 *
 */
export const IMG_1XmPBhTQBOIVhu0LCsqG8 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1XmPBhTQBOIVhu0LCsqG8/01b7cf8d73ce949bf3ae96a42bdac178/window-decals.png',
  description: ``,
  originalHeight: 375,
  originalWidth: 345
}

/**
 * ![outdoor-camera-mount](https://images.ctfassets.net/v6awd0kabi65/6btFyF4ej1vIrZjINzWCHA/3bdfe1bdd97d1d7b83eb8d36aaf62de2/outdoor-camera-mount.png?w=120&h=120&fit=pad)
 *
 * outdoor-camera-mount
 *
 *
 */
export const IMG_6btFyF4ej1vIrZjINzWCHA = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6btFyF4ej1vIrZjINzWCHA/3bdfe1bdd97d1d7b83eb8d36aaf62de2/outdoor-camera-mount.png',
  description: ``,
  originalHeight: 401,
  originalWidth: 369
}

/**
 * ![Panic Button (SS2)](https://images.ctfassets.net/v6awd0kabi65/6a6AwiJy83004etw4O4vRF/2235e1d406fe5509684fce71aadcdf1f/entry_transparent_1.png?w=120&h=120&fit=pad)
 *
 * Panic Button (SS2)
 *
 *
 */
export const IMG_6a6AwiJy83004etw4O4vRF = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6a6AwiJy83004etw4O4vRF/2235e1d406fe5509684fce71aadcdf1f/entry_transparent_1.png',
  description: ``,
  originalHeight: 416,
  originalWidth: 521
}

/**
 * ![Siren (SS2)](https://images.ctfassets.net/v6awd0kabi65/22ZusxeG16GQehZV2ULSOH/b5c347b06e6982877a74423b44af8059/entry_transparent_1__2_.png?w=120&h=120&fit=pad)
 *
 * Siren (SS2)
 *
 *
 */
export const IMG_22ZusxeG16GQehZV2ULSOH = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/22ZusxeG16GQehZV2ULSOH/b5c347b06e6982877a74423b44af8059/entry_transparent_1__2_.png',
  description: ``,
  originalHeight: 334,
  originalWidth: 307
}

/**
 * ![Keychain Remote (SS2)](https://images.ctfassets.net/v6awd0kabi65/6KODItqLg1ZaXOXGHZlEAI/f01cacc6885ed3fb7d1be881fb231a2f/entry_transparent_1__1_.png?w=120&h=120&fit=pad)
 *
 * Keychain Remote (SS2)
 *
 *
 */
export const IMG_6KODItqLg1ZaXOXGHZlEAI = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6KODItqLg1ZaXOXGHZlEAI/f01cacc6885ed3fb7d1be881fb231a2f/entry_transparent_1__1_.png',
  description: ``,
  originalHeight: 393,
  originalWidth: 362
}

/**
 * ![Glassbreak Sensor (SS2)](https://images.ctfassets.net/v6awd0kabi65/4g6DJJAPB2OEW8tDkhQk8L/1b33eb074ea0c66a81b0897b2862ef62/entry_transparent_1.png?w=120&h=120&fit=pad)
 *
 * Glassbreak Sensor (SS2)
 *
 *
 */
export const IMG_4g6DJJAPB2OEW8tDkhQk8L = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4g6DJJAPB2OEW8tDkhQk8L/1b33eb074ea0c66a81b0897b2862ef62/entry_transparent_1.png',
  description: ``,
  originalHeight: 430,
  originalWidth: 504
}

/**
 * ![Entry Sensor (SS2)](https://images.ctfassets.net/v6awd0kabi65/2uTcffhcgWIcmtSIBUqPow/0bffb33b178ea5a4bd2f190e4951a472/entry_transparent_1.png?w=120&h=120&fit=pad)
 *
 * Entry Sensor (SS2)
 *
 *
 */
export const IMG_2uTcffhcgWIcmtSIBUqPow = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2uTcffhcgWIcmtSIBUqPow/0bffb33b178ea5a4bd2f190e4951a472/entry_transparent_1.png',
  description: ``,
  originalHeight: 396,
  originalWidth: 365
}

/**
 * ![Motion Sensor (SS2)](https://images.ctfassets.net/v6awd0kabi65/7mP34BOrxMc78tjHKWtC63/5173d75af554ca723771a90001928e96/entry_transparent_1.png?w=120&h=120&fit=pad)
 *
 * Motion Sensor (SS2)
 *
 *
 */
export const IMG_7mP34BOrxMc78tjHKWtC63 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7mP34BOrxMc78tjHKWtC63/5173d75af554ca723771a90001928e96/entry_transparent_1.png',
  description: ``,
  originalHeight: 416,
  originalWidth: 402
}

/**
 * ![Smoke & Carbon Monoxide Detector Lifestyle](https://images.ctfassets.net/v6awd0kabi65/1HqUC8CB3tMa2sUwABbQbR/0000ea71b49e6d856fb49ada73b7ba3b/RED_22-0114-context_2_studio.1_portrait.jpg?w=120&h=120&fit=pad)
 *
 * Smoke & Carbon Monoxide Detector Lifestyle
 *
 * Image of Smoke & Carbon Monoxide Detector installed on bedroom ceiling
 */
export const IMG_1HqUC8CB3tMa2sUwABbQbR = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1HqUC8CB3tMa2sUwABbQbR/0000ea71b49e6d856fb49ada73b7ba3b/RED_22-0114-context_2_studio.1_portrait.jpg',
  description: `Image of Smoke & Carbon Monoxide Detector installed on bedroom ceiling`,
  originalHeight: 530,
  originalWidth: 530
}

/**
 * ![Smoke & Carbon Monoxide Detector (With Background)](https://images.ctfassets.net/v6awd0kabi65/7qWqwYz4AWQ1uf5J6Nubdp/e28c21da60fcbff7a79d09bc5bb9adff/Smoke-and-Carbon-Monoxide-Detector.png?w=120&h=120&fit=pad)
 *
 * Smoke & Carbon Monoxide Detector (With Background)
 *
 * Smoke & Carbon Monoxide Detector
 */
export const IMG_7qWqwYz4AWQ1uf5J6Nubdp = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7qWqwYz4AWQ1uf5J6Nubdp/e28c21da60fcbff7a79d09bc5bb9adff/Smoke-and-Carbon-Monoxide-Detector.png',
  description: `Smoke & Carbon Monoxide Detector`,
  originalHeight: 619,
  originalWidth: 554
}

/**
 * ![Smoke & Carbon Monoxide Detector](https://images.ctfassets.net/v6awd0kabi65/3rN42sEZIQSw3asIuzchPw/c77aef970d1f6b5c99cea426d2fdf6c3/Smoke.png?w=120&h=120&fit=pad)
 *
 * Smoke & Carbon Monoxide Detector
 *
 * Smoke & Carbon Monoxide Detector
 */
export const IMG_3rN42sEZIQSw3asIuzchPw = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3rN42sEZIQSw3asIuzchPw/c77aef970d1f6b5c99cea426d2fdf6c3/Smoke.png',
  description: `Smoke & Carbon Monoxide Detector`,
  originalHeight: 197,
  originalWidth: 197
}

/**
 * ![Alarm Sensors Disclaimer](https://images.ctfassets.net/v6awd0kabi65/2kO7yT72zOZqWQuPeb8IVL/9844b672ebbe8581b8b6a5161743999e/disclaimerimg.png?w=120&h=120&fit=pad)
 *
 * Alarm Sensors Disclaimer
 *
 * Base System SS3 Image
 */
export const IMG_2kO7yT72zOZqWQuPeb8IVL = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2kO7yT72zOZqWQuPeb8IVL/9844b672ebbe8581b8b6a5161743999e/disclaimerimg.png',
  description: `Base System SS3 Image`,
  originalHeight: 2724,
  originalWidth: 1394
}

/**
 * ![Hero - Flatlay Image](https://images.ctfassets.net/v6awd0kabi65/2PiLtbZ0bIhcyFD4SByiAP/4eb44135382d64f097b92d96adbb1efe/hero_meet-the-system.jpg?w=120&h=120&fit=pad)
 *
 * Hero - Flatlay Image
 *
 *
 */
export const IMG_2PiLtbZ0bIhcyFD4SByiAP = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2PiLtbZ0bIhcyFD4SByiAP/4eb44135382d64f097b92d96adbb1efe/hero_meet-the-system.jpg',
  description: ``,
  originalHeight: 960,
  originalWidth: 2630
}

/**
 * ![Hero - Build my system](https://images.ctfassets.net/v6awd0kabi65/6EQMbkhRI6AEltGJVGUAMY/7c0588f3e1319e3a77e799a9e442aa21/hero_build_my_system_uk.jpeg?w=120&h=120&fit=pad)
 *
 * Hero - Build my system
 *
 *
 */
export const IMG_6EQMbkhRI6AEltGJVGUAMY = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6EQMbkhRI6AEltGJVGUAMY/7c0588f3e1319e3a77e799a9e442aa21/hero_build_my_system_uk.jpeg',
  description: ``,
  originalHeight: 2250,
  originalWidth: 3000
}

/**
 * ![Hero - Shop packages](https://images.ctfassets.net/v6awd0kabi65/65Hs4S0g1YRv1xM0mjOGTh/839a0746f578f0a6f415b5ad355c633e/hero_shop_packages.png?w=120&h=120&fit=pad)
 *
 * Hero - Shop packages
 *
 *
 */
export const IMG_65Hs4S0g1YRv1xM0mjOGTh = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/65Hs4S0g1YRv1xM0mjOGTh/839a0746f578f0a6f415b5ad355c633e/hero_shop_packages.png',
  description: ``,
  originalHeight: 1200,
  originalWidth: 1284
}

/**
 * ![Hero - Build my system](https://images.ctfassets.net/v6awd0kabi65/2Ge7R4bABAO0BsuuFBLyxt/e6644057110431ea93895123ed1c0832/hero_build_my_system.png?w=120&h=120&fit=pad)
 *
 * Hero - Build my system
 *
 *
 */
export const IMG_2Ge7R4bABAO0BsuuFBLyxt = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2Ge7R4bABAO0BsuuFBLyxt/e6644057110431ea93895123ed1c0832/hero_build_my_system.png',
  description: ``,
  originalHeight: 1200,
  originalWidth: 1326
}

/**
 * ![Hero - Eve - Mobile](https://images.ctfassets.net/v6awd0kabi65/5RzLc3snvO2iGrR9uHAPrt/7ad346d9473651ea085b69bd5fccc6ae/UK_Hero_mobile-min.png?w=120&h=120&fit=pad)
 *
 * Hero - Eve - Mobile
 *
 *
 */
export const IMG_5RzLc3snvO2iGrR9uHAPrt = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5RzLc3snvO2iGrR9uHAPrt/7ad346d9473651ea085b69bd5fccc6ae/UK_Hero_mobile-min.png',
  description: ``,
  originalHeight: 800,
  originalWidth: 750
}

/**
 * ![Hero - Eve - Tablet](https://images.ctfassets.net/v6awd0kabi65/4YaYrRqV2DJa8WTFOd2lbK/1f4568b45d219937c92328a743d70410/UK_Hero_tablet-min.png?w=120&h=120&fit=pad)
 *
 * Hero - Eve - Tablet
 *
 *
 */
export const IMG_4YaYrRqV2DJa8WTFOd2lbK = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4YaYrRqV2DJa8WTFOd2lbK/1f4568b45d219937c92328a743d70410/UK_Hero_tablet-min.png',
  description: ``,
  originalHeight: 1200,
  originalWidth: 2173
}

/**
 * ![Hero - Eve - Desktop](https://images.ctfassets.net/v6awd0kabi65/5V6aMm9Y08F8Aj6ujuQfUL/fca3b958120dd1e69e2e83e2212df083/UK_Hero_desktop-min.png?w=120&h=120&fit=pad)
 *
 * Hero - Eve - Desktop
 *
 *
 */
export const IMG_5V6aMm9Y08F8Aj6ujuQfUL = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5V6aMm9Y08F8Aj6ujuQfUL/fca3b958120dd1e69e2e83e2212df083/UK_Hero_desktop-min.png',
  description: ``,
  originalHeight: 1200,
  originalWidth: 2400
}

/**
 * ![Built-to-last icon](https://images.ctfassets.net/v6awd0kabi65/2q3u6NMJJp8WnNV2WzwjkH/b386e6d0da270c28fbbebc52f43fab9d/Refresh.svg?w=120&h=120&fit=pad)
 *
 * Built-to-last icon
 *
 *
 */
export const IMG_2q3u6NMJJp8WnNV2WzwjkH = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2q3u6NMJJp8WnNV2WzwjkH/b386e6d0da270c28fbbebc52f43fab9d/Refresh.svg',
  description: ``,
  originalHeight: 33,
  originalWidth: 33
}

/**
 * ![24/7 monitoring](https://images.ctfassets.net/v6awd0kabi65/47F7aP5lNJVPlS41YwWqG3/82922baca39bd0c7587bafa1cc8bb0cc/Headphone_icon.svg?w=120&h=120&fit=pad)
 *
 * 24/7 monitoring
 *
 *
 */
export const IMG_47F7aP5lNJVPlS41YwWqG3 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/47F7aP5lNJVPlS41YwWqG3/82922baca39bd0c7587bafa1cc8bb0cc/Headphone_icon.svg',
  description: ``,
  originalHeight: 40,
  originalWidth: 40
}

/**
 * ![Lock icon](https://images.ctfassets.net/v6awd0kabi65/5j0NwWZhfPSy872kEOJPs6/018f1e0f875e21533eb3e23207c714c3/Lock.svg?w=120&h=120&fit=pad)
 *
 * Lock icon
 *
 *
 */
export const IMG_5j0NwWZhfPSy872kEOJPs6 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5j0NwWZhfPSy872kEOJPs6/018f1e0f875e21533eb3e23207c714c3/Lock.svg',
  description: ``,
  originalHeight: 35,
  originalWidth: 22
}

/**
 * ![Plug it in](https://images.ctfassets.net/v6awd0kabi65/40zU1dsoXE2Or5xuIcOUu7/9a55e7834fd1fa6e479da3f9476c8522/Wire.svg?w=120&h=120&fit=pad)
 *
 * Plug it in
 *
 *
 */
export const IMG_40zU1dsoXE2Or5xuIcOUu7 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/40zU1dsoXE2Or5xuIcOUu7/9a55e7834fd1fa6e479da3f9476c8522/Wire.svg',
  description: ``,
  originalHeight: 33,
  originalWidth: 23
}

/**
 * ![Smart Lock](https://images.ctfassets.net/v6awd0kabi65/723zuDiSzNudBGoW15d8gJ/e01554abca5aaa2b034f427e3e52129a/smart_lock.jpg?w=120&h=120&fit=pad)
 *
 * Smart Lock
 *
 *
 */
export const IMG_723zuDiSzNudBGoW15d8gJ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/723zuDiSzNudBGoW15d8gJ/e01554abca5aaa2b034f427e3e52129a/smart_lock.jpg',
  description: ``,
  originalHeight: 1000,
  originalWidth: 1336
}

/**
 * ![Complete Control](https://images.ctfassets.net/v6awd0kabi65/15nePM8Zheec0z7ze439Fy/da960d50a2e12acdb1617a52b91368f0/complete_control.png?w=120&h=120&fit=pad)
 *
 * Complete Control
 *
 *
 */
export const IMG_15nePM8Zheec0z7ze439Fy = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/15nePM8Zheec0z7ze439Fy/da960d50a2e12acdb1617a52b91368f0/complete_control.png',
  description: ``,
  originalHeight: 1099,
  originalWidth: 850
}

/**
 * ![SimpliCam Product Hero Banner - Media](https://images.ctfassets.net/v6awd0kabi65/5uXtvjQz6SB61GcwqIUVWi/d30bff811963d237aa2f9e19a69ce3e6/simplicam-hero_2x.jpeg?w=120&h=120&fit=pad)
 *
 * SimpliCam Product Hero Banner - Media
 *
 *
 */
export const IMG_5uXtvjQz6SB61GcwqIUVWi = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5uXtvjQz6SB61GcwqIUVWi/d30bff811963d237aa2f9e19a69ce3e6/simplicam-hero_2x.jpeg',
  description: ``,
  originalHeight: 3092,
  originalWidth: 4912
}

/**
 * ![iPhoneX Doorbell](https://images.ctfassets.net/v6awd0kabi65/3kaDjKYb8FmeN30PK3tnh1/903a611d2aa2c3f0217026aef1f6d700/vdp-iphonex.png?w=120&h=120&fit=pad)
 *
 * iPhoneX Doorbell
 *
 * iPhoneX displaying Doorbell camera feed
 */
export const IMG_3kaDjKYb8FmeN30PK3tnh1 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3kaDjKYb8FmeN30PK3tnh1/903a611d2aa2c3f0217026aef1f6d700/vdp-iphonex.png',
  description: `iPhoneX displaying Doorbell camera feed`,
  originalHeight: 794,
  originalWidth: 1280
}

/**
 * ![Doorbell Guarantee](https://images.ctfassets.net/v6awd0kabi65/7eJjgJx7Wal8d5agBSwKWA/45aa11f4e74396f8f2dcb32d1bc5de27/doorbell-box-w-guarantee.png?w=120&h=120&fit=pad)
 *
 * Doorbell Guarantee
 *
 * SimpliSafe Doorbell box and 100% satisfaction guarantee badge
 */
export const IMG_7eJjgJx7Wal8d5agBSwKWA = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7eJjgJx7Wal8d5agBSwKWA/45aa11f4e74396f8f2dcb32d1bc5de27/doorbell-box-w-guarantee.png',
  description: `SimpliSafe Doorbell box and 100% satisfaction guarantee badge`,
  originalHeight: 996,
  originalWidth: 1048
}

/**
 * ![Say Hello - outdoor camera](https://images.ctfassets.net/v6awd0kabi65/4eaJi1fX6IHdBkV3KQJGUF/cd9b7be411ffa9cb127e286f58a13d7f/Say_hello_-_Outdoor_Camera.jpeg?w=120&h=120&fit=pad)
 *
 * Say Hello - outdoor camera
 *
 *
 */
export const IMG_4eaJi1fX6IHdBkV3KQJGUF = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4eaJi1fX6IHdBkV3KQJGUF/cd9b7be411ffa9cb127e286f58a13d7f/Say_hello_-_Outdoor_Camera.jpeg',
  description: ``,
  originalHeight: 1200,
  originalWidth: 1601
}

/**
 * ![Meet Doorbell Pro](https://images.ctfassets.net/v6awd0kabi65/7NZkTP7IivK0BunCiesnG/4ff9259a65be9c272b5bba6f911fb9e5/doorbell-diagram.png?w=120&h=120&fit=pad)
 *
 * Meet Doorbell Pro
 *
 *
 */
export const IMG_7NZkTP7IivK0BunCiesnG = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7NZkTP7IivK0BunCiesnG/4ff9259a65be9c272b5bba6f911fb9e5/doorbell-diagram.png',
  description: ``,
  originalHeight: 1436,
  originalWidth: 1730
}

/**
 * ![SimpliSafe Bell Box installation](https://images.ctfassets.net/v6awd0kabi65/1HXw2vzw1nPN4o6IyRkUSM/547591ee37deb6b66ad054a9f428a117/Eve-3.png?w=120&h=120&fit=pad)
 *
 * SimpliSafe Bell Box installation
 *
 *
 */
export const IMG_1HXw2vzw1nPN4o6IyRkUSM = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1HXw2vzw1nPN4o6IyRkUSM/547591ee37deb6b66ad054a9f428a117/Eve-3.png',
  description: ``,
  originalHeight: 1094,
  originalWidth: 1346
}

/**
 * ![SimpliSafe Base Station on Table](https://images.ctfassets.net/v6awd0kabi65/1Cy9mVDoDcQ3ZCKplGd5oz/6233d8dd300b350fc1eb323a94080021/vdp_base-on-bookshelf.jpeg?w=120&h=120&fit=pad)
 *
 * SimpliSafe Base Station on Table
 *
 * SimpliSafe Base Station on top of a table
 */
export const IMG_1Cy9mVDoDcQ3ZCKplGd5oz = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1Cy9mVDoDcQ3ZCKplGd5oz/6233d8dd300b350fc1eb323a94080021/vdp_base-on-bookshelf.jpeg',
  description: `SimpliSafe Base Station on top of a table`,
  originalHeight: 1404,
  originalWidth: 1838
}

/**
 * ![Core components](https://images.ctfassets.net/v6awd0kabi65/5Hic2XM0YfDEKl4zAcjpjQ/aa488577ad3688a031e2457133179fc0/core-components_2x__1_.jpeg?w=120&h=120&fit=pad)
 *
 * Core components
 *
 *
 */
export const IMG_5Hic2XM0YfDEKl4zAcjpjQ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5Hic2XM0YfDEKl4zAcjpjQ/aa488577ad3688a031e2457133179fc0/core-components_2x__1_.jpeg',
  description: ``,
  originalHeight: 980,
  originalWidth: 1334
}

/**
 * ![Homepage Hero with offer (UK | Mobile)](https://images.ctfassets.net/v6awd0kabi65/5A9fy8pxFiVBI8gvTRRrv2/6733c6b8fa26b5a73ce6d6de71c46f86/System_Mobile_1029x837_____1_-_S2.png?w=120&h=120&fit=pad)
 *
 * Homepage Hero with offer (UK | Mobile)
 *
 *
 */
export const IMG_5A9fy8pxFiVBI8gvTRRrv2 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5A9fy8pxFiVBI8gvTRRrv2/6733c6b8fa26b5a73ce6d6de71c46f86/System_Mobile_1029x837_____1_-_S2.png',
  description: ``,
  originalHeight: 837,
  originalWidth: 1029
}

/**
 * ![Homepage Hero with offer (UK | Tablet)](https://images.ctfassets.net/v6awd0kabi65/UARd76ccfoUZmdPB6nglH/10ce8ed0f3f318a82a8ae05b2205338d/System_Tablet_2307x1497_____1_-_S2.png?w=120&h=120&fit=pad)
 *
 * Homepage Hero with offer (UK | Tablet)
 *
 *
 */
export const IMG_UARd76ccfoUZmdPB6nglH = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/UARd76ccfoUZmdPB6nglH/10ce8ed0f3f318a82a8ae05b2205338d/System_Tablet_2307x1497_____1_-_S2.png',
  description: ``,
  originalHeight: 1497,
  originalWidth: 2307
}

/**
 * ![Homepage Hero with offer (UK | Desktop)](https://images.ctfassets.net/v6awd0kabi65/7x4xZnbDSQOlEdxoVJteUd/0b3df28e04a265e7b435a38df87fa843/System_3936x1800px_____1_-_S2.png?w=120&h=120&fit=pad)
 *
 * Homepage Hero with offer (UK | Desktop)
 *
 *
 */
export const IMG_7x4xZnbDSQOlEdxoVJteUd = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7x4xZnbDSQOlEdxoVJteUd/0b3df28e04a265e7b435a38df87fa843/System_3936x1800px_____1_-_S2.png',
  description: ``,
  originalHeight: 1800,
  originalWidth: 3936
}

/**
 * ![Video Doorbell Angled on Glass](https://images.ctfassets.net/v6awd0kabi65/xko5lh2foTmzQFpS4hg2L/b600836e4fb4a4bd2924a7fdf72f14b0/desktop_doorbell-angled-glass-door.jpeg?w=120&h=120&fit=pad)
 *
 * Video Doorbell Angled on Glass
 *
 *
 */
export const IMG_xko5lh2foTmzQFpS4hg2L = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/xko5lh2foTmzQFpS4hg2L/b600836e4fb4a4bd2924a7fdf72f14b0/desktop_doorbell-angled-glass-door.jpeg',
  description: ``,
  originalHeight: 1202,
  originalWidth: 1280
}

/**
 * ![Doorbell Pro iPhone Messages](https://images.ctfassets.net/v6awd0kabi65/23xEKXe2PWL1BLA1pfDURx/55e6d5c086255c1d9c548594e8ac502a/messages.png?w=120&h=120&fit=pad)
 *
 * Doorbell Pro iPhone Messages
 *
 *
 */
export const IMG_23xEKXe2PWL1BLA1pfDURx = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/23xEKXe2PWL1BLA1pfDURx/55e6d5c086255c1d9c548594e8ac502a/messages.png',
  description: ``,
  originalHeight: 562,
  originalWidth: 1028
}

/**
 * ![SimpliSafe Doorbell on wooden wall](https://images.ctfassets.net/v6awd0kabi65/69DFQ1WTqt294JPfqyZFXs/d17c29f5d739ec4007c46ac5461387e9/vdp_flowerpot.jpeg?w=120&h=120&fit=pad)
 *
 * SimpliSafe Doorbell on wooden wall
 *
 * SimpliSafe Doorbell on wooden wall
 */
export const IMG_69DFQ1WTqt294JPfqyZFXs = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/69DFQ1WTqt294JPfqyZFXs/d17c29f5d739ec4007c46ac5461387e9/vdp_flowerpot.jpeg',
  description: `SimpliSafe Doorbell on wooden wall`,
  originalHeight: 1218,
  originalWidth: 1282
}

/**
 * ![Video Doorbell Hero Banner](https://images.ctfassets.net/v6awd0kabi65/52MmeRriW3LpwrbDfckG0d/70addd4e37ea372e54016eda030de4ff/doorbell-hero.jpeg?w=120&h=120&fit=pad)
 *
 * Video Doorbell Hero Banner
 *
 *
 */
export const IMG_52MmeRriW3LpwrbDfckG0d = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/52MmeRriW3LpwrbDfckG0d/70addd4e37ea372e54016eda030de4ff/doorbell-hero.jpeg',
  description: ``,
  originalHeight: 929,
  originalWidth: 1790
}

/**
 * ![Video Doorbell Pro](https://images.ctfassets.net/v6awd0kabi65/thZEtFNObPyd3uyzckPF2/b97c67310df4243dc1736ededaabf9fe/video_door_bell.webp?w=120&h=120&fit=pad)
 *
 * Video Doorbell Pro
 *
 *
 */
export const IMG_thZEtFNObPyd3uyzckPF2 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/thZEtFNObPyd3uyzckPF2/b97c67310df4243dc1736ededaabf9fe/video_door_bell.webp',
  description: ``,
  originalHeight: 866,
  originalWidth: 1312
}

/**
 * ![Indoor Camera](https://images.ctfassets.net/v6awd0kabi65/6KahkTNrJXmqqMnK5ocBx1/07b03a2d64d2cd8067c2d9718ce18dfc/indoor_camera.png?w=120&h=120&fit=pad)
 *
 * Indoor Camera
 *
 *
 */
export const IMG_6KahkTNrJXmqqMnK5ocBx1 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6KahkTNrJXmqqMnK5ocBx1/07b03a2d64d2cd8067c2d9718ce18dfc/indoor_camera.png',
  description: ``,
  originalHeight: 1105,
  originalWidth: 1472
}

/**
 * ![SimpliSafe Base Station - Add more protection](https://images.ctfassets.net/v6awd0kabi65/1LQvxPmMuO7z5Lv1s1vMiK/5181b2989b92d2a3751d249e87f13257/Whole_home_security.png?w=120&h=120&fit=pad)
 *
 * SimpliSafe Base Station - Add more protection
 *
 *
 */
export const IMG_1LQvxPmMuO7z5Lv1s1vMiK = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1LQvxPmMuO7z5Lv1s1vMiK/5181b2989b92d2a3751d249e87f13257/Whole_home_security.png',
  description: ``,
  originalHeight: 1200,
  originalWidth: 1218
}

/**
 * ![Shield Features Illustration](https://images.ctfassets.net/v6awd0kabi65/7zgCvCw08OJJidVR3kFk0z/c418465f7757abecfa704d50221dabd3/Shield-expanded.png?w=120&h=120&fit=pad)
 *
 * Shield Features Illustration
 *
 *
 */
export const IMG_7zgCvCw08OJJidVR3kFk0z = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7zgCvCw08OJJidVR3kFk0z/c418465f7757abecfa704d50221dabd3/Shield-expanded.png',
  description: ``,
  originalHeight: 1176,
  originalWidth: 1364
}

/**
 * ![Weather](https://images.ctfassets.net/v6awd0kabi65/2bDVug0IShMcOJRYo1UMuJ/39adce6f2ec1467d07443a15b7aa76d7/weather.svg?w=120&h=120&fit=pad)
 *
 * Weather
 *
 *
 */
export const IMG_2bDVug0IShMcOJRYo1UMuJ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2bDVug0IShMcOJRYo1UMuJ/39adce6f2ec1467d07443a15b7aa76d7/weather.svg',
  description: ``,
  originalHeight: 39,
  originalWidth: 39
}

/**
 * ![Wi-Fi](https://images.ctfassets.net/v6awd0kabi65/28ihAUHKOBa3SVc9eaZGRZ/871a8d4966c240e5188eee1b496a0d6d/wifi.svg?w=120&h=120&fit=pad)
 *
 * Wi-Fi
 *
 *
 */
export const IMG_28ihAUHKOBa3SVc9eaZGRZ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/28ihAUHKOBa3SVc9eaZGRZ/871a8d4966c240e5188eee1b496a0d6d/wifi.svg',
  description: ``,
  originalHeight: 39,
  originalWidth: 45
}

/**
 * ![Motion Sensor](https://images.ctfassets.net/v6awd0kabi65/3BzU530UWrXpXuxTDRYR1N/de88237f253e6e769094babd833676de/motion_sensor.png?w=120&h=120&fit=pad)
 *
 * Motion Sensor
 *
 *
 */
export const IMG_3BzU530UWrXpXuxTDRYR1N = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3BzU530UWrXpXuxTDRYR1N/de88237f253e6e769094babd833676de/motion_sensor.png',
  description: ``,
  originalHeight: 940,
  originalWidth: 1104
}

/**
 * ![Base Station](https://images.ctfassets.net/v6awd0kabi65/McHqvoR7riR7zJwS0b5HF/7a0e0fa02b167de98711df999fe7805e/base_station.jpeg?w=120&h=120&fit=pad)
 *
 * Base Station
 *
 *
 */
export const IMG_McHqvoR7riR7zJwS0b5HF = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/McHqvoR7riR7zJwS0b5HF/7a0e0fa02b167de98711df999fe7805e/base_station.jpeg',
  description: ``,
  originalHeight: 2250,
  originalWidth: 3000
}

/**
 * ![Alarm Sensors - SS2](https://images.ctfassets.net/v6awd0kabi65/AHggyN7PcmDpSgnceEde8/8b674e6e8752d1a8d39fa9891752c741/ss2_base.png?w=120&h=120&fit=pad)
 *
 * Alarm Sensors - SS2
 *
 *
 */
export const IMG_AHggyN7PcmDpSgnceEde8 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/AHggyN7PcmDpSgnceEde8/8b674e6e8752d1a8d39fa9891752c741/ss2_base.png',
  description: ``,
  originalHeight: 1140,
  originalWidth: 1276
}

/**
 * ![Alarm Sensors - SS3](https://images.ctfassets.net/v6awd0kabi65/309WTTxdmipW5AL9T4TopT/f6fb8370702a575ac64b4a25329c253e/ss3_base.png?w=120&h=120&fit=pad)
 *
 * Alarm Sensors - SS3
 *
 *
 */
export const IMG_309WTTxdmipW5AL9T4TopT = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/309WTTxdmipW5AL9T4TopT/f6fb8370702a575ac64b4a25329c253e/ss3_base.png',
  description: ``,
  originalHeight: 1142,
  originalWidth: 1278
}

/**
 * ![Carbon Monoxide Detector](https://images.ctfassets.net/v6awd0kabi65/26ZUKP5PXXgiYRXk41TBYa/ecce8a04503217ec379234525f0a1b04/carbon_monoxide.jpeg?w=120&h=120&fit=pad)
 *
 * Carbon Monoxide Detector
 *
 *
 */
export const IMG_26ZUKP5PXXgiYRXk41TBYa = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/26ZUKP5PXXgiYRXk41TBYa/ecce8a04503217ec379234525f0a1b04/carbon_monoxide.jpeg',
  description: ``,
  originalHeight: 1200,
  originalWidth: 1199
}

/**
 * ![Glassbreak Sensor](https://images.ctfassets.net/v6awd0kabi65/5pPdKwCxiLrqUp69Gm0t04/7ef2964d06812dfb81d882920e7f03ae/glassbreak.jpg?w=120&h=120&fit=pad)
 *
 * Glassbreak Sensor
 *
 *
 */
export const IMG_5pPdKwCxiLrqUp69Gm0t04 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5pPdKwCxiLrqUp69Gm0t04/7ef2964d06812dfb81d882920e7f03ae/glassbreak.jpg',
  description: ``,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Extra Entry Magnet](https://images.ctfassets.net/v6awd0kabi65/7d6umu5OCYQUXBq0JUhm3X/a26ce9f7ba9ec0ae4d02dc4ac233a0e9/extra_entry_magnet.png?w=120&h=120&fit=pad)
 *
 * Extra Entry Magnet
 *
 *
 */
export const IMG_7d6umu5OCYQUXBq0JUhm3X = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7d6umu5OCYQUXBq0JUhm3X/a26ce9f7ba9ec0ae4d02dc4ac233a0e9/extra_entry_magnet.png',
  description: ``,
  originalHeight: 430,
  originalWidth: 554
}

/**
 * ![Outdoor Kit](https://images.ctfassets.net/v6awd0kabi65/xazcjxb5XWsN0DJT2ewAm/7c83e01066e3e35dc56c4b9a22265d22/outdoor_kit.png?w=120&h=120&fit=pad)
 *
 * Outdoor Kit
 *
 *
 */
export const IMG_xazcjxb5XWsN0DJT2ewAm = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/xazcjxb5XWsN0DJT2ewAm/7c83e01066e3e35dc56c4b9a22265d22/outdoor_kit.png',
  description: ``,
  originalHeight: 398,
  originalWidth: 604
}

/**
 * ![Window Decals (5)](https://images.ctfassets.net/v6awd0kabi65/Kl1hh3jQJMym6PUKelcMR/4d1f8c45462a74503e6181c0390c0647/window_decals.png?w=120&h=120&fit=pad)
 *
 * Window Decals (5)
 *
 *
 */
export const IMG_Kl1hh3jQJMym6PUKelcMR = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/Kl1hh3jQJMym6PUKelcMR/4d1f8c45462a74503e6181c0390c0647/window_decals.png',
  description: ``,
  originalHeight: 430,
  originalWidth: 554
}

/**
 * ![Icon - Badge](https://images.ctfassets.net/v6awd0kabi65/mlytp6p5uOdhjVS16hN4N/7f3e9c682491ba680998c0c5f121aea1/Type_Badge.png?w=120&h=120&fit=pad)
 *
 * Icon - Badge
 *
 *
 */
export const IMG_mlytp6p5uOdhjVS16hN4N = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/mlytp6p5uOdhjVS16hN4N/7f3e9c682491ba680998c0c5f121aea1/Type_Badge.png',
  description: ``,
  originalHeight: 160,
  originalWidth: 160
}

/**
 * ![Icon - Smartphone](https://images.ctfassets.net/v6awd0kabi65/7CKSCf32I7pO3Fuw1dW28G/f85b7da9654bccdb20a71a7893a2e0f7/Type_smart_phone__1_.png?w=120&h=120&fit=pad)
 *
 * Icon - Smartphone
 *
 *
 */
export const IMG_7CKSCf32I7pO3Fuw1dW28G = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7CKSCf32I7pO3Fuw1dW28G/f85b7da9654bccdb20a71a7893a2e0f7/Type_smart_phone__1_.png',
  description: ``,
  originalHeight: 160,
  originalWidth: 160
}

/**
 * ![Icon - support](https://images.ctfassets.net/v6awd0kabi65/1n1QzdaJrQIMT6h4fORza4/2a2564c35305423c99d56b08afc8c731/Type_Support__1_.png?w=120&h=120&fit=pad)
 *
 * Icon - support
 *
 *
 */
export const IMG_1n1QzdaJrQIMT6h4fORza4 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1n1QzdaJrQIMT6h4fORza4/2a2564c35305423c99d56b08afc8c731/Type_Support__1_.png',
  description: ``,
  originalHeight: 160,
  originalWidth: 160
}

/**
 * ![Smoke sensor on the ceiling](https://images.ctfassets.net/v6awd0kabi65/2KmI7ZXkC79Ri61o3mvG2x/824183c4760335e411f0e0260e551227/Smoke_Cropped.jpeg?w=120&h=120&fit=pad)
 *
 * Smoke sensor on the ceiling
 *
 *
 */
export const IMG_2KmI7ZXkC79Ri61o3mvG2x = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2KmI7ZXkC79Ri61o3mvG2x/824183c4760335e411f0e0260e551227/Smoke_Cropped.jpeg',
  description: ``,
  originalHeight: 954,
  originalWidth: 954
}

/**
 * ![Panic button by the bed](https://images.ctfassets.net/v6awd0kabi65/53LONA3BITdMG8jOO9BI5g/a110b850b12e70c4211ecf87bc5639b6/Panic_bybed_medium_Cropped.jpeg?w=120&h=120&fit=pad)
 *
 * Panic button by the bed
 *
 *
 */
export const IMG_53LONA3BITdMG8jOO9BI5g = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/53LONA3BITdMG8jOO9BI5g/a110b850b12e70c4211ecf87bc5639b6/Panic_bybed_medium_Cropped.jpeg',
  description: ``,
  originalHeight: 1080,
  originalWidth: 1080
}

/**
 * ![Temperature sensor on the wall](https://images.ctfassets.net/v6awd0kabi65/6x3nGPq2NW4MM5velYThhB/4c9d36835e642e5b5be108980c622494/Freeze_Cropped.jpeg?w=120&h=120&fit=pad)
 *
 * Temperature sensor on the wall
 *
 *
 */
export const IMG_6x3nGPq2NW4MM5velYThhB = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6x3nGPq2NW4MM5velYThhB/4c9d36835e642e5b5be108980c622494/Freeze_Cropped.jpeg',
  description: ``,
  originalHeight: 651,
  originalWidth: 651
}

/**
 * ![Siren on the wall](https://images.ctfassets.net/v6awd0kabi65/5LxA7CX9hTL7Eirh7D76C2/7ad4eb684b0fa0cbe3320ea4798c985f/siren-2.jpeg?w=120&h=120&fit=pad)
 *
 * Siren on the wall
 *
 *
 */
export const IMG_5LxA7CX9hTL7Eirh7D76C2 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5LxA7CX9hTL7Eirh7D76C2/7ad4eb684b0fa0cbe3320ea4798c985f/siren-2.jpeg',
  description: ``,
  originalHeight: 862,
  originalWidth: 862
}

/**
 * ![Keypad and Keys](https://images.ctfassets.net/v6awd0kabi65/7xXuNgfN01XACeF8mL0eAQ/8f8a2c626acdc66e9b33d6d7ffa56744/desktop_designed-for-SS_2x.jpeg?w=120&h=120&fit=pad)
 *
 * Keypad and Keys
 *
 *
 */
export const IMG_7xXuNgfN01XACeF8mL0eAQ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7xXuNgfN01XACeF8mL0eAQ/8f8a2c626acdc66e9b33d6d7ffa56744/desktop_designed-for-SS_2x.jpeg',
  description: ``,
  originalHeight: 1127,
  originalWidth: 1144
}

/**
 * ![Motion Sensor](https://images.ctfassets.net/v6awd0kabi65/52cPDsSPsNMtbK89B26bsy/f3c460e036d750fc7e35a4d8d9d0f031/MTS-Burlary-sensors_motion_2x.png?w=120&h=120&fit=pad)
 *
 * Motion Sensor
 *
 *
 */
export const IMG_52cPDsSPsNMtbK89B26bsy = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/52cPDsSPsNMtbK89B26bsy/f3c460e036d750fc7e35a4d8d9d0f031/MTS-Burlary-sensors_motion_2x.png',
  description: ``,
  originalHeight: 940,
  originalWidth: 1104
}

/**
 * ![Glassbreak Wall](https://images.ctfassets.net/v6awd0kabi65/4BlAFmrZUb6aWibn6sKebT/8f9f46443c9256378feeaf43b4cbc543/Glassbreak_Cropped.jpeg?w=120&h=120&fit=pad)
 *
 * Glassbreak Wall
 *
 *
 */
export const IMG_4BlAFmrZUb6aWibn6sKebT = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4BlAFmrZUb6aWibn6sKebT/8f9f46443c9256378feeaf43b4cbc543/Glassbreak_Cropped.jpeg',
  description: ``,
  originalHeight: 816,
  originalWidth: 816
}

/**
 * ![Entry window](https://images.ctfassets.net/v6awd0kabi65/6xhq6i1r5jwZZ0NcFMZ7YV/2f93279facf69da0bb4662920eda2d71/Entry_Cropped.jpeg?w=120&h=120&fit=pad)
 *
 * Entry window
 *
 *
 */
export const IMG_6xhq6i1r5jwZZ0NcFMZ7YV = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6xhq6i1r5jwZZ0NcFMZ7YV/2f93279facf69da0bb4662920eda2d71/Entry_Cropped.jpeg',
  description: ``,
  originalHeight: 1260,
  originalWidth: 1260
}

/**
 * ![Meet the system - Image](https://images.ctfassets.net/v6awd0kabi65/7eLnjmbQwLhA5GYkjR4TW6/4c197780d113b3ebbbba8db89d293d68/image.png?w=120&h=120&fit=pad)
 *
 * Meet the system - Image
 *
 * Meet the system - Image
 */
export const IMG_7eLnjmbQwLhA5GYkjR4TW6 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7eLnjmbQwLhA5GYkjR4TW6/4c197780d113b3ebbbba8db89d293d68/image.png',
  description: `Meet the system - Image`,
  originalHeight: 1917,
  originalWidth: 2556
}

/**
 * ![SimpliSafe unboxing video](https://videos.ctfassets.net/v6awd0kabi65/7vynALiIUGa62nuelGuEXy/39828e88c0d831036918d3fb15c9ddf5/homepage.mp4?w=120&h=120&fit=pad)
 *
 * SimpliSafe unboxing video
 *
 * A video showing a SimpliSafe system being unboxed and installed.
 */
export const IMG_7vynALiIUGa62nuelGuEXy = {
  url: 'https://videos.ctfassets.net/v6awd0kabi65/7vynALiIUGa62nuelGuEXy/39828e88c0d831036918d3fb15c9ddf5/homepage.mp4',
  description: `A video showing a SimpliSafe system being unboxed and installed.`,
  originalHeight: null,
  originalWidth: null
}

/**
 * ![Pro Install Full Image](https://images.ctfassets.net/v6awd0kabi65/1h96fdBztfzYM0zr4cTFIY/6e34631be01b8a6f1d98065f4a73485a/i.shgcdn.webp?w=120&h=120&fit=pad)
 *
 * Pro Install Full Image
 *
 *
 */
export const IMG_1h96fdBztfzYM0zr4cTFIY = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1h96fdBztfzYM0zr4cTFIY/6e34631be01b8a6f1d98065f4a73485a/i.shgcdn.webp',
  description: ``,
  originalHeight: 2000,
  originalWidth: 3000
}

/**
 * ![Why choose simplisafe section - Pad](https://images.ctfassets.net/v6awd0kabi65/4TW8ioosZwVtl6MTqo9jmF/571e93a34e817deef47fd816032ffec8/image__1_.png?w=120&h=120&fit=pad)
 *
 * Why choose simplisafe section - Pad
 *
 *
 */
export const IMG_4TW8ioosZwVtl6MTqo9jmF = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4TW8ioosZwVtl6MTqo9jmF/571e93a34e817deef47fd816032ffec8/image__1_.png',
  description: ``,
  originalHeight: 533,
  originalWidth: 800
}

/**
 * ![Why choose simplisafe section - Indoor Camera](https://images.ctfassets.net/v6awd0kabi65/6Sle1GOqroH50p7OLZEPW5/aecc3348c4b11ab4ff00c7ed4131209c/image2.png?w=120&h=120&fit=pad)
 *
 * Why choose simplisafe section - Indoor Camera
 *
 *
 */
export const IMG_6Sle1GOqroH50p7OLZEPW5 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6Sle1GOqroH50p7OLZEPW5/aecc3348c4b11ab4ff00c7ed4131209c/image2.png',
  description: ``,
  originalHeight: 600,
  originalWidth: 800
}

/**
 * ![Shop - SimpliCam Security Camera (Nav)](https://images.ctfassets.net/v6awd0kabi65/7uhxGWTTHZLEJcyKvKes2S/6ece318e8339fe1ab5436971126c1683/nav_prod-cam.png?w=120&h=120&fit=pad)
 *
 * Shop - SimpliCam Security Camera (Nav)
 *
 * Black SimpliCam - Click for SimpliCam Page
 */
export const IMG_7uhxGWTTHZLEJcyKvKes2S = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7uhxGWTTHZLEJcyKvKes2S/6ece318e8339fe1ab5436971126c1683/nav_prod-cam.png',
  description: `Black SimpliCam - Click for SimpliCam Page`,
  originalHeight: 112,
  originalWidth: 112
}

/**
 * ![105db Wireless Siren - Features](https://images.ctfassets.net/v6awd0kabi65/5UR0aCITNva6Lh9yJEZtVf/5a77ccf25be850bee49d84054e7dab94/desktop_siren-sq_2x.jpeg?w=120&h=120&fit=pad)
 *
 * 105db Wireless Siren - Features
 *
 * siren sensor placed on a wall
 */
export const IMG_5UR0aCITNva6Lh9yJEZtVf = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5UR0aCITNva6Lh9yJEZtVf/5a77ccf25be850bee49d84054e7dab94/desktop_siren-sq_2x.jpeg',
  description: `siren sensor placed on a wall`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Key Fob - Features](https://images.ctfassets.net/v6awd0kabi65/6rL0h8cJa6KfmfrOGG2mYB/fb212ceb07f41f2e084491b5f267057c/desktop_keyfob-sq_2x.jpeg?w=120&h=120&fit=pad)
 *
 * Key Fob - Features
 *
 * keyfob in hand
 */
export const IMG_6rL0h8cJa6KfmfrOGG2mYB = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6rL0h8cJa6KfmfrOGG2mYB/fb212ceb07f41f2e084491b5f267057c/desktop_keyfob-sq_2x.jpeg',
  description: `keyfob in hand`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Glassbreak Sensor - Features](https://images.ctfassets.net/v6awd0kabi65/ByUGYvIJSvShkIkrPEpv4/999a6896e7cdff8af44f60627971188c/desktop_glassbreak-sq_2x.jpeg?w=120&h=120&fit=pad)
 *
 * Glassbreak Sensor - Features
 *
 * glassbreak sensor on table
 */
export const IMG_ByUGYvIJSvShkIkrPEpv4 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/ByUGYvIJSvShkIkrPEpv4/999a6896e7cdff8af44f60627971188c/desktop_glassbreak-sq_2x.jpeg',
  description: `glassbreak sensor on table`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Motion Sensor - Features](https://images.ctfassets.net/v6awd0kabi65/1aeYzFJLRVI3x8zo3R4HPa/01fa05ffca3e82a6bd9376a1c75f5083/desktop_motion-sq_2x.jpeg?w=120&h=120&fit=pad)
 *
 * Motion Sensor - Features
 *
 * motion sensor on table
 */
export const IMG_1aeYzFJLRVI3x8zo3R4HPa = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1aeYzFJLRVI3x8zo3R4HPa/01fa05ffca3e82a6bd9376a1c75f5083/desktop_motion-sq_2x.jpeg',
  description: `motion sensor on table`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Keypad - Features](https://images.ctfassets.net/v6awd0kabi65/4jTseQZYEC2ldE6oKz7ytN/7dec64bdb6a2a35fd921a473425f7094/desktop_extrakp-sq_2x.jpeg?w=120&h=120&fit=pad)
 *
 * Keypad - Features
 *
 * keypad (cloud) placed on a wall
 */
export const IMG_4jTseQZYEC2ldE6oKz7ytN = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4jTseQZYEC2ldE6oKz7ytN/7dec64bdb6a2a35fd921a473425f7094/desktop_extrakp-sq_2x.jpeg',
  description: `keypad (cloud) placed on a wall`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Panic Button - Feature](https://images.ctfassets.net/v6awd0kabi65/10grBmLcMWAuZG4LLbYWTK/74ea58ac9a8623b46dc2e91a01fd89f9/desktop_panic-sq_2x.jpeg?w=120&h=120&fit=pad)
 *
 * Panic Button - Feature
 *
 * pushing panic button on wall
 */
export const IMG_10grBmLcMWAuZG4LLbYWTK = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/10grBmLcMWAuZG4LLbYWTK/74ea58ac9a8623b46dc2e91a01fd89f9/desktop_panic-sq_2x.jpeg',
  description: `pushing panic button on wall`,
  originalHeight: 1201,
  originalWidth: 1200
}

/**
 * ![Water Sensor - Features](https://images.ctfassets.net/v6awd0kabi65/5q58PFobhHV2nEPkcDaNS1/8770936b50d412d83823df289e861074/desktop_water-sq.jpeg?w=120&h=120&fit=pad)
 *
 * Water Sensor - Features
 *
 * water sensor on floor
 */
export const IMG_5q58PFobhHV2nEPkcDaNS1 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5q58PFobhHV2nEPkcDaNS1/8770936b50d412d83823df289e861074/desktop_water-sq.jpeg',
  description: `water sensor on floor`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Temperature Sensor - Features](https://images.ctfassets.net/v6awd0kabi65/6vOEr16Hwcblfr5OrUkfkf/c5a169798f8d23fb254db72b34519eb2/desktop_temp-sq_2x.jpeg?w=120&h=120&fit=pad)
 *
 * Temperature Sensor - Features
 *
 * placing temperature sensor
 */
export const IMG_6vOEr16Hwcblfr5OrUkfkf = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6vOEr16Hwcblfr5OrUkfkf/c5a169798f8d23fb254db72b34519eb2/desktop_temp-sq_2x.jpeg',
  description: `placing temperature sensor`,
  originalHeight: 1012,
  originalWidth: 1012
}

/**
 * ![Entry Sensor - Features](https://images.ctfassets.net/v6awd0kabi65/7HQXgCnDx3pBFjydguO1A7/d87a246295fd011dcde677218b094d3d/desktop_entry-sq_2x.jpeg?w=120&h=120&fit=pad)
 *
 * Entry Sensor - Features
 *
 * entry sensor on door frame
 */
export const IMG_7HQXgCnDx3pBFjydguO1A7 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7HQXgCnDx3pBFjydguO1A7/d87a246295fd011dcde677218b094d3d/desktop_entry-sq_2x.jpeg',
  description: `entry sensor on door frame`,
  originalHeight: 1200,
  originalWidth: 1200
}

/**
 * ![Shop refurbished systems](https://images.ctfassets.net/v6awd0kabi65/1i6On9aeDQs5sKzLctxHv5/0ba75cf5f1acbbdb1918334c5977658c/shop-refurbished-systems.png?w=120&h=120&fit=pad)
 *
 * Shop refurbished systems
 *
 *
 */
export const IMG_1i6On9aeDQs5sKzLctxHv5 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1i6On9aeDQs5sKzLctxHv5/0ba75cf5f1acbbdb1918334c5977658c/shop-refurbished-systems.png',
  description: ``,
  originalHeight: 370,
  originalWidth: 484
}

/**
 * ![Add on to my system](https://images.ctfassets.net/v6awd0kabi65/4OcskADbMKFJH91caDRufg/b7bb52b004d72ed1208c656d401aa9ee/add-on-to-my-system.png?w=120&h=120&fit=pad)
 *
 * Add on to my system
 *
 *
 */
export const IMG_4OcskADbMKFJH91caDRufg = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4OcskADbMKFJH91caDRufg/b7bb52b004d72ed1208c656d401aa9ee/add-on-to-my-system.png',
  description: ``,
  originalHeight: 368,
  originalWidth: 428
}

/**
 * ![PLA Base Image](https://images.ctfassets.net/v6awd0kabi65/2mSjZExLGOOZj6jR23zzhH/1ce69723f35c4d0129c53ddc1e7fff7c/base_with_apples.png?w=120&h=120&fit=pad)
 *
 * PLA Base Image
 *
 * Base image used as the first carousel image on PLA package pages.
 */
export const IMG_2mSjZExLGOOZj6jR23zzhH = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2mSjZExLGOOZj6jR23zzhH/1ce69723f35c4d0129c53ddc1e7fff7c/base_with_apples.png',
  description: `Base image used as the first carousel image on PLA package pages.`,
  originalHeight: 810,
  originalWidth: 810
}

/**
 * ![Shop Landing Image](https://images.ctfassets.net/v6awd0kabi65/6EmD6YIRjzVbencWg3Bshf/8796d798ef9d19afc6b77fce36cc2de3/Shop_Landing_Image.jpeg?w=120&h=120&fit=pad)
 *
 * Shop Landing Image
 *
 * Background image used on the top banner on the PLP pages.
 */
export const IMG_6EmD6YIRjzVbencWg3Bshf = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6EmD6YIRjzVbencWg3Bshf/8796d798ef9d19afc6b77fce36cc2de3/Shop_Landing_Image.jpeg',
  description: `Background image used on the top banner on the PLP pages.`,
  originalHeight: 1200,
  originalWidth: 2618
}

/**
 * ![Temperature Sensor](https://images.ctfassets.net/v6awd0kabi65/1MLvJ6SGwZD2cWkYaS4iRo/e8b307c3614cd5ff05be1d4a09fafff6/temperature.png?w=120&h=120&fit=pad)
 *
 * Temperature Sensor
 *
 * Imagery used on the Floor Plan component on the Package pages.
 */
export const IMG_1MLvJ6SGwZD2cWkYaS4iRo = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1MLvJ6SGwZD2cWkYaS4iRo/e8b307c3614cd5ff05be1d4a09fafff6/temperature.png',
  description: `Imagery used on the Floor Plan component on the Package pages.`,
  originalHeight: 402,
  originalWidth: 603
}

/**
 * ![Motion Sensor](https://images.ctfassets.net/v6awd0kabi65/7kvax5zRZJX0UW0gBtExwA/3f35d2ad4957445c6bcc837aa89ba16f/motion.png?w=120&h=120&fit=pad)
 *
 * Motion Sensor
 *
 * Imagery used on the Floor Plan component on the Package pages.
 */
export const IMG_7kvax5zRZJX0UW0gBtExwA = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7kvax5zRZJX0UW0gBtExwA/3f35d2ad4957445c6bcc837aa89ba16f/motion.png',
  description: `Imagery used on the Floor Plan component on the Package pages.`,
  originalHeight: 402,
  originalWidth: 603
}

/**
 * ![Wireless Siren](https://images.ctfassets.net/v6awd0kabi65/29HUveT75NrhLDIIt9o4hK/c4f1390312b0fd7aff39eaf5a2a16e32/siren.png?w=120&h=120&fit=pad)
 *
 * Wireless Siren
 *
 * Imagery used on the Floor Plan component on the Package pages.
 */
export const IMG_29HUveT75NrhLDIIt9o4hK = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/29HUveT75NrhLDIIt9o4hK/c4f1390312b0fd7aff39eaf5a2a16e32/siren.png',
  description: `Imagery used on the Floor Plan component on the Package pages.`,
  originalHeight: 402,
  originalWidth: 603
}

/**
 * ![Interactive Monitoring](https://images.ctfassets.net/v6awd0kabi65/4J1FD2hY3pnSjoLCDZZDi6/fa37e77968fc455cfe15ac64de66635f/monitoring.png?w=120&h=120&fit=pad)
 *
 * Interactive Monitoring
 *
 * Imagery used on the Floor Plan component on the Package pages.
 */
export const IMG_4J1FD2hY3pnSjoLCDZZDi6 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4J1FD2hY3pnSjoLCDZZDi6/fa37e77968fc455cfe15ac64de66635f/monitoring.png',
  description: `Imagery used on the Floor Plan component on the Package pages.`,
  originalHeight: 402,
  originalWidth: 603
}

/**
 * ![Outdoor Camera](https://images.ctfassets.net/v6awd0kabi65/5UAL4ocenqfHmcJoQtALAR/b4c303fe568f1127a0ea6efa6ce653a4/outdoor.png?w=120&h=120&fit=pad)
 *
 * Outdoor Camera
 *
 * Imagery used on the Floor Plan component on the Package pages.
 */
export const IMG_5UAL4ocenqfHmcJoQtALAR = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5UAL4ocenqfHmcJoQtALAR/b4c303fe568f1127a0ea6efa6ce653a4/outdoor.png',
  description: `Imagery used on the Floor Plan component on the Package pages.`,
  originalHeight: 402,
  originalWidth: 603
}

/**
 * ![Panic Button](https://images.ctfassets.net/v6awd0kabi65/5Sf3XuBtUJE8qHJLHqnguY/8f9c6c0a9627ff7b7836a42d96660066/panic.png?w=120&h=120&fit=pad)
 *
 * Panic Button
 *
 * Imagery used on the Floor Plan component on the Package pages.
 */
export const IMG_5Sf3XuBtUJE8qHJLHqnguY = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5Sf3XuBtUJE8qHJLHqnguY/8f9c6c0a9627ff7b7836a42d96660066/panic.png',
  description: `Imagery used on the Floor Plan component on the Package pages.`,
  originalHeight: 402,
  originalWidth: 603
}

/**
 * ![Smoke Detector](https://images.ctfassets.net/v6awd0kabi65/qKzEHmGvHjLLWkwmmjYRf/cae4f4c00b1db90eb83bd12c772dbea2/smoke.png?w=120&h=120&fit=pad)
 *
 * Smoke Detector
 *
 * Imagery used on the Floor Plan component on the Package pages.
 */
export const IMG_qKzEHmGvHjLLWkwmmjYRf = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/qKzEHmGvHjLLWkwmmjYRf/cae4f4c00b1db90eb83bd12c772dbea2/smoke.png',
  description: `Imagery used on the Floor Plan component on the Package pages.`,
  originalHeight: 402,
  originalWidth: 603
}

/**
 * ![Mobile App](https://images.ctfassets.net/v6awd0kabi65/oBfPy0pypigaOdNW7pyMp/76d68353bda84896303ce3345837d80e/app.png?w=120&h=120&fit=pad)
 *
 * Mobile App
 *
 * Imagery used on the Floor Plan component on the Package pages.
 */
export const IMG_oBfPy0pypigaOdNW7pyMp = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/oBfPy0pypigaOdNW7pyMp/76d68353bda84896303ce3345837d80e/app.png',
  description: `Imagery used on the Floor Plan component on the Package pages.`,
  originalHeight: 402,
  originalWidth: 603
}

/**
 * ![Entry Sensor](https://images.ctfassets.net/v6awd0kabi65/BbNnSEpOhLVWLQn4G4gaN/45d92296e34253c78df40b074ed3a90d/entry.png?w=120&h=120&fit=pad)
 *
 * Entry Sensor
 *
 * Imagery used on the Floor Plan component on the Package pages.
 */
export const IMG_BbNnSEpOhLVWLQn4G4gaN = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/BbNnSEpOhLVWLQn4G4gaN/45d92296e34253c78df40b074ed3a90d/entry.png',
  description: `Imagery used on the Floor Plan component on the Package pages.`,
  originalHeight: 402,
  originalWidth: 603
}

/**
 * ![Keypad](https://images.ctfassets.net/v6awd0kabi65/748XLPyQ64OLLvBGE6Kyos/d3ddd919083daee04f3ebf20b0a5d232/keypad.png?w=120&h=120&fit=pad)
 *
 * Keypad
 *
 * Imagery used on the Floor Plan component on the Package pages.
 */
export const IMG_748XLPyQ64OLLvBGE6Kyos = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/748XLPyQ64OLLvBGE6Kyos/d3ddd919083daee04f3ebf20b0a5d232/keypad.png',
  description: `Imagery used on the Floor Plan component on the Package pages.`,
  originalHeight: 402,
  originalWidth: 603
}

/**
 * ![Base Station](https://images.ctfassets.net/v6awd0kabi65/7jd8Mh9bVc1Ys0q7R3L8Oh/20494c119f1d06448fc9fe60f7187b75/base.png?w=120&h=120&fit=pad)
 *
 * Base Station
 *
 * Imagery used on the Floor Plan component on the Package pages.
 */
export const IMG_7jd8Mh9bVc1Ys0q7R3L8Oh = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7jd8Mh9bVc1Ys0q7R3L8Oh/20494c119f1d06448fc9fe60f7187b75/base.png',
  description: `Imagery used on the Floor Plan component on the Package pages.`,
  originalHeight: 402,
  originalWidth: 603
}

/**
 * ![Keyfob](https://images.ctfassets.net/v6awd0kabi65/4kS0pn3sOMXxPj03gb45in/b9d6ce7aa4badcd1baa3ffe7fd32635f/keyfob.png?w=120&h=120&fit=pad)
 *
 * Keyfob
 *
 * Imagery used on the Floor Plan component on the Package pages.
 */
export const IMG_4kS0pn3sOMXxPj03gb45in = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4kS0pn3sOMXxPj03gb45in/b9d6ce7aa4badcd1baa3ffe7fd32635f/keyfob.png',
  description: `Imagery used on the Floor Plan component on the Package pages.`,
  originalHeight: 402,
  originalWidth: 603
}

/**
 * ![Indoor Camera](https://images.ctfassets.net/v6awd0kabi65/1zTeMPM0VuUKi2OZWWW8iY/6af728f31dfc450e6e33ed5439db1445/indoor.png?w=120&h=120&fit=pad)
 *
 * Indoor Camera
 *
 * Imagery used on the Floor Plan component on the Package pages.
 */
export const IMG_1zTeMPM0VuUKi2OZWWW8iY = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1zTeMPM0VuUKi2OZWWW8iY/6af728f31dfc450e6e33ed5439db1445/indoor.png',
  description: `Imagery used on the Floor Plan component on the Package pages.`,
  originalHeight: 402,
  originalWidth: 603
}

/**
 * ![Water Sensor](https://images.ctfassets.net/v6awd0kabi65/6dmDnXcM9UyJbcWzIVZE24/3d5b342a8c09e8517f2276dd149141de/water.png?w=120&h=120&fit=pad)
 *
 * Water Sensor
 *
 * Imagery used on the Floor Plan component on the Package pages.
 */
export const IMG_6dmDnXcM9UyJbcWzIVZE24 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6dmDnXcM9UyJbcWzIVZE24/3d5b342a8c09e8517f2276dd149141de/water.png',
  description: `Imagery used on the Floor Plan component on the Package pages.`,
  originalHeight: 402,
  originalWidth: 603
}

/**
 * ![Phone Icon](https://images.ctfassets.net/v6awd0kabi65/3SaOS7bgO9hrjLn9WD1QRF/9ca10a5044cd0be9e9ab7908078fe271/phone.png?w=120&h=120&fit=pad)
 *
 * Phone Icon
 *
 * Phone icon used in the header for mobile layouts.
 */
export const IMG_3SaOS7bgO9hrjLn9WD1QRF = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3SaOS7bgO9hrjLn9WD1QRF/9ca10a5044cd0be9e9ab7908078fe271/phone.png',
  description: `Phone icon used in the header for mobile layouts.`,
  originalHeight: 114,
  originalWidth: 108
}

/**
 * ![Today Show Logo](https://images.ctfassets.net/v6awd0kabi65/1IgN8BIyfWfJGlo1Sj4Z09/ee37cec6e0c22a2fd2db621e3588aa8b/today.png?w=120&h=120&fit=pad)
 *
 * Today Show Logo
 *
 *
 */
export const IMG_1IgN8BIyfWfJGlo1Sj4Z09 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1IgN8BIyfWfJGlo1Sj4Z09/ee37cec6e0c22a2fd2db621e3588aa8b/today.png',
  description: ``,
  originalHeight: 147,
  originalWidth: 198
}

/**
 * ![Dave Ramsey Logo](https://images.ctfassets.net/v6awd0kabi65/3fe9RGYlFCxD9OjS0Fnjb7/31f23597f9e4c2859bfd3e48e93d0a92/dave-ramsey.png?w=120&h=120&fit=pad)
 *
 * Dave Ramsey Logo
 *
 *
 */
export const IMG_3fe9RGYlFCxD9OjS0Fnjb7 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3fe9RGYlFCxD9OjS0Fnjb7/31f23597f9e4c2859bfd3e48e93d0a92/dave-ramsey.png',
  description: ``,
  originalHeight: 176,
  originalWidth: 512
}

/**
 * ![CEO Signature](https://images.ctfassets.net/v6awd0kabi65/3NoKCcF85o6ZlVqvr2oRMj/e893c70ed4808cadd9443a46ad487a1e/signature.png?w=120&h=120&fit=pad)
 *
 * CEO Signature
 *
 *
 */
export const IMG_3NoKCcF85o6ZlVqvr2oRMj = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3NoKCcF85o6ZlVqvr2oRMj/e893c70ed4808cadd9443a46ad487a1e/signature.png',
  description: ``,
  originalHeight: 151,
  originalWidth: 452
}

/**
 * ![Wireless Outdoor Camera](https://images.ctfassets.net/v6awd0kabi65/v4G7wZm6RmKO0AUyLzhzL/77f1a5c018c6fd8cce9254975f4efea4/outdoor_camera.jpeg?w=120&h=120&fit=pad)
 *
 * Wireless Outdoor Camera
 *
 * Used in the Carousel for PDP pages.
 */
export const IMG_v4G7wZm6RmKO0AUyLzhzL = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/v4G7wZm6RmKO0AUyLzhzL/77f1a5c018c6fd8cce9254975f4efea4/outdoor_camera.jpeg',
  description: `Used in the Carousel for PDP pages.`,
  originalHeight: 707,
  originalWidth: 853
}

/**
 * ![105dB Siren](https://images.ctfassets.net/v6awd0kabi65/7edAT4JYm2WDwCh2FxF2fS/0733fff6b8641448097a17bd52801274/siren.png?w=120&h=120&fit=pad)
 *
 * 105dB Siren
 *
 *
 */
export const IMG_7edAT4JYm2WDwCh2FxF2fS = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7edAT4JYm2WDwCh2FxF2fS/0733fff6b8641448097a17bd52801274/siren.png',
  description: ``,
  originalHeight: 600,
  originalWidth: 600
}

/**
 * ![The Starter](https://images.ctfassets.net/v6awd0kabi65/6XZJITfolL2FVNAaJGF1T5/eb571b961ac95c6e3f35076fb77154d6/starter.png?w=120&h=120&fit=pad)
 *
 * The Starter
 *
 * An image of all of the components included in The Starter package.
 */
export const IMG_6XZJITfolL2FVNAaJGF1T5 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6XZJITfolL2FVNAaJGF1T5/eb571b961ac95c6e3f35076fb77154d6/starter.png',
  description: `An image of all of the components included in The Starter package. `,
  originalHeight: 904,
  originalWidth: 1130
}

/**
 * ![The Windsor](https://images.ctfassets.net/v6awd0kabi65/7ypgzpC5JDbvEqFgNtWUkE/6b3b34ef016697d4829f4c316d53cd73/windsor.png?w=120&h=120&fit=pad)
 *
 * The Windsor
 *
 * An image of all of the components included in The Windsor package.
 */
export const IMG_7ypgzpC5JDbvEqFgNtWUkE = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7ypgzpC5JDbvEqFgNtWUkE/6b3b34ef016697d4829f4c316d53cd73/windsor.png',
  description: `An image of all of the components included in The Windsor package. `,
  originalHeight: 904,
  originalWidth: 1130
}

/**
 * ![The Tower](https://images.ctfassets.net/v6awd0kabi65/6z3n4zizLNw17zYKyfyjct/7e0beeb5c798fb69d6f39b1dd7646ebe/tower.png?w=120&h=120&fit=pad)
 *
 * The Tower
 *
 * An image of all of the components included in The Tower package.
 */
export const IMG_6z3n4zizLNw17zYKyfyjct = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6z3n4zizLNw17zYKyfyjct/7e0beeb5c798fb69d6f39b1dd7646ebe/tower.png',
  description: `An image of all of the components included in The Tower package. `,
  originalHeight: 2400,
  originalWidth: 3000
}

/**
 * ![The Edinburgh](https://images.ctfassets.net/v6awd0kabi65/7uK2IPg1EObDcsq44t4KY2/194a809c63927e54339a1af17a4905a9/edinburgh.png?w=120&h=120&fit=pad)
 *
 * The Edinburgh
 *
 * An image of all of the components included in The Edinburgh package.
 */
export const IMG_7uK2IPg1EObDcsq44t4KY2 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7uK2IPg1EObDcsq44t4KY2/194a809c63927e54339a1af17a4905a9/edinburgh.png',
  description: `An image of all of the components included in The Edinburgh package. `,
  originalHeight: 2400,
  originalWidth: 3000
}

/**
 * ![The Bamburgh](https://images.ctfassets.net/v6awd0kabi65/4Y5bvgL0MVAKyQG8ZgRhwT/50ab96048cc21ae9f30342bdf7e91093/bamburgh.png?w=120&h=120&fit=pad)
 *
 * The Bamburgh
 *
 * An image of all of the components included in The Bamburgh package.
 */
export const IMG_4Y5bvgL0MVAKyQG8ZgRhwT = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4Y5bvgL0MVAKyQG8ZgRhwT/50ab96048cc21ae9f30342bdf7e91093/bamburgh.png',
  description: `An image of all of the components included in The Bamburgh package. `,
  originalHeight: 904,
  originalWidth: 1130
}

/**
 * ![affirm-logo](https://images.ctfassets.net/v6awd0kabi65/6168YhvJ2phoxTufUt9VKe/95737018201431dda8279e2dd66a6a27/affirm-logo.svg?w=120&h=120&fit=pad)
 *
 * affirm-logo
 *
 *
 */
export const IMG_6168YhvJ2phoxTufUt9VKe = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6168YhvJ2phoxTufUt9VKe/95737018201431dda8279e2dd66a6a27/affirm-logo.svg',
  description: ``,
  originalHeight: 42,
  originalWidth: 105
}

/**
 * ![Yard Sign](https://images.ctfassets.net/v6awd0kabi65/6AMPyZd0JMAtapG1KbJuwO/227227c443758a1d2e2b0b57a43d1a5e/yard.png?w=120&h=120&fit=pad)
 *
 * Yard Sign
 *
 *
 */
export const IMG_6AMPyZd0JMAtapG1KbJuwO = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6AMPyZd0JMAtapG1KbJuwO/227227c443758a1d2e2b0b57a43d1a5e/yard.png',
  description: ``,
  originalHeight: 430,
  originalWidth: 554
}

/**
 * ![Key Fob](https://images.ctfassets.net/v6awd0kabi65/4praAZJcdCZmtq3sDA1Tu4/621bb02708023582df2c63aa3b021316/keyfob.png?w=120&h=120&fit=pad)
 *
 * Key Fob
 *
 *
 */
export const IMG_4praAZJcdCZmtq3sDA1Tu4 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4praAZJcdCZmtq3sDA1Tu4/621bb02708023582df2c63aa3b021316/keyfob.png',
  description: ``,
  originalHeight: 600,
  originalWidth: 600
}

/**
 * ![Optional Add-Ons Icon](https://images.ctfassets.net/v6awd0kabi65/33Y45rm6JOCRWyLUY2fAZh/ca92cf134f953073ac79d3f64f4af647/icon-badge.svg?w=120&h=120&fit=pad)
 *
 * Optional Add-Ons Icon
 *
 * Icon used on the BMS Page next to Product Groupings (e.g. "Choose your Burglary Sensors")
 */
export const IMG_33Y45rm6JOCRWyLUY2fAZh = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/33Y45rm6JOCRWyLUY2fAZh/ca92cf134f953073ac79d3f64f4af647/icon-badge.svg',
  description: `Icon used on the BMS Page next to Product Groupings (e.g. "Choose your Burglary Sensors")`,
  originalHeight: 50,
  originalWidth: 42
}

/**
 * ![Camera Icon](https://images.ctfassets.net/v6awd0kabi65/2qifBhfdTRv3T3vTiyZ9j4/136387834d71d8f429f58787b0739852/icon-video.svg?w=120&h=120&fit=pad)
 *
 * Camera Icon
 *
 * Icon used on the BMS Page next to Product Groupings (e.g. "Choose your Burglary Sensors")
 */
export const IMG_2qifBhfdTRv3T3vTiyZ9j4 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2qifBhfdTRv3T3vTiyZ9j4/136387834d71d8f429f58787b0739852/icon-video.svg',
  description: `Icon used on the BMS Page next to Product Groupings (e.g. "Choose your Burglary Sensors")`,
  originalHeight: 42,
  originalWidth: 56
}

/**
 * ![Hazard Sensor Icon](https://images.ctfassets.net/v6awd0kabi65/3SRZghfFpHJ2lwDASVlsaJ/4a3cf8533cae2ba02a5744e06d2e0ea5/icon-hazard.svg?w=120&h=120&fit=pad)
 *
 * Hazard Sensor Icon
 *
 * Icon used on the BMS Page next to Product Groupings (e.g. "Choose your Burglary Sensors")
 */
export const IMG_3SRZghfFpHJ2lwDASVlsaJ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3SRZghfFpHJ2lwDASVlsaJ/4a3cf8533cae2ba02a5744e06d2e0ea5/icon-hazard.svg',
  description: `Icon used on the BMS Page next to Product Groupings (e.g. "Choose your Burglary Sensors")`,
  originalHeight: 55,
  originalWidth: 40
}

/**
 * ![Burglary Sensor Icon](https://images.ctfassets.net/v6awd0kabi65/5YOjLbieZdpHlve6kkrW8C/cb9fc10561f7ac9fc226aad2b0657d4c/icon-siren.svg?w=120&h=120&fit=pad)
 *
 * Burglary Sensor Icon
 *
 * Icon used on the BMS Page next to Product Groupings (e.g. "Choose your Burglary Sensors")
 */
export const IMG_5YOjLbieZdpHlve6kkrW8C = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5YOjLbieZdpHlve6kkrW8C/cb9fc10561f7ac9fc226aad2b0657d4c/icon-siren.svg',
  description: `Icon used on the BMS Page next to Product Groupings (e.g. "Choose your Burglary Sensors")`,
  originalHeight: 43,
  originalWidth: 54
}

/**
 * ![Save your system for later popup](https://images.ctfassets.net/v6awd0kabi65/pXraturJrTxmYo6MLuvG8/89ead748735d974fe89693b715f2753a/Save_your_system_for_later_popup.png?w=120&h=120&fit=pad)
 *
 * Save your system for later popup
 *
 * SimpliSafe system containing key fob, keypad, base station, motion sensor, two entry sensors and a smoke detector
 */
export const IMG_pXraturJrTxmYo6MLuvG8 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/pXraturJrTxmYo6MLuvG8/89ead748735d974fe89693b715f2753a/Save_your_system_for_later_popup.png',
  description: `SimpliSafe system containing key fob, keypad, base station, motion sensor, two entry sensors and a smoke detector`,
  originalHeight: 366,
  originalWidth: 1274
}

/**
 * ![Outdoor Camera Battery](https://images.ctfassets.net/v6awd0kabi65/2zSpNYsxA523bqytmCK9EZ/b8917a1eb3f3a320f77b4cc570096d6b/battery.jpg?w=120&h=120&fit=pad)
 *
 * Outdoor Camera Battery
 *
 *
 */
export const IMG_2zSpNYsxA523bqytmCK9EZ = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2zSpNYsxA523bqytmCK9EZ/b8917a1eb3f3a320f77b4cc570096d6b/battery.jpg',
  description: ``,
  originalHeight: 430,
  originalWidth: 554
}

/**
 * ![Wireless Outdoor Camera (Transparent)](https://images.ctfassets.net/v6awd0kabi65/5k7RR4A8mUjkSk4D4OIxqP/6616b1087b88ef1288da3d34c1c8afee/outdoor.png?w=120&h=120&fit=pad)
 *
 * Wireless Outdoor Camera (Transparent)
 *
 *
 */
export const IMG_5k7RR4A8mUjkSk4D4OIxqP = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5k7RR4A8mUjkSk4D4OIxqP/6616b1087b88ef1288da3d34c1c8afee/outdoor.png',
  description: ``,
  originalHeight: 288,
  originalWidth: 286
}

/**
 * ![Entry Sensor (Side View)](https://images.ctfassets.net/v6awd0kabi65/2GcUiOuUFlhCQ3I2SZo84d/6b57a08dbe936e445e4ecfa4a26f4a5f/entry.png?w=120&h=120&fit=pad)
 *
 * Entry Sensor (Side View)
 *
 * Alternative angle to the original Entry Sensor product image.
 */
export const IMG_2GcUiOuUFlhCQ3I2SZo84d = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2GcUiOuUFlhCQ3I2SZo84d/6b57a08dbe936e445e4ecfa4a26f4a5f/entry.png',
  description: `Alternative angle to the original Entry Sensor product image.`,
  originalHeight: 600,
  originalWidth: 600
}

/**
 * ![Smoke Detector - Product Image](https://images.ctfassets.net/v6awd0kabi65/1b21hSgtRAAbkJ8Ni53LHi/117a692de39068ce84a022a152fe2e8a/smoke_transparent_sq.png?w=120&h=120&fit=pad)
 *
 * Smoke Detector - Product Image
 *
 *
 */
export const IMG_1b21hSgtRAAbkJ8Ni53LHi = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/1b21hSgtRAAbkJ8Ni53LHi/117a692de39068ce84a022a152fe2e8a/smoke_transparent_sq.png',
  description: ``,
  originalHeight: 1498,
  originalWidth: 1665
}

/**
 * ![Satisfaction Guarantee Image](https://images.ctfassets.net/v6awd0kabi65/4ZSOzdS5c58oJzAh47LLZL/53dbad6f2e3efef730a14c45f0eaab30/100-seal_2x.png?w=120&h=120&fit=pad)
 *
 * Satisfaction Guarantee Image
 *
 * 100% satisfaction guaranteed
 */
export const IMG_4ZSOzdS5c58oJzAh47LLZL = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4ZSOzdS5c58oJzAh47LLZL/53dbad6f2e3efef730a14c45f0eaab30/100-seal_2x.png',
  description: `100% satisfaction guaranteed`,
  originalHeight: 440,
  originalWidth: 436
}

/**
 * ![Base Station Layout](https://images.ctfassets.net/v6awd0kabi65/7inef13TEZkj70Td8cdHeN/cd5d28c20f819651057720156cbd446a/Screen_Shot_2022-07-06_at_2.06.56_PM.png?w=120&h=120&fit=pad)
 *
 * Base Station Layout
 *
 * An image of where the base station would be for the essentials package.
 */
export const IMG_7inef13TEZkj70Td8cdHeN = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7inef13TEZkj70Td8cdHeN/cd5d28c20f819651057720156cbd446a/Screen_Shot_2022-07-06_at_2.06.56_PM.png',
  description: `An image of where the base station would be for the essentials package. `,
  originalHeight: 1088,
  originalWidth: 1168
}

/**
 * ![Keypad Image](https://images.ctfassets.net/v6awd0kabi65/IQU9QgCfvQxzSVBaoKMh6/8e60181fc9e504ca16d0aa257abe7c0d/carousel_keypad-white.jpeg?w=120&h=120&fit=pad)
 *
 * Keypad Image
 *
 * A white keypad component for security systems
 */
export const IMG_IQU9QgCfvQxzSVBaoKMh6 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/IQU9QgCfvQxzSVBaoKMh6/8e60181fc9e504ca16d0aa257abe7c0d/carousel_keypad-white.jpeg',
  description: `A white keypad component for security systems`,
  originalHeight: 600,
  originalWidth: 680
}

/**
 * ![Keypad apartment location](https://images.ctfassets.net/v6awd0kabi65/5VjfKwfUK1syTpd9erOiFO/82c103f8f7501f16df3ca8cde28619a1/Screen_Shot_2022-07-06_at_2.17.54_PM.png?w=120&h=120&fit=pad)
 *
 * Keypad apartment location
 *
 * Shows where the keypad would go in an apartment
 */
export const IMG_5VjfKwfUK1syTpd9erOiFO = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5VjfKwfUK1syTpd9erOiFO/82c103f8f7501f16df3ca8cde28619a1/Screen_Shot_2022-07-06_at_2.17.54_PM.png',
  description: `Shows where the keypad would go in an apartment`,
  originalHeight: 1098,
  originalWidth: 1168
}

/**
 * ![Entry Sensor ](https://images.ctfassets.net/v6awd0kabi65/6SfG5WIQg0Msd2esE5CJpm/edc9d39ef440ec7e474d85386bde740f/Screen_Shot_2022-07-06_at_2.20.11_PM.png?w=120&h=120&fit=pad)
 *
 * Entry Sensor
 *
 *
 */
export const IMG_6SfG5WIQg0Msd2esE5CJpm = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6SfG5WIQg0Msd2esE5CJpm/edc9d39ef440ec7e474d85386bde740f/Screen_Shot_2022-07-06_at_2.20.11_PM.png',
  description: ``,
  originalHeight: 1122,
  originalWidth: 1156
}

/**
 * ![Motion Sensor Product Photo](https://images.ctfassets.net/v6awd0kabi65/2zHslBITgX21MY27VXIIXe/64608833841a366b68d22ae396f413ca/carousel_motion_sensor.jpeg?w=120&h=120&fit=pad)
 *
 * Motion Sensor Product Photo
 *
 *
 */
export const IMG_2zHslBITgX21MY27VXIIXe = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2zHslBITgX21MY27VXIIXe/64608833841a366b68d22ae396f413ca/carousel_motion_sensor.jpeg',
  description: ``,
  originalHeight: 600,
  originalWidth: 680
}

/**
 * ![Motion Sensor Apartment Location](https://images.ctfassets.net/v6awd0kabi65/6LfLY5SlHzFC2Kg8uRJsNv/f50ac53ab0d15937c7083616dcb950cb/Screen_Shot_2022-07-06_at_2.35.22_PM.png?w=120&h=120&fit=pad)
 *
 * Motion Sensor Apartment Location
 *
 * Floorplan image shows where a motion sensor would be located within an apartment
 */
export const IMG_6LfLY5SlHzFC2Kg8uRJsNv = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6LfLY5SlHzFC2Kg8uRJsNv/f50ac53ab0d15937c7083616dcb950cb/Screen_Shot_2022-07-06_at_2.35.22_PM.png',
  description: `Floorplan image shows where a motion sensor would be located within an apartment`,
  originalHeight: 1100,
  originalWidth: 1196
}

/**
 * ![Yard Sign in front of House](https://images.ctfassets.net/v6awd0kabi65/4EBS8DMIDTL0opPRG2AxIw/0e7800694967215411f4cafcd6f4a324/247-monitoring.jpeg?w=120&h=120&fit=pad)
 *
 * Yard Sign in front of House
 *
 *
 */
export const IMG_4EBS8DMIDTL0opPRG2AxIw = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4EBS8DMIDTL0opPRG2AxIw/0e7800694967215411f4cafcd6f4a324/247-monitoring.jpeg',
  description: ``,
  originalHeight: 601,
  originalWidth: 726
}

/**
 * ![Open Box Video ](https://videos.ctfassets.net/v6awd0kabi65/15EA1WKbDb7EHfxZGM6KiO/3d5f5844b205d7c1ab2a37ce75a7c794/homepage.mp4?w=120&h=120&fit=pad)
 *
 * Open Box Video
 *
 *
 */
export const IMG_15EA1WKbDb7EHfxZGM6KiO = {
  url: 'https://videos.ctfassets.net/v6awd0kabi65/15EA1WKbDb7EHfxZGM6KiO/3d5f5844b205d7c1ab2a37ce75a7c794/homepage.mp4',
  description: ``,
  originalHeight: null,
  originalWidth: null
}

/**
 * ![Light's up keypad](https://images.ctfassets.net/v6awd0kabi65/5uIqEqkVcMmQFR64TB7rRC/63113e3d1f2d475a89f67509e3ab74a3/lights-up-section.jpeg?w=120&h=120&fit=pad)
 *
 * Light's up keypad
 *
 *
 */
export const IMG_5uIqEqkVcMmQFR64TB7rRC = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5uIqEqkVcMmQFR64TB7rRC/63113e3d1f2d475a89f67509e3ab74a3/lights-up-section.jpeg',
  description: ``,
  originalHeight: 1200,
  originalWidth: 2460
}

/**
 * ![Dog](https://images.ctfassets.net/v6awd0kabi65/534PummLSVuP1ERQS4An7m/766d98235391ffc4fcc31e535aa3e8a8/detects-intruders.jpeg?w=120&h=120&fit=pad)
 *
 * Dog
 *
 *
 */
export const IMG_534PummLSVuP1ERQS4An7m = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/534PummLSVuP1ERQS4An7m/766d98235391ffc4fcc31e535aa3e8a8/detects-intruders.jpeg',
  description: ``,
  originalHeight: 601,
  originalWidth: 683
}

/**
 * ![Components](https://images.ctfassets.net/v6awd0kabi65/4BkW1LK3Y0IRyEBcbtIrj0/9f3d1a56ece4b93e127ec3ac203e2506/bells-and-whistles-bg.jpeg?w=120&h=120&fit=pad)
 *
 * Components
 *
 *
 */
export const IMG_4BkW1LK3Y0IRyEBcbtIrj0 = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4BkW1LK3Y0IRyEBcbtIrj0/9f3d1a56ece4b93e127ec3ac203e2506/bells-and-whistles-bg.jpeg',
  description: ``,
  originalHeight: 600,
  originalWidth: 1230
}

/**
 * ![NYT Logo](https://images.ctfassets.net/v6awd0kabi65/3drcbehWeqAc9PL6ExNq7f/b55e8d6baa4db7b076f8ed8c1437837e/2560px-NewYorkTimes.svg.png?w=120&h=120&fit=pad)
 *
 * NYT Logo
 *
 *
 */
export const IMG_3drcbehWeqAc9PL6ExNq7f = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/3drcbehWeqAc9PL6ExNq7f/b55e8d6baa4db7b076f8ed8c1437837e/2560px-NewYorkTimes.svg.png',
  description: ``,
  originalHeight: 346,
  originalWidth: 2560
}

/**
 * ![Fortune Magazine Logo](https://images.ctfassets.net/v6awd0kabi65/4EAFBs1sK2RmMPEmrGeIUV/dee4f9e61965ac5260430088b06fcd4e/Fortune_magazine_logo_2016.svg.png?w=120&h=120&fit=pad)
 *
 * Fortune Magazine Logo
 *
 *
 */
export const IMG_4EAFBs1sK2RmMPEmrGeIUV = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4EAFBs1sK2RmMPEmrGeIUV/dee4f9e61965ac5260430088b06fcd4e/Fortune_magazine_logo_2016.svg.png',
  description: ``,
  originalHeight: 299,
  originalWidth: 1280
}

/**
 * ![Temperature Sensor product photo](https://images.ctfassets.net/v6awd0kabi65/2wdgv7mz09uR2JhX3R9IHL/b79ada9442aa35753838341117ff1b78/sensor_freeze.png?w=120&h=120&fit=pad)
 *
 * Temperature Sensor product photo
 *
 *
 */
export const IMG_2wdgv7mz09uR2JhX3R9IHL = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2wdgv7mz09uR2JhX3R9IHL/b79ada9442aa35753838341117ff1b78/sensor_freeze.png',
  description: ``,
  originalHeight: 100,
  originalWidth: 68
}

/**
 * ![Home Icon](https://images.ctfassets.net/v6awd0kabi65/7lE4SSu0cafnESfNG1Es1L/7fd8248758f56851631cdc89b36e3cab/home-icon.svg?w=120&h=120&fit=pad)
 *
 * Home Icon
 *
 *
 */
export const IMG_7lE4SSu0cafnESfNG1Es1L = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7lE4SSu0cafnESfNG1Es1L/7fd8248758f56851631cdc89b36e3cab/home-icon.svg',
  description: ``,
  originalHeight: 75,
  originalWidth: 98
}

/**
 * ![Apartment icon](https://images.ctfassets.net/v6awd0kabi65/4sKAAQ7lD28EmaTyo1V5up/a01602a0c456d989106ab15dd040526a/apartment-icon.svg?w=120&h=120&fit=pad)
 *
 * Apartment icon
 *
 *
 */
export const IMG_4sKAAQ7lD28EmaTyo1V5up = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4sKAAQ7lD28EmaTyo1V5up/a01602a0c456d989106ab15dd040526a/apartment-icon.svg',
  description: ``,
  originalHeight: 111,
  originalWidth: 68
}

/**
 * ![Check Icon](https://images.ctfassets.net/v6awd0kabi65/5i8yS0m4KYuPaS90EyFkFG/705dade3d44354d28a1d89987d2c9315/checkmark.svg?w=120&h=120&fit=pad)
 *
 * Check Icon
 *
 *
 */
export const IMG_5i8yS0m4KYuPaS90EyFkFG = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/5i8yS0m4KYuPaS90EyFkFG/705dade3d44354d28a1d89987d2c9315/checkmark.svg',
  description: ``,
  originalHeight: 58,
  originalWidth: 61
}

/**
 * ![X Icon](https://images.ctfassets.net/v6awd0kabi65/7EUpD45YL4fmtQwDW3M1rb/90f0d4b82f841004b112bd25783294e5/x-mark.svg?w=120&h=120&fit=pad)
 *
 * X Icon
 *
 *
 */
export const IMG_7EUpD45YL4fmtQwDW3M1rb = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/7EUpD45YL4fmtQwDW3M1rb/90f0d4b82f841004b112bd25783294e5/x-mark.svg',
  description: ``,
  originalHeight: 80,
  originalWidth: 80
}

/**
 * ![Adult Icon](https://images.ctfassets.net/v6awd0kabi65/4bOgc9DpXJKAsFV2k02CVW/f4202e936802b16c09b430e8e4336882/adults.svg?w=120&h=120&fit=pad)
 *
 * Adult Icon
 *
 *
 */
export const IMG_4bOgc9DpXJKAsFV2k02CVW = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/4bOgc9DpXJKAsFV2k02CVW/f4202e936802b16c09b430e8e4336882/adults.svg',
  description: ``,
  originalHeight: 86,
  originalWidth: 71
}

/**
 * ![Pets Icon](https://images.ctfassets.net/v6awd0kabi65/2PnF8asq39oXu0gAy9zMkS/42cf20531f20f338432100e558d8e5fd/adults.svg?w=120&h=120&fit=pad)
 *
 * Pets Icon
 *
 *
 */
export const IMG_2PnF8asq39oXu0gAy9zMkS = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/2PnF8asq39oXu0gAy9zMkS/42cf20531f20f338432100e558d8e5fd/adults.svg',
  description: ``,
  originalHeight: 86,
  originalWidth: 71
}

/**
 * ![The Essentials Package](https://images.ctfassets.net/v6awd0kabi65/6it8EmlEzRJeiH2ghgkBFB/b7d51a283fd36502bb2570f255847927/carousel_essentials.jpg?w=120&h=120&fit=pad)
 *
 * The Essentials Package
 *
 * An image of all of the components included in The Essentials package.
 */
export const IMG_6it8EmlEzRJeiH2ghgkBFB = {
  url: 'https://images.ctfassets.net/v6awd0kabi65/6it8EmlEzRJeiH2ghgkBFB/b7d51a283fd36502bb2570f255847927/carousel_essentials.jpg',
  description: `An image of all of the components included in The Essentials package. `,
  originalHeight: 600,
  originalWidth: 680
}
